/*!
 * FormCreate商业版可视化表单设计器-让表单设计更简单
 * fc-designer-pro v5.0.1
 * (c) 2018-2024 FormCreate Team  https://form-create.com/
 * license 仅限于被授权主体（个人、企业或组织）使用
 */
(function () { "use strict"; try { if (typeof document != "undefined") { var e = document.createElement("style"); e.appendChild(document.createTextNode('.CodeMirror{color:#000;direction:ltr;font-family:monospace;height:300px}.CodeMirror-lines{padding:4px 0}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{padding:0 4px}.CodeMirror-gutter-filler,.CodeMirror-scrollbar-filler{background-color:#fff}.CodeMirror-gutters{background-color:#f7f7f7;border-right:1px solid #ddd;white-space:nowrap}.CodeMirror-linenumber{color:#999;min-width:20px;padding:0 3px 0 5px;text-align:right;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror-cursor{border-left:1px solid #000;border-right:none;width:0}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.cm-fat-cursor .CodeMirror-cursor{background:#7e7;border:0!important;width:auto}.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-fat-cursor .CodeMirror-line::selection,.cm-fat-cursor .CodeMirror-line>span::selection,.cm-fat-cursor .CodeMirror-line>span>span::selection{background:transparent}.cm-fat-cursor .CodeMirror-line::-moz-selection,.cm-fat-cursor .CodeMirror-line>span::-moz-selection,.cm-fat-cursor .CodeMirror-line>span>span::-moz-selection{background:transparent}.cm-fat-cursor{caret-color:transparent}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-rulers{bottom:0;left:0;overflow:hidden;position:absolute;right:0;top:-50px}.CodeMirror-ruler{border-left:1px solid #ccc;bottom:0;position:absolute;top:0}.cm-s-default .cm-header{color:#00f}.cm-s-default .cm-quote{color:#090}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-type,.cm-s-default .cm-variable-3{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-invalidchar,.cm-s-default .cm-error{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0b0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#a22}.CodeMirror-matchingtag{background:rgba(255,150,0,.3)}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{background:#fff;overflow:hidden;position:relative}.CodeMirror-scroll{height:100%;margin-bottom:-50px;margin-right:-50px;outline:none;overflow:scroll!important;padding-bottom:50px;position:relative;z-index:0}.CodeMirror-sizer{border-right:50px solid transparent;position:relative}.CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{display:none;outline:none;position:absolute;z-index:5}.CodeMirror-vscrollbar{overflow-x:hidden;overflow-y:scroll;right:0;top:0}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-x:scroll;overflow-y:hidden}.CodeMirror-scrollbar-filler{bottom:0;right:0}.CodeMirror-gutter-filler{bottom:0;left:0}.CodeMirror-gutters{left:0;min-height:100%;position:absolute;top:0;z-index:3}.CodeMirror-gutter{display:inline-block;height:100%;margin-bottom:-50px;vertical-align:top;white-space:normal}.CodeMirror-gutter-wrapper{background:none!important;border:none!important;position:absolute;z-index:4}.CodeMirror-gutter-background{bottom:0;position:absolute;top:0;z-index:4}.CodeMirror-gutter-elt{cursor:default;position:absolute;z-index:4}.CodeMirror-gutter-wrapper ::selection{background-color:transparent}.CodeMirror-gutter-wrapper ::-moz-selection{background-color:transparent}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{word-wrap:normal;-webkit-tap-highlight-color:transparent;background:transparent;border-radius:0;border-width:0;color:inherit;font-family:inherit;font-size:inherit;font-variant-ligatures:contextual;line-height:inherit;margin:0;overflow:visible;position:relative;white-space:pre;z-index:2}.CodeMirror-wrap pre.CodeMirror-line,.CodeMirror-wrap pre.CodeMirror-line-like{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{bottom:0;left:0;position:absolute;right:0;top:0;z-index:0}.CodeMirror-linewidget{padding:.1px;position:relative;z-index:2}.CodeMirror-rtl pre{direction:rtl}.CodeMirror-code{outline:none}.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber,.CodeMirror-scroll,.CodeMirror-sizer{box-sizing:content-box}.CodeMirror-measure{height:0;overflow:hidden;position:absolute;visibility:hidden;width:100%}.CodeMirror-cursor{pointer-events:none;position:absolute}.CodeMirror-measure pre{position:static}div.CodeMirror-cursors{position:relative;visibility:hidden;z-index:3}.CodeMirror-focused div.CodeMirror-cursors,div.CodeMirror-dragcursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror-line::selection,.CodeMirror-line>span::selection,.CodeMirror-line>span>span::selection{background:#d7d4f0}.CodeMirror-line::-moz-selection,.CodeMirror-line>span::-moz-selection,.CodeMirror-line>span>span::-moz-selection{background:#d7d4f0}.cm-searching{background-color:#ffa;background-color:#ff06}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:""}span.CodeMirror-selectedtext{background:none}.CodeMirror-hints{background:#fff;border:1px solid silver;border-radius:3px;box-shadow:2px 3px 5px #0003;font-family:monospace;font-size:90%;list-style:none;margin:0;max-height:20em;overflow:hidden;overflow-y:auto;padding:2px;position:absolute;z-index:1}.CodeMirror-hint{border-radius:2px;color:#000;cursor:pointer;margin:0;padding:0 4px;white-space:pre}li.CodeMirror-hint-active{background:#08f;color:#fff}._fd-fn{position:relative;width:100%}._fd-fn .el-button{bottom:3px;box-shadow:0 6px 16px #00000014,0 3px 6px -4px #0000001f,0 9px 28px 8px #0000000d;position:absolute;right:5px}._fd-fn-editor{height:100%;width:100%}._fd-fn-editor .CodeMirror{height:200px}._fd-fn-tip{color:#000;direction:ltr;font-family:monospace}._fd-fn-tip .cm-keyword{color:#708;line-height:24px;overflow-x:auto;white-space:nowrap}._fd-fn-tip .cm-keyword::-webkit-scrollbar{background-color:transparent;height:0;width:0}._fd-fn-ind{background-color:#f7f7f7;border-right:1px solid #ddd;display:inline-block;float:left;height:24px;margin-right:4px;width:29px}._fd-fn-arg{cursor:pointer;text-decoration:underline}._fd-fn-arg i{color:#3073ff;font-size:12px}._fd-event .el-button{border-color:#2e73ff;color:#2e73ff;font-weight:400;width:100%}._fd-event .el-badge{width:100%}._fd-event-dialog .el-dialog__body{padding:10px 20px}._fd-event-con .el-main{padding:0}._fd-event-l,._fd-event-r{border:1px solid #ececec;display:flex;flex:1;flex-direction:column;height:100%}._fd-event-dropdown .el-dropdown-menu{max-height:500px;overflow:scroll}._fd-event-head{align-items:center;background:#f8f9ff;border-bottom:1px solid #eee;display:flex;padding:5px 15px}._fd-event-head .el-button.is-link{color:#2f73ff}._fd-event-r{border-left:0}._fd-event-r ._fd-event-head{justify-content:flex-end}._fd-event-l>.el-main,._fd-event-r>.el-main{box-sizing:border-box;display:flex;flex:1;flex-basis:auto;flex-direction:row;min-width:0;width:100%}._fd-event-item,._fd-event-r>.el-main{flex-direction:column}._fd-event-item{display:flex;font-size:14px;justify-content:center;max-width:250px;overflow:hidden;white-space:pre-wrap}._fd-event-item ._fd-label{color:#999;font-size:12px}._fd-event-l .el-menu{border-right:0;border-top:0;overflow:auto;padding:0 10px 5px;width:100%}._fd-event-l .el-menu-item.is-active{background:#e4e7ed;color:#303133}._fd-event-l .el-menu-item{border:1px solid #ececec;border-radius:5px;height:auto;line-height:1em;margin-top:5px;padding:0}._fd-event-method{color:#9d238c;display:flex;flex-direction:column;font-family:monospace;font-size:14px;justify-content:center;overflow:hidden;white-space:pre-wrap;width:225px}._fd-event-method ._fd-label{color:#999;font-size:12px;margin-top:4px}._fd-event-method>span:first-child,._fd-fn-list-method>span:first-child{color:#9d238c}._fd-event-method>span:first-child>span,._fd-fn-list-method>span:first-child>span{color:#000;margin-left:10px}._fd-event-title{align-items:center;display:flex;justify-content:space-between;padding:10px 0;width:100%}._fd-event-title .fc-icon{color:#282828;font-size:18px;margin-right:6px}._fd-event-title .el-input{width:200px}._fd-event-title .el-input__wrapper{box-shadow:none}._fd-event-title .el-menu-item.is-active i{color:#282828}._fd-event-con .CodeMirror{height:100%;width:100%}._fd-event-con .CodeMirror-wrap pre.CodeMirror-line{padding-left:20px}._fd-drag-tool{word-wrap:break-word;box-sizing:border-box;display:block;min-height:20px;outline:1px dashed var(--fc-tool-border-color);overflow:hidden;padding:2px;position:relative;transition:outline-color .3s ease;word-break:break-all}._fd-drag-tool:hover{outline-color:#2e73ff;outline-style:solid}._fd-drag-tool ._fd-drag-tool{height:calc(100% - 6px);margin:3px}._fd-drag-tool+._fd-drag-tool{margin-top:5px}._fd-drag-tool.active{outline:2px solid #2e73ff}._fd-drag-tool.active>div>._fd-drag-btn{display:flex}._fd-drag-tool._fd-drop-hover ._fd-drag-box{padding-bottom:15px!important;padding-top:15px!important}._fd-drag-tool._fd-drop-hover:hover{outline:1px dashed var(--fc-tool-border-color)}._fd-drag-tool ._fd-drag-btn{display:none}.drag-r{bottom:2px;right:2px}._fd-drag-l,.drag-r{position:absolute;z-index:2}._fd-drag-l{left:0;top:0}._fd-drag-btn{background-color:#2e73ff;color:#fff;cursor:pointer;float:left;height:18px;justify-content:center;line-height:20px;padding-bottom:1px;text-align:center;width:18px}._fd-drag-btn+._fd-drag-btn{margin-left:2px}._fd-drag-danger{background-color:#ff2e2e}._fd-drag-btn i{font-size:14px}._fd-drag-mask{bottom:0;left:0;position:absolute;right:0;top:0;z-index:1}._fd-struct,._fd-struct .el-badge{width:100%}._fd-struct .el-button{border-color:#2e73ff;color:#2e73ff;font-weight:400;width:100%}._fd-struct .CodeMirror{height:450px}._fd-struct .CodeMirror-line{font-size:13px!important;line-height:16px!important}._fd-struct-con .CodeMirror-lint-tooltip{z-index:1!important}._fd-struct-con .el-dialog__body{padding:0 20px}._fd-html-editor{width:100%}._fd-html-editor .el-button{border-color:#2e73ff;color:#2e73ff;font-weight:400;width:100%}._fd-html-editor-con .CodeMirror{height:450px}._fd-html-editor-con .CodeMirror-line{font-size:13px!important;line-height:16px!important}._fd-html-editor-con .CodeMirror-lint-tooltip{z-index:1!important}._fd-html-editor-con .el-dialog__body{padding:0 20px}._fd-size-input{align-items:center;display:flex}._fd-size-input .el-input-number--small{width:122px}._fd-size-input .el-button{font-size:14px;margin-left:3px;padding:5px;width:25px}._fd-color-input{width:150px}._fd-color-input .el-input .el-color-picker{margin:0}._fd-color-input .el-input .el-input-group__append{padding:0;width:24px}._fd-color-input .el-input .el-color-picker__trigger{border-left:0;border-radius:0 3px 3px 0}._fd-field-input{width:100%}._fd-field-input .el-input-group__append{color:#606266;cursor:pointer;margin:0;padding:0;width:25px}._fd-field-popper .el-tree-node__content{color:#333;padding:2px 0}._fd-field-popper .el-select-dropdown__list>.el-select-dropdown__item{border-bottom:1px solid #eee;box-sizing:border-box;height:26px;padding-left:15px}._fd-box-size-input ._margin,._fd-box-size-input ._padding{background-color:#f2cea5;box-sizing:border-box;height:180px;outline:1px dashed #eee;padding:30px 45px;position:relative;width:100%}._fd-box-size-input ._margin{background-color:#c6cf92;height:120px;width:100%}._fd-box-size-input ._fd-input{background-color:unset;border:0;display:inline-block;font-size:12px;height:20px;margin:0;max-width:40px;outline:0 none;padding:0;text-align:center;text-decoration:underline;width:30%}._fd-box-size-input ._fd-input:focus,._fd-box-size-input ._fd-input:hover{background-color:#fff;opacity:.9}._fd-box-size-input ._fd-left,._fd-box-size-input ._fd-right{left:2px;margin-top:-10px;position:absolute;top:50%}._fd-box-size-input ._fd-bottom,._fd-box-size-input ._fd-top{left:50%;margin-left:-20px;position:absolute;top:5px}._fd-box-size-input ._fd-bottom{bottom:5px;top:unset}._fd-box-size-input ._fd-right{left:unset;right:2px}._fd-box-size-input ._box{align-items:center;background-color:#94b5c0;display:flex;height:100%;justify-content:center;width:100%}._fd-box-size-input ._margin-title,._fd-box-size-input ._padding-title{color:#000000a1;left:4px;position:absolute;top:2px}._fd-box-size-input ._fd-help{align-items:center;color:#606266;display:flex;position:absolute;right:2px;top:2px}._fd-box-size-input .fc-icon{color:#000000a1;cursor:pointer;font-size:18px}._fd-box-size-input .icon-minus{transform:rotate(-45deg)}._fd-box-size-input .fc-icon.active{color:#2f73ff}._fd-box-size-input ._fd-x{margin:0 5px}._fd-config-item{display:flex;flex-direction:column;font-size:12px;width:100%}._fd-config-item+._fd-config-item{margin-top:15px}._fd-ci-head{background:#fff;justify-content:space-between}._fd-ci-head,._fd-ci-label{align-items:center;display:flex}._fd-ci-label{color:#333;font-size:12px}._fd-ci-label.is-arrow{cursor:pointer}._fd-ci-append{background:#f5f5f5;display:flex;margin-top:10px;padding:5px}._fd-ci-label i{font-size:12px;font-weight:600;margin-left:4px;transform:rotate(90deg)}._fd-ci-label i.down{transform:rotate(-90deg)}._fd-ci-info{color:#999;font-size:12px;padding-right:5px}._fd-border-input{display:flex;height:110px;justify-content:center;width:100%}._fd-border-input ._fd-bi-left{align-items:center;display:flex;flex-direction:column;height:115px;justify-content:center;width:115px}._fd-border-input ._fd-bi-right{display:flex;flex-direction:column;justify-content:space-around;padding:5px;width:140px}._fd-border-input ._fd-bi-right ._fd-color-input{width:140px}._fd-bi-opt{align-items:center;display:flex;height:100%;width:100%}._fd-bi-opt ._line{width:100%}._fd-bi-opt .solid{border:1px solid #000}._fd-bi-opt .dashed{border:1px dashed #000}._fd-bi-opt .dotted{border:1px dotted #000}._fd-bi-opt .double{border:1px double #000}._fd-border-input ._fd-bil-row{display:flex;height:38px;justify-content:center}._fd-border-input ._fd-bil-col{align-items:center;cursor:pointer;display:flex;font-size:16px;height:22px;justify-content:center;margin:8px;width:22px}._fd-border-input ._fd-bil-col.active{color:#2e73ff;outline:1px dashed #2e73ff}.line-box{box-sizing:border-box;height:20px;padding:1px;width:150px}.line-box-con{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAD5JREFUOE9jZGBg+M+AChjR+HjlQYqHgQFoXibNS+gBBjKMpDAZHAaQ5GQGBgYUV4+mA7QAgaYokgJ14NMBAK1TIAlUJpxYAAAAAElFTkSuQmCC);height:100%;opacity:.3;width:100%}._fd-radius-input{display:flex;flex-direction:column;width:100%}._fd-radius-con{display:flex;flex-wrap:wrap}._fd-radius-item{box-sizing:border-box;padding:5px 0;width:50%}._fd-radius-item,._fd-radius-item ._fd-radius-icon{align-items:center;display:flex;justify-content:center}._fd-radius-item ._fd-radius-icon{height:24px;width:24px}._fd-radius-item ._fd-size-input .el-input-number--small{width:70px}._fd-display-input{display:flex;flex-direction:column}._fd-display-input .el-radio-button__inner{padding:4px;width:100%}._fd-display-input .el-radio-button{flex:1}._fd-display-input .is-active i{color:#fff}._fd-display-con{display:flex;flex-wrap:wrap}._fd-display-con.rotate-flag .rotate{display:inline-block;transform:rotate(-90deg)}._fd-display-con.column .icon-justify-flexstart:before{display:inline-block;transform:rotate(180deg)}._fd-display-con.column .icon-justify-flexend:before{display:inline-block;transform:rotate(0)}._fd-display-con.row-reverse .icon-justify-flexstart:before{display:inline-block;transform:rotate(180deg)}._fd-display-con.column-reverse .icon-justify-flexstart:before,._fd-display-con.row-reverse .icon-justify-flexend:before{display:inline-block;transform:rotate(0)}._fd-display-con.column-reverse .icon-justify-flexend:before{display:inline-block;transform:rotate(180deg)}._fd-display-raw{display:flex;flex-direction:column;margin-bottom:5px;width:100%}._fd-shadow-content{align-items:center;display:flex;flex-direction:column;justify-content:space-between}._fd-sc-form .fc-icon{font-size:12px}._fd-shadow-content .el-form-item{box-sizing:border-box;margin:0 0 5px!important;padding:0 0 0 10px;width:50%}._fd-shadow-content .el-input__wrapper{flex:1}._fd-shadow-content ._fd-sc-box{background:#f6f6f6;border:1px solid #ccc;border-radius:5px;cursor:pointer;height:250px;overflow:hidden;position:relative;width:250px}._fd-shadow-content ._fd-sc-box .spot{border-radius:100%;height:0;position:absolute;width:0}._fd-shadow-content ._fd-sc-box .spot-id{background:#1989fa;border-radius:100%;height:10px;left:-5px;position:absolute;top:-5px;width:10px;z-index:1}._fd-shadow-content ._fd-sc-box.down .spot-id{box-shadow:1px 1px 10px 2px #1989fa}._fd-shadow-content ._fd-sc-box .center-spot{background:#1989fa;border-radius:100%;height:0;left:125px;position:absolute;top:125px;width:0}._fd-shadow-content ._fd-sc-box .x-hr{background:#ccc;height:1px;position:absolute;top:125px;width:100%}._fd-shadow-content ._fd-sc-box .y-hr{background:#ccc;height:100%;left:125px;position:absolute;width:1px}._fd-shadow-content .el-select__placeholder{text-align:center}._fd-shadow-content .el-input-group__append{padding:0;width:55px}._fd-shadow-content .el-input{width:105px}._fd-shadow-content ._fd-sc-right{margin-top:10px}._fd-shadow-content ._fd-sc-radio{width:105px}._fd-shadow-content ._fd-sc-radio .el-radio-button{display:flex;flex:1}._fd-shadow-content ._fd-sc-radio .el-radio-button__inner{width:100%}._fd-shadow-input ._fd-ci-con{width:150px}._fd-shadow-input :focus-visible{outline:0 none}._fd-si-input .el-input-group__append{display:inline-flex;padding:0;width:24px}._fd-si-input .el-input__wrapper{flex:1}._fd-shadow-input ._fd-ci-con .fc-icon{cursor:pointer}._td-table-opt[data-v-f024cd9c]{width:100%}._td-table-opt-handle[data-v-f024cd9c]{align-items:center;display:flex;justify-content:space-between;padding-right:5px}._fd-style-config{display:flex;flex-direction:column;width:100%}._fd-style-config>div+div{margin-top:15px}._fd-opacity-input ._fd-ci-con{align-items:center;display:flex;justify-content:space-between;width:150px}._fd-opacity-input ._fd-ci-con>span{width:32px}._fd-opacity-input .el-slider{flex:1;margin-right:15px}._fd-computed,._fd-computed .el-badge{width:100%}._fd-computed .el-button{border-color:#2e73ff;color:#2e73ff;font-weight:400;width:100%}._fd-comp-con{height:600px}._fd-comp-con .el-tree>.el-tree-node{color:#000c;font-size:13px;font-weight:500;margin:1px;padding:14px}._fd-comp-con .el-tree>.el-tree-node+.el-tree-node{border-top:1px solid #eee}._fd-comp-con .el-tree-node{font-weight:400}._fd-comp-con .el-tree-node__content{margin-top:5px}._fd-computed-dialog .el-dialog__body{padding:10px 20px}._fd-comp-con .el-main{padding:0}._fd-comp-r{border:1px solid #ececec;display:flex;flex:1;flex-direction:column;height:100%}._fd-comp-head{align-items:center;background:#ecf1fe;border-bottom:1px solid #eee;color:#000c;display:flex;font-size:13px;font-weight:500;height:38px;padding:5px 15px}._fd-comp-r>.el-main,._fd-comp-script{box-sizing:border-box;display:flex;flex:1;flex-basis:auto;flex-direction:row;min-width:0;width:100%}._fd-comp-script{width:100%}._fd-comp-r>.el-main{flex-direction:column}._fd-comp-info{background:#f7f9ff;border-radius:6px;color:#666;height:90px;line-height:20px;margin:10px;padding:15px}._fd-comp-con .CodeMirror{height:100%;width:100%}._fd-comp-con .CodeMirror-wrap pre.CodeMirror-line{padding-left:20px}._fd-comp-node{align-items:center;display:flex;height:26px;justify-content:space-between;line-height:26px;padding-right:5px;width:100%}._fd-comp-node ._group{color:#61affe;font-weight:700;margin-right:5px}._fd-comp-node ._subform{color:#fca130;font-weight:700;margin-right:5px}._fd-comp-node.disabled{color:#999;cursor:not-allowed}._fd-comp-node.disabled ._fd-comp-id{background-color:#999}._fd-comp-id{background-color:#61affe;border-radius:5px;color:#fff;font-weight:500;height:20px;line-height:20px;text-align:center;width:20px}._fd-computed-dialog .el-aside{border:1px solid #eee;width:300px}._fd-comp-script .CodeMirror pre.CodeMirror-line{line-height:26px}._fd-fn-list,._fd-fn-list .el-badge{width:100%}._fd-fn-list .el-button{border-color:#2e73ff;color:#2e73ff;font-weight:400;width:100%}._fd-fn-list-dialog .el-dialog__body{padding:10px 20px}._fd-fn-list-con .el-main{padding:0}._fd-fn-list-l,._fd-fn-list-r{border:1px solid #ececec;display:flex;flex:1;flex-direction:column;height:100%}._fd-fn-list-head{align-items:center;background:#f8f9ff;border-bottom:1px solid #eee;display:flex;padding:5px 15px}._fd-fn-list-head .el-button.is-link{color:#2f73ff}._fd-fn-list-r{border-left:0}._fd-fn-list-r ._fd-fn-list-head{justify-content:flex-end}._fd-fn-list-l>.el-main,._fd-fn-list-r>.el-main{box-sizing:border-box;display:flex;flex:1;flex-basis:auto;flex-direction:row;min-width:0;width:100%}._fd-fn-list-r>.el-main{flex-direction:column}._fd-fn-list-l .el-menu{border-right:0;border-top:0;overflow:auto;padding:0 10px 5px;width:100%}._fd-fn-list-l .el-menu-item.is-active{background:#e4e7ed;color:#303133}._fd-fn-list-l .el-menu-item{border:1px solid #ececec;border-radius:5px;height:auto;line-height:1em;margin-top:5px;padding:0}._fd-fn-list-method{display:flex;flex-direction:column;font-family:monospace;font-size:14px;justify-content:center;line-height:1em;overflow:hidden;padding:10px 0;white-space:pre-wrap;width:100%}._fd-fn-list-method ._fd-label{color:#999;font-size:12px;margin-top:4px}._fd-fn-list-method-info>span:first-child,._fd-fn-list-method>span:first-child{color:#9d238c}._fd-fn-list-method-info>span:first-child>span,._fd-fn-list-method>span:first-child>span{color:#000;margin-left:10px}._fd-fn-list-con .CodeMirror{height:100%;width:100%}._fd-fn-list-con .CodeMirror-wrap pre.CodeMirror-line{padding-left:20px}._fd-struct-editor{flex:1;width:100%}._fd-struct-editor>div{height:100%}._fd-gfc,._fd-gfc .el-badge{width:100%}._fd-gfc .el-button{border-color:#2e73ff;color:#2e73ff;font-weight:400;width:100%}._fd-gfc-dialog .el-dialog__body{padding:10px 20px}._fd-gfc-con .el-main{padding:0}._fd-gfc-l,._fd-gfc-r{border:1px solid #ececec;display:flex;flex:1;flex-direction:column;height:100%}._fd-gfc-head{align-items:center;background:#f8f9ff;border-bottom:1px solid #eee;display:flex;padding:5px 15px}._fd-gfc-head .el-button.is-link{color:#2f73ff}._fd-gfc-r{border-left:0}._fd-gfc-r ._fd-gfc-head{justify-content:flex-end}._fd-gfc-l>.el-main,._fd-gfc-r>.el-main{box-sizing:border-box;display:flex;flex:1;flex-basis:auto;flex-direction:row;min-width:0;width:100%}._fd-gfc-r>.el-main{flex-direction:column}._fd-gfc-l .el-menu{border-right:0;border-top:0;overflow:auto;padding:0 10px 5px;width:100%}._fd-gfc-l .el-menu-item.is-active{background:#e4e7ed;color:#303133}._fd-gfc-l .el-menu-item{border:1px solid #ececec;border-radius:5px;height:auto;line-height:1em;margin-top:5px;padding:0}._fd-gfc-method{color:#702c71;display:flex;flex-direction:column;font-family:monospace;font-size:14px;justify-content:center;overflow:hidden;white-space:pre-wrap;width:100%}._fd-gfc-method ._fd-label{color:#999;font-size:12px;margin-top:4px}._fd-gfc-title{align-items:center;display:flex;justify-content:space-between;padding:10px 0;width:100%}._fd-gfc-title .el-input{width:200px}._fd-gfc-title .fc-icon{color:#282828;font-size:18px;margin-right:6px}._fd-gfc-title .el-input__wrapper{box-shadow:none}._fd-gfc-title .el-menu-item.is-active i{color:#282828}._fd-gfc-con .CodeMirror{height:100%;width:100%}._fd-gfc-con .CodeMirror-wrap pre.CodeMirror-line{padding-left:20px}._fd-gfs{align-items:center;display:flex;width:100%}._fd-gfs .el-select{width:190px}._fd-gfs-handle{display:inline-flex;height:14px;line-height:14px}._fd-gfs-handle .icon-refresh{color:#2f73ff;cursor:pointer;font-weight:700;margin-left:4px}._fd-gfs-handle .icon-refresh.disabled{color:#a9abb2;cursor:not-allowed}._fd-gfs-handle ._fc-manage-text{border-left:1px solid #d8d8d8;padding-left:4px}._fd-gec,._fd-gec .el-badge{width:100%}._fd-gec-dialog .el-dialog__body{padding:10px 20px}._fd-gec .el-button{border-color:#2e73ff;color:#2e73ff;font-weight:400;width:100%}._fd-gec-con .el-main{padding:0}._fd-gec-l,._fd-gec-r{border:1px solid #ececec;display:flex;flex:1;flex-direction:column;height:100%}._fd-gec-head{align-items:center;background:#f8f9ff;border-bottom:1px solid #eee;display:flex;padding:5px 15px}._fd-gec-head .el-button.is-link{color:#2f73ff}._fd-gec-r{border-left:0}._fd-gec-r ._fd-gec-head{justify-content:flex-end}._fd-gec-l>.el-main,._fd-gec-r>.el-main{box-sizing:border-box;display:flex;flex:1;flex-basis:auto;flex-direction:row;min-width:0;width:100%}._fd-gec-r>.el-main{flex-direction:column}._fd-gec-l .el-menu{border-right:0;border-top:0;overflow:auto;padding:0 10px 5px;width:100%}._fd-gec-l .el-menu-item.is-active{background:#e4e7ed;color:#303133}._fd-gec-l .el-menu-item{border:1px solid #ececec;border-radius:5px;height:auto;line-height:1em;margin-top:5px;padding:0}._fd-gec-method{color:#9d238c;display:flex;flex-direction:column;font-family:monospace;font-size:14px;justify-content:center;overflow:hidden;white-space:pre-wrap;width:225px}._fd-gec-method ._fd-label{color:#999;font-size:12px;margin-top:4px}._fd-gec-title{align-items:center;display:flex;justify-content:space-between;padding:10px 0;width:100%}._fd-gec-title .el-input{width:200px}._fd-gec-title .fc-icon{color:#282828;font-size:18px;margin-right:6px}._fd-gec-title .el-input__wrapper{box-shadow:none}._fd-gec-con .el-menu-item.is-active i{color:#282828}._fd-gec-con .CodeMirror{height:100%;width:100%}._fd-gec-con .CodeMirror-wrap pre.CodeMirror-line{padding-left:20px}._fd-gcc,._fd-gcc .el-badge{width:100%}._fd-gcc-dialog .el-dialog__body{padding:10px 20px}._fd-gcc .el-button{border-color:#2e73ff;color:#2e73ff;font-weight:400;width:100%}._fd-gcc-con .el-main{padding:0}._fd-gcc-l,._fd-gcc-r{border:1px solid #ececec;display:flex;flex:1;flex-direction:column;height:100%}._fd-gcc-head{align-items:center;background:#f8f9ff;border-bottom:1px solid #eee;display:flex;padding:5px 15px}._fd-gcc-head .el-button.is-link{color:#2f73ff}._fd-gcc-r{border-left:0}._fd-gcc-r ._fd-gcc-head{justify-content:flex-end}._fd-gcc-l>.el-main,._fd-gcc-r>.el-main{box-sizing:border-box;display:flex;flex:1;flex-basis:auto;flex-direction:row;min-width:0;width:100%}._fd-gcc-r>.el-main{flex-direction:column;padding:20px}._fd-gcc-l .el-menu{border-right:0;border-top:0;overflow:auto;padding:0 10px 5px;width:100%}._fd-gcc-l .el-menu-item.is-active{background:#e4e7ed;color:#303133}._fd-gcc-l .el-menu-item{border:1px solid #ececec;border-radius:5px;height:auto;line-height:1em;margin-top:5px;padding:0}._fd-gcc-method{color:#923b76;display:flex;flex-direction:column;font-family:monospace;font-size:14px;justify-content:center;overflow:hidden;white-space:pre-wrap;width:175px}._fd-gcc-method ._fd-label{color:#999;font-size:12px;margin-top:4px}._fd-gcc-title{align-items:center;display:flex;justify-content:space-between;padding:10px 0;width:100%}._fd-gcc-title .el-input{width:160px}._fd-gcc-title .fc-icon{color:#282828;font-size:18px;margin-right:6px}._fd-gcc-title .el-input__wrapper{box-shadow:none}._fd-gcc-con .el-menu-item.is-active i{color:#282828}._fd-gcs{align-items:center;display:flex;width:100%}._fd-gcs .el-select{width:190px}._fd-gcs-handle{display:inline-flex;height:14px;line-height:14px}._fd-gcs-handle ._fc-manage-text{border-left:1px solid #d8d8d8;padding-left:4px}._fd-table-view{overflow:auto}._fd-table-view-cell{background:#fff;border:2px inset rgba(0,0,0,.1);height:100%;min-height:50px}._fd-table-view-cell>._fd-drag-tool{border:0;height:100%;margin:0}._fd-table-view-btn{flex-direction:column;padding:0}._fd-table-view-btn .fc-icon{color:#fff;font-size:16px;width:18px}._fd-table-view-icon{color:#fff;display:flex;height:100%;justify-content:center;margin-top:1px;width:100%}._fd-table-view>table{border-bottom:1px solid #ebeef5;border-right:1px solid #ebeef5;border-color:#ebeef5 currentcolor currentcolor #ebeef5;border-style:solid none none solid;border-width:1px 0 0 1px;height:100%;overflow:hidden;table-layout:fixed;width:100%}._fd-table-view tr{min-height:50px}._fd-table-view td{border-bottom:0;border-right:0;border-color:currentcolor #ebeef5 #ebeef5 currentcolor;border-style:none solid solid none;border-width:0 1px 1px 0;box-sizing:border-box;min-height:50px;min-width:80px;overflow-wrap:break-word;padding:5px;position:relative;white-space:nowrap}._fd-tableCell-drag{height:100%}._fc-table{overflow:auto}._fc-table>table{border-bottom:1px solid #ebeef5;border-right:1px solid #ebeef5;border-color:#ebeef5 currentcolor currentcolor #ebeef5;border-style:solid none none solid;border-width:1px 0 0 1px;height:100%;overflow:hidden;table-layout:fixed;width:100%}._fc-table td,._fc-table tr{min-height:50px}._fc-table td{border-bottom:0;border-right:0;border-color:currentcolor #ebeef5 #ebeef5 currentcolor;border-style:none solid solid none;border-width:0 1px 1px 0;box-sizing:border-box;min-width:80px;overflow:hidden;overflow-wrap:break-word;padding:5px;position:relative}._fd-value{color:#aaa}._fd-validate .append-msg{cursor:pointer}._fd-validate .el-input-group__append{padding:0 10px}._fd-required{align-items:center;display:flex;width:100%}._fd-required .el-input{margin-left:15px}._fd-required .el-switch{height:28px}._fd-tree-opt ._fd-tree-opt-btn{background-color:#409eff;color:#fff;cursor:pointer;float:left;height:19px;justify-content:center;line-height:20px;padding-bottom:1px;text-align:center;width:18px}._fd-tree-opt-node{align-items:center;display:flex}._fd-tree-opt-first{margin-right:5px;width:60px}._fd-tree-opt-last{width:110px}._fd-tree-opt-last._label{width:175px}._fd-tree-opt-last._label .el-input-group__append{width:65px}._fd-tree-opt ._fd-tree-opt-danger{background-color:#f56c6b;border-radius:0 2px 2px 0}._fd-tree-opt .el-tree-node__content{height:28px;margin-bottom:3px}._fd-tree-opt .el-input__inner{border-right:0}._fd-tree-opt .el-input-group__append{background:#fff;padding-left:1px;padding-right:2px;width:90px}._fc-step-form{width:100%}._fc-step-form>.el-steps{margin-bottom:20px}._fc-step-form .el-step .el-step__head{line-height:1.4}._fd-step-form{width:100%}._fd-step-form .el-step{cursor:pointer}._fd-step-form>.el-steps{margin-bottom:20px}._fd-step-form .el-step .el-step__head{line-height:1.4}._fd-table-form{background:#fff;border:1px solid #ececec;width:100%}._fc-child-empty,._fd-table-form{min-height:130px}._fd-tf-wrap{display:flex;overflow:auto}._fd-tf-wrap>._fd-drag-tool{display:flex;flex-shrink:0;height:auto;margin:2px}._fd-ntable-form{background:#fff;border:1px solid #ececec;min-height:130px;width:100%}._fd-ntable-sub .el-form-item__label{display:none}._fd-ntable-form ._fc-child-empty{min-height:130px}._fd-ntf-wrap{display:flex;overflow:auto}._fd-ntf-wrap>._fd-drag-tool{display:flex;flex-shrink:0;height:auto;margin:2px}._fd-ntable-sub ._title{background-color:#f5f5f5;border-radius:8px 8px 0 0;color:#65676b;display:inline-block;font-size:12px;height:20px;line-height:1em;margin-left:2px;padding:6px 8px 0;text-align:center}._fd-ntable-sub>._fd-drag-tool{margin-top:0}._fc-nested-table-form{color:#000;overflow:auto}._fc-nested-table-form .form-create .el-form-item{margin-bottom:1px}._fc-nested-table-form .el-form-item__label{display:none!important}._fc-nested-table-form .el-form-item__content{display:flex;margin-left:0!important;width:100%!important}._fc-ntf-table ._fc-ntf-head-idx,._fc-ntf-table ._fc-ntf-idx{font-weight:500;min-width:40px;padding:0;text-align:center;width:40px}._fc-ntf-idx div{border:1px solid #bfbfbf;border-radius:6px;cursor:pointer;display:inline-flex;height:18px;justify-content:center;line-height:16px;width:18px}._fc-ntf-sub-idx{width:30px}._fc-ntf-btn,._fc-ntf-edit{min-width:70px;text-align:center;width:70px}._fc-ntf-btn .fc-icon{cursor:pointer}._fc-nested-table-form._fc-disabled ._fc-ntf-btn .fc-icon,._fc-nested-table-form._fc-disabled>.el-button{cursor:not-allowed}._fc-ntf-table{border:1px solid #ebeef5;border-bottom:0;height:100%;overflow:hidden;table-layout:fixed;width:100%}._fc-ntf-table>thead>tr>th{border:0;border-bottom:1px solid #ebeef5;color:#000000e0;font-weight:600;height:40px}._fc-ntf-table>thead>tr>th+th{border-left:1px solid #ebeef5}._fc-ntf-table tr{min-height:50px}._fc-ntf-table ._fc-read-view{text-align:center;width:100%}._fc-ntf-table td{border:0;border-bottom:1px solid #ebeef5;box-sizing:border-box;min-height:50px;min-width:80px;overflow:hidden;overflow-wrap:break-word;padding:10px;position:relative}._fc-ntf-table td+td{border-left:1px solid #ebeef5}._fc-ntf-table .el-cascader,._fc-ntf-table .el-date-editor,._fc-ntf-table .el-input-number,._fc-ntf-table .el-select,._fc-ntf-table .el-slider{width:100%}._fc-nested-table-form ._fc-ntf-sub{background-color:#fafafa}._fc-ntf-sub ._fc-table-form{background-color:#fff}._fc-ntf-sub ._fc-tf-table{border:0}._fc-ntf-idx+._fc-ntf-idx,._fc-ntf-sub-idx+._fc-ntf-head-idx{border-left:0}._fd-itable-form{background:#fff;border:1px solid #ececec;min-height:130px;width:100%}._fd-itable-form ._fc-child-empty{min-height:130px}._fd-itf-wrap{display:flex;overflow:auto}._fd-itf-wrap>._fd-drag-tool{display:flex;flex-shrink:0;height:auto;margin:2px}._fc-infinite-table-form{color:#000;overflow:auto}._fc-infinite-table-form .form-create .el-form-item{margin-bottom:1px}._fc-infinite-table-form .el-form-item__label{display:none!important}._fc-infinite-table-form .el-form-item__content{display:flex;margin-left:0!important;width:100%!important}._fc-itf-table ._fc-itf-head-idx,._fc-itf-table ._fc-itf-idx{font-weight:500;min-width:40px;padding:0;text-align:center;width:40px}._fc-itf-idx div{border:1px solid #bfbfbf;border-radius:6px;cursor:pointer;display:inline-flex;height:18px;justify-content:center;line-height:16px;width:18px}._fc-itf-sub-idx{width:30px}._fc-itf-btn,._fc-itf-edit{min-width:70px;text-align:center;width:70px}._fc-itf-btn .fc-icon{cursor:pointer}._fc-infinite-table-form._fc-disabled ._fc-itf-btn .fc-icon,._fc-infinite-table-form._fc-disabled>.el-button{cursor:not-allowed}._fc-itf-table{border:1px solid #ebeef5;border-bottom:0;height:100%;overflow:hidden;table-layout:fixed;width:100%}._fc-itf-table>thead>tr>th{border:0;border-bottom:1px solid #ebeef5;color:#000000e0;font-weight:600;height:40px}._fc-itf-table ._fc-itf-table>thead{display:none}._fc-itf-table ._fc-itf-table{border-right:0}._fc-itf-table>thead>tr>th+th{border-left:1px solid #ebeef5}._fc-itf-table tr{min-height:50px}._fc-itf-table ._fc-read-view{text-align:center;width:100%}._fc-itf-table td{border:0;border-bottom:1px solid #ebeef5;box-sizing:border-box;min-height:50px;min-width:80px;overflow:hidden;overflow-wrap:break-word;padding:10px;position:relative}._fc-itf-table td+td{border-left:1px solid #ebeef5}._fc-itf-table .el-cascader,._fc-itf-table .el-date-editor,._fc-itf-table .el-input-number,._fc-itf-table .el-select,._fc-itf-table .el-slider{width:100%}._fc-infinite-table-form ._fc-itf-sub{padding:5px 0 5px 10px}._fc-itf-sub ._fc-table-form{background-color:#fff}._fc-itf-sub ._fc-tf-table{border:0}._fc-itf-idx+._fc-itf-idx,._fc-itf-sub-idx+._fc-itf-head-idx{border-left:0}._fc-table-form{color:#000;overflow:auto}._fc-table-form .form-create .el-form-item{margin-bottom:1px}._fc-table-form .el-form-item__label{display:none!important}._fc-table-form .el-form-item__content{display:flex;margin-left:0!important;width:100%!important}._fc-tf-head-idx,._fc-tf-idx{font-weight:500;min-width:40px;text-align:center;width:40px}._fc-tf-btn,._fc-tf-edit{min-width:70px;text-align:center;width:70px}._fc-tf-btn .fc-icon{cursor:pointer}._fc-table-form._fc-disabled ._fc-tf-btn .fc-icon,._fc-table-form._fc-disabled>.el-button{cursor:not-allowed}._fc-tf-table{border:1px solid #ebeef5;border-bottom:0;height:100%;overflow:hidden;table-layout:fixed;width:100%}._fc-table-form ._fc-tf-table>thead>tr>th{border:0;border-bottom:1px solid #ebeef5;color:#000000e0;font-weight:600;height:40px}._fc-table-form ._fc-tf-table>thead>tr>th+th{border-left:1px solid #ebeef5}._fc-table-form tr{min-height:50px}._fc-table-form ._fc-read-view{text-align:center;width:100%}._fc-table-form td{border:0;border-bottom:1px solid #ebeef5;box-sizing:border-box;min-height:50px;min-width:80px;overflow:hidden;overflow-wrap:break-word;padding:5px;position:relative}._fc-table-form td+td{border-left:1px solid #ebeef5}._fc-tf-table .el-cascader,._fc-tf-table .el-date-editor,._fc-tf-table .el-input-number,._fc-tf-table .el-select,._fc-tf-table .el-slider{width:100%}._fd-tf-col ._fd-tf-con .el-form-item{margin-bottom:1px}._fd-tf-col{display:flex;flex-direction:column;flex-shrink:0;flex-wrap:wrap;width:180px}._fd-tf-con .el-form-item__label{display:none!important}._fd-tf-con{display:flex;flex:1;width:100%}._fd-tf-con .el-form-item__content{display:flex;margin-left:0!important;width:100%!important}._fd-tf-title{align-items:center;border-bottom:1px solid #ebeef5;display:flex;height:40px;margin-bottom:0;padding-left:5px;width:100%!important}._fd-tf-con ._fc-l-item{display:flex;flex-shrink:0;margin-top:4px;width:100%}._fd-tf-con ._fc-l-item>*{display:none!important}._fd-tf-con .el-cascader,._fd-tf-con .el-date-editor,._fd-tf-con .el-input-number,._fd-tf-con .el-select,._fd-tf-con .el-slider{width:100%}._fd-step-form-item>._fd-drag-tool{min-height:200px}._fc-cell{display:inline-block;width:50%}._fc-cell .el-cascader,._fc-cell .el-date-editor,._fc-cell .el-input-number,._fc-cell .el-select,._fc-cell .el-slider,._fd-row{width:100%}._fc-designer{--fc-drag-empty:"\\62d6\\62fd\\5de6\\4fa7\\5217\\8868\\4e2d\\7684\\7ec4\\4ef6\\5230\\6b64\\5904";--fc-child-empty:"\\70b9\\51fb\\53f3\\4e0b\\89d2  \\e789  \\6309\\94ae\\6dfb\\52a0\\4e00\\5217";--fc-tool-border-color:#ddddde;background-color:#fff;cursor:default;height:100%;min-height:500px;overflow:hidden;position:relative}._fc-designer>.el-main{bottom:0;left:0;padding:0;position:absolute;right:0;top:0}._fc-m .form-create ._fc-l-item{align-items:center;background:#f5f5f5;border:1px dashed #000;border-radius:4px;color:#000;display:flex!important;height:30px;justify-content:center;margin:5px 0;overflow:hidden;padding-bottom:0;transition:all .3s ease;width:100%}._fc-m .form-create ._fc-l-item ._fc-l-icon{display:inline-block!important;padding:0 4px}._fc-m .form-create ._fc-l-item ._fc-l-name{display:inline-block!important;font-size:12px}._fc-l,._fc-m,._fc-r{border-top:1px solid #ececec;box-sizing:border-box}._fc-r{--el-color-primary:#2e73ff}._fc-r-tab-props{padding:0 20px}._fc-r-title{color:#606266;font-size:12px;margin:15px 0 5px}._fc-r-name-input .el-input-group__append{color:#606266;cursor:pointer;margin:0;padding:0;width:25px}._fc-r .el-main{padding-bottom:100px}._fc-l .el-main{padding:0}._fc-l .el-tree-node__label{color:#333;font-weight:400;padding:3px}._fc-l .el-tree-node__content{height:30px;margin-top:5px}._fc-l .el-tree-node__content>.el-tree-node__expand-icon{color:#333}._fc-l .el-tree-node__expand-icon.is-leaf{color:transparent}@keyframes a{0%{transform:rotate(0)}to{transform:rotate(1turn)}}._fc-loading{animation:a 2s linear infinite}._fc-tree-node{align-items:center;display:flex;height:26px;justify-content:space-between;line-height:26px;padding-right:5px;width:100%}._fc-tree-node.active,._fc-tree-node.active .icon-more{color:#2e73ff}._fc-tree-label{align-items:center;display:flex}._fc-tree-label>i{font-weight:700;margin-right:5px}._fc-tree-more{align-items:center;display:flex;font-weight:700;padding:0 15px}._fc-l-tabs{border-bottom:1px solid #ececec;display:flex;padding:0}._fc-l-tab{box-sizing:border-box;color:#303133;display:inline-block;flex:1;font-size:14px;font-weight:600;height:40px;line-height:40px;list-style:none;position:relative;text-align:center}._fc-l ._fc-l-tab.active{border-bottom:2px solid #409eff;color:#409eff}._fc-l-group{border:1px solid #eee;margin:12px;padding:0;user-select:none}._fc-l-group ._fc-l-list{align-items:stretch;display:grid;grid-template-columns:repeat(3,1fr)}._fc-l-group.is-template ._fc-l-list{grid-column-gap:5px;align-items:stretch;display:grid;grid-template-columns:repeat(2,1fr);padding:0 7px}._fc-l-group.is-template ._fc-l-item{background:#eee;height:30px;line-height:28px;margin-bottom:5px;overflow:hidden;padding-bottom:0;text-overflow:ellipsis;white-space:nowrap}._fc-l-group.is-template ._fc-l-item:hover{background:#2e73ff}._fc-l-title{align-items:center;cursor:pointer;display:flex;font-weight:600;justify-content:space-between;margin:0;padding:12px}._fc-l-title,._fc-l-title i{font-size:14px}._fc-l-title i.down{transform:rotate(90deg)}._fc-l-item{background:#fff;color:#000;cursor:pointer;display:inline-block;line-height:1;padding-bottom:10px;text-align:center;transition:all .2s ease}._fc-l-item i{display:inline-block;font-size:21px}._fc-l-item ._fc-l-name{font-size:12px}._fc-l-item ._fc-l-icon{padding:10px 5px 12px}._fc-l-item:hover{background:#2e73ff;color:#fff}._fc-m-tools{border:1px solid #ececec;border-top:0;height:40px;justify-content:space-between}._fc-m-tools,._fc-m-tools-l,._fc-m-tools-r{align-items:center;display:flex}._fc-m-tools-l svg{cursor:pointer;width:18px}._fc-m-tools-l svg+svg{margin-left:10px}._fc-m-tools .line{background:#d8d8d8;height:24px;margin:0 10px;width:1px}._fc-m-tools .el-button{align-items:center;border-radius:5px;display:flex;padding:5px 10px}._fc-m-tools .el-button>span{align-items:center;display:inline-flex;justify-content:center}._fc-m-tools .el-button+.el-button,._fc-m-tools .el-dropdown{margin-left:10px}._fc-m-tools ._fd-m-extend{background-color:#f1f1f1;border-color:#ccc;border-radius:5px;color:#666;padding:5px}._fc-m-tools ._fd-m-extend .fc-icon{margin-right:0}._fc-m-tools ._fd-input-btn{align-items:center;display:flex;font-size:12px;justify-content:space-between}._fc-m-tools ._fd-input-btn .icon-check{color:#67c23a;font-size:18px}._fc-m-tools-r .fc-icon{font-size:14px;margin-right:2px}._fc-m-tools-l .fc-icon{cursor:pointer;font-size:18px}._fc-m-tools-l .fc-icon+.fc-icon{margin-left:10px}._fc-m-tools-l .fc-icon.disabled{color:#999;cursor:not-allowed}._fc-r .el-tabs__nav-wrap:after{background-color:#ececec;height:1px}._fc-r ._fc-r-tabs{border-bottom:1px solid #ececec;display:flex;padding:0}._fc-r .el-button,._fc-r .el-radio-button__inner,._fc-r .el-table__cell .cell{font-weight:400}._fc-r ._fc-r-tab{box-sizing:border-box;color:#303133;display:inline-block;flex:1;font-size:14px;font-weight:600;height:40px;line-height:40px;list-style:none;position:relative;text-align:center}._fc-r ._fc-r-tab.active{border-bottom:2px solid #409eff;color:#409eff}._fc-m-con{background:#f5f5f5;padding:20px;position:relative}._fc-m-drag{box-sizing:border-box;margin:0 auto;overflow:auto;padding:2px}._fc-m-input{padding:5px 5px 80px}._fc-m-input-handle{background:#fff;bottom:0;box-shadow:0 -8px 14px #0000001a;left:0;margin:20px;padding:12px;position:absolute;right:0;text-align:center;z-index:2}._fc-m-drag.mobile{width:350px}._fc-m-drag.pad{width:770px}._fc-m-drag,.draggable-drag{background:#fff;height:100%;position:relative}._fc-m-drag>form,._fc-m-drag>form>.el-row{height:100%}._fc-m-drag .el-tree{width:100%}._fd-drag-box{height:100%;min-height:60px;transition:padding-bottom,padding-top .3s ease;width:100%}._fd-drag-box ._fd-drag-box{outline:1px dashed #ececec}._fd-drag-tool>._fd-drag-box{outline:none}._fd-drag-box>div[data-draggable]{margin-bottom:1px}._fc-r ._fc-group-container+._fc-group-container{margin-top:20px}._fc-r ._fc-group-container{margin:0;padding:10px}._fc-r ._fc-group-handle{right:15px}._fc-r .el-form-item{margin-bottom:10px!important}._fc-r .el-form-item__label{color:#333}._fc-upload-preview{border-radius:5px;display:inline-block;height:120px;overflow:hidden;width:120px}.cm-fc-field,.cm-fc-id{background-color:#2e73ff;border-radius:5px;color:#fff;display:inline-block;line-height:1.5em;padding:0 8px}.cm-fc-id{background-color:#df2121}.CodeMirror-widget+.CodeMirror-widget{margin-left:5px}._fc-tabs .el-tabs__item{font-weight:400}._fc-tabs .el-tabs__nav-scroll{padding:0 15px}._fc-tabs .el-tab-pane{margin-right:15px}._fc-tabs .el-tabs__nav-wrap:after{height:1px}.form-create .fc-none{display:none}._fc-child-empty,._fd-draggable-drag.drag-holder,._fd-elCard-drag.drag-holder,._fd-elCollapseItem-drag.drag-holder,._fd-elTabPane-drag.drag-holder,._fd-elTooltip-drag.drag-holder,._fd-group-drag.drag-holder,._fd-stepFormItem-drag.drag-holder,._fd-subForm-drag.drag-holder,._fd-tableFormColumn-drag.drag-holder{background:#f5f5f5 url(data:image/png;base64,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);background-size:0;min-height:90px;position:relative}._fc-child-empty:after,._fd-draggable-drag.drag-holder:after,._fd-elCard-drag.drag-holder:after,._fd-elCollapseItem-drag.drag-holder:after,._fd-elTabPane-drag.drag-holder:after,._fd-elTooltip-drag.drag-holder:after,._fd-group-drag.drag-holder:after,._fd-stepFormItem-drag.drag-holder:after,._fd-subForm-drag.drag-holder:after,._fd-tableFormColumn-drag.drag-holder:after{align-items:center;bottom:0;color:#aaa;content:var(--fc-drag-empty);display:flex;font-size:12px;justify-content:center;left:0;position:absolute;right:0;top:0}._fc-designer ._fc-m-drag ._fd-draggable-drag{overflow:scroll;padding:2px 2px 100px}._fc-m-drag._fd-drop-hover ._fd-draggable-drag{padding-top:20px}._fd-draggable-drag.drag-holder{background-color:#fff}._fd-draggable-drag.drag-holder:after{font-size:16px}._fc-child-empty:after{content:var(--fc-child-empty);font-family:fc-icon!important}.fc-configured{color:#999;margin-left:5px}._fc-manage-text{color:#2f73ff;cursor:pointer;font-size:12px;margin-left:4px}._fc-manage-text i{font-size:12px}._fc-message-error{background-color:#fff;border-color:#fff;border-radius:8px;box-shadow:0 6px 16px #00000014,0 3px 6px -4px #0000001f,0 9px 28px 8px #0000000d;padding:9px 13px;top:16px;z-index:3}._fc-message-error>.el-icon{font-size:18px}._fc-message-error .el-message__content{color:#000000e0;font-size:14px}._fd-preview-dialog{border-radius:6px;padding-top:0}._fd-preview-dialog .el-dialog__header{float:right;position:absolute;right:0;top:0;z-index:1}._fd-preview-code{margin-top:0;max-height:510px;overflow:scroll}._fd-preview-tabs .el-tabs__nav-wrap:after{height:1px}._fd-preview-tabs .el-tabs__item{height:46px}._fd-preview-code>code{white-space:pre-wrap}._fd-row-line{background:#d8d8d8;height:1px;margin:10px 0;width:100%}.CodeMirror-hints{z-index:4}@font-face{font-family:fc-icon;src:url(data:font/woff;base64,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) format("woff")}.fc-icon{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:fc-icon!important;font-size:16px;font-style:normal}.icon-save-online:before{content:"\\e64b"}.icon-auto:before{content:"\\e692"}.icon-check:before{content:"\\e64c"}.icon-tooltip:before{content:"\\e7f3"}.icon-watermark:before{content:"\\e645"}.icon-table-form3:before{content:"\\e603"}.icon-table-form2:before{content:"\\e7f1"}.icon-card:before{content:"\\e76b"}.icon-lock:before{content:"\\eadc"}.icon-minus:before{content:"\\eafd"}.icon-shadow:before{content:"\\e6cc"}.icon-shadow-inset:before{content:"\\e6cd"}.icon-alignitems-flexstart:before{content:"\\e630";display:inline-block;transform:rotate(180deg)}.icon-align-center:before{content:"\\e607";display:inline-block;transform:rotate(90deg)}.icon-align-flexstart:before{content:"\\e60a";display:inline-block;transform:rotate(90deg)}.icon-align-spacearound:before{content:"\\e61f";display:inline-block;transform:rotate(-90deg)}.icon-align-spacebetween:before{content:"\\e65e";display:inline-block;transform:rotate(-90deg)}.icon-align-stretch:before{content:"\\e606";display:inline-block;transform:rotate(-90deg)}.icon-align-flexend:before{content:"\\e60a";display:inline-block;transform:rotate(-90deg)}.icon-justify-flexend:before{content:"\\e60a";display:inline-block;transform:rotate(180deg)}.icon-direction-rowreverse:before{content:"\\e677"}.icon-direction-row:before{content:"\\e678"}.icon-direction-column:before{content:"\\e679"}.icon-direction-columnreverse:before{content:"\\e67a"}.icon-justify-spacearound:before{content:"\\e61f"}.icon-justify-spacebetween:before{content:"\\e65e"}.icon-alignitems-baseline:before{content:"\\e660"}.icon-alignitems-flexend:before{content:"\\e630"}.icon-alignitems-center:before{content:"\\e632"}.icon-alignitems-stretch:before{content:"\\e633"}.icon-flex-nowrap:before{content:"\\e600"}.icon-flex-wrap:before{content:"\\e601"}.icon-justify-stretch:before{content:"\\e606"}.icon-justify-center:before{content:"\\e607"}.icon-justify-flexstart:before{content:"\\e60a"}.icon-display-flex:before{content:"\\e619"}.icon-display-inlineblock:before{content:"\\e61c"}.icon-display-block:before{content:"\\e61d"}.icon-display-inline:before{content:"\\e61e"}.icon-radius:before{content:"\\e6a1"}.icon-arrow:before{content:"\\e60e"}.icon-link:before{content:"\\e63f"}.icon-question:before{content:"\\e644"}.icon-refresh:before{content:"\\e659"}.icon-setting:before{content:"\\e7c6"}.icon-textarea:before{content:"\\e7c9"}.icon-password:before{content:"\\e7ca"}.icon-table-form:before{content:"\\e7c7"}.icon-value:before{content:"\\e7c8"}.icon-eye:before{content:"\\e796"}.icon-eye-close:before{content:"\\e66f"}.icon-cell:before{content:"\\e602"}.icon-group:before{content:"\\e7c0"}.icon-step-form:before{content:"\\e7c1"}.icon-add-circle:before{content:"\\e7c3"}.icon-add-tr:before{content:"\\e7c4"}.icon-add-td:before{content:"\\e7c5"}.icon-more:before{content:"\\e631"}.icon-flex:before{content:"\\e7b6"}.icon-tag:before{content:"\\e7b9"}.icon-html:before{content:"\\e68f"}.icon-tree-select:before{content:"\\e7bc"}.icon-descriptions:before{content:"\\e7bd"}.icon-table:before{content:"\\eb0a"}.icon-collapse:before{content:"\\e7bf"}.icon-pre-step:before{content:"\\e772"}.icon-next-step:before{content:"\\e775"}.icon-mobile-active:before{content:"\\e778"}.icon-pc-active:before{content:"\\e779"}.icon-pc:before{content:"\\e77a"}.icon-mobile:before{content:"\\e77d"}.icon-pad-active:before{content:"\\e78c"}.icon-pad:before{content:"\\e795"}.icon-subform:before{content:"\\eb77"}.icon-add-child:before{content:"\\e789"}.icon-switch:before{content:"\\e77c"}.icon-tab:before{content:"\\e77b"}.icon-button:before{content:"\\e77e"}.icon-input:before{content:"\\e77f"}.icon-checkbox:before{content:"\\e780"}.icon-radio:before{content:"\\e781"}.icon-rate:before{content:"\\e782"}.icon-number:before{content:"\\e783"}.icon-upload:before{content:"\\e784"}.icon-cascader:before{content:"\\e785"}.icon-space:before{content:"\\e786"}.icon-color:before{content:"\\e787"}.icon-span:before{content:"\\e788"}.icon-alert:before{content:"\\e78a"}.icon-row:before{content:"\\e78b"}.icon-divider:before{content:"\\e78d"}.icon-select:before{content:"\\e78e"}.icon-transfer:before{content:"\\e78f"}.icon-editor:before{content:"\\e790"}.icon-slider:before{content:"\\e791"}.icon-tree:before{content:"\\e792"}.icon-date:before{content:"\\e793"}.icon-time:before{content:"\\e794"}.icon-grid:before{content:"\\eb78"}.icon-delete:before{content:"\\e770"}.icon-copy:before{content:"\\e771"}.icon-import:before{content:"\\e773"}.icon-add:before{content:"\\e774"}.icon-preview:before{content:"\\e776"}.icon-move:before{content:"\\e777"}pre code.hljs{display:block;overflow-x:auto;padding:1em}code.hljs{padding:3px 5px}.hljs{background:#fff;color:#000}.hljs-subst,.hljs-title{color:#000;font-weight:400}.hljs-title.function_{color:#7a7a43}.hljs-code,.hljs-comment,.hljs-quote{color:#8c8c8c;font-style:italic}.hljs-meta{color:#9e880d}.hljs-section{color:#871094}.hljs-built_in,.hljs-keyword,.hljs-literal,.hljs-meta .hljs-keyword,.hljs-name,.hljs-selector-attr,.hljs-selector-class,.hljs-selector-id,.hljs-selector-pseudo,.hljs-selector-tag,.hljs-symbol,.hljs-template-tag,.hljs-type,.hljs-variable.language_{color:#0033b3}.hljs-attr,.hljs-property{color:#871094}.hljs-attribute{color:#174ad4}.hljs-number{color:#1750eb}.hljs-regexp{color:#264eff}.hljs-link{color:#006dcc;text-decoration:underline}.hljs-meta .hljs-string,.hljs-string{color:#067d17}.hljs-char.escape_{color:#0037a6}.hljs-doctag{text-decoration:underline}.hljs-template-variable{color:#248f8f}.hljs-addition{background:#bee6be}.hljs-deletion{background:#d6d6d6}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:700}')), document.head.appendChild(e) } } catch (o) { console.error("vite-plugin-css-injected-by-js", o) } })();
import { computed as Vn, unref as rc, isRef as Gh, ref as So, resolveComponent as ie, TransitionGroup as Yh, defineComponent as et, h as Eo, nextTick as cr, markRaw as On, openBlock as Z, createElementBlock as fe, createElementVNode as _, createTextVNode as xe, toDisplayString as ve, Fragment as ze, renderList as ft, createBlock as we, withCtx as Y, createVNode as X, createCommentVNode as Se, withModifiers as yt, withKeys as jl, toRefs as af, getCurrentInstance as Qh, reactive as ni, provide as sf, toRef as vo, watch as gl, normalizeClass as ot, withDirectives as dr, vShow as fr, renderSlot as en, normalizeStyle as ri, createSlots as Kh, pushScopeId as Jh, popScopeId as Xh, mergeProps as Vr, normalizeProps as Zh, guardReactiveProps as qh, resolveDynamicComponent as zl } from "vue";
import _n from "@form-create/element-ui";
import { ElMessage as _h } from "element-plus";
const st = {
  type(e, o) {
    return Object.prototype.toString.call(e) === "[object " + o + "]";
  },
  Undef(e) {
    return e == null;
  },
  Element(e) {
    return typeof e == "object" && e !== null && e.nodeType === 1 && !st.Object(e);
  },
  trueArray(e) {
    return Array.isArray(e) && e.length > 0;
  },
  Function(e) {
    const o = this.getType(e);
    return o === "Function" || o === "AsyncFunction";
  },
  getType(e) {
    const o = Object.prototype.toString.call(e);
    return /^\[object (.*)\]$/.exec(o)[1];
  },
  empty(e) {
    return e == null || Array.isArray(e) && Array.isArray(e) && !e.length ? !0 : typeof e == "string" && !e;
  }
};
["Date", "Object", "String", "Boolean", "Array", "Number"].forEach((e) => {
  st[e] = function (o) {
    return st.type(o, e);
  };
});
function Nr(e, o) {
  return {}.hasOwnProperty.call(e, o);
}
function mo(e, o, i) {
  e[o] = i;
}
function Wl(e, o = {}, i) {
  let l = !1;
  for (let n in o)
    if (Object.prototype.hasOwnProperty.call(o, n)) {
      let u = o[n];
      if ((l = Array.isArray(u)) || st.Object(u)) {
        let f = e[n] === void 0;
        if (l)
          l = !1, f && mo(e, n, []);
        else if (u._clone && i !== void 0)
          if (i)
            u = u.getRule(), f && mo(e, n, {});
          else {
            mo(e, n, u._clone());
            continue;
          }
        else
          f && mo(e, n, {});
        e[n] = Wl(e[n], u, i);
      } else
        mo(e, n, u), st.Undef(u) || (st.Undef(u.__json) || (e[n].__json = u.__json), st.Undef(u.__origin) || (e[n].__origin = u.__origin));
    }
  return i !== void 0 && Array.isArray(e) ? e.filter((n) => !n || !n.__ctrl) : e;
}
function Lt(e) {
  return Wl({}, { value: e }).value;
}
function ev(e, o, i) {
  return `[form-create ${e}]: ${o}` + (i ? `

rule: ` + JSON.stringify(i.getRule ? i.getRule() : i) : "");
}
function tv(e, o) {
  console.error(ev("err", e, o));
}
const uf = "[[FORM-CREATE-PREFIX-", df = "-FORM-CREATE-SUFFIX]]", ff = "$FN:", cf = "$FNX:", pf = "$GLOBAL:", yl = "function";
function hf(e) {
  return new Function("return " + e)();
}
function nv(e, o) {
  if (e && st.String(e) && e.length > 4) {
    let i = e.trim(), l = !1;
    try {
      if (i.indexOf(df) > 0 && i.indexOf(uf) === 0)
        i = i.replace(df, "").replace(uf, ""), l = !0;
      else if (i.indexOf(ff) === 0)
        i = i.replace(ff, ""), l = !0;
      else if (i.indexOf(pf) === 0) {
        const u = i.replace(pf, "");
        return i = function (...f) {
          const p = f[0].api.getGlobalEvent(u);
          if (p)
            return p.call(this, ...f);
        }, i.__json = e, i.__inject = !0, i;
      } else {
        if (i.indexOf(cf) === 0)
          return i = hf("function($inject){" + i.replace(cf, "") + "}"), i.__json = e, i.__inject = !0, i;
        !o && i.indexOf(yl) === 0 && i !== yl && (l = !0);
      }
      if (!l)
        return e;
      const n = hf(i.indexOf(yl) === -1 && i.indexOf("(") !== 0 ? yl + " " + i : i);
      return n.__json = e, n;
    } catch (n) {
      tv(`\u89E3\u6790\u5931\u8D25:${i}

err: ${n}`);
      return;
    }
  }
  return e;
}
function rv(e) {
  const o = e.replace(/(-[a-z])/g, function (i) {
    return i.replace("-", "").toLocaleUpperCase();
  });
  return Vs(o);
}
function Vs(e) {
  return e.replace(e[0], e[0].toLowerCase());
}
const ic = {
  name: "zh-cn",
  form: {
    field: "\u5B57\u6BB5 ID",
    title: "\u5B57\u6BB5\u540D\u79F0",
    info: "\u63D0\u793A\u4FE1\u606F",
    control: "\u8054\u52A8\u6570\u636E",
    labelPosition: "\u6807\u7B7E\u7684\u4F4D\u7F6E",
    labelStyle: "\u6807\u7B7E\u7684\u6837\u5F0F",
    labelSuffix: "\u6807\u7B7E\u7684\u540E\u7F00",
    globalEvent: "\u5168\u5C40\u4E8B\u4EF6",
    globalFetch: "\u5168\u5C40\u6570\u636E\u6E90",
    globalClass: "\u5168\u5C40\u6837\u5F0F",
    globalConfig: "\u5168\u5C40\u914D\u7F6E",
    size: "\u8868\u5355\u7684\u5C3A\u5BF8",
    event: "\u8868\u5355\u4E8B\u4EF6",
    labelWidth: "\u6807\u7B7E\u7684\u5BBD\u5EA6",
    hideRequiredAsterisk: "\u9690\u85CF\u5FC5\u586B\u5B57\u6BB5\u7684\u6807\u7B7E\u65C1\u8FB9\u7684\u7EA2\u8272\u661F\u53F7",
    showMessage: "\u663E\u793A\u6821\u9A8C\u9519\u8BEF\u4FE1\u606F",
    inlineMessage: "\u4EE5\u884C\u5185\u5F62\u5F0F\u5C55\u793A\u6821\u9A8C\u4FE1\u606F",
    submitBtn: "\u662F\u5426\u663E\u793A\u8868\u5355\u63D0\u4EA4\u6309\u94AE",
    resetBtn: "\u662F\u5426\u663E\u793A\u8868\u5355\u91CD\u7F6E\u6309\u94AE",
    appendChild: "\u6DFB\u52A0\u5B50\u7EA7",
    formMode: "\u8868\u5355\u6A21\u5F0F",
    formName: "\u8868\u5355\u540D\u79F0",
    previewMode: "\u9605\u8BFB\u6A21\u5F0F",
    componentMode: "\u751F\u6210\u7EC4\u4EF6",
    document: "\u5E2E\u52A9\u6587\u6863",
    onSubmit: "\u8868\u5355\u63D0\u4EA4\u65F6\u89E6\u53D1",
    onCreated: "\u8868\u5355\u7EC4\u4EF6\u521D\u59CB\u5316\u5B8C\u6BD5\u540E\u89E6\u53D1",
    onMounted: "\u8868\u5355\u7EC4\u4EF6\u6E32\u67D3\u5B8C\u6BD5\u540E\u89E6\u53D1",
    onChange: "\u8868\u5355\u7EC4\u4EF6\u7684\u503C\u53D1\u751F\u53D8\u5316\u65F6\u89E6\u53D1",
    beforeFetch: "\u8FDC\u7A0B\u6570\u636E\u8BF7\u6C42\u53D1\u9001\u524D\u89E6\u53D1"
  },
  computed: {
    value: {
      title: "\u8BA1\u7B97\u516C\u5F0F",
      btn: "\u8BBE\u7F6E\u8BA1\u7B97\u516C\u5F0F",
      name: "\u8BBE\u7F6E\u7EC4\u4EF6\u7684\u503C"
    },
    hidden: {
      title: "\u9690\u85CF\u6761\u4EF6",
      btn: "\u8BBE\u7F6E\u9690\u85CF\u6761\u4EF6",
      name: "\u8BBE\u7F6E\u7EC4\u4EF6\u7684\u9690\u85CF\u6761\u4EF6"
    },
    required: {
      title: "\u5FC5\u586B\u6761\u4EF6",
      btn: "\u8BBE\u7F6E\u5FC5\u586B\u6761\u4EF6",
      name: "\u8BBE\u7F6E\u7EC4\u4EF6\u7684\u5FC5\u586B\u6761\u4EF6"
    },
    disabled: {
      title: "\u7981\u7528\u6761\u4EF6",
      btn: "\u8BBE\u7F6E\u7981\u7528\u6761\u4EF6",
      name: "\u8BBE\u7F6E\u7EC4\u4EF6\u7684\u7981\u7528\u6761\u4EF6"
    },
    form: "\u5F53\u524D\u8868\u5355",
    subform: "\u5B50\u8868\u5355",
    formula: "\u51FD\u6570\u516C\u5F0F",
    formulaInfo: "\u51FD\u6570\u8BF4\u660E",
    formulaExample: "\u51FD\u6570\u793A\u4F8B",
    fieldUsed: "\u3010{label}\u3011\u5728\u8BA1\u7B97\u516C\u5F0F\u4E2D\u88AB\u4F7F\u7528\uFF0C\u8BF7\u5148\u4FEE\u6539\u5BF9\u5E94\u516C\u5F0F",
    fieldExist: "\u3010{label}\u3011\u5B57\u6BB5\u5DF2\u5B58\u5728",
    fieldEmpty: "\u5B57\u6BB5\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A",
    fieldChar: "\u5B57\u6BB5\u540D\u79F0\u5FC5\u987B\u4EE5\u5B57\u6BCD\u5F00\u5934"
  },
  validate: {
    type: "\u5B57\u6BB5\u7C7B\u578B",
    typePlaceholder: "\u8BF7\u9009\u62E9",
    trigger: "\u89E6\u53D1\u65B9\u5F0F",
    mode: "\u9A8C\u8BC1\u65B9\u5F0F",
    modes: {
      required: "\u5FC5\u586B",
      pattern: "\u6B63\u5219\u8868\u8FBE\u5F0F",
      min: "\u6700\u5C0F\u503C",
      max: "\u6700\u5927\u503C",
      len: "\u957F\u5EA6"
    },
    types: {
      string: "\u5B57\u7B26\u4E32",
      array: "\u591A\u9009",
      number: "\u6570\u5B57",
      integer: "\u6574\u6570",
      float: "\u5C0F\u6570",
      object: "\u5408\u96C6",
      date: "\u65E5\u671F",
      url: "URL\u94FE\u63A5",
      email: "\u90AE\u7BB1\u5730\u5740"
    },
    message: "\u9519\u8BEF\u4FE1\u606F",
    auto: "\u81EA\u52A8\u83B7\u53D6",
    autoRequired: "\u8BF7\u8F93\u5165{title}",
    autoMode: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684{title}",
    requiredPlaceholder: "\u8BF7\u8F93\u5165\u63D0\u793A\u8BED",
    required: "\u662F\u5426\u5FC5\u586B",
    rule: "\u9A8C\u8BC1\u89C4\u5219"
  },
  tableOptions: {
    handle: "\u64CD\u4F5C",
    add: "\u6DFB\u52A0",
    empty1: "\u70B9\u51FB\u53F3\u4E0B\u89D2",
    empty2: "\u6309\u94AE\u6DFB\u52A0\u4E00\u5217",
    rmCol: "\u5220\u9664\u5F53\u524D\u5217",
    rmRow: "\u5220\u9664\u5F53\u524D\u884C",
    splitRow: "\u62C6\u5206\u6210\u884C",
    splitCol: "\u62C6\u5206\u6210\u5217",
    mergeBottom: "\u5411\u4E0B\u5408\u5E76",
    mergeRight: "\u5411\u53F3\u5408\u5E76",
    addTop: "\u6DFB\u52A0\u4E0A\u5217",
    addBottom: "\u6DFB\u52A0\u4E0B\u5217",
    addLeft: "\u6DFB\u52A0\u5DE6\u5217",
    addRight: "\u6DFB\u52A0\u53F3\u5217",
    keyValue: "\u952E\u503C\u5BF9"
  },
  struct: {
    title: "\u7F16\u8F91\u6570\u636E",
    only: "\u3010{label}\u3011\u53EA\u5141\u8BB8\u6DFB\u52A0\u4E00\u4E2A",
    errorMsg: "\u8F93\u5165\u7684\u5185\u5BB9\u8BED\u6CD5\u9519\u8BEF",
    configured: "\u5DF2\u914D\u7F6E",
    configuredData: "\u5DF2\u914D\u7F6E {num} \u4E2A\u6570\u636E\u6E90",
    configuredEvent: "\u5DF2\u914D\u7F6E {num} \u4E2A\u4E8B\u4EF6"
  },
  class: {
    title: "\u8BBE\u7F6E\u6837\u5F0F",
    create: "\u521B\u5EFA\u6837\u5F0F",
    placeholder: "\u8BF7\u8F93\u5165\u7C7B\u7684\u540D\u79F0",
    saveMsg: "\u8BF7\u5148\u4FDD\u5B58\u5F53\u524D\u6B63\u5728\u7F16\u8F91\u7684\u6837\u5F0F",
    configured: "\u5DF2\u914D\u7F6E {num} \u4E2A\u6837\u5F0F"
  },
  event: {
    title: "\u8BBE\u7F6E\u4E8B\u4EF6",
    create: "\u521B\u5EFA\u4E8B\u4EF6",
    list: "\u4E8B\u4EF6\u5217\u8868",
    placeholder: "\u8BF7\u8F93\u5165\u4E8B\u4EF6\u7684\u540D\u79F0",
    saveMsg: "\u8BF7\u5148\u4FDD\u5B58\u5F53\u524D\u6B63\u5728\u7F16\u8F91\u7684\u4E8B\u4EF6",
    type: "\u7C7B\u578B",
    info: "\u8BF4\u660E",
    label: "\u5B57\u6BB5",
    inject: {
      api: "\u5F53\u524D\u8868\u5355\u7684api",
      rule: "\u5F53\u524D\u8868\u5355\u7684\u751F\u6210\u89C4\u5219",
      self: "\u7EC4\u4EF6\u7684\u751F\u6210\u89C4\u5219",
      option: "\u8868\u5355\u7684\u914D\u7F6E",
      args: "\u4E8B\u4EF6\u7684\u539F\u59CB\u53C2\u6570"
    }
  },
  eventInfo: {
    blur: "\u5931\u53BB\u7126\u70B9\u65F6\u89E6\u53D1",
    focus: "\u83B7\u5F97\u7126\u70B9\u65F6\u89E6\u53D1",
    change: "\u5F53\u7ED1\u5B9A\u503C\u53D8\u5316\u65F6\u89E6\u53D1",
    input: "\u5728\u503C\u6539\u53D8\u65F6\u89E6\u53D1",
    clear: "\u5728\u70B9\u51FB\u6E05\u7A7A\u6309\u94AE\u65F6\u89E6\u53D1",
    close: "\u5173\u95ED\u7EC4\u4EF6\u65F6\u89E6\u53D1",
    click: "\u70B9\u51FB\u7EC4\u4EF6\u65F6\u89E6\u53D1",
    add: "\u589E\u52A0\u65F6\u89E6\u53D1",
    delete: "\u5220\u9664\u65F6\u89E6\u53D1",
    visibleChange: "\u4E0B\u62C9\u6846\u51FA\u73B0/\u9690\u85CF\u65F6\u89E6\u53D1",
    calendarChange: "\u5728\u65E5\u5386\u6240\u9009\u65E5\u671F\u66F4\u6539\u65F6\u89E6\u53D1",
    panelChange: "\u5F53\u65E5\u671F\u9762\u677F\u6539\u53D8\u65F6\u89E6\u53D1"
  },
  fetch: {
    title: "\u8BBE\u7F6E\u6570\u636E\u6E90",
    create: "\u521B\u5EFA\u6570\u636E\u6E90",
    config: "\u8BF7\u6C42\u914D\u7F6E",
    action: "\u8BF7\u6C42\u94FE\u63A5",
    actionRequired: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u94FE\u63A5",
    placeholder: "\u8BF7\u8F93\u5165\u6570\u636E\u6E90\u7684\u540D\u79F0",
    method: "\u8BF7\u6C42\u65B9\u5F0F",
    data: "\u9644\u5E26\u6570\u636E",
    headers: "\u8BF7\u6C42\u5934\u90E8",
    parse: "\u6570\u636E\u5904\u7406",
    response: "\u63A5\u53E3\u8FD4\u56DE\u7684\u6570\u636E",
    onError: "\u9519\u8BEF\u5904\u7406",
    remote: "\u8FDC\u7A0B\u6570\u636E",
    static: "\u9759\u6001\u6570\u636E",
    optionsType: {
      fetch: "\u5168\u5C40\u6570\u636E\u6E90",
      struct: "\u9759\u6001\u6570\u636E"
    }
  },
  style: {
    width: "\u5BBD\u5EA6",
    height: "\u9AD8\u5EA6",
    color: "\u989C\u8272",
    backgroundColor: "\u80CC\u666F\u8272",
    margin: "\u5916\u8FB9\u8DDD",
    padding: "\u5185\u8FB9\u8DDD",
    borderRadius: "\u5706\u89D2",
    border: "\u8FB9\u6846",
    solid: "\u5B9E\u7EBF",
    dashed: "\u865A\u7EBF",
    dotted: "\u70B9\u72B6\u865A\u7EBF",
    double: "\u53CC\u5B9E\u7EBF",
    opacity: "\u900F\u660E\u5EA6",
    scale: "\u7F29\u653E",
    shadow: {
      name: "\u9634\u5F71",
      x: "x\u8F74\u504F\u79FB\u91CF",
      y: "y\u8F74\u504F\u79FB\u91CF",
      vague: "\u6A21\u7CCA\u534A\u5F84",
      extend: "\u6269\u6563\u534A\u5F84",
      inset: "\u5411\u5185",
      external: "\u5411\u5916",
      mode: "\u6A21\u5F0F",
      classic: "\u7ECF\u5178",
      flat: "\u6241\u5E73",
      solid: "\u7ACB\u4F53"
    },
    display: {
      name: "\u5E03\u5C40",
      block: "\u533A\u5757",
      "inline-block": "\u884C\u5185\u533A\u5757",
      inline: "\u884C\u5185\u6587\u672C",
      flex: "\u5F39\u6027\u76D2\u5B50"
    },
    flexDirection: {
      name: "\u4E3B\u8F74\u7684\u65B9\u5411",
      row: "\u4E3B\u8F74\u4E3A\u6C34\u5E73\u65B9\u5411\uFF0C\u8D77\u70B9\u5728\u5DE6\u7AEF",
      "row-reverse": "\u4E3B\u8F74\u4E3A\u6C34\u5E73\u65B9\u5411\uFF0C\u8D77\u70B9\u5728\u53F3\u7AEF",
      column: "\u4E3B\u8F74\u4E3A\u5782\u76F4\u65B9\u5411\uFF0C\u8D77\u70B9\u5728\u4E0A\u6CBF",
      "column-reverse": "\u4E3B\u8F74\u4E3A\u5782\u76F4\u65B9\u5411\uFF0C\u8D77\u70B9\u5728\u4E0B\u6CBF"
    },
    flexWrap: {
      name: "\u662F\u5426\u6362\u884C",
      nowrap: "\u4E0D\u6362\u884C",
      wrap: "\u6362\u884C"
    },
    justifyContent: {
      name: "\u4E3B\u8F74\u4E0A\u7684\u5BF9\u9F50\u65B9\u5F0F",
      "flex-start": "\u5DE6\u5BF9\u9F50",
      "flex-end": "\u53F3\u5BF9\u9F50",
      center: "\u5C45\u4E2D",
      "space-between": "\u4E24\u7AEF\u5BF9\u9F50",
      "space-around": "\u5B50\u5143\u7D20\u4E24\u4FA7\u7684\u95F4\u9694\u76F8\u7B49",
      "space-evenly": "\u5B50\u5143\u7D20\u5E73\u5747\u5206\u5E03\u5728\u4E3B\u8F74\u4E0A"
    },
    alignItems: {
      name: "\u5B50\u5143\u7D20\u4EA4\u53C9\u8F74\u4E0A\u7684\u5BF9\u9F50\u65B9\u5F0F",
      "flex-start": "\u4EA4\u53C9\u8F74\u7684\u8D77\u70B9\u5BF9\u9F50",
      "flex-end": "\u4EA4\u53C9\u8F74\u7684\u7EC8\u70B9\u5BF9\u9F50",
      center: "\u4EA4\u53C9\u8F74\u7684\u4E2D\u70B9\u5BF9\u9F50",
      baseline: "\u6CBF\u7B2C\u4E00\u884C\u6587\u5B57\u7684\u57FA\u7EBF\u5BF9\u9F50",
      stretch: "\u6EE1\u6574\u4E2A\u5BB9\u5668\u7684\u9AD8\u5EA6"
    },
    alignContent: {
      name: "\u591A\u884C\u5B50\u5143\u7D20\u5728\u4EA4\u53C9\u8F74\u4E0A\u7684\u5BF9\u9F50\u65B9\u5F0F",
      "flex-start": "\u4E0E\u4EA4\u53C9\u8F74\u7684\u8D77\u70B9\u5BF9\u9F50",
      "flex-end": "\u4E0E\u4EA4\u53C9\u8F74\u7684\u7EC8\u70B9\u5BF9\u9F50",
      center: "\u4E0E\u4EA4\u53C9\u8F74\u7684\u4E2D\u70B9\u5BF9\u9F50",
      "space-between": "\u4E0E\u4EA4\u53C9\u8F74\u4E24\u7AEF\u5BF9\u9F50",
      "space-around": "\u591A\u884C\u5B50\u5143\u7D20\u5E73\u5747\u5206\u5E03\u5728\u4EA4\u53C9\u8F74",
      stretch: "\u8F74\u7EBF\u5360\u6EE1\u6574\u4E2A\u4EA4\u53C9\u8F74"
    }
  },
  designer: {
    component: "\u7EC4\u4EF6\u914D\u7F6E",
    id: "\u552F\u4E00\u503C",
    name: "\u7F16\u53F7",
    type: "\u7EC4\u4EF6\u7C7B\u578B",
    form: "\u8868\u5355\u914D\u7F6E",
    style: "\u7EC4\u4EF6\u6837\u5F0F\u914D\u7F6E",
    rule: "\u57FA\u7840\u914D\u7F6E",
    advanced: "\u9AD8\u7EA7\u914D\u7F6E",
    props: "\u5C5E\u6027\u914D\u7F6E",
    validate: "\u9A8C\u8BC1\u914D\u7F6E",
    event: "\u4E8B\u4EF6\u914D\u7F6E",
    clearWarn: "\u6E05\u7A7A\u540E\u5C06\u4E0D\u80FD\u6062\u590D\uFF0C\u786E\u5B9A\u8981\u6E05\u7A7A\u5417\uFF1F",
    childEmpty: "\u70B9\u51FB\u53F3\u4E0B\u89D2 \\e789  \u6309\u94AE\u6DFB\u52A0\u4E00\u5217",
    dragEmpty: "\u62D6\u62FD\u5DE6\u4FA7\u5217\u8868\u4E2D\u7684\u7EC4\u4EF6\u5230\u6B64\u5904",
    unload: "\u786E\u5B9A\u79BB\u5F00\u5F53\u524D\u9875\u9762\u5417?"
  },
  menu: {
    template: "\u6A21\u677F",
    main: "\u57FA\u7840\u7EC4\u4EF6",
    aide: "\u8F85\u52A9\u7EC4\u4EF6",
    layout: "\u5E03\u5C40\u7EC4\u4EF6",
    component: "\u7EC4\u4EF6",
    subform: "\u5B50\u8868\u5355\u7EC4\u4EF6",
    tree: "\u7ED3\u6784"
  },
  formula: {
    math: "\u6570\u5B57\u5904\u7406",
    string: "\u6587\u672C\u5904\u7406",
    date: "\u65F6\u95F4\u5904\u7406",
    collection: "\u5408\u96C6\u5904\u7406",
    condition: "\u903B\u8F91\u5904\u7406",
    ADD: "\u83B7\u53D6\u4E24\u4E2A\u6570\u5B57\u76F8\u52A0\u7684\u503C",
    SUB: "\u83B7\u53D6\u4E24\u4E2A\u6570\u5B57\u76F8\u51CF\u7684\u503C",
    MUL: "\u83B7\u53D6\u4E24\u4E2A\u6570\u5B57\u76F8\u4E58\u7684\u503C",
    DIV: "\u83B7\u53D6\u4E24\u4E2A\u6570\u5B57\u76F8\u9664\u7684\u503C",
    SUM: "\u83B7\u53D6\u5408\u96C6\u4E2D\u6570\u503C\u7684\u603B\u548C",
    MAX: "\u83B7\u53D6\u53C2\u6570\u5217\u8868\u4E2D\u7684\u6700\u5927\u503C",
    MIN: "\u83B7\u53D6\u53C2\u6570\u5217\u8868\u4E2D\u7684\u6700\u5C0F\u503C",
    ABS: "\u83B7\u53D6\u6570\u5B57\u7684\u7EDD\u5BF9\u503C",
    AVG: "\u83B7\u53D6\u53C2\u6570\u5217\u8868\u7684\u5E73\u5747\u503C",
    POWER: "\u83B7\u53D6\u6307\u5B9A\u6570\u5B57\u7684\u4E58\u5E42",
    RAND: "\u83B7\u53D6\u4E00\u4E2A\u5927\u4E8E\u7B49\u4E8E0\u4E14\u5C0F\u4E8E1\u7684\u968F\u673A\u6570",
    PI: "\u83B7\u53D6\u5706\u5468\u7387",
    ROUND: "\u5C06\u4E00\u4E2A\u5C0F\u6570\u56DB\u820D\u4E94\u5165\u5230\u6307\u5B9A\u7684\u4F4D\u6570",
    SQRT: "\u83B7\u53D6\u4E00\u4E2A\u6570\u5B57\u7684\u6B63\u5E73\u65B9\u6839",
    NOW: "\u83B7\u53D6\u5F53\u524D\u7684\u65F6\u95F4",
    TODAY: "\u83B7\u53D6\u4ECA\u5929\u7684\u65E5\u671F",
    YEAR: "\u83B7\u53D6\u6307\u5B9A\u65E5\u671F\u7684\u5E74\u4EFD",
    MONTH: "\u83B7\u53D6\u6307\u5B9A\u65E5\u671F\u7684\u6708\u4EFD",
    DAY: "\u83B7\u53D6\u6307\u5B9A\u65E5\u671F\u7684\u5929\u6570",
    HOUR: "\u83B7\u53D6\u6307\u5B9A\u65E5\u671F\u7684\u5C0F\u65F6\u6570",
    MINUTE: "\u83B7\u53D6\u6307\u5B9A\u65E5\u671F\u7684\u5206\u949F\u6570",
    SECOND: "\u83B7\u53D6\u6307\u5B9A\u65E5\u671F\u7684\u79D2\u6570",
    DIFFDAYS: "\u83B7\u53D6\u4E24\u4E2A\u65E5\u671F\u4E4B\u95F4\u7684\u5929\u6570",
    DIFFHOURS: "\u83B7\u53D6\u4E24\u4E2A\u65F6\u95F4\u4E4B\u95F4\u7684\u5C0F\u65F6\u6570,\u4FDD\u7559\u4E24\u4F4D\u5C0F\u6570",
    DIFFMINUTES: "\u83B7\u53D6\u4E24\u4E2A\u65F6\u95F4\u4E4B\u95F4\u7684\u5206\u949F\u6570",
    TIMESTAMP: "\u83B7\u53D6\u6307\u5B9A\u65E5\u671F\u7684\u65F6\u95F4\u6233",
    STARTSWITH: "\u68C0\u67E5\u5B57\u7B26\u4E32\u662F\u5426\u4EE5\u6307\u5B9A\u5B57\u7B26\u4E32\u5F00\u5934",
    NOTEMPTY: "\u68C0\u67E5\u53C2\u6570\u662F\u5426\u4E0D\u4E3A\u7A7A",
    LEN: "\u83B7\u53D6\u6307\u5B9A\u5408\u96C6\u7684\u957F\u5EA6",
    MOD: "\u83B7\u53D6\u4E24\u4E2A\u6570\u5B57\u7684\u4F59\u6570",
    FLOOR: "\u83B7\u53D6\u6307\u5B9A\u6570\u5B57\u5411\u4E0B\u53D6\u6574\u7684\u503C",
    ISNUMBER: "\u68C0\u67E5\u53C2\u6570\u662F\u5426\u4E3A\u6570\u5B57",
    TONUMBER: "\u5C06\u53C2\u6570\u8F6C\u6362\u4E3A\u6570\u5B57",
    SLICELEFT: "\u83B7\u53D6\u4E00\u4E2A\u5B57\u7B26\u4E32\u4ECE\u5F00\u5934\u5F00\u59CB\u6307\u5B9A\u957F\u5EA6\u7684\u5B57\u7B26\u4E32",
    SLICERIGHT: "\u83B7\u53D6\u4E00\u4E2A\u5B57\u7B26\u4E32\u4ECE\u7ED3\u5C3E\u5F00\u59CB\u6307\u5B9A\u957F\u5EA6\u7684\u5B57\u7B26\u4E32",
    TOLOWER: "\u5C06\u5B57\u7B26\u4E32\u4E2D\u6240\u6709\u5927\u5199\u5B57\u6BCD\u8F6C\u6362\u4E3A\u5C0F\u5199\u5B57\u6BCD",
    TOUPPER: "\u5C06\u5B57\u7B26\u4E32\u4E2D\u6240\u6709\u5C0F\u5199\u5B57\u6BCD\u8F6C\u6362\u4E3A\u5927\u5199\u5B57\u6BCD",
    INCLUDES: "\u68C0\u67E5\u5B57\u7B26\u4E32\u4E2D\u662F\u5426\u5305\u542B\u6307\u5B9A\u5B57\u7B26\u4E32",
    REPLACE: "\u5C06\u5B57\u7B26\u4E32\u4E2D\u7684\u90E8\u5206\u6587\u672C\u66FF\u6362\u4E3A\u4E0D\u540C\u7684\u6587\u672C,\u53EA\u66FF\u6362\u5339\u914D\u5230\u7684\u7B2C\u4E00\u4E2A",
    REPLACEALL: "\u5C06\u5B57\u7B26\u4E32\u4E2D\u7684\u90E8\u5206\u6587\u672C\u66FF\u6362\u4E3A\u4E0D\u540C\u7684\u6587\u672C,\u66FF\u6362\u6240\u6709\u5339\u914D\u5230\u7684",
    TRIM: "\u5C06\u5B57\u7B26\u4E32\u524D\u540E\u7684\u7A7A\u683C\u5220\u9664",
    TOCHINSESAMOUNT: "\u83B7\u53D6\u6307\u5B9A\u6570\u5B57\u7684\u4E2D\u6587\u5927\u5199\u91D1\u989D",
    UNION: "\u5C06\u5408\u96C6/\u53C2\u6570\u4E2D\u7684\u503C\u53BB\u91CD,\u8FD4\u56DE\u53BB\u91CD\u540E\u7684\u5408\u96C6",
    AND: '\u5C06\u8868\u8FBE\u5F0F\u7528"\u5E76\u4E14"\u94FE\u63A5,\u5F53\u6240\u6709\u8868\u8FBE\u5F0F\u5747\u4E3Atrue\u65F6\u8FD4\u56DEtrue\uFF0C\u5426\u5219\u8FD4\u56DEfalse',
    OR: '\u5C06\u8868\u8FBE\u5F0F\u7528"\u6216"\u94FE\u63A5,\u5F53\u6709\u4E00\u4E2A\u8868\u8FBE\u5F0F\u4E3Atrue\u65F6\u8FD4\u56DEtrue\uFF0C\u5426\u5219\u8FD4\u56DEfalse',
    IF: "\u68C0\u67E5\u4E00\u4E2A\u6761\u4EF6\u80FD\u5426\u6EE1\u8DB3,\u5982\u679C\u6EE1\u8DB3\u8FD4\u56DE\u7B2C\u4E8C\u4E2A\u53C2\u6570\uFF0C\u5426\u5219\u8FD4\u56DE\u7B2C\u4E09\u4E2A\u53C2\u6570",
    IN: "\u68C0\u67E5\u7B2C\u4E8C\u4E2A\u53C2\u6570\u662F\u5426\u5728\u5408\u96C6\u4E2D",
    DEFAULT: "\u68C0\u67E5\u7B2C\u4E00\u4E2A\u53C2\u6570,\u5982\u679C\u4E3A\u7A7A\u8FD4\u56DE\u7B2C\u4E8C\u4E2A\u53C2\u6570,\u5426\u5219\u8FD4\u56DE\u7B2C\u4E00\u4E2A\u53C2\u6570",
    CASE: "\u68C0\u67E5\u662F\u5426\u6EE1\u8DB3\u4E00\u4E2A\u6216\u591A\u4E2A\u6761\u4EF6\uFF0C\u8FD4\u56DE\u7B2C\u4E00\u4E2A\u6EE1\u8DB3\u6761\u4EF6\u7684\u503C",
    COLUMN: "\u83B7\u53D6\u5B50\u8868\u5355\u4E2D\u6307\u5B9A\u5B57\u6BB5\u5E76\u8FD4\u56DE\u5408\u96C6",
    VALUE: "\u83B7\u53D6\u5206\u7EC4\u8868\u5355\u4E2D\u6307\u5B9A\u5B57\u6BB5",
    CONCAT: "\u5C06\u6240\u6709\u53C2\u6570\u62FC\u63A5,\u8FD4\u56DE\u62FC\u63A5\u540E\u7684\u5B57\u7B26\u4E32"
  },
  props: {
    title: "\u6807\u9898",
    content: "\u5185\u5BB9",
    collection: "\u5408\u96C6",
    group: "\u5206\u7EC4",
    custom: "\u81EA\u5B9A\u4E49",
    change: "\u6539\u53D8",
    blur: "\u5931\u53BB\u7126\u70B9",
    preview: "\u9884\u89C8",
    clear: "\u6E05\u7A7A",
    cancel: "\u53D6\u6D88",
    close: "\u5173\u95ED",
    ok: "\u786E\u5B9A",
    save: "\u4FDD\u5B58",
    refresh: "\u5237\u65B0",
    submit: "\u63D0\u4EA4",
    reset: "\u91CD\u7F6E",
    copy: "\u590D\u5236",
    delete: "\u5220\u9664",
    large: "\u5927",
    default: "\u9ED8\u8BA4",
    small: "\u5C0F",
    always: "\u5E38\u663E",
    never: "\u4E0D\u663E\u793A",
    hover: "\u60AC\u6D6E",
    click: "\u70B9\u51FB",
    button: "\u6309\u94AE",
    year: "\u5E74\u4EFD",
    month: "\u6708\u4EFD",
    date: "\u65E5\u671F",
    dates: "\u65E5\u671F\u591A\u9009",
    week: "\u4E00\u5468",
    datetime: "\u65E5\u671F\u65F6\u95F4",
    datetimerange: "\u65E5\u671F\u65F6\u95F4\u533A\u95F4",
    daterange: "\u65E5\u671F\u533A\u95F4",
    monthrange: "\u6708\u4EFD\u533A\u95F4",
    left: "\u5DE6\u5BF9\u9F50",
    right: "\u53F3\u5BF9\u9F50",
    top: "\u9876\u90E8",
    text: "\u6587\u5B57",
    picture: "\u56FE\u7247",
    "picture-card": "\u5361\u7247",
    center: "\u5C45\u4E2D",
    vertical: "\u7AD6\u5411",
    horizontal: "\u6A2A\u5411",
    manage: "\u7BA1\u7406",
    key: "\u952E\u540D",
    value: "\u503C",
    inputData: "\u5F55\u5165\u6570\u636E",
    options: "\u9009\u9879\u6570\u636E",
    option: "\u9009\u9879",
    _self: "\u5F53\u524D\u7A97\u53E3",
    _blank: "\u65B0\u7684\u7A97\u53E3",
    _parent: "\u7236\u7EA7\u7A97\u53E3",
    _top: "\u9876\u7EA7\u7A97\u53E3"
  },
  com: {
    cascader: {
      name: "\u7EA7\u8054\u9009\u62E9\u5668",
      event: {
        expandChange: "\u5F53\u5C55\u5F00\u8282\u70B9\u53D1\u751F\u53D8\u5316\u65F6\u89E6\u53D1",
        removeTag: "\u5728\u591A\u9009\u6A21\u5F0F\u4E0B\uFF0C\u79FB\u9664Tag\u65F6\u89E6\u53D1"
      },
      props: {
        props: "\u914D\u7F6E\u9009\u9879",
        placeholder: "\u8F93\u5165\u6846\u5360\u4F4D\u6587\u672C",
        disabled: "\u662F\u5426\u7981\u7528",
        clearable: "\u662F\u5426\u652F\u6301\u6E05\u7A7A\u9009\u9879",
        showAllLevels: "\u8F93\u5165\u6846\u4E2D\u662F\u5426\u663E\u793A\u9009\u4E2D\u503C\u7684\u5B8C\u6574\u8DEF\u5F84",
        collapseTags: "\u591A\u9009\u6A21\u5F0F\u4E0B\u662F\u5426\u6298\u53E0Tag",
        collapseTagsTooltip: "\u5F53\u9F20\u6807\u60AC\u505C\u4E8E\u6298\u53E0\u6807\u7B7E\u7684\u6587\u672C\u65F6\uFF0C\u662F\u5426\u663E\u793A\u6240\u6709\u9009\u4E2D\u7684\u6807\u7B7E",
        separator: "\u9009\u9879\u5206\u9694\u7B26",
        filterable: "\u8BE5\u9009\u9879\u662F\u5426\u53EF\u4EE5\u88AB\u641C\u7D22",
        tagType: "\u6807\u7B7E\u7C7B\u578B"
      },
      propsOpt: {
        multiple: "\u662F\u5426\u591A\u9009",
        expandTrigger: "\u6B21\u7EA7\u83DC\u5355\u7684\u5C55\u5F00\u65B9\u5F0F",
        checkStrictly: "\u662F\u5426\u4E25\u683C\u7684\u9075\u5B88\u7236\u5B50\u8282\u70B9\u4E0D\u4E92\u76F8\u5173\u8054",
        emitPath: "\u5728\u9009\u4E2D\u8282\u70B9\u6539\u53D8\u65F6\uFF0C\u662F\u5426\u8FD4\u56DE\u7531\u8BE5\u8282\u70B9\u6240\u5728\u7684\u5404\u7EA7\u83DC\u5355\u7684\u503C\u6240\u7EC4\u6210\u7684\u6570\u7EC4",
        value: "\u6307\u5B9A\u9009\u9879\u7684\u503C\u4E3A\u9009\u9879\u5BF9\u8C61\u7684\u67D0\u4E2A\u5C5E\u6027\u503C",
        label: "\u6307\u5B9A\u9009\u9879\u6807\u7B7E\u4E3A\u9009\u9879\u5BF9\u8C61\u7684\u67D0\u4E2A\u5C5E\u6027\u503C",
        children: "\u6307\u5B9A\u9009\u9879\u7684\u5B50\u9009\u9879\u4E3A\u9009\u9879\u5BF9\u8C61\u7684\u67D0\u4E2A\u5C5E\u6027\u503C",
        disabled: "\u6307\u5B9A\u9009\u9879\u7684\u7981\u7528\u4E3A\u9009\u9879\u5BF9\u8C61\u7684\u67D0\u4E2A\u5C5E\u6027\u503C",
        leaf: "\u6307\u5B9A\u9009\u9879\u7684\u53F6\u5B50\u8282\u70B9\u7684\u6807\u5FD7\u4F4D\u4E3A\u9009\u9879\u5BF9\u8C61\u7684\u67D0\u4E2A\u5C5E\u6027\u503C"
      }
    },
    checkbox: {
      name: "\u591A\u9009\u6846",
      props: {
        type: "\u6309\u94AE\u7C7B\u578B",
        disabled: "\u662F\u5426\u7981\u7528",
        min: "\u53EF\u88AB\u52FE\u9009\u7684\u6700\u5C0F\u6570\u91CF",
        max: "\u53EF\u88AB\u52FE\u9009\u7684\u6700\u5927\u6570\u91CF",
        textColor: "\u5F53\u6309\u94AE\u4E3A\u6D3B\u8DC3\u72B6\u6001\u65F6\u7684\u5B57\u4F53\u989C\u8272",
        fill: "\u5F53\u6309\u94AE\u4E3A\u6D3B\u8DC3\u72B6\u6001\u65F6\u7684\u8FB9\u6846\u548C\u80CC\u666F\u989C\u8272"
      }
    },
    col: {
      name: "\u5E03\u5C40\u683C\u5B50",
      props: {
        span: "\u6805\u683C\u5360\u636E\u7684\u5217\u6570",
        offset: "\u6805\u683C\u5DE6\u4FA7\u7684\u95F4\u9694\u683C\u6570",
        push: "\u6805\u683C\u5411\u53F3\u79FB\u52A8\u683C\u6570",
        pull: "\u6805\u683C\u5411\u5DE6\u79FB\u52A8\u683C\u6570"
      }
    },
    colorPicker: {
      name: "\u989C\u8272\u9009\u62E9\u5668",
      event: {
        activeChange: "\u9762\u677F\u4E2D\u5F53\u524D\u663E\u793A\u7684\u989C\u8272\u53D1\u751F\u6539\u53D8\u65F6\u89E6\u53D1"
      },
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        showAlpha: "\u662F\u5426\u652F\u6301\u900F\u660E\u5EA6\u9009\u62E9",
        colorFormat: "\u989C\u8272\u7684\u683C\u5F0F",
        predefine: "\u9884\u5B9A\u4E49\u989C\u8272"
      }
    },
    datePicker: {
      name: "\u65E5\u671F",
      props: {
        pickerOptions: "\u5F53\u524D\u65F6\u95F4\u65E5\u671F\u9009\u62E9\u5668\u7279\u6709\u7684\u9009\u9879",
        readonly: "\u5B8C\u5168\u53EA\u8BFB",
        disabled: "\u7981\u7528",
        type: "\u663E\u793A\u7C7B\u578B",
        editable: "\u6587\u672C\u6846\u53EF\u8F93\u5165",
        clearable: "\u662F\u5426\u663E\u793A\u6E05\u9664\u6309\u94AE",
        placeholder: "\u975E\u8303\u56F4\u9009\u62E9\u65F6\u7684\u5360\u4F4D\u5185\u5BB9",
        startPlaceholder: "\u8303\u56F4\u9009\u62E9\u65F6\u5F00\u59CB\u65E5\u671F\u7684\u5360\u4F4D\u5185\u5BB9",
        endPlaceholder: "\u8303\u56F4\u9009\u62E9\u65F6\u7ED3\u675F\u65E5\u671F\u7684\u5360\u4F4D\u5185\u5BB9",
        format: "\u663E\u793A\u5728\u8F93\u5165\u6846\u4E2D\u7684\u683C\u5F0F",
        align: "\u5BF9\u9F50\u65B9\u5F0F",
        rangeSeparator: "\u9009\u62E9\u8303\u56F4\u65F6\u7684\u5206\u9694\u7B26",
        unlinkPanels: "\u5728\u8303\u56F4\u9009\u62E9\u5668\u91CC\u53D6\u6D88\u4E24\u4E2A\u65E5\u671F\u9762\u677F\u4E4B\u95F4\u7684\u8054\u52A8"
      }
    },
    dateRange: {
      name: "\u65E5\u671F\u533A\u95F4"
    },
    timeRange: {
      name: "\u65F6\u95F4\u533A\u95F4"
    },
    elAlert: {
      name: "\u63D0\u793A",
      description: "\u8BF4\u660E\u6587\u5B57",
      props: {
        title: "\u6807\u9898",
        type: "\u4E3B\u9898",
        description: "\u8F85\u52A9\u6027\u6587\u5B57",
        closable: "\u662F\u5426\u53EF\u5173\u95ED",
        center: "\u6587\u5B57\u662F\u5426\u5C45\u4E2D",
        closeText: "\u5173\u95ED\u6309\u94AE\u81EA\u5B9A\u4E49\u6587\u672C",
        showIcon: "\u662F\u5426\u663E\u793A\u56FE\u6807",
        effect: "\u9009\u62E9\u63D0\u4F9B\u7684\u4E3B\u9898"
      }
    },
    elButton: {
      name: "\u6309\u94AE",
      props: {
        formCreateChild: "\u5185\u5BB9",
        size: "\u5C3A\u5BF8",
        type: "\u7C7B\u578B",
        plain: "\u662F\u5426\u6734\u7D20\u6309\u94AE",
        round: "\u662F\u5426\u5706\u89D2\u6309\u94AE",
        circle: "\u662F\u5426\u5706\u5F62\u6309\u94AE",
        loading: "\u662F\u5426\u52A0\u8F7D\u4E2D\u72B6\u6001",
        disabled: "\u662F\u5426\u7981\u7528\u72B6\u6001"
      }
    },
    elCard: {
      name: "\u5361\u7247",
      props: {
        header: "\u6807\u9898",
        shadow: "\u9634\u5F71\u663E\u793A\u65F6\u673A"
      }
    },
    elCollapse: {
      name: "\u6298\u53E0\u9762\u677F",
      event: {
        change: "\u5207\u6362\u5F53\u524D\u6D3B\u52A8\u9762\u677F\uFF0C\u5728\u624B\u98CE\u7434\u6A21\u5F0F\u4E0B\u5176\u7C7B\u578B\u662Fstring\uFF0C\u5728\u5176\u4ED6\u6A21\u5F0F\u4E0B\u662Farray"
      },
      props: {
        accordion: "\u662F\u5426\u624B\u98CE\u7434\u6A21\u5F0F"
      }
    },
    elCollapseItem: {
      name: "\u9762\u677F",
      props: {
        title: "\u9762\u677F\u6807\u9898",
        name: "\u552F\u4E00\u6807\u5FD7\u7B26",
        disabled: "\u662F\u5426\u7981\u7528"
      }
    },
    elDescriptions: {
      name: "\u63CF\u8FF0\u5217\u8868",
      props: {
        title: "\u6807\u9898\u6587\u672C\uFF0C\u663E\u793A\u5728\u5DE6\u4E0A\u65B9",
        extra: "\u64CD\u4F5C\u533A\u6587\u672C\uFF0C\u663E\u793A\u5728\u53F3\u4E0A\u65B9",
        column: "\u4E00\u884C\u4E2D\u8868\u683C\u7684\u6570\u91CF",
        border: "\u662F\u5426\u5E26\u6709\u8FB9\u6846",
        direction: "\u6392\u5217\u7684\u65B9\u5411",
        size: "\u5217\u8868\u7684\u5C3A\u5BF8"
      }
    },
    elDescriptionsItem: {
      name: "\u63CF\u8FF0\u683C\u5B50",
      props: {
        label: "\u6807\u7B7E\u6587\u672C",
        __child: "\u5185\u5BB9",
        span: "\u5217\u7684\u6570\u91CF",
        width: "\u5217\u7684\u5BBD\u5EA6\uFF0C\u4E0D\u540C\u884C\u76F8\u540C\u5217\u7684\u5BBD\u5EA6\u6309\u6700\u5927\u503C\u8BBE\u5B9A\uFF08\u5982\u65E0 border \uFF0C\u5BBD\u5EA6\u5305\u542B\u6807\u7B7E\u4E0E\u5185\u5BB9",
        minWidth: "\u5217\u7684\u6700\u5C0F\u5BBD\u5EA6",
        align: "\u5217\u7684\u5185\u5BB9\u5BF9\u9F50\u65B9\u5F0F\uFF08\u5982\u65E0 border\uFF0C\u5BF9\u6807\u7B7E\u548C\u5185\u5BB9\u5747\u751F\u6548\uFF09",
        labelAlign: "\u5217\u7684\u6807\u7B7E\u5BF9\u9F50\u65B9\u5F0F\uFF0C\u82E5\u4E0D\u8BBE\u7F6E\u8BE5\u9879\uFF0C\u5219\u4F7F\u7528\u5185\u5BB9\u7684\u5BF9\u9F50\u65B9\u5F0F\uFF08\u5982\u65E0 border\uFF0C\u8BF7\u4F7F\u7528 align \u53C2\u6570\uFF09",
        className: "\u5217\u7684\u5185\u5BB9\u81EA\u5B9A\u4E49\u7C7B\u540D"
      }
    },
    elDivider: {
      name: "\u5206\u5272\u7EBF",
      props: {
        direction: "\u8BBE\u7F6E\u5206\u5272\u7EBF\u65B9\u5411",
        formCreateChild: "\u8BBE\u7F6E\u5206\u5272\u7EBF\u6587\u6848",
        contentPosition: "\u8BBE\u7F6E\u5206\u5272\u7EBF\u6587\u6848\u7684\u4F4D\u7F6E"
      }
    },
    elTabPane: {
      name: "\u9009\u9879\u5361",
      props: {
        label: "\u9009\u9879\u5361\u6807\u9898",
        disabled: "\u662F\u5426\u7981\u7528",
        name: "\u9009\u9879\u5361\u7684\u6807\u8BC6\u7B26",
        lazy: "\u6807\u7B7E\u662F\u5426\u5EF6\u8FDF\u6E32\u67D3"
      }
    },
    elTabs: {
      name: "\u6807\u7B7E\u9875",
      event: {
        tabClick: "tab \u88AB\u9009\u4E2D\u65F6\u89E6\u53D1",
        tabChange: "activeName \u6539\u53D8\u65F6\u89E6\u53D1",
        tabRemove: "\u70B9\u51FB tab \u79FB\u9664\u6309\u94AE\u65F6\u89E6\u53D1",
        tabAdd: "\u70B9\u51FB tab \u65B0\u589E\u6309\u94AE\u65F6\u89E6\u53D1",
        edit: "\u70B9\u51FB tab \u7684\u65B0\u589E\u6216\u79FB\u9664\u6309\u94AE\u540E\u89E6\u53D1"
      },
      props: {
        type: "\u98CE\u683C\u7C7B\u578B",
        closable: "\u6807\u7B7E\u662F\u5426\u53EF\u5173\u95ED",
        tabPosition: "\u9009\u9879\u5361\u6240\u5728\u4F4D\u7F6E",
        stretch: "\u6807\u7B7E\u7684\u5BBD\u5EA6\u662F\u5426\u81EA\u6491\u5F00"
      }
    },
    elTag: {
      name: "\u6807\u7B7E",
      props: {
        formCreateNative: "\u662F\u5426\u663E\u793A\u6807\u9898",
        formCreateTitle: "\u6807\u9898",
        formCreateChild: "\u6807\u7B7E\u5185\u5BB9",
        type: "\u6807\u7B7E\u7684\u7C7B\u578B",
        size: "\u6807\u7B7E\u7684\u5C3A\u5BF8",
        effect: "\u6807\u7B7E\u7684\u4E3B\u9898",
        closable: "\u662F\u5426\u53EF\u5173\u95ED",
        disableTransitions: "\u662F\u5426\u7981\u7528\u6E10\u53D8\u52A8\u753B",
        hit: "\u662F\u5426\u6709\u8FB9\u6846\u63CF\u8FB9",
        round: "\u662F\u5426\u4E3A\u5706\u5F62",
        color: "\u80CC\u666F\u8272"
      }
    },
    elTransfer: {
      name: "\u7A7F\u68AD\u6846",
      event: {
        leftCheckChange: "\u5DE6\u4FA7\u5217\u8868\u5143\u7D20\u88AB\u7528\u6237\u9009\u4E2D / \u53D6\u6D88\u9009\u4E2D\u65F6\u89E6\u53D1",
        rightCheckChange: "\u53F3\u4FA7\u5217\u8868\u5143\u7D20\u88AB\u7528\u6237\u9009\u4E2D / \u53D6\u6D88\u9009\u4E2D\u65F6\u89E6\u53D1"
      },
      props: {
        filterable: "\u662F\u5426\u53EF\u641C\u7D22",
        filterPlaceholder: "\u641C\u7D22\u6846\u5360\u4F4D\u7B26",
        targetOrder: "\u53F3\u4FA7\u5217\u8868\u5143\u7D20\u7684\u6392\u5E8F\u7B56\u7565",
        targetOrderInfo: "\u82E5\u4E3A original\uFF0C\u5219\u4FDD\u6301\u4E0E\u6570\u636E\u76F8\u540C\u7684\u987A\u5E8F\uFF1B\u82E5\u4E3A push\uFF0C\u5219\u65B0\u52A0\u5165\u7684\u5143\u7D20\u6392\u5728\u6700\u540E\uFF1B\u82E5\u4E3A unshift\uFF0C\u5219\u65B0\u52A0\u5165\u7684\u5143\u7D20\u6392\u5728\u6700\u524D",
        titles: "\u81EA\u5B9A\u4E49\u5217\u8868\u6807\u9898",
        buttonTexts: "\u81EA\u5B9A\u4E49\u6309\u94AE\u6587\u6848",
        props: "\u6570\u636E\u6E90\u7684\u5B57\u6BB5\u522B\u540D"
      }
    },
    elTreeSelect: {
      name: "\u6811\u5F62\u9009\u62E9",
      event: {
        removeTag: "\u591A\u9009\u6A21\u5F0F\u4E0B\u79FB\u9664tag\u65F6\u89E6\u53D1"
      },
      props: {
        multiple: "\u662F\u5426\u591A\u9009",
        disabled: "\u662F\u5426\u7981\u7528",
        clearable: "\u662F\u5426\u53EF\u4EE5\u6E05\u7A7A\u9009\u9879",
        collapseTags: "\u591A\u9009\u65F6\u662F\u5426\u5C06\u9009\u4E2D\u503C\u6309\u6587\u5B57\u7684\u5F62\u5F0F\u5C55\u793A",
        multipleLimit: "\u591A\u9009\u65F6\u7528\u6237\u6700\u591A\u53EF\u4EE5\u9009\u62E9\u7684\u9879\u76EE\u6570\uFF0C\u4E3A 0 \u5219\u4E0D\u9650\u5236",
        placeholder: "\u5360\u4F4D\u7B26",
        props: "\u914D\u7F6E\u9009\u9879",
        renderAfterExpand: "\u662F\u5426\u5728\u7B2C\u4E00\u6B21\u5C55\u5F00\u67D0\u4E2A\u6811\u8282\u70B9\u540E\u624D\u6E32\u67D3\u5176\u5B50\u8282\u70B9",
        defaultExpandAll: "\u662F\u5426\u9ED8\u8BA4\u5C55\u5F00\u6240\u6709\u8282\u70B9",
        expandOnClickNode: "\u662F\u5426\u5728\u70B9\u51FB\u8282\u70B9\u7684\u65F6\u5019\u5C55\u5F00\u6216\u8005\u6536\u7F29\u8282\u70B9",
        checkOnClickNode: "\u662F\u5426\u5728\u70B9\u51FB\u8282\u70B9\u7684\u65F6\u5019\u9009\u4E2D\u8282\u70B9",
        nodeKey: "\u6BCF\u4E2A\u6811\u8282\u70B9\u7528\u6765\u4F5C\u4E3A\u552F\u4E00\u6807\u8BC6\u7684\u5C5E\u6027\uFF0C\u6574\u68F5\u6811\u5E94\u8BE5\u662F\u552F\u4E00\u7684"
      }
    },
    elLink: {
      name: "\u94FE\u63A5",
      props: {
        formCreateNative: "\u662F\u5426\u663E\u793A\u6807\u9898",
        formCreateTitle: "\u6807\u9898",
        formCreateChild: "\u5185\u5BB9",
        href: "\u8DF3\u8F6C\u94FE\u63A5",
        type: "\u7C7B\u578B",
        underline: "\u662F\u5426\u663E\u793A\u4E0B\u5212\u7EBF",
        disabled: "\u662F\u5426\u7981\u7528",
        target: "\u6253\u5F00\u65B9\u5F0F"
      }
    },
    elWatermark: {
      name: "\u6C34\u5370",
      props: {
        content: "\u6C34\u5370\u6587\u672C\u5185\u5BB9",
        image: "\u6C34\u5370\u56FE\u7247\uFF0C\u5EFA\u8BAE\u4F7F\u7528 2x \u6216 3x \u56FE\u50CF",
        width: "\u6C34\u5370\u7684\u5BBD\u5EA6\uFF0C content \u7684\u9ED8\u8BA4\u503C\u662F\u5B83\u81EA\u5DF1\u7684\u5BBD\u5EA6",
        height: "\u6C34\u5370\u7684\u9AD8\u5EA6\uFF0C content \u7684\u9ED8\u8BA4\u503C\u662F\u5B83\u81EA\u5DF1\u7684\u9AD8\u5EA6",
        rotate: "\u6C34\u5370\u7684\u65CB\u8F6C\u89D2\u5EA6, \u5355\u4F4D \xB0",
        zIndex: "\u6C34\u5370\u5143\u7D20\u7684z-index\u503C",
        gap: "\u6C34\u5370\u4E4B\u95F4\u7684\u95F4\u8DDD"
      }
    },
    elTooltip: {
      name: "\u6587\u5B57\u63D0\u793A",
      props: {
        content: "\u663E\u793A\u7684\u5185\u5BB9",
        disabled: "\u662F\u5426\u7981\u7528",
        rawContent: "\u5185\u5BB9\u662F\u5426\u4F5C\u4E3A HTML \u5B57\u7B26\u4E32\u5904\u7406",
        enterable: "\u9F20\u6807\u662F\u5426\u53EF\u8FDB\u5165\u5230 Tooltip \u4E2D",
        effect: "\u4E3B\u9898",
        placement: "Tooltip \u7EC4\u4EF6\u51FA\u73B0\u7684\u4F4D\u7F6E",
        trigger: "\u5982\u4F55\u89E6\u53D1 Tooltip",
        offset: "\u51FA\u73B0\u4F4D\u7F6E\u7684\u504F\u79FB\u91CF",
        showAfter: "\u5728\u89E6\u53D1\u540E\u591A\u4E45\u663E\u793A\u5185\u5BB9\uFF0C\u5355\u4F4D\u6BEB\u79D2",
        hideAfter: "\u5EF6\u8FDF\u5173\u95ED\uFF0C\u5355\u4F4D\u6BEB\u79D2",
        autoClose: "\u51FA\u73B0\u540E\u81EA\u52A8\u9690\u85CF\u5EF6\u65F6\uFF0C\u5355\u4F4D\u6BEB\u79D2"
      }
    },
    fcCell: {
      name: "\u683C\u5B50"
    },
    fcEditor: {
      name: "\u5BCC\u6587\u672C\u6846",
      props: {
        disabled: "\u662F\u5426\u7981\u7528"
      }
    },
    fcFlex: {
      name: "\u76D2\u5B50\u5E03\u5C40"
    },
    fcRow: {
      name: "\u6805\u683C\u5E03\u5C40",
      props: {
        gutter: "\u6805\u683C\u95F4\u9694",
        type: "flex\u5E03\u5C40\u6A21\u5F0F",
        justify: "flex\u5E03\u5C40\u4E0B\u7684\u6C34\u5E73\u6392\u5217\u65B9\u5F0F",
        align: "flex\u5E03\u5C40\u4E0B\u7684\u5782\u76F4\u6392\u5217\u65B9\u5F0F"
      }
    },
    fcTable: {
      name: "\u8868\u683C\u5E03\u5C40",
      props: {
        border: "\u662F\u5426\u663E\u793A\u8FB9\u6846",
        borderColor: "\u8FB9\u6846\u989C\u8272",
        borderWidth: "\u8FB9\u6846\u5BBD\u5EA6"
      }
    },
    fcTableGrid: {
      name: "\u683C\u5B50"
    },
    fcValue: {
      name: "\u8BA1\u7B97\u516C\u5F0F",
      empty: "\u5728\u53F3\u4FA7\u914D\u7F6E\u4E2D\u8BBE\u7F6E\u8BA1\u7B97\u516C\u5F0F"
    },
    group: {
      name: "\u5B50\u8868\u5355",
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        syncDisabled: "\u662F\u5426\u4E0E\u5B50\u8868\u5355\u5F3A\u5236\u540C\u6B65\u7981\u7528\u72B6\u6001",
        expand: "\u8BBE\u7F6E\u9ED8\u8BA4\u5C55\u5F00\u51E0\u9879",
        button: "\u662F\u5426\u663E\u793A\u64CD\u4F5C\u6309\u94AE",
        sortBtn: "\u662F\u5426\u663E\u793A\u6392\u5E8F\u6309\u94AE",
        min: "\u8BBE\u7F6E\u6700\u5C0F\u6DFB\u52A0\u51E0\u9879",
        max: "\u8BBE\u7F6E\u6700\u591A\u6DFB\u52A0\u51E0\u9879"
      }
    },
    html: {
      name: "HTML",
      props: {
        formCreateNative: "\u662F\u5426\u663E\u793A\u6807\u9898",
        formCreateTitle: "\u6807\u9898",
        formCreateChild: "\u5185\u5BB9"
      }
    },
    input: {
      name: "\u8F93\u5165\u6846",
      event: {
        change: "\u5F53\u503C\u6539\u53D8\u65F6\uFF0C\u5F53\u7EC4\u4EF6\u5931\u53BB\u7126\u70B9\u6216\u7528\u6237\u6309Enter\u65F6\u89E6\u53D1"
      },
      props: {
        maxlength: "\u6700\u5927\u8F93\u5165\u957F\u5EA6",
        minlength: "\u6700\u5C0F\u8F93\u5165\u957F\u5EA6",
        placeholder: "\u8F93\u5165\u6846\u5360\u4F4D\u6587\u672C",
        clearable: "\u662F\u5426\u663E\u793A\u6E05\u9664\u6309\u94AE",
        disabled: "\u662F\u5426\u7981\u7528",
        readonly: "\u662F\u5426\u53EA\u8BFB"
      }
    },
    inputNumber: {
      name: "\u8BA1\u6570\u5668",
      props: {
        min: "\u8BBE\u7F6E\u8BA1\u6570\u5668\u5141\u8BB8\u7684\u6700\u5C0F\u503C",
        max: "\u8BBE\u7F6E\u8BA1\u6570\u5668\u5141\u8BB8\u7684\u6700\u5927\u503C",
        step: "\u8BA1\u6570\u5668\u6B65\u957F",
        stepStrictly: "\u662F\u5426\u53EA\u80FD\u8F93\u5165 step \u7684\u500D\u6570",
        disabled: "\u662F\u5426\u7981\u7528\u8BA1\u6570\u5668",
        controls: "\u662F\u5426\u4F7F\u7528\u63A7\u5236\u6309\u94AE",
        controlsPosition: "\u63A7\u5236\u6309\u94AE\u4F4D\u7F6E",
        placeholder: "\u8F93\u5165\u6846\u5360\u4F4D\u6587\u672C"
      }
    },
    password: {
      name: "\u5BC6\u7801\u8F93\u5165\u6846",
      event: {
        change: "\u5F53\u503C\u6539\u53D8\u65F6\uFF0C\u5F53\u7EC4\u4EF6\u5931\u53BB\u7126\u70B9\u6216\u7528\u6237\u6309Enter\u65F6\u89E6\u53D1"
      },
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        readonly: "\u662F\u5426\u53EA\u8BFB",
        maxlength: "\u6700\u5927\u8F93\u5165\u957F\u5EA6",
        minlength: "\u6700\u5C0F\u8F93\u5165\u957F\u5EA6",
        placeholder: "\u8F93\u5165\u6846\u5360\u4F4D\u6587\u672C",
        clearable: "\u662F\u5426\u663E\u793A\u6E05\u9664\u6309\u94AE"
      }
    },
    radio: {
      name: "\u5355\u9009\u6846",
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        type: "\u6309\u94AE\u5F62\u5F0F",
        textColor: "\u6309\u94AE\u5F62\u5F0F\u6FC0\u6D3B\u65F6\u7684\u6587\u672C\u989C\u8272",
        fill: "\u6309\u94AE\u5F62\u5F0F\u6FC0\u6D3B\u65F6\u7684\u586B\u5145\u8272\u548C\u8FB9\u6846\u8272"
      }
    },
    rate: {
      name: "\u8BC4\u5206",
      props: {
        max: "\u6700\u5927\u5206\u503C",
        disabled: "\u662F\u5426\u7981\u7528",
        allowHalf: "\u662F\u5426\u5141\u8BB8\u534A\u9009",
        voidColor: "\u672A\u9009\u4E2D\u65F6\u56FE\u6807\u7684\u989C\u8272",
        disabledVoidColor: "\u53EA\u8BFB\u65F6\u672A\u9009\u4E2D\u65F6\u56FE\u6807\u7684\u989C\u8272",
        voidIconClass: "\u672A\u9009\u4E2D\u65F6\u56FE\u6807\u7684\u7C7B\u540D",
        disabledVoidIconClass: "\u53EA\u8BFB\u65F6\u672A\u9009\u4E2D\u65F6\u56FE\u6807\u7684\u7C7B\u540D",
        showScore: "\u662F\u5426\u663E\u793A\u5F53\u524D\u5206\u6570",
        textColor: "\u8F85\u52A9\u6587\u5B57\u7684\u989C\u8272",
        scoreTemplate: "\u5206\u6570\u663E\u793A\u6A21\u677F"
      }
    },
    select: {
      name: "\u9009\u62E9\u5668",
      event: {
        removeTag: "\u591A\u9009\u6A21\u5F0F\u4E0B\u79FB\u9664tag\u65F6\u89E6\u53D1"
      },
      props: {
        multiple: "\u662F\u5426\u591A\u9009",
        disabled: "\u662F\u5426\u7981\u7528",
        clearable: "\u662F\u5426\u53EF\u4EE5\u6E05\u7A7A\u9009\u9879",
        collapseTags: "\u591A\u9009\u65F6\u662F\u5426\u5C06\u9009\u4E2D\u503C\u6309\u6587\u5B57\u7684\u5F62\u5F0F\u5C55\u793A",
        multipleLimit: "\u591A\u9009\u65F6\u7528\u6237\u6700\u591A\u53EF\u4EE5\u9009\u62E9\u7684\u9879\u76EE\u6570\uFF0C\u4E3A 0 \u5219\u4E0D\u9650\u5236",
        placeholder: "\u5360\u4F4D\u7B26",
        filterable: "\u662F\u5426\u53EF\u641C\u7D22",
        allowCreate: "\u662F\u5426\u5141\u8BB8\u7528\u6237\u521B\u5EFA\u65B0\u6761\u76EE",
        noMatchText: "\u641C\u7D22\u6761\u4EF6\u65E0\u5339\u914D\u65F6\u663E\u793A\u7684\u6587\u5B57",
        noDataText: "\u9009\u9879\u4E3A\u7A7A\u65F6\u663E\u793A\u7684\u6587\u5B57",
        reserveKeyword: "\u591A\u9009\u4E14\u53EF\u641C\u7D22\u65F6\uFF0C\u662F\u5426\u5728\u9009\u4E2D\u4E00\u4E2A\u9009\u9879\u540E\u4FDD\u7559\u5F53\u524D\u7684\u641C\u7D22\u5173\u952E\u8BCD",
        defaultFirstOption: "\u5728\u8F93\u5165\u6846\u6309\u4E0B\u56DE\u8F66\uFF0C\u9009\u62E9\u7B2C\u4E00\u4E2A\u5339\u914D\u9879"
      }
    },
    slider: {
      name: "\u6ED1\u5757",
      props: {
        min: "\u6700\u5C0F\u503C",
        max: "\u6700\u5927\u503C",
        disabled: "\u662F\u5426\u7981\u7528",
        step: "\u6B65\u957F",
        showInput: "\u662F\u5426\u663E\u793A\u8F93\u5165\u6846\uFF0C\u4EC5\u5728\u975E\u8303\u56F4\u9009\u62E9\u65F6\u6709\u6548",
        showInputControls: "\u5728\u663E\u793A\u8F93\u5165\u6846\u7684\u60C5\u51B5\u4E0B\uFF0C\u662F\u5426\u663E\u793A\u8F93\u5165\u6846\u7684\u63A7\u5236\u6309\u94AE",
        showStops: "\u662F\u5426\u663E\u793A\u95F4\u65AD\u70B9",
        range: "\u662F\u5426\u4E3A\u8303\u56F4\u9009\u62E9",
        vertical: "\u662F\u5426\u7AD6\u5411\u6A21\u5F0F",
        height: "Slider \u9AD8\u5EA6\uFF0C\u7AD6\u5411\u6A21\u5F0F\u65F6\u5FC5\u586B"
      }
    },
    space: {
      name: "\u95F4\u8DDD"
    },
    stepForm: {
      name: "\u5206\u6B65\u8868\u5355",
      event: {
        submit: "\u70B9\u51FB\u63D0\u4EA4\u6309\u94AE\u65F6\u89E6\u53D1",
        next: "\u70B9\u51FB\u4E0B\u4E00\u6B65\u6309\u94AE\u65F6\u89E6\u53D1"
      },
      props: {
        autoValidate: "\u8FDB\u5165\u4E0B\u4E00\u6B65\u524D\u81EA\u52A8\u9A8C\u8BC1\u8868\u5355",
        "stepsProps>alignCenter": "\u8FDB\u884C\u5C45\u4E2D\u5BF9\u9F50",
        "stepsProps>simple": "\u662F\u5426\u5E94\u7528\u7B80\u6D01\u98CE\u683C"
      }
    },
    stepFormItem: {
      name: "\u6B65\u9AA4\u6761",
      props: {
        title: "\u6807\u9898",
        description: "\u63CF\u8FF0\u6587\u6848"
      }
    },
    subForm: {
      name: "\u5206\u7EC4",
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        syncDisabled: "\u662F\u5426\u4E0E\u5B50\u8868\u5355\u5F3A\u5236\u540C\u6B65\u7981\u7528\u72B6\u6001"
      }
    },
    switch: {
      name: "\u5F00\u5173",
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        width: "\u5BBD\u5EA6\uFF08px\uFF09",
        activeText: "\u6253\u5F00\u65F6\u7684\u6587\u5B57\u63CF\u8FF0",
        inactiveText: "\u5173\u95ED\u65F6\u7684\u6587\u5B57\u63CF\u8FF0",
        activeValue: "\u6253\u5F00\u65F6\u7684\u503C",
        inactiveValue: "\u5173\u95ED\u65F6\u7684\u503C",
        activeColor: "\u6253\u5F00\u65F6\u7684\u80CC\u666F\u8272",
        inactiveColor: "\u5173\u95ED\u65F6\u7684\u80CC\u666F\u8272"
      }
    },
    tableForm: {
      name: "\u8868\u683C\u8868\u5355",
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        max: "\u6700\u591A\u6DFB\u52A0\u51E0\u884C\uFF0C\u4E3A 0 \u5219\u4E0D\u9650\u5236"
      }
    },
    nestedTableForm: {
      name: "\u5D4C\u5957\u8868\u5355",
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        max: "\u6700\u591A\u6DFB\u52A0\u51E0\u884C\uFF0C\u4E3A 0 \u5219\u4E0D\u9650\u5236",
        nestedMax: "\u5B50\u8868\u5355\u6700\u591A\u6DFB\u52A0\u51E0\u884C\uFF0C\u4E3A 0 \u5219\u4E0D\u9650\u5236"
      }
    },
    infiniteTableForm: {
      name: "\u65E0\u9650\u7EA7\u8868\u5355",
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        childrenField: "\u8BBE\u7F6E\u5B50\u7EA7\u7684\u5B57\u6BB5\u540D",
        max: "\u6700\u591A\u6DFB\u52A0\u51E0\u884C\uFF0C\u4E3A 0 \u5219\u4E0D\u9650\u5236",
        layerMax: "\u6700\u591A\u6DFB\u52A0\u51E0\u5C42\uFF0C\u4E3A 0 \u5219\u4E0D\u9650\u5236"
      }
    },
    nestedSubTableForm: {
      name: "\u5B50\u8868\u683C\u8868\u5355"
    },
    tableFormColumn: {
      name: "\u8868\u683C\u683C\u5B50",
      label: "\u81EA\u5B9A\u4E49\u540D\u79F0",
      props: {
        label: "\u6807\u9898",
        width: "\u5BBD\u5EA6",
        color: "\u989C\u8272"
      }
    },
    text: {
      name: "\u6587\u5B57",
      props: {
        formCreateNative: "\u662F\u5426\u663E\u793A\u6807\u9898",
        formCreateTitle: "\u6807\u9898",
        formCreateChild: "\u5185\u5BB9"
      }
    },
    textarea: {
      name: "\u591A\u884C\u8F93\u5165\u6846",
      event: {
        change: "\u5F53\u503C\u6539\u53D8\u65F6\uFF0C\u5F53\u7EC4\u4EF6\u5931\u53BB\u7126\u70B9\u6216\u7528\u6237\u6309Enter\u65F6\u89E6\u53D1"
      },
      props: {
        disabled: "\u662F\u5426\u7981\u7528",
        readonly: "\u662F\u5426\u53EA\u8BFB",
        maxlength: "\u6700\u5927\u8F93\u5165\u957F\u5EA6",
        minlength: "\u6700\u5C0F\u8F93\u5165\u957F\u5EA6",
        showWordLimit: "\u662F\u5426\u663E\u793A\u7EDF\u8BA1\u5B57\u6570",
        placeholder: "\u8F93\u5165\u6846\u5360\u4F4D\u6587\u672C",
        rows: "\u8F93\u5165\u6846\u884C\u6570",
        autosize: "\u9AD8\u5EA6\u662F\u5426\u81EA\u9002\u5E94"
      }
    },
    timePicker: {
      name: "\u65F6\u95F4",
      props: {
        pickerOptions: "\u5F53\u524D\u65F6\u95F4\u65E5\u671F\u9009\u62E9\u5668\u7279\u6709\u7684\u9009\u9879",
        readonly: "\u5B8C\u5168\u53EA\u8BFB",
        disabled: "\u7981\u7528",
        editable: "\u6587\u672C\u6846\u53EF\u8F93\u5165",
        clearable: "\u662F\u5426\u663E\u793A\u6E05\u9664\u6309\u94AE",
        placeholder: "\u975E\u8303\u56F4\u9009\u62E9\u65F6\u7684\u5360\u4F4D\u5185\u5BB9",
        startPlaceholder: "\u8303\u56F4\u9009\u62E9\u65F6\u5F00\u59CB\u65E5\u671F\u7684\u5360\u4F4D\u5185\u5BB9",
        endPlaceholder: "\u8303\u56F4\u9009\u62E9\u65F6\u5F00\u59CB\u65E5\u671F\u7684\u5360\u4F4D\u5185\u5BB9",
        isRange: "\u662F\u5426\u4E3A\u65F6\u95F4\u8303\u56F4\u9009\u62E9",
        arrowControl: "\u662F\u5426\u4F7F\u7528\u7BAD\u5934\u8FDB\u884C\u65F6\u95F4\u9009\u62E9",
        align: "\u5BF9\u9F50\u65B9\u5F0F"
      }
    },
    tree: {
      name: "\u6811\u5F62\u63A7\u4EF6",
      event: {
        nodeClick: "\u5F53\u8282\u70B9\u88AB\u70B9\u51FB\u7684\u65F6\u5019\u89E6\u53D1",
        nodeContextmenu: "\u5F53\u67D0\u4E00\u8282\u70B9\u88AB\u9F20\u6807\u53F3\u952E\u70B9\u51FB\u65F6\u4F1A\u89E6\u53D1\u8BE5\u4E8B\u4EF6",
        checkChange: "\u5F53\u590D\u9009\u6846\u88AB\u70B9\u51FB\u7684\u65F6\u5019\u89E6\u53D1",
        check: "\u70B9\u51FB\u8282\u70B9\u590D\u9009\u6846\u4E4B\u540E\u89E6\u53D1",
        currentChange: "\u5F53\u524D\u9009\u4E2D\u8282\u70B9\u53D8\u5316\u65F6\u89E6\u53D1\u7684\u4E8B\u4EF6",
        nodeExpand: "\u8282\u70B9\u88AB\u5C55\u5F00\u65F6\u89E6\u53D1\u7684\u4E8B\u4EF6",
        nodeCollapse: "\u8282\u70B9\u88AB\u5173\u95ED\u65F6\u89E6\u53D1\u7684\u4E8B\u4EF6",
        nodeDragStart: "\u8282\u70B9\u5F00\u59CB\u62D6\u62FD\u65F6\u89E6\u53D1\u7684\u4E8B\u4EF6",
        nodeDragEnter: "\u62D6\u62FD\u8FDB\u5165\u5176\u4ED6\u8282\u70B9\u65F6\u89E6\u53D1\u7684\u4E8B\u4EF6",
        nodeDragLeave: "\u62D6\u62FD\u79BB\u5F00\u67D0\u4E2A\u8282\u70B9\u65F6\u89E6\u53D1\u7684\u4E8B\u4EF6",
        nodeDragOver: "\u5728\u62D6\u62FD\u8282\u70B9\u65F6\u89E6\u53D1\u7684\u4E8B\u4EF6\uFF08\u7C7B\u4F3C\u6D4F\u89C8\u5668\u7684 mouseover \u4E8B\u4EF6\uFF09",
        nodeDragEnd: "\u62D6\u62FD\u7ED3\u675F\u65F6\uFF08\u53EF\u80FD\u672A\u6210\u529F\uFF09\u89E6\u53D1\u7684\u4E8B\u4EF6",
        nodeDrop: "\u62D6\u62FD\u6210\u529F\u5B8C\u6210\u65F6\u89E6\u53D1\u7684\u4E8B\u4EF6"
      },
      props: {
        emptyText: "\u5185\u5BB9\u4E3A\u7A7A\u7684\u65F6\u5019\u5C55\u793A\u7684\u6587\u672C",
        props: "\u914D\u7F6E\u9009\u9879",
        renderAfterExpand: "\u662F\u5426\u5728\u7B2C\u4E00\u6B21\u5C55\u5F00\u67D0\u4E2A\u6811\u8282\u70B9\u540E\u624D\u6E32\u67D3\u5176\u5B50\u8282\u70B9",
        defaultExpandAll: "\u662F\u5426\u9ED8\u8BA4\u5C55\u5F00\u6240\u6709\u8282\u70B9",
        expandOnClickNode: "\u662F\u5426\u5728\u70B9\u51FB\u8282\u70B9\u7684\u65F6\u5019\u5C55\u5F00\u6216\u8005\u6536\u7F29\u8282\u70B9\uFF0C\u5982\u679C\u4E3A false\uFF0C\u5219\u53EA\u6709\u70B9\u7BAD\u5934\u56FE\u6807\u7684\u65F6\u5019\u624D\u4F1A\u5C55\u5F00\u6216\u8005\u6536\u7F29\u8282\u70B9\u3002",
        checkOnClickNode: "\u662F\u5426\u5728\u70B9\u51FB\u8282\u70B9\u7684\u65F6\u5019\u9009\u4E2D\u8282\u70B9",
        autoExpandParent: "\u5C55\u5F00\u5B50\u8282\u70B9\u7684\u65F6\u5019\u662F\u5426\u81EA\u52A8\u5C55\u5F00\u7236\u8282\u70B9",
        checkStrictly: "\u5728\u663E\u793A\u590D\u9009\u6846\u7684\u60C5\u51B5\u4E0B\uFF0C\u662F\u5426\u4E25\u683C\u7684\u9075\u5FAA\u7236\u5B50\u4E0D\u4E92\u76F8\u5173\u8054\u7684\u505A\u6CD5",
        accordion: "\u662F\u5426\u6BCF\u6B21\u53EA\u6253\u5F00\u4E00\u4E2A\u540C\u7EA7\u6811\u8282\u70B9\u5C55\u5F00",
        indent: "\u76F8\u90BB\u7EA7\u8282\u70B9\u95F4\u7684\u6C34\u5E73\u7F29\u8FDB(px)",
        nodeKey: "\u6BCF\u4E2A\u6811\u8282\u70B9\u7528\u6765\u4F5C\u4E3A\u552F\u4E00\u6807\u8BC6\u7684\u5C5E\u6027\uFF0C\u6574\u68F5\u6811\u5E94\u8BE5\u662F\u552F\u4E00\u7684"
      }
    },
    upload: {
      name: "\u4E0A\u4F20",
      info: "\u5728onSuccess\u65B9\u6CD5\u4E2D\u5C06\u63A5\u53E3\u8FD4\u56DE\u7684url\u8D4B\u503C\u7ED9file.url",
      event: {
        remove: "\u6587\u4EF6\u5217\u8868\u79FB\u9664\u6587\u4EF6\u65F6\u89E6\u53D1"
      },
      props: {
        listType: "\u4E0A\u4F20\u7C7B\u578B",
        multiple: "\u662F\u5426\u652F\u6301\u591A\u9009\u6587\u4EF6",
        action: "\u4E0A\u4F20\u7684\u5730\u5740(\u5FC5\u586B)",
        onSuccess: "\u4E0A\u4F20\u6210\u529F\u56DE\u8C03",
        headers: "\u8BBE\u7F6E\u4E0A\u4F20\u7684\u8BF7\u6C42\u5934\u90E8",
        data: "\u4E0A\u4F20\u65F6\u9644\u5E26\u7684\u989D\u5916\u53C2\u6570",
        name: "\u4E0A\u4F20\u7684\u6587\u4EF6\u5B57\u6BB5\u540D",
        withCredentials: "\u652F\u6301\u53D1\u9001 cookie \u51ED\u8BC1\u4FE1\u606F",
        accept: "\u63A5\u53D7\u4E0A\u4F20\u7684\u6587\u4EF6\u7C7B\u578B",
        autoUpload: "\u662F\u5426\u5728\u9009\u53D6\u6587\u4EF6\u540E\u7ACB\u5373\u8FDB\u884C\u4E0A\u4F20",
        disabled: "\u662F\u5426\u7981\u7528",
        limit: "\u6700\u5927\u5141\u8BB8\u4E0A\u4F20\u4E2A\u6570"
      }
    }
  },
  tmp: {
    duration: "\u65F6\u957F",
    chineseAmount: "\u91D1\u989D",
    col3: "\u4E09\u5217\u6805\u683C",
    col4: "\u56DB\u5217\u6805\u683C",
    table43: "4x3\u8868\u683C"
  }
};
function oc(e) {
  e.addKeyMap({
    name: "autoParentheses",
    "'('": (o) => {
      const i = o.getCursor();
      o.replaceRange("()", i, i, "+insert"), o.doc.setCursor({ line: i.line, ch: i.ch + 1 });
    }
  }), e.addKeyMap({
    name: "autoBraces",
    "'{'": (o) => {
      const i = o.getCursor();
      o.replaceRange("{}", i, i, "+insert"), o.doc.setCursor({ line: i.line, ch: i.ch + 1 });
    }
  }), e.addKeyMap({
    name: "autoBrackets",
    "'['": (o) => {
      const i = o.getCursor();
      o.replaceRange("[]", i, i, "+insert"), o.doc.setCursor({ line: i.line, ch: i.ch + 1 });
    }
  });
}
function Ur(e, o, i, l = []) {
  o.id || (o.id = 1), i && i--;
  for (let n = 0; n < 3; n++) {
    const u = {
      [o.label]: e + i * 10 + n,
      [o.value]: ++o.id
    };
    i && Ur(e, o, i, u.children = []), l.push(u);
  }
  return l;
}
function Gl(e, o) {
  const i = [
    { label: e("fetch.optionsType.struct"), value: 2 },
    { label: e("fetch.optionsType.fetch"), value: 1 }
  ], l = [
    {
      value: 1,
      rule: [
        {
          type: "GlobalFetchSelect",
          field: "formCreateEffect>fetch",
          props: {
            to: o
          }
        }
      ]
    },
    {
      value: 2,
      rule: [
        {
          type: "TableOptions",
          field: "formCreate" + Fo(o).replace(".", ">"),
          props: {
            keyValue: "label"
          }
        }
      ]
    }
  ];
  return {
    type: "radio",
    title: e("props.options"),
    field: "_optionType",
    value: 2,
    options: i,
    props: {
      type: "button"
    },
    control: l
  };
}
function Yl({ t: e, to: o, label: i, value: l }) {
  const n = [
    { label: e("fetch.optionsType.struct"), value: 2 },
    { label: e("fetch.optionsType.fetch"), value: 1 }
  ], u = [
    {
      value: 1,
      rule: [
        {
          type: "GlobalFetchSelect",
          field: "formCreateEffect>fetch",
          props: {
            to: o
          }
        }
      ]
    },
    {
      value: 2,
      rule: [
        {
          type: "TreeOptions",
          field: "formCreate" + Fo(o).replace(".", ">"),
          props: {
            columns: {
              label: i,
              value: l
            },
            keyValue: i
          }
        }
      ]
    }
  ];
  return {
    type: "radio",
    title: e("props.options"),
    field: "_optionType",
    value: 2,
    options: n,
    props: {
      type: "button"
    },
    control: u
  };
}
function Fo(e) {
  return e.replace(e[0], e[0].toLocaleUpperCase());
}
const kr = function (e) {
  const o = /object ([a-zA-Z]*)/.exec(Object.prototype.toString.call(e));
  return o && vf[o[1].toLowerCase()] ? vf[o[1].toLowerCase()](e) : e;
}, vf = {
  object: function (e) {
    var o = [];
    for (var i in e)
      !Nr(e, i) || o.push(
        kr(i) + ": " + (e[i] != null ? kr(e[i]) : "null")
      );
    return `{
 ` + o.join(`,
 `) + `
}`;
  },
  function: function (e) {
    e = "" + e;
    var o = /^ *([\w]+) *\(/.exec(e);
    return o && o[1] !== "function" ? "function " + e : e;
  },
  array: function (e) {
    for (var o = 0, i = []; o < e.length; o++)
      i[o] = e[o] != null ? kr(e[o]) : "null";
    return "[" + i.join(", ") + "]";
  },
  string: function (e) {
    for (var o = e.split(""), i = 0; i < o.length; i++) {
      var l = o[i];
      l >= " " ? l === "\\" ? o[i] = "\\\\" : l === '"' && (o[i] = '\\"') : o[i] = l === `
` ? "\\n" : l === "\r" ? "\\r" : l === "	" ? "\\t" : l === "\b" ? "\\b" : l === "\f" ? "\\f" : (l = l.charCodeAt(), "\\u00" + (l > 15 ? 1 : 0) + l % 16);
    }
    return '"' + o.join("") + '"';
  }
}, lc = function (e) {
  if (e && typeof e == "object") {
    for (let o in e)
      if (Object.prototype.hasOwnProperty.call(e, o)) {
        let i = e[o];
        (Array.isArray(i) || st.Object(i)) && lc(i), st.String(i) && (e[o] = nv(i));
      }
  }
  return e;
};
function iv(e, o, i) {
  o = (o || "").split(".");
  let l = 0, n = o.length;
  for (; e != null && l < n;)
    e = e[o[l++]];
  return l && l === n && e !== void 0 ? e : i;
}
const ov = (e) => (o, i) => lv(o, i, rc(e)), lv = (e, o, i) => iv(i, e, "").replace(
  /\{(\w+)\}/g,
  (l, n) => {
    var u;
    return `${(u = o == null ? void 0 : o[n]) != null ? u : `{${n}}`}`;
  }
), av = (e) => {
  const o = Vn(() => rc(e).name), i = Vn(() => Fo(rv(o.value || ""))), l = Gh(e) ? e : So(e);
  return {
    lang: o,
    name: i,
    locale: l,
    t: ov(e)
  };
}, Us = (e) => av(Vn(() => e.value || ic)), Ft = (e, o) => o.map((i) => (i.label = e("props." + i.value) || i.label, i)), Qe = (e, o, i) => i.map((l) => (l.field === "formCreate$required" ? l.title = e("validate.required") || l.title : l.field && l.field !== "_optionType" && (l.title = e("com." + o + "." + l.field) || l.title), l)), Ml = function (e, o, i) {
  return o.forEach((l) => {
    e.indexOf(l[i || "id"]) > -1 && e.splice(e.indexOf(l[i || "id"]), 1, l.label), st.trueArray(l.children) && Ml(e, l.children, i);
  }), e;
}, sv = function (e, o) {
  return o.forEach((i) => {
    e.indexOf(i.value) > -1 && (e[e.indexOf(i.value)] = i.label);
  }), e;
};
function go(e) {
  if (e) {
    if (!Array.isArray(e))
      return [e];
  } else
    return [];
  return e;
}
const js = (e) => {
  const o = [];
  return e && e.forEach((i) => {
    if (i._fc_drag_tag) {
      const l = {
        id: i.__fc__.id,
        rule: i,
        children: js(i.children)
      };
      l.children.length || delete l.children, o.push(l);
    } else
      o.push(...js(i.children));
  }), o;
}, mf = (e) => {
  const o = (i) => {
    const l = [];
    return i && i.forEach((n) => {
      n.field ? (n.children = o(n.children || []), n.children.length || delete n.children, l.push(n)) : l.push(...o(n.children || []));
    }), l;
  };
  return o(e);
}, gf = (e) => {
  const o = (i) => {
    const l = [];
    return i && i.forEach((n) => {
      if (typeof n == "object")
        if (n._fc_drag_tag) {
          const u = {
            _fc_id: n._fc_id,
            type: n.type,
            field: n.field,
            title: n.title,
            slot: n.slot,
            props: { ...n.props || {} },
            children: o(n.children || [])
          };
          u.children.length || delete u.children, l.push(u);
        } else
          l.push(...o(n.children));
    }), l;
  };
  return o(e);
};
function uv(e, o) {
  let i = o.rule.value;
  const l = o.$render.vNode.h, n = o.type, u = o.$handle.subForm[o.id];
  if (!o.input || o.rule.subForm || (Array.isArray(u) ? u.length : u) || ["fcGroup", "fcSubForm", "tableForm", "stepForm", "nestedTableForm", "infiniteTableForm"].indexOf(o.trueType) > -1)
    return o.parser.render(e, o);
  if (["radio", "select", "checkbox"].indexOf(n) > -1)
    i = sv([...go(i)], o.prop.props.options || o.prop.props.formCreateInject.options || []).join(", ");
  else if (["timePicker", "datePicker", "slider"].indexOf(n) > -1)
    i = Array.isArray(i) ? i.join(" - ") : i;
  else if (n === "cascader")
    i = [...go(i)], Array.isArray(i[0]) || (i = [i]), i = i.map((f) => Ml(f, o.prop.props.options || o.prop.props.formCreateInject.options || [], "value").join("/")).join(", ");
  else if (n === "elTransfer") {
    const f = [...go(i)];
    i = Ml(f, o.prop.props.data || o.prop.props.formCreateInject.options || [], "key").join(", ");
  } else if (["tree", "elTreeSelect"].indexOf(n) > -1) {
    const f = o.prop.props.data || o.prop.props.formCreateInject.options || [];
    i = Ml([...go(i)], f).join(", ");
  } else {
    if (n === "fcEditor")
      return l("div", { innerHTML: i });
    if (n === "upload")
      return i = go(i), l("div", { class: "_fc-upload" }, i.map(function (f) {
        return l("div", { class: "_fc-upload-preview" }, [
          l("el-image", { src: f, previewSrcList: i, fit: "cover" })
        ]);
      }));
    (typeof i == "boolean" || n === "switch" || n === "el-switch") && (i = i ? "\u662F" : "\u5426");
  }
  return l("span", { class: "_fc-read-view" }, ["" + (i || "")]);
}
function qs(e) {
  return {
    name: "$inject",
    columns: [
      { label: "$inject.api", info: e("event.inject.api"), type: "Api" },
      { label: "$inject.rule", info: e("event.inject.rule"), type: "Rule[]" },
      { label: "$inject.self", info: e("event.inject.self"), type: "Rule" },
      { label: "$inject.option", info: e("event.inject.option"), type: "Object" },
      { label: "$inject.args", info: e("event.inject.args"), type: "Array" }
    ]
  };
}
function Zn(e) {
  return ["", null, void 0].indexOf(e) !== -1;
}
function dv(e, o) {
  return `<template>
  <form-create
    v-model="formData"
    v-model:api="fapi"
    :rule="rule"
    :option="option"
    @submit="onSubmit"
  ></form-create>
</template>

<script>
import formCreate from "@form-create/element-ui";

export default {
  component: {
    formCreate: formCreate.$form()
  }
  data () {
    const option = formCreate.parseJson('${o.replaceAll("\\", "\\\\").replaceAll("'", "\\")}');
    //\u5F00\u542F\u9605\u8BFB\u6A21\u5F0F
    //option.preview = true;
    return {
      formData: {},
      fapi: null,
      rule: formCreate.parseJson('${e.replaceAll("\\", "\\\\").replaceAll("'", "\\")}'),
      option: option
    }
  },
  methods: {
    onSubmit (formData) {
      //todo \u63D0\u4EA4\u8868\u5355
    }
  }
}
<\/script>`;
}
function _s(e) {
  return e.replace(/[\ .*+?^${}()|[\]\\]/g, "\\$&");
}
let fv = 0;
function We() {
  const e = 370 + ++fv;
  return "F" + Math.random().toString(36).substr(3, 3) + Number(`${Date.now()}`).toString(36) + e.toString(36) + "c";
}
function cv(e, o) {
  return function (i, l, n) {
    const u = { ...i || {} };
    Object.keys(u).forEach((f) => {
      Zn(u[f]) && delete u[f];
    }), n.getRule(e).props.info = Object.keys(u).length > 0 ? o("struct.configured") : "";
  };
}
function yf({ t: e }) {
  const o = We();
  return [
    {
      type: "input",
      field: ">formName",
      value: "",
      title: e("form.formName")
    },
    {
      type: "radio",
      field: "labelPosition",
      value: "left",
      title: e("form.labelPosition"),
      options: Ft(e, [
        { value: "left", label: "left" },
        { value: "right", label: "right" },
        { value: "top", label: "top" }
      ])
    },
    {
      type: "radio",
      field: "size",
      value: "small",
      title: e("form.size"),
      options: Ft(e, [
        { value: "large", label: "large" },
        { value: "default", label: "default" },
        { value: "small", label: "small" }
      ])
    },
    {
      type: "input",
      field: "labelSuffix",
      value: "",
      title: e("form.labelSuffix"),
      style: {
        width: "150px"
      }
    },
    {
      type: "SizeInput",
      field: "labelWidth",
      value: "125px",
      title: e("form.labelWidth")
    },
    {
      type: "switch",
      field: "hideRequiredAsterisk",
      value: !1,
      title: e("form.hideRequiredAsterisk")
    },
    {
      type: "switch",
      field: "showMessage",
      value: !0,
      title: e("form.showMessage")
    },
    {
      type: "switch",
      field: "inlineMessage",
      value: !1,
      title: e("form.inlineMessage")
    },
    {
      type: "switch",
      field: "_submitBtn>show",
      value: !0,
      title: e("form.submitBtn")
    },
    {
      type: "switch",
      field: "_resetBtn>show",
      value: !1,
      title: e("form.resetBtn")
    },
    {
      type: "ConfigItem",
      col: { show: !0 },
      name: o,
      style: "margin-bottom: 10px",
      props: {
        label: e("form.labelStyle"),
        appendBackground: "#FFF",
        info: ""
      },
      children: [{
        type: "StyleConfig",
        field: "title>style",
        wrap: { show: !1 },
        value: {},
        slot: "append",
        update: cv(o, e)
      }]
    },
    {
      type: "FnConfig",
      field: ">_event",
      value: {},
      col: { show: !0 },
      props: {
        eventConfig: [
          {
            name: "onSubmit",
            info: e("form.onSubmit"),
            args: ["formData", "api"]
          },
          {
            name: "onCreated",
            info: e("form.onCreated"),
            args: ["api"]
          },
          {
            name: "onMounted",
            info: e("form.onMounted"),
            args: ["api"]
          },
          {
            name: "onChange",
            info: e("form.onChange"),
            args: ["field", "value", "options"]
          },
          {
            name: "beforeFetch",
            info: e("form.beforeFetch"),
            args: ["config", "options"]
          }
        ]
      },
      title: e("form.event")
    },
    {
      type: "ElDivider",
      children: [e("form.globalConfig")]
    },
    {
      type: "GlobalEventConfig",
      name: "GlobalEventConfig",
      field: ">globalEvent",
      value: {},
      title: e("form.globalEvent")
    },
    {
      type: "GlobalFetchConfig",
      name: "GlobalFetchConfig",
      field: ">globalData",
      value: {},
      title: e("form.globalFetch")
    },
    {
      type: "GlobalClassConfig",
      name: "GlobalClassConfig",
      field: ">globalClass",
      value: {},
      title: e("form.globalClass")
    }
  ];
}
function yo({ t: e }) {
  return [
    {
      type: "FieldInput",
      field: "field",
      value: "",
      title: e("form.field")
    },
    {
      type: "input",
      field: "title",
      value: "",
      title: e("form.title")
    },
    {
      type: "input",
      field: "info",
      value: "",
      title: e("form.info")
    },
    {
      type: "SizeInput",
      field: "formCreateWrap>labelWidth",
      value: "",
      title: e("form.labelWidth")
    },
    {
      type: "Struct",
      field: "_control",
      value: [],
      title: e("form.control"),
      info: {
        type: "tooltip",
        native: !0,
        effect: "light",
        align: "left",
        content: e("form.document") + '\uFF1A<a target="_blank" href="https://form-create.com/v3/guide/control">https://form-create.com/v3/guide/control</a>',
        rawContent: !0
      },
      props: {
        defaultValue: [],
        validate(o) {
          return Array.isArray(o) ? o.length ? !o.some(({ rule: i }) => !Array.isArray(i)) : !0 : !1;
        }
      }
    }
  ];
}
function bf({ t: e }) {
  return [
    {
      type: "GlobalClassSelect",
      title: "Class",
      field: "class",
      wrap: {
        labelWidth: "45px"
      }
    },
    {
      type: "StyleConfig",
      field: "style",
      title: "",
      value: {}
    }
  ];
}
function Af({ t: e }) {
  return [
    {
      type: "ComputedConfig",
      field: "value",
      value: "",
      props: {
        type: "value",
        btn: e("computed.value.btn"),
        title: e("computed.value.title"),
        name: e("computed.value.name")
      },
      title: e("computed.value.title")
    },
    {
      type: "ComputedConfig",
      field: "hidden",
      value: "",
      props: {
        btn: e("computed.hidden.btn"),
        title: e("computed.hidden.title"),
        name: e("computed.hidden.name")
      },
      title: e("computed.hidden.title")
    },
    {
      type: "ComputedConfig",
      field: "$required",
      value: "",
      props: {
        btn: e("computed.required.btn"),
        title: e("computed.required.title"),
        name: e("computed.required.name")
      },
      title: e("computed.required.title")
    },
    {
      type: "ComputedConfig",
      field: "props.disabled",
      value: "",
      props: {
        btn: e("computed.disabled.btn"),
        title: e("computed.disabled.title"),
        name: e("computed.disabled.name")
      },
      title: e("computed.disabled.title")
    }
  ];
}
function Cf({ t: e }) {
  return [
    {
      type: "Required",
      field: "required",
      title: e("validate.required")
    },
    {
      type: "validate",
      field: "validate",
      title: e("validate.rule"),
      value: []
    }
  ];
}
function pv(e) {
  e = e || /* @__PURE__ */ new Map();
  const o = {
    $on(i, l) {
      const n = e.get(i);
      n && n.push(l) || e.set(i, [l]);
    },
    $once(i, l) {
      l._once = !0, o.$on(i, l);
    },
    $off(i, l) {
      const n = e.get(i);
      n && n.splice(n.indexOf(l) >>> 0, 1);
    },
    $emit(i, ...l) {
      (e.get(i) || []).slice().map((n) => {
        n._once && (o.$off(i, n), delete n._once), n(...l);
      }), (e.get("*") || []).slice().map((n) => {
        n(i, l);
      });
    }
  };
  return o;
}
const hv = "\u5355\u9009\u6846", Ga = "radio", vv = {
  menu: "main",
  icon: "icon-radio",
  label: hv,
  name: Ga,
  event: ["change"],
  validate: ["string", "number"],
  rule({ t: e }) {
    return {
      type: Ga,
      field: We(),
      title: e("com.radio.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {},
      options: Ur(e("props.option"), { label: "label", value: "value" }, 1)
    };
  },
  props(e, { t: o }) {
    return Qe(o, Ga + ".props", [
      Gl(o, "options"),
      { type: "switch", field: "disabled" },
      {
        type: "switch",
        field: "type",
        props: { activeValue: "button", inactiveValue: "default" }
      },
      { type: "ColorInput", field: "textColor" },
      {
        type: "ColorInput",
        field: "fill"
      }
    ]);
  }
}, mv = "\u591A\u9009\u6846", Ya = "checkbox", gv = {
  menu: "main",
  icon: "icon-checkbox",
  label: mv,
  name: Ya,
  event: ["change"],
  validate: ["array"],
  rule({ t: e }) {
    return {
      type: Ya,
      field: We(),
      title: e("com.checkbox.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {},
      options: Ur(e("props.option"), { label: "label", value: "value" }, 1)
    };
  },
  props(e, { t: o }) {
    return Qe(o, Ya + ".props", [
      Gl(o, "options"),
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "type",
        props: { activeValue: "button", inactiveValue: "default" }
      },
      {
        field: "min",
        type: "inputNumber",
        props: {
          min: 0
        }
      },
      {
        field: "max",
        type: "inputNumber",
        props: {
          min: 0
        }
      },
      {
        type: "ColorInput",
        field: "textColor"
      },
      {
        type: "ColorInput",
        field: "fill"
      }
    ]);
  }
}, yv = "\u8F93\u5165\u6846", Qa = "input", bv = {
  menu: "main",
  icon: "icon-input",
  label: yv,
  name: Qa,
  event: ["blur", "focus", "change", "input", "clear"],
  validate: ["string", "url", "email"],
  rule({ t: e }) {
    return {
      type: Qa,
      field: We(),
      title: e("com.input.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(e, { t: o }) {
    return Qe(o, Qa + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "readonly"
      },
      {
        type: "inputNumber",
        field: "maxlength",
        props: { min: 0 }
      },
      {
        type: "inputNumber",
        field: "minlength",
        props: { min: 0 }
      },
      {
        type: "input",
        field: "placeholder"
      },
      {
        type: "switch",
        field: "clearable"
      }
    ]);
  }
}, Av = "\u591A\u884C\u8F93\u5165\u6846", Sf = "textarea", Cv = {
  menu: "main",
  icon: "icon-textarea",
  label: Av,
  name: Sf,
  event: ["blur", "focus", "change", "input"],
  validate: ["string"],
  rule({ t: e }) {
    return {
      type: "input",
      field: We(),
      title: e("com.textarea.name"),
      info: "",
      $required: !1,
      props: {
        type: "textarea"
      }
    };
  },
  props(e, { t: o }) {
    return Qe(o, Sf + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "readonly"
      },
      {
        type: "inputNumber",
        field: "maxlength",
        props: { min: 0 }
      },
      {
        type: "inputNumber",
        field: "minlength",
        props: { min: 0 }
      },
      {
        type: "switch",
        field: "showWordLimit"
      },
      {
        type: "input",
        field: "placeholder"
      },
      {
        type: "inputNumber",
        field: "rows",
        props: {
          min: 0
        }
      },
      {
        type: "switch",
        field: "autosize"
      }
    ]);
  }
}, Sv = "\u5BC6\u7801\u8F93\u5165\u6846", Ef = "password", Ev = {
  menu: "main",
  icon: "icon-password",
  label: Sv,
  name: Ef,
  event: ["blur", "focus", "change", "input", "clear"],
  validate: ["string"],
  rule({ t: e }) {
    return {
      type: "input",
      field: We(),
      title: e("com.password.name"),
      info: "",
      $required: !1,
      props: {
        type: "password"
      }
    };
  },
  props(e, { t: o }) {
    return Qe(o, Ef + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "readonly"
      },
      {
        type: "inputNumber",
        field: "maxlength",
        props: { min: 0 }
      },
      {
        type: "inputNumber",
        field: "minlength",
        props: { min: 0 }
      },
      {
        type: "input",
        field: "placeholder"
      },
      {
        type: "switch",
        field: "clearable"
      }
    ]);
  }
}, wv = "\u8BA1\u6570\u5668", Ka = "inputNumber", xv = {
  menu: "main",
  icon: "icon-number",
  label: wv,
  name: Ka,
  event: ["blur", "focus", "change"],
  validate: ["number", "integer", "float"],
  rule({ t: e }) {
    return {
      type: Ka,
      field: We(),
      title: e("com.inputNumber.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(e, { t: o }) {
    return Qe(o, Ka + ".props", [{ type: "switch", field: "disabled" }, {
      type: "inputNumber",
      field: "min"
    }, {
      type: "inputNumber",
      field: "max"
    }, { type: "inputNumber", field: "step", props: { min: 0 } }, {
      type: "switch",
      field: "stepStrictly"
    }, {
      type: "switch",
      field: "controls",
      value: !0
    }, {
      type: "select",
      field: "controlsPosition",
      options: Ft(o, [{ label: "default", value: "" }, { label: "right", value: "right" }])
    }, { type: "input", field: "placeholder" }]);
  }
}, Tv = "\u9009\u62E9\u5668", Ja = "select", Dv = {
  menu: "main",
  icon: "icon-select",
  label: Tv,
  name: Ja,
  event: ["change", "visibleChange", "removeTag", "clear", "blur", "focus"],
  validate: ["string", "number", "array"],
  rule({ t: e }) {
    return {
      type: Ja,
      field: We(),
      title: e("com.select.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {},
      options: Ur(e("props.option"), { label: "label", value: "value" }, 1)
    };
  },
  watch: {
    multiple({ rule: e }) {
      e.key = We();
    }
  },
  props(e, { t: o }) {
    return Qe(o, Ja + ".props", [
      Gl(o, "options"),
      { type: "switch", field: "multiple" },
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "clearable" },
      {
        type: "switch",
        field: "collapseTags"
      },
      {
        type: "inputNumber",
        field: "multipleLimit",
        props: { min: 0 }
      },
      { type: "input", field: "placeholder" },
      {
        type: "switch",
        field: "filterable"
      },
      { type: "switch", field: "allowCreate" },
      {
        type: "input",
        field: "noMatchText"
      },
      { type: "input", field: "noDataText" },
      {
        type: "switch",
        field: "reserveKeyword"
      },
      { type: "switch", field: "defaultFirstOption" }
    ]);
  }
}, Iv = "\u5F00\u5173", Xa = "switch", Rv = {
  menu: "main",
  icon: "icon-switch",
  label: Iv,
  name: Xa,
  event: ["change"],
  rule({ t: e }) {
    return {
      type: Xa,
      field: We(),
      title: e("com.switch.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(e, { t: o }) {
    return Qe(o, Xa + ".props", [{
      type: "switch",
      field: "disabled"
    }, {
      type: "inputNumber",
      field: "width",
      props: { min: 0 }
    }, { type: "input", field: "activeText" }, {
      type: "input",
      field: "inactiveText"
    }, { type: "input", field: "activeValue" }, {
      type: "input",
      field: "inactiveValue"
    }, { type: "ColorInput", field: "activeColor" }, {
      type: "ColorInput",
      field: "inactiveColor"
    }]);
  }
}, Fv = "\u6ED1\u5757", Za = "slider", Mv = {
  menu: "main",
  icon: "icon-slider",
  label: Fv,
  name: Za,
  event: ["change", "input"],
  validate: ["number", "array"],
  rule({ t: e }) {
    return {
      type: Za,
      field: We(),
      title: e("com.slider.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(e, { t: o }) {
    return Qe(o, Za + ".props", [{ type: "switch", field: "disabled" }, {
      type: "switch",
      field: "range"
    }, {
      type: "inputNumber",
      field: "min",
      props: { min: 0 }
    }, {
      type: "inputNumber",
      field: "max",
      props: { min: 0 }
    }, {
      type: "inputNumber",
      field: "step",
      props: { min: 0 }
    }, { type: "switch", field: "showInput" }, {
      type: "switch",
      field: "showInputControls",
      value: !0
    }, { type: "switch", field: "showStops" }, {
      type: "switch",
      field: "vertical"
    }, {
      type: "input",
      field: "height"
    }]);
  }
}, Ov = "\u65F6\u95F4", qa = "timePicker", Nv = {
  menu: "main",
  icon: "icon-time",
  label: Ov,
  name: qa,
  event: ["change", "blur", "focus", "visibleChange"],
  rule({ t: e }) {
    return {
      type: qa,
      field: We(),
      title: e("com.timePicker.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  watch: {
    isRange({ rule: e }) {
      e.key = We();
    }
  },
  props(e, { t: o }) {
    return Qe(o, qa + ".props", [{ type: "switch", field: "readonly" }, {
      type: "switch",
      field: "disabled"
    }, {
      type: "switch",
      field: "isRange"
    }, {
      type: "switch",
      field: "clearable",
      value: !0
    }, {
      type: "Struct",
      field: "pickerOptions",
      props: { defaultValue: {} }
    }, { type: "switch", field: "editable", value: !0 }, {
      type: "input",
      field: "placeholder"
    }, {
      type: "input",
      field: "startPlaceholder"
    }, { type: "input", field: "endPlaceholder" }, {
      type: "switch",
      field: "arrowControl"
    }, {
      type: "select",
      field: "align",
      options: Ft(o, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
        label: "right",
        value: "right"
      }])
    }]);
  }
}, Lv = "\u65F6\u95F4\u533A\u95F4", Pv = "timeRange", $v = {
  menu: "main",
  icon: "icon-time",
  label: Lv,
  name: Pv,
  event: ["change", "blur", "focus", "visibleChange"],
  rule({ t: e }) {
    return {
      type: "timePicker",
      field: We(),
      title: e("com.timeRange.name"),
      info: "",
      $required: !1,
      props: {
        isRange: !0
      }
    };
  },
  props(e, { t: o }) {
    return Qe(o, "timePicker.props", [{ type: "switch", field: "readonly" }, {
      type: "switch",
      field: "disabled"
    }, {
      type: "switch",
      field: "clearable",
      value: !0
    }, {
      type: "Struct",
      field: "pickerOptions",
      props: { defaultValue: {} }
    }, { type: "switch", field: "editable", value: !0 }, {
      type: "input",
      field: "startPlaceholder"
    }, { type: "input", field: "endPlaceholder" }, {
      type: "switch",
      field: "arrowControl"
    }, {
      type: "select",
      field: "align",
      options: Ft(o, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
        label: "right",
        value: "right"
      }])
    }]);
  }
}, Bv = "\u65E5\u671F", _a = "datePicker", kv = {
  menu: "main",
  icon: "icon-date",
  label: Bv,
  name: _a,
  event: ["change", "blur", "focus", "calendarChange", "panelChange", "visibleChange"],
  rule({ t: e }) {
    return {
      type: _a,
      field: We(),
      title: e("com.datePicker.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(e, { t: o }) {
    return Qe(o, _a + ".props", [{ type: "switch", field: "readonly" }, {
      type: "switch",
      field: "disabled"
    }, {
      type: "select",
      field: "type",
      options: Ft(o, [{ label: "year", value: "year" }, { label: "month", value: "month" }, {
        label: "date",
        value: "date"
      }, { label: "dates", value: "dates" }, { label: "week", value: "week" }, {
        label: "datetime",
        value: "datetime"
      }, { label: "datetimerange", value: "datetimerange" }, {
        label: "daterange",
        value: "daterange"
      }, { label: "monthrange", value: "monthrange" }])
    }, {
      type: "switch",
      field: "clearable",
      value: !0
    }, {
      type: "Struct",
      field: "pickerOptions",
      props: { defaultValue: {} }
    }, { type: "switch", field: "editable", value: !0 }, {
      type: "input",
      field: "placeholder"
    }, {
      type: "input",
      field: "startPlaceholder"
    }, { type: "input", field: "endPlaceholder" }, {
      type: "input",
      field: "format"
    }, {
      type: "select",
      field: "align",
      options: Ft(o, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
        label: "right",
        value: "right"
      }])
    }, { type: "input", field: "rangeSeparator" }, {
      type: "switch",
      field: "unlinkPanels"
    }]);
  }
}, Hv = "\u65E5\u671F\u533A\u95F4", Vv = "dateRange", Uv = {
  menu: "main",
  icon: "icon-date",
  label: Hv,
  name: Vv,
  event: ["change", "blur", "focus", "calendarChange", "panelChange", "visibleChange"],
  rule({ t: e }) {
    return {
      type: "datePicker",
      field: We(),
      title: e("com.dateRange.name"),
      info: "",
      $required: !1,
      props: {
        type: "datetimerange"
      }
    };
  },
  props(e, { t: o }) {
    return Qe(o, "datePicker.props", [{ type: "switch", field: "readonly" }, {
      type: "switch",
      field: "disabled"
    }, {
      type: "select",
      field: "type",
      options: Ft(o, [
        { label: "datetimerange", value: "datetimerange" },
        { label: "daterange", value: "daterange" },
        { label: "monthrange", value: "monthrange" }
      ])
    }, {
      type: "switch",
      field: "clearable",
      value: !0
    }, {
      type: "Struct",
      field: "pickerOptions",
      props: { defaultValue: {} }
    }, { type: "switch", field: "editable", value: !0 }, {
      type: "input",
      field: "startPlaceholder"
    }, { type: "input", field: "endPlaceholder" }, {
      type: "input",
      field: "format"
    }, {
      type: "select",
      field: "align",
      options: Ft(o, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
        label: "right",
        value: "right"
      }])
    }, { type: "input", field: "rangeSeparator" }, {
      type: "switch",
      field: "unlinkPanels"
    }]);
  }
}, jv = "\u8BC4\u5206", es = "rate", zv = {
  menu: "main",
  icon: "icon-rate",
  label: jv,
  name: es,
  event: ["change"],
  validate: ["number"],
  rule({ t: e }) {
    return {
      type: es,
      field: We(),
      title: e("com.rate.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(e, { t: o }) {
    return Qe(o, es + ".props", [
      { type: "inputNumber", field: "max", props: { min: 0 } },
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "allowHalf" },
      {
        type: "ColorInput",
        field: "voidColor"
      },
      { type: "ColorInput", field: "disabledVoidColor" },
      {
        type: "input",
        field: "voidIconClass"
      },
      { type: "input", field: "disabledVoidIconClass" },
      {
        type: "switch",
        field: "showScore"
      },
      { type: "ColorInput", field: "textColor" },
      {
        type: "input",
        field: "scoreTemplate"
      }
    ]);
  }
}, Wv = "\u989C\u8272\u9009\u62E9\u5668", ts = "colorPicker", Gv = {
  menu: "main",
  icon: "icon-color",
  label: Wv,
  name: ts,
  event: ["change", "activeChange", "focus", "blur"],
  validate: ["string"],
  rule({ t: e }) {
    return {
      type: ts,
      field: We(),
      title: e("com.colorPicker.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(e, { t: o }) {
    return Qe(o, ts + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "showAlpha"
      },
      {
        type: "select",
        field: "colorFormat",
        options: [{ label: "hsl", value: "hsl" }, { label: "hsv", value: "hsv" }, {
          label: "hex",
          value: "hex"
        }, { label: "rgb", value: "rgb" }]
      },
      {
        type: "tableOptions",
        field: "predefine",
        props: {
          column: [{ label: o("props.value"), key: "value" }],
          valueType: "string"
        }
      }
    ]);
  }
}, Yv = "\u6805\u683C\u5E03\u5C40", ns = "fcRow", Qv = {
  menu: "layout",
  icon: "icon-row",
  label: Yv,
  name: ns,
  mask: !1,
  rule() {
    return {
      type: ns,
      props: {},
      children: []
    };
  },
  children: "col",
  childrenLen: 2,
  props(e, { t: o }) {
    return Qe(o, ns + ".props", [{
      type: "inputNumber",
      field: "gutter",
      props: { min: 0 }
    }, {
      type: "switch",
      field: "type",
      props: { activeValue: "flex", inactiveValue: "default" }
    }, {
      type: "select",
      field: "justify",
      options: [{ label: "start", value: "start" }, { label: "end", value: "end" }, {
        label: "center",
        value: "center"
      }, { label: "space-around", value: "space-around" }, { label: "space-between", value: "space-between" }]
    }, {
      type: "select",
      field: "align",
      options: [{ label: "top", value: "top" }, { label: "middle", value: "middle" }, {
        label: "bottom",
        value: "bottom"
      }]
    }]);
  }
}, rs = "col", Kv = {
  name: rs,
  label: "\u683C\u5B50",
  drag: !0,
  dragBtn: !1,
  inside: !0,
  mask: !1,
  rule() {
    return {
      type: rs,
      props: { span: 12 },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, rs + ".props", [
      { type: "slider", field: "span", value: 12, props: { min: 0, max: 24 } },
      { type: "slider", field: "offset", props: { min: 0, max: 24 } },
      { type: "slider", field: "push", props: { min: 0, max: 24 } },
      { type: "slider", field: "pull", props: { min: 0, max: 24 } }
    ]);
  }
}, Jv = "\u9009\u9879\u5361", is = "elTabPane", Xv = {
  label: Jv,
  name: is,
  inside: !0,
  drag: !0,
  dragBtn: !1,
  mask: !1,
  rule({ t: e }) {
    return {
      type: is,
      props: { label: e("com.elTabPane.name") },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, is + ".props", [{ type: "input", field: "label" }, {
      type: "switch",
      field: "disabled"
    }, { type: "input", field: "name" }, {
      type: "switch",
      field: "lazy"
    }]);
  }
}, Zv = "\u5206\u5272\u7EBF", os = "elDivider", qv = {
  menu: "aide",
  icon: "icon-divider",
  label: Zv,
  name: os,
  rule({ t: e }) {
    return {
      type: os,
      props: {},
      children: [e("com.elDivider.name")]
    };
  },
  props(e, { t: o }) {
    return Qe(o, os + ".props", [{
      type: "select",
      field: "direction",
      options: Ft(o, [{ label: "horizontal", value: "horizontal" }, { label: "vertical", value: "vertical" }])
    }, {
      type: "input",
      field: "formCreateChild"
    }, {
      type: "select",
      field: "contentPosition",
      options: Ft(o, [{ label: "left", value: "left" }, { label: "right", value: "right" }, {
        label: "center",
        value: "center"
      }])
    }]);
  }
}, _v = "\u7EA7\u8054\u9009\u62E9\u5668", bl = "cascader", em = {
  menu: "main",
  icon: "icon-cascader",
  label: _v,
  name: bl,
  event: ["change", "expandChange", "blur", "focus", "visibleChange", "removeTag"],
  validate: ["string", "number", "array"],
  rule({ t: e }) {
    return {
      type: bl,
      field: We(),
      title: e("com.cascader.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {
        options: Ur(e("props.option"), { label: "label", value: "value" }, 3)
      }
    };
  },
  props(e, { t: o }) {
    return Qe(o, bl + ".props", [
      Yl({ t: o, to: "props.options" }),
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "clearable"
      },
      {
        type: "input",
        field: "placeholder"
      },
      {
        type: "Object",
        field: "props",
        props: {
          rule: Qe(o, bl + ".propsOpt", [{
            type: "switch",
            field: "multiple"
          }, {
            type: "select",
            field: "expandTrigger",
            options: Ft(o, [{ label: "click", value: "click" }, {
              label: "hover",
              value: "hover"
            }])
          }, {
            type: "switch",
            field: "checkStrictly"
          }, {
            type: "switch",
            field: "emitPath",
            value: !0
          }, {
            type: "input",
            field: "value",
            value: "value"
          }, {
            type: "input",
            field: "label",
            value: "label"
          }, {
            type: "input",
            field: "children",
            value: "children"
          }, {
            type: "input",
            field: "disabled",
            value: "disabled"
          }, { type: "input", field: "leaf" }])
        }
      },
      {
        type: "switch",
        field: "showAllLevels",
        value: !0
      },
      {
        type: "switch",
        field: "collapseTags"
      },
      {
        type: "switch",
        field: "collapseTagsTooltip"
      },
      {
        type: "input",
        field: "separator"
      },
      {
        type: "switch",
        field: "filterable"
      },
      {
        type: "select",
        field: "tagType",
        options: [
          { label: "success", value: "success" },
          { label: "info", value: "info" },
          { label: "warning", value: "warning" },
          { label: "danger", value: "danger" }
        ]
      }
    ]);
  }
}, tm = "\u4E0A\u4F20", ls = "upload", nm = {
  menu: "main",
  icon: "icon-upload",
  label: tm,
  name: ls,
  event: ["change", "remove"],
  validate: ["array"],
  rule({ t: e }) {
    return {
      type: ls,
      field: We(),
      title: e("com.upload.name"),
      info: "",
      $required: !1,
      props: {
        action: "",
        onSuccess(o, i) {
          i.url = o.data.url;
        }
      }
    };
  },
  props(e, { t: o }) {
    return Qe(o, ls + ".props", [{
      type: "switch",
      field: "disabled"
    }, {
      type: "select",
      field: "listType",
      value: "text",
      options: Ft(o, [{ label: "text", value: "text" }, {
        label: "picture",
        value: "picture"
      }, {
        label: "picture-card",
        value: "picture-card"
      }])
    }, { type: "switch", field: "multiple" }, {
      type: "input",
      field: "action"
    }, {
      type: "FnEditor",
      field: "onSuccess",
      info: o("com.upload.info"),
      props: {
        args: ["res", "file"],
        name: "onSuccess"
      }
    }, {
      type: "TableOptions",
      field: "headers",
      props: {
        column: [{ label: o("props.key"), key: "label" }, { label: o("props.value"), key: "value" }],
        valueType: "object"
      }
    }, {
      type: "TableOptions",
      field: "data",
      props: {
        column: [{ label: o("props.key"), key: "label" }, { label: o("props.value"), key: "value" }],
        valueType: "object"
      }
    }, { type: "input", field: "name" }, {
      type: "switch",
      field: "withCredentials"
    }, { type: "input", field: "accept" }, {
      type: "switch",
      field: "autoUpload",
      value: !0
    }, {
      type: "inputNumber",
      field: "limit",
      props: { min: 0 }
    }]);
  }
}, rm = "\u7A7F\u68AD\u6846", as = "elTransfer", im = {
  menu: "main",
  icon: "icon-transfer",
  label: rm,
  name: as,
  event: ["change", "leftCheckChange", "rightCheckChange"],
  validate: ["string", "number", "array"],
  rule({ t: e }) {
    return {
      type: as,
      field: We(),
      title: e("com.elTransfer.name"),
      info: "",
      $required: !1,
      props: {
        data: Ur(e("props.option"), { label: "label", value: "key" }, 1)
      }
    };
  },
  props(e, { t: o }) {
    return Qe(o, as + ".props", [
      Yl({ t: o, to: "props.data", label: "label", value: "key" }),
      { type: "switch", field: "filterable" },
      {
        type: "input",
        field: "filterPlaceholder"
      },
      {
        type: "select",
        field: "targetOrder",
        info: o("com.elTransfer.targetOrderInfo"),
        options: [{ label: "original", value: "original" }, {
          label: "push",
          value: "push"
        }, { label: "unshift", value: "unshift" }]
      },
      {
        type: "TableOptions",
        field: "titles",
        props: {
          column: [{ label: o("props.value"), key: "value" }],
          valueType: "string",
          max: 2
        }
      },
      {
        type: "TableOptions",
        field: "buttonTexts",
        props: {
          column: [{ label: o("props.value"), key: "value" }],
          valueType: "string",
          max: 2
        }
      },
      {
        type: "Struct",
        field: "props",
        props: {
          column: [{ label: o("props.key"), key: "label" }, { label: o("props.value"), key: "value" }],
          valueType: "object"
        }
      }
    ]);
  }
}, om = "\u6811\u5F62\u63A7\u4EF6", ss = "tree", lm = {
  menu: "main",
  icon: "icon-tree",
  label: om,
  name: ss,
  event: ["nodeClick", "nodeContextmenu", "checkChange", "check", "currentChange", "nodeExpand", "nodeCollapse", "nodeDragStart", "nodeDragEnter", "nodeDragLeave", "nodeDragOver", "nodeDragEnd", "nodeDrop"],
  validate: ["string", "number", "array"],
  rule({ t: e }) {
    return {
      type: ss,
      field: We(),
      title: e("com.tree.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {
        props: {
          label: "label"
        },
        showCheckbox: !0,
        nodeKey: "id",
        data: Ur(e("props.option"), { label: "label", value: "id" }, 3)
      }
    };
  },
  props(e, { t: o }) {
    return Qe(o, ss + ".props", [
      Yl({ t: o, to: "props.data", label: "label", value: "id" }),
      { type: "input", field: "emptyText" },
      {
        type: "TableOptions",
        field: "props",
        props: {
          column: [{ label: o("props.key"), key: "label" }, { label: o("props.value"), key: "value" }],
          valueType: "object"
        }
      },
      {
        type: "switch",
        field: "renderAfterExpand",
        value: !0
      },
      {
        type: "switch",
        field: "defaultExpandAll"
      },
      {
        type: "switch",
        field: "expandOnClickNode",
        value: !0
      },
      {
        type: "switch",
        field: "checkOnClickNode"
      },
      { type: "switch", field: "autoExpandParent", value: !0 },
      {
        type: "switch",
        field: "checkStrictly"
      },
      { type: "switch", field: "accordion" },
      {
        type: "inputNumber",
        field: "indent"
      },
      {
        type: "input",
        field: "nodeKey"
      }
    ]);
  }
}, am = "\u63D0\u793A", us = "elAlert", sm = {
  menu: "aide",
  icon: "icon-alert",
  label: am,
  name: us,
  event: ["close"],
  rule({ t: e }) {
    return {
      type: us,
      props: {
        title: e("com.elAlert.name"),
        description: e("com.elAlert.description"),
        type: "success",
        effect: "dark"
      },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, us + ".props", [{ type: "input", field: "title" }, {
      type: "select",
      field: "type",
      options: [{ label: "success", value: "success" }, { label: "warning", value: "warning" }, {
        label: "info",
        value: "info"
      }, { label: "error", value: "error" }]
    }, { type: "input", field: "description" }, {
      type: "switch",
      field: "closable",
      value: !0
    }, { type: "switch", field: "center", value: !0 }, {
      type: "input",
      field: "closeText"
    }, { type: "switch", field: "showIcon" }, {
      type: "select",
      field: "effect",
      options: [{ label: "light", value: "light" }, { label: "dark", value: "dark" }]
    }]);
  }
}, um = "\u6587\u5B57", wf = "text", dm = {
  menu: "aide",
  icon: "icon-span",
  label: um,
  name: wf,
  rule({ t: e }) {
    return {
      type: "div",
      title: "",
      native: !0,
      children: [e("com.text.name")]
    };
  },
  watch: {
    formCreateNative({ value: e, rule: o }) {
      e && (o.title = "");
    }
  },
  props(e, { t: o }) {
    return Qe(o, wf + ".props", [
      {
        type: "switch",
        field: "formCreateNative",
        props: {
          activeValue: !1,
          inactiveValue: !0
        },
        control: [{ value: !1, rule: ["formCreateTitle"] }]
      },
      {
        type: "input",
        field: "formCreateTitle"
      },
      {
        type: "input",
        field: "formCreateChild",
        props: {
          type: "textarea"
        }
      }
    ]);
  }
}, fm = "\u95F4\u8DDD", cm = "space", pm = {
  menu: "layout",
  icon: "icon-space",
  label: fm,
  name: cm,
  rule() {
    return {
      type: "div",
      wrap: {
        show: !1
      },
      native: !0,
      style: {
        width: "100%",
        height: "20px"
      },
      children: []
    };
  },
  props() {
    return [];
  }
}, hm = "\u6807\u7B7E\u9875", ds = "elTabs", vm = {
  menu: "layout",
  icon: "icon-tab",
  label: hm,
  name: ds,
  children: "elTabPane",
  mask: !1,
  event: ["tabClick", "tabChange", "tabRemove", "tabAdd", "edit"],
  rule() {
    return {
      type: ds,
      style: { width: "100%" },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, ds + ".props", [{
      type: "select",
      field: "type",
      options: [{
        label: "card",
        value: "card"
      }, { label: "border-card", value: "border-card" }]
    }, { type: "switch", field: "closable" }, {
      type: "select",
      field: "tabPosition",
      options: Ft(o, [{ label: "top", value: "top" }, { label: "right", value: "right" }, {
        label: "left",
        value: "left"
      }])
    }, { type: "switch", field: "stretch" }]);
  }
}, mm = "\u6309\u94AE", fs = "elButton", gm = {
  menu: "aide",
  icon: "icon-button",
  label: mm,
  name: fs,
  mask: !0,
  event: ["click"],
  rule({ t: e }) {
    return {
      type: fs,
      props: {},
      children: [e("com.elButton.name")]
    };
  },
  props(e, { t: o }) {
    return Qe(o, fs + ".props", [{
      type: "input",
      field: "formCreateChild"
    }, {
      type: "select",
      field: "size",
      options: Ft(o, [{ label: "large", value: "large" }, { label: "default", value: "default" }, {
        label: "small",
        value: "small"
      }])
    }, {
      type: "select",
      field: "type",
      options: [{ label: "primary", value: "primary" }, {
        label: "success",
        value: "success"
      }, { label: "warning", value: "warning" }, { label: "danger", value: "danger" }, {
        label: "info",
        value: "info"
      }]
    }, { type: "switch", field: "plain" }, {
      type: "switch",
      field: "round"
    }, { type: "switch", field: "circle" }, {
      type: "switch",
      field: "loading"
    }, { type: "switch", field: "disabled" }]);
  }
}, ym = "\u5BCC\u6587\u672C\u6846", cs = "fcEditor", bm = {
  menu: "main",
  icon: "icon-editor",
  label: ym,
  name: cs,
  event: ["change"],
  validate: ["string"],
  rule({ t: e }) {
    return {
      type: cs,
      field: We(),
      title: e("com.fcEditor.name"),
      info: "",
      $required: !1,
      props: {}
    };
  },
  props(e, { t: o }) {
    return Qe(o, cs + ".props", [{
      type: "switch",
      field: "disabled"
    }]);
  }
}, Am = "\u5B50\u8868\u5355", xf = "group", Cm = {
  menu: "subform",
  icon: "icon-subform",
  label: Am,
  name: xf,
  inside: !1,
  drag: !0,
  dragBtn: !0,
  mask: !1,
  event: ["change"],
  subForm: "array",
  loadRule(e) {
    e.children = e.props.rule || [], e.type = "FcRow", delete e.props.rule;
  },
  parseRule(e) {
    e.props.rule = e.children, e.type = "group", delete e.children, delete e.props.mode;
  },
  rule({ t: e }) {
    return {
      type: "fcRow",
      field: We(),
      title: e("com.group.name"),
      info: "",
      $required: !1,
      props: {},
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, xf + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "syncDisabled", value: !0 },
      { type: "switch", field: "button", value: !0 },
      { type: "switch", field: "sortBtn", value: !0 },
      { type: "inputNumber", field: "expand" },
      { type: "inputNumber", field: "min" },
      { type: "inputNumber", field: "max" }
    ]);
  }
}, Sm = "\u5206\u7EC4", Tf = "subForm", Em = {
  menu: "subform",
  icon: "icon-group",
  label: Sm,
  name: Tf,
  inside: !1,
  drag: !0,
  dragBtn: !0,
  mask: !1,
  subForm: "object",
  event: ["change"],
  loadRule(e) {
    e.children = e.props.rule || [], e.type = "FcRow", delete e.props.rule;
  },
  parseRule(e) {
    e.props.rule = e.children, e.type = "subForm", delete e.children;
  },
  rule({ t: e }) {
    return {
      type: "fcRow",
      field: We(),
      title: e("com.subForm.name"),
      info: "",
      $required: !1,
      props: {},
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, Tf + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "syncDisabled", value: !0 }
    ]);
  }
}, wm = "\u5361\u7247", ps = "elCard", xm = {
  menu: "layout",
  icon: "icon-card",
  label: wm,
  name: ps,
  drag: !0,
  inside: !1,
  mask: !1,
  rule({ t: e }) {
    return {
      type: ps,
      props: {
        header: e("com.elCard.props.header")
      },
      style: {
        width: "100%"
      },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, ps + ".props", [{
      type: "input",
      field: "header"
    }, {
      type: "select",
      field: "shadow",
      value: "always",
      options: Ft(o, [{ label: "always", value: "always" }, { label: "never", value: "never" }, {
        label: "hover",
        value: "hover"
      }])
    }]);
  }
}, Tm = "\u6298\u53E0\u9762\u677F", hs = "elCollapse", Dm = {
  menu: "layout",
  icon: "icon-collapse",
  label: Tm,
  name: hs,
  mask: !1,
  children: "elCollapseItem",
  event: ["change"],
  rule() {
    return {
      type: hs,
      props: {},
      style: {
        width: "100%"
      },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, hs + ".props", [{
      type: "switch",
      field: "accordion"
    }]);
  }
}, Im = "\u9762\u677F", vs = "elCollapseItem", Rm = {
  icon: "icon-cell",
  label: Im,
  name: vs,
  drag: !0,
  dragBtn: !1,
  inside: !0,
  mask: !1,
  rule({ t: e }) {
    return {
      type: vs,
      props: {
        title: e("com.elCollapseItem.name")
      },
      style: {},
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, vs + ".props", [{
      type: "input",
      field: "title"
    }, {
      type: "input",
      field: "name"
    }, {
      type: "switch",
      field: "disabled"
    }]);
  }
}, Fm = "\u6811\u5F62\u9009\u62E9", ms = "elTreeSelect", Mm = {
  menu: "main",
  icon: "icon-tree-select",
  label: Fm,
  name: ms,
  event: ["change", "visibleChange", "removeTag", "clear", "blur", "focus"],
  validate: ["string", "number", "array"],
  rule({ t: e }) {
    return {
      type: ms,
      field: We(),
      title: e("com.elTreeSelect.name"),
      info: "",
      effect: {
        fetch: ""
      },
      $required: !1,
      props: {
        nodeKey: "id",
        showCheckbox: !0,
        data: Ur(e("props.option"), { label: "label", value: "id" }, 3)
      }
    };
  },
  watch: {
    multiple({ rule: e }) {
      e.key = We();
    }
  },
  props(e, { t: o }) {
    return Qe(o, ms + ".props", [
      Yl({ t: o, to: "props.data", label: "label", value: "id" }),
      { type: "switch", field: "multiple" },
      {
        type: "switch",
        field: "disabled"
      },
      { type: "switch", field: "clearable" },
      {
        type: "switch",
        field: "collapseTags"
      },
      {
        type: "inputNumber",
        field: "multipleLimit",
        props: { min: 0 }
      },
      { type: "input", field: "placeholder" },
      {
        type: "TableOptions",
        field: "props",
        props: {
          column: [{ label: o("props.key"), key: "label" }, { label: o("props.value"), key: "value" }],
          valueType: "object"
        }
      },
      {
        type: "switch",
        field: "renderAfterExpand",
        value: !0
      },
      {
        type: "switch",
        field: "defaultExpandAll"
      },
      {
        type: "switch",
        field: "expandOnClickNode",
        value: !0
      },
      {
        type: "switch",
        field: "checkOnClickNode"
      },
      {
        type: "input",
        field: "nodeKey"
      }
    ]);
  }
}, Om = "\u6807\u7B7E", gs = "elTag", Nm = {
  menu: "aide",
  icon: "icon-tag",
  label: Om,
  name: gs,
  mask: !0,
  event: ["click", "close"],
  rule({ t: e }) {
    return {
      type: gs,
      title: "",
      native: !0,
      children: [e("com.elTag.name")]
    };
  },
  watch: {
    formCreateNative({ value: e, rule: o }) {
      e && (o.title = "");
    }
  },
  props(e, { t: o }) {
    return Qe(o, gs + ".props", [
      {
        type: "switch",
        field: "formCreateNative",
        props: {
          activeValue: !1,
          inactiveValue: !0
        },
        control: [{ value: !1, rule: ["formCreateTitle"] }]
      },
      {
        type: "input",
        field: "formCreateTitle"
      },
      {
        type: "input",
        field: "formCreateChild"
      },
      {
        type: "select",
        field: "type",
        options: [{ label: "primary", value: "primary" }, {
          label: "success",
          value: "success"
        }, { label: "warning", value: "warning" }, { label: "danger", value: "danger" }, {
          label: "info",
          value: "info"
        }]
      },
      {
        type: "select",
        field: "size",
        options: Ft(o, [{ label: "large", value: "large" }, {
          label: "default",
          value: "default"
        }, { label: "small", value: "small" }])
      },
      {
        type: "select",
        field: "effect",
        options: [{ label: "dark", value: "dark" }, {
          label: "light",
          value: "light"
        }, { label: "plain", value: "plain" }]
      },
      {
        type: "switch",
        field: "closable"
      },
      {
        type: "switch",
        field: "disableTransitions"
      },
      {
        type: "switch",
        field: "hit"
      },
      {
        type: "switch",
        field: "round"
      },
      {
        type: "ColorInput",
        field: "color"
      }
    ]);
  }
}, Lm = "\u63CF\u8FF0\u683C\u5B50", ys = "elDescriptionsItem", Pm = {
  icon: "icon-cell",
  label: Lm,
  name: ys,
  dragBtn: !1,
  inside: !0,
  mask: !1,
  rule({ t: e }) {
    return {
      type: ys,
      props: {
        label: e("props.title")
      },
      children: [e("props.content")]
    };
  },
  watch: {
    __child({ value: e, rule: o }) {
      o.children[0].children[0] = e;
    }
  },
  attrs: {
    child({ rule: e }) {
      return e.children[0].children[0] || "";
    }
  },
  props(e, { t: o }) {
    return Qe(o, ys + ".props", [
      { type: "input", field: "label" },
      {
        type: "input",
        field: "__child"
      },
      {
        type: "inputNumber",
        field: "span"
      },
      {
        type: "input",
        field: "width"
      },
      {
        type: "input",
        field: "minWidth"
      },
      {
        type: "select",
        field: "align",
        options: Ft(o, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
          label: "right",
          value: "right"
        }])
      },
      {
        type: "select",
        field: "labelAlign",
        options: Ft(o, [{ label: "left", value: "left" }, { label: "center", value: "center" }, {
          label: "right",
          value: "right"
        }])
      },
      { type: "input", field: "className" }
    ]);
  }
}, $m = "\u63CF\u8FF0\u5217\u8868", bs = "elDescriptions", Bm = {
  menu: "layout",
  icon: "icon-descriptions",
  label: $m,
  name: bs,
  mask: !1,
  rule() {
    return {
      type: bs,
      props: {
        border: !0
      },
      style: {
        width: "100%"
      },
      children: []
    };
  },
  children: "elDescriptionsItem",
  childrenLen: 2,
  props(e, { t: o }) {
    return Qe(o, bs + ".props", [{
      type: "input",
      field: "title",
      value: ""
    }, {
      type: "input",
      field: "extra",
      value: ""
    }, {
      type: "inputNumber",
      field: "column",
      value: 3,
      props: { min: 0 }
    }, {
      type: "switch",
      field: "border"
    }, {
      type: "select",
      field: "direction",
      options: Ft(o, [{ label: "vertical", value: "vertical" }, {
        label: "horizontal",
        value: "horizontal"
      }])
    }, {
      type: "select",
      field: "size",
      options: Ft(o, [{ label: "large", value: "large" }, { label: "default", value: "default" }, {
        label: "small",
        value: "small"
      }])
    }]);
  }
}, km = "\u5206\u6B65\u8868\u5355", As = "stepForm", Hm = {
  menu: "subform",
  icon: "icon-step-form",
  label: km,
  name: As,
  mask: !1,
  children: "stepFormItem",
  childrenLen: 2,
  event: ["change", "submit", "next"],
  subForm: "object",
  loadRule(e) {
    e.props || (e.props = {});
    const o = e.props.steps || {};
    e.children = o.map((i) => ({
      type: "stepFormItem",
      _fc_drag_tag: "stepFormItem",
      props: {
        title: i.props.title,
        description: i.props.description
      },
      children: i.rule
    })), delete e.props.steps;
  },
  parseRule(e) {
    const o = e.children || [];
    e.props.steps = o.map((i) => ({
      props: i.props,
      rule: i.children
    })), e.children = [];
  },
  rule() {
    return {
      type: As,
      field: We(),
      title: "",
      info: "",
      $required: !1,
      props: {},
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, As + ".props", [
      { type: "switch", field: "autoValidate" },
      { type: "switch", field: "stepsProps>alignCenter" },
      {
        type: "switch",
        field: "stepsProps>simple"
      }
    ]);
  }
}, Vm = "\u6B65\u9AA4\u6761", Cs = "stepFormItem", Um = {
  icon: "icon-cell",
  label: Vm,
  name: Cs,
  drag: !0,
  dragBtn: !1,
  inside: !0,
  mask: !1,
  style: !1,
  advanced: !1,
  rule({ t: e }) {
    return {
      type: Cs,
      props: {
        title: e("com.stepFormItem.props.title"),
        description: ""
      },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, Cs + ".props", [
      {
        type: "input",
        field: "title",
        value: ""
      },
      {
        type: "input",
        field: "description",
        value: ""
      }
    ]);
  }
}, jm = "HTML", Ss = "html", zm = {
  menu: "aide",
  icon: "icon-html",
  label: jm,
  name: Ss,
  rule() {
    return {
      type: Ss,
      title: "",
      native: !0,
      attrs: {
        innerHTML: ""
      },
      children: [`<div style="color:blue;">
 html html html html html html html html html
  </div>`]
    };
  },
  watch: {
    formCreateNative({ value: e, rule: o }) {
      e && (o.title = "");
    }
  },
  props(e, { t: o }) {
    return Qe(o, Ss + ".props", [
      {
        type: "switch",
        field: "formCreateNative",
        props: {
          activeValue: !1,
          inactiveValue: !0
        },
        control: [{ value: !1, rule: ["formCreateTitle"] }]
      },
      {
        type: "input",
        field: "formCreateTitle"
      },
      {
        type: "HtmlEditor",
        field: "formCreateChild"
      }
    ]);
  }
}, Wm = "\u8868\u683C\u5E03\u5C40", Es = "fcTable", Gm = {
  menu: "layout",
  icon: "icon-table",
  label: Wm,
  name: Es,
  inside: !1,
  mask: !1,
  rule() {
    return {
      type: Es,
      props: {},
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, Es + ".props", [
      { type: "switch", field: "border", value: !0 },
      { type: "ColorInput", field: "borderColor" },
      { type: "input", field: "borderWidth" }
    ]);
  }
}, Ym = "\u8868\u683C\u8868\u5355", ws = "tableForm", Qm = {
  menu: "subform",
  icon: "icon-table-form",
  label: Ym,
  name: ws,
  children: "tableFormColumn",
  mask: !1,
  subForm: "array",
  event: ["change", "add", "delete"],
  loadRule(e) {
    e.props || (e.props = {});
    const o = e.props.columns || [];
    e.children = o.map((i) => ({
      type: "tableFormColumn",
      _fc_drag_tag: "tableFormColumn",
      props: {
        label: i.label,
        width: i.style.width || "",
        color: i.style.color || ""
      },
      children: i.rule || []
    })), delete e.props.columns;
  },
  parseRule(e) {
    const o = e.children || [];
    e.props.columns = o.map((i) => ({
      label: i.props.label,
      style: {
        width: i.props.width,
        color: i.props.color
      },
      rule: i.children || []
    })), e.children = [];
  },
  rule({ t: e }) {
    return {
      type: ws,
      field: We(),
      title: e("com.tableForm.name"),
      info: "",
      props: {},
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, ws + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "inputNumber",
        field: "max",
        props: { min: 0 }
      }
    ]);
  }
}, Km = "\u65E0\u9650\u7EA7\u8868\u5355", Al = "infiniteTableForm", Jm = {
  menu: "subform",
  icon: "icon-table-form3",
  label: Km,
  name: Al,
  children: "tableFormColumn",
  mask: !1,
  subForm: "array",
  event: ["change", "add", "delete"],
  loadRule(e) {
    e.props || (e.props = {});
    const o = e.props.columns || [];
    e.children = o.map((i) => ({
      type: "tableFormColumn",
      _fc_drag_tag: "tableFormColumn",
      props: {
        label: i.label,
        width: i.style.width || "",
        color: i.style.color || ""
      },
      children: i.rule || []
    })), delete e.props.columns;
  },
  parseRule(e) {
    const o = e.children || [];
    e.props.columns = o.map((i) => ({
      label: i.props.label,
      style: {
        width: i.props.width,
        color: i.props.color
      },
      rule: i.children || []
    })), e.children = [];
  },
  rule({ t: e }) {
    return {
      type: Al,
      field: We(),
      title: e("com." + Al + ".name"),
      info: "",
      props: {},
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, Al + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "input",
        field: "childrenField",
        value: "children"
      },
      {
        type: "inputNumber",
        field: "max",
        props: { min: 0 }
      },
      {
        type: "inputNumber",
        field: "layerMax",
        props: { min: 0 }
      }
    ]);
  }
}, Xm = "\u5D4C\u5957\u8868\u5355", Cl = "nestedTableForm", Zm = (e) => e.map((o) => ({
  type: "tableFormColumn",
  _fc_drag_tag: "tableFormColumn",
  props: {
    label: o.label,
    width: o.style.width || "",
    color: o.style.color || ""
  },
  children: o.rule || []
})), qm = {
  menu: "subform",
  icon: "icon-table-form2",
  label: Xm,
  name: Cl,
  children: "tableFormColumn",
  mask: !1,
  subForm: "array",
  event: ["change", "add", "delete"],
  slot: ["default", {
    name: "nested",
    type: "nestedSubTableForm"
  }],
  loadRule(e) {
    e.props || (e.props = {});
    const o = e.props.columns || [], i = e.props.nested || [];
    e.children = Zm(o), e.children.push({
      type: "TableForm",
      _fc_drag_tag: "nestedSubTableForm",
      field: e.props.nestedField,
      props: {
        columns: i
      },
      slot: "nested"
    }), delete e.props.nestedField, delete e.props.columns, delete e.props.nested;
  },
  parseRule(e) {
    const o = e.children || [];
    e.props.columns = [], o.forEach((i) => {
      if (i.slot === "nested") {
        e.props.nested = i.props.columns, e.props.nestedField = i.field;
        return;
      }
      e.props.columns.push({
        label: i.props.label,
        style: {
          width: i.props.width,
          color: i.props.color
        },
        rule: i.children || []
      });
    }), e.children = [];
  },
  rule({ t: e }) {
    return {
      type: Cl,
      field: We(),
      title: e("com." + Cl + ".name"),
      info: "",
      props: {},
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, Cl + ".props", [
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "inputNumber",
        field: "max",
        props: { min: 0 }
      },
      {
        type: "inputNumber",
        field: "nestedMax",
        props: { min: 0 }
      }
    ]);
  }
}, _m = "\u5B50\u8868\u683C\u8868\u5355", eg = "nestedSubTableForm", tg = {
  icon: "icon-table-form",
  label: _m,
  name: eg,
  children: "tableFormColumn",
  mask: !1,
  validate: !1,
  style: !1,
  advanced: !1,
  subForm: "array",
  hiddenBaseField: ["title", "info", "formCreateWrap>labelWidth", "formCreate_computed>hidden", "formCreate_computed>value", "_control"],
  loadRule(e) {
    e.props || (e.props = {});
    const o = e.props.columns || [];
    e.children = o.map((i) => ({
      type: "tableFormColumn",
      _fc_drag_tag: "tableFormColumn",
      props: {
        label: i.label,
        width: i.style.width || "",
        color: i.style.color || ""
      },
      children: i.rule || []
    })), delete e.props.columns;
  },
  parseRule(e) {
    const o = e.children || [];
    e.props.columns = o.map((i) => ({
      label: i.props.label,
      style: {
        width: i.props.width,
        color: i.props.color
      },
      rule: i.children || []
    })), e.children = [];
  },
  rule() {
    return {
      type: "TableForm",
      field: We(),
      title: "",
      info: "",
      props: {},
      children: []
    };
  },
  props() {
    return [];
  }
}, xs = "tableFormColumn", ng = {
  icon: "icon-cell",
  name: xs,
  drag: !0,
  dragBtn: !1,
  mask: !1,
  style: !1,
  advanced: !1,
  rule({ t: e }) {
    return {
      type: xs,
      props: {
        label: e("com.tableFormColumn.label"),
        width: "auto"
      },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, xs + ".props", [
      {
        type: "input",
        field: "label"
      },
      {
        type: "input",
        field: "width"
      },
      {
        type: "ColorInput",
        field: "color"
      }
    ]);
  }
}, rg = "\u76D2\u5B50\u5E03\u5C40", ig = "fcFlex", og = {
  menu: "layout",
  icon: "icon-flex",
  label: rg,
  name: ig,
  mask: !1,
  children: "fcCell",
  childrenLen: 2,
  rule() {
    return {
      type: "fcRow",
      props: {},
      children: []
    };
  },
  props() {
    return [];
  }
}, Df = "fcCell", lg = {
  name: Df,
  label: "\u683C\u5B50",
  drag: !0,
  dragBtn: !1,
  inside: !0,
  mask: !1,
  rule() {
    return {
      type: Df,
      children: []
    };
  },
  props() {
    return [];
  }
}, ag = "\u8BA1\u7B97\u516C\u5F0F", If = "fcValue", sg = {
  menu: "main",
  icon: "icon-value",
  label: ag,
  name: If,
  event: ["change"],
  validate: !1,
  rule({ t: e }) {
    return {
      type: If,
      field: We(),
      title: e("com.fcValue.name"),
      info: "",
      props: {}
    };
  },
  props() {
    return [];
  }
}, ug = "\u94FE\u63A5", Ts = "elLink", dg = {
  menu: "aide",
  icon: "icon-link",
  label: ug,
  name: Ts,
  rule({ t: e }) {
    return {
      type: Ts,
      title: "",
      native: !0,
      children: [e("com.elLink.name")]
    };
  },
  watch: {
    formCreateNative({ value: e, rule: o }) {
      e && (o.title = "");
    }
  },
  props(e, { t: o }) {
    return Qe(o, Ts + ".props", [
      {
        type: "switch",
        field: "formCreateNative",
        props: {
          activeValue: !1,
          inactiveValue: !0
        },
        control: [{ value: !1, rule: ["formCreateTitle"] }]
      },
      {
        type: "input",
        field: "formCreateTitle"
      },
      {
        type: "input",
        field: "href"
      },
      {
        type: "input",
        field: "formCreateChild"
      },
      {
        type: "select",
        field: "target",
        options: Ft(o, [
          { label: "_self", value: "_self" },
          { label: "_blank", value: "_blank" },
          { label: "_parent", value: "_parent" },
          { label: "_top", value: "_top" }
        ])
      },
      {
        type: "switch",
        field: "underline",
        value: !0
      },
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "select",
        field: "type",
        options: [
          { label: "primary", value: "primary" },
          { label: "success", value: "success" },
          { label: "warning", value: "warning" },
          { label: "danger", value: "danger" },
          { label: "info", value: "info" },
          { label: "default", value: "default" }
        ]
      }
    ]);
  }
}, fg = "\u6587\u5B57\u63D0\u793A", Sl = "elTooltip", cg = {
  menu: "aide",
  icon: "icon-tooltip",
  label: fg,
  name: Sl,
  drag: !0,
  dragBtn: !0,
  inside: !1,
  mask: !1,
  rule({ t: e }) {
    return {
      type: Sl,
      props: {
        content: e("com." + Sl + ".name")
      },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, Sl + ".props", [
      {
        type: "input",
        field: "content",
        props: { type: "textarea" }
      },
      {
        type: "switch",
        field: "disabled"
      },
      {
        type: "switch",
        field: "rawContent"
      },
      {
        type: "switch",
        field: "enterable",
        value: !0
      },
      {
        type: "select",
        field: "effect",
        value: "dark",
        options: [{ label: "dark", value: "dark" }, { label: "light", value: "light" }]
      },
      {
        type: "select",
        field: "placement",
        value: "bottom",
        options: [
          { label: "top", value: "top" },
          { label: "top-start", value: "top-start" },
          { label: "top-end", value: "top-end" },
          { label: "bottom", value: "bottom" },
          { label: "bottom-start", value: "bottom-start" },
          { label: "bottom-end", value: "bottom-end" },
          { label: "left", value: "left" },
          { label: "left-start", value: "left-start" },
          { label: "left-end", value: "left-end" },
          { label: "right", value: "right" },
          { label: "right-start", value: "right-start" },
          { label: "right-end", value: "right-end" }
        ]
      },
      {
        type: "select",
        field: "trigger",
        value: "hover",
        options: [
          { label: "hover", value: "hover" },
          { label: "click", value: "click" },
          { label: "focus", value: "focus" },
          { label: "contextmenu", value: "contextmenu" }
        ]
      },
      {
        type: "inputNumber",
        field: "offset"
      },
      {
        type: "inputNumber",
        field: "showAfter",
        props: {
          min: 0
        }
      },
      {
        type: "inputNumber",
        field: "hideAfter",
        props: {
          min: 0
        }
      },
      {
        type: "inputNumber",
        field: "autoClose",
        props: {
          min: 0
        }
      }
    ]);
  }
}, pg = "\u6C34\u5370", El = "elWatermark", hg = {
  menu: "aide",
  icon: "icon-watermark",
  label: pg,
  name: El,
  drag: !0,
  dragBtn: !0,
  inside: !1,
  mask: !1,
  rule({ t: e }) {
    return {
      type: El,
      style: {
        width: "100%"
      },
      props: {
        content: e("com." + El + ".name")
      },
      children: []
    };
  },
  props(e, { t: o }) {
    return Qe(o, El + ".props", [
      {
        type: "input",
        field: "content"
      },
      {
        type: "input",
        field: "image"
      },
      {
        type: "inputNumber",
        field: "width",
        props: {
          min: 0
        },
        value: 120
      },
      {
        type: "inputNumber",
        field: "height",
        props: {
          min: 0
        },
        value: 64
      },
      {
        type: "inputNumber",
        field: "rotate",
        value: -22
      },
      {
        type: "inputNumber",
        field: "zIndex",
        props: {
          min: 0
        }
      },
      {
        type: "TableOptions",
        field: "gap",
        props: {
          column: [{ label: o("props.value"), key: "value" }],
          valueType: "string",
          max: 2
        },
        value: [100, 100]
      }
    ]);
  }
}, vg = "\u91D1\u989D", mg = {
  menu: "template",
  name: "chineseAmount",
  label: vg,
  autoField: !0,
  template: [
    {
      type: "inputNumber",
      field: "Fgtxlugfgbdvb5c",
      title: "\u91D1\u989D",
      info: "",
      $required: !1,
      display: !0,
      hidden: !1,
      _fc_drag_tag: "inputNumber"
    },
    {
      type: "fcValue",
      field: "Fvr1lugfgd3yb7c",
      title: " ",
      info: "",
      display: !0,
      hidden: !1,
      _fc_drag_tag: "fcValue",
      style: {
        color: "#999999"
      },
      computed: {
        value: '"\u5927\u5199: " + TOCHINSESAMOUNT(Fgtxlugfgbdvb5c || 0)'
      }
    }
  ]
}, gg = "\u65F6\u957F", yg = {
  menu: "template",
  name: "duration",
  label: gg,
  autoField: !0,
  template: [
    {
      type: "fcRow",
      children: [
        {
          type: "fcCell",
          children: [
            {
              type: "datePicker",
              field: "Fl4bluvbythuanc",
              title: "\u5F00\u59CB\u65F6\u95F4",
              info: "",
              $required: !1,
              display: !0,
              hidden: !1,
              _fc_drag_tag: "datePicker",
              validate: [
                {
                  type: "validator",
                  trigger: "change",
                  validator: `[[FORM-CREATE-PREFIX-function validator(rule, value, callback){rule.inject.api.validateField('F2w2luvbythuapc');
callback();}-FORM-CREATE-SUFFIX]]`,
                  mode: "min",
                  message: ""
                }
              ]
            }
          ],
          display: !0,
          hidden: !1,
          _fc_drag_tag: "fcCell",
          style: {
            width: "400px"
          }
        },
        {
          type: "fcCell",
          children: [
            {
              type: "select",
              field: "Fg3aluvbythuaoc",
              title: "",
              info: "",
              effect: {
                fetch: ""
              },
              $required: !1,
              options: [
                {
                  label: "\u4E0A\u5348",
                  value: "1"
                },
                {
                  label: "\u4E0B\u5348",
                  value: "1.5"
                }
              ],
              display: !0,
              hidden: !1,
              _fc_drag_tag: "select"
            }
          ],
          display: !0,
          hidden: !1,
          _fc_drag_tag: "fcCell",
          style: {
            paddingLeft: "10px",
            width: "150px"
          }
        }
      ],
      display: !0,
      hidden: !1,
      _fc_drag_tag: "fcFlex"
    },
    {
      type: "fcRow",
      children: [
        {
          type: "fcCell",
          children: [
            {
              type: "datePicker",
              field: "F2w2luvbythuapc",
              title: "\u7ED3\u675F\u65F6\u95F4",
              info: "",
              display: !0,
              hidden: !1,
              $required: !1,
              _fc_drag_tag: "datePicker",
              validate: [
                {
                  type: "validator",
                  trigger: "change",
                  validator: `[[FORM-CREATE-PREFIX-function validator(rule, value, callback){let startTime = rule.inject.api.getValue('Fl4bluvbythuanc');
if(startTime && value && Date.parse(startTime) > Date.parse(value)) {
	callback(false);
  return;
}
callback()}-FORM-CREATE-SUFFIX]]`,
                  mode: "min",
                  message: "\u5F00\u59CB\u65F6\u95F4\u4E0D\u80FD\u5927\u4E8E\u7ED3\u675F\u65F6\u95F4"
                }
              ]
            }
          ],
          display: !0,
          hidden: !1,
          _fc_drag_tag: "fcCell",
          style: {
            width: "400px"
          }
        },
        {
          type: "fcCell",
          children: [
            {
              type: "select",
              field: "Fq7zluvbythuaqc",
              title: "",
              info: "",
              effect: {
                fetch: ""
              },
              $required: !1,
              options: [
                {
                  label: "\u4E0A\u5348",
                  value: "1"
                },
                {
                  label: "\u4E0B\u5348",
                  value: "1.5"
                }
              ],
              display: !0,
              hidden: !1,
              _fc_drag_tag: "select"
            }
          ],
          display: !0,
          hidden: !1,
          _fc_drag_tag: "fcCell",
          style: {
            paddingLeft: "10px",
            width: "150px"
          }
        }
      ],
      display: !0,
      hidden: !1,
      _fc_drag_tag: "fcFlex"
    },
    {
      type: "fcRow",
      children: [
        {
          type: "fcCell",
          children: [
            {
              type: "inputNumber",
              field: "F8m2luvbythuarc",
              title: "\u65F6\u957F",
              info: "",
              $required: !1,
              props: {
                controls: !1
              },
              display: !0,
              hidden: !1,
              _fc_drag_tag: "inputNumber",
              computed: {
                value: "MAX(IF(Fl4bluvbythuanc && F2w2luvbythuapc && TIMESTAMP(F2w2luvbythuapc) > TIMESTAMP(Fl4bluvbythuanc), DIFFDAYS(Fl4bluvbythuanc, F2w2luvbythuapc), -1) + IF(Fq7zluvbythuaqc && Fg3aluvbythuaoc, Fq7zluvbythuaqc - Fg3aluvbythuaoc + 0.5, 0), 0);"
              }
            }
          ],
          display: !0,
          hidden: !1,
          _fc_drag_tag: "fcCell",
          style: {
            width: "400px"
          }
        },
        {
          type: "fcCell",
          display: !0,
          hidden: !1,
          _fc_drag_tag: "fcCell",
          style: {
            paddingLeft: "10px",
            width: "30px"
          },
          children: [
            {
              type: "text",
              title: "",
              native: !0,
              children: [
                "\u5929"
              ],
              display: !0,
              hidden: !1,
              _fc_drag_tag: "text"
            }
          ]
        }
      ],
      display: !0,
      hidden: !1,
      _fc_drag_tag: "fcFlex",
      style: {
        display: "flex",
        alignItems: "baseline"
      }
    }
  ]
}, bg = "\u4E09\u5217\u6805\u683C", Ag = {
  menu: "template",
  name: "col3",
  label: bg,
  autoField: !1,
  template: [
    {
      type: "fcRow",
      children: [
        {
          type: "col",
          props: {
            span: 8
          },
          display: !0,
          hidden: !1,
          _fc_drag_tag: "col"
        },
        {
          type: "col",
          props: {
            span: 8
          },
          display: !0,
          hidden: !1,
          _fc_drag_tag: "col"
        },
        {
          type: "col",
          props: {
            span: 8
          },
          display: !0,
          hidden: !1,
          _fc_drag_tag: "col"
        }
      ],
      display: !0,
      hidden: !1,
      _fc_drag_tag: "fcRow"
    }
  ]
}, Cg = "\u56DB\u5217\u6805\u683C", Sg = {
  menu: "template",
  name: "col4",
  label: Cg,
  autoField: !1,
  template: [
    {
      type: "fcRow",
      children: [
        {
          type: "col",
          props: {
            span: 6
          },
          display: !0,
          hidden: !1,
          _fc_drag_tag: "col"
        },
        {
          type: "col",
          props: {
            span: 6
          },
          display: !0,
          hidden: !1,
          _fc_drag_tag: "col"
        },
        {
          type: "col",
          props: {
            span: 6
          },
          display: !0,
          hidden: !1,
          _fc_drag_tag: "col"
        },
        {
          type: "col",
          props: {
            span: 6
          },
          display: !0,
          hidden: !1,
          _fc_drag_tag: "col"
        }
      ],
      display: !0,
      hidden: !1,
      _fc_drag_tag: "fcRow"
    }
  ]
}, Eg = "\u56DB\u884C\u4E09\u5217\u8868\u683C", wg = {
  menu: "template",
  name: "table43",
  label: Eg,
  autoField: !1,
  template: [
    {
      type: "fcTable",
      props: {
        rule: {
          row: 4,
          col: 3,
          style: {},
          class: {},
          layout: []
        }
      },
      display: !0,
      hidden: !1,
      _fc_drag_tag: "fcTable"
    }
  ]
}, xg = [
  bv,
  Cv,
  Ev,
  xv,
  vv,
  gv,
  Dv,
  Rv,
  zv,
  Nv,
  $v,
  Mv,
  kv,
  Uv,
  Gv,
  em,
  nm,
  im,
  lm,
  Mm,
  bm,
  Cm,
  Em,
  Hm,
  sg,
  Qm,
  ng,
  qm,
  tg,
  Jm,
  sm,
  gm,
  dm,
  zm,
  qv,
  Nm,
  dg,
  cg,
  hg,
  Qv,
  Gm,
  og,
  lg,
  vm,
  pm,
  xm,
  Dm,
  Bm,
  Ag,
  Sg,
  wg,
  mg,
  yg,
  Kv,
  Xv,
  Rm,
  Pm,
  Um
];
function Tg(e) {
  return {
    icon: e.field ? "icon-input" : "icon-cell",
    label: e.field || e.type,
    name: "_",
    mask: !0,
    handleBtn: ["delete"],
    rule() {
      return e;
    },
    props() {
      return [];
    }
  };
}
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Rf(e, o) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    o && (l = l.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), i.push.apply(i, l);
  }
  return i;
}
function er(e) {
  for (var o = 1; o < arguments.length; o++) {
    var i = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Rf(Object(i), !0).forEach(function (l) {
      Dg(e, l, i[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Rf(Object(i)).forEach(function (l) {
      Object.defineProperty(e, l, Object.getOwnPropertyDescriptor(i, l));
    });
  }
  return e;
}
function Ol(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ol = function (o) {
    return typeof o;
  } : Ol = function (o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Ol(e);
}
function Dg(e, o, i) {
  return o in e ? Object.defineProperty(e, o, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = i, e;
}
function hr() {
  return hr = Object.assign || function (e) {
    for (var o = 1; o < arguments.length; o++) {
      var i = arguments[o];
      for (var l in i)
        Object.prototype.hasOwnProperty.call(i, l) && (e[l] = i[l]);
    }
    return e;
  }, hr.apply(this, arguments);
}
function Ig(e, o) {
  if (e == null)
    return {};
  var i = {}, l = Object.keys(e), n, u;
  for (u = 0; u < l.length; u++)
    n = l[u], !(o.indexOf(n) >= 0) && (i[n] = e[n]);
  return i;
}
function Rg(e, o) {
  if (e == null)
    return {};
  var i = Ig(e, o), l, n;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (n = 0; n < u.length; n++)
      l = u[n], !(o.indexOf(l) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, l) || (i[l] = e[l]));
  }
  return i;
}
var Fg = "1.14.0";
function pr(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var vr = pr(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), No = pr(/Edge/i), Ff = pr(/firefox/i), wo = pr(/safari/i) && !pr(/chrome/i) && !pr(/android/i), ac = pr(/iP(ad|od|hone)/i), Mg = pr(/chrome/i) && pr(/android/i), sc = {
  capture: !1,
  passive: !1
};
function mt(e, o, i) {
  e.addEventListener(o, i, !vr && sc);
}
function dt(e, o, i) {
  e.removeEventListener(o, i, !vr && sc);
}
function Bl(e, o) {
  if (!!o) {
    if (o[0] === ">" && (o = o.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(o);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(o);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(o);
      } catch {
        return !1;
      }
    return !1;
  }
}
function Og(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function Xn(e, o, i, l) {
  if (e) {
    i = i || document;
    do {
      if (o != null && (o[0] === ">" ? e.parentNode === i && Bl(e, o) : Bl(e, o)) || l && e === i)
        return e;
      if (e === i)
        break;
    } while (e = Og(e));
  }
  return null;
}
var Mf = /\s+/g;
function wn(e, o, i) {
  if (e && o)
    if (e.classList)
      e.classList[i ? "add" : "remove"](o);
    else {
      var l = (" " + e.className + " ").replace(Mf, " ").replace(" " + o + " ", " ");
      e.className = (l + (i ? " " + o : "")).replace(Mf, " ");
    }
}
function Ke(e, o, i) {
  var l = e && e.style;
  if (l) {
    if (i === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? i = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (i = e.currentStyle), o === void 0 ? i : i[o];
    !(o in l) && o.indexOf("webkit") === -1 && (o = "-webkit-" + o), l[o] = i + (typeof i == "string" ? "" : "px");
  }
}
function Li(e, o) {
  var i = "";
  if (typeof e == "string")
    i = e;
  else
    do {
      var l = Ke(e, "transform");
      l && l !== "none" && (i = l + " " + i);
    } while (!o && (e = e.parentNode));
  var n = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return n && new n(i);
}
function uc(e, o, i) {
  if (e) {
    var l = e.getElementsByTagName(o), n = 0, u = l.length;
    if (i)
      for (; n < u; n++)
        i(l[n], n);
    return l;
  }
  return [];
}
function qn() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function Kt(e, o, i, l, n) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var u, f, p, c, v, b, y;
    if (e !== window && e.parentNode && e !== qn() ? (u = e.getBoundingClientRect(), f = u.top, p = u.left, c = u.bottom, v = u.right, b = u.height, y = u.width) : (f = 0, p = 0, c = window.innerHeight, v = window.innerWidth, b = window.innerHeight, y = window.innerWidth), (o || i) && e !== window && (n = n || e.parentNode, !vr))
      do
        if (n && n.getBoundingClientRect && (Ke(n, "transform") !== "none" || i && Ke(n, "position") !== "static")) {
          var E = n.getBoundingClientRect();
          f -= E.top + parseInt(Ke(n, "border-top-width")), p -= E.left + parseInt(Ke(n, "border-left-width")), c = f + u.height, v = p + u.width;
          break;
        }
      while (n = n.parentNode);
    if (l && e !== window) {
      var w = Li(n || e), h = w && w.a, m = w && w.d;
      w && (f /= m, p /= h, y /= h, b /= m, c = f + b, v = p + y);
    }
    return {
      top: f,
      left: p,
      bottom: c,
      right: v,
      width: y,
      height: b
    };
  }
}
function Of(e, o, i) {
  for (var l = Br(e, !0), n = Kt(e)[o]; l;) {
    var u = Kt(l)[i], f = void 0;
    if (i === "top" || i === "left" ? f = n >= u : f = n <= u, !f)
      return l;
    if (l === qn())
      break;
    l = Br(l, !1);
  }
  return !1;
}
function Pi(e, o, i, l) {
  for (var n = 0, u = 0, f = e.children; u < f.length;) {
    if (f[u].style.display !== "none" && f[u] !== Je.ghost && (l || f[u] !== Je.dragged) && Xn(f[u], i.draggable, e, !1)) {
      if (n === o)
        return f[u];
      n++;
    }
    u++;
  }
  return null;
}
function eu(e, o) {
  for (var i = e.lastElementChild; i && (i === Je.ghost || Ke(i, "display") === "none" || o && !Bl(i, o));)
    i = i.previousElementSibling;
  return i || null;
}
function Mn(e, o) {
  var i = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling;)
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== Je.clone && (!o || Bl(e, o)) && i++;
  return i;
}
function Nf(e) {
  var o = 0, i = 0, l = qn();
  if (e)
    do {
      var n = Li(e), u = n.a, f = n.d;
      o += e.scrollLeft * u, i += e.scrollTop * f;
    } while (e !== l && (e = e.parentNode));
  return [o, i];
}
function Ng(e, o) {
  for (var i in e)
    if (!!e.hasOwnProperty(i)) {
      for (var l in o)
        if (o.hasOwnProperty(l) && o[l] === e[i][l])
          return Number(i);
    }
  return -1;
}
function Br(e, o) {
  if (!e || !e.getBoundingClientRect)
    return qn();
  var i = e, l = !1;
  do
    if (i.clientWidth < i.scrollWidth || i.clientHeight < i.scrollHeight) {
      var n = Ke(i);
      if (i.clientWidth < i.scrollWidth && (n.overflowX == "auto" || n.overflowX == "scroll") || i.clientHeight < i.scrollHeight && (n.overflowY == "auto" || n.overflowY == "scroll")) {
        if (!i.getBoundingClientRect || i === document.body)
          return qn();
        if (l || o)
          return i;
        l = !0;
      }
    }
  while (i = i.parentNode);
  return qn();
}
function Lg(e, o) {
  if (e && o)
    for (var i in o)
      o.hasOwnProperty(i) && (e[i] = o[i]);
  return e;
}
function Ds(e, o) {
  return Math.round(e.top) === Math.round(o.top) && Math.round(e.left) === Math.round(o.left) && Math.round(e.height) === Math.round(o.height) && Math.round(e.width) === Math.round(o.width);
}
var xo;
function dc(e, o) {
  return function () {
    if (!xo) {
      var i = arguments, l = this;
      i.length === 1 ? e.call(l, i[0]) : e.apply(l, i), xo = setTimeout(function () {
        xo = void 0;
      }, o);
    }
  };
}
function Pg() {
  clearTimeout(xo), xo = void 0;
}
function fc(e, o, i) {
  e.scrollLeft += o, e.scrollTop += i;
}
function cc(e) {
  var o = window.Polymer, i = window.jQuery || window.Zepto;
  return o && o.dom ? o.dom(e).cloneNode(!0) : i ? i(e).clone(!0)[0] : e.cloneNode(!0);
}
var Tn = "Sortable" + new Date().getTime();
function $g() {
  var e = [], o;
  return {
    captureAnimationState: function () {
      if (e = [], !!this.options.animation) {
        var l = [].slice.call(this.el.children);
        l.forEach(function (n) {
          if (!(Ke(n, "display") === "none" || n === Je.ghost)) {
            e.push({
              target: n,
              rect: Kt(n)
            });
            var u = er({}, e[e.length - 1].rect);
            if (n.thisAnimationDuration) {
              var f = Li(n, !0);
              f && (u.top -= f.f, u.left -= f.e);
            }
            n.fromRect = u;
          }
        });
      }
    },
    addAnimationState: function (l) {
      e.push(l);
    },
    removeAnimationState: function (l) {
      e.splice(Ng(e, {
        target: l
      }), 1);
    },
    animateAll: function (l) {
      var n = this;
      if (!this.options.animation) {
        clearTimeout(o), typeof l == "function" && l();
        return;
      }
      var u = !1, f = 0;
      e.forEach(function (p) {
        var c = 0, v = p.target, b = v.fromRect, y = Kt(v), E = v.prevFromRect, w = v.prevToRect, h = p.rect, m = Li(v, !0);
        m && (y.top -= m.f, y.left -= m.e), v.toRect = y, v.thisAnimationDuration && Ds(E, y) && !Ds(b, y) && (h.top - y.top) / (h.left - y.left) === (b.top - y.top) / (b.left - y.left) && (c = kg(h, E, w, n.options)), Ds(y, b) || (v.prevFromRect = b, v.prevToRect = y, c || (c = n.options.animation), n.animate(v, h, y, c)), c && (u = !0, f = Math.max(f, c), clearTimeout(v.animationResetTimer), v.animationResetTimer = setTimeout(function () {
          v.animationTime = 0, v.prevFromRect = null, v.fromRect = null, v.prevToRect = null, v.thisAnimationDuration = null;
        }, c), v.thisAnimationDuration = c);
      }), clearTimeout(o), u ? o = setTimeout(function () {
        typeof l == "function" && l();
      }, f) : typeof l == "function" && l(), e = [];
    },
    animate: function (l, n, u, f) {
      if (f) {
        Ke(l, "transition", ""), Ke(l, "transform", "");
        var p = Li(this.el), c = p && p.a, v = p && p.d, b = (n.left - u.left) / (c || 1), y = (n.top - u.top) / (v || 1);
        l.animatingX = !!b, l.animatingY = !!y, Ke(l, "transform", "translate3d(" + b + "px," + y + "px,0)"), this.forRepaintDummy = Bg(l), Ke(l, "transition", "transform " + f + "ms" + (this.options.easing ? " " + this.options.easing : "")), Ke(l, "transform", "translate3d(0,0,0)"), typeof l.animated == "number" && clearTimeout(l.animated), l.animated = setTimeout(function () {
          Ke(l, "transition", ""), Ke(l, "transform", ""), l.animated = !1, l.animatingX = !1, l.animatingY = !1;
        }, f);
      }
    }
  };
}
function Bg(e) {
  return e.offsetWidth;
}
function kg(e, o, i, l) {
  return Math.sqrt(Math.pow(o.top - e.top, 2) + Math.pow(o.left - e.left, 2)) / Math.sqrt(Math.pow(o.top - i.top, 2) + Math.pow(o.left - i.left, 2)) * l.animation;
}
var Di = [], Is = {
  initializeByDefault: !0
}, Lo = {
  mount: function (o) {
    for (var i in Is)
      Is.hasOwnProperty(i) && !(i in o) && (o[i] = Is[i]);
    Di.forEach(function (l) {
      if (l.pluginName === o.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(o.pluginName, " more than once");
    }), Di.push(o);
  },
  pluginEvent: function (o, i, l) {
    var n = this;
    this.eventCanceled = !1, l.cancel = function () {
      n.eventCanceled = !0;
    };
    var u = o + "Global";
    Di.forEach(function (f) {
      !i[f.pluginName] || (i[f.pluginName][u] && i[f.pluginName][u](er({
        sortable: i
      }, l)), i.options[f.pluginName] && i[f.pluginName][o] && i[f.pluginName][o](er({
        sortable: i
      }, l)));
    });
  },
  initializePlugins: function (o, i, l, n) {
    Di.forEach(function (p) {
      var c = p.pluginName;
      if (!(!o.options[c] && !p.initializeByDefault)) {
        var v = new p(o, i, o.options);
        v.sortable = o, v.options = o.options, o[c] = v, hr(l, v.defaults);
      }
    });
    for (var u in o.options)
      if (!!o.options.hasOwnProperty(u)) {
        var f = this.modifyOption(o, u, o.options[u]);
        typeof f < "u" && (o.options[u] = f);
      }
  },
  getEventProperties: function (o, i) {
    var l = {};
    return Di.forEach(function (n) {
      typeof n.eventProperties == "function" && hr(l, n.eventProperties.call(i[n.pluginName], o));
    }), l;
  },
  modifyOption: function (o, i, l) {
    var n;
    return Di.forEach(function (u) {
      !o[u.pluginName] || u.optionListeners && typeof u.optionListeners[i] == "function" && (n = u.optionListeners[i].call(o[u.pluginName], l));
    }), n;
  }
};
function Hg(e) {
  var o = e.sortable, i = e.rootEl, l = e.name, n = e.targetEl, u = e.cloneEl, f = e.toEl, p = e.fromEl, c = e.oldIndex, v = e.newIndex, b = e.oldDraggableIndex, y = e.newDraggableIndex, E = e.originalEvent, w = e.putSortable, h = e.extraEventProperties;
  if (o = o || i && i[Tn], !!o) {
    var m, I = o.options, D = "on" + l.charAt(0).toUpperCase() + l.substr(1);
    window.CustomEvent && !vr && !No ? m = new CustomEvent(l, {
      bubbles: !0,
      cancelable: !0
    }) : (m = document.createEvent("Event"), m.initEvent(l, !0, !0)), m.to = f || i, m.from = p || i, m.item = n || i, m.clone = u, m.oldIndex = c, m.newIndex = v, m.oldDraggableIndex = b, m.newDraggableIndex = y, m.originalEvent = E, m.pullMode = w ? w.lastPutMode : void 0;
    var g = er(er({}, h), Lo.getEventProperties(l, o));
    for (var S in g)
      m[S] = g[S];
    i && i.dispatchEvent(m), I[D] && I[D].call(o, m);
  }
}
var Vg = ["evt"], yn = function (o, i) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = l.evt, u = Rg(l, Vg);
  Lo.pluginEvent.bind(Je)(o, i, er({
    dragEl: Ie,
    parentEl: Ot,
    ghostEl: nt,
    rootEl: Dt,
    nextEl: ei,
    lastDownEl: Nl,
    cloneEl: Nt,
    cloneHidden: Pr,
    dragStarted: bo,
    putSortable: qt,
    activeSortable: Je.active,
    originalEvent: n,
    oldIndex: Ni,
    oldDraggableIndex: To,
    newIndex: xn,
    newDraggableIndex: Lr,
    hideGhostForTarget: mc,
    unhideGhostForTarget: gc,
    cloneNowHidden: function () {
      Pr = !0;
    },
    cloneNowShown: function () {
      Pr = !1;
    },
    dispatchSortableEvent: function (p) {
      cn({
        sortable: i,
        name: p,
        originalEvent: n
      });
    }
  }, u));
};
function cn(e) {
  Hg(er({
    putSortable: qt,
    cloneEl: Nt,
    targetEl: Ie,
    rootEl: Dt,
    oldIndex: Ni,
    oldDraggableIndex: To,
    newIndex: xn,
    newDraggableIndex: Lr
  }, e));
}
var Ie, Ot, nt, Dt, ei, Nl, Nt, Pr, Ni, xn, To, Lr, wl, qt, Mi = !1, kl = !1, Hl = [], qr, Hn, Rs, Fs, Lf, Pf, bo, Ii, Do, Io = !1, xl = !1, Ll, rn, Ms = [], zs = !1, Vl = [], Ql = typeof document < "u", Tl = ac, $f = No || vr ? "cssFloat" : "float", Ug = Ql && !Mg && !ac && "draggable" in document.createElement("div"), pc = function () {
  if (!!Ql) {
    if (vr)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), hc = function (o, i) {
  var l = Ke(o), n = parseInt(l.width) - parseInt(l.paddingLeft) - parseInt(l.paddingRight) - parseInt(l.borderLeftWidth) - parseInt(l.borderRightWidth), u = Pi(o, 0, i), f = Pi(o, 1, i), p = u && Ke(u), c = f && Ke(f), v = p && parseInt(p.marginLeft) + parseInt(p.marginRight) + Kt(u).width, b = c && parseInt(c.marginLeft) + parseInt(c.marginRight) + Kt(f).width;
  if (l.display === "flex")
    return l.flexDirection === "column" || l.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (l.display === "grid")
    return l.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (u && p.float && p.float !== "none") {
    var y = p.float === "left" ? "left" : "right";
    return f && (c.clear === "both" || c.clear === y) ? "vertical" : "horizontal";
  }
  return u && (p.display === "block" || p.display === "flex" || p.display === "table" || p.display === "grid" || v >= n && l[$f] === "none" || f && l[$f] === "none" && v + b > n) ? "vertical" : "horizontal";
}, jg = function (o, i, l) {
  var n = l ? o.left : o.top, u = l ? o.right : o.bottom, f = l ? o.width : o.height, p = l ? i.left : i.top, c = l ? i.right : i.bottom, v = l ? i.width : i.height;
  return n === p || u === c || n + f / 2 === p + v / 2;
}, zg = function (o, i) {
  var l;
  return Hl.some(function (n) {
    var u = n[Tn].options.emptyInsertThreshold;
    if (!(!u || eu(n))) {
      var f = Kt(n), p = o >= f.left - u && o <= f.right + u, c = i >= f.top - u && i <= f.bottom + u;
      if (p && c)
        return l = n;
    }
  }), l;
}, vc = function (o) {
  function i(u, f) {
    return function (p, c, v, b) {
      var y = p.options.group.name && c.options.group.name && p.options.group.name === c.options.group.name;
      if (u == null && (f || y))
        return !0;
      if (u == null || u === !1)
        return !1;
      if (f && u === "clone")
        return u;
      if (typeof u == "function")
        return i(u(p, c, v, b), f)(p, c, v, b);
      var E = (f ? p : c).options.group.name;
      return u === !0 || typeof u == "string" && u === E || u.join && u.indexOf(E) > -1;
    };
  }
  var l = {}, n = o.group;
  (!n || Ol(n) != "object") && (n = {
    name: n
  }), l.name = n.name, l.checkPull = i(n.pull, !0), l.checkPut = i(n.put), l.revertClone = n.revertClone, o.group = l;
}, mc = function () {
  !pc && nt && Ke(nt, "display", "none");
}, gc = function () {
  !pc && nt && Ke(nt, "display", "");
};
Ql && document.addEventListener("click", function (e) {
  if (kl)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), kl = !1, !1;
}, !0);
var _r = function (o) {
  if (Ie) {
    o = o.touches ? o.touches[0] : o;
    var i = zg(o.clientX, o.clientY);
    if (i) {
      var l = {};
      for (var n in o)
        o.hasOwnProperty(n) && (l[n] = o[n]);
      l.target = l.rootEl = i, l.preventDefault = void 0, l.stopPropagation = void 0, i[Tn]._onDragOver(l);
    }
  }
}, Wg = function (o) {
  Ie && Ie.parentNode[Tn]._isOutsideThisEl(o.target);
};
function Je(e, o) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = o = hr({}, o), e[Tn] = this;
  var i = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: !1,
    invertedSwapThreshold: null,
    removeCloneOnHide: !0,
    direction: function () {
      return hc(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function (f, p) {
      f.setData("Text", p.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Je.supportPointer !== !1 && "PointerEvent" in window && !wo,
    emptyInsertThreshold: 5
  };
  Lo.initializePlugins(this, e, i);
  for (var l in i)
    !(l in o) && (o[l] = i[l]);
  vc(o);
  for (var n in this)
    n.charAt(0) === "_" && typeof this[n] == "function" && (this[n] = this[n].bind(this));
  this.nativeDraggable = o.forceFallback ? !1 : Ug, this.nativeDraggable && (this.options.touchStartThreshold = 1), o.supportPointer ? mt(e, "pointerdown", this._onTapStart) : (mt(e, "mousedown", this._onTapStart), mt(e, "touchstart", this._onTapStart)), this.nativeDraggable && (mt(e, "dragover", this), mt(e, "dragenter", this)), Hl.push(this.el), o.store && o.store.get && this.sort(o.store.get(this) || []), hr(this, $g());
}
Je.prototype = {
  constructor: Je,
  _isOutsideThisEl: function (o) {
    !this.el.contains(o) && o !== this.el && (Ii = null);
  },
  _getDirection: function (o, i) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, o, i, Ie) : this.options.direction;
  },
  _onTapStart: function (o) {
    if (!!o.cancelable) {
      var i = this, l = this.el, n = this.options, u = n.preventOnFilter, f = o.type, p = o.touches && o.touches[0] || o.pointerType && o.pointerType === "touch" && o, c = (p || o).target, v = o.target.shadowRoot && (o.path && o.path[0] || o.composedPath && o.composedPath()[0]) || c, b = n.filter;
      if (qg(l), !Ie && !(/mousedown|pointerdown/.test(f) && o.button !== 0 || n.disabled) && !v.isContentEditable && !(!this.nativeDraggable && wo && c && c.tagName.toUpperCase() === "SELECT") && (c = Xn(c, n.draggable, l, !1), !(c && c.animated) && Nl !== c)) {
        if (Ni = Mn(c), To = Mn(c, n.draggable), typeof b == "function") {
          if (b.call(this, o, c, this)) {
            cn({
              sortable: i,
              rootEl: v,
              name: "filter",
              targetEl: c,
              toEl: l,
              fromEl: l
            }), yn("filter", i, {
              evt: o
            }), u && o.cancelable && o.preventDefault();
            return;
          }
        } else if (b && (b = b.split(",").some(function (y) {
          if (y = Xn(v, y.trim(), l, !1), y)
            return cn({
              sortable: i,
              rootEl: y,
              name: "filter",
              targetEl: c,
              fromEl: l,
              toEl: l
            }), yn("filter", i, {
              evt: o
            }), !0;
        }), b)) {
          u && o.cancelable && o.preventDefault();
          return;
        }
        n.handle && !Xn(v, n.handle, l, !1) || this._prepareDragStart(o, p, c);
      }
    }
  },
  _prepareDragStart: function (o, i, l) {
    var n = this, u = n.el, f = n.options, p = u.ownerDocument, c;
    if (l && !Ie && l.parentNode === u) {
      var v = Kt(l);
      if (Dt = u, Ie = l, Ot = Ie.parentNode, ei = Ie.nextSibling, Nl = l, wl = f.group, Je.dragged = Ie, qr = {
        target: Ie,
        clientX: (i || o).clientX,
        clientY: (i || o).clientY
      }, Lf = qr.clientX - v.left, Pf = qr.clientY - v.top, this._lastX = (i || o).clientX, this._lastY = (i || o).clientY, Ie.style["will-change"] = "all", c = function () {
        if (yn("delayEnded", n, {
          evt: o
        }), Je.eventCanceled) {
          n._onDrop();
          return;
        }
        n._disableDelayedDragEvents(), !Ff && n.nativeDraggable && (Ie.draggable = !0), n._triggerDragStart(o, i), cn({
          sortable: n,
          name: "choose",
          originalEvent: o
        }), wn(Ie, f.chosenClass, !0);
      }, f.ignore.split(",").forEach(function (b) {
        uc(Ie, b.trim(), Os);
      }), mt(p, "dragover", _r), mt(p, "mousemove", _r), mt(p, "touchmove", _r), mt(p, "mouseup", n._onDrop), mt(p, "touchend", n._onDrop), mt(p, "touchcancel", n._onDrop), Ff && this.nativeDraggable && (this.options.touchStartThreshold = 4, Ie.draggable = !0), yn("delayStart", this, {
        evt: o
      }), f.delay && (!f.delayOnTouchOnly || i) && (!this.nativeDraggable || !(No || vr))) {
        if (Je.eventCanceled) {
          this._onDrop();
          return;
        }
        mt(p, "mouseup", n._disableDelayedDrag), mt(p, "touchend", n._disableDelayedDrag), mt(p, "touchcancel", n._disableDelayedDrag), mt(p, "mousemove", n._delayedDragTouchMoveHandler), mt(p, "touchmove", n._delayedDragTouchMoveHandler), f.supportPointer && mt(p, "pointermove", n._delayedDragTouchMoveHandler), n._dragStartTimer = setTimeout(c, f.delay);
      } else
        c();
    }
  },
  _delayedDragTouchMoveHandler: function (o) {
    var i = o.touches ? o.touches[0] : o;
    Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function () {
    Ie && Os(Ie), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function () {
    var o = this.el.ownerDocument;
    dt(o, "mouseup", this._disableDelayedDrag), dt(o, "touchend", this._disableDelayedDrag), dt(o, "touchcancel", this._disableDelayedDrag), dt(o, "mousemove", this._delayedDragTouchMoveHandler), dt(o, "touchmove", this._delayedDragTouchMoveHandler), dt(o, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function (o, i) {
    i = i || o.pointerType == "touch" && o, !this.nativeDraggable || i ? this.options.supportPointer ? mt(document, "pointermove", this._onTouchMove) : i ? mt(document, "touchmove", this._onTouchMove) : mt(document, "mousemove", this._onTouchMove) : (mt(Ie, "dragend", this), mt(Dt, "dragstart", this._onDragStart));
    try {
      document.selection ? Pl(function () {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function (o, i) {
    if (Mi = !1, Dt && Ie) {
      yn("dragStarted", this, {
        evt: i
      }), this.nativeDraggable && mt(document, "dragover", Wg);
      var l = this.options;
      !o && wn(Ie, l.dragClass, !1), wn(Ie, l.ghostClass, !0), Je.active = this, o && this._appendGhost(), cn({
        sortable: this,
        name: "start",
        originalEvent: i
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function () {
    if (Hn) {
      this._lastX = Hn.clientX, this._lastY = Hn.clientY, mc();
      for (var o = document.elementFromPoint(Hn.clientX, Hn.clientY), i = o; o && o.shadowRoot && (o = o.shadowRoot.elementFromPoint(Hn.clientX, Hn.clientY), o !== i);)
        i = o;
      if (Ie.parentNode[Tn]._isOutsideThisEl(o), i)
        do {
          if (i[Tn]) {
            var l = void 0;
            if (l = i[Tn]._onDragOver({
              clientX: Hn.clientX,
              clientY: Hn.clientY,
              target: o,
              rootEl: i
            }), l && !this.options.dragoverBubble)
              break;
          }
          o = i;
        } while (i = i.parentNode);
      gc();
    }
  },
  _onTouchMove: function (o) {
    if (qr) {
      var i = this.options, l = i.fallbackTolerance, n = i.fallbackOffset, u = o.touches ? o.touches[0] : o, f = nt && Li(nt, !0), p = nt && f && f.a, c = nt && f && f.d, v = Tl && rn && Nf(rn), b = (u.clientX - qr.clientX + n.x) / (p || 1) + (v ? v[0] - Ms[0] : 0) / (p || 1), y = (u.clientY - qr.clientY + n.y) / (c || 1) + (v ? v[1] - Ms[1] : 0) / (c || 1);
      if (!Je.active && !Mi) {
        if (l && Math.max(Math.abs(u.clientX - this._lastX), Math.abs(u.clientY - this._lastY)) < l)
          return;
        this._onDragStart(o, !0);
      }
      if (nt) {
        f ? (f.e += b - (Rs || 0), f.f += y - (Fs || 0)) : f = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: b,
          f: y
        };
        var E = "matrix(".concat(f.a, ",").concat(f.b, ",").concat(f.c, ",").concat(f.d, ",").concat(f.e, ",").concat(f.f, ")");
        Ke(nt, "webkitTransform", E), Ke(nt, "mozTransform", E), Ke(nt, "msTransform", E), Ke(nt, "transform", E), Rs = b, Fs = y, Hn = u;
      }
      o.cancelable && o.preventDefault();
    }
  },
  _appendGhost: function () {
    if (!nt) {
      var o = this.options.fallbackOnBody ? document.body : Dt, i = Kt(Ie, !0, Tl, !0, o), l = this.options;
      if (Tl) {
        for (rn = o; Ke(rn, "position") === "static" && Ke(rn, "transform") === "none" && rn !== document;)
          rn = rn.parentNode;
        rn !== document.body && rn !== document.documentElement ? (rn === document && (rn = qn()), i.top += rn.scrollTop, i.left += rn.scrollLeft) : rn = qn(), Ms = Nf(rn);
      }
      nt = Ie.cloneNode(!0), wn(nt, l.ghostClass, !1), wn(nt, l.fallbackClass, !0), wn(nt, l.dragClass, !0), Ke(nt, "transition", ""), Ke(nt, "transform", ""), Ke(nt, "box-sizing", "border-box"), Ke(nt, "margin", 0), Ke(nt, "top", i.top), Ke(nt, "left", i.left), Ke(nt, "width", i.width), Ke(nt, "height", i.height), Ke(nt, "opacity", "0.8"), Ke(nt, "position", Tl ? "absolute" : "fixed"), Ke(nt, "zIndex", "100000"), Ke(nt, "pointerEvents", "none"), Je.ghost = nt, o.appendChild(nt), Ke(nt, "transform-origin", Lf / parseInt(nt.style.width) * 100 + "% " + Pf / parseInt(nt.style.height) * 100 + "%");
    }
  },
  _onDragStart: function (o, i) {
    var l = this, n = o.dataTransfer, u = l.options;
    if (yn("dragStart", this, {
      evt: o
    }), Je.eventCanceled) {
      this._onDrop();
      return;
    }
    yn("setupClone", this), Je.eventCanceled || (Nt = cc(Ie), Nt.draggable = !1, Nt.style["will-change"] = "", this._hideClone(), wn(Nt, this.options.chosenClass, !1), Je.clone = Nt), l.cloneId = Pl(function () {
      yn("clone", l), !Je.eventCanceled && (l.options.removeCloneOnHide || Dt.insertBefore(Nt, Ie), l._hideClone(), cn({
        sortable: l,
        name: "clone"
      }));
    }), !i && wn(Ie, u.dragClass, !0), i ? (kl = !0, l._loopId = setInterval(l._emulateDragOver, 50)) : (dt(document, "mouseup", l._onDrop), dt(document, "touchend", l._onDrop), dt(document, "touchcancel", l._onDrop), n && (n.effectAllowed = "move", u.setData && u.setData.call(l, n, Ie)), mt(document, "drop", l), Ke(Ie, "transform", "translateZ(0)")), Mi = !0, l._dragStartId = Pl(l._dragStarted.bind(l, i, o)), mt(document, "selectstart", l), bo = !0, wo && Ke(document.body, "user-select", "none");
  },
  _onDragOver: function (o) {
    var i = this.el, l = o.target, n, u, f, p = this.options, c = p.group, v = Je.active, b = wl === c, y = p.sort, E = qt || v, w, h = this, m = !1;
    if (zs)
      return;
    function I(Q, ne) {
      yn(Q, h, er({
        evt: o,
        isOwner: b,
        axis: w ? "vertical" : "horizontal",
        revert: f,
        dragRect: n,
        targetRect: u,
        canSort: y,
        fromSortable: E,
        target: l,
        completed: g,
        onMove: function (q, ge) {
          return Dl(Dt, i, Ie, n, q, Kt(q), o, ge);
        },
        changed: S
      }, ne));
    }
    function D() {
      I("dragOverAnimationCapture"), h.captureAnimationState(), h !== E && E.captureAnimationState();
    }
    function g(Q) {
      return I("dragOverCompleted", {
        insertion: Q
      }), Q && (b ? v._hideClone() : v._showClone(h), h !== E && (wn(Ie, qt ? qt.options.ghostClass : v.options.ghostClass, !1), wn(Ie, p.ghostClass, !0)), qt !== h && h !== Je.active ? qt = h : h === Je.active && qt && (qt = null), E === h && (h._ignoreWhileAnimating = l), h.animateAll(function () {
        I("dragOverAnimationComplete"), h._ignoreWhileAnimating = null;
      }), h !== E && (E.animateAll(), E._ignoreWhileAnimating = null)), (l === Ie && !Ie.animated || l === i && !l.animated) && (Ii = null), !p.dragoverBubble && !o.rootEl && l !== document && (Ie.parentNode[Tn]._isOutsideThisEl(o.target), !Q && _r(o)), !p.dragoverBubble && o.stopPropagation && o.stopPropagation(), m = !0;
    }
    function S() {
      xn = Mn(Ie), Lr = Mn(Ie, p.draggable), cn({
        sortable: h,
        name: "change",
        toEl: i,
        newIndex: xn,
        newDraggableIndex: Lr,
        originalEvent: o
      });
    }
    if (o.preventDefault !== void 0 && o.cancelable && o.preventDefault(), l = Xn(l, p.draggable, i, !0), I("dragOver"), Je.eventCanceled)
      return m;
    if (Ie.contains(o.target) || l.animated && l.animatingX && l.animatingY || h._ignoreWhileAnimating === l)
      return g(!1);
    if (kl = !1, v && !p.disabled && (b ? y || (f = Ot !== Dt) : qt === this || (this.lastPutMode = wl.checkPull(this, v, Ie, o)) && c.checkPut(this, v, Ie, o))) {
      if (w = this._getDirection(o, l) === "vertical", n = Kt(Ie), I("dragOverValid"), Je.eventCanceled)
        return m;
      if (f)
        return Ot = Dt, D(), this._hideClone(), I("revert"), Je.eventCanceled || (ei ? Dt.insertBefore(Ie, ei) : Dt.appendChild(Ie)), g(!0);
      var x = eu(i, p.draggable);
      if (!x || Kg(o, w, this) && !x.animated) {
        if (x === Ie)
          return g(!1);
        if (x && i === o.target && (l = x), l && (u = Kt(l)), Dl(Dt, i, Ie, n, l, u, o, !!l) !== !1)
          return D(), i.appendChild(Ie), Ot = i, S(), g(!0);
      } else if (x && Qg(o, w, this)) {
        var R = Pi(i, 0, p, !0);
        if (R === Ie)
          return g(!1);
        if (l = R, u = Kt(l), Dl(Dt, i, Ie, n, l, u, o, !1) !== !1)
          return D(), i.insertBefore(Ie, R), Ot = i, S(), g(!0);
      } else if (l.parentNode === i) {
        u = Kt(l);
        var N = 0, T, H = Ie.parentNode !== i, B = !jg(Ie.animated && Ie.toRect || n, l.animated && l.toRect || u, w), L = w ? "top" : "left", P = Of(l, "top", "top") || Of(Ie, "top", "top"), C = P ? P.scrollTop : void 0;
        Ii !== l && (T = u[L], Io = !1, xl = !B && p.invertSwap || H), N = Jg(o, l, u, w, B ? 1 : p.swapThreshold, p.invertedSwapThreshold == null ? p.swapThreshold : p.invertedSwapThreshold, xl, Ii === l);
        var M;
        if (N !== 0) {
          var k = Mn(Ie);
          do
            k -= N, M = Ot.children[k];
          while (M && (Ke(M, "display") === "none" || M === nt));
        }
        if (N === 0 || M === l)
          return g(!1);
        Ii = l, Do = N;
        var F = l.nextElementSibling, j = !1;
        j = N === 1;
        var W = Dl(Dt, i, Ie, n, l, u, o, j);
        if (W !== !1)
          return (W === 1 || W === -1) && (j = W === 1), zs = !0, setTimeout(Yg, 30), D(), j && !F ? i.appendChild(Ie) : l.parentNode.insertBefore(Ie, j ? F : l), P && fc(P, 0, C - P.scrollTop), Ot = Ie.parentNode, T !== void 0 && !xl && (Ll = Math.abs(T - Kt(l)[L])), S(), g(!0);
      }
      if (i.contains(Ie))
        return g(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function () {
    dt(document, "mousemove", this._onTouchMove), dt(document, "touchmove", this._onTouchMove), dt(document, "pointermove", this._onTouchMove), dt(document, "dragover", _r), dt(document, "mousemove", _r), dt(document, "touchmove", _r);
  },
  _offUpEvents: function () {
    var o = this.el.ownerDocument;
    dt(o, "mouseup", this._onDrop), dt(o, "touchend", this._onDrop), dt(o, "pointerup", this._onDrop), dt(o, "touchcancel", this._onDrop), dt(document, "selectstart", this);
  },
  _onDrop: function (o) {
    var i = this.el, l = this.options;
    if (xn = Mn(Ie), Lr = Mn(Ie, l.draggable), yn("drop", this, {
      evt: o
    }), Ot = Ie && Ie.parentNode, xn = Mn(Ie), Lr = Mn(Ie, l.draggable), Je.eventCanceled) {
      this._nulling();
      return;
    }
    Mi = !1, xl = !1, Io = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Ws(this.cloneId), Ws(this._dragStartId), this.nativeDraggable && (dt(document, "drop", this), dt(i, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), wo && Ke(document.body, "user-select", ""), Ke(Ie, "transform", ""), o && (bo && (o.cancelable && o.preventDefault(), !l.dropBubble && o.stopPropagation()), nt && nt.parentNode && nt.parentNode.removeChild(nt), (Dt === Ot || qt && qt.lastPutMode !== "clone") && Nt && Nt.parentNode && Nt.parentNode.removeChild(Nt), Ie && (this.nativeDraggable && dt(Ie, "dragend", this), Os(Ie), Ie.style["will-change"] = "", bo && !Mi && wn(Ie, qt ? qt.options.ghostClass : this.options.ghostClass, !1), wn(Ie, this.options.chosenClass, !1), cn({
      sortable: this,
      name: "unchoose",
      toEl: Ot,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: o
    }), Dt !== Ot ? (xn >= 0 && (cn({
      rootEl: Ot,
      name: "add",
      toEl: Ot,
      fromEl: Dt,
      originalEvent: o
    }), cn({
      sortable: this,
      name: "remove",
      toEl: Ot,
      originalEvent: o
    }), cn({
      rootEl: Ot,
      name: "sort",
      toEl: Ot,
      fromEl: Dt,
      originalEvent: o
    }), cn({
      sortable: this,
      name: "sort",
      toEl: Ot,
      originalEvent: o
    })), qt && qt.save()) : xn !== Ni && xn >= 0 && (cn({
      sortable: this,
      name: "update",
      toEl: Ot,
      originalEvent: o
    }), cn({
      sortable: this,
      name: "sort",
      toEl: Ot,
      originalEvent: o
    })), Je.active && ((xn == null || xn === -1) && (xn = Ni, Lr = To), cn({
      sortable: this,
      name: "end",
      toEl: Ot,
      originalEvent: o
    }), this.save()))), this._nulling();
  },
  _nulling: function () {
    yn("nulling", this), Dt = Ie = Ot = nt = ei = Nt = Nl = Pr = qr = Hn = bo = xn = Lr = Ni = To = Ii = Do = qt = wl = Je.dragged = Je.ghost = Je.clone = Je.active = null, Vl.forEach(function (o) {
      o.checked = !0;
    }), Vl.length = Rs = Fs = 0;
  },
  handleEvent: function (o) {
    switch (o.type) {
      case "drop":
      case "dragend":
        this._onDrop(o);
        break;
      case "dragenter":
      case "dragover":
        Ie && (this._onDragOver(o), Gg(o));
        break;
      case "selectstart":
        o.preventDefault();
        break;
    }
  },
  toArray: function () {
    for (var o = [], i, l = this.el.children, n = 0, u = l.length, f = this.options; n < u; n++)
      i = l[n], Xn(i, f.draggable, this.el, !1) && o.push(i.getAttribute(f.dataIdAttr) || Zg(i));
    return o;
  },
  sort: function (o, i) {
    var l = {}, n = this.el;
    this.toArray().forEach(function (u, f) {
      var p = n.children[f];
      Xn(p, this.options.draggable, n, !1) && (l[u] = p);
    }, this), i && this.captureAnimationState(), o.forEach(function (u) {
      l[u] && (n.removeChild(l[u]), n.appendChild(l[u]));
    }), i && this.animateAll();
  },
  save: function () {
    var o = this.options.store;
    o && o.set && o.set(this);
  },
  closest: function (o, i) {
    return Xn(o, i || this.options.draggable, this.el, !1);
  },
  option: function (o, i) {
    var l = this.options;
    if (i === void 0)
      return l[o];
    var n = Lo.modifyOption(this, o, i);
    typeof n < "u" ? l[o] = n : l[o] = i, o === "group" && vc(l);
  },
  destroy: function () {
    yn("destroy", this);
    var o = this.el;
    o[Tn] = null, dt(o, "mousedown", this._onTapStart), dt(o, "touchstart", this._onTapStart), dt(o, "pointerdown", this._onTapStart), this.nativeDraggable && (dt(o, "dragover", this), dt(o, "dragenter", this)), Array.prototype.forEach.call(o.querySelectorAll("[draggable]"), function (i) {
      i.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Hl.splice(Hl.indexOf(this.el), 1), this.el = o = null;
  },
  _hideClone: function () {
    if (!Pr) {
      if (yn("hideClone", this), Je.eventCanceled)
        return;
      Ke(Nt, "display", "none"), this.options.removeCloneOnHide && Nt.parentNode && Nt.parentNode.removeChild(Nt), Pr = !0;
    }
  },
  _showClone: function (o) {
    if (o.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Pr) {
      if (yn("showClone", this), Je.eventCanceled)
        return;
      Ie.parentNode == Dt && !this.options.group.revertClone ? Dt.insertBefore(Nt, Ie) : ei ? Dt.insertBefore(Nt, ei) : Dt.appendChild(Nt), this.options.group.revertClone && this.animate(Ie, Nt), Ke(Nt, "display", ""), Pr = !1;
    }
  }
};
function Gg(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function Dl(e, o, i, l, n, u, f, p) {
  var c, v = e[Tn], b = v.options.onMove, y;
  return window.CustomEvent && !vr && !No ? c = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (c = document.createEvent("Event"), c.initEvent("move", !0, !0)), c.to = o, c.from = e, c.dragged = i, c.draggedRect = l, c.related = n || o, c.relatedRect = u || Kt(o), c.willInsertAfter = p, c.originalEvent = f, e.dispatchEvent(c), b && (y = b.call(v, c, f)), y;
}
function Os(e) {
  e.draggable = !1;
}
function Yg() {
  zs = !1;
}
function Qg(e, o, i) {
  var l = Kt(Pi(i.el, 0, i.options, !0)), n = 10;
  return o ? e.clientX < l.left - n || e.clientY < l.top && e.clientX < l.right : e.clientY < l.top - n || e.clientY < l.bottom && e.clientX < l.left;
}
function Kg(e, o, i) {
  var l = Kt(eu(i.el, i.options.draggable)), n = 10;
  return o ? e.clientX > l.right + n || e.clientX <= l.right && e.clientY > l.bottom && e.clientX >= l.left : e.clientX > l.right && e.clientY > l.top || e.clientX <= l.right && e.clientY > l.bottom + n;
}
function Jg(e, o, i, l, n, u, f, p) {
  var c = l ? e.clientY : e.clientX, v = l ? i.height : i.width, b = l ? i.top : i.left, y = l ? i.bottom : i.right, E = !1;
  if (!f) {
    if (p && Ll < v * n) {
      if (!Io && (Do === 1 ? c > b + v * u / 2 : c < y - v * u / 2) && (Io = !0), Io)
        E = !0;
      else if (Do === 1 ? c < b + Ll : c > y - Ll)
        return -Do;
    } else if (c > b + v * (1 - n) / 2 && c < y - v * (1 - n) / 2)
      return Xg(o);
  }
  return E = E || f, E && (c < b + v * u / 2 || c > y - v * u / 2) ? c > b + v / 2 ? 1 : -1 : 0;
}
function Xg(e) {
  return Mn(Ie) < Mn(e) ? 1 : -1;
}
function Zg(e) {
  for (var o = e.tagName + e.className + e.src + e.href + e.textContent, i = o.length, l = 0; i--;)
    l += o.charCodeAt(i);
  return l.toString(36);
}
function qg(e) {
  Vl.length = 0;
  for (var o = e.getElementsByTagName("input"), i = o.length; i--;) {
    var l = o[i];
    l.checked && Vl.push(l);
  }
}
function Pl(e) {
  return setTimeout(e, 0);
}
function Ws(e) {
  return clearTimeout(e);
}
Ql && mt(document, "touchmove", function (e) {
  (Je.active || Mi) && e.cancelable && e.preventDefault();
});
Je.utils = {
  on: mt,
  off: dt,
  css: Ke,
  find: uc,
  is: function (o, i) {
    return !!Xn(o, i, o, !1);
  },
  extend: Lg,
  throttle: dc,
  closest: Xn,
  toggleClass: wn,
  clone: cc,
  index: Mn,
  nextTick: Pl,
  cancelNextTick: Ws,
  detectDirection: hc,
  getChild: Pi
};
Je.get = function (e) {
  return e[Tn];
};
Je.mount = function () {
  for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
    o[i] = arguments[i];
  o[0].constructor === Array && (o = o[0]), o.forEach(function (l) {
    if (!l.prototype || !l.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(l));
    l.utils && (Je.utils = er(er({}, Je.utils), l.utils)), Lo.mount(l);
  });
};
Je.create = function (e, o) {
  return new Je(e, o);
};
Je.version = Fg;
var Vt = [], Ao, Gs, Ys = !1, Ns, Ls, Ul, Co;
function _g() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var o in this)
      o.charAt(0) === "_" && typeof this[o] == "function" && (this[o] = this[o].bind(this));
  }
  return e.prototype = {
    dragStarted: function (i) {
      var l = i.originalEvent;
      this.sortable.nativeDraggable ? mt(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? mt(document, "pointermove", this._handleFallbackAutoScroll) : l.touches ? mt(document, "touchmove", this._handleFallbackAutoScroll) : mt(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function (i) {
      var l = i.originalEvent;
      !this.options.dragOverBubble && !l.rootEl && this._handleAutoScroll(l);
    },
    drop: function () {
      this.sortable.nativeDraggable ? dt(document, "dragover", this._handleAutoScroll) : (dt(document, "pointermove", this._handleFallbackAutoScroll), dt(document, "touchmove", this._handleFallbackAutoScroll), dt(document, "mousemove", this._handleFallbackAutoScroll)), Bf(), $l(), Pg();
    },
    nulling: function () {
      Ul = Gs = Ao = Ys = Co = Ns = Ls = null, Vt.length = 0;
    },
    _handleFallbackAutoScroll: function (i) {
      this._handleAutoScroll(i, !0);
    },
    _handleAutoScroll: function (i, l) {
      var n = this, u = (i.touches ? i.touches[0] : i).clientX, f = (i.touches ? i.touches[0] : i).clientY, p = document.elementFromPoint(u, f);
      if (Ul = i, l || this.options.forceAutoScrollFallback || No || vr || wo) {
        Ps(i, this.options, p, l);
        var c = Br(p, !0);
        Ys && (!Co || u !== Ns || f !== Ls) && (Co && Bf(), Co = setInterval(function () {
          var v = Br(document.elementFromPoint(u, f), !0);
          v !== c && (c = v, $l()), Ps(i, n.options, v, l);
        }, 10), Ns = u, Ls = f);
      } else {
        if (!this.options.bubbleScroll || Br(p, !0) === qn()) {
          $l();
          return;
        }
        Ps(i, this.options, Br(p, !1), !1);
      }
    }
  }, hr(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function $l() {
  Vt.forEach(function (e) {
    clearInterval(e.pid);
  }), Vt = [];
}
function Bf() {
  clearInterval(Co);
}
var Ps = dc(function (e, o, i, l) {
  if (!!o.scroll) {
    var n = (e.touches ? e.touches[0] : e).clientX, u = (e.touches ? e.touches[0] : e).clientY, f = o.scrollSensitivity, p = o.scrollSpeed, c = qn(), v = !1, b;
    Gs !== i && (Gs = i, $l(), Ao = o.scroll, b = o.scrollFn, Ao === !0 && (Ao = Br(i, !0)));
    var y = 0, E = Ao;
    do {
      var w = E, h = Kt(w), m = h.top, I = h.bottom, D = h.left, g = h.right, S = h.width, x = h.height, R = void 0, N = void 0, T = w.scrollWidth, H = w.scrollHeight, B = Ke(w), L = w.scrollLeft, P = w.scrollTop;
      w === c ? (R = S < T && (B.overflowX === "auto" || B.overflowX === "scroll" || B.overflowX === "visible"), N = x < H && (B.overflowY === "auto" || B.overflowY === "scroll" || B.overflowY === "visible")) : (R = S < T && (B.overflowX === "auto" || B.overflowX === "scroll"), N = x < H && (B.overflowY === "auto" || B.overflowY === "scroll"));
      var C = R && (Math.abs(g - n) <= f && L + S < T) - (Math.abs(D - n) <= f && !!L), M = N && (Math.abs(I - u) <= f && P + x < H) - (Math.abs(m - u) <= f && !!P);
      if (!Vt[y])
        for (var k = 0; k <= y; k++)
          Vt[k] || (Vt[k] = {});
      (Vt[y].vx != C || Vt[y].vy != M || Vt[y].el !== w) && (Vt[y].el = w, Vt[y].vx = C, Vt[y].vy = M, clearInterval(Vt[y].pid), (C != 0 || M != 0) && (v = !0, Vt[y].pid = setInterval(function () {
        l && this.layer === 0 && Je.active._onTouchMove(Ul);
        var F = Vt[this.layer].vy ? Vt[this.layer].vy * p : 0, j = Vt[this.layer].vx ? Vt[this.layer].vx * p : 0;
        typeof b == "function" && b.call(Je.dragged.parentNode[Tn], j, F, e, Ul, Vt[this.layer].el) !== "continue" || fc(Vt[this.layer].el, j, F);
      }.bind({
        layer: y
      }), 24))), y++;
    } while (o.bubbleScroll && E !== c && (E = Br(E, !1)));
    Ys = v;
  }
}, 30), yc = function (o) {
  var i = o.originalEvent, l = o.putSortable, n = o.dragEl, u = o.activeSortable, f = o.dispatchSortableEvent, p = o.hideGhostForTarget, c = o.unhideGhostForTarget;
  if (!!i) {
    var v = l || u;
    p();
    var b = i.changedTouches && i.changedTouches.length ? i.changedTouches[0] : i, y = document.elementFromPoint(b.clientX, b.clientY);
    c(), v && !v.el.contains(y) && (f("spill"), this.onSpill({
      dragEl: n,
      putSortable: l
    }));
  }
};
function tu() {
}
tu.prototype = {
  startIndex: null,
  dragStart: function (o) {
    var i = o.oldDraggableIndex;
    this.startIndex = i;
  },
  onSpill: function (o) {
    var i = o.dragEl, l = o.putSortable;
    this.sortable.captureAnimationState(), l && l.captureAnimationState();
    var n = Pi(this.sortable.el, this.startIndex, this.options);
    n ? this.sortable.el.insertBefore(i, n) : this.sortable.el.appendChild(i), this.sortable.animateAll(), l && l.animateAll();
  },
  drop: yc
};
hr(tu, {
  pluginName: "revertOnSpill"
});
function nu() {
}
nu.prototype = {
  onSpill: function (o) {
    var i = o.dragEl, l = o.putSortable, n = l || this.sortable;
    n.captureAnimationState(), i.parentNode && i.parentNode.removeChild(i), n.animateAll();
  },
  drop: yc
};
hr(nu, {
  pluginName: "removeOnSpill"
});
Je.mount(new _g());
Je.mount(nu, tu);
function $s(e) {
  e.parentElement !== null && e.parentElement.removeChild(e);
}
function kf(e, o, i) {
  const l = i === 0 ? e.children[0] : e.children[i - 1].nextSibling;
  e.insertBefore(o, l);
}
function ey() {
  return typeof window < "u" ? window.console : global.console;
}
const ty = ey();
function ny(e) {
  const o = /* @__PURE__ */ Object.create(null);
  return function (l) {
    return o[l] || (o[l] = e(l));
  };
}
const ry = /-(\w)/g, iy = ny((e) => e.replace(ry, (o, i) => i.toUpperCase())), bc = ["Start", "Add", "Remove", "Update", "End"], Ac = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], Cc = ["Move"], oy = [Cc, bc, Ac].flatMap((e) => e).map((e) => `on${e}`), Qs = {
  manage: Cc,
  manageAndEmit: bc,
  emit: Ac
};
function ly(e) {
  return oy.indexOf(e) !== -1;
}
const ay = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "math",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rb",
  "rp",
  "rt",
  "rtc",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "slot",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "svg",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
];
function sy(e) {
  return ay.includes(e);
}
function uy(e) {
  return ["transition-group", "TransitionGroup"].includes(e);
}
function Sc(e) {
  return ["id", "class", "role", "style"].includes(e) || e.startsWith("data-") || e.startsWith("aria-") || e.startsWith("on");
}
function Ec(e) {
  return e.reduce((o, [i, l]) => (o[i] = l, o), {});
}
function dy({ $attrs: e, componentData: o = {} }) {
  return {
    ...Ec(
      Object.entries(e).filter(([l, n]) => Sc(l))
    ),
    ...o
  };
}
function fy({ $attrs: e, callBackBuilder: o }) {
  const i = Ec(wc(e));
  Object.entries(o).forEach(([n, u]) => {
    Qs[n].forEach((f) => {
      i[`on${f}`] = u(f);
    });
  });
  const l = `[data-draggable]${i.draggable || ""}`;
  return {
    ...i,
    draggable: l
  };
}
function wc(e) {
  return Object.entries(e).filter(([o, i]) => !Sc(o)).map(([o, i]) => [iy(o), i]).filter(([o, i]) => !ly(o));
}
const Hf = ({ el: e }) => e, cy = (e, o) => e.__draggable_context = o, Vf = (e) => e.__draggable_context;
class py {
  constructor({
    nodes: { header: o, default: i, footer: l },
    root: n,
    realList: u
  }) {
    this.defaultNodes = i, this.children = [...o, ...i, ...l], this.externalComponent = n.externalComponent, this.rootTransition = n.transition, this.tag = n.tag, this.realList = u;
  }
  get _isRootComponent() {
    return this.externalComponent || this.rootTransition;
  }
  render(o, i) {
    const { tag: l, children: n, _isRootComponent: u } = this;
    return o(l, i, u ? { default: () => n } : n);
  }
  updated() {
    const { defaultNodes: o, realList: i } = this;
    o.forEach((l, n) => {
      cy(Hf(l), {
        element: i[n],
        index: n
      });
    });
  }
  getUnderlyingVm(o) {
    return Vf(o);
  }
  getVmIndexFromDomIndex(o, i) {
    const { defaultNodes: l } = this, { length: n } = l, u = i.children, f = u.item(o);
    if (f === null)
      return n;
    const p = Vf(f);
    if (p)
      return p.index;
    if (n === 0)
      return 0;
    const c = Hf(l[0]), v = [...u].findIndex(
      (b) => b === c
    );
    return o < v ? 0 : n;
  }
}
function hy(e, o) {
  const i = e[o];
  return i ? i() : [];
}
function vy({ $slots: e, realList: o, getKey: i }) {
  const l = o || [], [n, u] = ["header", "footer"].map(
    (c) => hy(e, c)
  ), { item: f } = e;
  if (!f)
    throw new Error("draggable element must have an item slot");
  const p = l.flatMap(
    (c, v) => f({ element: c, index: v }).map((b) => (b.key = i(c), b.props = { ...b.props || {}, "data-draggable": !0 }, b))
  );
  if (p.length !== l.length)
    throw new Error("Item slot must have only one child");
  return {
    header: n,
    footer: u,
    default: p
  };
}
function my(e) {
  const o = uy(e), i = !sy(e) && !o;
  return {
    transition: o,
    externalComponent: i,
    tag: i ? ie(e) : o ? Yh : e
  };
}
function gy({ $slots: e, tag: o, realList: i, getKey: l }) {
  const n = vy({ $slots: e, realList: i, getKey: l }), u = my(o);
  return new py({ nodes: n, root: u, realList: i });
}
function xc(e, o) {
  cr(() => this.$emit(e.toLowerCase(), o));
}
function Tc(e) {
  return (o, i) => {
    if (this.realList !== null)
      return this[`onDrag${e}`](o, i);
  };
}
function yy(e) {
  const o = Tc.call(this, e);
  return (i, l) => {
    o.call(this, i, l), xc.call(this, e, i);
  };
}
let Bs = null;
const by = {
  list: {
    type: Array,
    required: !1,
    default: null
  },
  modelValue: {
    type: Array,
    required: !1,
    default: null
  },
  itemKey: {
    type: [String, Function],
    required: !0
  },
  clone: {
    type: Function,
    default: (e) => e
  },
  tag: {
    type: String,
    default: "div"
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: !1,
    default: null
  }
}, Ay = [
  "update:modelValue",
  "change",
  ...[...Qs.manageAndEmit, ...Qs.emit].map((e) => e.toLowerCase())
], ru = et({
  name: "draggable",
  inheritAttrs: !1,
  props: by,
  emits: Ay,
  data() {
    return {
      error: !1
    };
  },
  render() {
    try {
      this.error = !1;
      const { $slots: e, $attrs: o, tag: i, componentData: l, realList: n, getKey: u } = this, f = gy({
        $slots: e,
        tag: i,
        realList: n,
        getKey: u
      });
      this.componentStructure = f;
      const p = dy({ $attrs: o, componentData: l });
      return f.render(Eo, p);
    } catch (e) {
      return this.error = !0, Eo("pre", { style: { color: "red" } }, e.stack);
    }
  },
  created() {
    this.list !== null && this.modelValue !== null && ty.error(
      "modelValue and list props are mutually exclusive! Please set one or another."
    );
  },
  mounted() {
    if (this.error)
      return;
    const { $attrs: e, $el: o, componentStructure: i } = this;
    i.updated();
    const l = fy({
      $attrs: e,
      callBackBuilder: {
        manageAndEmit: (u) => yy.call(this, u),
        emit: (u) => xc.bind(this, u),
        manage: (u) => Tc.call(this, u)
      }
    }), n = o.nodeType === 1 ? o : o.parentElement;
    this._sortable = new Je(n, l), this.targetDomElement = n, n.__draggable_component__ = this;
  },
  updated() {
    this.componentStructure.updated();
  },
  beforeUnmount() {
    this._sortable !== void 0 && this._sortable.destroy();
  },
  computed: {
    realList() {
      const { list: e } = this;
      return e || this.modelValue;
    },
    getKey() {
      const { itemKey: e } = this;
      return typeof e == "function" ? e : (o) => o[e];
    }
  },
  watch: {
    $attrs: {
      handler(e) {
        const { _sortable: o } = this;
        !o || wc(e).forEach(([i, l]) => {
          o.option(i, l);
        });
      },
      deep: !0
    }
  },
  methods: {
    getUnderlyingVm(e) {
      return this.componentStructure.getUnderlyingVm(e) || null;
    },
    getUnderlyingPotencialDraggableComponent(e) {
      return e.__draggable_component__;
    },
    emitChanges(e) {
      cr(() => this.$emit("change", e));
    },
    alterList(e) {
      if (this.list) {
        e(this.list);
        return;
      }
      const o = [...this.modelValue];
      e(o), this.$emit("update:modelValue", o);
    },
    spliceList() {
      const e = (o) => o.splice(...arguments);
      this.alterList(e);
    },
    updatePosition(e, o) {
      const i = (l) => l.splice(o, 0, l.splice(e, 1)[0]);
      this.alterList(i);
    },
    getRelatedContextFromMoveEvent({ to: e, related: o }) {
      const i = this.getUnderlyingPotencialDraggableComponent(e);
      if (!i)
        return { component: i };
      const l = i.realList, n = { list: l, component: i };
      return e !== o && l ? { ...i.getUnderlyingVm(o) || {}, ...n } : n;
    },
    getVmIndexFromDomIndex(e) {
      return this.componentStructure.getVmIndexFromDomIndex(
        e,
        this.targetDomElement
      );
    },
    onDragStart(e) {
      this.context = this.getUnderlyingVm(e.item), e.item._underlying_vm_ = this.clone(this.context.element), Bs = e.item;
    },
    onDragAdd(e) {
      const o = e.item._underlying_vm_;
      if (o === void 0)
        return;
      $s(e.item);
      const i = this.getVmIndexFromDomIndex(e.newIndex);
      this.spliceList(i, 0, o);
      const l = { element: o, newIndex: i };
      this.emitChanges({ added: l });
    },
    onDragRemove(e) {
      if (kf(this.$el, e.item, e.oldIndex), e.pullMode === "clone") {
        $s(e.clone);
        return;
      }
      const { index: o, element: i } = this.context;
      this.spliceList(o, 1);
      const l = { element: i, oldIndex: o };
      this.emitChanges({ removed: l });
    },
    onDragUpdate(e) {
      $s(e.item), kf(e.from, e.item, e.oldIndex);
      const o = this.context.index, i = this.getVmIndexFromDomIndex(e.newIndex);
      this.updatePosition(o, i);
      const l = { element: this.context.element, oldIndex: o, newIndex: i };
      this.emitChanges({ moved: l });
    },
    computeFutureIndex(e, o) {
      if (!e.element)
        return 0;
      const i = [...o.to.children].filter(
        (f) => f.style.display !== "none"
      ), l = i.indexOf(o.related), n = e.component.getVmIndexFromDomIndex(
        l
      );
      return i.indexOf(Bs) !== -1 || !o.willInsertAfter ? n : n + 1;
    },
    onDragMove(e, o) {
      const { move: i, realList: l } = this;
      if (!i || !l)
        return !0;
      const n = this.getRelatedContextFromMoveEvent(e), u = this.computeFutureIndex(n, e), f = {
        ...this.context,
        futureIndex: u
      }, p = {
        ...e,
        relatedContext: n,
        draggedContext: f
      };
      return i(p, o);
    },
    onDragEnd() {
      Bs = null;
    }
  }
});
function Cy() {
  return [
    {
      name: "template",
      title: "\u6A21\u677F",
      list: []
    },
    {
      name: "main",
      title: "\u57FA\u7840\u7EC4\u4EF6",
      list: []
    },
    {
      name: "subform",
      title: "\u5B50\u8868\u5355\u7EC4\u4EF6",
      list: []
    },
    {
      name: "aide",
      title: "\u8F85\u52A9\u7EC4\u4EF6",
      list: []
    },
    {
      name: "layout",
      title: "\u5E03\u5C40\u7EC4\u4EF6",
      list: []
    }
  ];
}
const Ri = {
  Add: (e, o) => {
    let i, l, n;
    try {
      i = e.toString().split(".")[1].length;
    } catch {
      i = 0;
    }
    try {
      l = o.toString().split(".")[1].length;
    } catch {
      l = 0;
    }
    return n = Math.pow(10, Math.max(i, l)), (e * n + o * n) / n;
  },
  Sub: (e, o) => {
    let i, l, n;
    try {
      i = e.toString().split(".")[1].length;
    } catch {
      i = 0;
    }
    try {
      l = o.toString().split(".")[1].length;
    } catch {
      l = 0;
    }
    n = Math.pow(10, Math.max(i, l));
    let u = i >= l ? i : l;
    return Number(((e * n - o * n) / n).toFixed(u));
  },
  Mul: (e, o) => {
    let i = 0, l = e.toString(), n = o.toString();
    try {
      i += l.split(".")[1].length;
    } catch {
    }
    try {
      i += n.split(".")[1].length;
    } catch {
    }
    return Number(l.replace(".", "")) * Number(n.replace(".", "")) / Math.pow(10, i);
  },
  Div: (e, o) => {
    let i = 0, l = 0;
    try {
      i = e.toString().split(".")[1].length;
    } catch {
    }
    try {
      l = o.toString().split(".")[1].length;
    } catch {
    }
    let n = Number(e.toString().replace(".", "")), u = Number(o.toString().replace(".", ""));
    return n / u * Math.pow(10, l - i);
  }
}, Mo = {
  ADD: function (e, o) {
    return Ri.Add(e, o);
  },
  SUB: function (e, o) {
    return Ri.Sub(e, o);
  },
  MUL: function (e, o) {
    return Ri.Mul(e, o);
  },
  DIV: function (e, o) {
    return Ri.Div(e, o);
  },
  SUM: function (e) {
    return (e || []).reduce((o, i) => Ri.Add(o, i || 0), 0);
  },
  MAX: function (...e) {
    return Math.max(...e.map((o) => parseFloat(o)).filter((o) => !isNaN(o)));
  },
  MIN: function (...e) {
    return Math.min(...e.map((o) => parseFloat(o)).filter((o) => !isNaN(o)));
  },
  ABS: function (e) {
    return parseFloat(Math.abs(e)) || 0;
  },
  AVG: function (...e) {
    return e.length ? Ri.Div(Mo.SUM(e), e.length) : 0;
  },
  POWER: function (e, o) {
    return Math.pow(parseFloat(e), parseFloat(o));
  },
  RAND: function () {
    return Math.random();
  },
  PI: function () {
    return Number(Math.PI);
  },
  ROUND: function (e, o) {
    return e = parseFloat(e), isNaN(e) ? 0 : parseFloat(e.toFixed(parseFloat(o) || 0));
  },
  SQRT: function (e) {
    return Math.sqrt(parseFloat(e)) || 0;
  },
  TONUMBER: function (e) {
    return parseFloat(e) || 0;
  },
  NOW: function () {
    const e = new Date(), o = e.getFullYear(), i = ("0" + (e.getMonth() + 1)).slice(-2), l = ("0" + e.getDate()).slice(-2), n = ("0" + e.getHours()).slice(-2), u = ("0" + e.getMinutes()).slice(-2), f = ("0" + e.getSeconds()).slice(-2);
    return o + "-" + i + "-" + l + " " + n + ":" + u + ":" + f;
  },
  TODAY: function () {
    const e = new Date(), o = e.getFullYear(), i = ("0" + (e.getMonth() + 1)).slice(-2), l = ("0" + e.getDate()).slice(-2);
    return o + "-" + i + "-" + l;
  },
  YEAR: function (e) {
    return e ? new Date(e).getFullYear() : null;
  },
  MONTH: function (e) {
    return e ? new Date(e).getMonth() + 1 : null;
  },
  DAY: function (e) {
    return e ? new Date(e).getDate() : null;
  },
  HOUR: function (e) {
    return e ? new Date(e).getHours() : null;
  },
  MINUTE: function (e) {
    return e ? new Date(e).getMinutes() : null;
  },
  SECOND: function (e) {
    return e ? new Date(e).getSeconds() : null;
  },
  DIFFDAYS: function (e, o) {
    const i = new Date(e), l = new Date(o);
    return parseInt(Math.ceil(Math.abs(l.getTime() - i.getTime()) / (1e3 * 60 * 60 * 24)));
  },
  DIFFHOURS: function (e, o) {
    const i = new Date(e), l = new Date(o);
    return parseFloat(Math.abs(l.getTime() - i.getTime()) / (1e3 * 60 * 60)).toFixed(2);
  },
  DIFFMINUTES: function (e, o) {
    const i = new Date(e), l = new Date(o);
    return parseInt(Math.ceil(Math.abs(l.getTime() - i.getTime()) / (1e3 * 60)));
  },
  TIMESTAMP: function (e) {
    return Date.parse(e);
  },
  STARTSWITH: function (e, o) {
    return ("" + e).substring(0, ("" + o).length) === o;
  },
  NOTEMPTY: function (e) {
    return !st.empty(e);
  },
  LEN: function (e) {
    return Array.isArray(e) ? e.length : 0;
  },
  MOD: function (e, o) {
    return e = parseFloat(e), o = parseFloat(o), !e || !o || isNaN(e) || isNaN(o) ? 0 : e % o;
  },
  FLOOR: function (e) {
    return Math.floor(parseFloat(e) || 0);
  },
  ISNUMBER: function (e) {
    return e === "" || e === null ? !1 : !isNaN(Number(e));
  },
  SLICELEFT: function (e, o) {
    return ("" + e).slice(0, Number(o) || 0);
  },
  SLICERIGHT: function (e, o) {
    return ("" + e).slice(Number(o) * -1);
  },
  TOLOWER: function (e) {
    return ("" + e).toLowerCase();
  },
  TOUPPER: function (e) {
    return ("" + e).toUpperCase();
  },
  INCLUDES: function (e, o) {
    return (e || "").indexOf(o || "");
  },
  REPLACE: function (e, o, i) {
    return (e || "").replace(o || "", i || "");
  },
  REPLACEALL: function (e, o, i) {
    return (e || "").replaceAll(o || "", i || "");
  },
  TRIM: function (e) {
    return (e || "").trim();
  },
  TOCHINSESAMOUNT: function (e) {
    let o = ["\u96F6", "\u58F9", "\u8D30", "\u53C1", "\u8086", "\u4F0D", "\u9646", "\u67D2", "\u634C", "\u7396"], i = ["", "\u4E07", "\u4EBF", "\u4E07\u4EBF", "\u4EBF\u4EBF"], l = ["", "\u62FE", "\u4F70", "\u4EDF"], n = ["\u89D2", "\u5206"];
    function u(E) {
      let w = "", h = "", m = 0, I = !0;
      for (; E > 0;) {
        let D = E % 10;
        D === 0 ? I || (I = !0, h = o[D] + h) : (I = !1, w = o[D], w += l[m], h = w + h), m++, E = Math.floor(E / 10);
      }
      return h;
    }
    let f = 0, p = "", c = "", v = !1;
    if (e === 0)
      return o[0];
    let b = Math.floor(e), y = Math.round((e - b) * 100);
    for (; b > 0;) {
      let E = b % 1e4;
      v && (c = o[0] + c), p = u(E), p += E !== 0 ? i[f] : i[0], c = p + c, v = E < 1e3 && E > 0, b = Math.floor(b / 1e4), f++;
    }
    return c && (c += "\u5143"), y > 0 ? (c += o[Math.floor(y / 10)] + n[0], y % 10 !== 0 && (c += o[y % 10] + n[1])) : c && (c += "\u6574"), c;
  },
  UNION: function (...e) {
    return (Array.isArray(e[0]) ? e[0] : e).filter((i, l, n) => n.indexOf(i) === l);
  },
  AND: function (...e) {
    return !!e.reduce((o, i) => o && i, !0);
  },
  OR: function (...e) {
    return !!e.reduce((o, i) => o || i, !1);
  },
  IF: function (e, o = !0, i = !1) {
    return e ? o : i;
  },
  DEFAULT: function (e, o) {
    return st.Undef(e) ? o : e;
  },
  CASE: function (...e) {
    for (let o = 0; o < e.length - 1; o += 2)
      if (e[o])
        return e[o + 1];
    return null;
  },
  COLUMN: function (e, o) {
    const i = [];
    return Array.isArray(e) && e.forEach(function (l) {
      Array.isArray(l) ? i.push(...Mo.COLUMN(l, o)) : l && i.push(l[o]);
    }), i;
  },
  VALUE: function (e, o, i) {
    const l = ("" + o).split(".");
    let n = e;
    for (let u = 0; u < l.length; u++)
      if (Nr(n, l[u]))
        n = n[l[u]];
      else
        return i;
    return n;
  },
  CONCAT: function (...e) {
    return "".concat(...e);
  },
  IN: function (e, o) {
    return (e || []).indexOf(o) > -1;
  }
}, Ks = {
  ADD: "ADD(1, 2) = 3",
  SUB: "SUB(10, 1) = 9",
  MUL: "MUL(2, 2) = 4",
  DIV: "DIV(10, 2) = 5",
  SUM: "SUM(1,2,3) = 6, SUM([5, 6, 7]) = 18",
  MAX: "MAX(1, 5, 10) = 10",
  MIN: "MIN(1, 5, 10) = 1",
  ABS: "ABS(-10) = 10, ABS(10) = 10",
  AVG: "AVG(2, 4, 6, 8) = 5",
  POWER: "POWER(2, 4) = 16",
  RAND: "RAND() = 0.75348173001531",
  PI: "PI() = 3.141592653589793",
  ROUND: "ROUND(3.149, 2) = 3.15, ROUND(3.149) = 3",
  SQRT: "SQRT(9) = 3",
  NOW: 'NOW() = "2024-03-15 12:08:31"',
  TODAY: 'TODAY() = "2024-03-15"',
  YEAR: 'YEAR("2024-03-15 12:08:31") = 2024',
  MONTH: 'MONTH("2024-03-15 12:08:31") = 3',
  DAY: 'DAY("2024-03-15 12:08:31") = 15',
  HOUR: 'HOUR("2024-03-15 12:08:31") = 12',
  MINUTE: 'MINUTE("2024-03-15 12:08:31") = 8',
  SECOND: 'SECOND("2024-03-15 12:08:31") = 31',
  TIMESTAMP: 'TIMESTAMP("2024-03-15 12:08:31") = 1710475711000',
  DIFFDAYS: 'DIFFDAYS("2024-01-15","2024-03-15") = 60',
  DIFFHOURS: 'DIFFHOURS("2024-01-15 12:00:00", "2024-01-16 15:00:00") = 27, DIFFHOURS("2024-01-15 12:00:00", "2024-01-15 12:30:00") = 0.5',
  DIFFMINUTES: 'DIFFMINUTES("2024-01-15 12:00:00", "2024-01-15 12:30:00") = 30',
  STARTSWITH: 'STARTSWITH("ABCDEF","ABC") = true, STARTSWITH("ABCDEF","AD") = false',
  NOTEMPTY: 'NOTEMPTY("") = false, NOTEMPTY([]) = false, NOTEMPTY("0") = true',
  LEN: 'LEN(["a", "b", "c"]) = 3',
  MOD: "MOD(10, 3) = 1",
  FLOOR: "FLOOR(1.93) = 1",
  ISNUMBER: 'ISNUMBER("2.34") = true, ISNUMBER("2.4e") = false',
  TONUMBER: 'TONUMBER("1.5") = 1.5, TONUMBER("2.4e") = 2.4; TONUMBER("ABC") = 0',
  SLICELEFT: 'SLICELEFT("ABCDE", 3) = "ABC"',
  SLICERIGHT: 'SLICERIGHT("ABCDE", 3) = "CDE"',
  TOLOWER: "",
  TOUPPER: 'TOUPPER("abcd") = "ABCD"',
  INCLUDES: 'TOLOWER("ABCD") = "abcd"',
  REPLACE: 'REPLACE("AbAc","A","1") = "1bAc"',
  REPLACEALL: 'REPLACEALL("AbAc","A","1") = "1b1c"',
  TRIM: 'TRIM("\\t\\n ABC \\t\\n") = "ABC"',
  TOCHINSESAMOUNT: 'TOCHINSESAMOUNT(32.14) = "\u53C1\u62FE\u8D30\u5143\u58F9\u89D2\u8086\u5206"',
  UNION: "UNION(1, 3, 5, 1, 4, 3) = [1, 3, 5, 4], UNION([1, 2, 3, 1, 2, 3]) = [1, 2, 3]",
  AND: "AND(true, true) = true, AND(true, false) = false",
  OR: "OR(false, false) = false, OR(false, true) = true",
  IF: "IF(false, 1, 0) = 0, IF(true, 1, 0) = 1",
  IN: "IN([1,2,3,4], 4) = true, IN([1,2,3,4], 5) = false",
  DEFAULT: 'DEFAULT("#FF7271", "#000") = "#FF7271", DEFAULT("", "#000") = "", DEFAULT(null, "#000") = "#000"',
  CASE: "CASE(IN([1,2,3,4], 5), 1, IN([1,2,3,4], 2), 2) = 2",
  COLUMN: 'COLUMN([{key: 1}, {key: 2}, {key: 3}],"key") = [1, 2, 3], COLUMN([[{key: 1}, {key: 2}], [{key: 3}, {key: 4}]], "key") = [1, 2, 3, 4]',
  VALUE: 'VALUE({key: 1}, "key", 2) = 1, VALUE({key: 1}, "value", 2) = 2, VALUE({list: {key: 1}}, "list.key") = 1',
  CONCAT: 'CONCAT("ABC", "DEF") = "ABCDEF"'
}, Dc = [
  {
    key: "math",
    children: ["TONUMBER", "ADD", "SUB", "MUL", "DIV", "SUM", "MAX", "MIN", "ABS", "AVG", "MOD", "SQRT", "POWER", "RAND", "PI", "ROUND", "FLOOR", "TOCHINSESAMOUNT"]
  },
  {
    key: "string",
    children: ["STARTSWITH", "SLICELEFT", "SLICERIGHT", "TOLOWER", "TOUPPER", "INCLUDES", "CONCAT", "REPLACE", "REPLACEALL", "TRIM"]
  },
  {
    key: "date",
    children: ["NOW", "TODAY", "YEAR", "MONTH", "DAY", "HOUR", "MINUTE", "SECOND", "DIFFDAYS", "DIFFHOURS", "DIFFMINUTES", "TIMESTAMP"]
  },
  {
    key: "collection",
    children: ["LEN", "UNION", "COLUMN", "VALUE"]
  },
  {
    key: "condition",
    children: ["IN", "IF", "AND", "OR", "CASE", "DEFAULT", "NOTEMPTY", "ISNUMBER"]
  }
];
_n.parser().preview = uv;
Object.keys(Mo).forEach((e) => {
  _n.setFormula(e, Mo[e]);
});
const Kl = _n, Ze = _n.factory();
let Ic = null, Js = So(null);
function Xs(...e) {
  return Ic(...e);
}
const Rc = (e) => {
  Js.value = e || ic;
  const o = Us(Js);
  return Ic = o.t, o;
};
Rc();
var Sy = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, $i = { exports: {} };
(function (e, o) {
  (function (i, l) {
    e.exports = l();
  })(Sy, function () {
    var i = navigator.userAgent, l = navigator.platform, n = /gecko\/\d/i.test(i), u = /MSIE \d/.test(i), f = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(i), p = /Edge\/(\d+)/.exec(i), c = u || f || p, v = c && (u ? document.documentMode || 6 : +(p || f)[1]), b = !p && /WebKit\//.test(i), y = b && /Qt\/\d+\.\d+/.test(i), E = !p && /Chrome\/(\d+)/.exec(i), w = E && +E[1], h = /Opera\//.test(i), m = /Apple Computer/.test(navigator.vendor), I = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(i), D = /PhantomJS/.test(i), g = m && (/Mobile\/\w+/.test(i) || navigator.maxTouchPoints > 2), S = /Android/.test(i), x = g || S || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(i), R = g || /Mac/.test(l), N = /\bCrOS\b/.test(i), T = /win/i.test(l), H = h && i.match(/Version\/(\d*\.\d*)/);
    H && (H = Number(H[1])), H && H >= 15 && (h = !1, b = !0);
    var B = R && (y || h && (H == null || H < 12.11)), L = n || c && v >= 9;
    function P(t) {
      return new RegExp("(^|\\s)" + t + "(?:$|\\s)\\s*");
    }
    var C = function (t, r) {
      var s = t.className, a = P(r).exec(s);
      if (a) {
        var d = s.slice(a.index + a[0].length);
        t.className = s.slice(0, a.index) + (d ? a[1] + d : "");
      }
    };
    function M(t) {
      for (var r = t.childNodes.length; r > 0; --r)
        t.removeChild(t.firstChild);
      return t;
    }
    function k(t, r) {
      return M(t).appendChild(r);
    }
    function F(t, r, s, a) {
      var d = document.createElement(t);
      if (s && (d.className = s), a && (d.style.cssText = a), typeof r == "string")
        d.appendChild(document.createTextNode(r));
      else if (r)
        for (var A = 0; A < r.length; ++A)
          d.appendChild(r[A]);
      return d;
    }
    function j(t, r, s, a) {
      var d = F(t, r, s, a);
      return d.setAttribute("role", "presentation"), d;
    }
    var W;
    document.createRange ? W = function (t, r, s, a) {
      var d = document.createRange();
      return d.setEnd(a || t, s), d.setStart(t, r), d;
    } : W = function (t, r, s) {
      var a = document.body.createTextRange();
      try {
        a.moveToElementText(t.parentNode);
      } catch {
        return a;
      }
      return a.collapse(!0), a.moveEnd("character", s), a.moveStart("character", r), a;
    };
    function Q(t, r) {
      if (r.nodeType == 3 && (r = r.parentNode), t.contains)
        return t.contains(r);
      do
        if (r.nodeType == 11 && (r = r.host), r == t)
          return !0;
      while (r = r.parentNode);
    }
    function ne(t) {
      var r;
      try {
        r = t.activeElement;
      } catch {
        r = t.body || null;
      }
      for (; r && r.shadowRoot && r.shadowRoot.activeElement;)
        r = r.shadowRoot.activeElement;
      return r;
    }
    function te(t, r) {
      var s = t.className;
      P(r).test(s) || (t.className += (s ? " " : "") + r);
    }
    function q(t, r) {
      for (var s = t.split(" "), a = 0; a < s.length; a++)
        s[a] && !P(s[a]).test(r) && (r += " " + s[a]);
      return r;
    }
    var ge = function (t) {
      t.select();
    };
    g ? ge = function (t) {
      t.selectionStart = 0, t.selectionEnd = t.value.length;
    } : c && (ge = function (t) {
      try {
        t.select();
      } catch {
      }
    });
    function be(t) {
      return t.display.wrapper.ownerDocument;
    }
    function me(t) {
      return be(t).defaultView;
    }
    function ae(t) {
      var r = Array.prototype.slice.call(arguments, 1);
      return function () {
        return t.apply(null, r);
      };
    }
    function le(t, r, s) {
      r || (r = {});
      for (var a in t)
        t.hasOwnProperty(a) && (s !== !1 || !r.hasOwnProperty(a)) && (r[a] = t[a]);
      return r;
    }
    function ue(t, r, s, a, d) {
      r == null && (r = t.search(/[^\s\u00a0]/), r == -1 && (r = t.length));
      for (var A = a || 0, O = d || 0; ;) {
        var $ = t.indexOf("	", A);
        if ($ < 0 || $ >= r)
          return O + (r - A);
        O += $ - A, O += s - O % s, A = $ + 1;
      }
    }
    var he = function () {
      this.id = null, this.f = null, this.time = 0, this.handler = ae(this.onTimeout, this);
    };
    he.prototype.onTimeout = function (t) {
      t.id = 0, t.time <= +new Date() ? t.f() : setTimeout(t.handler, t.time - +new Date());
    }, he.prototype.set = function (t, r) {
      this.f = r;
      var s = +new Date() + t;
      (!this.id || s < this.time) && (clearTimeout(this.id), this.id = setTimeout(this.handler, t), this.time = s);
    };
    function se(t, r) {
      for (var s = 0; s < t.length; ++s)
        if (t[s] == r)
          return s;
      return -1;
    }
    var Ae = 50, Ee = {
      toString: function () {
        return "CodeMirror.Pass";
      }
    }, Ne = { scroll: !1 }, _e = { origin: "*mouse" }, at = { origin: "+move" };
    function it(t, r, s) {
      for (var a = 0, d = 0; ;) {
        var A = t.indexOf("	", a);
        A == -1 && (A = t.length);
        var O = A - a;
        if (A == t.length || d + O >= r)
          return a + Math.min(O, r - d);
        if (d += A - a, d += s - d % s, a = A + 1, d >= r)
          return a;
      }
    }
    var St = [""];
    function Et(t) {
      for (; St.length <= t;)
        St.push(He(St) + " ");
      return St[t];
    }
    function He(t) {
      return t[t.length - 1];
    }
    function bt(t, r) {
      for (var s = [], a = 0; a < t.length; a++)
        s[a] = r(t[a], a);
      return s;
    }
    function pn(t, r, s) {
      for (var a = 0, d = s(r); a < t.length && s(t[a]) <= d;)
        a++;
      t.splice(a, 0, r);
    }
    function Ut() {
    }
    function yr(t, r) {
      var s;
      return Object.create ? s = Object.create(t) : (Ut.prototype = t, s = new Ut()), r && le(r, s), s;
    }
    var Un = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
    function bn(t) {
      return /\w/.test(t) || t > "\x80" && (t.toUpperCase() != t.toLowerCase() || Un.test(t));
    }
    function An(t, r) {
      return r ? r.source.indexOf("\\w") > -1 && bn(t) ? !0 : r.test(t) : bn(t);
    }
    function jn(t) {
      for (var r in t)
        if (t.hasOwnProperty(r) && t[r])
          return !1;
      return !0;
    }
    var Cn = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
    function Dn(t) {
      return t.charCodeAt(0) >= 768 && Cn.test(t);
    }
    function Bt(t, r, s) {
      for (; (s < 0 ? r > 0 : r < t.length) && Dn(t.charAt(r));)
        r += s;
      return r;
    }
    function ct(t, r, s) {
      for (var a = r > s ? -1 : 1; ;) {
        if (r == s)
          return r;
        var d = (r + s) / 2, A = a < 0 ? Math.ceil(d) : Math.floor(d);
        if (A == r)
          return t(A) ? r : s;
        t(A) ? s = A : r = A + a;
      }
    }
    function hn(t, r, s, a) {
      if (!t)
        return a(r, s, "ltr", 0);
      for (var d = !1, A = 0; A < t.length; ++A) {
        var O = t[A];
        (O.from < s && O.to > r || r == s && O.to == r) && (a(Math.max(O.from, r), Math.min(O.to, s), O.level == 1 ? "rtl" : "ltr", A), d = !0);
      }
      d || a(r, s, "ltr");
    }
    var rt = null;
    function Me(t, r, s) {
      var a;
      rt = null;
      for (var d = 0; d < t.length; ++d) {
        var A = t[d];
        if (A.from < r && A.to > r)
          return d;
        A.to == r && (A.from != A.to && s == "before" ? a = d : rt = d), A.from == r && (A.from != A.to && s != "before" ? a = d : rt = d);
      }
      return a != null ? a : rt;
    }
    var Re = function () {
      var t = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN", r = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
      function s(U) {
        return U <= 247 ? t.charAt(U) : 1424 <= U && U <= 1524 ? "R" : 1536 <= U && U <= 1785 ? r.charAt(U - 1536) : 1774 <= U && U <= 2220 ? "r" : 8192 <= U && U <= 8203 ? "w" : U == 8204 ? "b" : "L";
      }
      var a = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/, d = /[stwN]/, A = /[LRr]/, O = /[Lb1n]/, $ = /[1n]/;
      function V(U, G, K) {
        this.level = U, this.from = G, this.to = K;
      }
      return function (U, G) {
        var K = G == "ltr" ? "L" : "R";
        if (U.length == 0 || G == "ltr" && !a.test(U))
          return !1;
        for (var oe = U.length, re = [], pe = 0; pe < oe; ++pe)
          re.push(s(U.charCodeAt(pe)));
        for (var ye = 0, Ce = K; ye < oe; ++ye) {
          var Te = re[ye];
          Te == "m" ? re[ye] = Ce : Ce = Te;
        }
        for (var Fe = 0, De = K; Fe < oe; ++Fe) {
          var Le = re[Fe];
          Le == "1" && De == "r" ? re[Fe] = "n" : A.test(Le) && (De = Le, Le == "r" && (re[Fe] = "R"));
        }
        for (var Ue = 1, Ve = re[0]; Ue < oe - 1; ++Ue) {
          var tt = re[Ue];
          tt == "+" && Ve == "1" && re[Ue + 1] == "1" ? re[Ue] = "1" : tt == "," && Ve == re[Ue + 1] && (Ve == "1" || Ve == "n") && (re[Ue] = Ve), Ve = tt;
        }
        for (var At = 0; At < oe; ++At) {
          var Gt = re[At];
          if (Gt == ",")
            re[At] = "N";
          else if (Gt == "%") {
            var Tt = void 0;
            for (Tt = At + 1; Tt < oe && re[Tt] == "%"; ++Tt)
              ;
            for (var gn = At && re[At - 1] == "!" || Tt < oe && re[Tt] == "1" ? "1" : "N", un = At; un < Tt; ++un)
              re[un] = gn;
            At = Tt - 1;
          }
        }
        for (var Pt = 0, dn = K; Pt < oe; ++Pt) {
          var Jt = re[Pt];
          dn == "L" && Jt == "1" ? re[Pt] = "L" : A.test(Jt) && (dn = Jt);
        }
        for (var Ht = 0; Ht < oe; ++Ht)
          if (d.test(re[Ht])) {
            var $t = void 0;
            for ($t = Ht + 1; $t < oe && d.test(re[$t]); ++$t)
              ;
            for (var Rt = (Ht ? re[Ht - 1] : K) == "L", fn = ($t < oe ? re[$t] : K) == "L", xi = Rt == fn ? Rt ? "L" : "R" : K, Or = Ht; Or < $t; ++Or)
              re[Or] = xi;
            Ht = $t - 1;
          }
        for (var Zt = [], Jn, Yt = 0; Yt < oe;)
          if (O.test(re[Yt])) {
            var za = Yt;
            for (++Yt; Yt < oe && O.test(re[Yt]); ++Yt)
              ;
            Zt.push(new V(0, za, Yt));
          } else {
            var ur = Yt, Xr = Zt.length, Zr = G == "rtl" ? 1 : 0;
            for (++Yt; Yt < oe && re[Yt] != "L"; ++Yt)
              ;
            for (var nn = ur; nn < Yt;)
              if ($.test(re[nn])) {
                ur < nn && (Zt.splice(Xr, 0, new V(1, ur, nn)), Xr += Zr);
                var Ti = nn;
                for (++nn; nn < Yt && $.test(re[nn]); ++nn)
                  ;
                Zt.splice(Xr, 0, new V(2, Ti, nn)), Xr += Zr, ur = nn;
              } else
                ++nn;
            ur < Yt && Zt.splice(Xr, 0, new V(1, ur, Yt));
          }
        return G == "ltr" && (Zt[0].level == 1 && (Jn = U.match(/^\s+/)) && (Zt[0].from = Jn[0].length, Zt.unshift(new V(0, 0, Jn[0].length))), He(Zt).level == 1 && (Jn = U.match(/\s+$/)) && (He(Zt).to -= Jn[0].length, Zt.push(new V(0, oe - Jn[0].length, oe)))), G == "rtl" ? Zt.reverse() : Zt;
      };
    }();
    function je(t, r) {
      var s = t.order;
      return s == null && (s = t.order = Re(t.text, r)), s;
    }
    var Oe = [], de = function (t, r, s) {
      if (t.addEventListener)
        t.addEventListener(r, s, !1);
      else if (t.attachEvent)
        t.attachEvent("on" + r, s);
      else {
        var a = t._handlers || (t._handlers = {});
        a[r] = (a[r] || Oe).concat(s);
      }
    };
    function ke(t, r) {
      return t._handlers && t._handlers[r] || Oe;
    }
    function Pe(t, r, s) {
      if (t.removeEventListener)
        t.removeEventListener(r, s, !1);
      else if (t.detachEvent)
        t.detachEvent("on" + r, s);
      else {
        var a = t._handlers, d = a && a[r];
        if (d) {
          var A = se(d, s);
          A > -1 && (a[r] = d.slice(0, A).concat(d.slice(A + 1)));
        }
      }
    }
    function $e(t, r) {
      var s = ke(t, r);
      if (!!s.length)
        for (var a = Array.prototype.slice.call(arguments, 2), d = 0; d < s.length; ++d)
          s[d].apply(null, a);
    }
    function Xe(t, r, s) {
      return typeof r == "string" && (r = {
        type: r, preventDefault: function () {
          this.defaultPrevented = !0;
        }
      }), $e(t, s || r.type, t, r), br(r) || r.codemirrorIgnore;
    }
    function on(t) {
      var r = t._handlers && t._handlers.cursorActivity;
      if (!!r)
        for (var s = t.curOp.cursorActivityHandlers || (t.curOp.cursorActivityHandlers = []), a = 0; a < r.length; ++a)
          se(s, r[a]) == -1 && s.push(r[a]);
    }
    function xt(t, r) {
      return ke(t, r).length > 0;
    }
    function Ct(t) {
      t.prototype.on = function (r, s) {
        de(this, r, s);
      }, t.prototype.off = function (r, s) {
        Pe(this, r, s);
      };
    }
    function pt(t) {
      t.preventDefault ? t.preventDefault() : t.returnValue = !1;
    }
    function In(t) {
      t.stopPropagation ? t.stopPropagation() : t.cancelBubble = !0;
    }
    function br(t) {
      return t.defaultPrevented != null ? t.defaultPrevented : t.returnValue == !1;
    }
    function Nn(t) {
      pt(t), In(t);
    }
    function ln(t) {
      return t.target || t.srcElement;
    }
    function ki(t) {
      var r = t.which;
      return r == null && (t.button & 1 ? r = 1 : t.button & 2 ? r = 3 : t.button & 4 && (r = 2)), R && t.ctrlKey && r == 1 && (r = 3), r;
    }
    var Zl = function () {
      if (c && v < 9)
        return !1;
      var t = F("div");
      return "draggable" in t || "dragDrop" in t;
    }(), Rn;
    function ql(t) {
      if (Rn == null) {
        var r = F("span", "\u200B");
        k(t, F("span", [r, document.createTextNode("x")])), t.firstChild.offsetHeight != 0 && (Rn = r.offsetWidth <= 1 && r.offsetHeight > 2 && !(c && v < 8));
      }
      var s = Rn ? F("span", "\u200B") : F("span", "\xA0", null, "display: inline-block; width: 1px; margin-right: -1px");
      return s.setAttribute("cm-text", ""), s;
    }
    var oi;
    function Bo(t) {
      if (oi != null)
        return oi;
      var r = k(t, document.createTextNode("A\u062EA")), s = W(r, 0, 1).getBoundingClientRect(), a = W(r, 1, 2).getBoundingClientRect();
      return M(t), !s || s.left == s.right ? !1 : oi = a.right - s.right < 3;
    }
    var Hi = `

b`.split(/\n/).length != 3 ? function (t) {
      for (var r = 0, s = [], a = t.length; r <= a;) {
        var d = t.indexOf(`
`, r);
        d == -1 && (d = t.length);
        var A = t.slice(r, t.charAt(d - 1) == "\r" ? d - 1 : d), O = A.indexOf("\r");
        O != -1 ? (s.push(A.slice(0, O)), r += O + 1) : (s.push(A), r = d + 1);
      }
      return s;
    } : function (t) {
      return t.split(/\r\n?|\n/);
    }, Ar = window.getSelection ? function (t) {
      try {
        return t.selectionStart != t.selectionEnd;
      } catch {
        return !1;
      }
    } : function (t) {
      var r;
      try {
        r = t.ownerDocument.selection.createRange();
      } catch {
      }
      return !r || r.parentElement() != t ? !1 : r.compareEndPoints("StartToEnd", r) != 0;
    }, zn = function () {
      var t = F("div");
      return "oncopy" in t ? !0 : (t.setAttribute("oncopy", "return;"), typeof t.oncopy == "function");
    }(), Wn = null;
    function ko(t) {
      if (Wn != null)
        return Wn;
      var r = k(t, F("span", "x")), s = r.getBoundingClientRect(), a = W(r, 0, 1).getBoundingClientRect();
      return Wn = Math.abs(s.left - a.left) > 1;
    }
    var Ln = {}, Cr = {};
    function Ho(t, r) {
      arguments.length > 2 && (r.dependencies = Array.prototype.slice.call(arguments, 2)), Ln[t] = r;
    }
    function li(t, r) {
      Cr[t] = r;
    }
    function vn(t) {
      if (typeof t == "string" && Cr.hasOwnProperty(t))
        t = Cr[t];
      else if (t && typeof t.name == "string" && Cr.hasOwnProperty(t.name)) {
        var r = Cr[t.name];
        typeof r == "string" && (r = { name: r }), t = yr(r, t), t.name = r.name;
      } else {
        if (typeof t == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(t))
          return vn("application/xml");
        if (typeof t == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(t))
          return vn("application/json");
      }
      return typeof t == "string" ? { name: t } : t || { name: "null" };
    }
    function tr(t, r) {
      r = vn(r);
      var s = Ln[r.name];
      if (!s)
        return tr(t, "text/plain");
      var a = s(t, r);
      if (Sr.hasOwnProperty(r.name)) {
        var d = Sr[r.name];
        for (var A in d)
          !d.hasOwnProperty(A) || (a.hasOwnProperty(A) && (a["_" + A] = a[A]), a[A] = d[A]);
      }
      if (a.name = r.name, r.helperType && (a.helperType = r.helperType), r.modeProps)
        for (var O in r.modeProps)
          a[O] = r.modeProps[O];
      return a;
    }
    var Sr = {};
    function Vo(t, r) {
      var s = Sr.hasOwnProperty(t) ? Sr[t] : Sr[t] = {};
      le(r, s);
    }
    function nr(t, r) {
      if (r === !0)
        return r;
      if (t.copyState)
        return t.copyState(r);
      var s = {};
      for (var a in r) {
        var d = r[a];
        d instanceof Array && (d = d.concat([])), s[a] = d;
      }
      return s;
    }
    function Er(t, r) {
      for (var s; t.innerMode && (s = t.innerMode(r), !(!s || s.mode == t));)
        r = s.state, t = s.mode;
      return s || { mode: t, state: r };
    }
    function Vi(t, r, s) {
      return t.startState ? t.startState(r, s) : !0;
    }
    var It = function (t, r, s) {
      this.pos = this.start = 0, this.string = t, this.tabSize = r || 8, this.lastColumnPos = this.lastColumnValue = 0, this.lineStart = 0, this.lineOracle = s;
    };
    It.prototype.eol = function () {
      return this.pos >= this.string.length;
    }, It.prototype.sol = function () {
      return this.pos == this.lineStart;
    }, It.prototype.peek = function () {
      return this.string.charAt(this.pos) || void 0;
    }, It.prototype.next = function () {
      if (this.pos < this.string.length)
        return this.string.charAt(this.pos++);
    }, It.prototype.eat = function (t) {
      var r = this.string.charAt(this.pos), s;
      if (typeof t == "string" ? s = r == t : s = r && (t.test ? t.test(r) : t(r)), s)
        return ++this.pos, r;
    }, It.prototype.eatWhile = function (t) {
      for (var r = this.pos; this.eat(t);)
        ;
      return this.pos > r;
    }, It.prototype.eatSpace = function () {
      for (var t = this.pos; /[\s\u00a0]/.test(this.string.charAt(this.pos));)
        ++this.pos;
      return this.pos > t;
    }, It.prototype.skipToEnd = function () {
      this.pos = this.string.length;
    }, It.prototype.skipTo = function (t) {
      var r = this.string.indexOf(t, this.pos);
      if (r > -1)
        return this.pos = r, !0;
    }, It.prototype.backUp = function (t) {
      this.pos -= t;
    }, It.prototype.column = function () {
      return this.lastColumnPos < this.start && (this.lastColumnValue = ue(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue - (this.lineStart ? ue(this.string, this.lineStart, this.tabSize) : 0);
    }, It.prototype.indentation = function () {
      return ue(this.string, null, this.tabSize) - (this.lineStart ? ue(this.string, this.lineStart, this.tabSize) : 0);
    }, It.prototype.match = function (t, r, s) {
      if (typeof t == "string") {
        var a = function (O) {
          return s ? O.toLowerCase() : O;
        }, d = this.string.substr(this.pos, t.length);
        if (a(d) == a(t))
          return r !== !1 && (this.pos += t.length), !0;
      } else {
        var A = this.string.slice(this.pos).match(t);
        return A && A.index > 0 ? null : (A && r !== !1 && (this.pos += A[0].length), A);
      }
    }, It.prototype.current = function () {
      return this.string.slice(this.start, this.pos);
    }, It.prototype.hideFirstChars = function (t, r) {
      this.lineStart += t;
      try {
        return r();
      } finally {
        this.lineStart -= t;
      }
    }, It.prototype.lookAhead = function (t) {
      var r = this.lineOracle;
      return r && r.lookAhead(t);
    }, It.prototype.baseToken = function () {
      var t = this.lineOracle;
      return t && t.baseToken(this.pos);
    };
    function Be(t, r) {
      if (r -= t.first, r < 0 || r >= t.size)
        throw new Error("There is no line " + (r + t.first) + " in the document.");
      for (var s = t; !s.lines;)
        for (var a = 0; ; ++a) {
          var d = s.children[a], A = d.chunkSize();
          if (r < A) {
            s = d;
            break;
          }
          r -= A;
        }
      return s.lines[r];
    }
    function rr(t, r, s) {
      var a = [], d = r.line;
      return t.iter(r.line, s.line + 1, function (A) {
        var O = A.text;
        d == s.line && (O = O.slice(0, s.ch)), d == r.line && (O = O.slice(r.ch)), a.push(O), ++d;
      }), a;
    }
    function ai(t, r, s) {
      var a = [];
      return t.iter(r, s, function (d) {
        a.push(d.text);
      }), a;
    }
    function Fn(t, r) {
      var s = r - t.height;
      if (s)
        for (var a = t; a; a = a.parent)
          a.height += s;
    }
    function ht(t) {
      if (t.parent == null)
        return null;
      for (var r = t.parent, s = se(r.lines, t), a = r.parent; a; r = a, a = a.parent)
        for (var d = 0; a.children[d] != r; ++d)
          s += a.children[d].chunkSize();
      return s + r.first;
    }
    function Gn(t, r) {
      var s = t.first;
      e:
      do {
        for (var a = 0; a < t.children.length; ++a) {
          var d = t.children[a], A = d.height;
          if (r < A) {
            t = d;
            continue e;
          }
          r -= A, s += d.chunkSize();
        }
        return s;
      } while (!t.lines);
      for (var O = 0; O < t.lines.length; ++O) {
        var $ = t.lines[O], V = $.height;
        if (r < V)
          break;
        r -= V;
      }
      return s + O;
    }
    function z(t, r) {
      return r >= t.first && r < t.first + t.size;
    }
    function J(t, r) {
      return String(t.lineNumberFormatter(r + t.firstLineNumber));
    }
    function ee(t, r, s) {
      if (s === void 0 && (s = null), !(this instanceof ee))
        return new ee(t, r, s);
      this.line = t, this.ch = r, this.sticky = s;
    }
    function ce(t, r) {
      return t.line - r.line || t.ch - r.ch;
    }
    function Ge(t, r) {
      return t.sticky == r.sticky && ce(t, r) == 0;
    }
    function lt(t) {
      return ee(t.line, t.ch);
    }
    function ut(t, r) {
      return ce(t, r) < 0 ? r : t;
    }
    function kt(t, r) {
      return ce(t, r) < 0 ? t : r;
    }
    function Sn(t, r) {
      return Math.max(t.first, Math.min(r, t.first + t.size - 1));
    }
    function Ye(t, r) {
      if (r.line < t.first)
        return ee(t.first, 0);
      var s = t.first + t.size - 1;
      return r.line > s ? ee(s, Be(t, s).text.length) : Yc(r, Be(t, r.line).text.length);
    }
    function Yc(t, r) {
      var s = t.ch;
      return s == null || s > r ? ee(t.line, r) : s < 0 ? ee(t.line, 0) : t;
    }
    function au(t, r) {
      for (var s = [], a = 0; a < r.length; a++)
        s[a] = Ye(t, r[a]);
      return s;
    }
    var Uo = function (t, r) {
      this.state = t, this.lookAhead = r;
    }, Yn = function (t, r, s, a) {
      this.state = r, this.doc = t, this.line = s, this.maxLookAhead = a || 0, this.baseTokens = null, this.baseTokenPos = 1;
    };
    Yn.prototype.lookAhead = function (t) {
      var r = this.doc.getLine(this.line + t);
      return r != null && t > this.maxLookAhead && (this.maxLookAhead = t), r;
    }, Yn.prototype.baseToken = function (t) {
      if (!this.baseTokens)
        return null;
      for (; this.baseTokens[this.baseTokenPos] <= t;)
        this.baseTokenPos += 2;
      var r = this.baseTokens[this.baseTokenPos + 1];
      return {
        type: r && r.replace(/( |^)overlay .*/, ""),
        size: this.baseTokens[this.baseTokenPos] - t
      };
    }, Yn.prototype.nextLine = function () {
      this.line++, this.maxLookAhead > 0 && this.maxLookAhead--;
    }, Yn.fromSaved = function (t, r, s) {
      return r instanceof Uo ? new Yn(t, nr(t.mode, r.state), s, r.lookAhead) : new Yn(t, nr(t.mode, r), s);
    }, Yn.prototype.save = function (t) {
      var r = t !== !1 ? nr(this.doc.mode, this.state) : this.state;
      return this.maxLookAhead > 0 ? new Uo(r, this.maxLookAhead) : r;
    };
    function su(t, r, s, a) {
      var d = [t.state.modeGen], A = {};
      hu(
        t,
        r.text,
        t.doc.mode,
        s,
        function (U, G) {
          return d.push(U, G);
        },
        A,
        a
      );
      for (var O = s.state, $ = function (U) {
        s.baseTokens = d;
        var G = t.state.overlays[U], K = 1, oe = 0;
        s.state = !0, hu(t, r.text, G.mode, s, function (re, pe) {
          for (var ye = K; oe < re;) {
            var Ce = d[K];
            Ce > re && d.splice(K, 1, re, d[K + 1], Ce), K += 2, oe = Math.min(re, Ce);
          }
          if (!!pe)
            if (G.opaque)
              d.splice(ye, K - ye, re, "overlay " + pe), K = ye + 2;
            else
              for (; ye < K; ye += 2) {
                var Te = d[ye + 1];
                d[ye + 1] = (Te ? Te + " " : "") + "overlay " + pe;
              }
        }, A), s.state = O, s.baseTokens = null, s.baseTokenPos = 1;
      }, V = 0; V < t.state.overlays.length; ++V)
        $(V);
      return { styles: d, classes: A.bgClass || A.textClass ? A : null };
    }
    function uu(t, r, s) {
      if (!r.styles || r.styles[0] != t.state.modeGen) {
        var a = Ui(t, ht(r)), d = r.text.length > t.options.maxHighlightLength && nr(t.doc.mode, a.state), A = su(t, r, a);
        d && (a.state = d), r.stateAfter = a.save(!d), r.styles = A.styles, A.classes ? r.styleClasses = A.classes : r.styleClasses && (r.styleClasses = null), s === t.doc.highlightFrontier && (t.doc.modeFrontier = Math.max(t.doc.modeFrontier, ++t.doc.highlightFrontier));
      }
      return r.styles;
    }
    function Ui(t, r, s) {
      var a = t.doc, d = t.display;
      if (!a.mode.startState)
        return new Yn(a, !0, r);
      var A = Qc(t, r, s), O = A > a.first && Be(a, A - 1).stateAfter, $ = O ? Yn.fromSaved(a, O, A) : new Yn(a, Vi(a.mode), A);
      return a.iter(A, r, function (V) {
        _l(t, V.text, $);
        var U = $.line;
        V.stateAfter = U == r - 1 || U % 5 == 0 || U >= d.viewFrom && U < d.viewTo ? $.save() : null, $.nextLine();
      }), s && (a.modeFrontier = $.line), $;
    }
    function _l(t, r, s, a) {
      var d = t.doc.mode, A = new It(r, t.options.tabSize, s);
      for (A.start = A.pos = a || 0, r == "" && du(d, s.state); !A.eol();)
        ea(d, A, s.state), A.start = A.pos;
    }
    function du(t, r) {
      if (t.blankLine)
        return t.blankLine(r);
      if (!!t.innerMode) {
        var s = Er(t, r);
        if (s.mode.blankLine)
          return s.mode.blankLine(s.state);
      }
    }
    function ea(t, r, s, a) {
      for (var d = 0; d < 10; d++) {
        a && (a[0] = Er(t, s).mode);
        var A = t.token(r, s);
        if (r.pos > r.start)
          return A;
      }
      throw new Error("Mode " + t.name + " failed to advance stream.");
    }
    var fu = function (t, r, s) {
      this.start = t.start, this.end = t.pos, this.string = t.current(), this.type = r || null, this.state = s;
    };
    function cu(t, r, s, a) {
      var d = t.doc, A = d.mode, O;
      r = Ye(d, r);
      var $ = Be(d, r.line), V = Ui(t, r.line, s), U = new It($.text, t.options.tabSize, V), G;
      for (a && (G = []); (a || U.pos < r.ch) && !U.eol();)
        U.start = U.pos, O = ea(A, U, V.state), a && G.push(new fu(U, O, nr(d.mode, V.state)));
      return a ? G : new fu(U, O, V.state);
    }
    function pu(t, r) {
      if (t)
        for (; ;) {
          var s = t.match(/(?:^|\s+)line-(background-)?(\S+)/);
          if (!s)
            break;
          t = t.slice(0, s.index) + t.slice(s.index + s[0].length);
          var a = s[1] ? "bgClass" : "textClass";
          r[a] == null ? r[a] = s[2] : new RegExp("(?:^|\\s)" + s[2] + "(?:$|\\s)").test(r[a]) || (r[a] += " " + s[2]);
        }
      return t;
    }
    function hu(t, r, s, a, d, A, O) {
      var $ = s.flattenSpans;
      $ == null && ($ = t.options.flattenSpans);
      var V = 0, U = null, G = new It(r, t.options.tabSize, a), K, oe = t.options.addModeClass && [null];
      for (r == "" && pu(du(s, a.state), A); !G.eol();) {
        if (G.pos > t.options.maxHighlightLength ? ($ = !1, O && _l(t, r, a, G.pos), G.pos = r.length, K = null) : K = pu(ea(s, G, a.state, oe), A), oe) {
          var re = oe[0].name;
          re && (K = "m-" + (K ? re + " " + K : re));
        }
        if (!$ || U != K) {
          for (; V < G.start;)
            V = Math.min(G.start, V + 5e3), d(V, U);
          U = K;
        }
        G.start = G.pos;
      }
      for (; V < G.pos;) {
        var pe = Math.min(G.pos, V + 5e3);
        d(pe, U), V = pe;
      }
    }
    function Qc(t, r, s) {
      for (var a, d, A = t.doc, O = s ? -1 : r - (t.doc.mode.innerMode ? 1e3 : 100), $ = r; $ > O; --$) {
        if ($ <= A.first)
          return A.first;
        var V = Be(A, $ - 1), U = V.stateAfter;
        if (U && (!s || $ + (U instanceof Uo ? U.lookAhead : 0) <= A.modeFrontier))
          return $;
        var G = ue(V.text, null, t.options.tabSize);
        (d == null || a > G) && (d = $ - 1, a = G);
      }
      return d;
    }
    function Kc(t, r) {
      if (t.modeFrontier = Math.min(t.modeFrontier, r), !(t.highlightFrontier < r - 10)) {
        for (var s = t.first, a = r - 1; a > s; a--) {
          var d = Be(t, a).stateAfter;
          if (d && (!(d instanceof Uo) || a + d.lookAhead < r)) {
            s = a + 1;
            break;
          }
        }
        t.highlightFrontier = Math.min(t.highlightFrontier, s);
      }
    }
    var vu = !1, ir = !1;
    function Jc() {
      vu = !0;
    }
    function Xc() {
      ir = !0;
    }
    function jo(t, r, s) {
      this.marker = t, this.from = r, this.to = s;
    }
    function ji(t, r) {
      if (t)
        for (var s = 0; s < t.length; ++s) {
          var a = t[s];
          if (a.marker == r)
            return a;
        }
    }
    function Zc(t, r) {
      for (var s, a = 0; a < t.length; ++a)
        t[a] != r && (s || (s = [])).push(t[a]);
      return s;
    }
    function qc(t, r, s) {
      var a = s && window.WeakSet && (s.markedSpans || (s.markedSpans = /* @__PURE__ */ new WeakSet()));
      a && t.markedSpans && a.has(t.markedSpans) ? t.markedSpans.push(r) : (t.markedSpans = t.markedSpans ? t.markedSpans.concat([r]) : [r], a && a.add(t.markedSpans)), r.marker.attachLine(t);
    }
    function _c(t, r, s) {
      var a;
      if (t)
        for (var d = 0; d < t.length; ++d) {
          var A = t[d], O = A.marker, $ = A.from == null || (O.inclusiveLeft ? A.from <= r : A.from < r);
          if ($ || A.from == r && O.type == "bookmark" && (!s || !A.marker.insertLeft)) {
            var V = A.to == null || (O.inclusiveRight ? A.to >= r : A.to > r);
            (a || (a = [])).push(new jo(O, A.from, V ? null : A.to));
          }
        }
      return a;
    }
    function ep(t, r, s) {
      var a;
      if (t)
        for (var d = 0; d < t.length; ++d) {
          var A = t[d], O = A.marker, $ = A.to == null || (O.inclusiveRight ? A.to >= r : A.to > r);
          if ($ || A.from == r && O.type == "bookmark" && (!s || A.marker.insertLeft)) {
            var V = A.from == null || (O.inclusiveLeft ? A.from <= r : A.from < r);
            (a || (a = [])).push(new jo(
              O,
              V ? null : A.from - r,
              A.to == null ? null : A.to - r
            ));
          }
        }
      return a;
    }
    function ta(t, r) {
      if (r.full)
        return null;
      var s = z(t, r.from.line) && Be(t, r.from.line).markedSpans, a = z(t, r.to.line) && Be(t, r.to.line).markedSpans;
      if (!s && !a)
        return null;
      var d = r.from.ch, A = r.to.ch, O = ce(r.from, r.to) == 0, $ = _c(s, d, O), V = ep(a, A, O), U = r.text.length == 1, G = He(r.text).length + (U ? d : 0);
      if ($)
        for (var K = 0; K < $.length; ++K) {
          var oe = $[K];
          if (oe.to == null) {
            var re = ji(V, oe.marker);
            re ? U && (oe.to = re.to == null ? null : re.to + G) : oe.to = d;
          }
        }
      if (V)
        for (var pe = 0; pe < V.length; ++pe) {
          var ye = V[pe];
          if (ye.to != null && (ye.to += G), ye.from == null) {
            var Ce = ji($, ye.marker);
            Ce || (ye.from = G, U && ($ || ($ = [])).push(ye));
          } else
            ye.from += G, U && ($ || ($ = [])).push(ye);
        }
      $ && ($ = mu($)), V && V != $ && (V = mu(V));
      var Te = [$];
      if (!U) {
        var Fe = r.text.length - 2, De;
        if (Fe > 0 && $)
          for (var Le = 0; Le < $.length; ++Le)
            $[Le].to == null && (De || (De = [])).push(new jo($[Le].marker, null, null));
        for (var Ue = 0; Ue < Fe; ++Ue)
          Te.push(De);
        Te.push(V);
      }
      return Te;
    }
    function mu(t) {
      for (var r = 0; r < t.length; ++r) {
        var s = t[r];
        s.from != null && s.from == s.to && s.marker.clearWhenEmpty !== !1 && t.splice(r--, 1);
      }
      return t.length ? t : null;
    }
    function tp(t, r, s) {
      var a = null;
      if (t.iter(r.line, s.line + 1, function (re) {
        if (re.markedSpans)
          for (var pe = 0; pe < re.markedSpans.length; ++pe) {
            var ye = re.markedSpans[pe].marker;
            ye.readOnly && (!a || se(a, ye) == -1) && (a || (a = [])).push(ye);
          }
      }), !a)
        return null;
      for (var d = [{ from: r, to: s }], A = 0; A < a.length; ++A)
        for (var O = a[A], $ = O.find(0), V = 0; V < d.length; ++V) {
          var U = d[V];
          if (!(ce(U.to, $.from) < 0 || ce(U.from, $.to) > 0)) {
            var G = [V, 1], K = ce(U.from, $.from), oe = ce(U.to, $.to);
            (K < 0 || !O.inclusiveLeft && !K) && G.push({ from: U.from, to: $.from }), (oe > 0 || !O.inclusiveRight && !oe) && G.push({ from: $.to, to: U.to }), d.splice.apply(d, G), V += G.length - 3;
          }
        }
      return d;
    }
    function gu(t) {
      var r = t.markedSpans;
      if (!!r) {
        for (var s = 0; s < r.length; ++s)
          r[s].marker.detachLine(t);
        t.markedSpans = null;
      }
    }
    function yu(t, r) {
      if (!!r) {
        for (var s = 0; s < r.length; ++s)
          r[s].marker.attachLine(t);
        t.markedSpans = r;
      }
    }
    function zo(t) {
      return t.inclusiveLeft ? -1 : 0;
    }
    function Wo(t) {
      return t.inclusiveRight ? 1 : 0;
    }
    function na(t, r) {
      var s = t.lines.length - r.lines.length;
      if (s != 0)
        return s;
      var a = t.find(), d = r.find(), A = ce(a.from, d.from) || zo(t) - zo(r);
      if (A)
        return -A;
      var O = ce(a.to, d.to) || Wo(t) - Wo(r);
      return O || r.id - t.id;
    }
    function bu(t, r) {
      var s = ir && t.markedSpans, a;
      if (s)
        for (var d = void 0, A = 0; A < s.length; ++A)
          d = s[A], d.marker.collapsed && (r ? d.from : d.to) == null && (!a || na(a, d.marker) < 0) && (a = d.marker);
      return a;
    }
    function Au(t) {
      return bu(t, !0);
    }
    function Go(t) {
      return bu(t, !1);
    }
    function np(t, r) {
      var s = ir && t.markedSpans, a;
      if (s)
        for (var d = 0; d < s.length; ++d) {
          var A = s[d];
          A.marker.collapsed && (A.from == null || A.from < r) && (A.to == null || A.to > r) && (!a || na(a, A.marker) < 0) && (a = A.marker);
        }
      return a;
    }
    function Cu(t, r, s, a, d) {
      var A = Be(t, r), O = ir && A.markedSpans;
      if (O)
        for (var $ = 0; $ < O.length; ++$) {
          var V = O[$];
          if (!!V.marker.collapsed) {
            var U = V.marker.find(0), G = ce(U.from, s) || zo(V.marker) - zo(d), K = ce(U.to, a) || Wo(V.marker) - Wo(d);
            if (!(G >= 0 && K <= 0 || G <= 0 && K >= 0) && (G <= 0 && (V.marker.inclusiveRight && d.inclusiveLeft ? ce(U.to, s) >= 0 : ce(U.to, s) > 0) || G >= 0 && (V.marker.inclusiveRight && d.inclusiveLeft ? ce(U.from, a) <= 0 : ce(U.from, a) < 0)))
              return !0;
          }
        }
    }
    function Pn(t) {
      for (var r; r = Au(t);)
        t = r.find(-1, !0).line;
      return t;
    }
    function rp(t) {
      for (var r; r = Go(t);)
        t = r.find(1, !0).line;
      return t;
    }
    function ip(t) {
      for (var r, s; r = Go(t);)
        t = r.find(1, !0).line, (s || (s = [])).push(t);
      return s;
    }
    function ra(t, r) {
      var s = Be(t, r), a = Pn(s);
      return s == a ? r : ht(a);
    }
    function Su(t, r) {
      if (r > t.lastLine())
        return r;
      var s = Be(t, r), a;
      if (!wr(t, s))
        return r;
      for (; a = Go(s);)
        s = a.find(1, !0).line;
      return ht(s) + 1;
    }
    function wr(t, r) {
      var s = ir && r.markedSpans;
      if (s) {
        for (var a = void 0, d = 0; d < s.length; ++d)
          if (a = s[d], !!a.marker.collapsed) {
            if (a.from == null)
              return !0;
            if (!a.marker.widgetNode && a.from == 0 && a.marker.inclusiveLeft && ia(t, r, a))
              return !0;
          }
      }
    }
    function ia(t, r, s) {
      if (s.to == null) {
        var a = s.marker.find(1, !0);
        return ia(t, a.line, ji(a.line.markedSpans, s.marker));
      }
      if (s.marker.inclusiveRight && s.to == r.text.length)
        return !0;
      for (var d = void 0, A = 0; A < r.markedSpans.length; ++A)
        if (d = r.markedSpans[A], d.marker.collapsed && !d.marker.widgetNode && d.from == s.to && (d.to == null || d.to != s.from) && (d.marker.inclusiveLeft || s.marker.inclusiveRight) && ia(t, r, d))
          return !0;
    }
    function or(t) {
      t = Pn(t);
      for (var r = 0, s = t.parent, a = 0; a < s.lines.length; ++a) {
        var d = s.lines[a];
        if (d == t)
          break;
        r += d.height;
      }
      for (var A = s.parent; A; s = A, A = s.parent)
        for (var O = 0; O < A.children.length; ++O) {
          var $ = A.children[O];
          if ($ == s)
            break;
          r += $.height;
        }
      return r;
    }
    function Yo(t) {
      if (t.height == 0)
        return 0;
      for (var r = t.text.length, s, a = t; s = Au(a);) {
        var d = s.find(0, !0);
        a = d.from.line, r += d.from.ch - d.to.ch;
      }
      for (a = t; s = Go(a);) {
        var A = s.find(0, !0);
        r -= a.text.length - A.from.ch, a = A.to.line, r += a.text.length - A.to.ch;
      }
      return r;
    }
    function oa(t) {
      var r = t.display, s = t.doc;
      r.maxLine = Be(s, s.first), r.maxLineLength = Yo(r.maxLine), r.maxLineChanged = !0, s.iter(function (a) {
        var d = Yo(a);
        d > r.maxLineLength && (r.maxLineLength = d, r.maxLine = a);
      });
    }
    var si = function (t, r, s) {
      this.text = t, yu(this, r), this.height = s ? s(this) : 1;
    };
    si.prototype.lineNo = function () {
      return ht(this);
    }, Ct(si);
    function op(t, r, s, a) {
      t.text = r, t.stateAfter && (t.stateAfter = null), t.styles && (t.styles = null), t.order != null && (t.order = null), gu(t), yu(t, s);
      var d = a ? a(t) : 1;
      d != t.height && Fn(t, d);
    }
    function lp(t) {
      t.parent = null, gu(t);
    }
    var ap = {}, sp = {};
    function Eu(t, r) {
      if (!t || /^\s*$/.test(t))
        return null;
      var s = r.addModeClass ? sp : ap;
      return s[t] || (s[t] = t.replace(/\S+/g, "cm-$&"));
    }
    function wu(t, r) {
      var s = j("span", null, null, b ? "padding-right: .1px" : null), a = {
        pre: j("pre", [s], "CodeMirror-line"),
        content: s,
        col: 0,
        pos: 0,
        cm: t,
        trailingSpace: !1,
        splitSpaces: t.getOption("lineWrapping")
      };
      r.measure = {};
      for (var d = 0; d <= (r.rest ? r.rest.length : 0); d++) {
        var A = d ? r.rest[d - 1] : r.line, O = void 0;
        a.pos = 0, a.addToken = dp, Bo(t.display.measure) && (O = je(A, t.doc.direction)) && (a.addToken = cp(a.addToken, O)), a.map = [];
        var $ = r != t.display.externalMeasured && ht(A);
        pp(A, a, uu(t, A, $)), A.styleClasses && (A.styleClasses.bgClass && (a.bgClass = q(A.styleClasses.bgClass, a.bgClass || "")), A.styleClasses.textClass && (a.textClass = q(A.styleClasses.textClass, a.textClass || ""))), a.map.length == 0 && a.map.push(0, 0, a.content.appendChild(ql(t.display.measure))), d == 0 ? (r.measure.map = a.map, r.measure.cache = {}) : ((r.measure.maps || (r.measure.maps = [])).push(a.map), (r.measure.caches || (r.measure.caches = [])).push({}));
      }
      if (b) {
        var V = a.content.lastChild;
        (/\bcm-tab\b/.test(V.className) || V.querySelector && V.querySelector(".cm-tab")) && (a.content.className = "cm-tab-wrap-hack");
      }
      return $e(t, "renderLine", t, r.line, a.pre), a.pre.className && (a.textClass = q(a.pre.className, a.textClass || "")), a;
    }
    function up(t) {
      var r = F("span", "\u2022", "cm-invalidchar");
      return r.title = "\\u" + t.charCodeAt(0).toString(16), r.setAttribute("aria-label", r.title), r;
    }
    function dp(t, r, s, a, d, A, O) {
      if (!!r) {
        var $ = t.splitSpaces ? fp(r, t.trailingSpace) : r, V = t.cm.state.specialChars, U = !1, G;
        if (!V.test(r))
          t.col += r.length, G = document.createTextNode($), t.map.push(t.pos, t.pos + r.length, G), c && v < 9 && (U = !0), t.pos += r.length;
        else {
          G = document.createDocumentFragment();
          for (var K = 0; ;) {
            V.lastIndex = K;
            var oe = V.exec(r), re = oe ? oe.index - K : r.length - K;
            if (re) {
              var pe = document.createTextNode($.slice(K, K + re));
              c && v < 9 ? G.appendChild(F("span", [pe])) : G.appendChild(pe), t.map.push(t.pos, t.pos + re, pe), t.col += re, t.pos += re;
            }
            if (!oe)
              break;
            K += re + 1;
            var ye = void 0;
            if (oe[0] == "	") {
              var Ce = t.cm.options.tabSize, Te = Ce - t.col % Ce;
              ye = G.appendChild(F("span", Et(Te), "cm-tab")), ye.setAttribute("role", "presentation"), ye.setAttribute("cm-text", "	"), t.col += Te;
            } else
              oe[0] == "\r" || oe[0] == `
` ? (ye = G.appendChild(F("span", oe[0] == "\r" ? "\u240D" : "\u2424", "cm-invalidchar")), ye.setAttribute("cm-text", oe[0]), t.col += 1) : (ye = t.cm.options.specialCharPlaceholder(oe[0]), ye.setAttribute("cm-text", oe[0]), c && v < 9 ? G.appendChild(F("span", [ye])) : G.appendChild(ye), t.col += 1);
            t.map.push(t.pos, t.pos + 1, ye), t.pos++;
          }
        }
        if (t.trailingSpace = $.charCodeAt(r.length - 1) == 32, s || a || d || U || A || O) {
          var Fe = s || "";
          a && (Fe += a), d && (Fe += d);
          var De = F("span", [G], Fe, A);
          if (O)
            for (var Le in O)
              O.hasOwnProperty(Le) && Le != "style" && Le != "class" && De.setAttribute(Le, O[Le]);
          return t.content.appendChild(De);
        }
        t.content.appendChild(G);
      }
    }
    function fp(t, r) {
      if (t.length > 1 && !/  /.test(t))
        return t;
      for (var s = r, a = "", d = 0; d < t.length; d++) {
        var A = t.charAt(d);
        A == " " && s && (d == t.length - 1 || t.charCodeAt(d + 1) == 32) && (A = "\xA0"), a += A, s = A == " ";
      }
      return a;
    }
    function cp(t, r) {
      return function (s, a, d, A, O, $, V) {
        d = d ? d + " cm-force-border" : "cm-force-border";
        for (var U = s.pos, G = U + a.length; ;) {
          for (var K = void 0, oe = 0; oe < r.length && (K = r[oe], !(K.to > U && K.from <= U)); oe++)
            ;
          if (K.to >= G)
            return t(s, a, d, A, O, $, V);
          t(s, a.slice(0, K.to - U), d, A, null, $, V), A = null, a = a.slice(K.to - U), U = K.to;
        }
      };
    }
    function xu(t, r, s, a) {
      var d = !a && s.widgetNode;
      d && t.map.push(t.pos, t.pos + r, d), !a && t.cm.display.input.needsContentAttribute && (d || (d = t.content.appendChild(document.createElement("span"))), d.setAttribute("cm-marker", s.id)), d && (t.cm.display.input.setUneditable(d), t.content.appendChild(d)), t.pos += r, t.trailingSpace = !1;
    }
    function pp(t, r, s) {
      var a = t.markedSpans, d = t.text, A = 0;
      if (!a) {
        for (var O = 1; O < s.length; O += 2)
          r.addToken(r, d.slice(A, A = s[O]), Eu(s[O + 1], r.cm.options));
        return;
      }
      for (var $ = d.length, V = 0, U = 1, G = "", K, oe, re = 0, pe, ye, Ce, Te, Fe; ;) {
        if (re == V) {
          pe = ye = Ce = oe = "", Fe = null, Te = null, re = 1 / 0;
          for (var De = [], Le = void 0, Ue = 0; Ue < a.length; ++Ue) {
            var Ve = a[Ue], tt = Ve.marker;
            if (tt.type == "bookmark" && Ve.from == V && tt.widgetNode)
              De.push(tt);
            else if (Ve.from <= V && (Ve.to == null || Ve.to > V || tt.collapsed && Ve.to == V && Ve.from == V)) {
              if (Ve.to != null && Ve.to != V && re > Ve.to && (re = Ve.to, ye = ""), tt.className && (pe += " " + tt.className), tt.css && (oe = (oe ? oe + ";" : "") + tt.css), tt.startStyle && Ve.from == V && (Ce += " " + tt.startStyle), tt.endStyle && Ve.to == re && (Le || (Le = [])).push(tt.endStyle, Ve.to), tt.title && ((Fe || (Fe = {})).title = tt.title), tt.attributes)
                for (var At in tt.attributes)
                  (Fe || (Fe = {}))[At] = tt.attributes[At];
              tt.collapsed && (!Te || na(Te.marker, tt) < 0) && (Te = Ve);
            } else
              Ve.from > V && re > Ve.from && (re = Ve.from);
          }
          if (Le)
            for (var Gt = 0; Gt < Le.length; Gt += 2)
              Le[Gt + 1] == re && (ye += " " + Le[Gt]);
          if (!Te || Te.from == V)
            for (var Tt = 0; Tt < De.length; ++Tt)
              xu(r, 0, De[Tt]);
          if (Te && (Te.from || 0) == V) {
            if (xu(
              r,
              (Te.to == null ? $ + 1 : Te.to) - V,
              Te.marker,
              Te.from == null
            ), Te.to == null)
              return;
            Te.to == V && (Te = !1);
          }
        }
        if (V >= $)
          break;
        for (var gn = Math.min($, re); ;) {
          if (G) {
            var un = V + G.length;
            if (!Te) {
              var Pt = un > gn ? G.slice(0, gn - V) : G;
              r.addToken(
                r,
                Pt,
                K ? K + pe : pe,
                Ce,
                V + Pt.length == re ? ye : "",
                oe,
                Fe
              );
            }
            if (un >= gn) {
              G = G.slice(gn - V), V = gn;
              break;
            }
            V = un, Ce = "";
          }
          G = d.slice(A, A = s[U++]), K = Eu(s[U++], r.cm.options);
        }
      }
    }
    function Tu(t, r, s) {
      this.line = r, this.rest = ip(r), this.size = this.rest ? ht(He(this.rest)) - s + 1 : 1, this.node = this.text = null, this.hidden = wr(t, r);
    }
    function Qo(t, r, s) {
      for (var a = [], d, A = r; A < s; A = d) {
        var O = new Tu(t.doc, Be(t.doc, A), A);
        d = A + O.size, a.push(O);
      }
      return a;
    }
    var ui = null;
    function hp(t) {
      ui ? ui.ops.push(t) : t.ownsGroup = ui = {
        ops: [t],
        delayedCallbacks: []
      };
    }
    function vp(t) {
      var r = t.delayedCallbacks, s = 0;
      do {
        for (; s < r.length; s++)
          r[s].call(null);
        for (var a = 0; a < t.ops.length; a++) {
          var d = t.ops[a];
          if (d.cursorActivityHandlers)
            for (; d.cursorActivityCalled < d.cursorActivityHandlers.length;)
              d.cursorActivityHandlers[d.cursorActivityCalled++].call(null, d.cm);
        }
      } while (s < r.length);
    }
    function mp(t, r) {
      var s = t.ownsGroup;
      if (!!s)
        try {
          vp(s);
        } finally {
          ui = null, r(s);
        }
    }
    var zi = null;
    function jt(t, r) {
      var s = ke(t, r);
      if (!!s.length) {
        var a = Array.prototype.slice.call(arguments, 2), d;
        ui ? d = ui.delayedCallbacks : zi ? d = zi : (d = zi = [], setTimeout(gp, 0));
        for (var A = function ($) {
          d.push(function () {
            return s[$].apply(null, a);
          });
        }, O = 0; O < s.length; ++O)
          A(O);
      }
    }
    function gp() {
      var t = zi;
      zi = null;
      for (var r = 0; r < t.length; ++r)
        t[r]();
    }
    function Du(t, r, s, a) {
      for (var d = 0; d < r.changes.length; d++) {
        var A = r.changes[d];
        A == "text" ? bp(t, r) : A == "gutter" ? Ru(t, r, s, a) : A == "class" ? la(t, r) : A == "widget" && Ap(t, r, a);
      }
      r.changes = null;
    }
    function Wi(t) {
      return t.node == t.text && (t.node = F("div", null, null, "position: relative"), t.text.parentNode && t.text.parentNode.replaceChild(t.node, t.text), t.node.appendChild(t.text), c && v < 8 && (t.node.style.zIndex = 2)), t.node;
    }
    function yp(t, r) {
      var s = r.bgClass ? r.bgClass + " " + (r.line.bgClass || "") : r.line.bgClass;
      if (s && (s += " CodeMirror-linebackground"), r.background)
        s ? r.background.className = s : (r.background.parentNode.removeChild(r.background), r.background = null);
      else if (s) {
        var a = Wi(r);
        r.background = a.insertBefore(F("div", null, s), a.firstChild), t.display.input.setUneditable(r.background);
      }
    }
    function Iu(t, r) {
      var s = t.display.externalMeasured;
      return s && s.line == r.line ? (t.display.externalMeasured = null, r.measure = s.measure, s.built) : wu(t, r);
    }
    function bp(t, r) {
      var s = r.text.className, a = Iu(t, r);
      r.text == r.node && (r.node = a.pre), r.text.parentNode.replaceChild(a.pre, r.text), r.text = a.pre, a.bgClass != r.bgClass || a.textClass != r.textClass ? (r.bgClass = a.bgClass, r.textClass = a.textClass, la(t, r)) : s && (r.text.className = s);
    }
    function la(t, r) {
      yp(t, r), r.line.wrapClass ? Wi(r).className = r.line.wrapClass : r.node != r.text && (r.node.className = "");
      var s = r.textClass ? r.textClass + " " + (r.line.textClass || "") : r.line.textClass;
      r.text.className = s || "";
    }
    function Ru(t, r, s, a) {
      if (r.gutter && (r.node.removeChild(r.gutter), r.gutter = null), r.gutterBackground && (r.node.removeChild(r.gutterBackground), r.gutterBackground = null), r.line.gutterClass) {
        var d = Wi(r);
        r.gutterBackground = F(
          "div",
          null,
          "CodeMirror-gutter-background " + r.line.gutterClass,
          "left: " + (t.options.fixedGutter ? a.fixedPos : -a.gutterTotalWidth) + "px; width: " + a.gutterTotalWidth + "px"
        ), t.display.input.setUneditable(r.gutterBackground), d.insertBefore(r.gutterBackground, r.text);
      }
      var A = r.line.gutterMarkers;
      if (t.options.lineNumbers || A) {
        var O = Wi(r), $ = r.gutter = F("div", null, "CodeMirror-gutter-wrapper", "left: " + (t.options.fixedGutter ? a.fixedPos : -a.gutterTotalWidth) + "px");
        if ($.setAttribute("aria-hidden", "true"), t.display.input.setUneditable($), O.insertBefore($, r.text), r.line.gutterClass && ($.className += " " + r.line.gutterClass), t.options.lineNumbers && (!A || !A["CodeMirror-linenumbers"]) && (r.lineNumber = $.appendChild(
          F(
            "div",
            J(t.options, s),
            "CodeMirror-linenumber CodeMirror-gutter-elt",
            "left: " + a.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + t.display.lineNumInnerWidth + "px"
          )
        )), A)
          for (var V = 0; V < t.display.gutterSpecs.length; ++V) {
            var U = t.display.gutterSpecs[V].className, G = A.hasOwnProperty(U) && A[U];
            G && $.appendChild(F(
              "div",
              [G],
              "CodeMirror-gutter-elt",
              "left: " + a.gutterLeft[U] + "px; width: " + a.gutterWidth[U] + "px"
            ));
          }
      }
    }
    function Ap(t, r, s) {
      r.alignable && (r.alignable = null);
      for (var a = P("CodeMirror-linewidget"), d = r.node.firstChild, A = void 0; d; d = A)
        A = d.nextSibling, a.test(d.className) && r.node.removeChild(d);
      Fu(t, r, s);
    }
    function Cp(t, r, s, a) {
      var d = Iu(t, r);
      return r.text = r.node = d.pre, d.bgClass && (r.bgClass = d.bgClass), d.textClass && (r.textClass = d.textClass), la(t, r), Ru(t, r, s, a), Fu(t, r, a), r.node;
    }
    function Fu(t, r, s) {
      if (Mu(t, r.line, r, s, !0), r.rest)
        for (var a = 0; a < r.rest.length; a++)
          Mu(t, r.rest[a], r, s, !1);
    }
    function Mu(t, r, s, a, d) {
      if (!!r.widgets)
        for (var A = Wi(s), O = 0, $ = r.widgets; O < $.length; ++O) {
          var V = $[O], U = F("div", [V.node], "CodeMirror-linewidget" + (V.className ? " " + V.className : ""));
          V.handleMouseEvents || U.setAttribute("cm-ignore-events", "true"), Sp(V, U, s, a), t.display.input.setUneditable(U), d && V.above ? A.insertBefore(U, s.gutter || s.text) : A.appendChild(U), jt(V, "redraw");
        }
    }
    function Sp(t, r, s, a) {
      if (t.noHScroll) {
        (s.alignable || (s.alignable = [])).push(r);
        var d = a.wrapperWidth;
        r.style.left = a.fixedPos + "px", t.coverGutter || (d -= a.gutterTotalWidth, r.style.paddingLeft = a.gutterTotalWidth + "px"), r.style.width = d + "px";
      }
      t.coverGutter && (r.style.zIndex = 5, r.style.position = "relative", t.noHScroll || (r.style.marginLeft = -a.gutterTotalWidth + "px"));
    }
    function Gi(t) {
      if (t.height != null)
        return t.height;
      var r = t.doc.cm;
      if (!r)
        return 0;
      if (!Q(document.body, t.node)) {
        var s = "position: relative;";
        t.coverGutter && (s += "margin-left: -" + r.display.gutters.offsetWidth + "px;"), t.noHScroll && (s += "width: " + r.display.wrapper.clientWidth + "px;"), k(r.display.measure, F("div", [t.node], null, s));
      }
      return t.height = t.node.parentNode.offsetHeight;
    }
    function lr(t, r) {
      for (var s = ln(r); s != t.wrapper; s = s.parentNode)
        if (!s || s.nodeType == 1 && s.getAttribute("cm-ignore-events") == "true" || s.parentNode == t.sizer && s != t.mover)
          return !0;
    }
    function Ko(t) {
      return t.lineSpace.offsetTop;
    }
    function aa(t) {
      return t.mover.offsetHeight - t.lineSpace.offsetHeight;
    }
    function Ou(t) {
      if (t.cachedPaddingH)
        return t.cachedPaddingH;
      var r = k(t.measure, F("pre", "x", "CodeMirror-line-like")), s = window.getComputedStyle ? window.getComputedStyle(r) : r.currentStyle, a = { left: parseInt(s.paddingLeft), right: parseInt(s.paddingRight) };
      return !isNaN(a.left) && !isNaN(a.right) && (t.cachedPaddingH = a), a;
    }
    function Qn(t) {
      return Ae - t.display.nativeBarWidth;
    }
    function jr(t) {
      return t.display.scroller.clientWidth - Qn(t) - t.display.barWidth;
    }
    function sa(t) {
      return t.display.scroller.clientHeight - Qn(t) - t.display.barHeight;
    }
    function Ep(t, r, s) {
      var a = t.options.lineWrapping, d = a && jr(t);
      if (!r.measure.heights || a && r.measure.width != d) {
        var A = r.measure.heights = [];
        if (a) {
          r.measure.width = d;
          for (var O = r.text.firstChild.getClientRects(), $ = 0; $ < O.length - 1; $++) {
            var V = O[$], U = O[$ + 1];
            Math.abs(V.bottom - U.bottom) > 2 && A.push((V.bottom + U.top) / 2 - s.top);
          }
        }
        A.push(s.bottom - s.top);
      }
    }
    function Nu(t, r, s) {
      if (t.line == r)
        return { map: t.measure.map, cache: t.measure.cache };
      if (t.rest) {
        for (var a = 0; a < t.rest.length; a++)
          if (t.rest[a] == r)
            return { map: t.measure.maps[a], cache: t.measure.caches[a] };
        for (var d = 0; d < t.rest.length; d++)
          if (ht(t.rest[d]) > s)
            return { map: t.measure.maps[d], cache: t.measure.caches[d], before: !0 };
      }
    }
    function wp(t, r) {
      r = Pn(r);
      var s = ht(r), a = t.display.externalMeasured = new Tu(t.doc, r, s);
      a.lineN = s;
      var d = a.built = wu(t, a);
      return a.text = d.pre, k(t.display.lineMeasure, d.pre), a;
    }
    function Lu(t, r, s, a) {
      return Kn(t, di(t, r), s, a);
    }
    function ua(t, r) {
      if (r >= t.display.viewFrom && r < t.display.viewTo)
        return t.display.view[Gr(t, r)];
      var s = t.display.externalMeasured;
      if (s && r >= s.lineN && r < s.lineN + s.size)
        return s;
    }
    function di(t, r) {
      var s = ht(r), a = ua(t, s);
      a && !a.text ? a = null : a && a.changes && (Du(t, a, s, ha(t)), t.curOp.forceUpdate = !0), a || (a = wp(t, r));
      var d = Nu(a, r, s);
      return {
        line: r,
        view: a,
        rect: null,
        map: d.map,
        cache: d.cache,
        before: d.before,
        hasHeights: !1
      };
    }
    function Kn(t, r, s, a, d) {
      r.before && (s = -1);
      var A = s + (a || ""), O;
      return r.cache.hasOwnProperty(A) ? O = r.cache[A] : (r.rect || (r.rect = r.view.text.getBoundingClientRect()), r.hasHeights || (Ep(t, r.view, r.rect), r.hasHeights = !0), O = Tp(t, r, s, a), O.bogus || (r.cache[A] = O)), {
        left: O.left,
        right: O.right,
        top: d ? O.rtop : O.top,
        bottom: d ? O.rbottom : O.bottom
      };
    }
    var Pu = { left: 0, right: 0, top: 0, bottom: 0 };
    function $u(t, r, s) {
      for (var a, d, A, O, $, V, U = 0; U < t.length; U += 3)
        if ($ = t[U], V = t[U + 1], r < $ ? (d = 0, A = 1, O = "left") : r < V ? (d = r - $, A = d + 1) : (U == t.length - 3 || r == V && t[U + 3] > r) && (A = V - $, d = A - 1, r >= V && (O = "right")), d != null) {
          if (a = t[U + 2], $ == V && s == (a.insertLeft ? "left" : "right") && (O = s), s == "left" && d == 0)
            for (; U && t[U - 2] == t[U - 3] && t[U - 1].insertLeft;)
              a = t[(U -= 3) + 2], O = "left";
          if (s == "right" && d == V - $)
            for (; U < t.length - 3 && t[U + 3] == t[U + 4] && !t[U + 5].insertLeft;)
              a = t[(U += 3) + 2], O = "right";
          break;
        }
      return { node: a, start: d, end: A, collapse: O, coverStart: $, coverEnd: V };
    }
    function xp(t, r) {
      var s = Pu;
      if (r == "left")
        for (var a = 0; a < t.length && (s = t[a]).left == s.right; a++)
          ;
      else
        for (var d = t.length - 1; d >= 0 && (s = t[d]).left == s.right; d--)
          ;
      return s;
    }
    function Tp(t, r, s, a) {
      var d = $u(r.map, s, a), A = d.node, O = d.start, $ = d.end, V = d.collapse, U;
      if (A.nodeType == 3) {
        for (var G = 0; G < 4; G++) {
          for (; O && Dn(r.line.text.charAt(d.coverStart + O));)
            --O;
          for (; d.coverStart + $ < d.coverEnd && Dn(r.line.text.charAt(d.coverStart + $));)
            ++$;
          if (c && v < 9 && O == 0 && $ == d.coverEnd - d.coverStart ? U = A.parentNode.getBoundingClientRect() : U = xp(W(A, O, $).getClientRects(), a), U.left || U.right || O == 0)
            break;
          $ = O, O = O - 1, V = "right";
        }
        c && v < 11 && (U = Dp(t.display.measure, U));
      } else {
        O > 0 && (V = a = "right");
        var K;
        t.options.lineWrapping && (K = A.getClientRects()).length > 1 ? U = K[a == "right" ? K.length - 1 : 0] : U = A.getBoundingClientRect();
      }
      if (c && v < 9 && !O && (!U || !U.left && !U.right)) {
        var oe = A.parentNode.getClientRects()[0];
        oe ? U = { left: oe.left, right: oe.left + ci(t.display), top: oe.top, bottom: oe.bottom } : U = Pu;
      }
      for (var re = U.top - r.rect.top, pe = U.bottom - r.rect.top, ye = (re + pe) / 2, Ce = r.view.measure.heights, Te = 0; Te < Ce.length - 1 && !(ye < Ce[Te]); Te++)
        ;
      var Fe = Te ? Ce[Te - 1] : 0, De = Ce[Te], Le = {
        left: (V == "right" ? U.right : U.left) - r.rect.left,
        right: (V == "left" ? U.left : U.right) - r.rect.left,
        top: Fe,
        bottom: De
      };
      return !U.left && !U.right && (Le.bogus = !0), t.options.singleCursorHeightPerLine || (Le.rtop = re, Le.rbottom = pe), Le;
    }
    function Dp(t, r) {
      if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !ko(t))
        return r;
      var s = screen.logicalXDPI / screen.deviceXDPI, a = screen.logicalYDPI / screen.deviceYDPI;
      return {
        left: r.left * s,
        right: r.right * s,
        top: r.top * a,
        bottom: r.bottom * a
      };
    }
    function Bu(t) {
      if (t.measure && (t.measure.cache = {}, t.measure.heights = null, t.rest))
        for (var r = 0; r < t.rest.length; r++)
          t.measure.caches[r] = {};
    }
    function ku(t) {
      t.display.externalMeasure = null, M(t.display.lineMeasure);
      for (var r = 0; r < t.display.view.length; r++)
        Bu(t.display.view[r]);
    }
    function Yi(t) {
      ku(t), t.display.cachedCharWidth = t.display.cachedTextHeight = t.display.cachedPaddingH = null, t.options.lineWrapping || (t.display.maxLineChanged = !0), t.display.lineNumChars = null;
    }
    function Hu(t) {
      return E && S ? -(t.body.getBoundingClientRect().left - parseInt(getComputedStyle(t.body).marginLeft)) : t.defaultView.pageXOffset || (t.documentElement || t.body).scrollLeft;
    }
    function Vu(t) {
      return E && S ? -(t.body.getBoundingClientRect().top - parseInt(getComputedStyle(t.body).marginTop)) : t.defaultView.pageYOffset || (t.documentElement || t.body).scrollTop;
    }
    function da(t) {
      var r = Pn(t), s = r.widgets, a = 0;
      if (s)
        for (var d = 0; d < s.length; ++d)
          s[d].above && (a += Gi(s[d]));
      return a;
    }
    function Jo(t, r, s, a, d) {
      if (!d) {
        var A = da(r);
        s.top += A, s.bottom += A;
      }
      if (a == "line")
        return s;
      a || (a = "local");
      var O = or(r);
      if (a == "local" ? O += Ko(t.display) : O -= t.display.viewOffset, a == "page" || a == "window") {
        var $ = t.display.lineSpace.getBoundingClientRect();
        O += $.top + (a == "window" ? 0 : Vu(be(t)));
        var V = $.left + (a == "window" ? 0 : Hu(be(t)));
        s.left += V, s.right += V;
      }
      return s.top += O, s.bottom += O, s;
    }
    function Uu(t, r, s) {
      if (s == "div")
        return r;
      var a = r.left, d = r.top;
      if (s == "page")
        a -= Hu(be(t)), d -= Vu(be(t));
      else if (s == "local" || !s) {
        var A = t.display.sizer.getBoundingClientRect();
        a += A.left, d += A.top;
      }
      var O = t.display.lineSpace.getBoundingClientRect();
      return { left: a - O.left, top: d - O.top };
    }
    function Xo(t, r, s, a, d) {
      return a || (a = Be(t.doc, r.line)), Jo(t, a, Lu(t, a, r.ch, d), s);
    }
    function $n(t, r, s, a, d, A) {
      a = a || Be(t.doc, r.line), d || (d = di(t, a));
      function O(pe, ye) {
        var Ce = Kn(t, d, pe, ye ? "right" : "left", A);
        return ye ? Ce.left = Ce.right : Ce.right = Ce.left, Jo(t, a, Ce, s);
      }
      var $ = je(a, t.doc.direction), V = r.ch, U = r.sticky;
      if (V >= a.text.length ? (V = a.text.length, U = "before") : V <= 0 && (V = 0, U = "after"), !$)
        return O(U == "before" ? V - 1 : V, U == "before");
      function G(pe, ye, Ce) {
        var Te = $[ye], Fe = Te.level == 1;
        return O(Ce ? pe - 1 : pe, Fe != Ce);
      }
      var K = Me($, V, U), oe = rt, re = G(V, K, U == "before");
      return oe != null && (re.other = G(V, oe, U != "before")), re;
    }
    function ju(t, r) {
      var s = 0;
      r = Ye(t.doc, r), t.options.lineWrapping || (s = ci(t.display) * r.ch);
      var a = Be(t.doc, r.line), d = or(a) + Ko(t.display);
      return { left: s, right: s, top: d, bottom: d + a.height };
    }
    function fa(t, r, s, a, d) {
      var A = ee(t, r, s);
      return A.xRel = d, a && (A.outside = a), A;
    }
    function ca(t, r, s) {
      var a = t.doc;
      if (s += t.display.viewOffset, s < 0)
        return fa(a.first, 0, null, -1, -1);
      var d = Gn(a, s), A = a.first + a.size - 1;
      if (d > A)
        return fa(a.first + a.size - 1, Be(a, A).text.length, null, 1, 1);
      r < 0 && (r = 0);
      for (var O = Be(a, d); ;) {
        var $ = Ip(t, O, d, r, s), V = np(O, $.ch + ($.xRel > 0 || $.outside > 0 ? 1 : 0));
        if (!V)
          return $;
        var U = V.find(1);
        if (U.line == d)
          return U;
        O = Be(a, d = U.line);
      }
    }
    function zu(t, r, s, a) {
      a -= da(r);
      var d = r.text.length, A = ct(function (O) {
        return Kn(t, s, O - 1).bottom <= a;
      }, d, 0);
      return d = ct(function (O) {
        return Kn(t, s, O).top > a;
      }, A, d), { begin: A, end: d };
    }
    function Wu(t, r, s, a) {
      s || (s = di(t, r));
      var d = Jo(t, r, Kn(t, s, a), "line").top;
      return zu(t, r, s, d);
    }
    function pa(t, r, s, a) {
      return t.bottom <= s ? !1 : t.top > s ? !0 : (a ? t.left : t.right) > r;
    }
    function Ip(t, r, s, a, d) {
      d -= or(r);
      var A = di(t, r), O = da(r), $ = 0, V = r.text.length, U = !0, G = je(r, t.doc.direction);
      if (G) {
        var K = (t.options.lineWrapping ? Fp : Rp)(t, r, s, A, G, a, d);
        U = K.level != 1, $ = U ? K.from : K.to - 1, V = U ? K.to : K.from - 1;
      }
      var oe = null, re = null, pe = ct(function (Ue) {
        var Ve = Kn(t, A, Ue);
        return Ve.top += O, Ve.bottom += O, pa(Ve, a, d, !1) ? (Ve.top <= d && Ve.left <= a && (oe = Ue, re = Ve), !0) : !1;
      }, $, V), ye, Ce, Te = !1;
      if (re) {
        var Fe = a - re.left < re.right - a, De = Fe == U;
        pe = oe + (De ? 0 : 1), Ce = De ? "after" : "before", ye = Fe ? re.left : re.right;
      } else {
        !U && (pe == V || pe == $) && pe++, Ce = pe == 0 ? "after" : pe == r.text.length ? "before" : Kn(t, A, pe - (U ? 1 : 0)).bottom + O <= d == U ? "after" : "before";
        var Le = $n(t, ee(s, pe, Ce), "line", r, A);
        ye = Le.left, Te = d < Le.top ? -1 : d >= Le.bottom ? 1 : 0;
      }
      return pe = Bt(r.text, pe, 1), fa(s, pe, Ce, Te, a - ye);
    }
    function Rp(t, r, s, a, d, A, O) {
      var $ = ct(function (K) {
        var oe = d[K], re = oe.level != 1;
        return pa($n(
          t,
          ee(s, re ? oe.to : oe.from, re ? "before" : "after"),
          "line",
          r,
          a
        ), A, O, !0);
      }, 0, d.length - 1), V = d[$];
      if ($ > 0) {
        var U = V.level != 1, G = $n(
          t,
          ee(s, U ? V.from : V.to, U ? "after" : "before"),
          "line",
          r,
          a
        );
        pa(G, A, O, !0) && G.top > O && (V = d[$ - 1]);
      }
      return V;
    }
    function Fp(t, r, s, a, d, A, O) {
      var $ = zu(t, r, a, O), V = $.begin, U = $.end;
      /\s/.test(r.text.charAt(U - 1)) && U--;
      for (var G = null, K = null, oe = 0; oe < d.length; oe++) {
        var re = d[oe];
        if (!(re.from >= U || re.to <= V)) {
          var pe = re.level != 1, ye = Kn(t, a, pe ? Math.min(U, re.to) - 1 : Math.max(V, re.from)).right, Ce = ye < A ? A - ye + 1e9 : ye - A;
          (!G || K > Ce) && (G = re, K = Ce);
        }
      }
      return G || (G = d[d.length - 1]), G.from < V && (G = { from: V, to: G.to, level: G.level }), G.to > U && (G = { from: G.from, to: U, level: G.level }), G;
    }
    var zr;
    function fi(t) {
      if (t.cachedTextHeight != null)
        return t.cachedTextHeight;
      if (zr == null) {
        zr = F("pre", null, "CodeMirror-line-like");
        for (var r = 0; r < 49; ++r)
          zr.appendChild(document.createTextNode("x")), zr.appendChild(F("br"));
        zr.appendChild(document.createTextNode("x"));
      }
      k(t.measure, zr);
      var s = zr.offsetHeight / 50;
      return s > 3 && (t.cachedTextHeight = s), M(t.measure), s || 1;
    }
    function ci(t) {
      if (t.cachedCharWidth != null)
        return t.cachedCharWidth;
      var r = F("span", "xxxxxxxxxx"), s = F("pre", [r], "CodeMirror-line-like");
      k(t.measure, s);
      var a = r.getBoundingClientRect(), d = (a.right - a.left) / 10;
      return d > 2 && (t.cachedCharWidth = d), d || 10;
    }
    function ha(t) {
      for (var r = t.display, s = {}, a = {}, d = r.gutters.clientLeft, A = r.gutters.firstChild, O = 0; A; A = A.nextSibling, ++O) {
        var $ = t.display.gutterSpecs[O].className;
        s[$] = A.offsetLeft + A.clientLeft + d, a[$] = A.clientWidth;
      }
      return {
        fixedPos: va(r),
        gutterTotalWidth: r.gutters.offsetWidth,
        gutterLeft: s,
        gutterWidth: a,
        wrapperWidth: r.wrapper.clientWidth
      };
    }
    function va(t) {
      return t.scroller.getBoundingClientRect().left - t.sizer.getBoundingClientRect().left;
    }
    function Gu(t) {
      var r = fi(t.display), s = t.options.lineWrapping, a = s && Math.max(5, t.display.scroller.clientWidth / ci(t.display) - 3);
      return function (d) {
        if (wr(t.doc, d))
          return 0;
        var A = 0;
        if (d.widgets)
          for (var O = 0; O < d.widgets.length; O++)
            d.widgets[O].height && (A += d.widgets[O].height);
        return s ? A + (Math.ceil(d.text.length / a) || 1) * r : A + r;
      };
    }
    function ma(t) {
      var r = t.doc, s = Gu(t);
      r.iter(function (a) {
        var d = s(a);
        d != a.height && Fn(a, d);
      });
    }
    function Wr(t, r, s, a) {
      var d = t.display;
      if (!s && ln(r).getAttribute("cm-not-content") == "true")
        return null;
      var A, O, $ = d.lineSpace.getBoundingClientRect();
      try {
        A = r.clientX - $.left, O = r.clientY - $.top;
      } catch {
        return null;
      }
      var V = ca(t, A, O), U;
      if (a && V.xRel > 0 && (U = Be(t.doc, V.line).text).length == V.ch) {
        var G = ue(U, U.length, t.options.tabSize) - U.length;
        V = ee(V.line, Math.max(0, Math.round((A - Ou(t.display).left) / ci(t.display)) - G));
      }
      return V;
    }
    function Gr(t, r) {
      if (r >= t.display.viewTo || (r -= t.display.viewFrom, r < 0))
        return null;
      for (var s = t.display.view, a = 0; a < s.length; a++)
        if (r -= s[a].size, r < 0)
          return a;
    }
    function an(t, r, s, a) {
      r == null && (r = t.doc.first), s == null && (s = t.doc.first + t.doc.size), a || (a = 0);
      var d = t.display;
      if (a && s < d.viewTo && (d.updateLineNumbers == null || d.updateLineNumbers > r) && (d.updateLineNumbers = r), t.curOp.viewChanged = !0, r >= d.viewTo)
        ir && ra(t.doc, r) < d.viewTo && Tr(t);
      else if (s <= d.viewFrom)
        ir && Su(t.doc, s + a) > d.viewFrom ? Tr(t) : (d.viewFrom += a, d.viewTo += a);
      else if (r <= d.viewFrom && s >= d.viewTo)
        Tr(t);
      else if (r <= d.viewFrom) {
        var A = Zo(t, s, s + a, 1);
        A ? (d.view = d.view.slice(A.index), d.viewFrom = A.lineN, d.viewTo += a) : Tr(t);
      } else if (s >= d.viewTo) {
        var O = Zo(t, r, r, -1);
        O ? (d.view = d.view.slice(0, O.index), d.viewTo = O.lineN) : Tr(t);
      } else {
        var $ = Zo(t, r, r, -1), V = Zo(t, s, s + a, 1);
        $ && V ? (d.view = d.view.slice(0, $.index).concat(Qo(t, $.lineN, V.lineN)).concat(d.view.slice(V.index)), d.viewTo += a) : Tr(t);
      }
      var U = d.externalMeasured;
      U && (s < U.lineN ? U.lineN += a : r < U.lineN + U.size && (d.externalMeasured = null));
    }
    function xr(t, r, s) {
      t.curOp.viewChanged = !0;
      var a = t.display, d = t.display.externalMeasured;
      if (d && r >= d.lineN && r < d.lineN + d.size && (a.externalMeasured = null), !(r < a.viewFrom || r >= a.viewTo)) {
        var A = a.view[Gr(t, r)];
        if (A.node != null) {
          var O = A.changes || (A.changes = []);
          se(O, s) == -1 && O.push(s);
        }
      }
    }
    function Tr(t) {
      t.display.viewFrom = t.display.viewTo = t.doc.first, t.display.view = [], t.display.viewOffset = 0;
    }
    function Zo(t, r, s, a) {
      var d = Gr(t, r), A, O = t.display.view;
      if (!ir || s == t.doc.first + t.doc.size)
        return { index: d, lineN: s };
      for (var $ = t.display.viewFrom, V = 0; V < d; V++)
        $ += O[V].size;
      if ($ != r) {
        if (a > 0) {
          if (d == O.length - 1)
            return null;
          A = $ + O[d].size - r, d++;
        } else
          A = $ - r;
        r += A, s += A;
      }
      for (; ra(t.doc, s) != s;) {
        if (d == (a < 0 ? 0 : O.length - 1))
          return null;
        s += a * O[d - (a < 0 ? 1 : 0)].size, d += a;
      }
      return { index: d, lineN: s };
    }
    function Mp(t, r, s) {
      var a = t.display, d = a.view;
      d.length == 0 || r >= a.viewTo || s <= a.viewFrom ? (a.view = Qo(t, r, s), a.viewFrom = r) : (a.viewFrom > r ? a.view = Qo(t, r, a.viewFrom).concat(a.view) : a.viewFrom < r && (a.view = a.view.slice(Gr(t, r))), a.viewFrom = r, a.viewTo < s ? a.view = a.view.concat(Qo(t, a.viewTo, s)) : a.viewTo > s && (a.view = a.view.slice(0, Gr(t, s)))), a.viewTo = s;
    }
    function Yu(t) {
      for (var r = t.display.view, s = 0, a = 0; a < r.length; a++) {
        var d = r[a];
        !d.hidden && (!d.node || d.changes) && ++s;
      }
      return s;
    }
    function Qi(t) {
      t.display.input.showSelection(t.display.input.prepareSelection());
    }
    function Qu(t, r) {
      r === void 0 && (r = !0);
      var s = t.doc, a = {}, d = a.cursors = document.createDocumentFragment(), A = a.selection = document.createDocumentFragment(), O = t.options.$customCursor;
      O && (r = !0);
      for (var $ = 0; $ < s.sel.ranges.length; $++)
        if (!(!r && $ == s.sel.primIndex)) {
          var V = s.sel.ranges[$];
          if (!(V.from().line >= t.display.viewTo || V.to().line < t.display.viewFrom)) {
            var U = V.empty();
            if (O) {
              var G = O(t, V);
              G && ga(t, G, d);
            } else
              (U || t.options.showCursorWhenSelecting) && ga(t, V.head, d);
            U || Op(t, V, A);
          }
        }
      return a;
    }
    function ga(t, r, s) {
      var a = $n(t, r, "div", null, null, !t.options.singleCursorHeightPerLine), d = s.appendChild(F("div", "\xA0", "CodeMirror-cursor"));
      if (d.style.left = a.left + "px", d.style.top = a.top + "px", d.style.height = Math.max(0, a.bottom - a.top) * t.options.cursorHeight + "px", /\bcm-fat-cursor\b/.test(t.getWrapperElement().className)) {
        var A = Xo(t, r, "div", null, null), O = A.right - A.left;
        d.style.width = (O > 0 ? O : t.defaultCharWidth()) + "px";
      }
      if (a.other) {
        var $ = s.appendChild(F("div", "\xA0", "CodeMirror-cursor CodeMirror-secondarycursor"));
        $.style.display = "", $.style.left = a.other.left + "px", $.style.top = a.other.top + "px", $.style.height = (a.other.bottom - a.other.top) * 0.85 + "px";
      }
    }
    function qo(t, r) {
      return t.top - r.top || t.left - r.left;
    }
    function Op(t, r, s) {
      var a = t.display, d = t.doc, A = document.createDocumentFragment(), O = Ou(t.display), $ = O.left, V = Math.max(a.sizerWidth, jr(t) - a.sizer.offsetLeft) - O.right, U = d.direction == "ltr";
      function G(De, Le, Ue, Ve) {
        Le < 0 && (Le = 0), Le = Math.round(Le), Ve = Math.round(Ve), A.appendChild(F("div", null, "CodeMirror-selected", "position: absolute; left: " + De + `px;
                             top: ` + Le + "px; width: " + (Ue == null ? V - De : Ue) + `px;
                             height: ` + (Ve - Le) + "px"));
      }
      function K(De, Le, Ue) {
        var Ve = Be(d, De), tt = Ve.text.length, At, Gt;
        function Tt(Pt, dn) {
          return Xo(t, ee(De, Pt), "div", Ve, dn);
        }
        function gn(Pt, dn, Jt) {
          var Ht = Wu(t, Ve, null, Pt), $t = dn == "ltr" == (Jt == "after") ? "left" : "right", Rt = Jt == "after" ? Ht.begin : Ht.end - (/\s/.test(Ve.text.charAt(Ht.end - 1)) ? 2 : 1);
          return Tt(Rt, $t)[$t];
        }
        var un = je(Ve, d.direction);
        return hn(un, Le || 0, Ue == null ? tt : Ue, function (Pt, dn, Jt, Ht) {
          var $t = Jt == "ltr", Rt = Tt(Pt, $t ? "left" : "right"), fn = Tt(dn - 1, $t ? "right" : "left"), xi = Le == null && Pt == 0, Or = Ue == null && dn == tt, Zt = Ht == 0, Jn = !un || Ht == un.length - 1;
          if (fn.top - Rt.top <= 3) {
            var Yt = (U ? xi : Or) && Zt, za = (U ? Or : xi) && Jn, ur = Yt ? $ : ($t ? Rt : fn).left, Xr = za ? V : ($t ? fn : Rt).right;
            G(ur, Rt.top, Xr - ur, Rt.bottom);
          } else {
            var Zr, nn, Ti, Wa;
            $t ? (Zr = U && xi && Zt ? $ : Rt.left, nn = U ? V : gn(Pt, Jt, "before"), Ti = U ? $ : gn(dn, Jt, "after"), Wa = U && Or && Jn ? V : fn.right) : (Zr = U ? gn(Pt, Jt, "before") : $, nn = !U && xi && Zt ? V : Rt.right, Ti = !U && Or && Jn ? $ : fn.left, Wa = U ? gn(dn, Jt, "after") : V), G(Zr, Rt.top, nn - Zr, Rt.bottom), Rt.bottom < fn.top && G($, Rt.bottom, null, fn.top), G(Ti, fn.top, Wa - Ti, fn.bottom);
          }
          (!At || qo(Rt, At) < 0) && (At = Rt), qo(fn, At) < 0 && (At = fn), (!Gt || qo(Rt, Gt) < 0) && (Gt = Rt), qo(fn, Gt) < 0 && (Gt = fn);
        }), { start: At, end: Gt };
      }
      var oe = r.from(), re = r.to();
      if (oe.line == re.line)
        K(oe.line, oe.ch, re.ch);
      else {
        var pe = Be(d, oe.line), ye = Be(d, re.line), Ce = Pn(pe) == Pn(ye), Te = K(oe.line, oe.ch, Ce ? pe.text.length + 1 : null).end, Fe = K(re.line, Ce ? 0 : null, re.ch).start;
        Ce && (Te.top < Fe.top - 2 ? (G(Te.right, Te.top, null, Te.bottom), G($, Fe.top, Fe.left, Fe.bottom)) : G(Te.right, Te.top, Fe.left - Te.right, Te.bottom)), Te.bottom < Fe.top && G($, Te.bottom, null, Fe.top);
      }
      s.appendChild(A);
    }
    function ya(t) {
      if (!!t.state.focused) {
        var r = t.display;
        clearInterval(r.blinker);
        var s = !0;
        r.cursorDiv.style.visibility = "", t.options.cursorBlinkRate > 0 ? r.blinker = setInterval(function () {
          t.hasFocus() || pi(t), r.cursorDiv.style.visibility = (s = !s) ? "" : "hidden";
        }, t.options.cursorBlinkRate) : t.options.cursorBlinkRate < 0 && (r.cursorDiv.style.visibility = "hidden");
      }
    }
    function Ku(t) {
      t.hasFocus() || (t.display.input.focus(), t.state.focused || Aa(t));
    }
    function ba(t) {
      t.state.delayingBlurEvent = !0, setTimeout(function () {
        t.state.delayingBlurEvent && (t.state.delayingBlurEvent = !1, t.state.focused && pi(t));
      }, 100);
    }
    function Aa(t, r) {
      t.state.delayingBlurEvent && !t.state.draggingText && (t.state.delayingBlurEvent = !1), t.options.readOnly != "nocursor" && (t.state.focused || ($e(t, "focus", t, r), t.state.focused = !0, te(t.display.wrapper, "CodeMirror-focused"), !t.curOp && t.display.selForContextMenu != t.doc.sel && (t.display.input.reset(), b && setTimeout(function () {
        return t.display.input.reset(!0);
      }, 20)), t.display.input.receivedFocus()), ya(t));
    }
    function pi(t, r) {
      t.state.delayingBlurEvent || (t.state.focused && ($e(t, "blur", t, r), t.state.focused = !1, C(t.display.wrapper, "CodeMirror-focused")), clearInterval(t.display.blinker), setTimeout(function () {
        t.state.focused || (t.display.shift = !1);
      }, 150));
    }
    function _o(t) {
      for (var r = t.display, s = r.lineDiv.offsetTop, a = Math.max(0, r.scroller.getBoundingClientRect().top), d = r.lineDiv.getBoundingClientRect().top, A = 0, O = 0; O < r.view.length; O++) {
        var $ = r.view[O], V = t.options.lineWrapping, U = void 0, G = 0;
        if (!$.hidden) {
          if (d += $.line.height, c && v < 8) {
            var K = $.node.offsetTop + $.node.offsetHeight;
            U = K - s, s = K;
          } else {
            var oe = $.node.getBoundingClientRect();
            U = oe.bottom - oe.top, !V && $.text.firstChild && (G = $.text.firstChild.getBoundingClientRect().right - oe.left - 1);
          }
          var re = $.line.height - U;
          if ((re > 5e-3 || re < -5e-3) && (d < a && (A -= re), Fn($.line, U), Ju($.line), $.rest))
            for (var pe = 0; pe < $.rest.length; pe++)
              Ju($.rest[pe]);
          if (G > t.display.sizerWidth) {
            var ye = Math.ceil(G / ci(t.display));
            ye > t.display.maxLineLength && (t.display.maxLineLength = ye, t.display.maxLine = $.line, t.display.maxLineChanged = !0);
          }
        }
      }
      Math.abs(A) > 2 && (r.scroller.scrollTop += A);
    }
    function Ju(t) {
      if (t.widgets)
        for (var r = 0; r < t.widgets.length; ++r) {
          var s = t.widgets[r], a = s.node.parentNode;
          a && (s.height = a.offsetHeight);
        }
    }
    function el(t, r, s) {
      var a = s && s.top != null ? Math.max(0, s.top) : t.scroller.scrollTop;
      a = Math.floor(a - Ko(t));
      var d = s && s.bottom != null ? s.bottom : a + t.wrapper.clientHeight, A = Gn(r, a), O = Gn(r, d);
      if (s && s.ensure) {
        var $ = s.ensure.from.line, V = s.ensure.to.line;
        $ < A ? (A = $, O = Gn(r, or(Be(r, $)) + t.wrapper.clientHeight)) : Math.min(V, r.lastLine()) >= O && (A = Gn(r, or(Be(r, V)) - t.wrapper.clientHeight), O = V);
      }
      return { from: A, to: Math.max(O, A + 1) };
    }
    function Np(t, r) {
      if (!Xe(t, "scrollCursorIntoView")) {
        var s = t.display, a = s.sizer.getBoundingClientRect(), d = null, A = s.wrapper.ownerDocument;
        if (r.top + a.top < 0 ? d = !0 : r.bottom + a.top > (A.defaultView.innerHeight || A.documentElement.clientHeight) && (d = !1), d != null && !D) {
          var O = F("div", "\u200B", null, `position: absolute;
                         top: ` + (r.top - s.viewOffset - Ko(t.display)) + `px;
                         height: ` + (r.bottom - r.top + Qn(t) + s.barHeight) + `px;
                         left: ` + r.left + "px; width: " + Math.max(2, r.right - r.left) + "px;");
          t.display.lineSpace.appendChild(O), O.scrollIntoView(d), t.display.lineSpace.removeChild(O);
        }
      }
    }
    function Lp(t, r, s, a) {
      a == null && (a = 0);
      var d;
      !t.options.lineWrapping && r == s && (s = r.sticky == "before" ? ee(r.line, r.ch + 1, "before") : r, r = r.ch ? ee(r.line, r.sticky == "before" ? r.ch - 1 : r.ch, "after") : r);
      for (var A = 0; A < 5; A++) {
        var O = !1, $ = $n(t, r), V = !s || s == r ? $ : $n(t, s);
        d = {
          left: Math.min($.left, V.left),
          top: Math.min($.top, V.top) - a,
          right: Math.max($.left, V.left),
          bottom: Math.max($.bottom, V.bottom) + a
        };
        var U = Ca(t, d), G = t.doc.scrollTop, K = t.doc.scrollLeft;
        if (U.scrollTop != null && (Ji(t, U.scrollTop), Math.abs(t.doc.scrollTop - G) > 1 && (O = !0)), U.scrollLeft != null && (Yr(t, U.scrollLeft), Math.abs(t.doc.scrollLeft - K) > 1 && (O = !0)), !O)
          break;
      }
      return d;
    }
    function Pp(t, r) {
      var s = Ca(t, r);
      s.scrollTop != null && Ji(t, s.scrollTop), s.scrollLeft != null && Yr(t, s.scrollLeft);
    }
    function Ca(t, r) {
      var s = t.display, a = fi(t.display);
      r.top < 0 && (r.top = 0);
      var d = t.curOp && t.curOp.scrollTop != null ? t.curOp.scrollTop : s.scroller.scrollTop, A = sa(t), O = {};
      r.bottom - r.top > A && (r.bottom = r.top + A);
      var $ = t.doc.height + aa(s), V = r.top < a, U = r.bottom > $ - a;
      if (r.top < d)
        O.scrollTop = V ? 0 : r.top;
      else if (r.bottom > d + A) {
        var G = Math.min(r.top, (U ? $ : r.bottom) - A);
        G != d && (O.scrollTop = G);
      }
      var K = t.options.fixedGutter ? 0 : s.gutters.offsetWidth, oe = t.curOp && t.curOp.scrollLeft != null ? t.curOp.scrollLeft : s.scroller.scrollLeft - K, re = jr(t) - s.gutters.offsetWidth, pe = r.right - r.left > re;
      return pe && (r.right = r.left + re), r.left < 10 ? O.scrollLeft = 0 : r.left < oe ? O.scrollLeft = Math.max(0, r.left + K - (pe ? 0 : 10)) : r.right > re + oe - 3 && (O.scrollLeft = r.right + (pe ? 0 : 10) - re), O;
    }
    function Sa(t, r) {
      r != null && (tl(t), t.curOp.scrollTop = (t.curOp.scrollTop == null ? t.doc.scrollTop : t.curOp.scrollTop) + r);
    }
    function hi(t) {
      tl(t);
      var r = t.getCursor();
      t.curOp.scrollToPos = { from: r, to: r, margin: t.options.cursorScrollMargin };
    }
    function Ki(t, r, s) {
      (r != null || s != null) && tl(t), r != null && (t.curOp.scrollLeft = r), s != null && (t.curOp.scrollTop = s);
    }
    function $p(t, r) {
      tl(t), t.curOp.scrollToPos = r;
    }
    function tl(t) {
      var r = t.curOp.scrollToPos;
      if (r) {
        t.curOp.scrollToPos = null;
        var s = ju(t, r.from), a = ju(t, r.to);
        Xu(t, s, a, r.margin);
      }
    }
    function Xu(t, r, s, a) {
      var d = Ca(t, {
        left: Math.min(r.left, s.left),
        top: Math.min(r.top, s.top) - a,
        right: Math.max(r.right, s.right),
        bottom: Math.max(r.bottom, s.bottom) + a
      });
      Ki(t, d.scrollLeft, d.scrollTop);
    }
    function Ji(t, r) {
      Math.abs(t.doc.scrollTop - r) < 2 || (n || wa(t, { top: r }), Zu(t, r, !0), n && wa(t), qi(t, 100));
    }
    function Zu(t, r, s) {
      r = Math.max(0, Math.min(t.display.scroller.scrollHeight - t.display.scroller.clientHeight, r)), !(t.display.scroller.scrollTop == r && !s) && (t.doc.scrollTop = r, t.display.scrollbars.setScrollTop(r), t.display.scroller.scrollTop != r && (t.display.scroller.scrollTop = r));
    }
    function Yr(t, r, s, a) {
      r = Math.max(0, Math.min(r, t.display.scroller.scrollWidth - t.display.scroller.clientWidth)), !((s ? r == t.doc.scrollLeft : Math.abs(t.doc.scrollLeft - r) < 2) && !a) && (t.doc.scrollLeft = r, nd(t), t.display.scroller.scrollLeft != r && (t.display.scroller.scrollLeft = r), t.display.scrollbars.setScrollLeft(r));
    }
    function Xi(t) {
      var r = t.display, s = r.gutters.offsetWidth, a = Math.round(t.doc.height + aa(t.display));
      return {
        clientHeight: r.scroller.clientHeight,
        viewHeight: r.wrapper.clientHeight,
        scrollWidth: r.scroller.scrollWidth,
        clientWidth: r.scroller.clientWidth,
        viewWidth: r.wrapper.clientWidth,
        barLeft: t.options.fixedGutter ? s : 0,
        docHeight: a,
        scrollHeight: a + Qn(t) + r.barHeight,
        nativeBarWidth: r.nativeBarWidth,
        gutterWidth: s
      };
    }
    var Qr = function (t, r, s) {
      this.cm = s;
      var a = this.vert = F("div", [F("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar"), d = this.horiz = F("div", [F("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
      a.tabIndex = d.tabIndex = -1, t(a), t(d), de(a, "scroll", function () {
        a.clientHeight && r(a.scrollTop, "vertical");
      }), de(d, "scroll", function () {
        d.clientWidth && r(d.scrollLeft, "horizontal");
      }), this.checkedZeroWidth = !1, c && v < 8 && (this.horiz.style.minHeight = this.vert.style.minWidth = "18px");
    };
    Qr.prototype.update = function (t) {
      var r = t.scrollWidth > t.clientWidth + 1, s = t.scrollHeight > t.clientHeight + 1, a = t.nativeBarWidth;
      if (s) {
        this.vert.style.display = "block", this.vert.style.bottom = r ? a + "px" : "0";
        var d = t.viewHeight - (r ? a : 0);
        this.vert.firstChild.style.height = Math.max(0, t.scrollHeight - t.clientHeight + d) + "px";
      } else
        this.vert.scrollTop = 0, this.vert.style.display = "", this.vert.firstChild.style.height = "0";
      if (r) {
        this.horiz.style.display = "block", this.horiz.style.right = s ? a + "px" : "0", this.horiz.style.left = t.barLeft + "px";
        var A = t.viewWidth - t.barLeft - (s ? a : 0);
        this.horiz.firstChild.style.width = Math.max(0, t.scrollWidth - t.clientWidth + A) + "px";
      } else
        this.horiz.style.display = "", this.horiz.firstChild.style.width = "0";
      return !this.checkedZeroWidth && t.clientHeight > 0 && (a == 0 && this.zeroWidthHack(), this.checkedZeroWidth = !0), { right: s ? a : 0, bottom: r ? a : 0 };
    }, Qr.prototype.setScrollLeft = function (t) {
      this.horiz.scrollLeft != t && (this.horiz.scrollLeft = t), this.disableHoriz && this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
    }, Qr.prototype.setScrollTop = function (t) {
      this.vert.scrollTop != t && (this.vert.scrollTop = t), this.disableVert && this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
    }, Qr.prototype.zeroWidthHack = function () {
      var t = R && !I ? "12px" : "18px";
      this.horiz.style.height = this.vert.style.width = t, this.horiz.style.visibility = this.vert.style.visibility = "hidden", this.disableHoriz = new he(), this.disableVert = new he();
    }, Qr.prototype.enableZeroWidthBar = function (t, r, s) {
      t.style.visibility = "";
      function a() {
        var d = t.getBoundingClientRect(), A = s == "vert" ? document.elementFromPoint(d.right - 1, (d.top + d.bottom) / 2) : document.elementFromPoint((d.right + d.left) / 2, d.bottom - 1);
        A != t ? t.style.visibility = "hidden" : r.set(1e3, a);
      }
      r.set(1e3, a);
    }, Qr.prototype.clear = function () {
      var t = this.horiz.parentNode;
      t.removeChild(this.horiz), t.removeChild(this.vert);
    };
    var Zi = function () {
    };
    Zi.prototype.update = function () {
      return { bottom: 0, right: 0 };
    }, Zi.prototype.setScrollLeft = function () {
    }, Zi.prototype.setScrollTop = function () {
    }, Zi.prototype.clear = function () {
    };
    function vi(t, r) {
      r || (r = Xi(t));
      var s = t.display.barWidth, a = t.display.barHeight;
      qu(t, r);
      for (var d = 0; d < 4 && s != t.display.barWidth || a != t.display.barHeight; d++)
        s != t.display.barWidth && t.options.lineWrapping && _o(t), qu(t, Xi(t)), s = t.display.barWidth, a = t.display.barHeight;
    }
    function qu(t, r) {
      var s = t.display, a = s.scrollbars.update(r);
      s.sizer.style.paddingRight = (s.barWidth = a.right) + "px", s.sizer.style.paddingBottom = (s.barHeight = a.bottom) + "px", s.heightForcer.style.borderBottom = a.bottom + "px solid transparent", a.right && a.bottom ? (s.scrollbarFiller.style.display = "block", s.scrollbarFiller.style.height = a.bottom + "px", s.scrollbarFiller.style.width = a.right + "px") : s.scrollbarFiller.style.display = "", a.bottom && t.options.coverGutterNextToScrollbar && t.options.fixedGutter ? (s.gutterFiller.style.display = "block", s.gutterFiller.style.height = a.bottom + "px", s.gutterFiller.style.width = r.gutterWidth + "px") : s.gutterFiller.style.display = "";
    }
    var _u = { native: Qr, null: Zi };
    function ed(t) {
      t.display.scrollbars && (t.display.scrollbars.clear(), t.display.scrollbars.addClass && C(t.display.wrapper, t.display.scrollbars.addClass)), t.display.scrollbars = new _u[t.options.scrollbarStyle](function (r) {
        t.display.wrapper.insertBefore(r, t.display.scrollbarFiller), de(r, "mousedown", function () {
          t.state.focused && setTimeout(function () {
            return t.display.input.focus();
          }, 0);
        }), r.setAttribute("cm-not-content", "true");
      }, function (r, s) {
        s == "horizontal" ? Yr(t, r) : Ji(t, r);
      }, t), t.display.scrollbars.addClass && te(t.display.wrapper, t.display.scrollbars.addClass);
    }
    var Bp = 0;
    function Kr(t) {
      t.curOp = {
        cm: t,
        viewChanged: !1,
        startHeight: t.doc.height,
        forceUpdate: !1,
        updateInput: 0,
        typing: !1,
        changeObjs: null,
        cursorActivityHandlers: null,
        cursorActivityCalled: 0,
        selectionChanged: !1,
        updateMaxLine: !1,
        scrollLeft: null,
        scrollTop: null,
        scrollToPos: null,
        focus: !1,
        id: ++Bp,
        markArrays: null
      }, hp(t.curOp);
    }
    function Jr(t) {
      var r = t.curOp;
      r && mp(r, function (s) {
        for (var a = 0; a < s.ops.length; a++)
          s.ops[a].cm.curOp = null;
        kp(s);
      });
    }
    function kp(t) {
      for (var r = t.ops, s = 0; s < r.length; s++)
        Hp(r[s]);
      for (var a = 0; a < r.length; a++)
        Vp(r[a]);
      for (var d = 0; d < r.length; d++)
        Up(r[d]);
      for (var A = 0; A < r.length; A++)
        jp(r[A]);
      for (var O = 0; O < r.length; O++)
        zp(r[O]);
    }
    function Hp(t) {
      var r = t.cm, s = r.display;
      Gp(r), t.updateMaxLine && oa(r), t.mustUpdate = t.viewChanged || t.forceUpdate || t.scrollTop != null || t.scrollToPos && (t.scrollToPos.from.line < s.viewFrom || t.scrollToPos.to.line >= s.viewTo) || s.maxLineChanged && r.options.lineWrapping, t.update = t.mustUpdate && new nl(r, t.mustUpdate && { top: t.scrollTop, ensure: t.scrollToPos }, t.forceUpdate);
    }
    function Vp(t) {
      t.updatedDisplay = t.mustUpdate && Ea(t.cm, t.update);
    }
    function Up(t) {
      var r = t.cm, s = r.display;
      t.updatedDisplay && _o(r), t.barMeasure = Xi(r), s.maxLineChanged && !r.options.lineWrapping && (t.adjustWidthTo = Lu(r, s.maxLine, s.maxLine.text.length).left + 3, r.display.sizerWidth = t.adjustWidthTo, t.barMeasure.scrollWidth = Math.max(s.scroller.clientWidth, s.sizer.offsetLeft + t.adjustWidthTo + Qn(r) + r.display.barWidth), t.maxScrollLeft = Math.max(0, s.sizer.offsetLeft + t.adjustWidthTo - jr(r))), (t.updatedDisplay || t.selectionChanged) && (t.preparedSelection = s.input.prepareSelection());
    }
    function jp(t) {
      var r = t.cm;
      t.adjustWidthTo != null && (r.display.sizer.style.minWidth = t.adjustWidthTo + "px", t.maxScrollLeft < r.doc.scrollLeft && Yr(r, Math.min(r.display.scroller.scrollLeft, t.maxScrollLeft), !0), r.display.maxLineChanged = !1);
      var s = t.focus && t.focus == ne(be(r));
      t.preparedSelection && r.display.input.showSelection(t.preparedSelection, s), (t.updatedDisplay || t.startHeight != r.doc.height) && vi(r, t.barMeasure), t.updatedDisplay && Ta(r, t.barMeasure), t.selectionChanged && ya(r), r.state.focused && t.updateInput && r.display.input.reset(t.typing), s && Ku(t.cm);
    }
    function zp(t) {
      var r = t.cm, s = r.display, a = r.doc;
      if (t.updatedDisplay && td(r, t.update), s.wheelStartX != null && (t.scrollTop != null || t.scrollLeft != null || t.scrollToPos) && (s.wheelStartX = s.wheelStartY = null), t.scrollTop != null && Zu(r, t.scrollTop, t.forceScroll), t.scrollLeft != null && Yr(r, t.scrollLeft, !0, !0), t.scrollToPos) {
        var d = Lp(
          r,
          Ye(a, t.scrollToPos.from),
          Ye(a, t.scrollToPos.to),
          t.scrollToPos.margin
        );
        Np(r, d);
      }
      var A = t.maybeHiddenMarkers, O = t.maybeUnhiddenMarkers;
      if (A)
        for (var $ = 0; $ < A.length; ++$)
          A[$].lines.length || $e(A[$], "hide");
      if (O)
        for (var V = 0; V < O.length; ++V)
          O[V].lines.length && $e(O[V], "unhide");
      s.wrapper.offsetHeight && (a.scrollTop = r.display.scroller.scrollTop), t.changeObjs && $e(r, "changes", r, t.changeObjs), t.update && t.update.finish();
    }
    function mn(t, r) {
      if (t.curOp)
        return r();
      Kr(t);
      try {
        return r();
      } finally {
        Jr(t);
      }
    }
    function zt(t, r) {
      return function () {
        if (t.curOp)
          return r.apply(t, arguments);
        Kr(t);
        try {
          return r.apply(t, arguments);
        } finally {
          Jr(t);
        }
      };
    }
    function tn(t) {
      return function () {
        if (this.curOp)
          return t.apply(this, arguments);
        Kr(this);
        try {
          return t.apply(this, arguments);
        } finally {
          Jr(this);
        }
      };
    }
    function Wt(t) {
      return function () {
        var r = this.cm;
        if (!r || r.curOp)
          return t.apply(this, arguments);
        Kr(r);
        try {
          return t.apply(this, arguments);
        } finally {
          Jr(r);
        }
      };
    }
    function qi(t, r) {
      t.doc.highlightFrontier < t.display.viewTo && t.state.highlight.set(r, ae(Wp, t));
    }
    function Wp(t) {
      var r = t.doc;
      if (!(r.highlightFrontier >= t.display.viewTo)) {
        var s = +new Date() + t.options.workTime, a = Ui(t, r.highlightFrontier), d = [];
        r.iter(a.line, Math.min(r.first + r.size, t.display.viewTo + 500), function (A) {
          if (a.line >= t.display.viewFrom) {
            var O = A.styles, $ = A.text.length > t.options.maxHighlightLength ? nr(r.mode, a.state) : null, V = su(t, A, a, !0);
            $ && (a.state = $), A.styles = V.styles;
            var U = A.styleClasses, G = V.classes;
            G ? A.styleClasses = G : U && (A.styleClasses = null);
            for (var K = !O || O.length != A.styles.length || U != G && (!U || !G || U.bgClass != G.bgClass || U.textClass != G.textClass), oe = 0; !K && oe < O.length; ++oe)
              K = O[oe] != A.styles[oe];
            K && d.push(a.line), A.stateAfter = a.save(), a.nextLine();
          } else
            A.text.length <= t.options.maxHighlightLength && _l(t, A.text, a), A.stateAfter = a.line % 5 == 0 ? a.save() : null, a.nextLine();
          if (+new Date() > s)
            return qi(t, t.options.workDelay), !0;
        }), r.highlightFrontier = a.line, r.modeFrontier = Math.max(r.modeFrontier, a.line), d.length && mn(t, function () {
          for (var A = 0; A < d.length; A++)
            xr(t, d[A], "text");
        });
      }
    }
    var nl = function (t, r, s) {
      var a = t.display;
      this.viewport = r, this.visible = el(a, t.doc, r), this.editorIsHidden = !a.wrapper.offsetWidth, this.wrapperHeight = a.wrapper.clientHeight, this.wrapperWidth = a.wrapper.clientWidth, this.oldDisplayWidth = jr(t), this.force = s, this.dims = ha(t), this.events = [];
    };
    nl.prototype.signal = function (t, r) {
      xt(t, r) && this.events.push(arguments);
    }, nl.prototype.finish = function () {
      for (var t = 0; t < this.events.length; t++)
        $e.apply(null, this.events[t]);
    };
    function Gp(t) {
      var r = t.display;
      !r.scrollbarsClipped && r.scroller.offsetWidth && (r.nativeBarWidth = r.scroller.offsetWidth - r.scroller.clientWidth, r.heightForcer.style.height = Qn(t) + "px", r.sizer.style.marginBottom = -r.nativeBarWidth + "px", r.sizer.style.borderRightWidth = Qn(t) + "px", r.scrollbarsClipped = !0);
    }
    function Yp(t) {
      if (t.hasFocus())
        return null;
      var r = ne(be(t));
      if (!r || !Q(t.display.lineDiv, r))
        return null;
      var s = { activeElt: r };
      if (window.getSelection) {
        var a = me(t).getSelection();
        a.anchorNode && a.extend && Q(t.display.lineDiv, a.anchorNode) && (s.anchorNode = a.anchorNode, s.anchorOffset = a.anchorOffset, s.focusNode = a.focusNode, s.focusOffset = a.focusOffset);
      }
      return s;
    }
    function Qp(t) {
      if (!(!t || !t.activeElt || t.activeElt == ne(t.activeElt.ownerDocument)) && (t.activeElt.focus(), !/^(INPUT|TEXTAREA)$/.test(t.activeElt.nodeName) && t.anchorNode && Q(document.body, t.anchorNode) && Q(document.body, t.focusNode))) {
        var r = t.activeElt.ownerDocument, s = r.defaultView.getSelection(), a = r.createRange();
        a.setEnd(t.anchorNode, t.anchorOffset), a.collapse(!1), s.removeAllRanges(), s.addRange(a), s.extend(t.focusNode, t.focusOffset);
      }
    }
    function Ea(t, r) {
      var s = t.display, a = t.doc;
      if (r.editorIsHidden)
        return Tr(t), !1;
      if (!r.force && r.visible.from >= s.viewFrom && r.visible.to <= s.viewTo && (s.updateLineNumbers == null || s.updateLineNumbers >= s.viewTo) && s.renderedView == s.view && Yu(t) == 0)
        return !1;
      rd(t) && (Tr(t), r.dims = ha(t));
      var d = a.first + a.size, A = Math.max(r.visible.from - t.options.viewportMargin, a.first), O = Math.min(d, r.visible.to + t.options.viewportMargin);
      s.viewFrom < A && A - s.viewFrom < 20 && (A = Math.max(a.first, s.viewFrom)), s.viewTo > O && s.viewTo - O < 20 && (O = Math.min(d, s.viewTo)), ir && (A = ra(t.doc, A), O = Su(t.doc, O));
      var $ = A != s.viewFrom || O != s.viewTo || s.lastWrapHeight != r.wrapperHeight || s.lastWrapWidth != r.wrapperWidth;
      Mp(t, A, O), s.viewOffset = or(Be(t.doc, s.viewFrom)), t.display.mover.style.top = s.viewOffset + "px";
      var V = Yu(t);
      if (!$ && V == 0 && !r.force && s.renderedView == s.view && (s.updateLineNumbers == null || s.updateLineNumbers >= s.viewTo))
        return !1;
      var U = Yp(t);
      return V > 4 && (s.lineDiv.style.display = "none"), Kp(t, s.updateLineNumbers, r.dims), V > 4 && (s.lineDiv.style.display = ""), s.renderedView = s.view, Qp(U), M(s.cursorDiv), M(s.selectionDiv), s.gutters.style.height = s.sizer.style.minHeight = 0, $ && (s.lastWrapHeight = r.wrapperHeight, s.lastWrapWidth = r.wrapperWidth, qi(t, 400)), s.updateLineNumbers = null, !0;
    }
    function td(t, r) {
      for (var s = r.viewport, a = !0; ; a = !1) {
        if (!a || !t.options.lineWrapping || r.oldDisplayWidth == jr(t)) {
          if (s && s.top != null && (s = { top: Math.min(t.doc.height + aa(t.display) - sa(t), s.top) }), r.visible = el(t.display, t.doc, s), r.visible.from >= t.display.viewFrom && r.visible.to <= t.display.viewTo)
            break;
        } else
          a && (r.visible = el(t.display, t.doc, s));
        if (!Ea(t, r))
          break;
        _o(t);
        var d = Xi(t);
        Qi(t), vi(t, d), Ta(t, d), r.force = !1;
      }
      r.signal(t, "update", t), (t.display.viewFrom != t.display.reportedViewFrom || t.display.viewTo != t.display.reportedViewTo) && (r.signal(t, "viewportChange", t, t.display.viewFrom, t.display.viewTo), t.display.reportedViewFrom = t.display.viewFrom, t.display.reportedViewTo = t.display.viewTo);
    }
    function wa(t, r) {
      var s = new nl(t, r);
      if (Ea(t, s)) {
        _o(t), td(t, s);
        var a = Xi(t);
        Qi(t), vi(t, a), Ta(t, a), s.finish();
      }
    }
    function Kp(t, r, s) {
      var a = t.display, d = t.options.lineNumbers, A = a.lineDiv, O = A.firstChild;
      function $(pe) {
        var ye = pe.nextSibling;
        return b && R && t.display.currentWheelTarget == pe ? pe.style.display = "none" : pe.parentNode.removeChild(pe), ye;
      }
      for (var V = a.view, U = a.viewFrom, G = 0; G < V.length; G++) {
        var K = V[G];
        if (!K.hidden)
          if (!K.node || K.node.parentNode != A) {
            var oe = Cp(t, K, U, s);
            A.insertBefore(oe, O);
          } else {
            for (; O != K.node;)
              O = $(O);
            var re = d && r != null && r <= U && K.lineNumber;
            K.changes && (se(K.changes, "gutter") > -1 && (re = !1), Du(t, K, U, s)), re && (M(K.lineNumber), K.lineNumber.appendChild(document.createTextNode(J(t.options, U)))), O = K.node.nextSibling;
          }
        U += K.size;
      }
      for (; O;)
        O = $(O);
    }
    function xa(t) {
      var r = t.gutters.offsetWidth;
      t.sizer.style.marginLeft = r + "px", jt(t, "gutterChanged", t);
    }
    function Ta(t, r) {
      t.display.sizer.style.minHeight = r.docHeight + "px", t.display.heightForcer.style.top = r.docHeight + "px", t.display.gutters.style.height = r.docHeight + t.display.barHeight + Qn(t) + "px";
    }
    function nd(t) {
      var r = t.display, s = r.view;
      if (!(!r.alignWidgets && (!r.gutters.firstChild || !t.options.fixedGutter))) {
        for (var a = va(r) - r.scroller.scrollLeft + t.doc.scrollLeft, d = r.gutters.offsetWidth, A = a + "px", O = 0; O < s.length; O++)
          if (!s[O].hidden) {
            t.options.fixedGutter && (s[O].gutter && (s[O].gutter.style.left = A), s[O].gutterBackground && (s[O].gutterBackground.style.left = A));
            var $ = s[O].alignable;
            if ($)
              for (var V = 0; V < $.length; V++)
                $[V].style.left = A;
          }
        t.options.fixedGutter && (r.gutters.style.left = a + d + "px");
      }
    }
    function rd(t) {
      if (!t.options.lineNumbers)
        return !1;
      var r = t.doc, s = J(t.options, r.first + r.size - 1), a = t.display;
      if (s.length != a.lineNumChars) {
        var d = a.measure.appendChild(F(
          "div",
          [F("div", s)],
          "CodeMirror-linenumber CodeMirror-gutter-elt"
        )), A = d.firstChild.offsetWidth, O = d.offsetWidth - A;
        return a.lineGutter.style.width = "", a.lineNumInnerWidth = Math.max(A, a.lineGutter.offsetWidth - O) + 1, a.lineNumWidth = a.lineNumInnerWidth + O, a.lineNumChars = a.lineNumInnerWidth ? s.length : -1, a.lineGutter.style.width = a.lineNumWidth + "px", xa(t.display), !0;
      }
      return !1;
    }
    function Da(t, r) {
      for (var s = [], a = !1, d = 0; d < t.length; d++) {
        var A = t[d], O = null;
        if (typeof A != "string" && (O = A.style, A = A.className), A == "CodeMirror-linenumbers")
          if (r)
            a = !0;
          else
            continue;
        s.push({ className: A, style: O });
      }
      return r && !a && s.push({ className: "CodeMirror-linenumbers", style: null }), s;
    }
    function id(t) {
      var r = t.gutters, s = t.gutterSpecs;
      M(r), t.lineGutter = null;
      for (var a = 0; a < s.length; ++a) {
        var d = s[a], A = d.className, O = d.style, $ = r.appendChild(F("div", null, "CodeMirror-gutter " + A));
        O && ($.style.cssText = O), A == "CodeMirror-linenumbers" && (t.lineGutter = $, $.style.width = (t.lineNumWidth || 1) + "px");
      }
      r.style.display = s.length ? "" : "none", xa(t);
    }
    function _i(t) {
      id(t.display), an(t), nd(t);
    }
    function Jp(t, r, s, a) {
      var d = this;
      this.input = s, d.scrollbarFiller = F("div", null, "CodeMirror-scrollbar-filler"), d.scrollbarFiller.setAttribute("cm-not-content", "true"), d.gutterFiller = F("div", null, "CodeMirror-gutter-filler"), d.gutterFiller.setAttribute("cm-not-content", "true"), d.lineDiv = j("div", null, "CodeMirror-code"), d.selectionDiv = F("div", null, null, "position: relative; z-index: 1"), d.cursorDiv = F("div", null, "CodeMirror-cursors"), d.measure = F("div", null, "CodeMirror-measure"), d.lineMeasure = F("div", null, "CodeMirror-measure"), d.lineSpace = j(
        "div",
        [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
        null,
        "position: relative; outline: none"
      );
      var A = j("div", [d.lineSpace], "CodeMirror-lines");
      d.mover = F("div", [A], null, "position: relative"), d.sizer = F("div", [d.mover], "CodeMirror-sizer"), d.sizerWidth = null, d.heightForcer = F("div", null, null, "position: absolute; height: " + Ae + "px; width: 1px;"), d.gutters = F("div", null, "CodeMirror-gutters"), d.lineGutter = null, d.scroller = F("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll"), d.scroller.setAttribute("tabIndex", "-1"), d.wrapper = F("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror"), d.wrapper.setAttribute("translate", "no"), c && v < 8 && (d.gutters.style.zIndex = -1, d.scroller.style.paddingRight = 0), !b && !(n && x) && (d.scroller.draggable = !0), t && (t.appendChild ? t.appendChild(d.wrapper) : t(d.wrapper)), d.viewFrom = d.viewTo = r.first, d.reportedViewFrom = d.reportedViewTo = r.first, d.view = [], d.renderedView = null, d.externalMeasured = null, d.viewOffset = 0, d.lastWrapHeight = d.lastWrapWidth = 0, d.updateLineNumbers = null, d.nativeBarWidth = d.barHeight = d.barWidth = 0, d.scrollbarsClipped = !1, d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null, d.alignWidgets = !1, d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null, d.maxLine = null, d.maxLineLength = 0, d.maxLineChanged = !1, d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null, d.shift = !1, d.selForContextMenu = null, d.activeTouch = null, d.gutterSpecs = Da(a.gutters, a.lineNumbers), id(d), s.init(d);
    }
    var rl = 0, ar = null;
    c ? ar = -0.53 : n ? ar = 15 : E ? ar = -0.7 : m && (ar = -1 / 3);
    function od(t) {
      var r = t.wheelDeltaX, s = t.wheelDeltaY;
      return r == null && t.detail && t.axis == t.HORIZONTAL_AXIS && (r = t.detail), s == null && t.detail && t.axis == t.VERTICAL_AXIS ? s = t.detail : s == null && (s = t.wheelDelta), { x: r, y: s };
    }
    function Xp(t) {
      var r = od(t);
      return r.x *= ar, r.y *= ar, r;
    }
    function ld(t, r) {
      E && w == 102 && (t.display.chromeScrollHack == null ? t.display.sizer.style.pointerEvents = "none" : clearTimeout(t.display.chromeScrollHack), t.display.chromeScrollHack = setTimeout(function () {
        t.display.chromeScrollHack = null, t.display.sizer.style.pointerEvents = "";
      }, 100));
      var s = od(r), a = s.x, d = s.y, A = ar;
      r.deltaMode === 0 && (a = r.deltaX, d = r.deltaY, A = 1);
      var O = t.display, $ = O.scroller, V = $.scrollWidth > $.clientWidth, U = $.scrollHeight > $.clientHeight;
      if (!!(a && V || d && U)) {
        if (d && R && b) {
          e:
          for (var G = r.target, K = O.view; G != $; G = G.parentNode)
            for (var oe = 0; oe < K.length; oe++)
              if (K[oe].node == G) {
                t.display.currentWheelTarget = G;
                break e;
              }
        }
        if (a && !n && !h && A != null) {
          d && U && Ji(t, Math.max(0, $.scrollTop + d * A)), Yr(t, Math.max(0, $.scrollLeft + a * A)), (!d || d && U) && pt(r), O.wheelStartX = null;
          return;
        }
        if (d && A != null) {
          var re = d * A, pe = t.doc.scrollTop, ye = pe + O.wrapper.clientHeight;
          re < 0 ? pe = Math.max(0, pe + re - 50) : ye = Math.min(t.doc.height, ye + re + 50), wa(t, { top: pe, bottom: ye });
        }
        rl < 20 && r.deltaMode !== 0 && (O.wheelStartX == null ? (O.wheelStartX = $.scrollLeft, O.wheelStartY = $.scrollTop, O.wheelDX = a, O.wheelDY = d, setTimeout(function () {
          if (O.wheelStartX != null) {
            var Ce = $.scrollLeft - O.wheelStartX, Te = $.scrollTop - O.wheelStartY, Fe = Te && O.wheelDY && Te / O.wheelDY || Ce && O.wheelDX && Ce / O.wheelDX;
            O.wheelStartX = O.wheelStartY = null, Fe && (ar = (ar * rl + Fe) / (rl + 1), ++rl);
          }
        }, 200)) : (O.wheelDX += a, O.wheelDY += d));
      }
    }
    var En = function (t, r) {
      this.ranges = t, this.primIndex = r;
    };
    En.prototype.primary = function () {
      return this.ranges[this.primIndex];
    }, En.prototype.equals = function (t) {
      if (t == this)
        return !0;
      if (t.primIndex != this.primIndex || t.ranges.length != this.ranges.length)
        return !1;
      for (var r = 0; r < this.ranges.length; r++) {
        var s = this.ranges[r], a = t.ranges[r];
        if (!Ge(s.anchor, a.anchor) || !Ge(s.head, a.head))
          return !1;
      }
      return !0;
    }, En.prototype.deepCopy = function () {
      for (var t = [], r = 0; r < this.ranges.length; r++)
        t[r] = new vt(lt(this.ranges[r].anchor), lt(this.ranges[r].head));
      return new En(t, this.primIndex);
    }, En.prototype.somethingSelected = function () {
      for (var t = 0; t < this.ranges.length; t++)
        if (!this.ranges[t].empty())
          return !0;
      return !1;
    }, En.prototype.contains = function (t, r) {
      r || (r = t);
      for (var s = 0; s < this.ranges.length; s++) {
        var a = this.ranges[s];
        if (ce(r, a.from()) >= 0 && ce(t, a.to()) <= 0)
          return s;
      }
      return -1;
    };
    var vt = function (t, r) {
      this.anchor = t, this.head = r;
    };
    vt.prototype.from = function () {
      return kt(this.anchor, this.head);
    }, vt.prototype.to = function () {
      return ut(this.anchor, this.head);
    }, vt.prototype.empty = function () {
      return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
    };
    function Bn(t, r, s) {
      var a = t && t.options.selectionsMayTouch, d = r[s];
      r.sort(function (oe, re) {
        return ce(oe.from(), re.from());
      }), s = se(r, d);
      for (var A = 1; A < r.length; A++) {
        var O = r[A], $ = r[A - 1], V = ce($.to(), O.from());
        if (a && !O.empty() ? V > 0 : V >= 0) {
          var U = kt($.from(), O.from()), G = ut($.to(), O.to()), K = $.empty() ? O.from() == O.head : $.from() == $.head;
          A <= s && --s, r.splice(--A, 2, new vt(K ? G : U, K ? U : G));
        }
      }
      return new En(r, s);
    }
    function Dr(t, r) {
      return new En([new vt(t, r || t)], 0);
    }
    function Ir(t) {
      return t.text ? ee(
        t.from.line + t.text.length - 1,
        He(t.text).length + (t.text.length == 1 ? t.from.ch : 0)
      ) : t.to;
    }
    function ad(t, r) {
      if (ce(t, r.from) < 0)
        return t;
      if (ce(t, r.to) <= 0)
        return Ir(r);
      var s = t.line + r.text.length - (r.to.line - r.from.line) - 1, a = t.ch;
      return t.line == r.to.line && (a += Ir(r).ch - r.to.ch), ee(s, a);
    }
    function Ia(t, r) {
      for (var s = [], a = 0; a < t.sel.ranges.length; a++) {
        var d = t.sel.ranges[a];
        s.push(new vt(
          ad(d.anchor, r),
          ad(d.head, r)
        ));
      }
      return Bn(t.cm, s, t.sel.primIndex);
    }
    function sd(t, r, s) {
      return t.line == r.line ? ee(s.line, t.ch - r.ch + s.ch) : ee(s.line + (t.line - r.line), t.ch);
    }
    function Zp(t, r, s) {
      for (var a = [], d = ee(t.first, 0), A = d, O = 0; O < r.length; O++) {
        var $ = r[O], V = sd($.from, d, A), U = sd(Ir($), d, A);
        if (d = $.to, A = U, s == "around") {
          var G = t.sel.ranges[O], K = ce(G.head, G.anchor) < 0;
          a[O] = new vt(K ? U : V, K ? V : U);
        } else
          a[O] = new vt(V, V);
      }
      return new En(a, t.sel.primIndex);
    }
    function Ra(t) {
      t.doc.mode = tr(t.options, t.doc.modeOption), eo(t);
    }
    function eo(t) {
      t.doc.iter(function (r) {
        r.stateAfter && (r.stateAfter = null), r.styles && (r.styles = null);
      }), t.doc.modeFrontier = t.doc.highlightFrontier = t.doc.first, qi(t, 100), t.state.modeGen++, t.curOp && an(t);
    }
    function ud(t, r) {
      return r.from.ch == 0 && r.to.ch == 0 && He(r.text) == "" && (!t.cm || t.cm.options.wholeLineUpdateBefore);
    }
    function Fa(t, r, s, a) {
      function d(Fe) {
        return s ? s[Fe] : null;
      }
      function A(Fe, De, Le) {
        op(Fe, De, Le, a), jt(Fe, "change", Fe, r);
      }
      function O(Fe, De) {
        for (var Le = [], Ue = Fe; Ue < De; ++Ue)
          Le.push(new si(U[Ue], d(Ue), a));
        return Le;
      }
      var $ = r.from, V = r.to, U = r.text, G = Be(t, $.line), K = Be(t, V.line), oe = He(U), re = d(U.length - 1), pe = V.line - $.line;
      if (r.full)
        t.insert(0, O(0, U.length)), t.remove(U.length, t.size - U.length);
      else if (ud(t, r)) {
        var ye = O(0, U.length - 1);
        A(K, K.text, re), pe && t.remove($.line, pe), ye.length && t.insert($.line, ye);
      } else if (G == K)
        if (U.length == 1)
          A(G, G.text.slice(0, $.ch) + oe + G.text.slice(V.ch), re);
        else {
          var Ce = O(1, U.length - 1);
          Ce.push(new si(oe + G.text.slice(V.ch), re, a)), A(G, G.text.slice(0, $.ch) + U[0], d(0)), t.insert($.line + 1, Ce);
        }
      else if (U.length == 1)
        A(G, G.text.slice(0, $.ch) + U[0] + K.text.slice(V.ch), d(0)), t.remove($.line + 1, pe);
      else {
        A(G, G.text.slice(0, $.ch) + U[0], d(0)), A(K, oe + K.text.slice(V.ch), re);
        var Te = O(1, U.length - 1);
        pe > 1 && t.remove($.line + 1, pe - 1), t.insert($.line + 1, Te);
      }
      jt(t, "change", t, r);
    }
    function Rr(t, r, s) {
      function a(d, A, O) {
        if (d.linked)
          for (var $ = 0; $ < d.linked.length; ++$) {
            var V = d.linked[$];
            if (V.doc != A) {
              var U = O && V.sharedHist;
              s && !U || (r(V.doc, U), a(V.doc, d, U));
            }
          }
      }
      a(t, null, !0);
    }
    function dd(t, r) {
      if (r.cm)
        throw new Error("This document is already in use.");
      t.doc = r, r.cm = t, ma(t), Ra(t), fd(t), t.options.direction = r.direction, t.options.lineWrapping || oa(t), t.options.mode = r.modeOption, an(t);
    }
    function fd(t) {
      (t.doc.direction == "rtl" ? te : C)(t.display.lineDiv, "CodeMirror-rtl");
    }
    function qp(t) {
      mn(t, function () {
        fd(t), an(t);
      });
    }
    function il(t) {
      this.done = [], this.undone = [], this.undoDepth = t ? t.undoDepth : 1 / 0, this.lastModTime = this.lastSelTime = 0, this.lastOp = this.lastSelOp = null, this.lastOrigin = this.lastSelOrigin = null, this.generation = this.maxGeneration = t ? t.maxGeneration : 1;
    }
    function Ma(t, r) {
      var s = { from: lt(r.from), to: Ir(r), text: rr(t, r.from, r.to) };
      return hd(t, s, r.from.line, r.to.line + 1), Rr(t, function (a) {
        return hd(a, s, r.from.line, r.to.line + 1);
      }, !0), s;
    }
    function cd(t) {
      for (; t.length;) {
        var r = He(t);
        if (r.ranges)
          t.pop();
        else
          break;
      }
    }
    function _p(t, r) {
      if (r)
        return cd(t.done), He(t.done);
      if (t.done.length && !He(t.done).ranges)
        return He(t.done);
      if (t.done.length > 1 && !t.done[t.done.length - 2].ranges)
        return t.done.pop(), He(t.done);
    }
    function pd(t, r, s, a) {
      var d = t.history;
      d.undone.length = 0;
      var A = +new Date(), O, $;
      if ((d.lastOp == a || d.lastOrigin == r.origin && r.origin && (r.origin.charAt(0) == "+" && d.lastModTime > A - (t.cm ? t.cm.options.historyEventDelay : 500) || r.origin.charAt(0) == "*")) && (O = _p(d, d.lastOp == a)))
        $ = He(O.changes), ce(r.from, r.to) == 0 && ce(r.from, $.to) == 0 ? $.to = Ir(r) : O.changes.push(Ma(t, r));
      else {
        var V = He(d.done);
        for ((!V || !V.ranges) && ol(t.sel, d.done), O = {
          changes: [Ma(t, r)],
          generation: d.generation
        }, d.done.push(O); d.done.length > d.undoDepth;)
          d.done.shift(), d.done[0].ranges || d.done.shift();
      }
      d.done.push(s), d.generation = ++d.maxGeneration, d.lastModTime = d.lastSelTime = A, d.lastOp = d.lastSelOp = a, d.lastOrigin = d.lastSelOrigin = r.origin, $ || $e(t, "historyAdded");
    }
    function eh(t, r, s, a) {
      var d = r.charAt(0);
      return d == "*" || d == "+" && s.ranges.length == a.ranges.length && s.somethingSelected() == a.somethingSelected() && new Date() - t.history.lastSelTime <= (t.cm ? t.cm.options.historyEventDelay : 500);
    }
    function th(t, r, s, a) {
      var d = t.history, A = a && a.origin;
      s == d.lastSelOp || A && d.lastSelOrigin == A && (d.lastModTime == d.lastSelTime && d.lastOrigin == A || eh(t, A, He(d.done), r)) ? d.done[d.done.length - 1] = r : ol(r, d.done), d.lastSelTime = +new Date(), d.lastSelOrigin = A, d.lastSelOp = s, a && a.clearRedo !== !1 && cd(d.undone);
    }
    function ol(t, r) {
      var s = He(r);
      s && s.ranges && s.equals(t) || r.push(t);
    }
    function hd(t, r, s, a) {
      var d = r["spans_" + t.id], A = 0;
      t.iter(Math.max(t.first, s), Math.min(t.first + t.size, a), function (O) {
        O.markedSpans && ((d || (d = r["spans_" + t.id] = {}))[A] = O.markedSpans), ++A;
      });
    }
    function nh(t) {
      if (!t)
        return null;
      for (var r, s = 0; s < t.length; ++s)
        t[s].marker.explicitlyCleared ? r || (r = t.slice(0, s)) : r && r.push(t[s]);
      return r ? r.length ? r : null : t;
    }
    function rh(t, r) {
      var s = r["spans_" + t.id];
      if (!s)
        return null;
      for (var a = [], d = 0; d < r.text.length; ++d)
        a.push(nh(s[d]));
      return a;
    }
    function vd(t, r) {
      var s = rh(t, r), a = ta(t, r);
      if (!s)
        return a;
      if (!a)
        return s;
      for (var d = 0; d < s.length; ++d) {
        var A = s[d], O = a[d];
        if (A && O) {
          e:
          for (var $ = 0; $ < O.length; ++$) {
            for (var V = O[$], U = 0; U < A.length; ++U)
              if (A[U].marker == V.marker)
                continue e;
            A.push(V);
          }
        } else
          O && (s[d] = O);
      }
      return s;
    }
    function mi(t, r, s) {
      for (var a = [], d = 0; d < t.length; ++d) {
        var A = t[d];
        if (A.ranges) {
          a.push(s ? En.prototype.deepCopy.call(A) : A);
          continue;
        }
        var O = A.changes, $ = [];
        a.push({ changes: $ });
        for (var V = 0; V < O.length; ++V) {
          var U = O[V], G = void 0;
          if ($.push({ from: U.from, to: U.to, text: U.text }), r)
            for (var K in U)
              (G = K.match(/^spans_(\d+)$/)) && se(r, Number(G[1])) > -1 && (He($)[K] = U[K], delete U[K]);
        }
      }
      return a;
    }
    function Oa(t, r, s, a) {
      if (a) {
        var d = t.anchor;
        if (s) {
          var A = ce(r, d) < 0;
          A != ce(s, d) < 0 ? (d = r, r = s) : A != ce(r, s) < 0 && (r = s);
        }
        return new vt(d, r);
      } else
        return new vt(s || r, r);
    }
    function ll(t, r, s, a, d) {
      d == null && (d = t.cm && (t.cm.display.shift || t.extend)), Xt(t, new En([Oa(t.sel.primary(), r, s, d)], 0), a);
    }
    function md(t, r, s) {
      for (var a = [], d = t.cm && (t.cm.display.shift || t.extend), A = 0; A < t.sel.ranges.length; A++)
        a[A] = Oa(t.sel.ranges[A], r[A], null, d);
      var O = Bn(t.cm, a, t.sel.primIndex);
      Xt(t, O, s);
    }
    function Na(t, r, s, a) {
      var d = t.sel.ranges.slice(0);
      d[r] = s, Xt(t, Bn(t.cm, d, t.sel.primIndex), a);
    }
    function gd(t, r, s, a) {
      Xt(t, Dr(r, s), a);
    }
    function ih(t, r, s) {
      var a = {
        ranges: r.ranges,
        update: function (d) {
          this.ranges = [];
          for (var A = 0; A < d.length; A++)
            this.ranges[A] = new vt(
              Ye(t, d[A].anchor),
              Ye(t, d[A].head)
            );
        },
        origin: s && s.origin
      };
      return $e(t, "beforeSelectionChange", t, a), t.cm && $e(t.cm, "beforeSelectionChange", t.cm, a), a.ranges != r.ranges ? Bn(t.cm, a.ranges, a.ranges.length - 1) : r;
    }
    function yd(t, r, s) {
      var a = t.history.done, d = He(a);
      d && d.ranges ? (a[a.length - 1] = r, al(t, r, s)) : Xt(t, r, s);
    }
    function Xt(t, r, s) {
      al(t, r, s), th(t, t.sel, t.cm ? t.cm.curOp.id : NaN, s);
    }
    function al(t, r, s) {
      (xt(t, "beforeSelectionChange") || t.cm && xt(t.cm, "beforeSelectionChange")) && (r = ih(t, r, s));
      var a = s && s.bias || (ce(r.primary().head, t.sel.primary().head) < 0 ? -1 : 1);
      bd(t, Cd(t, r, a, !0)), !(s && s.scroll === !1) && t.cm && t.cm.getOption("readOnly") != "nocursor" && hi(t.cm);
    }
    function bd(t, r) {
      r.equals(t.sel) || (t.sel = r, t.cm && (t.cm.curOp.updateInput = 1, t.cm.curOp.selectionChanged = !0, on(t.cm)), jt(t, "cursorActivity", t));
    }
    function Ad(t) {
      bd(t, Cd(t, t.sel, null, !1));
    }
    function Cd(t, r, s, a) {
      for (var d, A = 0; A < r.ranges.length; A++) {
        var O = r.ranges[A], $ = r.ranges.length == t.sel.ranges.length && t.sel.ranges[A], V = sl(t, O.anchor, $ && $.anchor, s, a), U = O.head == O.anchor ? V : sl(t, O.head, $ && $.head, s, a);
        (d || V != O.anchor || U != O.head) && (d || (d = r.ranges.slice(0, A)), d[A] = new vt(V, U));
      }
      return d ? Bn(t.cm, d, r.primIndex) : r;
    }
    function gi(t, r, s, a, d) {
      var A = Be(t, r.line);
      if (A.markedSpans)
        for (var O = 0; O < A.markedSpans.length; ++O) {
          var $ = A.markedSpans[O], V = $.marker, U = "selectLeft" in V ? !V.selectLeft : V.inclusiveLeft, G = "selectRight" in V ? !V.selectRight : V.inclusiveRight;
          if (($.from == null || (U ? $.from <= r.ch : $.from < r.ch)) && ($.to == null || (G ? $.to >= r.ch : $.to > r.ch))) {
            if (d && ($e(V, "beforeCursorEnter"), V.explicitlyCleared))
              if (A.markedSpans) {
                --O;
                continue;
              } else
                break;
            if (!V.atomic)
              continue;
            if (s) {
              var K = V.find(a < 0 ? 1 : -1), oe = void 0;
              if ((a < 0 ? G : U) && (K = Sd(t, K, -a, K && K.line == r.line ? A : null)), K && K.line == r.line && (oe = ce(K, s)) && (a < 0 ? oe < 0 : oe > 0))
                return gi(t, K, r, a, d);
            }
            var re = V.find(a < 0 ? -1 : 1);
            return (a < 0 ? U : G) && (re = Sd(t, re, a, re.line == r.line ? A : null)), re ? gi(t, re, r, a, d) : null;
          }
        }
      return r;
    }
    function sl(t, r, s, a, d) {
      var A = a || 1, O = gi(t, r, s, A, d) || !d && gi(t, r, s, A, !0) || gi(t, r, s, -A, d) || !d && gi(t, r, s, -A, !0);
      return O || (t.cantEdit = !0, ee(t.first, 0));
    }
    function Sd(t, r, s, a) {
      return s < 0 && r.ch == 0 ? r.line > t.first ? Ye(t, ee(r.line - 1)) : null : s > 0 && r.ch == (a || Be(t, r.line)).text.length ? r.line < t.first + t.size - 1 ? ee(r.line + 1, 0) : null : new ee(r.line, r.ch + s);
    }
    function Ed(t) {
      t.setSelection(ee(t.firstLine(), 0), ee(t.lastLine()), Ne);
    }
    function wd(t, r, s) {
      var a = {
        canceled: !1,
        from: r.from,
        to: r.to,
        text: r.text,
        origin: r.origin,
        cancel: function () {
          return a.canceled = !0;
        }
      };
      return s && (a.update = function (d, A, O, $) {
        d && (a.from = Ye(t, d)), A && (a.to = Ye(t, A)), O && (a.text = O), $ !== void 0 && (a.origin = $);
      }), $e(t, "beforeChange", t, a), t.cm && $e(t.cm, "beforeChange", t.cm, a), a.canceled ? (t.cm && (t.cm.curOp.updateInput = 2), null) : { from: a.from, to: a.to, text: a.text, origin: a.origin };
    }
    function yi(t, r, s) {
      if (t.cm) {
        if (!t.cm.curOp)
          return zt(t.cm, yi)(t, r, s);
        if (t.cm.state.suppressEdits)
          return;
      }
      if (!((xt(t, "beforeChange") || t.cm && xt(t.cm, "beforeChange")) && (r = wd(t, r, !0), !r))) {
        var a = vu && !s && tp(t, r.from, r.to);
        if (a)
          for (var d = a.length - 1; d >= 0; --d)
            xd(t, { from: a[d].from, to: a[d].to, text: d ? [""] : r.text, origin: r.origin });
        else
          xd(t, r);
      }
    }
    function xd(t, r) {
      if (!(r.text.length == 1 && r.text[0] == "" && ce(r.from, r.to) == 0)) {
        var s = Ia(t, r);
        pd(t, r, s, t.cm ? t.cm.curOp.id : NaN), to(t, r, s, ta(t, r));
        var a = [];
        Rr(t, function (d, A) {
          !A && se(a, d.history) == -1 && (Rd(d.history, r), a.push(d.history)), to(d, r, null, ta(d, r));
        });
      }
    }
    function ul(t, r, s) {
      var a = t.cm && t.cm.state.suppressEdits;
      if (!(a && !s)) {
        for (var d = t.history, A, O = t.sel, $ = r == "undo" ? d.done : d.undone, V = r == "undo" ? d.undone : d.done, U = 0; U < $.length && (A = $[U], !(s ? A.ranges && !A.equals(t.sel) : !A.ranges)); U++)
          ;
        if (U != $.length) {
          for (d.lastOrigin = d.lastSelOrigin = null; ;)
            if (A = $.pop(), A.ranges) {
              if (ol(A, V), s && !A.equals(t.sel)) {
                Xt(t, A, { clearRedo: !1 });
                return;
              }
              O = A;
            } else if (a) {
              $.push(A);
              return;
            } else
              break;
          var G = [];
          ol(O, V), V.push({ changes: G, generation: d.generation }), d.generation = A.generation || ++d.maxGeneration;
          for (var K = xt(t, "beforeChange") || t.cm && xt(t.cm, "beforeChange"), oe = function (ye) {
            var Ce = A.changes[ye];
            if (Ce.origin = r, K && !wd(t, Ce, !1))
              return $.length = 0, {};
            G.push(Ma(t, Ce));
            var Te = ye ? Ia(t, Ce) : He($);
            to(t, Ce, Te, vd(t, Ce)), !ye && t.cm && t.cm.scrollIntoView({ from: Ce.from, to: Ir(Ce) });
            var Fe = [];
            Rr(t, function (De, Le) {
              !Le && se(Fe, De.history) == -1 && (Rd(De.history, Ce), Fe.push(De.history)), to(De, Ce, null, vd(De, Ce));
            });
          }, re = A.changes.length - 1; re >= 0; --re) {
            var pe = oe(re);
            if (pe)
              return pe.v;
          }
        }
      }
    }
    function Td(t, r) {
      if (r != 0 && (t.first += r, t.sel = new En(bt(t.sel.ranges, function (d) {
        return new vt(
          ee(d.anchor.line + r, d.anchor.ch),
          ee(d.head.line + r, d.head.ch)
        );
      }), t.sel.primIndex), t.cm)) {
        an(t.cm, t.first, t.first - r, r);
        for (var s = t.cm.display, a = s.viewFrom; a < s.viewTo; a++)
          xr(t.cm, a, "gutter");
      }
    }
    function to(t, r, s, a) {
      if (t.cm && !t.cm.curOp)
        return zt(t.cm, to)(t, r, s, a);
      if (r.to.line < t.first) {
        Td(t, r.text.length - 1 - (r.to.line - r.from.line));
        return;
      }
      if (!(r.from.line > t.lastLine())) {
        if (r.from.line < t.first) {
          var d = r.text.length - 1 - (t.first - r.from.line);
          Td(t, d), r = {
            from: ee(t.first, 0),
            to: ee(r.to.line + d, r.to.ch),
            text: [He(r.text)],
            origin: r.origin
          };
        }
        var A = t.lastLine();
        r.to.line > A && (r = {
          from: r.from,
          to: ee(A, Be(t, A).text.length),
          text: [r.text[0]],
          origin: r.origin
        }), r.removed = rr(t, r.from, r.to), s || (s = Ia(t, r)), t.cm ? oh(t.cm, r, a) : Fa(t, r, a), al(t, s, Ne), t.cantEdit && sl(t, ee(t.firstLine(), 0)) && (t.cantEdit = !1);
      }
    }
    function oh(t, r, s) {
      var a = t.doc, d = t.display, A = r.from, O = r.to, $ = !1, V = A.line;
      t.options.lineWrapping || (V = ht(Pn(Be(a, A.line))), a.iter(V, O.line + 1, function (re) {
        if (re == d.maxLine)
          return $ = !0, !0;
      })), a.sel.contains(r.from, r.to) > -1 && on(t), Fa(a, r, s, Gu(t)), t.options.lineWrapping || (a.iter(V, A.line + r.text.length, function (re) {
        var pe = Yo(re);
        pe > d.maxLineLength && (d.maxLine = re, d.maxLineLength = pe, d.maxLineChanged = !0, $ = !1);
      }), $ && (t.curOp.updateMaxLine = !0)), Kc(a, A.line), qi(t, 400);
      var U = r.text.length - (O.line - A.line) - 1;
      r.full ? an(t) : A.line == O.line && r.text.length == 1 && !ud(t.doc, r) ? xr(t, A.line, "text") : an(t, A.line, O.line + 1, U);
      var G = xt(t, "changes"), K = xt(t, "change");
      if (K || G) {
        var oe = {
          from: A,
          to: O,
          text: r.text,
          removed: r.removed,
          origin: r.origin
        };
        K && jt(t, "change", t, oe), G && (t.curOp.changeObjs || (t.curOp.changeObjs = [])).push(oe);
      }
      t.display.selForContextMenu = null;
    }
    function bi(t, r, s, a, d) {
      var A;
      a || (a = s), ce(a, s) < 0 && (A = [a, s], s = A[0], a = A[1]), typeof r == "string" && (r = t.splitLines(r)), yi(t, { from: s, to: a, text: r, origin: d });
    }
    function Dd(t, r, s, a) {
      s < t.line ? t.line += a : r < t.line && (t.line = r, t.ch = 0);
    }
    function Id(t, r, s, a) {
      for (var d = 0; d < t.length; ++d) {
        var A = t[d], O = !0;
        if (A.ranges) {
          A.copied || (A = t[d] = A.deepCopy(), A.copied = !0);
          for (var $ = 0; $ < A.ranges.length; $++)
            Dd(A.ranges[$].anchor, r, s, a), Dd(A.ranges[$].head, r, s, a);
          continue;
        }
        for (var V = 0; V < A.changes.length; ++V) {
          var U = A.changes[V];
          if (s < U.from.line)
            U.from = ee(U.from.line + a, U.from.ch), U.to = ee(U.to.line + a, U.to.ch);
          else if (r <= U.to.line) {
            O = !1;
            break;
          }
        }
        O || (t.splice(0, d + 1), d = 0);
      }
    }
    function Rd(t, r) {
      var s = r.from.line, a = r.to.line, d = r.text.length - (a - s) - 1;
      Id(t.done, s, a, d), Id(t.undone, s, a, d);
    }
    function no(t, r, s, a) {
      var d = r, A = r;
      return typeof r == "number" ? A = Be(t, Sn(t, r)) : d = ht(r), d == null ? null : (a(A, d) && t.cm && xr(t.cm, d, s), A);
    }
    function ro(t) {
      this.lines = t, this.parent = null;
      for (var r = 0, s = 0; s < t.length; ++s)
        t[s].parent = this, r += t[s].height;
      this.height = r;
    }
    ro.prototype = {
      chunkSize: function () {
        return this.lines.length;
      },
      removeInner: function (t, r) {
        for (var s = t, a = t + r; s < a; ++s) {
          var d = this.lines[s];
          this.height -= d.height, lp(d), jt(d, "delete");
        }
        this.lines.splice(t, r);
      },
      collapse: function (t) {
        t.push.apply(t, this.lines);
      },
      insertInner: function (t, r, s) {
        this.height += s, this.lines = this.lines.slice(0, t).concat(r).concat(this.lines.slice(t));
        for (var a = 0; a < r.length; ++a)
          r[a].parent = this;
      },
      iterN: function (t, r, s) {
        for (var a = t + r; t < a; ++t)
          if (s(this.lines[t]))
            return !0;
      }
    };
    function io(t) {
      this.children = t;
      for (var r = 0, s = 0, a = 0; a < t.length; ++a) {
        var d = t[a];
        r += d.chunkSize(), s += d.height, d.parent = this;
      }
      this.size = r, this.height = s, this.parent = null;
    }
    io.prototype = {
      chunkSize: function () {
        return this.size;
      },
      removeInner: function (t, r) {
        this.size -= r;
        for (var s = 0; s < this.children.length; ++s) {
          var a = this.children[s], d = a.chunkSize();
          if (t < d) {
            var A = Math.min(r, d - t), O = a.height;
            if (a.removeInner(t, A), this.height -= O - a.height, d == A && (this.children.splice(s--, 1), a.parent = null), (r -= A) == 0)
              break;
            t = 0;
          } else
            t -= d;
        }
        if (this.size - r < 25 && (this.children.length > 1 || !(this.children[0] instanceof ro))) {
          var $ = [];
          this.collapse($), this.children = [new ro($)], this.children[0].parent = this;
        }
      },
      collapse: function (t) {
        for (var r = 0; r < this.children.length; ++r)
          this.children[r].collapse(t);
      },
      insertInner: function (t, r, s) {
        this.size += r.length, this.height += s;
        for (var a = 0; a < this.children.length; ++a) {
          var d = this.children[a], A = d.chunkSize();
          if (t <= A) {
            if (d.insertInner(t, r, s), d.lines && d.lines.length > 50) {
              for (var O = d.lines.length % 25 + 25, $ = O; $ < d.lines.length;) {
                var V = new ro(d.lines.slice($, $ += 25));
                d.height -= V.height, this.children.splice(++a, 0, V), V.parent = this;
              }
              d.lines = d.lines.slice(0, O), this.maybeSpill();
            }
            break;
          }
          t -= A;
        }
      },
      maybeSpill: function () {
        if (!(this.children.length <= 10)) {
          var t = this;
          do {
            var r = t.children.splice(t.children.length - 5, 5), s = new io(r);
            if (t.parent) {
              t.size -= s.size, t.height -= s.height;
              var d = se(t.parent.children, t);
              t.parent.children.splice(d + 1, 0, s);
            } else {
              var a = new io(t.children);
              a.parent = t, t.children = [a, s], t = a;
            }
            s.parent = t.parent;
          } while (t.children.length > 10);
          t.parent.maybeSpill();
        }
      },
      iterN: function (t, r, s) {
        for (var a = 0; a < this.children.length; ++a) {
          var d = this.children[a], A = d.chunkSize();
          if (t < A) {
            var O = Math.min(r, A - t);
            if (d.iterN(t, O, s))
              return !0;
            if ((r -= O) == 0)
              break;
            t = 0;
          } else
            t -= A;
        }
      }
    };
    var oo = function (t, r, s) {
      if (s)
        for (var a in s)
          s.hasOwnProperty(a) && (this[a] = s[a]);
      this.doc = t, this.node = r;
    };
    oo.prototype.clear = function () {
      var t = this.doc.cm, r = this.line.widgets, s = this.line, a = ht(s);
      if (!(a == null || !r)) {
        for (var d = 0; d < r.length; ++d)
          r[d] == this && r.splice(d--, 1);
        r.length || (s.widgets = null);
        var A = Gi(this);
        Fn(s, Math.max(0, s.height - A)), t && (mn(t, function () {
          Fd(t, s, -A), xr(t, a, "widget");
        }), jt(t, "lineWidgetCleared", t, this, a));
      }
    }, oo.prototype.changed = function () {
      var t = this, r = this.height, s = this.doc.cm, a = this.line;
      this.height = null;
      var d = Gi(this) - r;
      !d || (wr(this.doc, a) || Fn(a, a.height + d), s && mn(s, function () {
        s.curOp.forceUpdate = !0, Fd(s, a, d), jt(s, "lineWidgetChanged", s, t, ht(a));
      }));
    }, Ct(oo);
    function Fd(t, r, s) {
      or(r) < (t.curOp && t.curOp.scrollTop || t.doc.scrollTop) && Sa(t, s);
    }
    function lh(t, r, s, a) {
      var d = new oo(t, s, a), A = t.cm;
      return A && d.noHScroll && (A.display.alignWidgets = !0), no(t, r, "widget", function (O) {
        var $ = O.widgets || (O.widgets = []);
        if (d.insertAt == null ? $.push(d) : $.splice(Math.min($.length, Math.max(0, d.insertAt)), 0, d), d.line = O, A && !wr(t, O)) {
          var V = or(O) < t.scrollTop;
          Fn(O, O.height + Gi(d)), V && Sa(A, d.height), A.curOp.forceUpdate = !0;
        }
        return !0;
      }), A && jt(A, "lineWidgetAdded", A, d, typeof r == "number" ? r : ht(r)), d;
    }
    var Md = 0, Fr = function (t, r) {
      this.lines = [], this.type = r, this.doc = t, this.id = ++Md;
    };
    Fr.prototype.clear = function () {
      if (!this.explicitlyCleared) {
        var t = this.doc.cm, r = t && !t.curOp;
        if (r && Kr(t), xt(this, "clear")) {
          var s = this.find();
          s && jt(this, "clear", s.from, s.to);
        }
        for (var a = null, d = null, A = 0; A < this.lines.length; ++A) {
          var O = this.lines[A], $ = ji(O.markedSpans, this);
          t && !this.collapsed ? xr(t, ht(O), "text") : t && ($.to != null && (d = ht(O)), $.from != null && (a = ht(O))), O.markedSpans = Zc(O.markedSpans, $), $.from == null && this.collapsed && !wr(this.doc, O) && t && Fn(O, fi(t.display));
        }
        if (t && this.collapsed && !t.options.lineWrapping)
          for (var V = 0; V < this.lines.length; ++V) {
            var U = Pn(this.lines[V]), G = Yo(U);
            G > t.display.maxLineLength && (t.display.maxLine = U, t.display.maxLineLength = G, t.display.maxLineChanged = !0);
          }
        a != null && t && this.collapsed && an(t, a, d + 1), this.lines.length = 0, this.explicitlyCleared = !0, this.atomic && this.doc.cantEdit && (this.doc.cantEdit = !1, t && Ad(t.doc)), t && jt(t, "markerCleared", t, this, a, d), r && Jr(t), this.parent && this.parent.clear();
      }
    }, Fr.prototype.find = function (t, r) {
      t == null && this.type == "bookmark" && (t = 1);
      for (var s, a, d = 0; d < this.lines.length; ++d) {
        var A = this.lines[d], O = ji(A.markedSpans, this);
        if (O.from != null && (s = ee(r ? A : ht(A), O.from), t == -1))
          return s;
        if (O.to != null && (a = ee(r ? A : ht(A), O.to), t == 1))
          return a;
      }
      return s && { from: s, to: a };
    }, Fr.prototype.changed = function () {
      var t = this, r = this.find(-1, !0), s = this, a = this.doc.cm;
      !r || !a || mn(a, function () {
        var d = r.line, A = ht(r.line), O = ua(a, A);
        if (O && (Bu(O), a.curOp.selectionChanged = a.curOp.forceUpdate = !0), a.curOp.updateMaxLine = !0, !wr(s.doc, d) && s.height != null) {
          var $ = s.height;
          s.height = null;
          var V = Gi(s) - $;
          V && Fn(d, d.height + V);
        }
        jt(a, "markerChanged", a, t);
      });
    }, Fr.prototype.attachLine = function (t) {
      if (!this.lines.length && this.doc.cm) {
        var r = this.doc.cm.curOp;
        (!r.maybeHiddenMarkers || se(r.maybeHiddenMarkers, this) == -1) && (r.maybeUnhiddenMarkers || (r.maybeUnhiddenMarkers = [])).push(this);
      }
      this.lines.push(t);
    }, Fr.prototype.detachLine = function (t) {
      if (this.lines.splice(se(this.lines, t), 1), !this.lines.length && this.doc.cm) {
        var r = this.doc.cm.curOp;
        (r.maybeHiddenMarkers || (r.maybeHiddenMarkers = [])).push(this);
      }
    }, Ct(Fr);
    function Ai(t, r, s, a, d) {
      if (a && a.shared)
        return ah(t, r, s, a, d);
      if (t.cm && !t.cm.curOp)
        return zt(t.cm, Ai)(t, r, s, a, d);
      var A = new Fr(t, d), O = ce(r, s);
      if (a && le(a, A, !1), O > 0 || O == 0 && A.clearWhenEmpty !== !1)
        return A;
      if (A.replacedWith && (A.collapsed = !0, A.widgetNode = j("span", [A.replacedWith], "CodeMirror-widget"), a.handleMouseEvents || A.widgetNode.setAttribute("cm-ignore-events", "true"), a.insertLeft && (A.widgetNode.insertLeft = !0)), A.collapsed) {
        if (Cu(t, r.line, r, s, A) || r.line != s.line && Cu(t, s.line, r, s, A))
          throw new Error("Inserting collapsed marker partially overlapping an existing one");
        Xc();
      }
      A.addToHistory && pd(t, { from: r, to: s, origin: "markText" }, t.sel, NaN);
      var $ = r.line, V = t.cm, U;
      if (t.iter($, s.line + 1, function (K) {
        V && A.collapsed && !V.options.lineWrapping && Pn(K) == V.display.maxLine && (U = !0), A.collapsed && $ != r.line && Fn(K, 0), qc(K, new jo(
          A,
          $ == r.line ? r.ch : null,
          $ == s.line ? s.ch : null
        ), t.cm && t.cm.curOp), ++$;
      }), A.collapsed && t.iter(r.line, s.line + 1, function (K) {
        wr(t, K) && Fn(K, 0);
      }), A.clearOnEnter && de(A, "beforeCursorEnter", function () {
        return A.clear();
      }), A.readOnly && (Jc(), (t.history.done.length || t.history.undone.length) && t.clearHistory()), A.collapsed && (A.id = ++Md, A.atomic = !0), V) {
        if (U && (V.curOp.updateMaxLine = !0), A.collapsed)
          an(V, r.line, s.line + 1);
        else if (A.className || A.startStyle || A.endStyle || A.css || A.attributes || A.title)
          for (var G = r.line; G <= s.line; G++)
            xr(V, G, "text");
        A.atomic && Ad(V.doc), jt(V, "markerAdded", V, A);
      }
      return A;
    }
    var lo = function (t, r) {
      this.markers = t, this.primary = r;
      for (var s = 0; s < t.length; ++s)
        t[s].parent = this;
    };
    lo.prototype.clear = function () {
      if (!this.explicitlyCleared) {
        this.explicitlyCleared = !0;
        for (var t = 0; t < this.markers.length; ++t)
          this.markers[t].clear();
        jt(this, "clear");
      }
    }, lo.prototype.find = function (t, r) {
      return this.primary.find(t, r);
    }, Ct(lo);
    function ah(t, r, s, a, d) {
      a = le(a), a.shared = !1;
      var A = [Ai(t, r, s, a, d)], O = A[0], $ = a.widgetNode;
      return Rr(t, function (V) {
        $ && (a.widgetNode = $.cloneNode(!0)), A.push(Ai(V, Ye(V, r), Ye(V, s), a, d));
        for (var U = 0; U < V.linked.length; ++U)
          if (V.linked[U].isParent)
            return;
        O = He(A);
      }), new lo(A, O);
    }
    function Od(t) {
      return t.findMarks(ee(t.first, 0), t.clipPos(ee(t.lastLine())), function (r) {
        return r.parent;
      });
    }
    function sh(t, r) {
      for (var s = 0; s < r.length; s++) {
        var a = r[s], d = a.find(), A = t.clipPos(d.from), O = t.clipPos(d.to);
        if (ce(A, O)) {
          var $ = Ai(t, A, O, a.primary, a.primary.type);
          a.markers.push($), $.parent = a;
        }
      }
    }
    function uh(t) {
      for (var r = function (a) {
        var d = t[a], A = [d.primary.doc];
        Rr(d.primary.doc, function (V) {
          return A.push(V);
        });
        for (var O = 0; O < d.markers.length; O++) {
          var $ = d.markers[O];
          se(A, $.doc) == -1 && ($.parent = null, d.markers.splice(O--, 1));
        }
      }, s = 0; s < t.length; s++)
        r(s);
    }
    var dh = 0, sn = function (t, r, s, a, d) {
      if (!(this instanceof sn))
        return new sn(t, r, s, a, d);
      s == null && (s = 0), io.call(this, [new ro([new si("", null)])]), this.first = s, this.scrollTop = this.scrollLeft = 0, this.cantEdit = !1, this.cleanGeneration = 1, this.modeFrontier = this.highlightFrontier = s;
      var A = ee(s, 0);
      this.sel = Dr(A), this.history = new il(null), this.id = ++dh, this.modeOption = r, this.lineSep = a, this.direction = d == "rtl" ? "rtl" : "ltr", this.extend = !1, typeof t == "string" && (t = this.splitLines(t)), Fa(this, { from: A, to: A, text: t }), Xt(this, Dr(A), Ne);
    };
    sn.prototype = yr(io.prototype, {
      constructor: sn,
      iter: function (t, r, s) {
        s ? this.iterN(t - this.first, r - t, s) : this.iterN(this.first, this.first + this.size, t);
      },
      insert: function (t, r) {
        for (var s = 0, a = 0; a < r.length; ++a)
          s += r[a].height;
        this.insertInner(t - this.first, r, s);
      },
      remove: function (t, r) {
        this.removeInner(t - this.first, r);
      },
      getValue: function (t) {
        var r = ai(this, this.first, this.first + this.size);
        return t === !1 ? r : r.join(t || this.lineSeparator());
      },
      setValue: Wt(function (t) {
        var r = ee(this.first, 0), s = this.first + this.size - 1;
        yi(this, {
          from: r,
          to: ee(s, Be(this, s).text.length),
          text: this.splitLines(t),
          origin: "setValue",
          full: !0
        }, !0), this.cm && Ki(this.cm, 0, 0), Xt(this, Dr(r), Ne);
      }),
      replaceRange: function (t, r, s, a) {
        r = Ye(this, r), s = s ? Ye(this, s) : r, bi(this, t, r, s, a);
      },
      getRange: function (t, r, s) {
        var a = rr(this, Ye(this, t), Ye(this, r));
        return s === !1 ? a : s === "" ? a.join("") : a.join(s || this.lineSeparator());
      },
      getLine: function (t) {
        var r = this.getLineHandle(t);
        return r && r.text;
      },
      getLineHandle: function (t) {
        if (z(this, t))
          return Be(this, t);
      },
      getLineNumber: function (t) {
        return ht(t);
      },
      getLineHandleVisualStart: function (t) {
        return typeof t == "number" && (t = Be(this, t)), Pn(t);
      },
      lineCount: function () {
        return this.size;
      },
      firstLine: function () {
        return this.first;
      },
      lastLine: function () {
        return this.first + this.size - 1;
      },
      clipPos: function (t) {
        return Ye(this, t);
      },
      getCursor: function (t) {
        var r = this.sel.primary(), s;
        return t == null || t == "head" ? s = r.head : t == "anchor" ? s = r.anchor : t == "end" || t == "to" || t === !1 ? s = r.to() : s = r.from(), s;
      },
      listSelections: function () {
        return this.sel.ranges;
      },
      somethingSelected: function () {
        return this.sel.somethingSelected();
      },
      setCursor: Wt(function (t, r, s) {
        gd(this, Ye(this, typeof t == "number" ? ee(t, r || 0) : t), null, s);
      }),
      setSelection: Wt(function (t, r, s) {
        gd(this, Ye(this, t), Ye(this, r || t), s);
      }),
      extendSelection: Wt(function (t, r, s) {
        ll(this, Ye(this, t), r && Ye(this, r), s);
      }),
      extendSelections: Wt(function (t, r) {
        md(this, au(this, t), r);
      }),
      extendSelectionsBy: Wt(function (t, r) {
        var s = bt(this.sel.ranges, t);
        md(this, au(this, s), r);
      }),
      setSelections: Wt(function (t, r, s) {
        if (!!t.length) {
          for (var a = [], d = 0; d < t.length; d++)
            a[d] = new vt(
              Ye(this, t[d].anchor),
              Ye(this, t[d].head || t[d].anchor)
            );
          r == null && (r = Math.min(t.length - 1, this.sel.primIndex)), Xt(this, Bn(this.cm, a, r), s);
        }
      }),
      addSelection: Wt(function (t, r, s) {
        var a = this.sel.ranges.slice(0);
        a.push(new vt(Ye(this, t), Ye(this, r || t))), Xt(this, Bn(this.cm, a, a.length - 1), s);
      }),
      getSelection: function (t) {
        for (var r = this.sel.ranges, s, a = 0; a < r.length; a++) {
          var d = rr(this, r[a].from(), r[a].to());
          s = s ? s.concat(d) : d;
        }
        return t === !1 ? s : s.join(t || this.lineSeparator());
      },
      getSelections: function (t) {
        for (var r = [], s = this.sel.ranges, a = 0; a < s.length; a++) {
          var d = rr(this, s[a].from(), s[a].to());
          t !== !1 && (d = d.join(t || this.lineSeparator())), r[a] = d;
        }
        return r;
      },
      replaceSelection: function (t, r, s) {
        for (var a = [], d = 0; d < this.sel.ranges.length; d++)
          a[d] = t;
        this.replaceSelections(a, r, s || "+input");
      },
      replaceSelections: Wt(function (t, r, s) {
        for (var a = [], d = this.sel, A = 0; A < d.ranges.length; A++) {
          var O = d.ranges[A];
          a[A] = { from: O.from(), to: O.to(), text: this.splitLines(t[A]), origin: s };
        }
        for (var $ = r && r != "end" && Zp(this, a, r), V = a.length - 1; V >= 0; V--)
          yi(this, a[V]);
        $ ? yd(this, $) : this.cm && hi(this.cm);
      }),
      undo: Wt(function () {
        ul(this, "undo");
      }),
      redo: Wt(function () {
        ul(this, "redo");
      }),
      undoSelection: Wt(function () {
        ul(this, "undo", !0);
      }),
      redoSelection: Wt(function () {
        ul(this, "redo", !0);
      }),
      setExtending: function (t) {
        this.extend = t;
      },
      getExtending: function () {
        return this.extend;
      },
      historySize: function () {
        for (var t = this.history, r = 0, s = 0, a = 0; a < t.done.length; a++)
          t.done[a].ranges || ++r;
        for (var d = 0; d < t.undone.length; d++)
          t.undone[d].ranges || ++s;
        return { undo: r, redo: s };
      },
      clearHistory: function () {
        var t = this;
        this.history = new il(this.history), Rr(this, function (r) {
          return r.history = t.history;
        }, !0);
      },
      markClean: function () {
        this.cleanGeneration = this.changeGeneration(!0);
      },
      changeGeneration: function (t) {
        return t && (this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null), this.history.generation;
      },
      isClean: function (t) {
        return this.history.generation == (t || this.cleanGeneration);
      },
      getHistory: function () {
        return {
          done: mi(this.history.done),
          undone: mi(this.history.undone)
        };
      },
      setHistory: function (t) {
        var r = this.history = new il(this.history);
        r.done = mi(t.done.slice(0), null, !0), r.undone = mi(t.undone.slice(0), null, !0);
      },
      setGutterMarker: Wt(function (t, r, s) {
        return no(this, t, "gutter", function (a) {
          var d = a.gutterMarkers || (a.gutterMarkers = {});
          return d[r] = s, !s && jn(d) && (a.gutterMarkers = null), !0;
        });
      }),
      clearGutter: Wt(function (t) {
        var r = this;
        this.iter(function (s) {
          s.gutterMarkers && s.gutterMarkers[t] && no(r, s, "gutter", function () {
            return s.gutterMarkers[t] = null, jn(s.gutterMarkers) && (s.gutterMarkers = null), !0;
          });
        });
      }),
      lineInfo: function (t) {
        var r;
        if (typeof t == "number") {
          if (!z(this, t) || (r = t, t = Be(this, t), !t))
            return null;
        } else if (r = ht(t), r == null)
          return null;
        return {
          line: r,
          handle: t,
          text: t.text,
          gutterMarkers: t.gutterMarkers,
          textClass: t.textClass,
          bgClass: t.bgClass,
          wrapClass: t.wrapClass,
          widgets: t.widgets
        };
      },
      addLineClass: Wt(function (t, r, s) {
        return no(this, t, r == "gutter" ? "gutter" : "class", function (a) {
          var d = r == "text" ? "textClass" : r == "background" ? "bgClass" : r == "gutter" ? "gutterClass" : "wrapClass";
          if (!a[d])
            a[d] = s;
          else {
            if (P(s).test(a[d]))
              return !1;
            a[d] += " " + s;
          }
          return !0;
        });
      }),
      removeLineClass: Wt(function (t, r, s) {
        return no(this, t, r == "gutter" ? "gutter" : "class", function (a) {
          var d = r == "text" ? "textClass" : r == "background" ? "bgClass" : r == "gutter" ? "gutterClass" : "wrapClass", A = a[d];
          if (A)
            if (s == null)
              a[d] = null;
            else {
              var O = A.match(P(s));
              if (!O)
                return !1;
              var $ = O.index + O[0].length;
              a[d] = A.slice(0, O.index) + (!O.index || $ == A.length ? "" : " ") + A.slice($) || null;
            }
          else
            return !1;
          return !0;
        });
      }),
      addLineWidget: Wt(function (t, r, s) {
        return lh(this, t, r, s);
      }),
      removeLineWidget: function (t) {
        t.clear();
      },
      markText: function (t, r, s) {
        return Ai(this, Ye(this, t), Ye(this, r), s, s && s.type || "range");
      },
      setBookmark: function (t, r) {
        var s = {
          replacedWith: r && (r.nodeType == null ? r.widget : r),
          insertLeft: r && r.insertLeft,
          clearWhenEmpty: !1,
          shared: r && r.shared,
          handleMouseEvents: r && r.handleMouseEvents
        };
        return t = Ye(this, t), Ai(this, t, t, s, "bookmark");
      },
      findMarksAt: function (t) {
        t = Ye(this, t);
        var r = [], s = Be(this, t.line).markedSpans;
        if (s)
          for (var a = 0; a < s.length; ++a) {
            var d = s[a];
            (d.from == null || d.from <= t.ch) && (d.to == null || d.to >= t.ch) && r.push(d.marker.parent || d.marker);
          }
        return r;
      },
      findMarks: function (t, r, s) {
        t = Ye(this, t), r = Ye(this, r);
        var a = [], d = t.line;
        return this.iter(t.line, r.line + 1, function (A) {
          var O = A.markedSpans;
          if (O)
            for (var $ = 0; $ < O.length; $++) {
              var V = O[$];
              !(V.to != null && d == t.line && t.ch >= V.to || V.from == null && d != t.line || V.from != null && d == r.line && V.from >= r.ch) && (!s || s(V.marker)) && a.push(V.marker.parent || V.marker);
            }
          ++d;
        }), a;
      },
      getAllMarks: function () {
        var t = [];
        return this.iter(function (r) {
          var s = r.markedSpans;
          if (s)
            for (var a = 0; a < s.length; ++a)
              s[a].from != null && t.push(s[a].marker);
        }), t;
      },
      posFromIndex: function (t) {
        var r, s = this.first, a = this.lineSeparator().length;
        return this.iter(function (d) {
          var A = d.text.length + a;
          if (A > t)
            return r = t, !0;
          t -= A, ++s;
        }), Ye(this, ee(s, r));
      },
      indexFromPos: function (t) {
        t = Ye(this, t);
        var r = t.ch;
        if (t.line < this.first || t.ch < 0)
          return 0;
        var s = this.lineSeparator().length;
        return this.iter(this.first, t.line, function (a) {
          r += a.text.length + s;
        }), r;
      },
      copy: function (t) {
        var r = new sn(
          ai(this, this.first, this.first + this.size),
          this.modeOption,
          this.first,
          this.lineSep,
          this.direction
        );
        return r.scrollTop = this.scrollTop, r.scrollLeft = this.scrollLeft, r.sel = this.sel, r.extend = !1, t && (r.history.undoDepth = this.history.undoDepth, r.setHistory(this.getHistory())), r;
      },
      linkedDoc: function (t) {
        t || (t = {});
        var r = this.first, s = this.first + this.size;
        t.from != null && t.from > r && (r = t.from), t.to != null && t.to < s && (s = t.to);
        var a = new sn(ai(this, r, s), t.mode || this.modeOption, r, this.lineSep, this.direction);
        return t.sharedHist && (a.history = this.history), (this.linked || (this.linked = [])).push({ doc: a, sharedHist: t.sharedHist }), a.linked = [{ doc: this, isParent: !0, sharedHist: t.sharedHist }], sh(a, Od(this)), a;
      },
      unlinkDoc: function (t) {
        if (t instanceof wt && (t = t.doc), this.linked)
          for (var r = 0; r < this.linked.length; ++r) {
            var s = this.linked[r];
            if (s.doc == t) {
              this.linked.splice(r, 1), t.unlinkDoc(this), uh(Od(this));
              break;
            }
          }
        if (t.history == this.history) {
          var a = [t.id];
          Rr(t, function (d) {
            return a.push(d.id);
          }, !0), t.history = new il(null), t.history.done = mi(this.history.done, a), t.history.undone = mi(this.history.undone, a);
        }
      },
      iterLinkedDocs: function (t) {
        Rr(this, t);
      },
      getMode: function () {
        return this.mode;
      },
      getEditor: function () {
        return this.cm;
      },
      splitLines: function (t) {
        return this.lineSep ? t.split(this.lineSep) : Hi(t);
      },
      lineSeparator: function () {
        return this.lineSep || `
`;
      },
      setDirection: Wt(function (t) {
        t != "rtl" && (t = "ltr"), t != this.direction && (this.direction = t, this.iter(function (r) {
          return r.order = null;
        }), this.cm && qp(this.cm));
      })
    }), sn.prototype.eachLine = sn.prototype.iter;
    var Nd = 0;
    function fh(t) {
      var r = this;
      if (Ld(r), !(Xe(r, t) || lr(r.display, t))) {
        pt(t), c && (Nd = +new Date());
        var s = Wr(r, t, !0), a = t.dataTransfer.files;
        if (!(!s || r.isReadOnly()))
          if (a && a.length && window.FileReader && window.File)
            for (var d = a.length, A = Array(d), O = 0, $ = function () {
              ++O == d && zt(r, function () {
                s = Ye(r.doc, s);
                var re = {
                  from: s,
                  to: s,
                  text: r.doc.splitLines(
                    A.filter(function (pe) {
                      return pe != null;
                    }).join(r.doc.lineSeparator())
                  ),
                  origin: "paste"
                };
                yi(r.doc, re), yd(r.doc, Dr(Ye(r.doc, s), Ye(r.doc, Ir(re))));
              })();
            }, V = function (re, pe) {
              if (r.options.allowDropFileTypes && se(r.options.allowDropFileTypes, re.type) == -1) {
                $();
                return;
              }
              var ye = new FileReader();
              ye.onerror = function () {
                return $();
              }, ye.onload = function () {
                var Ce = ye.result;
                if (/[\x00-\x08\x0e-\x1f]{2}/.test(Ce)) {
                  $();
                  return;
                }
                A[pe] = Ce, $();
              }, ye.readAsText(re);
            }, U = 0; U < a.length; U++)
              V(a[U], U);
          else {
            if (r.state.draggingText && r.doc.sel.contains(s) > -1) {
              r.state.draggingText(t), setTimeout(function () {
                return r.display.input.focus();
              }, 20);
              return;
            }
            try {
              var G = t.dataTransfer.getData("Text");
              if (G) {
                var K;
                if (r.state.draggingText && !r.state.draggingText.copy && (K = r.listSelections()), al(r.doc, Dr(s, s)), K)
                  for (var oe = 0; oe < K.length; ++oe)
                    bi(r.doc, "", K[oe].anchor, K[oe].head, "drag");
                r.replaceSelection(G, "around", "paste"), r.display.input.focus();
              }
            } catch {
            }
          }
      }
    }
    function ch(t, r) {
      if (c && (!t.state.draggingText || +new Date() - Nd < 100)) {
        Nn(r);
        return;
      }
      if (!(Xe(t, r) || lr(t.display, r)) && (r.dataTransfer.setData("Text", t.getSelection()), r.dataTransfer.effectAllowed = "copyMove", r.dataTransfer.setDragImage && !m)) {
        var s = F("img", null, null, "position: fixed; left: 0; top: 0;");
        s.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", h && (s.width = s.height = 1, t.display.wrapper.appendChild(s), s._top = s.offsetTop), r.dataTransfer.setDragImage(s, 0, 0), h && s.parentNode.removeChild(s);
      }
    }
    function ph(t, r) {
      var s = Wr(t, r);
      if (!!s) {
        var a = document.createDocumentFragment();
        ga(t, s, a), t.display.dragCursor || (t.display.dragCursor = F("div", null, "CodeMirror-cursors CodeMirror-dragcursors"), t.display.lineSpace.insertBefore(t.display.dragCursor, t.display.cursorDiv)), k(t.display.dragCursor, a);
      }
    }
    function Ld(t) {
      t.display.dragCursor && (t.display.lineSpace.removeChild(t.display.dragCursor), t.display.dragCursor = null);
    }
    function Pd(t) {
      if (!!document.getElementsByClassName) {
        for (var r = document.getElementsByClassName("CodeMirror"), s = [], a = 0; a < r.length; a++) {
          var d = r[a].CodeMirror;
          d && s.push(d);
        }
        s.length && s[0].operation(function () {
          for (var A = 0; A < s.length; A++)
            t(s[A]);
        });
      }
    }
    var $d = !1;
    function hh() {
      $d || (vh(), $d = !0);
    }
    function vh() {
      var t;
      de(window, "resize", function () {
        t == null && (t = setTimeout(function () {
          t = null, Pd(mh);
        }, 100));
      }), de(window, "blur", function () {
        return Pd(pi);
      });
    }
    function mh(t) {
      var r = t.display;
      r.cachedCharWidth = r.cachedTextHeight = r.cachedPaddingH = null, r.scrollbarsClipped = !1, t.setSize();
    }
    for (var Mr = {
      3: "Pause",
      8: "Backspace",
      9: "Tab",
      13: "Enter",
      16: "Shift",
      17: "Ctrl",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Esc",
      32: "Space",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "Left",
      38: "Up",
      39: "Right",
      40: "Down",
      44: "PrintScrn",
      45: "Insert",
      46: "Delete",
      59: ";",
      61: "=",
      91: "Mod",
      92: "Mod",
      93: "Mod",
      106: "*",
      107: "=",
      109: "-",
      110: ".",
      111: "/",
      145: "ScrollLock",
      173: "-",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'",
      224: "Mod",
      63232: "Up",
      63233: "Down",
      63234: "Left",
      63235: "Right",
      63272: "Delete",
      63273: "Home",
      63275: "End",
      63276: "PageUp",
      63277: "PageDown",
      63302: "Insert"
    }, ao = 0; ao < 10; ao++)
      Mr[ao + 48] = Mr[ao + 96] = String(ao);
    for (var dl = 65; dl <= 90; dl++)
      Mr[dl] = String.fromCharCode(dl);
    for (var so = 1; so <= 12; so++)
      Mr[so + 111] = Mr[so + 63235] = "F" + so;
    var sr = {};
    sr.basic = {
      Left: "goCharLeft",
      Right: "goCharRight",
      Up: "goLineUp",
      Down: "goLineDown",
      End: "goLineEnd",
      Home: "goLineStartSmart",
      PageUp: "goPageUp",
      PageDown: "goPageDown",
      Delete: "delCharAfter",
      Backspace: "delCharBefore",
      "Shift-Backspace": "delCharBefore",
      Tab: "defaultTab",
      "Shift-Tab": "indentAuto",
      Enter: "newlineAndIndent",
      Insert: "toggleOverwrite",
      Esc: "singleSelection"
    }, sr.pcDefault = {
      "Ctrl-A": "selectAll",
      "Ctrl-D": "deleteLine",
      "Ctrl-Z": "undo",
      "Shift-Ctrl-Z": "redo",
      "Ctrl-Y": "redo",
      "Ctrl-Home": "goDocStart",
      "Ctrl-End": "goDocEnd",
      "Ctrl-Up": "goLineUp",
      "Ctrl-Down": "goLineDown",
      "Ctrl-Left": "goGroupLeft",
      "Ctrl-Right": "goGroupRight",
      "Alt-Left": "goLineStart",
      "Alt-Right": "goLineEnd",
      "Ctrl-Backspace": "delGroupBefore",
      "Ctrl-Delete": "delGroupAfter",
      "Ctrl-S": "save",
      "Ctrl-F": "find",
      "Ctrl-G": "findNext",
      "Shift-Ctrl-G": "findPrev",
      "Shift-Ctrl-F": "replace",
      "Shift-Ctrl-R": "replaceAll",
      "Ctrl-[": "indentLess",
      "Ctrl-]": "indentMore",
      "Ctrl-U": "undoSelection",
      "Shift-Ctrl-U": "redoSelection",
      "Alt-U": "redoSelection",
      fallthrough: "basic"
    }, sr.emacsy = {
      "Ctrl-F": "goCharRight",
      "Ctrl-B": "goCharLeft",
      "Ctrl-P": "goLineUp",
      "Ctrl-N": "goLineDown",
      "Ctrl-A": "goLineStart",
      "Ctrl-E": "goLineEnd",
      "Ctrl-V": "goPageDown",
      "Shift-Ctrl-V": "goPageUp",
      "Ctrl-D": "delCharAfter",
      "Ctrl-H": "delCharBefore",
      "Alt-Backspace": "delWordBefore",
      "Ctrl-K": "killLine",
      "Ctrl-T": "transposeChars",
      "Ctrl-O": "openLine"
    }, sr.macDefault = {
      "Cmd-A": "selectAll",
      "Cmd-D": "deleteLine",
      "Cmd-Z": "undo",
      "Shift-Cmd-Z": "redo",
      "Cmd-Y": "redo",
      "Cmd-Home": "goDocStart",
      "Cmd-Up": "goDocStart",
      "Cmd-End": "goDocEnd",
      "Cmd-Down": "goDocEnd",
      "Alt-Left": "goGroupLeft",
      "Alt-Right": "goGroupRight",
      "Cmd-Left": "goLineLeft",
      "Cmd-Right": "goLineRight",
      "Alt-Backspace": "delGroupBefore",
      "Ctrl-Alt-Backspace": "delGroupAfter",
      "Alt-Delete": "delGroupAfter",
      "Cmd-S": "save",
      "Cmd-F": "find",
      "Cmd-G": "findNext",
      "Shift-Cmd-G": "findPrev",
      "Cmd-Alt-F": "replace",
      "Shift-Cmd-Alt-F": "replaceAll",
      "Cmd-[": "indentLess",
      "Cmd-]": "indentMore",
      "Cmd-Backspace": "delWrappedLineLeft",
      "Cmd-Delete": "delWrappedLineRight",
      "Cmd-U": "undoSelection",
      "Shift-Cmd-U": "redoSelection",
      "Ctrl-Up": "goDocStart",
      "Ctrl-Down": "goDocEnd",
      fallthrough: ["basic", "emacsy"]
    }, sr.default = R ? sr.macDefault : sr.pcDefault;
    function gh(t) {
      var r = t.split(/-(?!$)/);
      t = r[r.length - 1];
      for (var s, a, d, A, O = 0; O < r.length - 1; O++) {
        var $ = r[O];
        if (/^(cmd|meta|m)$/i.test($))
          A = !0;
        else if (/^a(lt)?$/i.test($))
          s = !0;
        else if (/^(c|ctrl|control)$/i.test($))
          a = !0;
        else if (/^s(hift)?$/i.test($))
          d = !0;
        else
          throw new Error("Unrecognized modifier name: " + $);
      }
      return s && (t = "Alt-" + t), a && (t = "Ctrl-" + t), A && (t = "Cmd-" + t), d && (t = "Shift-" + t), t;
    }
    function yh(t) {
      var r = {};
      for (var s in t)
        if (t.hasOwnProperty(s)) {
          var a = t[s];
          if (/^(name|fallthrough|(de|at)tach)$/.test(s))
            continue;
          if (a == "...") {
            delete t[s];
            continue;
          }
          for (var d = bt(s.split(" "), gh), A = 0; A < d.length; A++) {
            var O = void 0, $ = void 0;
            A == d.length - 1 ? ($ = d.join(" "), O = a) : ($ = d.slice(0, A + 1).join(" "), O = "...");
            var V = r[$];
            if (!V)
              r[$] = O;
            else if (V != O)
              throw new Error("Inconsistent bindings for " + $);
          }
          delete t[s];
        }
      for (var U in r)
        t[U] = r[U];
      return t;
    }
    function Ci(t, r, s, a) {
      r = fl(r);
      var d = r.call ? r.call(t, a) : r[t];
      if (d === !1)
        return "nothing";
      if (d === "...")
        return "multi";
      if (d != null && s(d))
        return "handled";
      if (r.fallthrough) {
        if (Object.prototype.toString.call(r.fallthrough) != "[object Array]")
          return Ci(t, r.fallthrough, s, a);
        for (var A = 0; A < r.fallthrough.length; A++) {
          var O = Ci(t, r.fallthrough[A], s, a);
          if (O)
            return O;
        }
      }
    }
    function Bd(t) {
      var r = typeof t == "string" ? t : Mr[t.keyCode];
      return r == "Ctrl" || r == "Alt" || r == "Shift" || r == "Mod";
    }
    function kd(t, r, s) {
      var a = t;
      return r.altKey && a != "Alt" && (t = "Alt-" + t), (B ? r.metaKey : r.ctrlKey) && a != "Ctrl" && (t = "Ctrl-" + t), (B ? r.ctrlKey : r.metaKey) && a != "Mod" && (t = "Cmd-" + t), !s && r.shiftKey && a != "Shift" && (t = "Shift-" + t), t;
    }
    function Hd(t, r) {
      if (h && t.keyCode == 34 && t.char)
        return !1;
      var s = Mr[t.keyCode];
      return s == null || t.altGraphKey ? !1 : (t.keyCode == 3 && t.code && (s = t.code), kd(s, t, r));
    }
    function fl(t) {
      return typeof t == "string" ? sr[t] : t;
    }
    function Si(t, r) {
      for (var s = t.doc.sel.ranges, a = [], d = 0; d < s.length; d++) {
        for (var A = r(s[d]); a.length && ce(A.from, He(a).to) <= 0;) {
          var O = a.pop();
          if (ce(O.from, A.from) < 0) {
            A.from = O.from;
            break;
          }
        }
        a.push(A);
      }
      mn(t, function () {
        for (var $ = a.length - 1; $ >= 0; $--)
          bi(t.doc, "", a[$].from, a[$].to, "+delete");
        hi(t);
      });
    }
    function La(t, r, s) {
      var a = Bt(t.text, r + s, s);
      return a < 0 || a > t.text.length ? null : a;
    }
    function Pa(t, r, s) {
      var a = La(t, r.ch, s);
      return a == null ? null : new ee(r.line, a, s < 0 ? "after" : "before");
    }
    function $a(t, r, s, a, d) {
      if (t) {
        r.doc.direction == "rtl" && (d = -d);
        var A = je(s, r.doc.direction);
        if (A) {
          var O = d < 0 ? He(A) : A[0], $ = d < 0 == (O.level == 1), V = $ ? "after" : "before", U;
          if (O.level > 0 || r.doc.direction == "rtl") {
            var G = di(r, s);
            U = d < 0 ? s.text.length - 1 : 0;
            var K = Kn(r, G, U).top;
            U = ct(function (oe) {
              return Kn(r, G, oe).top == K;
            }, d < 0 == (O.level == 1) ? O.from : O.to - 1, U), V == "before" && (U = La(s, U, 1));
          } else
            U = d < 0 ? O.to : O.from;
          return new ee(a, U, V);
        }
      }
      return new ee(a, d < 0 ? s.text.length : 0, d < 0 ? "before" : "after");
    }
    function bh(t, r, s, a) {
      var d = je(r, t.doc.direction);
      if (!d)
        return Pa(r, s, a);
      s.ch >= r.text.length ? (s.ch = r.text.length, s.sticky = "before") : s.ch <= 0 && (s.ch = 0, s.sticky = "after");
      var A = Me(d, s.ch, s.sticky), O = d[A];
      if (t.doc.direction == "ltr" && O.level % 2 == 0 && (a > 0 ? O.to > s.ch : O.from < s.ch))
        return Pa(r, s, a);
      var $ = function (Te, Fe) {
        return La(r, Te instanceof ee ? Te.ch : Te, Fe);
      }, V, U = function (Te) {
        return t.options.lineWrapping ? (V = V || di(t, r), Wu(t, r, V, Te)) : { begin: 0, end: r.text.length };
      }, G = U(s.sticky == "before" ? $(s, -1) : s.ch);
      if (t.doc.direction == "rtl" || O.level == 1) {
        var K = O.level == 1 == a < 0, oe = $(s, K ? 1 : -1);
        if (oe != null && (K ? oe <= O.to && oe <= G.end : oe >= O.from && oe >= G.begin)) {
          var re = K ? "before" : "after";
          return new ee(s.line, oe, re);
        }
      }
      var pe = function (Te, Fe, De) {
        for (var Le = function (At, Gt) {
          return Gt ? new ee(s.line, $(At, 1), "before") : new ee(s.line, At, "after");
        }; Te >= 0 && Te < d.length; Te += Fe) {
          var Ue = d[Te], Ve = Fe > 0 == (Ue.level != 1), tt = Ve ? De.begin : $(De.end, -1);
          if (Ue.from <= tt && tt < Ue.to || (tt = Ve ? Ue.from : $(Ue.to, -1), De.begin <= tt && tt < De.end))
            return Le(tt, Ve);
        }
      }, ye = pe(A + a, a, G);
      if (ye)
        return ye;
      var Ce = a > 0 ? G.end : $(G.begin, -1);
      return Ce != null && !(a > 0 && Ce == r.text.length) && (ye = pe(a > 0 ? 0 : d.length - 1, a, U(Ce)), ye) ? ye : null;
    }
    var uo = {
      selectAll: Ed,
      singleSelection: function (t) {
        return t.setSelection(t.getCursor("anchor"), t.getCursor("head"), Ne);
      },
      killLine: function (t) {
        return Si(t, function (r) {
          if (r.empty()) {
            var s = Be(t.doc, r.head.line).text.length;
            return r.head.ch == s && r.head.line < t.lastLine() ? { from: r.head, to: ee(r.head.line + 1, 0) } : { from: r.head, to: ee(r.head.line, s) };
          } else
            return { from: r.from(), to: r.to() };
        });
      },
      deleteLine: function (t) {
        return Si(t, function (r) {
          return {
            from: ee(r.from().line, 0),
            to: Ye(t.doc, ee(r.to().line + 1, 0))
          };
        });
      },
      delLineLeft: function (t) {
        return Si(t, function (r) {
          return {
            from: ee(r.from().line, 0),
            to: r.from()
          };
        });
      },
      delWrappedLineLeft: function (t) {
        return Si(t, function (r) {
          var s = t.charCoords(r.head, "div").top + 5, a = t.coordsChar({ left: 0, top: s }, "div");
          return { from: a, to: r.from() };
        });
      },
      delWrappedLineRight: function (t) {
        return Si(t, function (r) {
          var s = t.charCoords(r.head, "div").top + 5, a = t.coordsChar({ left: t.display.lineDiv.offsetWidth + 100, top: s }, "div");
          return { from: r.from(), to: a };
        });
      },
      undo: function (t) {
        return t.undo();
      },
      redo: function (t) {
        return t.redo();
      },
      undoSelection: function (t) {
        return t.undoSelection();
      },
      redoSelection: function (t) {
        return t.redoSelection();
      },
      goDocStart: function (t) {
        return t.extendSelection(ee(t.firstLine(), 0));
      },
      goDocEnd: function (t) {
        return t.extendSelection(ee(t.lastLine()));
      },
      goLineStart: function (t) {
        return t.extendSelectionsBy(
          function (r) {
            return Vd(t, r.head.line);
          },
          { origin: "+move", bias: 1 }
        );
      },
      goLineStartSmart: function (t) {
        return t.extendSelectionsBy(
          function (r) {
            return Ud(t, r.head);
          },
          { origin: "+move", bias: 1 }
        );
      },
      goLineEnd: function (t) {
        return t.extendSelectionsBy(
          function (r) {
            return Ah(t, r.head.line);
          },
          { origin: "+move", bias: -1 }
        );
      },
      goLineRight: function (t) {
        return t.extendSelectionsBy(function (r) {
          var s = t.cursorCoords(r.head, "div").top + 5;
          return t.coordsChar({ left: t.display.lineDiv.offsetWidth + 100, top: s }, "div");
        }, at);
      },
      goLineLeft: function (t) {
        return t.extendSelectionsBy(function (r) {
          var s = t.cursorCoords(r.head, "div").top + 5;
          return t.coordsChar({ left: 0, top: s }, "div");
        }, at);
      },
      goLineLeftSmart: function (t) {
        return t.extendSelectionsBy(function (r) {
          var s = t.cursorCoords(r.head, "div").top + 5, a = t.coordsChar({ left: 0, top: s }, "div");
          return a.ch < t.getLine(a.line).search(/\S/) ? Ud(t, r.head) : a;
        }, at);
      },
      goLineUp: function (t) {
        return t.moveV(-1, "line");
      },
      goLineDown: function (t) {
        return t.moveV(1, "line");
      },
      goPageUp: function (t) {
        return t.moveV(-1, "page");
      },
      goPageDown: function (t) {
        return t.moveV(1, "page");
      },
      goCharLeft: function (t) {
        return t.moveH(-1, "char");
      },
      goCharRight: function (t) {
        return t.moveH(1, "char");
      },
      goColumnLeft: function (t) {
        return t.moveH(-1, "column");
      },
      goColumnRight: function (t) {
        return t.moveH(1, "column");
      },
      goWordLeft: function (t) {
        return t.moveH(-1, "word");
      },
      goGroupRight: function (t) {
        return t.moveH(1, "group");
      },
      goGroupLeft: function (t) {
        return t.moveH(-1, "group");
      },
      goWordRight: function (t) {
        return t.moveH(1, "word");
      },
      delCharBefore: function (t) {
        return t.deleteH(-1, "codepoint");
      },
      delCharAfter: function (t) {
        return t.deleteH(1, "char");
      },
      delWordBefore: function (t) {
        return t.deleteH(-1, "word");
      },
      delWordAfter: function (t) {
        return t.deleteH(1, "word");
      },
      delGroupBefore: function (t) {
        return t.deleteH(-1, "group");
      },
      delGroupAfter: function (t) {
        return t.deleteH(1, "group");
      },
      indentAuto: function (t) {
        return t.indentSelection("smart");
      },
      indentMore: function (t) {
        return t.indentSelection("add");
      },
      indentLess: function (t) {
        return t.indentSelection("subtract");
      },
      insertTab: function (t) {
        return t.replaceSelection("	");
      },
      insertSoftTab: function (t) {
        for (var r = [], s = t.listSelections(), a = t.options.tabSize, d = 0; d < s.length; d++) {
          var A = s[d].from(), O = ue(t.getLine(A.line), A.ch, a);
          r.push(Et(a - O % a));
        }
        t.replaceSelections(r);
      },
      defaultTab: function (t) {
        t.somethingSelected() ? t.indentSelection("add") : t.execCommand("insertTab");
      },
      transposeChars: function (t) {
        return mn(t, function () {
          for (var r = t.listSelections(), s = [], a = 0; a < r.length; a++)
            if (!!r[a].empty()) {
              var d = r[a].head, A = Be(t.doc, d.line).text;
              if (A) {
                if (d.ch == A.length && (d = new ee(d.line, d.ch - 1)), d.ch > 0)
                  d = new ee(d.line, d.ch + 1), t.replaceRange(
                    A.charAt(d.ch - 1) + A.charAt(d.ch - 2),
                    ee(d.line, d.ch - 2),
                    d,
                    "+transpose"
                  );
                else if (d.line > t.doc.first) {
                  var O = Be(t.doc, d.line - 1).text;
                  O && (d = new ee(d.line, 1), t.replaceRange(
                    A.charAt(0) + t.doc.lineSeparator() + O.charAt(O.length - 1),
                    ee(d.line - 1, O.length - 1),
                    d,
                    "+transpose"
                  ));
                }
              }
              s.push(new vt(d, d));
            }
          t.setSelections(s);
        });
      },
      newlineAndIndent: function (t) {
        return mn(t, function () {
          for (var r = t.listSelections(), s = r.length - 1; s >= 0; s--)
            t.replaceRange(t.doc.lineSeparator(), r[s].anchor, r[s].head, "+input");
          r = t.listSelections();
          for (var a = 0; a < r.length; a++)
            t.indentLine(r[a].from().line, null, !0);
          hi(t);
        });
      },
      openLine: function (t) {
        return t.replaceSelection(`
`, "start");
      },
      toggleOverwrite: function (t) {
        return t.toggleOverwrite();
      }
    };
    function Vd(t, r) {
      var s = Be(t.doc, r), a = Pn(s);
      return a != s && (r = ht(a)), $a(!0, t, a, r, 1);
    }
    function Ah(t, r) {
      var s = Be(t.doc, r), a = rp(s);
      return a != s && (r = ht(a)), $a(!0, t, s, r, -1);
    }
    function Ud(t, r) {
      var s = Vd(t, r.line), a = Be(t.doc, s.line), d = je(a, t.doc.direction);
      if (!d || d[0].level == 0) {
        var A = Math.max(s.ch, a.text.search(/\S/)), O = r.line == s.line && r.ch <= A && r.ch;
        return ee(s.line, O ? 0 : A, s.sticky);
      }
      return s;
    }
    function cl(t, r, s) {
      if (typeof r == "string" && (r = uo[r], !r))
        return !1;
      t.display.input.ensurePolled();
      var a = t.display.shift, d = !1;
      try {
        t.isReadOnly() && (t.state.suppressEdits = !0), s && (t.display.shift = !1), d = r(t) != Ee;
      } finally {
        t.display.shift = a, t.state.suppressEdits = !1;
      }
      return d;
    }
    function Ch(t, r, s) {
      for (var a = 0; a < t.state.keyMaps.length; a++) {
        var d = Ci(r, t.state.keyMaps[a], s, t);
        if (d)
          return d;
      }
      return t.options.extraKeys && Ci(r, t.options.extraKeys, s, t) || Ci(r, t.options.keyMap, s, t);
    }
    var Sh = new he();
    function fo(t, r, s, a) {
      var d = t.state.keySeq;
      if (d) {
        if (Bd(r))
          return "handled";
        if (/\'$/.test(r) ? t.state.keySeq = null : Sh.set(50, function () {
          t.state.keySeq == d && (t.state.keySeq = null, t.display.input.reset());
        }), jd(t, d + " " + r, s, a))
          return !0;
      }
      return jd(t, r, s, a);
    }
    function jd(t, r, s, a) {
      var d = Ch(t, r, a);
      return d == "multi" && (t.state.keySeq = r), d == "handled" && jt(t, "keyHandled", t, r, s), (d == "handled" || d == "multi") && (pt(s), ya(t)), !!d;
    }
    function zd(t, r) {
      var s = Hd(r, !0);
      return s ? r.shiftKey && !t.state.keySeq ? fo(t, "Shift-" + s, r, function (a) {
        return cl(t, a, !0);
      }) || fo(t, s, r, function (a) {
        if (typeof a == "string" ? /^go[A-Z]/.test(a) : a.motion)
          return cl(t, a);
      }) : fo(t, s, r, function (a) {
        return cl(t, a);
      }) : !1;
    }
    function Eh(t, r, s) {
      return fo(t, "'" + s + "'", r, function (a) {
        return cl(t, a, !0);
      });
    }
    var Ba = null;
    function Wd(t) {
      var r = this;
      if (!(t.target && t.target != r.display.input.getField()) && (r.curOp.focus = ne(be(r)), !Xe(r, t))) {
        c && v < 11 && t.keyCode == 27 && (t.returnValue = !1);
        var s = t.keyCode;
        r.display.shift = s == 16 || t.shiftKey;
        var a = zd(r, t);
        h && (Ba = a ? s : null, !a && s == 88 && !zn && (R ? t.metaKey : t.ctrlKey) && r.replaceSelection("", null, "cut")), n && !R && !a && s == 46 && t.shiftKey && !t.ctrlKey && document.execCommand && document.execCommand("cut"), s == 18 && !/\bCodeMirror-crosshair\b/.test(r.display.lineDiv.className) && wh(r);
      }
    }
    function wh(t) {
      var r = t.display.lineDiv;
      te(r, "CodeMirror-crosshair");
      function s(a) {
        (a.keyCode == 18 || !a.altKey) && (C(r, "CodeMirror-crosshair"), Pe(document, "keyup", s), Pe(document, "mouseover", s));
      }
      de(document, "keyup", s), de(document, "mouseover", s);
    }
    function Gd(t) {
      t.keyCode == 16 && (this.doc.sel.shift = !1), Xe(this, t);
    }
    function Yd(t) {
      var r = this;
      if (!(t.target && t.target != r.display.input.getField()) && !(lr(r.display, t) || Xe(r, t) || t.ctrlKey && !t.altKey || R && t.metaKey)) {
        var s = t.keyCode, a = t.charCode;
        if (h && s == Ba) {
          Ba = null, pt(t);
          return;
        }
        if (!(h && (!t.which || t.which < 10) && zd(r, t))) {
          var d = String.fromCharCode(a == null ? s : a);
          d != "\b" && (Eh(r, t, d) || r.display.input.onKeyPress(t));
        }
      }
    }
    var xh = 400, ka = function (t, r, s) {
      this.time = t, this.pos = r, this.button = s;
    };
    ka.prototype.compare = function (t, r, s) {
      return this.time + xh > t && ce(r, this.pos) == 0 && s == this.button;
    };
    var co, po;
    function Th(t, r) {
      var s = +new Date();
      return po && po.compare(s, t, r) ? (co = po = null, "triple") : co && co.compare(s, t, r) ? (po = new ka(s, t, r), co = null, "double") : (co = new ka(s, t, r), po = null, "single");
    }
    function Qd(t) {
      var r = this, s = r.display;
      if (!(Xe(r, t) || s.activeTouch && s.input.supportsTouch())) {
        if (s.input.ensurePolled(), s.shift = t.shiftKey, lr(s, t)) {
          b || (s.scroller.draggable = !1, setTimeout(function () {
            return s.scroller.draggable = !0;
          }, 100));
          return;
        }
        if (!Ha(r, t)) {
          var a = Wr(r, t), d = ki(t), A = a ? Th(a, d) : "single";
          me(r).focus(), d == 1 && r.state.selectingText && r.state.selectingText(t), !(a && Dh(r, d, a, A, t)) && (d == 1 ? a ? Rh(r, a, A, t) : ln(t) == s.scroller && pt(t) : d == 2 ? (a && ll(r.doc, a), setTimeout(function () {
            return s.input.focus();
          }, 20)) : d == 3 && (L ? r.display.input.onContextMenu(t) : ba(r)));
        }
      }
    }
    function Dh(t, r, s, a, d) {
      var A = "Click";
      return a == "double" ? A = "Double" + A : a == "triple" && (A = "Triple" + A), A = (r == 1 ? "Left" : r == 2 ? "Middle" : "Right") + A, fo(t, kd(A, d), d, function (O) {
        if (typeof O == "string" && (O = uo[O]), !O)
          return !1;
        var $ = !1;
        try {
          t.isReadOnly() && (t.state.suppressEdits = !0), $ = O(t, s) != Ee;
        } finally {
          t.state.suppressEdits = !1;
        }
        return $;
      });
    }
    function Ih(t, r, s) {
      var a = t.getOption("configureMouse"), d = a ? a(t, r, s) : {};
      if (d.unit == null) {
        var A = N ? s.shiftKey && s.metaKey : s.altKey;
        d.unit = A ? "rectangle" : r == "single" ? "char" : r == "double" ? "word" : "line";
      }
      return (d.extend == null || t.doc.extend) && (d.extend = t.doc.extend || s.shiftKey), d.addNew == null && (d.addNew = R ? s.metaKey : s.ctrlKey), d.moveOnDrag == null && (d.moveOnDrag = !(R ? s.altKey : s.ctrlKey)), d;
    }
    function Rh(t, r, s, a) {
      c ? setTimeout(ae(Ku, t), 0) : t.curOp.focus = ne(be(t));
      var d = Ih(t, s, a), A = t.doc.sel, O;
      t.options.dragDrop && Zl && !t.isReadOnly() && s == "single" && (O = A.contains(r)) > -1 && (ce((O = A.ranges[O]).from(), r) < 0 || r.xRel > 0) && (ce(O.to(), r) > 0 || r.xRel < 0) ? Fh(t, a, r, d) : Mh(t, a, r, d);
    }
    function Fh(t, r, s, a) {
      var d = t.display, A = !1, O = zt(t, function (U) {
        b && (d.scroller.draggable = !1), t.state.draggingText = !1, t.state.delayingBlurEvent && (t.hasFocus() ? t.state.delayingBlurEvent = !1 : ba(t)), Pe(d.wrapper.ownerDocument, "mouseup", O), Pe(d.wrapper.ownerDocument, "mousemove", $), Pe(d.scroller, "dragstart", V), Pe(d.scroller, "drop", O), A || (pt(U), a.addNew || ll(t.doc, s, null, null, a.extend), b && !m || c && v == 9 ? setTimeout(function () {
          d.wrapper.ownerDocument.body.focus({ preventScroll: !0 }), d.input.focus();
        }, 20) : d.input.focus());
      }), $ = function (U) {
        A = A || Math.abs(r.clientX - U.clientX) + Math.abs(r.clientY - U.clientY) >= 10;
      }, V = function () {
        return A = !0;
      };
      b && (d.scroller.draggable = !0), t.state.draggingText = O, O.copy = !a.moveOnDrag, de(d.wrapper.ownerDocument, "mouseup", O), de(d.wrapper.ownerDocument, "mousemove", $), de(d.scroller, "dragstart", V), de(d.scroller, "drop", O), t.state.delayingBlurEvent = !0, setTimeout(function () {
        return d.input.focus();
      }, 20), d.scroller.dragDrop && d.scroller.dragDrop();
    }
    function Kd(t, r, s) {
      if (s == "char")
        return new vt(r, r);
      if (s == "word")
        return t.findWordAt(r);
      if (s == "line")
        return new vt(ee(r.line, 0), Ye(t.doc, ee(r.line + 1, 0)));
      var a = s(t, r);
      return new vt(a.from, a.to);
    }
    function Mh(t, r, s, a) {
      c && ba(t);
      var d = t.display, A = t.doc;
      pt(r);
      var O, $, V = A.sel, U = V.ranges;
      if (a.addNew && !a.extend ? ($ = A.sel.contains(s), $ > -1 ? O = U[$] : O = new vt(s, s)) : (O = A.sel.primary(), $ = A.sel.primIndex), a.unit == "rectangle")
        a.addNew || (O = new vt(s, s)), s = Wr(t, r, !0, !0), $ = -1;
      else {
        var G = Kd(t, s, a.unit);
        a.extend ? O = Oa(O, G.anchor, G.head, a.extend) : O = G;
      }
      a.addNew ? $ == -1 ? ($ = U.length, Xt(
        A,
        Bn(t, U.concat([O]), $),
        { scroll: !1, origin: "*mouse" }
      )) : U.length > 1 && U[$].empty() && a.unit == "char" && !a.extend ? (Xt(
        A,
        Bn(t, U.slice(0, $).concat(U.slice($ + 1)), 0),
        { scroll: !1, origin: "*mouse" }
      ), V = A.sel) : Na(A, $, O, _e) : ($ = 0, Xt(A, new En([O], 0), _e), V = A.sel);
      var K = s;
      function oe(De) {
        if (ce(K, De) != 0)
          if (K = De, a.unit == "rectangle") {
            for (var Le = [], Ue = t.options.tabSize, Ve = ue(Be(A, s.line).text, s.ch, Ue), tt = ue(Be(A, De.line).text, De.ch, Ue), At = Math.min(Ve, tt), Gt = Math.max(Ve, tt), Tt = Math.min(s.line, De.line), gn = Math.min(t.lastLine(), Math.max(s.line, De.line)); Tt <= gn; Tt++) {
              var un = Be(A, Tt).text, Pt = it(un, At, Ue);
              At == Gt ? Le.push(new vt(ee(Tt, Pt), ee(Tt, Pt))) : un.length > Pt && Le.push(new vt(ee(Tt, Pt), ee(Tt, it(un, Gt, Ue))));
            }
            Le.length || Le.push(new vt(s, s)), Xt(
              A,
              Bn(t, V.ranges.slice(0, $).concat(Le), $),
              { origin: "*mouse", scroll: !1 }
            ), t.scrollIntoView(De);
          } else {
            var dn = O, Jt = Kd(t, De, a.unit), Ht = dn.anchor, $t;
            ce(Jt.anchor, Ht) > 0 ? ($t = Jt.head, Ht = kt(dn.from(), Jt.anchor)) : ($t = Jt.anchor, Ht = ut(dn.to(), Jt.head));
            var Rt = V.ranges.slice(0);
            Rt[$] = Oh(t, new vt(Ye(A, Ht), $t)), Xt(A, Bn(t, Rt, $), _e);
          }
      }
      var re = d.wrapper.getBoundingClientRect(), pe = 0;
      function ye(De) {
        var Le = ++pe, Ue = Wr(t, De, !0, a.unit == "rectangle");
        if (!!Ue)
          if (ce(Ue, K) != 0) {
            t.curOp.focus = ne(be(t)), oe(Ue);
            var Ve = el(d, A);
            (Ue.line >= Ve.to || Ue.line < Ve.from) && setTimeout(zt(t, function () {
              pe == Le && ye(De);
            }), 150);
          } else {
            var tt = De.clientY < re.top ? -20 : De.clientY > re.bottom ? 20 : 0;
            tt && setTimeout(zt(t, function () {
              pe == Le && (d.scroller.scrollTop += tt, ye(De));
            }), 50);
          }
      }
      function Ce(De) {
        t.state.selectingText = !1, pe = 1 / 0, De && (pt(De), d.input.focus()), Pe(d.wrapper.ownerDocument, "mousemove", Te), Pe(d.wrapper.ownerDocument, "mouseup", Fe), A.history.lastSelOrigin = null;
      }
      var Te = zt(t, function (De) {
        De.buttons === 0 || !ki(De) ? Ce(De) : ye(De);
      }), Fe = zt(t, Ce);
      t.state.selectingText = Fe, de(d.wrapper.ownerDocument, "mousemove", Te), de(d.wrapper.ownerDocument, "mouseup", Fe);
    }
    function Oh(t, r) {
      var s = r.anchor, a = r.head, d = Be(t.doc, s.line);
      if (ce(s, a) == 0 && s.sticky == a.sticky)
        return r;
      var A = je(d);
      if (!A)
        return r;
      var O = Me(A, s.ch, s.sticky), $ = A[O];
      if ($.from != s.ch && $.to != s.ch)
        return r;
      var V = O + ($.from == s.ch == ($.level != 1) ? 0 : 1);
      if (V == 0 || V == A.length)
        return r;
      var U;
      if (a.line != s.line)
        U = (a.line - s.line) * (t.doc.direction == "ltr" ? 1 : -1) > 0;
      else {
        var G = Me(A, a.ch, a.sticky), K = G - O || (a.ch - s.ch) * ($.level == 1 ? -1 : 1);
        G == V - 1 || G == V ? U = K < 0 : U = K > 0;
      }
      var oe = A[V + (U ? -1 : 0)], re = U == (oe.level == 1), pe = re ? oe.from : oe.to, ye = re ? "after" : "before";
      return s.ch == pe && s.sticky == ye ? r : new vt(new ee(s.line, pe, ye), a);
    }
    function Jd(t, r, s, a) {
      var d, A;
      if (r.touches)
        d = r.touches[0].clientX, A = r.touches[0].clientY;
      else
        try {
          d = r.clientX, A = r.clientY;
        } catch {
          return !1;
        }
      if (d >= Math.floor(t.display.gutters.getBoundingClientRect().right))
        return !1;
      a && pt(r);
      var O = t.display, $ = O.lineDiv.getBoundingClientRect();
      if (A > $.bottom || !xt(t, s))
        return br(r);
      A -= $.top - O.viewOffset;
      for (var V = 0; V < t.display.gutterSpecs.length; ++V) {
        var U = O.gutters.childNodes[V];
        if (U && U.getBoundingClientRect().right >= d) {
          var G = Gn(t.doc, A), K = t.display.gutterSpecs[V];
          return $e(t, s, t, G, K.className, r), br(r);
        }
      }
    }
    function Ha(t, r) {
      return Jd(t, r, "gutterClick", !0);
    }
    function Xd(t, r) {
      lr(t.display, r) || Nh(t, r) || Xe(t, r, "contextmenu") || L || t.display.input.onContextMenu(r);
    }
    function Nh(t, r) {
      return xt(t, "gutterContextMenu") ? Jd(t, r, "gutterContextMenu", !1) : !1;
    }
    function Zd(t) {
      t.display.wrapper.className = t.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + t.options.theme.replace(/(^|\s)\s*/g, " cm-s-"), Yi(t);
    }
    var Ei = {
      toString: function () {
        return "CodeMirror.Init";
      }
    }, qd = {}, pl = {};
    function Lh(t) {
      var r = t.optionHandlers;
      function s(a, d, A, O) {
        t.defaults[a] = d, A && (r[a] = O ? function ($, V, U) {
          U != Ei && A($, V, U);
        } : A);
      }
      t.defineOption = s, t.Init = Ei, s("value", "", function (a, d) {
        return a.setValue(d);
      }, !0), s("mode", null, function (a, d) {
        a.doc.modeOption = d, Ra(a);
      }, !0), s("indentUnit", 2, Ra, !0), s("indentWithTabs", !1), s("smartIndent", !0), s("tabSize", 4, function (a) {
        eo(a), Yi(a), an(a);
      }, !0), s("lineSeparator", null, function (a, d) {
        if (a.doc.lineSep = d, !!d) {
          var A = [], O = a.doc.first;
          a.doc.iter(function (V) {
            for (var U = 0; ;) {
              var G = V.text.indexOf(d, U);
              if (G == -1)
                break;
              U = G + d.length, A.push(ee(O, G));
            }
            O++;
          });
          for (var $ = A.length - 1; $ >= 0; $--)
            bi(a.doc, d, A[$], ee(A[$].line, A[$].ch + d.length));
        }
      }), s("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (a, d, A) {
        a.state.specialChars = new RegExp(d.source + (d.test("	") ? "" : "|	"), "g"), A != Ei && a.refresh();
      }), s("specialCharPlaceholder", up, function (a) {
        return a.refresh();
      }, !0), s("electricChars", !0), s("inputStyle", x ? "contenteditable" : "textarea", function () {
        throw new Error("inputStyle can not (yet) be changed in a running editor");
      }, !0), s("spellcheck", !1, function (a, d) {
        return a.getInputField().spellcheck = d;
      }, !0), s("autocorrect", !1, function (a, d) {
        return a.getInputField().autocorrect = d;
      }, !0), s("autocapitalize", !1, function (a, d) {
        return a.getInputField().autocapitalize = d;
      }, !0), s("rtlMoveVisually", !T), s("wholeLineUpdateBefore", !0), s("theme", "default", function (a) {
        Zd(a), _i(a);
      }, !0), s("keyMap", "default", function (a, d, A) {
        var O = fl(d), $ = A != Ei && fl(A);
        $ && $.detach && $.detach(a, O), O.attach && O.attach(a, $ || null);
      }), s("extraKeys", null), s("configureMouse", null), s("lineWrapping", !1, $h, !0), s("gutters", [], function (a, d) {
        a.display.gutterSpecs = Da(d, a.options.lineNumbers), _i(a);
      }, !0), s("fixedGutter", !0, function (a, d) {
        a.display.gutters.style.left = d ? va(a.display) + "px" : "0", a.refresh();
      }, !0), s("coverGutterNextToScrollbar", !1, function (a) {
        return vi(a);
      }, !0), s("scrollbarStyle", "native", function (a) {
        ed(a), vi(a), a.display.scrollbars.setScrollTop(a.doc.scrollTop), a.display.scrollbars.setScrollLeft(a.doc.scrollLeft);
      }, !0), s("lineNumbers", !1, function (a, d) {
        a.display.gutterSpecs = Da(a.options.gutters, d), _i(a);
      }, !0), s("firstLineNumber", 1, _i, !0), s("lineNumberFormatter", function (a) {
        return a;
      }, _i, !0), s("showCursorWhenSelecting", !1, Qi, !0), s("resetSelectionOnContextMenu", !0), s("lineWiseCopyCut", !0), s("pasteLinesPerSelection", !0), s("selectionsMayTouch", !1), s("readOnly", !1, function (a, d) {
        d == "nocursor" && (pi(a), a.display.input.blur()), a.display.input.readOnlyChanged(d);
      }), s("screenReaderLabel", null, function (a, d) {
        d = d === "" ? null : d, a.display.input.screenReaderLabelChanged(d);
      }), s("disableInput", !1, function (a, d) {
        d || a.display.input.reset();
      }, !0), s("dragDrop", !0, Ph), s("allowDropFileTypes", null), s("cursorBlinkRate", 530), s("cursorScrollMargin", 0), s("cursorHeight", 1, Qi, !0), s("singleCursorHeightPerLine", !0, Qi, !0), s("workTime", 100), s("workDelay", 100), s("flattenSpans", !0, eo, !0), s("addModeClass", !1, eo, !0), s("pollInterval", 100), s("undoDepth", 200, function (a, d) {
        return a.doc.history.undoDepth = d;
      }), s("historyEventDelay", 1250), s("viewportMargin", 10, function (a) {
        return a.refresh();
      }, !0), s("maxHighlightLength", 1e4, eo, !0), s("moveInputWithCursor", !0, function (a, d) {
        d || a.display.input.resetPosition();
      }), s("tabindex", null, function (a, d) {
        return a.display.input.getField().tabIndex = d || "";
      }), s("autofocus", null), s("direction", "ltr", function (a, d) {
        return a.doc.setDirection(d);
      }, !0), s("phrases", null);
    }
    function Ph(t, r, s) {
      var a = s && s != Ei;
      if (!r != !a) {
        var d = t.display.dragFunctions, A = r ? de : Pe;
        A(t.display.scroller, "dragstart", d.start), A(t.display.scroller, "dragenter", d.enter), A(t.display.scroller, "dragover", d.over), A(t.display.scroller, "dragleave", d.leave), A(t.display.scroller, "drop", d.drop);
      }
    }
    function $h(t) {
      t.options.lineWrapping ? (te(t.display.wrapper, "CodeMirror-wrap"), t.display.sizer.style.minWidth = "", t.display.sizerWidth = null) : (C(t.display.wrapper, "CodeMirror-wrap"), oa(t)), ma(t), an(t), Yi(t), setTimeout(function () {
        return vi(t);
      }, 100);
    }
    function wt(t, r) {
      var s = this;
      if (!(this instanceof wt))
        return new wt(t, r);
      this.options = r = r ? le(r) : {}, le(qd, r, !1);
      var a = r.value;
      typeof a == "string" ? a = new sn(a, r.mode, null, r.lineSeparator, r.direction) : r.mode && (a.modeOption = r.mode), this.doc = a;
      var d = new wt.inputStyles[r.inputStyle](this), A = this.display = new Jp(t, a, d, r);
      A.wrapper.CodeMirror = this, Zd(this), r.lineWrapping && (this.display.wrapper.className += " CodeMirror-wrap"), ed(this), this.state = {
        keyMaps: [],
        overlays: [],
        modeGen: 0,
        overwrite: !1,
        delayingBlurEvent: !1,
        focused: !1,
        suppressEdits: !1,
        pasteIncoming: -1,
        cutIncoming: -1,
        selectingText: !1,
        draggingText: !1,
        highlight: new he(),
        keySeq: null,
        specialChars: null
      }, r.autofocus && !x && A.input.focus(), c && v < 11 && setTimeout(function () {
        return s.display.input.reset(!0);
      }, 20), Bh(this), hh(), Kr(this), this.curOp.forceUpdate = !0, dd(this, a), r.autofocus && !x || this.hasFocus() ? setTimeout(function () {
        s.hasFocus() && !s.state.focused && Aa(s);
      }, 20) : pi(this);
      for (var O in pl)
        pl.hasOwnProperty(O) && pl[O](this, r[O], Ei);
      rd(this), r.finishInit && r.finishInit(this);
      for (var $ = 0; $ < Va.length; ++$)
        Va[$](this);
      Jr(this), b && r.lineWrapping && getComputedStyle(A.lineDiv).textRendering == "optimizelegibility" && (A.lineDiv.style.textRendering = "auto");
    }
    wt.defaults = qd, wt.optionHandlers = pl;
    function Bh(t) {
      var r = t.display;
      de(r.scroller, "mousedown", zt(t, Qd)), c && v < 11 ? de(r.scroller, "dblclick", zt(t, function (V) {
        if (!Xe(t, V)) {
          var U = Wr(t, V);
          if (!(!U || Ha(t, V) || lr(t.display, V))) {
            pt(V);
            var G = t.findWordAt(U);
            ll(t.doc, G.anchor, G.head);
          }
        }
      })) : de(r.scroller, "dblclick", function (V) {
        return Xe(t, V) || pt(V);
      }), de(r.scroller, "contextmenu", function (V) {
        return Xd(t, V);
      }), de(r.input.getField(), "contextmenu", function (V) {
        r.scroller.contains(V.target) || Xd(t, V);
      });
      var s, a = { end: 0 };
      function d() {
        r.activeTouch && (s = setTimeout(function () {
          return r.activeTouch = null;
        }, 1e3), a = r.activeTouch, a.end = +new Date());
      }
      function A(V) {
        if (V.touches.length != 1)
          return !1;
        var U = V.touches[0];
        return U.radiusX <= 1 && U.radiusY <= 1;
      }
      function O(V, U) {
        if (U.left == null)
          return !0;
        var G = U.left - V.left, K = U.top - V.top;
        return G * G + K * K > 20 * 20;
      }
      de(r.scroller, "touchstart", function (V) {
        if (!Xe(t, V) && !A(V) && !Ha(t, V)) {
          r.input.ensurePolled(), clearTimeout(s);
          var U = +new Date();
          r.activeTouch = {
            start: U,
            moved: !1,
            prev: U - a.end <= 300 ? a : null
          }, V.touches.length == 1 && (r.activeTouch.left = V.touches[0].pageX, r.activeTouch.top = V.touches[0].pageY);
        }
      }), de(r.scroller, "touchmove", function () {
        r.activeTouch && (r.activeTouch.moved = !0);
      }), de(r.scroller, "touchend", function (V) {
        var U = r.activeTouch;
        if (U && !lr(r, V) && U.left != null && !U.moved && new Date() - U.start < 300) {
          var G = t.coordsChar(r.activeTouch, "page"), K;
          !U.prev || O(U, U.prev) ? K = new vt(G, G) : !U.prev.prev || O(U, U.prev.prev) ? K = t.findWordAt(G) : K = new vt(ee(G.line, 0), Ye(t.doc, ee(G.line + 1, 0))), t.setSelection(K.anchor, K.head), t.focus(), pt(V);
        }
        d();
      }), de(r.scroller, "touchcancel", d), de(r.scroller, "scroll", function () {
        r.scroller.clientHeight && (Ji(t, r.scroller.scrollTop), Yr(t, r.scroller.scrollLeft, !0), $e(t, "scroll", t));
      }), de(r.scroller, "mousewheel", function (V) {
        return ld(t, V);
      }), de(r.scroller, "DOMMouseScroll", function (V) {
        return ld(t, V);
      }), de(r.wrapper, "scroll", function () {
        return r.wrapper.scrollTop = r.wrapper.scrollLeft = 0;
      }), r.dragFunctions = {
        enter: function (V) {
          Xe(t, V) || Nn(V);
        },
        over: function (V) {
          Xe(t, V) || (ph(t, V), Nn(V));
        },
        start: function (V) {
          return ch(t, V);
        },
        drop: zt(t, fh),
        leave: function (V) {
          Xe(t, V) || Ld(t);
        }
      };
      var $ = r.input.getField();
      de($, "keyup", function (V) {
        return Gd.call(t, V);
      }), de($, "keydown", zt(t, Wd)), de($, "keypress", zt(t, Yd)), de($, "focus", function (V) {
        return Aa(t, V);
      }), de($, "blur", function (V) {
        return pi(t, V);
      });
    }
    var Va = [];
    wt.defineInitHook = function (t) {
      return Va.push(t);
    };
    function ho(t, r, s, a) {
      var d = t.doc, A;
      s == null && (s = "add"), s == "smart" && (d.mode.indent ? A = Ui(t, r).state : s = "prev");
      var O = t.options.tabSize, $ = Be(d, r), V = ue($.text, null, O);
      $.stateAfter && ($.stateAfter = null);
      var U = $.text.match(/^\s*/)[0], G;
      if (!a && !/\S/.test($.text))
        G = 0, s = "not";
      else if (s == "smart" && (G = d.mode.indent(A, $.text.slice(U.length), $.text), G == Ee || G > 150)) {
        if (!a)
          return;
        s = "prev";
      }
      s == "prev" ? r > d.first ? G = ue(Be(d, r - 1).text, null, O) : G = 0 : s == "add" ? G = V + t.options.indentUnit : s == "subtract" ? G = V - t.options.indentUnit : typeof s == "number" && (G = V + s), G = Math.max(0, G);
      var K = "", oe = 0;
      if (t.options.indentWithTabs)
        for (var re = Math.floor(G / O); re; --re)
          oe += O, K += "	";
      if (oe < G && (K += Et(G - oe)), K != U)
        return bi(d, K, ee(r, 0), ee(r, U.length), "+input"), $.stateAfter = null, !0;
      for (var pe = 0; pe < d.sel.ranges.length; pe++) {
        var ye = d.sel.ranges[pe];
        if (ye.head.line == r && ye.head.ch < U.length) {
          var Ce = ee(r, U.length);
          Na(d, pe, new vt(Ce, Ce));
          break;
        }
      }
    }
    var kn = null;
    function hl(t) {
      kn = t;
    }
    function Ua(t, r, s, a, d) {
      var A = t.doc;
      t.display.shift = !1, a || (a = A.sel);
      var O = +new Date() - 200, $ = d == "paste" || t.state.pasteIncoming > O, V = Hi(r), U = null;
      if ($ && a.ranges.length > 1)
        if (kn && kn.text.join(`
`) == r) {
          if (a.ranges.length % kn.text.length == 0) {
            U = [];
            for (var G = 0; G < kn.text.length; G++)
              U.push(A.splitLines(kn.text[G]));
          }
        } else
          V.length == a.ranges.length && t.options.pasteLinesPerSelection && (U = bt(V, function (Te) {
            return [Te];
          }));
      for (var K = t.curOp.updateInput, oe = a.ranges.length - 1; oe >= 0; oe--) {
        var re = a.ranges[oe], pe = re.from(), ye = re.to();
        re.empty() && (s && s > 0 ? pe = ee(pe.line, pe.ch - s) : t.state.overwrite && !$ ? ye = ee(ye.line, Math.min(Be(A, ye.line).text.length, ye.ch + He(V).length)) : $ && kn && kn.lineWise && kn.text.join(`
`) == V.join(`
`) && (pe = ye = ee(pe.line, 0)));
        var Ce = {
          from: pe,
          to: ye,
          text: U ? U[oe % U.length] : V,
          origin: d || ($ ? "paste" : t.state.cutIncoming > O ? "cut" : "+input")
        };
        yi(t.doc, Ce), jt(t, "inputRead", t, Ce);
      }
      r && !$ && ef(t, r), hi(t), t.curOp.updateInput < 2 && (t.curOp.updateInput = K), t.curOp.typing = !0, t.state.pasteIncoming = t.state.cutIncoming = -1;
    }
    function _d(t, r) {
      var s = t.clipboardData && t.clipboardData.getData("Text");
      if (s)
        return t.preventDefault(), !r.isReadOnly() && !r.options.disableInput && r.hasFocus() && mn(r, function () {
          return Ua(r, s, 0, null, "paste");
        }), !0;
    }
    function ef(t, r) {
      if (!(!t.options.electricChars || !t.options.smartIndent))
        for (var s = t.doc.sel, a = s.ranges.length - 1; a >= 0; a--) {
          var d = s.ranges[a];
          if (!(d.head.ch > 100 || a && s.ranges[a - 1].head.line == d.head.line)) {
            var A = t.getModeAt(d.head), O = !1;
            if (A.electricChars) {
              for (var $ = 0; $ < A.electricChars.length; $++)
                if (r.indexOf(A.electricChars.charAt($)) > -1) {
                  O = ho(t, d.head.line, "smart");
                  break;
                }
            } else
              A.electricInput && A.electricInput.test(Be(t.doc, d.head.line).text.slice(0, d.head.ch)) && (O = ho(t, d.head.line, "smart"));
            O && jt(t, "electricInput", t, d.head.line);
          }
        }
    }
    function tf(t) {
      for (var r = [], s = [], a = 0; a < t.doc.sel.ranges.length; a++) {
        var d = t.doc.sel.ranges[a].head.line, A = { anchor: ee(d, 0), head: ee(d + 1, 0) };
        s.push(A), r.push(t.getRange(A.anchor, A.head));
      }
      return { text: r, ranges: s };
    }
    function nf(t, r, s, a) {
      t.setAttribute("autocorrect", s ? "" : "off"), t.setAttribute("autocapitalize", a ? "" : "off"), t.setAttribute("spellcheck", !!r);
    }
    function rf() {
      var t = F("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none"), r = F("div", [t], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
      return b ? t.style.width = "1000px" : t.setAttribute("wrap", "off"), g && (t.style.border = "1px solid black"), nf(t), r;
    }
    function kh(t) {
      var r = t.optionHandlers, s = t.helpers = {};
      t.prototype = {
        constructor: t,
        focus: function () {
          me(this).focus(), this.display.input.focus();
        },
        setOption: function (a, d) {
          var A = this.options, O = A[a];
          A[a] == d && a != "mode" || (A[a] = d, r.hasOwnProperty(a) && zt(this, r[a])(this, d, O), $e(this, "optionChange", this, a));
        },
        getOption: function (a) {
          return this.options[a];
        },
        getDoc: function () {
          return this.doc;
        },
        addKeyMap: function (a, d) {
          this.state.keyMaps[d ? "push" : "unshift"](fl(a));
        },
        removeKeyMap: function (a) {
          for (var d = this.state.keyMaps, A = 0; A < d.length; ++A)
            if (d[A] == a || d[A].name == a)
              return d.splice(A, 1), !0;
        },
        addOverlay: tn(function (a, d) {
          var A = a.token ? a : t.getMode(this.options, a);
          if (A.startState)
            throw new Error("Overlays may not be stateful.");
          pn(
            this.state.overlays,
            {
              mode: A,
              modeSpec: a,
              opaque: d && d.opaque,
              priority: d && d.priority || 0
            },
            function (O) {
              return O.priority;
            }
          ), this.state.modeGen++, an(this);
        }),
        removeOverlay: tn(function (a) {
          for (var d = this.state.overlays, A = 0; A < d.length; ++A) {
            var O = d[A].modeSpec;
            if (O == a || typeof a == "string" && O.name == a) {
              d.splice(A, 1), this.state.modeGen++, an(this);
              return;
            }
          }
        }),
        indentLine: tn(function (a, d, A) {
          typeof d != "string" && typeof d != "number" && (d == null ? d = this.options.smartIndent ? "smart" : "prev" : d = d ? "add" : "subtract"), z(this.doc, a) && ho(this, a, d, A);
        }),
        indentSelection: tn(function (a) {
          for (var d = this.doc.sel.ranges, A = -1, O = 0; O < d.length; O++) {
            var $ = d[O];
            if ($.empty())
              $.head.line > A && (ho(this, $.head.line, a, !0), A = $.head.line, O == this.doc.sel.primIndex && hi(this));
            else {
              var V = $.from(), U = $.to(), G = Math.max(A, V.line);
              A = Math.min(this.lastLine(), U.line - (U.ch ? 0 : 1)) + 1;
              for (var K = G; K < A; ++K)
                ho(this, K, a);
              var oe = this.doc.sel.ranges;
              V.ch == 0 && d.length == oe.length && oe[O].from().ch > 0 && Na(this.doc, O, new vt(V, oe[O].to()), Ne);
            }
          }
        }),
        getTokenAt: function (a, d) {
          return cu(this, a, d);
        },
        getLineTokens: function (a, d) {
          return cu(this, ee(a), d, !0);
        },
        getTokenTypeAt: function (a) {
          a = Ye(this.doc, a);
          var d = uu(this, Be(this.doc, a.line)), A = 0, O = (d.length - 1) / 2, $ = a.ch, V;
          if ($ == 0)
            V = d[2];
          else
            for (; ;) {
              var U = A + O >> 1;
              if ((U ? d[U * 2 - 1] : 0) >= $)
                O = U;
              else if (d[U * 2 + 1] < $)
                A = U + 1;
              else {
                V = d[U * 2 + 2];
                break;
              }
            }
          var G = V ? V.indexOf("overlay ") : -1;
          return G < 0 ? V : G == 0 ? null : V.slice(0, G - 1);
        },
        getModeAt: function (a) {
          var d = this.doc.mode;
          return d.innerMode ? t.innerMode(d, this.getTokenAt(a).state).mode : d;
        },
        getHelper: function (a, d) {
          return this.getHelpers(a, d)[0];
        },
        getHelpers: function (a, d) {
          var A = [];
          if (!s.hasOwnProperty(d))
            return A;
          var O = s[d], $ = this.getModeAt(a);
          if (typeof $[d] == "string")
            O[$[d]] && A.push(O[$[d]]);
          else if ($[d])
            for (var V = 0; V < $[d].length; V++) {
              var U = O[$[d][V]];
              U && A.push(U);
            }
          else
            $.helperType && O[$.helperType] ? A.push(O[$.helperType]) : O[$.name] && A.push(O[$.name]);
          for (var G = 0; G < O._global.length; G++) {
            var K = O._global[G];
            K.pred($, this) && se(A, K.val) == -1 && A.push(K.val);
          }
          return A;
        },
        getStateAfter: function (a, d) {
          var A = this.doc;
          return a = Sn(A, a == null ? A.first + A.size - 1 : a), Ui(this, a + 1, d).state;
        },
        cursorCoords: function (a, d) {
          var A, O = this.doc.sel.primary();
          return a == null ? A = O.head : typeof a == "object" ? A = Ye(this.doc, a) : A = a ? O.from() : O.to(), $n(this, A, d || "page");
        },
        charCoords: function (a, d) {
          return Xo(this, Ye(this.doc, a), d || "page");
        },
        coordsChar: function (a, d) {
          return a = Uu(this, a, d || "page"), ca(this, a.left, a.top);
        },
        lineAtHeight: function (a, d) {
          return a = Uu(this, { top: a, left: 0 }, d || "page").top, Gn(this.doc, a + this.display.viewOffset);
        },
        heightAtLine: function (a, d, A) {
          var O = !1, $;
          if (typeof a == "number") {
            var V = this.doc.first + this.doc.size - 1;
            a < this.doc.first ? a = this.doc.first : a > V && (a = V, O = !0), $ = Be(this.doc, a);
          } else
            $ = a;
          return Jo(this, $, { top: 0, left: 0 }, d || "page", A || O).top + (O ? this.doc.height - or($) : 0);
        },
        defaultTextHeight: function () {
          return fi(this.display);
        },
        defaultCharWidth: function () {
          return ci(this.display);
        },
        getViewport: function () {
          return { from: this.display.viewFrom, to: this.display.viewTo };
        },
        addWidget: function (a, d, A, O, $) {
          var V = this.display;
          a = $n(this, Ye(this.doc, a));
          var U = a.bottom, G = a.left;
          if (d.style.position = "absolute", d.setAttribute("cm-ignore-events", "true"), this.display.input.setUneditable(d), V.sizer.appendChild(d), O == "over")
            U = a.top;
          else if (O == "above" || O == "near") {
            var K = Math.max(V.wrapper.clientHeight, this.doc.height), oe = Math.max(V.sizer.clientWidth, V.lineSpace.clientWidth);
            (O == "above" || a.bottom + d.offsetHeight > K) && a.top > d.offsetHeight ? U = a.top - d.offsetHeight : a.bottom + d.offsetHeight <= K && (U = a.bottom), G + d.offsetWidth > oe && (G = oe - d.offsetWidth);
          }
          d.style.top = U + "px", d.style.left = d.style.right = "", $ == "right" ? (G = V.sizer.clientWidth - d.offsetWidth, d.style.right = "0px") : ($ == "left" ? G = 0 : $ == "middle" && (G = (V.sizer.clientWidth - d.offsetWidth) / 2), d.style.left = G + "px"), A && Pp(this, { left: G, top: U, right: G + d.offsetWidth, bottom: U + d.offsetHeight });
        },
        triggerOnKeyDown: tn(Wd),
        triggerOnKeyPress: tn(Yd),
        triggerOnKeyUp: Gd,
        triggerOnMouseDown: tn(Qd),
        execCommand: function (a) {
          if (uo.hasOwnProperty(a))
            return uo[a].call(null, this);
        },
        triggerElectric: tn(function (a) {
          ef(this, a);
        }),
        findPosH: function (a, d, A, O) {
          var $ = 1;
          d < 0 && ($ = -1, d = -d);
          for (var V = Ye(this.doc, a), U = 0; U < d && (V = ja(this.doc, V, $, A, O), !V.hitSide); ++U)
            ;
          return V;
        },
        moveH: tn(function (a, d) {
          var A = this;
          this.extendSelectionsBy(function (O) {
            return A.display.shift || A.doc.extend || O.empty() ? ja(A.doc, O.head, a, d, A.options.rtlMoveVisually) : a < 0 ? O.from() : O.to();
          }, at);
        }),
        deleteH: tn(function (a, d) {
          var A = this.doc.sel, O = this.doc;
          A.somethingSelected() ? O.replaceSelection("", null, "+delete") : Si(this, function ($) {
            var V = ja(O, $.head, a, d, !1);
            return a < 0 ? { from: V, to: $.head } : { from: $.head, to: V };
          });
        }),
        findPosV: function (a, d, A, O) {
          var $ = 1, V = O;
          d < 0 && ($ = -1, d = -d);
          for (var U = Ye(this.doc, a), G = 0; G < d; ++G) {
            var K = $n(this, U, "div");
            if (V == null ? V = K.left : K.left = V, U = of(this, K, $, A), U.hitSide)
              break;
          }
          return U;
        },
        moveV: tn(function (a, d) {
          var A = this, O = this.doc, $ = [], V = !this.display.shift && !O.extend && O.sel.somethingSelected();
          if (O.extendSelectionsBy(function (G) {
            if (V)
              return a < 0 ? G.from() : G.to();
            var K = $n(A, G.head, "div");
            G.goalColumn != null && (K.left = G.goalColumn), $.push(K.left);
            var oe = of(A, K, a, d);
            return d == "page" && G == O.sel.primary() && Sa(A, Xo(A, oe, "div").top - K.top), oe;
          }, at), $.length)
            for (var U = 0; U < O.sel.ranges.length; U++)
              O.sel.ranges[U].goalColumn = $[U];
        }),
        findWordAt: function (a) {
          var d = this.doc, A = Be(d, a.line).text, O = a.ch, $ = a.ch;
          if (A) {
            var V = this.getHelper(a, "wordChars");
            (a.sticky == "before" || $ == A.length) && O ? --O : ++$;
            for (var U = A.charAt(O), G = An(U, V) ? function (K) {
              return An(K, V);
            } : /\s/.test(U) ? function (K) {
              return /\s/.test(K);
            } : function (K) {
              return !/\s/.test(K) && !An(K);
            }; O > 0 && G(A.charAt(O - 1));)
              --O;
            for (; $ < A.length && G(A.charAt($));)
              ++$;
          }
          return new vt(ee(a.line, O), ee(a.line, $));
        },
        toggleOverwrite: function (a) {
          a != null && a == this.state.overwrite || ((this.state.overwrite = !this.state.overwrite) ? te(this.display.cursorDiv, "CodeMirror-overwrite") : C(this.display.cursorDiv, "CodeMirror-overwrite"), $e(this, "overwriteToggle", this, this.state.overwrite));
        },
        hasFocus: function () {
          return this.display.input.getField() == ne(be(this));
        },
        isReadOnly: function () {
          return !!(this.options.readOnly || this.doc.cantEdit);
        },
        scrollTo: tn(function (a, d) {
          Ki(this, a, d);
        }),
        getScrollInfo: function () {
          var a = this.display.scroller;
          return {
            left: a.scrollLeft,
            top: a.scrollTop,
            height: a.scrollHeight - Qn(this) - this.display.barHeight,
            width: a.scrollWidth - Qn(this) - this.display.barWidth,
            clientHeight: sa(this),
            clientWidth: jr(this)
          };
        },
        scrollIntoView: tn(function (a, d) {
          a == null ? (a = { from: this.doc.sel.primary().head, to: null }, d == null && (d = this.options.cursorScrollMargin)) : typeof a == "number" ? a = { from: ee(a, 0), to: null } : a.from == null && (a = { from: a, to: null }), a.to || (a.to = a.from), a.margin = d || 0, a.from.line != null ? $p(this, a) : Xu(this, a.from, a.to, a.margin);
        }),
        setSize: tn(function (a, d) {
          var A = this, O = function (V) {
            return typeof V == "number" || /^\d+$/.test(String(V)) ? V + "px" : V;
          };
          a != null && (this.display.wrapper.style.width = O(a)), d != null && (this.display.wrapper.style.height = O(d)), this.options.lineWrapping && ku(this);
          var $ = this.display.viewFrom;
          this.doc.iter($, this.display.viewTo, function (V) {
            if (V.widgets) {
              for (var U = 0; U < V.widgets.length; U++)
                if (V.widgets[U].noHScroll) {
                  xr(A, $, "widget");
                  break;
                }
            }
            ++$;
          }), this.curOp.forceUpdate = !0, $e(this, "refresh", this);
        }),
        operation: function (a) {
          return mn(this, a);
        },
        startOperation: function () {
          return Kr(this);
        },
        endOperation: function () {
          return Jr(this);
        },
        refresh: tn(function () {
          var a = this.display.cachedTextHeight;
          an(this), this.curOp.forceUpdate = !0, Yi(this), Ki(this, this.doc.scrollLeft, this.doc.scrollTop), xa(this.display), (a == null || Math.abs(a - fi(this.display)) > 0.5 || this.options.lineWrapping) && ma(this), $e(this, "refresh", this);
        }),
        swapDoc: tn(function (a) {
          var d = this.doc;
          return d.cm = null, this.state.selectingText && this.state.selectingText(), dd(this, a), Yi(this), this.display.input.reset(), Ki(this, a.scrollLeft, a.scrollTop), this.curOp.forceScroll = !0, jt(this, "swapDoc", this, d), d;
        }),
        phrase: function (a) {
          var d = this.options.phrases;
          return d && Object.prototype.hasOwnProperty.call(d, a) ? d[a] : a;
        },
        getInputField: function () {
          return this.display.input.getField();
        },
        getWrapperElement: function () {
          return this.display.wrapper;
        },
        getScrollerElement: function () {
          return this.display.scroller;
        },
        getGutterElement: function () {
          return this.display.gutters;
        }
      }, Ct(t), t.registerHelper = function (a, d, A) {
        s.hasOwnProperty(a) || (s[a] = t[a] = { _global: [] }), s[a][d] = A;
      }, t.registerGlobalHelper = function (a, d, A, O) {
        t.registerHelper(a, d, O), s[a]._global.push({ pred: A, val: O });
      };
    }
    function ja(t, r, s, a, d) {
      var A = r, O = s, $ = Be(t, r.line), V = d && t.direction == "rtl" ? -s : s;
      function U() {
        var Fe = r.line + V;
        return Fe < t.first || Fe >= t.first + t.size ? !1 : (r = new ee(Fe, r.ch, r.sticky), $ = Be(t, Fe));
      }
      function G(Fe) {
        var De;
        if (a == "codepoint") {
          var Le = $.text.charCodeAt(r.ch + (s > 0 ? 0 : -1));
          if (isNaN(Le))
            De = null;
          else {
            var Ue = s > 0 ? Le >= 55296 && Le < 56320 : Le >= 56320 && Le < 57343;
            De = new ee(r.line, Math.max(0, Math.min($.text.length, r.ch + s * (Ue ? 2 : 1))), -s);
          }
        } else
          d ? De = bh(t.cm, $, r, s) : De = Pa($, r, s);
        if (De == null)
          if (!Fe && U())
            r = $a(d, t.cm, $, r.line, V);
          else
            return !1;
        else
          r = De;
        return !0;
      }
      if (a == "char" || a == "codepoint")
        G();
      else if (a == "column")
        G(!0);
      else if (a == "word" || a == "group")
        for (var K = null, oe = a == "group", re = t.cm && t.cm.getHelper(r, "wordChars"), pe = !0; !(s < 0 && !G(!pe)); pe = !1) {
          var ye = $.text.charAt(r.ch) || `
`, Ce = An(ye, re) ? "w" : oe && ye == `
` ? "n" : !oe || /\s/.test(ye) ? null : "p";
          if (oe && !pe && !Ce && (Ce = "s"), K && K != Ce) {
            s < 0 && (s = 1, G(), r.sticky = "after");
            break;
          }
          if (Ce && (K = Ce), s > 0 && !G(!pe))
            break;
        }
      var Te = sl(t, r, A, O, !0);
      return Ge(A, Te) && (Te.hitSide = !0), Te;
    }
    function of(t, r, s, a) {
      var d = t.doc, A = r.left, O;
      if (a == "page") {
        var $ = Math.min(t.display.wrapper.clientHeight, me(t).innerHeight || d(t).documentElement.clientHeight), V = Math.max($ - 0.5 * fi(t.display), 3);
        O = (s > 0 ? r.bottom : r.top) + s * V;
      } else
        a == "line" && (O = s > 0 ? r.bottom + 3 : r.top - 3);
      for (var U; U = ca(t, A, O), !!U.outside;) {
        if (s < 0 ? O <= 0 : O >= d.height) {
          U.hitSide = !0;
          break;
        }
        O += s * 5;
      }
      return U;
    }
    var gt = function (t) {
      this.cm = t, this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null, this.polling = new he(), this.composing = null, this.gracePeriod = !1, this.readDOMTimeout = null;
    };
    gt.prototype.init = function (t) {
      var r = this, s = this, a = s.cm, d = s.div = t.lineDiv;
      d.contentEditable = !0, nf(d, a.options.spellcheck, a.options.autocorrect, a.options.autocapitalize);
      function A($) {
        for (var V = $.target; V; V = V.parentNode) {
          if (V == d)
            return !0;
          if (/\bCodeMirror-(?:line)?widget\b/.test(V.className))
            break;
        }
        return !1;
      }
      de(d, "paste", function ($) {
        !A($) || Xe(a, $) || _d($, a) || v <= 11 && setTimeout(zt(a, function () {
          return r.updateFromDOM();
        }), 20);
      }), de(d, "compositionstart", function ($) {
        r.composing = { data: $.data, done: !1 };
      }), de(d, "compositionupdate", function ($) {
        r.composing || (r.composing = { data: $.data, done: !1 });
      }), de(d, "compositionend", function ($) {
        r.composing && ($.data != r.composing.data && r.readFromDOMSoon(), r.composing.done = !0);
      }), de(d, "touchstart", function () {
        return s.forceCompositionEnd();
      }), de(d, "input", function () {
        r.composing || r.readFromDOMSoon();
      });
      function O($) {
        if (!(!A($) || Xe(a, $))) {
          if (a.somethingSelected())
            hl({ lineWise: !1, text: a.getSelections() }), $.type == "cut" && a.replaceSelection("", null, "cut");
          else if (a.options.lineWiseCopyCut) {
            var V = tf(a);
            hl({ lineWise: !0, text: V.text }), $.type == "cut" && a.operation(function () {
              a.setSelections(V.ranges, 0, Ne), a.replaceSelection("", null, "cut");
            });
          } else
            return;
          if ($.clipboardData) {
            $.clipboardData.clearData();
            var U = kn.text.join(`
`);
            if ($.clipboardData.setData("Text", U), $.clipboardData.getData("Text") == U) {
              $.preventDefault();
              return;
            }
          }
          var G = rf(), K = G.firstChild;
          a.display.lineSpace.insertBefore(G, a.display.lineSpace.firstChild), K.value = kn.text.join(`
`);
          var oe = ne(d.ownerDocument);
          ge(K), setTimeout(function () {
            a.display.lineSpace.removeChild(G), oe.focus(), oe == d && s.showPrimarySelection();
          }, 50);
        }
      }
      de(d, "copy", O), de(d, "cut", O);
    }, gt.prototype.screenReaderLabelChanged = function (t) {
      t ? this.div.setAttribute("aria-label", t) : this.div.removeAttribute("aria-label");
    }, gt.prototype.prepareSelection = function () {
      var t = Qu(this.cm, !1);
      return t.focus = ne(this.div.ownerDocument) == this.div, t;
    }, gt.prototype.showSelection = function (t, r) {
      !t || !this.cm.display.view.length || ((t.focus || r) && this.showPrimarySelection(), this.showMultipleSelections(t));
    }, gt.prototype.getSelection = function () {
      return this.cm.display.wrapper.ownerDocument.getSelection();
    }, gt.prototype.showPrimarySelection = function () {
      var t = this.getSelection(), r = this.cm, s = r.doc.sel.primary(), a = s.from(), d = s.to();
      if (r.display.viewTo == r.display.viewFrom || a.line >= r.display.viewTo || d.line < r.display.viewFrom) {
        t.removeAllRanges();
        return;
      }
      var A = vl(r, t.anchorNode, t.anchorOffset), O = vl(r, t.focusNode, t.focusOffset);
      if (!(A && !A.bad && O && !O.bad && ce(kt(A, O), a) == 0 && ce(ut(A, O), d) == 0)) {
        var $ = r.display.view, V = a.line >= r.display.viewFrom && lf(r, a) || { node: $[0].measure.map[2], offset: 0 }, U = d.line < r.display.viewTo && lf(r, d);
        if (!U) {
          var G = $[$.length - 1].measure, K = G.maps ? G.maps[G.maps.length - 1] : G.map;
          U = { node: K[K.length - 1], offset: K[K.length - 2] - K[K.length - 3] };
        }
        if (!V || !U) {
          t.removeAllRanges();
          return;
        }
        var oe = t.rangeCount && t.getRangeAt(0), re;
        try {
          re = W(V.node, V.offset, U.offset, U.node);
        } catch {
        }
        re && (!n && r.state.focused ? (t.collapse(V.node, V.offset), re.collapsed || (t.removeAllRanges(), t.addRange(re))) : (t.removeAllRanges(), t.addRange(re)), oe && t.anchorNode == null ? t.addRange(oe) : n && this.startGracePeriod()), this.rememberSelection();
      }
    }, gt.prototype.startGracePeriod = function () {
      var t = this;
      clearTimeout(this.gracePeriod), this.gracePeriod = setTimeout(function () {
        t.gracePeriod = !1, t.selectionChanged() && t.cm.operation(function () {
          return t.cm.curOp.selectionChanged = !0;
        });
      }, 20);
    }, gt.prototype.showMultipleSelections = function (t) {
      k(this.cm.display.cursorDiv, t.cursors), k(this.cm.display.selectionDiv, t.selection);
    }, gt.prototype.rememberSelection = function () {
      var t = this.getSelection();
      this.lastAnchorNode = t.anchorNode, this.lastAnchorOffset = t.anchorOffset, this.lastFocusNode = t.focusNode, this.lastFocusOffset = t.focusOffset;
    }, gt.prototype.selectionInEditor = function () {
      var t = this.getSelection();
      if (!t.rangeCount)
        return !1;
      var r = t.getRangeAt(0).commonAncestorContainer;
      return Q(this.div, r);
    }, gt.prototype.focus = function () {
      this.cm.options.readOnly != "nocursor" && ((!this.selectionInEditor() || ne(this.div.ownerDocument) != this.div) && this.showSelection(this.prepareSelection(), !0), this.div.focus());
    }, gt.prototype.blur = function () {
      this.div.blur();
    }, gt.prototype.getField = function () {
      return this.div;
    }, gt.prototype.supportsTouch = function () {
      return !0;
    }, gt.prototype.receivedFocus = function () {
      var t = this, r = this;
      this.selectionInEditor() ? setTimeout(function () {
        return t.pollSelection();
      }, 20) : mn(this.cm, function () {
        return r.cm.curOp.selectionChanged = !0;
      });
      function s() {
        r.cm.state.focused && (r.pollSelection(), r.polling.set(r.cm.options.pollInterval, s));
      }
      this.polling.set(this.cm.options.pollInterval, s);
    }, gt.prototype.selectionChanged = function () {
      var t = this.getSelection();
      return t.anchorNode != this.lastAnchorNode || t.anchorOffset != this.lastAnchorOffset || t.focusNode != this.lastFocusNode || t.focusOffset != this.lastFocusOffset;
    }, gt.prototype.pollSelection = function () {
      if (!(this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged())) {
        var t = this.getSelection(), r = this.cm;
        if (S && E && this.cm.display.gutterSpecs.length && Hh(t.anchorNode)) {
          this.cm.triggerOnKeyDown({ type: "keydown", keyCode: 8, preventDefault: Math.abs }), this.blur(), this.focus();
          return;
        }
        if (!this.composing) {
          this.rememberSelection();
          var s = vl(r, t.anchorNode, t.anchorOffset), a = vl(r, t.focusNode, t.focusOffset);
          s && a && mn(r, function () {
            Xt(r.doc, Dr(s, a), Ne), (s.bad || a.bad) && (r.curOp.selectionChanged = !0);
          });
        }
      }
    }, gt.prototype.pollContent = function () {
      this.readDOMTimeout != null && (clearTimeout(this.readDOMTimeout), this.readDOMTimeout = null);
      var t = this.cm, r = t.display, s = t.doc.sel.primary(), a = s.from(), d = s.to();
      if (a.ch == 0 && a.line > t.firstLine() && (a = ee(a.line - 1, Be(t.doc, a.line - 1).length)), d.ch == Be(t.doc, d.line).text.length && d.line < t.lastLine() && (d = ee(d.line + 1, 0)), a.line < r.viewFrom || d.line > r.viewTo - 1)
        return !1;
      var A, O, $;
      a.line == r.viewFrom || (A = Gr(t, a.line)) == 0 ? (O = ht(r.view[0].line), $ = r.view[0].node) : (O = ht(r.view[A].line), $ = r.view[A - 1].node.nextSibling);
      var V = Gr(t, d.line), U, G;
      if (V == r.view.length - 1 ? (U = r.viewTo - 1, G = r.lineDiv.lastChild) : (U = ht(r.view[V + 1].line) - 1, G = r.view[V + 1].node.previousSibling), !$)
        return !1;
      for (var K = t.doc.splitLines(Vh(t, $, G, O, U)), oe = rr(t.doc, ee(O, 0), ee(U, Be(t.doc, U).text.length)); K.length > 1 && oe.length > 1;)
        if (He(K) == He(oe))
          K.pop(), oe.pop(), U--;
        else if (K[0] == oe[0])
          K.shift(), oe.shift(), O++;
        else
          break;
      for (var re = 0, pe = 0, ye = K[0], Ce = oe[0], Te = Math.min(ye.length, Ce.length); re < Te && ye.charCodeAt(re) == Ce.charCodeAt(re);)
        ++re;
      for (var Fe = He(K), De = He(oe), Le = Math.min(
        Fe.length - (K.length == 1 ? re : 0),
        De.length - (oe.length == 1 ? re : 0)
      ); pe < Le && Fe.charCodeAt(Fe.length - pe - 1) == De.charCodeAt(De.length - pe - 1);)
        ++pe;
      if (K.length == 1 && oe.length == 1 && O == a.line)
        for (; re && re > a.ch && Fe.charCodeAt(Fe.length - pe - 1) == De.charCodeAt(De.length - pe - 1);)
          re--, pe++;
      K[K.length - 1] = Fe.slice(0, Fe.length - pe).replace(/^\u200b+/, ""), K[0] = K[0].slice(re).replace(/\u200b+$/, "");
      var Ue = ee(O, re), Ve = ee(U, oe.length ? He(oe).length - pe : 0);
      if (K.length > 1 || K[0] || ce(Ue, Ve))
        return bi(t.doc, K, Ue, Ve, "+input"), !0;
    }, gt.prototype.ensurePolled = function () {
      this.forceCompositionEnd();
    }, gt.prototype.reset = function () {
      this.forceCompositionEnd();
    }, gt.prototype.forceCompositionEnd = function () {
      !this.composing || (clearTimeout(this.readDOMTimeout), this.composing = null, this.updateFromDOM(), this.div.blur(), this.div.focus());
    }, gt.prototype.readFromDOMSoon = function () {
      var t = this;
      this.readDOMTimeout == null && (this.readDOMTimeout = setTimeout(function () {
        if (t.readDOMTimeout = null, t.composing)
          if (t.composing.done)
            t.composing = null;
          else
            return;
        t.updateFromDOM();
      }, 80));
    }, gt.prototype.updateFromDOM = function () {
      var t = this;
      (this.cm.isReadOnly() || !this.pollContent()) && mn(this.cm, function () {
        return an(t.cm);
      });
    }, gt.prototype.setUneditable = function (t) {
      t.contentEditable = "false";
    }, gt.prototype.onKeyPress = function (t) {
      t.charCode == 0 || this.composing || (t.preventDefault(), this.cm.isReadOnly() || zt(this.cm, Ua)(this.cm, String.fromCharCode(t.charCode == null ? t.keyCode : t.charCode), 0));
    }, gt.prototype.readOnlyChanged = function (t) {
      this.div.contentEditable = String(t != "nocursor");
    }, gt.prototype.onContextMenu = function () {
    }, gt.prototype.resetPosition = function () {
    }, gt.prototype.needsContentAttribute = !0;
    function lf(t, r) {
      var s = ua(t, r.line);
      if (!s || s.hidden)
        return null;
      var a = Be(t.doc, r.line), d = Nu(s, a, r.line), A = je(a, t.doc.direction), O = "left";
      if (A) {
        var $ = Me(A, r.ch);
        O = $ % 2 ? "right" : "left";
      }
      var V = $u(d.map, r.ch, O);
      return V.offset = V.collapse == "right" ? V.end : V.start, V;
    }
    function Hh(t) {
      for (var r = t; r; r = r.parentNode)
        if (/CodeMirror-gutter-wrapper/.test(r.className))
          return !0;
      return !1;
    }
    function wi(t, r) {
      return r && (t.bad = !0), t;
    }
    function Vh(t, r, s, a, d) {
      var A = "", O = !1, $ = t.doc.lineSeparator(), V = !1;
      function U(re) {
        return function (pe) {
          return pe.id == re;
        };
      }
      function G() {
        O && (A += $, V && (A += $), O = V = !1);
      }
      function K(re) {
        re && (G(), A += re);
      }
      function oe(re) {
        if (re.nodeType == 1) {
          var pe = re.getAttribute("cm-text");
          if (pe) {
            K(pe);
            return;
          }
          var ye = re.getAttribute("cm-marker"), Ce;
          if (ye) {
            var Te = t.findMarks(ee(a, 0), ee(d + 1, 0), U(+ye));
            Te.length && (Ce = Te[0].find(0)) && K(rr(t.doc, Ce.from, Ce.to).join($));
            return;
          }
          if (re.getAttribute("contenteditable") == "false")
            return;
          var Fe = /^(pre|div|p|li|table|br)$/i.test(re.nodeName);
          if (!/^br$/i.test(re.nodeName) && re.textContent.length == 0)
            return;
          Fe && G();
          for (var De = 0; De < re.childNodes.length; De++)
            oe(re.childNodes[De]);
          /^(pre|p)$/i.test(re.nodeName) && (V = !0), Fe && (O = !0);
        } else
          re.nodeType == 3 && K(re.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
      }
      for (; oe(r), r != s;)
        r = r.nextSibling, V = !1;
      return A;
    }
    function vl(t, r, s) {
      var a;
      if (r == t.display.lineDiv) {
        if (a = t.display.lineDiv.childNodes[s], !a)
          return wi(t.clipPos(ee(t.display.viewTo - 1)), !0);
        r = null, s = 0;
      } else
        for (a = r; ; a = a.parentNode) {
          if (!a || a == t.display.lineDiv)
            return null;
          if (a.parentNode && a.parentNode == t.display.lineDiv)
            break;
        }
      for (var d = 0; d < t.display.view.length; d++) {
        var A = t.display.view[d];
        if (A.node == a)
          return Uh(A, r, s);
      }
    }
    function Uh(t, r, s) {
      var a = t.text.firstChild, d = !1;
      if (!r || !Q(a, r))
        return wi(ee(ht(t.line), 0), !0);
      if (r == a && (d = !0, r = a.childNodes[s], s = 0, !r)) {
        var A = t.rest ? He(t.rest) : t.line;
        return wi(ee(ht(A), A.text.length), d);
      }
      var O = r.nodeType == 3 ? r : null, $ = r;
      for (!O && r.childNodes.length == 1 && r.firstChild.nodeType == 3 && (O = r.firstChild, s && (s = O.nodeValue.length)); $.parentNode != a;)
        $ = $.parentNode;
      var V = t.measure, U = V.maps;
      function G(Ce, Te, Fe) {
        for (var De = -1; De < (U ? U.length : 0); De++)
          for (var Le = De < 0 ? V.map : U[De], Ue = 0; Ue < Le.length; Ue += 3) {
            var Ve = Le[Ue + 2];
            if (Ve == Ce || Ve == Te) {
              var tt = ht(De < 0 ? t.line : t.rest[De]), At = Le[Ue] + Fe;
              return (Fe < 0 || Ve != Ce) && (At = Le[Ue + (Fe ? 1 : 0)]), ee(tt, At);
            }
          }
      }
      var K = G(O, $, s);
      if (K)
        return wi(K, d);
      for (var oe = $.nextSibling, re = O ? O.nodeValue.length - s : 0; oe; oe = oe.nextSibling) {
        if (K = G(oe, oe.firstChild, 0), K)
          return wi(ee(K.line, K.ch - re), d);
        re += oe.textContent.length;
      }
      for (var pe = $.previousSibling, ye = s; pe; pe = pe.previousSibling) {
        if (K = G(pe, pe.firstChild, -1), K)
          return wi(ee(K.line, K.ch + ye), d);
        ye += pe.textContent.length;
      }
    }
    var Mt = function (t) {
      this.cm = t, this.prevInput = "", this.pollingFast = !1, this.polling = new he(), this.hasSelection = !1, this.composing = null;
    };
    Mt.prototype.init = function (t) {
      var r = this, s = this, a = this.cm;
      this.createField(t);
      var d = this.textarea;
      t.wrapper.insertBefore(this.wrapper, t.wrapper.firstChild), g && (d.style.width = "0px"), de(d, "input", function () {
        c && v >= 9 && r.hasSelection && (r.hasSelection = null), s.poll();
      }), de(d, "paste", function (O) {
        Xe(a, O) || _d(O, a) || (a.state.pasteIncoming = +new Date(), s.fastPoll());
      });
      function A(O) {
        if (!Xe(a, O)) {
          if (a.somethingSelected())
            hl({ lineWise: !1, text: a.getSelections() });
          else if (a.options.lineWiseCopyCut) {
            var $ = tf(a);
            hl({ lineWise: !0, text: $.text }), O.type == "cut" ? a.setSelections($.ranges, null, Ne) : (s.prevInput = "", d.value = $.text.join(`
`), ge(d));
          } else
            return;
          O.type == "cut" && (a.state.cutIncoming = +new Date());
        }
      }
      de(d, "cut", A), de(d, "copy", A), de(t.scroller, "paste", function (O) {
        if (!(lr(t, O) || Xe(a, O))) {
          if (!d.dispatchEvent) {
            a.state.pasteIncoming = +new Date(), s.focus();
            return;
          }
          var $ = new Event("paste");
          $.clipboardData = O.clipboardData, d.dispatchEvent($);
        }
      }), de(t.lineSpace, "selectstart", function (O) {
        lr(t, O) || pt(O);
      }), de(d, "compositionstart", function () {
        var O = a.getCursor("from");
        s.composing && s.composing.range.clear(), s.composing = {
          start: O,
          range: a.markText(O, a.getCursor("to"), { className: "CodeMirror-composing" })
        };
      }), de(d, "compositionend", function () {
        s.composing && (s.poll(), s.composing.range.clear(), s.composing = null);
      });
    }, Mt.prototype.createField = function (t) {
      this.wrapper = rf(), this.textarea = this.wrapper.firstChild;
    }, Mt.prototype.screenReaderLabelChanged = function (t) {
      t ? this.textarea.setAttribute("aria-label", t) : this.textarea.removeAttribute("aria-label");
    }, Mt.prototype.prepareSelection = function () {
      var t = this.cm, r = t.display, s = t.doc, a = Qu(t);
      if (t.options.moveInputWithCursor) {
        var d = $n(t, s.sel.primary().head, "div"), A = r.wrapper.getBoundingClientRect(), O = r.lineDiv.getBoundingClientRect();
        a.teTop = Math.max(0, Math.min(
          r.wrapper.clientHeight - 10,
          d.top + O.top - A.top
        )), a.teLeft = Math.max(0, Math.min(
          r.wrapper.clientWidth - 10,
          d.left + O.left - A.left
        ));
      }
      return a;
    }, Mt.prototype.showSelection = function (t) {
      var r = this.cm, s = r.display;
      k(s.cursorDiv, t.cursors), k(s.selectionDiv, t.selection), t.teTop != null && (this.wrapper.style.top = t.teTop + "px", this.wrapper.style.left = t.teLeft + "px");
    }, Mt.prototype.reset = function (t) {
      if (!(this.contextMenuPending || this.composing)) {
        var r = this.cm;
        if (r.somethingSelected()) {
          this.prevInput = "";
          var s = r.getSelection();
          this.textarea.value = s, r.state.focused && ge(this.textarea), c && v >= 9 && (this.hasSelection = s);
        } else
          t || (this.prevInput = this.textarea.value = "", c && v >= 9 && (this.hasSelection = null));
      }
    }, Mt.prototype.getField = function () {
      return this.textarea;
    }, Mt.prototype.supportsTouch = function () {
      return !1;
    }, Mt.prototype.focus = function () {
      if (this.cm.options.readOnly != "nocursor" && (!x || ne(this.textarea.ownerDocument) != this.textarea))
        try {
          this.textarea.focus();
        } catch {
        }
    }, Mt.prototype.blur = function () {
      this.textarea.blur();
    }, Mt.prototype.resetPosition = function () {
      this.wrapper.style.top = this.wrapper.style.left = 0;
    }, Mt.prototype.receivedFocus = function () {
      this.slowPoll();
    }, Mt.prototype.slowPoll = function () {
      var t = this;
      this.pollingFast || this.polling.set(this.cm.options.pollInterval, function () {
        t.poll(), t.cm.state.focused && t.slowPoll();
      });
    }, Mt.prototype.fastPoll = function () {
      var t = !1, r = this;
      r.pollingFast = !0;
      function s() {
        var a = r.poll();
        !a && !t ? (t = !0, r.polling.set(60, s)) : (r.pollingFast = !1, r.slowPoll());
      }
      r.polling.set(20, s);
    }, Mt.prototype.poll = function () {
      var t = this, r = this.cm, s = this.textarea, a = this.prevInput;
      if (this.contextMenuPending || !r.state.focused || Ar(s) && !a && !this.composing || r.isReadOnly() || r.options.disableInput || r.state.keySeq)
        return !1;
      var d = s.value;
      if (d == a && !r.somethingSelected())
        return !1;
      if (c && v >= 9 && this.hasSelection === d || R && /[\uf700-\uf7ff]/.test(d))
        return r.display.input.reset(), !1;
      if (r.doc.sel == r.display.selForContextMenu) {
        var A = d.charCodeAt(0);
        if (A == 8203 && !a && (a = "\u200B"), A == 8666)
          return this.reset(), this.cm.execCommand("undo");
      }
      for (var O = 0, $ = Math.min(a.length, d.length); O < $ && a.charCodeAt(O) == d.charCodeAt(O);)
        ++O;
      return mn(r, function () {
        Ua(
          r,
          d.slice(O),
          a.length - O,
          null,
          t.composing ? "*compose" : null
        ), d.length > 1e3 || d.indexOf(`
`) > -1 ? s.value = t.prevInput = "" : t.prevInput = d, t.composing && (t.composing.range.clear(), t.composing.range = r.markText(
          t.composing.start,
          r.getCursor("to"),
          { className: "CodeMirror-composing" }
        ));
      }), !0;
    }, Mt.prototype.ensurePolled = function () {
      this.pollingFast && this.poll() && (this.pollingFast = !1);
    }, Mt.prototype.onKeyPress = function () {
      c && v >= 9 && (this.hasSelection = null), this.fastPoll();
    }, Mt.prototype.onContextMenu = function (t) {
      var r = this, s = r.cm, a = s.display, d = r.textarea;
      r.contextMenuPending && r.contextMenuPending();
      var A = Wr(s, t), O = a.scroller.scrollTop;
      if (!A || h)
        return;
      var $ = s.options.resetSelectionOnContextMenu;
      $ && s.doc.sel.contains(A) == -1 && zt(s, Xt)(s.doc, Dr(A), Ne);
      var V = d.style.cssText, U = r.wrapper.style.cssText, G = r.wrapper.offsetParent.getBoundingClientRect();
      r.wrapper.style.cssText = "position: static", d.style.cssText = `position: absolute; width: 30px; height: 30px;
      top: ` + (t.clientY - G.top - 5) + "px; left: " + (t.clientX - G.left - 5) + `px;
      z-index: 1000; background: ` + (c ? "rgba(255, 255, 255, .05)" : "transparent") + `;
      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);`;
      var K;
      b && (K = d.ownerDocument.defaultView.scrollY), a.input.focus(), b && d.ownerDocument.defaultView.scrollTo(null, K), a.input.reset(), s.somethingSelected() || (d.value = r.prevInput = " "), r.contextMenuPending = re, a.selForContextMenu = s.doc.sel, clearTimeout(a.detectingSelectAll);
      function oe() {
        if (d.selectionStart != null) {
          var ye = s.somethingSelected(), Ce = "\u200B" + (ye ? d.value : "");
          d.value = "\u21DA", d.value = Ce, r.prevInput = ye ? "" : "\u200B", d.selectionStart = 1, d.selectionEnd = Ce.length, a.selForContextMenu = s.doc.sel;
        }
      }
      function re() {
        if (r.contextMenuPending == re && (r.contextMenuPending = !1, r.wrapper.style.cssText = U, d.style.cssText = V, c && v < 9 && a.scrollbars.setScrollTop(a.scroller.scrollTop = O), d.selectionStart != null)) {
          (!c || c && v < 9) && oe();
          var ye = 0, Ce = function () {
            a.selForContextMenu == s.doc.sel && d.selectionStart == 0 && d.selectionEnd > 0 && r.prevInput == "\u200B" ? zt(s, Ed)(s) : ye++ < 10 ? a.detectingSelectAll = setTimeout(Ce, 500) : (a.selForContextMenu = null, a.input.reset());
          };
          a.detectingSelectAll = setTimeout(Ce, 200);
        }
      }
      if (c && v >= 9 && oe(), L) {
        Nn(t);
        var pe = function () {
          Pe(window, "mouseup", pe), setTimeout(re, 20);
        };
        de(window, "mouseup", pe);
      } else
        setTimeout(re, 50);
    }, Mt.prototype.readOnlyChanged = function (t) {
      t || this.reset(), this.textarea.disabled = t == "nocursor", this.textarea.readOnly = !!t;
    }, Mt.prototype.setUneditable = function () {
    }, Mt.prototype.needsContentAttribute = !1;
    function jh(t, r) {
      if (r = r ? le(r) : {}, r.value = t.value, !r.tabindex && t.tabIndex && (r.tabindex = t.tabIndex), !r.placeholder && t.placeholder && (r.placeholder = t.placeholder), r.autofocus == null) {
        var s = ne(t.ownerDocument);
        r.autofocus = s == t || t.getAttribute("autofocus") != null && s == document.body;
      }
      function a() {
        t.value = $.getValue();
      }
      var d;
      if (t.form && (de(t.form, "submit", a), !r.leaveSubmitMethodAlone)) {
        var A = t.form;
        d = A.submit;
        try {
          var O = A.submit = function () {
            a(), A.submit = d, A.submit(), A.submit = O;
          };
        } catch {
        }
      }
      r.finishInit = function (V) {
        V.save = a, V.getTextArea = function () {
          return t;
        }, V.toTextArea = function () {
          V.toTextArea = isNaN, a(), t.parentNode.removeChild(V.getWrapperElement()), t.style.display = "", t.form && (Pe(t.form, "submit", a), !r.leaveSubmitMethodAlone && typeof t.form.submit == "function" && (t.form.submit = d));
        };
      }, t.style.display = "none";
      var $ = wt(
        function (V) {
          return t.parentNode.insertBefore(V, t.nextSibling);
        },
        r
      );
      return $;
    }
    function zh(t) {
      t.off = Pe, t.on = de, t.wheelEventPixels = Xp, t.Doc = sn, t.splitLines = Hi, t.countColumn = ue, t.findColumn = it, t.isWordChar = bn, t.Pass = Ee, t.signal = $e, t.Line = si, t.changeEnd = Ir, t.scrollbarModel = _u, t.Pos = ee, t.cmpPos = ce, t.modes = Ln, t.mimeModes = Cr, t.resolveMode = vn, t.getMode = tr, t.modeExtensions = Sr, t.extendMode = Vo, t.copyState = nr, t.startState = Vi, t.innerMode = Er, t.commands = uo, t.keyMap = sr, t.keyName = Hd, t.isModifierKey = Bd, t.lookupKey = Ci, t.normalizeKeyMap = yh, t.StringStream = It, t.SharedTextMarker = lo, t.TextMarker = Fr, t.LineWidget = oo, t.e_preventDefault = pt, t.e_stopPropagation = In, t.e_stop = Nn, t.addClass = te, t.contains = Q, t.rmClass = C, t.keyNames = Mr;
    }
    Lh(wt), kh(wt);
    var Wh = "iter insert remove copy getEditor constructor".split(" ");
    for (var ml in sn.prototype)
      sn.prototype.hasOwnProperty(ml) && se(Wh, ml) < 0 && (wt.prototype[ml] = function (t) {
        return function () {
          return t.apply(this.doc, arguments);
        };
      }(sn.prototype[ml]));
    return Ct(sn), wt.inputStyles = { textarea: Mt, contenteditable: gt }, wt.defineMode = function (t) {
      !wt.defaults.mode && t != "null" && (wt.defaults.mode = t), Ho.apply(this, arguments);
    }, wt.defineMIME = li, wt.defineMode("null", function () {
      return {
        token: function (t) {
          return t.skipToEnd();
        }
      };
    }), wt.defineMIME("text/plain", "null"), wt.defineExtension = function (t, r) {
      wt.prototype[t] = r;
    }, wt.defineDocExtension = function (t, r) {
      sn.prototype[t] = r;
    }, wt.fromTextArea = jh, zh(wt), wt.version = "6.65.7", wt;
  });
})($i);
const Hr = $i.exports;
(function (e, o) {
  (function (i) {
    i($i.exports);
  })(function (i) {
    i.defineMode("javascript", function (l, n) {
      var u = l.indentUnit, f = n.statementIndent, p = n.jsonld, c = n.json || p, v = n.trackScope !== !1, b = n.typescript, y = n.wordCharacters || /[\w$\xa1-\uffff]/, E = function () {
        function z(kt) {
          return { type: kt, style: "keyword" };
        }
        var J = z("keyword a"), ee = z("keyword b"), ce = z("keyword c"), Ge = z("keyword d"), lt = z("operator"), ut = { type: "atom", style: "atom" };
        return {
          if: z("if"),
          while: J,
          with: J,
          else: ee,
          do: ee,
          try: ee,
          finally: ee,
          return: Ge,
          break: Ge,
          continue: Ge,
          new: z("new"),
          delete: ce,
          void: ce,
          throw: ce,
          debugger: z("debugger"),
          var: z("var"),
          const: z("var"),
          let: z("var"),
          function: z("function"),
          catch: z("catch"),
          for: z("for"),
          switch: z("switch"),
          case: z("case"),
          default: z("default"),
          in: lt,
          typeof: lt,
          instanceof: lt,
          true: ut,
          false: ut,
          null: ut,
          undefined: ut,
          NaN: ut,
          Infinity: ut,
          this: z("this"),
          class: z("class"),
          super: z("atom"),
          yield: ce,
          export: z("export"),
          import: z("import"),
          extends: ce,
          await: ce
        };
      }(), w = /[+\-*&%=<>!?|~^@]/, h = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
      function m(z) {
        for (var J = !1, ee, ce = !1; (ee = z.next()) != null;) {
          if (!J) {
            if (ee == "/" && !ce)
              return;
            ee == "[" ? ce = !0 : ce && ee == "]" && (ce = !1);
          }
          J = !J && ee == "\\";
        }
      }
      var I, D;
      function g(z, J, ee) {
        return I = z, D = ee, J;
      }
      function S(z, J) {
        var ee = z.next();
        if (ee == '"' || ee == "'")
          return J.tokenize = x(ee), J.tokenize(z, J);
        if (ee == "." && z.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/))
          return g("number", "number");
        if (ee == "." && z.match(".."))
          return g("spread", "meta");
        if (/[\[\]{}\(\),;\:\.]/.test(ee))
          return g(ee);
        if (ee == "=" && z.eat(">"))
          return g("=>", "operator");
        if (ee == "0" && z.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/))
          return g("number", "number");
        if (/\d/.test(ee))
          return z.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/), g("number", "number");
        if (ee == "/")
          return z.eat("*") ? (J.tokenize = R, R(z, J)) : z.eat("/") ? (z.skipToEnd(), g("comment", "comment")) : Gn(z, J, 1) ? (m(z), z.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/), g("regexp", "string-2")) : (z.eat("="), g("operator", "operator", z.current()));
        if (ee == "`")
          return J.tokenize = N, N(z, J);
        if (ee == "#" && z.peek() == "!")
          return z.skipToEnd(), g("meta", "meta");
        if (ee == "#" && z.eatWhile(y))
          return g("variable", "property");
        if (ee == "<" && z.match("!--") || ee == "-" && z.match("->") && !/\S/.test(z.string.slice(0, z.start)))
          return z.skipToEnd(), g("comment", "comment");
        if (w.test(ee))
          return (ee != ">" || !J.lexical || J.lexical.type != ">") && (z.eat("=") ? (ee == "!" || ee == "=") && z.eat("=") : /[<>*+\-|&?]/.test(ee) && (z.eat(ee), ee == ">" && z.eat(ee))), ee == "?" && z.eat(".") ? g(".") : g("operator", "operator", z.current());
        if (y.test(ee)) {
          z.eatWhile(y);
          var ce = z.current();
          if (J.lastType != ".") {
            if (E.propertyIsEnumerable(ce)) {
              var Ge = E[ce];
              return g(Ge.type, Ge.style, ce);
            }
            if (ce == "async" && z.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, !1))
              return g("async", "keyword", ce);
          }
          return g("variable", "variable", ce);
        }
      }
      function x(z) {
        return function (J, ee) {
          var ce = !1, Ge;
          if (p && J.peek() == "@" && J.match(h))
            return ee.tokenize = S, g("jsonld-keyword", "meta");
          for (; (Ge = J.next()) != null && !(Ge == z && !ce);)
            ce = !ce && Ge == "\\";
          return ce || (ee.tokenize = S), g("string", "string");
        };
      }
      function R(z, J) {
        for (var ee = !1, ce; ce = z.next();) {
          if (ce == "/" && ee) {
            J.tokenize = S;
            break;
          }
          ee = ce == "*";
        }
        return g("comment", "comment");
      }
      function N(z, J) {
        for (var ee = !1, ce; (ce = z.next()) != null;) {
          if (!ee && (ce == "`" || ce == "$" && z.eat("{"))) {
            J.tokenize = S;
            break;
          }
          ee = !ee && ce == "\\";
        }
        return g("quasi", "string-2", z.current());
      }
      var T = "([{}])";
      function H(z, J) {
        J.fatArrowAt && (J.fatArrowAt = null);
        var ee = z.string.indexOf("=>", z.start);
        if (!(ee < 0)) {
          if (b) {
            var ce = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(z.string.slice(z.start, ee));
            ce && (ee = ce.index);
          }
          for (var Ge = 0, lt = !1, ut = ee - 1; ut >= 0; --ut) {
            var kt = z.string.charAt(ut), Sn = T.indexOf(kt);
            if (Sn >= 0 && Sn < 3) {
              if (!Ge) {
                ++ut;
                break;
              }
              if (--Ge == 0) {
                kt == "(" && (lt = !0);
                break;
              }
            } else if (Sn >= 3 && Sn < 6)
              ++Ge;
            else if (y.test(kt))
              lt = !0;
            else if (/["'\/`]/.test(kt))
              for (; ; --ut) {
                if (ut == 0)
                  return;
                var Ye = z.string.charAt(ut - 1);
                if (Ye == kt && z.string.charAt(ut - 2) != "\\") {
                  ut--;
                  break;
                }
              }
            else if (lt && !Ge) {
              ++ut;
              break;
            }
          }
          lt && !Ge && (J.fatArrowAt = ut);
        }
      }
      var B = {
        atom: !0,
        number: !0,
        variable: !0,
        string: !0,
        regexp: !0,
        this: !0,
        import: !0,
        "jsonld-keyword": !0
      };
      function L(z, J, ee, ce, Ge, lt) {
        this.indented = z, this.column = J, this.type = ee, this.prev = Ge, this.info = lt, ce != null && (this.align = ce);
      }
      function P(z, J) {
        if (!v)
          return !1;
        for (var ee = z.localVars; ee; ee = ee.next)
          if (ee.name == J)
            return !0;
        for (var ce = z.context; ce; ce = ce.prev)
          for (var ee = ce.vars; ee; ee = ee.next)
            if (ee.name == J)
              return !0;
      }
      function C(z, J, ee, ce, Ge) {
        var lt = z.cc;
        for (M.state = z, M.stream = Ge, M.marked = null, M.cc = lt, M.style = J, z.lexical.hasOwnProperty("align") || (z.lexical.align = !0); ;) {
          var ut = lt.length ? lt.pop() : c ? Ee : se;
          if (ut(ee, ce)) {
            for (; lt.length && lt[lt.length - 1].lex;)
              lt.pop()();
            return M.marked ? M.marked : ee == "variable" && P(z, ce) ? "variable-2" : J;
          }
        }
      }
      var M = { state: null, column: null, marked: null, cc: null };
      function k() {
        for (var z = arguments.length - 1; z >= 0; z--)
          M.cc.push(arguments[z]);
      }
      function F() {
        return k.apply(null, arguments), !0;
      }
      function j(z, J) {
        for (var ee = J; ee; ee = ee.next)
          if (ee.name == z)
            return !0;
        return !1;
      }
      function W(z) {
        var J = M.state;
        if (M.marked = "def", !!v) {
          if (J.context) {
            if (J.lexical.info == "var" && J.context && J.context.block) {
              var ee = Q(z, J.context);
              if (ee != null) {
                J.context = ee;
                return;
              }
            } else if (!j(z, J.localVars)) {
              J.localVars = new q(z, J.localVars);
              return;
            }
          }
          n.globalVars && !j(z, J.globalVars) && (J.globalVars = new q(z, J.globalVars));
        }
      }
      function Q(z, J) {
        if (J)
          if (J.block) {
            var ee = Q(z, J.prev);
            return ee ? ee == J.prev ? J : new te(ee, J.vars, !0) : null;
          } else
            return j(z, J.vars) ? J : new te(J.prev, new q(z, J.vars), !1);
        else
          return null;
      }
      function ne(z) {
        return z == "public" || z == "private" || z == "protected" || z == "abstract" || z == "readonly";
      }
      function te(z, J, ee) {
        this.prev = z, this.vars = J, this.block = ee;
      }
      function q(z, J) {
        this.name = z, this.next = J;
      }
      var ge = new q("this", new q("arguments", null));
      function be() {
        M.state.context = new te(M.state.context, M.state.localVars, !1), M.state.localVars = ge;
      }
      function me() {
        M.state.context = new te(M.state.context, M.state.localVars, !0), M.state.localVars = null;
      }
      be.lex = me.lex = !0;
      function ae() {
        M.state.localVars = M.state.context.vars, M.state.context = M.state.context.prev;
      }
      ae.lex = !0;
      function le(z, J) {
        var ee = function () {
          var ce = M.state, Ge = ce.indented;
          if (ce.lexical.type == "stat")
            Ge = ce.lexical.indented;
          else
            for (var lt = ce.lexical; lt && lt.type == ")" && lt.align; lt = lt.prev)
              Ge = lt.indented;
          ce.lexical = new L(Ge, M.stream.column(), z, null, ce.lexical, J);
        };
        return ee.lex = !0, ee;
      }
      function ue() {
        var z = M.state;
        z.lexical.prev && (z.lexical.type == ")" && (z.indented = z.lexical.indented), z.lexical = z.lexical.prev);
      }
      ue.lex = !0;
      function he(z) {
        function J(ee) {
          return ee == z ? F() : z == ";" || ee == "}" || ee == ")" || ee == "]" ? k() : F(J);
        }
        return J;
      }
      function se(z, J) {
        return z == "var" ? F(le("vardef", J), Nn, he(";"), ue) : z == "keyword a" ? F(le("form"), _e, se, ue) : z == "keyword b" ? F(le("form"), se, ue) : z == "keyword d" ? M.stream.match(/^\s*$/, !1) ? F() : F(le("stat"), it, he(";"), ue) : z == "debugger" ? F(he(";")) : z == "{" ? F(le("}"), me, rt, ue, ae) : z == ";" ? F() : z == "if" ? (M.state.lexical.info == "else" && M.state.cc[M.state.cc.length - 1] == ue && M.state.cc.pop()(), F(le("form"), _e, se, ue, oi)) : z == "function" ? F(zn) : z == "for" ? F(le("form"), me, Bo, se, ae, ue) : z == "class" || b && J == "interface" ? (M.marked = "keyword", F(le("form", z == "class" ? z : J), Ho, ue)) : z == "variable" ? b && J == "declare" ? (M.marked = "keyword", F(se)) : b && (J == "module" || J == "enum" || J == "type") && M.stream.match(/^\s*\w/, !1) ? (M.marked = "keyword", J == "enum" ? F(ai) : J == "type" ? F(ko, he("operator"), de, he(";")) : F(le("form"), ln, he("{"), le("}"), rt, ue, ue)) : b && J == "namespace" ? (M.marked = "keyword", F(le("form"), Ee, se, ue)) : b && J == "abstract" ? (M.marked = "keyword", F(se)) : F(le("stat"), An) : z == "switch" ? F(
          le("form"),
          _e,
          he("{"),
          le("}", "switch"),
          me,
          rt,
          ue,
          ue,
          ae
        ) : z == "case" ? F(Ee, he(":")) : z == "default" ? F(he(":")) : z == "catch" ? F(le("form"), be, Ae, se, ue, ae) : z == "export" ? F(le("stat"), Sr, ue) : z == "import" ? F(le("stat"), nr, ue) : z == "async" ? F(se) : J == "@" ? F(Ee, se) : k(le("stat"), Ee, he(";"), ue);
      }
      function Ae(z) {
        if (z == "(")
          return F(Ln, he(")"));
      }
      function Ee(z, J) {
        return at(z, J, !1);
      }
      function Ne(z, J) {
        return at(z, J, !0);
      }
      function _e(z) {
        return z != "(" ? k() : F(le(")"), it, he(")"), ue);
      }
      function at(z, J, ee) {
        if (M.state.fatArrowAt == M.stream.start) {
          var ce = ee ? Ut : pn;
          if (z == "(")
            return F(be, le(")"), ct(Ln, ")"), ue, he("=>"), ce, ae);
          if (z == "variable")
            return k(be, ln, he("=>"), ce, ae);
        }
        var Ge = ee ? Et : St;
        return B.hasOwnProperty(z) ? F(Ge) : z == "function" ? F(zn, Ge) : z == "class" || b && J == "interface" ? (M.marked = "keyword", F(le("form"), Cr, ue)) : z == "keyword c" || z == "async" ? F(ee ? Ne : Ee) : z == "(" ? F(le(")"), it, he(")"), ue, Ge) : z == "operator" || z == "spread" ? F(ee ? Ne : Ee) : z == "[" ? F(le("]"), rr, ue, Ge) : z == "{" ? hn(Cn, "}", null, Ge) : z == "quasi" ? k(He, Ge) : z == "new" ? F(yr(ee)) : F();
      }
      function it(z) {
        return z.match(/[;\}\)\],]/) ? k() : k(Ee);
      }
      function St(z, J) {
        return z == "," ? F(it) : Et(z, J, !1);
      }
      function Et(z, J, ee) {
        var ce = ee == !1 ? St : Et, Ge = ee == !1 ? Ee : Ne;
        if (z == "=>")
          return F(be, ee ? Ut : pn, ae);
        if (z == "operator")
          return /\+\+|--/.test(J) || b && J == "!" ? F(ce) : b && J == "<" && M.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, !1) ? F(le(">"), ct(de, ">"), ue, ce) : J == "?" ? F(Ee, he(":"), Ge) : F(Ge);
        if (z == "quasi")
          return k(He, ce);
        if (z != ";") {
          if (z == "(")
            return hn(Ne, ")", "call", ce);
          if (z == ".")
            return F(jn, ce);
          if (z == "[")
            return F(le("]"), it, he("]"), ue, ce);
          if (b && J == "as")
            return M.marked = "keyword", F(de, ce);
          if (z == "regexp")
            return M.state.lastType = M.marked = "operator", M.stream.backUp(M.stream.pos - M.stream.start - 1), F(Ge);
        }
      }
      function He(z, J) {
        return z != "quasi" ? k() : J.slice(J.length - 2) != "${" ? F(He) : F(it, bt);
      }
      function bt(z) {
        if (z == "}")
          return M.marked = "string-2", M.state.tokenize = N, F(He);
      }
      function pn(z) {
        return H(M.stream, M.state), k(z == "{" ? se : Ee);
      }
      function Ut(z) {
        return H(M.stream, M.state), k(z == "{" ? se : Ne);
      }
      function yr(z) {
        return function (J) {
          return J == "." ? F(z ? bn : Un) : J == "variable" && b ? F(pt, z ? Et : St) : k(z ? Ne : Ee);
        };
      }
      function Un(z, J) {
        if (J == "target")
          return M.marked = "keyword", F(St);
      }
      function bn(z, J) {
        if (J == "target")
          return M.marked = "keyword", F(Et);
      }
      function An(z) {
        return z == ":" ? F(ue, se) : k(St, he(";"), ue);
      }
      function jn(z) {
        if (z == "variable")
          return M.marked = "property", F();
      }
      function Cn(z, J) {
        if (z == "async")
          return M.marked = "property", F(Cn);
        if (z == "variable" || M.style == "keyword") {
          if (M.marked = "property", J == "get" || J == "set")
            return F(Dn);
          var ee;
          return b && M.state.fatArrowAt == M.stream.start && (ee = M.stream.match(/^\s*:\s*/, !1)) && (M.state.fatArrowAt = M.stream.pos + ee[0].length), F(Bt);
        } else {
          if (z == "number" || z == "string")
            return M.marked = p ? "property" : M.style + " property", F(Bt);
          if (z == "jsonld-keyword")
            return F(Bt);
          if (b && ne(J))
            return M.marked = "keyword", F(Cn);
          if (z == "[")
            return F(Ee, Me, he("]"), Bt);
          if (z == "spread")
            return F(Ne, Bt);
          if (J == "*")
            return M.marked = "keyword", F(Cn);
          if (z == ":")
            return k(Bt);
        }
      }
      function Dn(z) {
        return z != "variable" ? k(Bt) : (M.marked = "property", F(zn));
      }
      function Bt(z) {
        if (z == ":")
          return F(Ne);
        if (z == "(")
          return k(zn);
      }
      function ct(z, J, ee) {
        function ce(Ge, lt) {
          if (ee ? ee.indexOf(Ge) > -1 : Ge == ",") {
            var ut = M.state.lexical;
            return ut.info == "call" && (ut.pos = (ut.pos || 0) + 1), F(function (kt, Sn) {
              return kt == J || Sn == J ? k() : k(z);
            }, ce);
          }
          return Ge == J || lt == J ? F() : ee && ee.indexOf(";") > -1 ? k(z) : F(he(J));
        }
        return function (Ge, lt) {
          return Ge == J || lt == J ? F() : k(z, ce);
        };
      }
      function hn(z, J, ee) {
        for (var ce = 3; ce < arguments.length; ce++)
          M.cc.push(arguments[ce]);
        return F(le(J, ee), ct(z, J), ue);
      }
      function rt(z) {
        return z == "}" ? F() : k(se, rt);
      }
      function Me(z, J) {
        if (b) {
          if (z == ":")
            return F(de);
          if (J == "?")
            return F(Me);
        }
      }
      function Re(z, J) {
        if (b && (z == ":" || J == "in"))
          return F(de);
      }
      function je(z) {
        if (b && z == ":")
          return M.stream.match(/^\s*\w+\s+is\b/, !1) ? F(Ee, Oe, de) : F(de);
      }
      function Oe(z, J) {
        if (J == "is")
          return M.marked = "keyword", F();
      }
      function de(z, J) {
        if (J == "keyof" || J == "typeof" || J == "infer" || J == "readonly")
          return M.marked = "keyword", F(J == "typeof" ? Ne : de);
        if (z == "variable" || J == "void")
          return M.marked = "type", F(Ct);
        if (J == "|" || J == "&")
          return F(de);
        if (z == "string" || z == "number" || z == "atom")
          return F(Ct);
        if (z == "[")
          return F(le("]"), ct(de, "]", ","), ue, Ct);
        if (z == "{")
          return F(le("}"), Pe, ue, Ct);
        if (z == "(")
          return F(ct(xt, ")"), ke, Ct);
        if (z == "<")
          return F(ct(de, ">"), de);
        if (z == "quasi")
          return k(Xe, Ct);
      }
      function ke(z) {
        if (z == "=>")
          return F(de);
      }
      function Pe(z) {
        return z.match(/[\}\)\]]/) ? F() : z == "," || z == ";" ? F(Pe) : k($e, Pe);
      }
      function $e(z, J) {
        if (z == "variable" || M.style == "keyword")
          return M.marked = "property", F($e);
        if (J == "?" || z == "number" || z == "string")
          return F($e);
        if (z == ":")
          return F(de);
        if (z == "[")
          return F(he("variable"), Re, he("]"), $e);
        if (z == "(")
          return k(Wn, $e);
        if (!z.match(/[;\}\)\],]/))
          return F();
      }
      function Xe(z, J) {
        return z != "quasi" ? k() : J.slice(J.length - 2) != "${" ? F(Xe) : F(de, on);
      }
      function on(z) {
        if (z == "}")
          return M.marked = "string-2", M.state.tokenize = N, F(Xe);
      }
      function xt(z, J) {
        return z == "variable" && M.stream.match(/^\s*[?:]/, !1) || J == "?" ? F(xt) : z == ":" ? F(de) : z == "spread" ? F(xt) : k(de);
      }
      function Ct(z, J) {
        if (J == "<")
          return F(le(">"), ct(de, ">"), ue, Ct);
        if (J == "|" || z == "." || J == "&")
          return F(de);
        if (z == "[")
          return F(de, he("]"), Ct);
        if (J == "extends" || J == "implements")
          return M.marked = "keyword", F(de);
        if (J == "?")
          return F(de, he(":"), de);
      }
      function pt(z, J) {
        if (J == "<")
          return F(le(">"), ct(de, ">"), ue, Ct);
      }
      function In() {
        return k(de, br);
      }
      function br(z, J) {
        if (J == "=")
          return F(de);
      }
      function Nn(z, J) {
        return J == "enum" ? (M.marked = "keyword", F(ai)) : k(ln, Me, Rn, ql);
      }
      function ln(z, J) {
        if (b && ne(J))
          return M.marked = "keyword", F(ln);
        if (z == "variable")
          return W(J), F();
        if (z == "spread")
          return F(ln);
        if (z == "[")
          return hn(Zl, "]");
        if (z == "{")
          return hn(ki, "}");
      }
      function ki(z, J) {
        return z == "variable" && !M.stream.match(/^\s*:/, !1) ? (W(J), F(Rn)) : (z == "variable" && (M.marked = "property"), z == "spread" ? F(ln) : z == "}" ? k() : z == "[" ? F(Ee, he("]"), he(":"), ki) : F(he(":"), ln, Rn));
      }
      function Zl() {
        return k(ln, Rn);
      }
      function Rn(z, J) {
        if (J == "=")
          return F(Ne);
      }
      function ql(z) {
        if (z == ",")
          return F(Nn);
      }
      function oi(z, J) {
        if (z == "keyword b" && J == "else")
          return F(le("form", "else"), se, ue);
      }
      function Bo(z, J) {
        if (J == "await")
          return F(Bo);
        if (z == "(")
          return F(le(")"), Hi, ue);
      }
      function Hi(z) {
        return z == "var" ? F(Nn, Ar) : z == "variable" ? F(Ar) : k(Ar);
      }
      function Ar(z, J) {
        return z == ")" ? F() : z == ";" ? F(Ar) : J == "in" || J == "of" ? (M.marked = "keyword", F(Ee, Ar)) : k(Ee, Ar);
      }
      function zn(z, J) {
        if (J == "*")
          return M.marked = "keyword", F(zn);
        if (z == "variable")
          return W(J), F(zn);
        if (z == "(")
          return F(be, le(")"), ct(Ln, ")"), ue, je, se, ae);
        if (b && J == "<")
          return F(le(">"), ct(In, ">"), ue, zn);
      }
      function Wn(z, J) {
        if (J == "*")
          return M.marked = "keyword", F(Wn);
        if (z == "variable")
          return W(J), F(Wn);
        if (z == "(")
          return F(be, le(")"), ct(Ln, ")"), ue, je, ae);
        if (b && J == "<")
          return F(le(">"), ct(In, ">"), ue, Wn);
      }
      function ko(z, J) {
        if (z == "keyword" || z == "variable")
          return M.marked = "type", F(ko);
        if (J == "<")
          return F(le(">"), ct(In, ">"), ue);
      }
      function Ln(z, J) {
        return J == "@" && F(Ee, Ln), z == "spread" ? F(Ln) : b && ne(J) ? (M.marked = "keyword", F(Ln)) : b && z == "this" ? F(Me, Rn) : k(ln, Me, Rn);
      }
      function Cr(z, J) {
        return z == "variable" ? Ho(z, J) : li(z, J);
      }
      function Ho(z, J) {
        if (z == "variable")
          return W(J), F(li);
      }
      function li(z, J) {
        if (J == "<")
          return F(le(">"), ct(In, ">"), ue, li);
        if (J == "extends" || J == "implements" || b && z == ",")
          return J == "implements" && (M.marked = "keyword"), F(b ? de : Ee, li);
        if (z == "{")
          return F(le("}"), vn, ue);
      }
      function vn(z, J) {
        if (z == "async" || z == "variable" && (J == "static" || J == "get" || J == "set" || b && ne(J)) && M.stream.match(/^\s+[\w$\xa1-\uffff]/, !1))
          return M.marked = "keyword", F(vn);
        if (z == "variable" || M.style == "keyword")
          return M.marked = "property", F(tr, vn);
        if (z == "number" || z == "string")
          return F(tr, vn);
        if (z == "[")
          return F(Ee, Me, he("]"), tr, vn);
        if (J == "*")
          return M.marked = "keyword", F(vn);
        if (b && z == "(")
          return k(Wn, vn);
        if (z == ";" || z == ",")
          return F(vn);
        if (z == "}")
          return F();
        if (J == "@")
          return F(Ee, vn);
      }
      function tr(z, J) {
        if (J == "!" || J == "?")
          return F(tr);
        if (z == ":")
          return F(de, Rn);
        if (J == "=")
          return F(Ne);
        var ee = M.state.lexical.prev, ce = ee && ee.info == "interface";
        return k(ce ? Wn : zn);
      }
      function Sr(z, J) {
        return J == "*" ? (M.marked = "keyword", F(Be, he(";"))) : J == "default" ? (M.marked = "keyword", F(Ee, he(";"))) : z == "{" ? F(ct(Vo, "}"), Be, he(";")) : k(se);
      }
      function Vo(z, J) {
        if (J == "as")
          return M.marked = "keyword", F(he("variable"));
        if (z == "variable")
          return k(Ne, Vo);
      }
      function nr(z) {
        return z == "string" ? F() : z == "(" ? k(Ee) : z == "." ? k(St) : k(Er, Vi, Be);
      }
      function Er(z, J) {
        return z == "{" ? hn(Er, "}") : (z == "variable" && W(J), J == "*" && (M.marked = "keyword"), F(It));
      }
      function Vi(z) {
        if (z == ",")
          return F(Er, Vi);
      }
      function It(z, J) {
        if (J == "as")
          return M.marked = "keyword", F(Er);
      }
      function Be(z, J) {
        if (J == "from")
          return M.marked = "keyword", F(Ee);
      }
      function rr(z) {
        return z == "]" ? F() : k(ct(Ne, "]"));
      }
      function ai() {
        return k(le("form"), ln, he("{"), le("}"), ct(Fn, "}"), ue, ue);
      }
      function Fn() {
        return k(ln, Rn);
      }
      function ht(z, J) {
        return z.lastType == "operator" || z.lastType == "," || w.test(J.charAt(0)) || /[,.]/.test(J.charAt(0));
      }
      function Gn(z, J, ee) {
        return J.tokenize == S && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(J.lastType) || J.lastType == "quasi" && /\{\s*$/.test(z.string.slice(0, z.pos - (ee || 0)));
      }
      return {
        startState: function (z) {
          var J = {
            tokenize: S,
            lastType: "sof",
            cc: [],
            lexical: new L((z || 0) - u, 0, "block", !1),
            localVars: n.localVars,
            context: n.localVars && new te(null, null, !1),
            indented: z || 0
          };
          return n.globalVars && typeof n.globalVars == "object" && (J.globalVars = n.globalVars), J;
        },
        token: function (z, J) {
          if (z.sol() && (J.lexical.hasOwnProperty("align") || (J.lexical.align = !1), J.indented = z.indentation(), H(z, J)), J.tokenize != R && z.eatSpace())
            return null;
          var ee = J.tokenize(z, J);
          return I == "comment" ? ee : (J.lastType = I == "operator" && (D == "++" || D == "--") ? "incdec" : I, C(J, ee, I, D, z));
        },
        indent: function (z, J) {
          if (z.tokenize == R || z.tokenize == N)
            return i.Pass;
          if (z.tokenize != S)
            return 0;
          var ee = J && J.charAt(0), ce = z.lexical, Ge;
          if (!/^\s*else\b/.test(J))
            for (var lt = z.cc.length - 1; lt >= 0; --lt) {
              var ut = z.cc[lt];
              if (ut == ue)
                ce = ce.prev;
              else if (ut != oi && ut != ae)
                break;
            }
          for (; (ce.type == "stat" || ce.type == "form") && (ee == "}" || (Ge = z.cc[z.cc.length - 1]) && (Ge == St || Ge == Et) && !/^[,\.=+\-*:?[\(]/.test(J));)
            ce = ce.prev;
          f && ce.type == ")" && ce.prev.type == "stat" && (ce = ce.prev);
          var kt = ce.type, Sn = ee == kt;
          return kt == "vardef" ? ce.indented + (z.lastType == "operator" || z.lastType == "," ? ce.info.length + 1 : 0) : kt == "form" && ee == "{" ? ce.indented : kt == "form" ? ce.indented + u : kt == "stat" ? ce.indented + (ht(z, J) ? f || u : 0) : ce.info == "switch" && !Sn && n.doubleIndentSwitch != !1 ? ce.indented + (/^(?:case|default)\b/.test(J) ? u : 2 * u) : ce.align ? ce.column + (Sn ? 0 : 1) : ce.indented + (Sn ? 0 : u);
        },
        electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
        blockCommentStart: c ? null : "/*",
        blockCommentEnd: c ? null : "*/",
        blockCommentContinue: c ? null : " * ",
        lineComment: c ? null : "//",
        fold: "brace",
        closeBrackets: "()[]{}''\"\"``",
        helperType: c ? "json" : "javascript",
        jsonldMode: p,
        jsonMode: c,
        expressionAllowed: Gn,
        skipExpression: function (z) {
          C(z, "atom", "atom", "true", new i.StringStream("", 2, null));
        }
      };
    }), i.registerHelper("wordChars", "javascript", /[\w$]/), i.defineMIME("text/javascript", "javascript"), i.defineMIME("text/ecmascript", "javascript"), i.defineMIME("application/javascript", "javascript"), i.defineMIME("application/x-javascript", "javascript"), i.defineMIME("application/ecmascript", "javascript"), i.defineMIME("application/json", { name: "javascript", json: !0 }), i.defineMIME("application/x-json", { name: "javascript", json: !0 }), i.defineMIME("application/manifest+json", { name: "javascript", json: !0 }), i.defineMIME("application/ld+json", { name: "javascript", jsonld: !0 }), i.defineMIME("text/typescript", { name: "javascript", typescript: !0 }), i.defineMIME("application/typescript", { name: "javascript", typescript: !0 });
  });
})();
(function (e, o) {
  (function (i) {
    i($i.exports);
  })(function (i) {
    var l = "CodeMirror-hint", n = "CodeMirror-hint-active";
    i.showHint = function (D, g, S) {
      if (!g)
        return D.showHint(S);
      S && S.async && (g.async = !0);
      var x = { hint: g };
      if (S)
        for (var R in S)
          x[R] = S[R];
      return D.showHint(x);
    }, i.defineExtension("showHint", function (D) {
      D = c(this, this.getCursor("start"), D);
      var g = this.listSelections();
      if (!(g.length > 1)) {
        if (this.somethingSelected()) {
          if (!D.hint.supportsSelection)
            return;
          for (var S = 0; S < g.length; S++)
            if (g[S].head.line != g[S].anchor.line)
              return;
        }
        this.state.completionActive && this.state.completionActive.close();
        var x = this.state.completionActive = new u(this, D);
        !x.options.hint || (i.signal(this, "startCompletion", this), x.update(!0));
      }
    }), i.defineExtension("closeHint", function () {
      this.state.completionActive && this.state.completionActive.close();
    });
    function u(D, g) {
      if (this.cm = D, this.options = g, this.widget = null, this.debounce = 0, this.tick = 0, this.startPos = this.cm.getCursor("start"), this.startLen = this.cm.getLine(this.startPos.line).length - this.cm.getSelection().length, this.options.updateOnCursorActivity) {
        var S = this;
        D.on("cursorActivity", this.activityFunc = function () {
          S.cursorActivity();
        });
      }
    }
    var f = window.requestAnimationFrame || function (D) {
      return setTimeout(D, 1e3 / 60);
    }, p = window.cancelAnimationFrame || clearTimeout;
    u.prototype = {
      close: function () {
        !this.active() || (this.cm.state.completionActive = null, this.tick = null, this.options.updateOnCursorActivity && this.cm.off("cursorActivity", this.activityFunc), this.widget && this.data && i.signal(this.data, "close"), this.widget && this.widget.close(), i.signal(this.cm, "endCompletion", this.cm));
      },
      active: function () {
        return this.cm.state.completionActive == this;
      },
      pick: function (D, g) {
        var S = D.list[g], x = this;
        this.cm.operation(function () {
          S.hint ? S.hint(x.cm, D, S) : x.cm.replaceRange(
            v(S),
            S.from || D.from,
            S.to || D.to,
            "complete"
          ), i.signal(D, "pick", S), x.cm.scrollIntoView();
        }), this.options.closeOnPick && this.close();
      },
      cursorActivity: function () {
        this.debounce && (p(this.debounce), this.debounce = 0);
        var D = this.startPos;
        this.data && (D = this.data.from);
        var g = this.cm.getCursor(), S = this.cm.getLine(g.line);
        if (g.line != this.startPos.line || S.length - g.ch != this.startLen - this.startPos.ch || g.ch < D.ch || this.cm.somethingSelected() || !g.ch || this.options.closeCharacters.test(S.charAt(g.ch - 1)))
          this.close();
        else {
          var x = this;
          this.debounce = f(function () {
            x.update();
          }), this.widget && this.widget.disable();
        }
      },
      update: function (D) {
        if (this.tick != null) {
          var g = this, S = ++this.tick;
          h(this.options.hint, this.cm, this.options, function (x) {
            g.tick == S && g.finishUpdate(x, D);
          });
        }
      },
      finishUpdate: function (D, g) {
        this.data && i.signal(this.data, "update");
        var S = this.widget && this.widget.picked || g && this.options.completeSingle;
        this.widget && this.widget.close(), this.data = D, D && D.list.length && (S && D.list.length == 1 ? this.pick(D, 0) : (this.widget = new E(this, D), i.signal(D, "shown")));
      }
    };
    function c(D, g, S) {
      var x = D.options.hintOptions, R = {};
      for (var N in I)
        R[N] = I[N];
      if (x)
        for (var N in x)
          x[N] !== void 0 && (R[N] = x[N]);
      if (S)
        for (var N in S)
          S[N] !== void 0 && (R[N] = S[N]);
      return R.hint.resolve && (R.hint = R.hint.resolve(D, g)), R;
    }
    function v(D) {
      return typeof D == "string" ? D : D.text;
    }
    function b(D, g) {
      var S = {
        Up: function () {
          g.moveFocus(-1);
        },
        Down: function () {
          g.moveFocus(1);
        },
        PageUp: function () {
          g.moveFocus(-g.menuSize() + 1, !0);
        },
        PageDown: function () {
          g.moveFocus(g.menuSize() - 1, !0);
        },
        Home: function () {
          g.setFocus(0);
        },
        End: function () {
          g.setFocus(g.length - 1);
        },
        Enter: g.pick,
        Tab: g.pick,
        Esc: g.close
      }, x = /Mac/.test(navigator.platform);
      x && (S["Ctrl-P"] = function () {
        g.moveFocus(-1);
      }, S["Ctrl-N"] = function () {
        g.moveFocus(1);
      });
      var R = D.options.customKeys, N = R ? {} : S;
      function T(L, P) {
        var C;
        typeof P != "string" ? C = function (M) {
          return P(M, g);
        } : S.hasOwnProperty(P) ? C = S[P] : C = P, N[L] = C;
      }
      if (R)
        for (var H in R)
          R.hasOwnProperty(H) && T(H, R[H]);
      var B = D.options.extraKeys;
      if (B)
        for (var H in B)
          B.hasOwnProperty(H) && T(H, B[H]);
      return N;
    }
    function y(D, g) {
      for (; g && g != D;) {
        if (g.nodeName.toUpperCase() === "LI" && g.parentNode == D)
          return g;
        g = g.parentNode;
      }
    }
    function E(D, g) {
      this.id = "cm-complete-" + Math.floor(Math.random(1e6)), this.completion = D, this.data = g, this.picked = !1;
      var S = this, x = D.cm, R = x.getInputField().ownerDocument, N = R.defaultView || R.parentWindow, T = this.hints = R.createElement("ul");
      T.setAttribute("role", "listbox"), T.setAttribute("aria-expanded", "true"), T.id = this.id;
      var H = D.cm.options.theme;
      T.className = "CodeMirror-hints " + H, this.selectedHint = g.selectedHint || 0;
      for (var B = g.list, L = 0; L < B.length; ++L) {
        var P = T.appendChild(R.createElement("li")), C = B[L], M = l + (L != this.selectedHint ? "" : " " + n);
        C.className != null && (M = C.className + " " + M), P.className = M, L == this.selectedHint && P.setAttribute("aria-selected", "true"), P.id = this.id + "-" + L, P.setAttribute("role", "option"), C.render ? C.render(P, g, C) : P.appendChild(R.createTextNode(C.displayText || v(C))), P.hintId = L;
      }
      var k = D.options.container || R.body, F = x.cursorCoords(D.options.alignWithWord ? g.from : null), j = F.left, W = F.bottom, Q = !0, ne = 0, te = 0;
      if (k !== R.body) {
        var q = ["absolute", "relative", "fixed"].indexOf(N.getComputedStyle(k).position) !== -1, ge = q ? k : k.offsetParent, be = ge.getBoundingClientRect(), me = R.body.getBoundingClientRect();
        ne = be.left - me.left - ge.scrollLeft, te = be.top - me.top - ge.scrollTop;
      }
      T.style.left = j - ne + "px", T.style.top = W - te + "px";
      var ae = N.innerWidth || Math.max(R.body.offsetWidth, R.documentElement.offsetWidth), le = N.innerHeight || Math.max(R.body.offsetHeight, R.documentElement.offsetHeight);
      k.appendChild(T), x.getInputField().setAttribute("aria-autocomplete", "list"), x.getInputField().setAttribute("aria-owns", this.id), x.getInputField().setAttribute("aria-activedescendant", this.id + "-" + this.selectedHint);
      var ue = D.options.moveOnOverlap ? T.getBoundingClientRect() : new DOMRect(), he = D.options.paddingForScrollbar ? T.scrollHeight > T.clientHeight + 1 : !1, se;
      setTimeout(function () {
        se = x.getScrollInfo();
      });
      var Ae = ue.bottom - le;
      if (Ae > 0) {
        var Ee = ue.bottom - ue.top, Ne = F.top - (F.bottom - ue.top);
        if (Ne - Ee > 0)
          T.style.top = (W = F.top - Ee - te) + "px", Q = !1;
        else if (Ee > le) {
          T.style.height = le - 5 + "px", T.style.top = (W = F.bottom - ue.top - te) + "px";
          var _e = x.getCursor();
          g.from.ch != _e.ch && (F = x.cursorCoords(_e), T.style.left = (j = F.left - ne) + "px", ue = T.getBoundingClientRect());
        }
      }
      var at = ue.right - ae;
      if (he && (at += x.display.nativeBarWidth), at > 0 && (ue.right - ue.left > ae && (T.style.width = ae - 5 + "px", at -= ue.right - ue.left - ae), T.style.left = (j = Math.max(F.left - at - ne, 0)) + "px"), he)
        for (var it = T.firstChild; it; it = it.nextSibling)
          it.style.paddingRight = x.display.nativeBarWidth + "px";
      if (x.addKeyMap(this.keyMap = b(D, {
        moveFocus: function (He, bt) {
          S.changeActive(S.selectedHint + He, bt);
        },
        setFocus: function (He) {
          S.changeActive(He);
        },
        menuSize: function () {
          return S.screenAmount();
        },
        length: B.length,
        close: function () {
          D.close();
        },
        pick: function () {
          S.pick();
        },
        data: g
      })), D.options.closeOnUnfocus) {
        var St;
        x.on("blur", this.onBlur = function () {
          St = setTimeout(function () {
            D.close();
          }, 100);
        }), x.on("focus", this.onFocus = function () {
          clearTimeout(St);
        });
      }
      x.on("scroll", this.onScroll = function () {
        var He = x.getScrollInfo(), bt = x.getWrapperElement().getBoundingClientRect();
        se || (se = x.getScrollInfo());
        var pn = W + se.top - He.top, Ut = pn - (N.pageYOffset || (R.documentElement || R.body).scrollTop);
        if (Q || (Ut += T.offsetHeight), Ut <= bt.top || Ut >= bt.bottom)
          return D.close();
        T.style.top = pn + "px", T.style.left = j + se.left - He.left + "px";
      }), i.on(T, "dblclick", function (He) {
        var bt = y(T, He.target || He.srcElement);
        bt && bt.hintId != null && (S.changeActive(bt.hintId), S.pick());
      }), i.on(T, "click", function (He) {
        var bt = y(T, He.target || He.srcElement);
        bt && bt.hintId != null && (S.changeActive(bt.hintId), D.options.completeOnSingleClick && S.pick());
      }), i.on(T, "mousedown", function () {
        setTimeout(function () {
          x.focus();
        }, 20);
      });
      var Et = this.getSelectedHintRange();
      return (Et.from !== 0 || Et.to !== 0) && this.scrollToActive(), i.signal(g, "select", B[this.selectedHint], T.childNodes[this.selectedHint]), !0;
    }
    E.prototype = {
      close: function () {
        if (this.completion.widget == this) {
          this.completion.widget = null, this.hints.parentNode && this.hints.parentNode.removeChild(this.hints), this.completion.cm.removeKeyMap(this.keyMap);
          var D = this.completion.cm.getInputField();
          D.removeAttribute("aria-activedescendant"), D.removeAttribute("aria-owns");
          var g = this.completion.cm;
          this.completion.options.closeOnUnfocus && (g.off("blur", this.onBlur), g.off("focus", this.onFocus)), g.off("scroll", this.onScroll);
        }
      },
      disable: function () {
        this.completion.cm.removeKeyMap(this.keyMap);
        var D = this;
        this.keyMap = {
          Enter: function () {
            D.picked = !0;
          }
        }, this.completion.cm.addKeyMap(this.keyMap);
      },
      pick: function () {
        this.completion.pick(this.data, this.selectedHint);
      },
      changeActive: function (D, g) {
        if (D >= this.data.list.length ? D = g ? this.data.list.length - 1 : 0 : D < 0 && (D = g ? 0 : this.data.list.length - 1), this.selectedHint != D) {
          var S = this.hints.childNodes[this.selectedHint];
          S && (S.className = S.className.replace(" " + n, ""), S.removeAttribute("aria-selected")), S = this.hints.childNodes[this.selectedHint = D], S.className += " " + n, S.setAttribute("aria-selected", "true"), this.completion.cm.getInputField().setAttribute("aria-activedescendant", S.id), this.scrollToActive(), i.signal(this.data, "select", this.data.list[this.selectedHint], S);
        }
      },
      scrollToActive: function () {
        var D = this.getSelectedHintRange(), g = this.hints.childNodes[D.from], S = this.hints.childNodes[D.to], x = this.hints.firstChild;
        g.offsetTop < this.hints.scrollTop ? this.hints.scrollTop = g.offsetTop - x.offsetTop : S.offsetTop + S.offsetHeight > this.hints.scrollTop + this.hints.clientHeight && (this.hints.scrollTop = S.offsetTop + S.offsetHeight - this.hints.clientHeight + x.offsetTop);
      },
      screenAmount: function () {
        return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1;
      },
      getSelectedHintRange: function () {
        var D = this.completion.options.scrollMargin || 0;
        return {
          from: Math.max(0, this.selectedHint - D),
          to: Math.min(this.data.list.length - 1, this.selectedHint + D)
        };
      }
    };
    function w(D, g) {
      if (!D.somethingSelected())
        return g;
      for (var S = [], x = 0; x < g.length; x++)
        g[x].supportsSelection && S.push(g[x]);
      return S;
    }
    function h(D, g, S, x) {
      if (D.async)
        D(g, x, S);
      else {
        var R = D(g, S);
        R && R.then ? R.then(x) : x(R);
      }
    }
    function m(D, g) {
      var S = D.getHelpers(g, "hint"), x;
      if (S.length) {
        var R = function (N, T, H) {
          var B = w(N, S);
          function L(P) {
            if (P == B.length)
              return T(null);
            h(B[P], N, H, function (C) {
              C && C.list.length > 0 ? T(C) : L(P + 1);
            });
          }
          L(0);
        };
        return R.async = !0, R.supportsSelection = !0, R;
      } else
        return (x = D.getHelper(D.getCursor(), "hintWords")) ? function (N) {
          return i.hint.fromList(N, { words: x });
        } : i.hint.anyword ? function (N, T) {
          return i.hint.anyword(N, T);
        } : function () {
        };
    }
    i.registerHelper("hint", "auto", {
      resolve: m
    }), i.registerHelper("hint", "fromList", function (D, g) {
      var S = D.getCursor(), x = D.getTokenAt(S), R, N = i.Pos(S.line, x.start), T = S;
      x.start < S.ch && /\w/.test(x.string.charAt(S.ch - x.start - 1)) ? R = x.string.substr(0, S.ch - x.start) : (R = "", N = S);
      for (var H = [], B = 0; B < g.words.length; B++) {
        var L = g.words[B];
        L.slice(0, R.length) == R && H.push(L);
      }
      if (H.length)
        return { list: H, from: N, to: T };
    }), i.commands.autocomplete = i.showHint;
    var I = {
      hint: i.hint.auto,
      completeSingle: !0,
      alignWithWord: !0,
      closeCharacters: /[\s()\[\]{};:>,]/,
      closeOnPick: !0,
      closeOnUnfocus: !0,
      updateOnCursorActivity: !0,
      completeOnSingleClick: !0,
      container: null,
      customKeys: null,
      extraKeys: null,
      paddingForScrollbar: !0,
      moveOnOverlap: !0
    };
    i.defineOption("hintOptions", null);
  });
})();
(function (e, o) {
  (function (i) {
    i($i.exports);
  })(function (i) {
    var l = i.Pos;
    function n(D, g) {
      for (var S = 0, x = D.length; S < x; ++S)
        g(D[S]);
    }
    function u(D, g) {
      if (!Array.prototype.indexOf) {
        for (var S = D.length; S--;)
          if (D[S] === g)
            return !0;
        return !1;
      }
      return D.indexOf(g) != -1;
    }
    function f(D, g, S, x) {
      var R = D.getCursor(), N = S(D, R);
      if (!/\b(?:string|comment)\b/.test(N.type)) {
        var T = i.innerMode(D.getMode(), N.state);
        if (T.mode.helperType !== "json") {
          N.state = T.state, /^[\w$_]*$/.test(N.string) ? N.end > R.ch && (N.end = R.ch, N.string = N.string.slice(0, R.ch - N.start)) : N = {
            start: R.ch,
            end: R.ch,
            string: "",
            state: N.state,
            type: N.string == "." ? "property" : null
          };
          for (var H = N; H.type == "property";) {
            if (H = S(D, l(R.line, H.start)), H.string != ".")
              return;
            if (H = S(D, l(R.line, H.start)), !B)
              var B = [];
            B.push(H);
          }
          return {
            list: I(N, B, g, x),
            from: l(R.line, N.start),
            to: l(R.line, N.end)
          };
        }
      }
    }
    function p(D, g) {
      return f(
        D,
        w,
        function (S, x) {
          return S.getTokenAt(x);
        },
        g
      );
    }
    i.registerHelper("hint", "javascript", p);
    function c(D, g) {
      var S = D.getTokenAt(g);
      return g.ch == S.start + 1 && S.string.charAt(0) == "." ? (S.end = S.start, S.string = ".", S.type = "property") : /^\.[\w$_]*$/.test(S.string) && (S.type = "property", S.start++, S.string = S.string.replace(/\./, "")), S;
    }
    function v(D, g) {
      return f(D, h, c, g);
    }
    i.registerHelper("hint", "coffeescript", v);
    var b = "charAt charCodeAt indexOf lastIndexOf substring substr slice trim trimLeft trimRight toUpperCase toLowerCase split concat match replace search".split(" "), y = "length concat join splice push pop shift unshift slice reverse sort indexOf lastIndexOf every some filter forEach map reduce reduceRight ".split(" "), E = "prototype apply call bind".split(" "), w = "break case catch class const continue debugger default delete do else export extends false finally for function if in import instanceof new null return super switch this throw true try typeof var void while with yield".split(" "), h = "and break catch class continue delete do else extends false finally for if in instanceof isnt new no not null of off on or return switch then throw true try typeof until void while with yes".split(" ");
    function m(D, g) {
      if (!Object.getOwnPropertyNames || !Object.getPrototypeOf)
        for (var S in D)
          g(S);
      else
        for (var x = D; x; x = Object.getPrototypeOf(x))
          Object.getOwnPropertyNames(x).forEach(g);
    }
    function I(D, g, S, x) {
      var R = [], N = D.string, T = x && x.globalScope || window;
      function H(F) {
        F.lastIndexOf(N, 0) == 0 && !u(R, F) && R.push(F);
      }
      function B(F) {
        typeof F == "string" ? n(b, H) : F instanceof Array ? n(y, H) : F instanceof Function && n(E, H), m(F, H);
      }
      if (g && g.length) {
        var L = g.pop(), P;
        for (L.type && L.type.indexOf("variable") === 0 ? (x && x.additionalContext && (P = x.additionalContext[L.string]), (!x || x.useGlobalScope !== !1) && (P = P || T[L.string])) : L.type == "string" ? P = "" : L.type == "atom" ? P = 1 : L.type == "function" && (T.jQuery != null && (L.string == "$" || L.string == "jQuery") && typeof T.jQuery == "function" ? P = T.jQuery() : T._ != null && L.string == "_" && typeof T._ == "function" && (P = T._())); P != null && g.length;)
          P = P[g.pop().string];
        P != null && B(P);
      } else {
        for (var C = D.state.localVars; C; C = C.next)
          H(C.name);
        for (var M = D.state.context; M; M = M.prev)
          for (var C = M.vars; C; C = C.next)
            H(C.name);
        for (var C = D.state.globalVars; C; C = C.next)
          H(C.name);
        if (x && x.additionalContext != null)
          for (var k in x.additionalContext)
            H(k);
        (!x || x.useGlobalScope !== !1) && B(T), n(S, H);
      }
      return R;
    }
  });
})();
const _t = (e) => _h({
  message: e,
  type: "error",
  customClass: "_fc-message-error"
});
const qe = (e, o) => {
  const i = e.__vccOpts || e;
  for (const [l, n] of o)
    i[l] = n;
  return i;
}, Uf = "[[FORM-CREATE-PREFIX-", jf = "-FORM-CREATE-SUFFIX]]", Ey = et({
  name: "FnEditor",
  props: {
    modelValue: [String, Function],
    name: String,
    args: Array,
    body: Boolean,
    button: Boolean
  },
  inject: ["designer"],
  data() {
    return {
      editor: null,
      fn: "",
      visible: !1,
      value: ""
    };
  },
  watch: {
    modelValue(e) {
      e != this.value && this.editor && this.editor.setValue(this.tidyValue());
    }
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    argStr() {
      return (this.args || []).map((e) => typeof e == "string" ? e : e.name).join(", ");
    },
    argList() {
      return this.args.map((e) => typeof e == "string" ? {
        name: e,
        type: "string"
      } : e);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.load();
    });
  },
  methods: {
    save() {
      const e = this.editor.getValue() || "";
      if (e.trim() === "")
        this.fn = "";
      else {
        let o;
        try {
          o = new Function("return function " + this.name + "(" + this.argStr + "){" + e + "}")();
        } catch (i) {
          return console.error(i), _t(this.t("struct.errorMsg")), !1;
        }
        this.body ? this.fn = e : this.fn = Uf + o + jf;
      }
      return this.submit(), !0;
    },
    submit() {
      this.$emit("update:modelValue", this.fn), this.value = this.fn, this.visible = !1;
    },
    tidyValue() {
      let e = this.modelValue || "";
      return e.__json && (e = e.__json), typeof e == "function" ? (e = kr(e), e = /(?:function\s+\w+\s*\(.*?\)|\(\s*.*?\s*\)\s*=>)\s*{([^}]*)}/g.exec(e)[1].trim()) : this.body || (e = e.replace(Uf + "function " + this.name + "(" + this.argStr + "){", "").replace("}" + jf, "")), e;
    },
    load() {
      this.$nextTick(() => {
        let e = this.tidyValue();
        this.editor = On(Hr(this.$refs.editor, {
          lineNumbers: !0,
          mode: { name: "javascript", globalVars: !0 },
          extraKeys: { "Ctrl-Space": "autocomplete" },
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: e
        })), this.editor.on("inputRead", (o, i) => {
          i.keyCode === 32 && i.ctrlKey && Hr.showHint(o, Hr.hint.javascript);
        }), this.editor.on("change", () => {
          this.visible = !0;
        }), oc(this.editor);
      });
    }
  }
}), wy = { class: "_fd-fn" }, xy = { class: "_fd-fn-tip" }, Ty = /* @__PURE__ */ _("div", { class: "_fd-fn-ind" }, null, -1), Dy = { class: "cm-keyword" }, Iy = { key: 0 }, Ry = { class: "_fd-fn-arg" }, Fy = /* @__PURE__ */ _("i", { class: "fc-icon icon-question" }, null, -1), My = {
  ref: "editor",
  class: "_fd-fn-editor"
}, Oy = /* @__PURE__ */ _("div", { class: "_fd-fn-tip" }, [
  /* @__PURE__ */ _("div", { class: "_fd-fn-ind" }),
  /* @__PURE__ */ _("div", { class: "cm-keyword" }, "}")
], -1);
function Ny(e, o, i, l, n, u) {
  const f = ie("el-table-column"), p = ie("el-table"), c = ie("el-popover"), v = ie("ElButton");
  return Z(), fe("div", wy, [
    _("div", xy, [
      Ty,
      _("div", Dy, [
        _("span", null, [
          xe("function " + ve(e.name) + "(", 1),
          (Z(!0), fe(ze, null, ft(e.argList, (b, y) => (Z(), fe(ze, null, [
            xe(ve(y > 0 ? ", " : ""), 1),
            b.type === "string" ? (Z(), fe("span", Iy, ve(b.name), 1)) : (Z(), we(c, {
              key: 1,
              placement: "top-start",
              width: 400,
              trigger: "click",
              title: b.name,
              content: b.info || ""
            }, {
              reference: Y(() => [
                _("span", Ry, [
                  xe(ve(b.name), 1),
                  Fy
                ])
              ]),
              default: Y(() => [
                b.columns ? (Z(), we(p, {
                  key: 0,
                  data: b.columns,
                  border: ""
                }, {
                  default: Y(() => [
                    X(f, {
                      width: "120",
                      property: "label",
                      label: e.t("event.label")
                    }, null, 8, ["label"]),
                    X(f, {
                      property: "info",
                      label: e.t("event.info")
                    }, null, 8, ["label"]),
                    X(f, {
                      width: "80",
                      property: "type",
                      label: e.t("event.type")
                    }, null, 8, ["label"])
                  ]),
                  _: 2
                }, 1032, ["data"])) : Se("", !0)
              ]),
              _: 2
            }, 1032, ["title", "content"]))
          ], 64))), 256)),
          xe(") {")
        ])
      ])
    ]),
    _("div", My, null, 512),
    Oy,
    e.visible && e.button ? (Z(), we(v, {
      key: 0,
      type: "primary",
      size: "small",
      onClick: e.save
    }, {
      default: Y(() => [
        xe(ve(e.t("props.save")), 1)
      ]),
      _: 1
    }, 8, ["onClick"])) : Se("", !0)
  ]);
}
const Po = /* @__PURE__ */ qe(Ey, [["render", Ny]]);
const Oi = "$FNX:", Il = (e) => st.String(e) && e.indexOf(Oi) === 0, Ly = et({
  name: "EventConfig",
  emits: ["update:modelValue"],
  props: {
    modelValue: [Object, void 0, null],
    componentName: "",
    eventName: {
      type: Array,
      default: () => []
    }
  },
  inject: ["designer"],
  components: {
    FnEditor: Po
  },
  data() {
    return {
      visible: !1,
      activeData: null,
      val: null,
      defActive: "no",
      event: {},
      cus: !1,
      cusValue: "",
      eventType: "fn",
      eventKey: "",
      eventStr: ""
    };
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    eventNum() {
      let e = 0;
      return Object.keys(this.modelValue || {}).forEach((o) => {
        e += Array.isArray(this.modelValue[o]) ? this.modelValue[o].length : 1;
      }), e;
    },
    eventInfo() {
      const e = {};
      return this.eventName.forEach((o) => {
        e[o] = this.t("com." + this.componentName + ".event." + o) || this.t("eventInfo." + o) || "";
      }), e;
    },
    globalEvent() {
      return this.designer.setupState.formOptions.globalEvent || {};
    },
    options() {
      return Object.keys(this.globalEvent).map((e) => ({
        label: this.globalEvent[e].label,
        value: "$GLOBAL:" + e
      }));
    },
    fnArgs() {
      return [qs(this.t)];
    }
  },
  watch: {
    visible(e) {
      this.event = e ? this.loadFN(Wl({}, this.modelValue || {})) : {}, e || (this.destroy(), this.closeCus());
    }
  },
  methods: {
    openConfig() {
      this.designer.setupState.openGlobalEventDialog();
    },
    addCus() {
      const e = this.cusValue && this.cusValue.trim();
      e && (this.closeCus(), this.add(e));
    },
    closeCus() {
      this.cus = !1, this.cusValue = "";
    },
    cusEvent() {
      this.cus = !0;
    },
    loadFN(e) {
      const o = {};
      return Object.keys(e).forEach((i) => {
        if (Array.isArray(e[i])) {
          const l = [];
          e[i].forEach((n) => {
            Il(n) ? l.push(n.replace(Oi, "")) : st.Function(n) && Il(n.__json) ? l.push(n.__json.replace(Oi, "")) : n && n.indexOf("$GLOBAL:") === 0 && l.push(n);
          }), o[i] = l;
        } else
          Il(e[i]) ? o[i] = [e[i].replace(Oi, "")] : st.Function(e[i]) && Il(e[i].__json) ? o[i] = [e[i].__json.replace(Oi, "")] : e[i] && e[i].indexOf("$GLOBAL:") === 0 && (o[i] = [e[i]]);
      }), o;
    },
    parseFN(e) {
      const o = {};
      return Object.keys(e).forEach((i) => {
        o[i] = [], e[i].forEach((l, n) => {
          o[i][n] = l.indexOf("$GLOBAL:") !== 0 ? Oi + l : l;
        }), o[i].length === 1 && (o[i] = o[i][0]);
      }), o;
    },
    add(e) {
      let o = {};
      if (Array.isArray(this.event[e]))
        this.event[e].push(""), o = {
          name: e,
          item: this.event[e],
          index: this.event[e].length - 1
        };
      else if (this.event[e]) {
        const i = [this.event[e], ""];
        this.event[e] = i, o = {
          name: e,
          item: i,
          index: 1
        };
      } else {
        const i = [""];
        this.event[e] = i, o = {
          name: e,
          item: i,
          index: 0
        };
      }
      this.activeData || this.edit(o);
    },
    edit(e) {
      e.key = We(), e.item ? this.val = e.item[e.index] : this.val = this.event[e.name], this.activeData = e, this.eventType = this.val.indexOf("$GLOBAL:") === 0 ? "event" : "fn", this.eventType === "event" ? (this.eventKey = this.val, this.eventStr = "") : (this.eventStr = this.val, this.eventKey = ""), this.defActive = e.name + (e.index || 0);
    },
    save() {
      let e = this.eventKey;
      if (this.eventType !== "event") {
        if (!this.$refs.fn.save())
          return;
        e = this.eventStr;
      }
      this.activeData.item ? this.activeData.item[this.activeData.index] = e : this.event[this.activeData.name] = e, this.destroy();
    },
    rm(e) {
      e.index !== void 0 ? e.item.splice(e.index, 1) : this.$delete(this.event, e.name), this.defActive === e.name + (e.index || 0) && this.destroy();
    },
    destroy() {
      this.activeData = null, this.val = null, this.defActive = "no";
    },
    close() {
      this.destroy();
    },
    submit() {
      if (this.activeData)
        return _t(this.t("event.saveMsg"));
      this.$emit("update:modelValue", this.parseFN(this.event)), this.visible = !1, this.destroy(), this.closeCus();
    }
  },
  beforeCreate() {
    window.$inject = {
      $f: {},
      rule: [],
      self: {},
      option: {},
      inject: {},
      args: []
    };
  }
}), Py = { class: "_fd-event" }, $y = { class: "el-dropdown-link" }, By = /* @__PURE__ */ _("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1), ky = { class: "_fd-event-item" }, Hy = {
  key: 0,
  class: "_fd-label"
}, Vy = ["onClick"], Uy = { class: "_fd-event-method" }, jy = {
  key: 0,
  class: "_fd-label"
}, zy = ["onClick"], Wy = ["onClick"], Gy = { class: "_fd-event-method" }, Yy = {
  key: 0,
  class: "_fd-label"
}, Qy = ["onClick"], Ky = /* @__PURE__ */ _("i", { class: "fc-icon icon-setting" }, null, -1);
function Jy(e, o, i, l, n, u) {
  const f = ie("ElButton"), p = ie("el-badge"), c = ie("el-button"), v = ie("el-dropdown-item"), b = ie("el-dropdown-menu"), y = ie("el-dropdown"), E = ie("el-header"), w = ie("el-menu-item"), h = ie("el-input"), m = ie("el-menu"), I = ie("el-main"), D = ie("el-container"), g = ie("el-aside"), S = ie("FnEditor"), x = ie("el-tab-pane"), R = ie("el-option"), N = ie("el-select"), T = ie("el-tabs"), H = ie("ElDialog");
  return Z(), fe("div", Py, [
    X(p, {
      value: e.eventNum,
      type: "warning",
      hidden: e.eventNum < 1
    }, {
      default: Y(() => [
        X(f, {
          size: "small",
          onClick: o[0] || (o[0] = (B) => e.visible = !0)
        }, {
          default: Y(() => [
            xe(ve(e.t("event.title")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "hidden"]),
    X(H, {
      class: "_fd-event-dialog",
      title: e.t("event.title"),
      modelValue: e.visible,
      "onUpdate:modelValue": o[11] || (o[11] = (B) => e.visible = B),
      "destroy-on-close": "",
      "close-on-click-modal": !1,
      "append-to-body": "",
      width: "980px"
    }, {
      footer: Y(() => [
        _("div", null, [
          X(f, {
            size: "default",
            onClick: o[10] || (o[10] = (B) => e.visible = !1)
          }, {
            default: Y(() => [
              xe(ve(e.t("props.cancel")), 1)
            ]),
            _: 1
          }),
          X(f, {
            type: "primary",
            size: "default",
            onClick: e.submit,
            color: "#2f73ff"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.ok")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: Y(() => [
        X(D, {
          class: "_fd-event-con",
          style: { height: "600px" }
        }, {
          default: Y(() => [
            X(g, { style: { width: "300px" } }, {
              default: Y(() => [
                X(D, { class: "_fd-event-l" }, {
                  default: Y(() => [
                    X(E, {
                      class: "_fd-event-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(y, {
                          "popper-class": "_fd-event-dropdown",
                          trigger: "click",
                          size: "default",
                          placement: "bottom-start"
                        }, {
                          dropdown: Y(() => [
                            X(b, null, {
                              default: Y(() => [
                                (Z(!0), fe(ze, null, ft(e.eventName, (B) => (Z(), we(v, {
                                  key: B,
                                  onClick: (L) => e.add(B)
                                }, {
                                  default: Y(() => [
                                    _("div", ky, [
                                      _("span", null, ve(B), 1),
                                      e.eventInfo[B] ? (Z(), fe("span", Hy, ve(e.eventInfo[B]), 1)) : Se("", !0)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))), 128)),
                                X(v, {
                                  divided: e.eventName.length > 0,
                                  onClick: e.cusEvent
                                }, {
                                  default: Y(() => [
                                    _("div", null, ve(e.t("props.custom")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["divided", "onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          default: Y(() => [
                            _("span", $y, [
                              X(c, {
                                link: "",
                                type: "primary",
                                size: "default"
                              }, {
                                default: Y(() => [
                                  xe(ve(e.t("event.create")), 1),
                                  By
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    X(I, null, {
                      default: Y(() => [
                        X(m, {
                          "default-active": e.defActive,
                          modelValue: e.activeData,
                          "onUpdate:modelValue": o[5] || (o[5] = (B) => e.activeData = B)
                        }, {
                          default: Y(() => [
                            (Z(!0), fe(ze, null, ft(e.event, (B, L) => (Z(), fe(ze, null, [
                              Array.isArray(B) ? (Z(!0), fe(ze, { key: 0 }, ft(B, (P, C) => (Z(), we(w, {
                                key: L + C,
                                index: L + C
                              }, {
                                default: Y(() => [
                                  _("div", {
                                    class: "_fd-event-title",
                                    onClick: yt((M) => e.edit({ name: L, item: B, index: C }), ["stop"])
                                  }, [
                                    _("div", Uy, [
                                      _("span", null, [
                                        xe("function"),
                                        _("span", null, ve(L), 1)
                                      ]),
                                      e.eventInfo[L] ? (Z(), fe("span", jy, ve(e.eventInfo[L]), 1)) : Se("", !0)
                                    ]),
                                    _("i", {
                                      class: "fc-icon icon-delete",
                                      onClick: yt((M) => e.rm({ name: L, item: B, index: C }), ["stop"])
                                    }, null, 8, zy)
                                  ], 8, Vy)
                                ]),
                                _: 2
                              }, 1032, ["index"]))), 128)) : (Z(), we(w, {
                                key: 1,
                                index: L + 0
                              }, {
                                default: Y(() => [
                                  _("div", {
                                    class: "_fd-event-title",
                                    onClick: yt((P) => e.edit({ name: L }), ["stop"])
                                  }, [
                                    _("div", Gy, [
                                      _("span", null, [
                                        xe("function"),
                                        _("span", null, ve(L), 1)
                                      ]),
                                      e.eventInfo[L] ? (Z(), fe("span", Yy, ve(e.eventInfo[L]), 1)) : Se("", !0)
                                    ]),
                                    _("i", {
                                      class: "fc-icon icon-delete",
                                      onClick: yt((P) => e.rm({ name: L }), ["stop"])
                                    }, null, 8, Qy)
                                  ], 8, Wy)
                                ]),
                                _: 2
                              }, 1032, ["index"]))
                            ], 64))), 256)),
                            e.cus ? (Z(), we(w, {
                              key: 0,
                              style: { "padding-left": "10px" },
                              index: "custom"
                            }, {
                              default: Y(() => [
                                _("div", {
                                  class: "_fd-event-title",
                                  onClick: o[4] || (o[4] = yt(() => {
                                  }, ["stop"]))
                                }, [
                                  X(h, {
                                    type: "text",
                                    modelValue: e.cusValue,
                                    "onUpdate:modelValue": o[1] || (o[1] = (B) => e.cusValue = B),
                                    size: "default",
                                    onKeydown: jl(e.addCus, ["enter"]),
                                    placeholder: e.t("event.placeholder")
                                  }, null, 8, ["modelValue", "onKeydown", "placeholder"]),
                                  _("div", null, [
                                    _("i", {
                                      class: "fc-icon icon-add",
                                      onClick: o[2] || (o[2] = yt((...B) => e.addCus && e.addCus(...B), ["stop"]))
                                    }),
                                    _("i", {
                                      class: "fc-icon icon-delete",
                                      onClick: o[3] || (o[3] = yt((...B) => e.closeCus && e.closeCus(...B), ["stop"]))
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })) : Se("", !0)
                          ]),
                          _: 1
                        }, 8, ["default-active", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            X(I, null, {
              default: Y(() => [
                X(D, { class: "_fd-event-r" }, {
                  default: Y(() => [
                    e.activeData ? (Z(), we(E, {
                      key: 0,
                      class: "_fd-event-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(c, {
                          size: "small",
                          onClick: e.close
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        X(c, {
                          size: "small",
                          type: "primary",
                          onClick: e.save,
                          color: "#2f73ff"
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.save")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })) : Se("", !0),
                    e.activeData ? (Z(), we(I, { key: 1 }, {
                      default: Y(() => [
                        (Z(), we(T, {
                          modelValue: e.eventType,
                          "onUpdate:modelValue": o[9] || (o[9] = (B) => e.eventType = B),
                          class: "_fc-tabs",
                          key: e.activeData.key
                        }, {
                          default: Y(() => [
                            X(x, {
                              label: e.t("props.custom"),
                              name: "fn",
                              lazy: ""
                            }, {
                              default: Y(() => [
                                X(S, {
                                  ref: "fn",
                                  modelValue: e.eventStr,
                                  "onUpdate:modelValue": o[6] || (o[6] = (B) => e.eventStr = B),
                                  body: "",
                                  name: e.activeData.name,
                                  args: e.fnArgs,
                                  style: { height: "455px" }
                                }, null, 8, ["modelValue", "name", "args"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            X(x, {
                              label: e.t("form.globalEvent"),
                              name: "event"
                            }, {
                              default: Y(() => [
                                X(N, {
                                  modelValue: e.eventKey,
                                  "onUpdate:modelValue": o[7] || (o[7] = (B) => e.eventKey = B),
                                  clearable: "",
                                  style: { width: "240px", "margin-left": "15px" }
                                }, {
                                  default: Y(() => [
                                    (Z(!0), fe(ze, null, ft(e.options, (B) => (Z(), we(R, {
                                      key: B.value,
                                      label: B.label,
                                      value: B.value
                                    }, null, 8, ["label", "value"]))), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _("span", {
                                  class: "_fc-manage-text",
                                  onClick: o[8] || (o[8] = (...B) => e.openConfig && e.openConfig(...B))
                                }, [
                                  xe(ve(e.t("props.manage")), 1),
                                  Ky
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      ]),
                      _: 1
                    })) : Se("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]);
}
const Fc = /* @__PURE__ */ qe(Ly, [["render", Jy]]);
function Xy(e, o) {
  var i = null;
  return function (...l) {
    i !== null && clearTimeout(i), i = setTimeout(() => e.call(this, ...l), o);
  };
}
/*!
  Highlight.js v11.9.0 (git: b7ec4bfafc)
  (c) 2006-2024 undefined and other contributors
  License: BSD-3-Clause
 */
function Mc(e) {
  return e instanceof Map ? e.clear = e.delete = e.set = () => {
    throw Error("map is read-only");
  } : e instanceof Set && (e.add = e.clear = e.delete = () => {
    throw Error("set is read-only");
  }), Object.freeze(e), Object.getOwnPropertyNames(e).forEach((o) => {
    const i = e[o], l = typeof i;
    l !== "object" && l !== "function" || Object.isFrozen(i) || Mc(i);
  }), e;
}
class zf {
  constructor(o) {
    o.data === void 0 && (o.data = {}), this.data = o.data, this.isMatchIgnored = !1;
  }
  ignoreMatch() {
    this.isMatchIgnored = !0;
  }
}
function Oc(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function $r(e, ...o) {
  const i = /* @__PURE__ */ Object.create(null);
  for (const l in e)
    i[l] = e[l];
  return o.forEach((l) => {
    for (const n in l)
      i[n] = l[n];
  }), i;
}
const Wf = (e) => !!e.scope;
class Zy {
  constructor(o, i) {
    this.buffer = "", this.classPrefix = i.classPrefix, o.walk(this);
  }
  addText(o) {
    this.buffer += Oc(o);
  }
  openNode(o) {
    if (!Wf(o))
      return;
    const i = ((l, { prefix: n }) => {
      if (l.startsWith("language:"))
        return l.replace("language:", "language-");
      if (l.includes(".")) {
        const u = l.split(".");
        return [`${n}${u.shift()}`, ...u.map((f, p) => `${f}${"_".repeat(p + 1)}`)].join(" ");
      }
      return `${n}${l}`;
    })(o.scope, { prefix: this.classPrefix });
    this.span(i);
  }
  closeNode(o) {
    Wf(o) && (this.buffer += "</span>");
  }
  value() {
    return this.buffer;
  }
  span(o) {
    this.buffer += `<span class="${o}">`;
  }
}
const Gf = (e = {}) => {
  const o = { children: [] };
  return Object.assign(o, e), o;
};
class iu {
  constructor() {
    this.rootNode = Gf(), this.stack = [this.rootNode];
  }
  get top() {
    return this.stack[this.stack.length - 1];
  }
  get root() {
    return this.rootNode;
  }
  add(o) {
    this.top.children.push(o);
  }
  openNode(o) {
    const i = Gf({ scope: o });
    this.add(i), this.stack.push(i);
  }
  closeNode() {
    if (this.stack.length > 1)
      return this.stack.pop();
  }
  closeAllNodes() {
    for (; this.closeNode();)
      ;
  }
  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }
  walk(o) {
    return this.constructor._walk(o, this.rootNode);
  }
  static _walk(o, i) {
    return typeof i == "string" ? o.addText(i) : i.children && (o.openNode(i), i.children.forEach((l) => this._walk(o, l)), o.closeNode(i)), o;
  }
  static _collapse(o) {
    typeof o != "string" && o.children && (o.children.every((i) => typeof i == "string") ? o.children = [o.children.join("")] : o.children.forEach((i) => {
      iu._collapse(i);
    }));
  }
}
class qy extends iu {
  constructor(o) {
    super(), this.options = o;
  }
  addText(o) {
    o !== "" && this.add(o);
  }
  startScope(o) {
    this.openNode(o);
  }
  endScope() {
    this.closeNode();
  }
  __addSublanguage(o, i) {
    const l = o.root;
    i && (l.scope = "language:" + i), this.add(l);
  }
  toHTML() {
    return new Zy(this, this.options).value();
  }
  finalize() {
    return this.closeAllNodes(), !0;
  }
}
function Oo(e) {
  return e ? typeof e == "string" ? e : e.source : null;
}
function Nc(e) {
  return ii("(?=", e, ")");
}
function _y(e) {
  return ii("(?:", e, ")*");
}
function e0(e) {
  return ii("(?:", e, ")?");
}
function ii(...e) {
  return e.map((o) => Oo(o)).join("");
}
function ou(...e) {
  return "(" + (((i) => {
    const l = i[i.length - 1];
    return typeof l == "object" && l.constructor === Object ? (i.splice(i.length - 1, 1), l) : {};
  })(e).capture ? "" : "?:") + e.map((i) => Oo(i)).join("|") + ")";
}
function Lc(e) {
  return RegExp(e.toString() + "|").exec("").length - 1;
}
const t0 = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function Zs(e, { joinWith: o }) {
  let i = 0;
  return e.map((l) => {
    i += 1;
    const n = i;
    let u = Oo(l), f = "";
    for (; u.length > 0;) {
      const p = t0.exec(u);
      if (!p) {
        f += u;
        break;
      }
      f += u.substring(0, p.index), u = u.substring(p.index + p[0].length), p[0][0] === "\\" && p[1] ? f += "\\" + (Number(p[1]) + n) : (f += p[0], p[0] === "(" && i++);
    }
    return f;
  }).map((l) => `(${l})`).join(o);
}
const Yf = "[a-zA-Z]\\w*", ks = "[a-zA-Z_]\\w*", Qf = "\\b\\d+(\\.\\d+)?", Kf = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", Jf = "\\b(0b[01]+)", Ro = {
  begin: "\\\\[\\s\\S]",
  relevance: 0
}, n0 = {
  scope: "string",
  begin: "'",
  end: "'",
  illegal: "\\n",
  contains: [Ro]
}, r0 = {
  scope: "string",
  begin: '"',
  end: '"',
  illegal: "\\n",
  contains: [Ro]
}, Jl = (e, o, i = {}) => {
  const l = $r({
    scope: "comment",
    begin: e,
    end: o,
    contains: []
  }, i);
  l.contains.push({
    scope: "doctag",
    begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
    end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
    excludeBegin: !0,
    relevance: 0
  });
  const n = ou("I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/);
  return l.contains.push({ begin: ii(/[ ]+/, "(", n, /[.]?[:]?([.][ ]|[ ])/, "){3}") }), l;
}, i0 = Jl("//", "$"), o0 = Jl("/\\*", "\\*/"), l0 = Jl("#", "$");
var Rl = Object.freeze({
  __proto__: null,
  APOS_STRING_MODE: n0,
  BACKSLASH_ESCAPE: Ro,
  BINARY_NUMBER_MODE: {
    scope: "number",
    begin: Jf,
    relevance: 0
  },
  BINARY_NUMBER_RE: Jf,
  COMMENT: Jl,
  C_BLOCK_COMMENT_MODE: o0,
  C_LINE_COMMENT_MODE: i0,
  C_NUMBER_MODE: {
    scope: "number",
    begin: Kf,
    relevance: 0
  },
  C_NUMBER_RE: Kf,
  END_SAME_AS_BEGIN: (e) => Object.assign(e, {
    "on:begin": (o, i) => {
      i.data._beginMatch = o[1];
    },
    "on:end": (o, i) => {
      i.data._beginMatch !== o[1] && i.ignoreMatch();
    }
  }),
  HASH_COMMENT_MODE: l0,
  IDENT_RE: Yf,
  MATCH_NOTHING_RE: /\b\B/,
  METHOD_GUARD: { begin: "\\.\\s*" + ks, relevance: 0 },
  NUMBER_MODE: { scope: "number", begin: Qf, relevance: 0 },
  NUMBER_RE: Qf,
  PHRASAL_WORDS_MODE: {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  },
  QUOTE_STRING_MODE: r0,
  REGEXP_MODE: {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [Ro, { begin: /\[/, end: /\]/, relevance: 0, contains: [Ro] }]
  },
  RE_STARTERS_RE: "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~",
  SHEBANG: (e = {}) => {
    const o = /^#![ ]*\//;
    return e.binary && (e.begin = ii(o, /.*\b/, e.binary, /\b.*/)), $r({
      scope: "meta",
      begin: o,
      end: /$/,
      relevance: 0,
      "on:begin": (i, l) => {
        i.index !== 0 && l.ignoreMatch();
      }
    }, e);
  },
  TITLE_MODE: { scope: "title", begin: Yf, relevance: 0 },
  UNDERSCORE_IDENT_RE: ks,
  UNDERSCORE_TITLE_MODE: { scope: "title", begin: ks, relevance: 0 }
});
function a0(e, o) {
  e.input[e.index - 1] === "." && o.ignoreMatch();
}
function s0(e, o) {
  e.className !== void 0 && (e.scope = e.className, delete e.className);
}
function u0(e, o) {
  o && e.beginKeywords && (e.begin = "\\b(" + e.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", e.__beforeBegin = a0, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, e.relevance === void 0 && (e.relevance = 0));
}
function d0(e, o) {
  Array.isArray(e.illegal) && (e.illegal = ou(...e.illegal));
}
function f0(e, o) {
  if (e.match) {
    if (e.begin || e.end)
      throw Error("begin & end are not supported with match");
    e.begin = e.match, delete e.match;
  }
}
function c0(e, o) {
  e.relevance === void 0 && (e.relevance = 1);
}
const p0 = (e, o) => {
  if (!e.beforeMatch)
    return;
  if (e.starts)
    throw Error("beforeMatch cannot be used with starts");
  const i = Object.assign({}, e);
  Object.keys(e).forEach((l) => {
    delete e[l];
  }), e.keywords = i.keywords, e.begin = ii(i.beforeMatch, Nc(i.begin)), e.starts = {
    relevance: 0,
    contains: [Object.assign(i, { endsParent: !0 })]
  }, e.relevance = 0, delete i.beforeMatch;
}, h0 = ["of", "and", "for", "in", "not", "or", "if", "then", "parent", "list", "value"], v0 = "keyword";
function Pc(e, o, i = v0) {
  const l = /* @__PURE__ */ Object.create(null);
  return typeof e == "string" ? n(i, e.split(" ")) : Array.isArray(e) ? n(i, e) : Object.keys(e).forEach((u) => {
    Object.assign(l, Pc(e[u], o, u));
  }), l;
  function n(u, f) {
    o && (f = f.map((p) => p.toLowerCase())), f.forEach((p) => {
      const c = p.split("|");
      l[c[0]] = [u, m0(c[0], c[1])];
    });
  }
}
function m0(e, o) {
  return o ? Number(o) : ((i) => h0.includes(i.toLowerCase()))(e) ? 0 : 1;
}
const Xf = {}, ti = (e) => {
  console.error(e);
}, Zf = (e, ...o) => {
  console.log("WARN: " + e, ...o);
}, Fi = (e, o) => {
  Xf[`${e}/${o}`] || (console.log(`Deprecated as of ${e}. ${o}`), Xf[`${e}/${o}`] = !0);
}, Fl = Error();
function qf(e, o, { key: i }) {
  let l = 0;
  const n = e[i], u = {}, f = {};
  for (let p = 1; p <= o.length; p++)
    f[p + l] = n[p], u[p + l] = !0, l += Lc(o[p - 1]);
  e[i] = f, e[i]._emit = u, e[i]._multi = !0;
}
function g0(e) {
  ((o) => {
    o.scope && typeof o.scope == "object" && o.scope !== null && (o.beginScope = o.scope, delete o.scope);
  })(e), typeof e.beginScope == "string" && (e.beginScope = {
    _wrap: e.beginScope
  }), typeof e.endScope == "string" && (e.endScope = {
    _wrap: e.endScope
  }), ((o) => {
    if (Array.isArray(o.begin)) {
      if (o.skip || o.excludeBegin || o.returnBegin)
        throw ti("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), Fl;
      if (typeof o.beginScope != "object" || o.beginScope === null)
        throw ti("beginScope must be object"), Fl;
      qf(o, o.begin, { key: "beginScope" }), o.begin = Zs(o.begin, { joinWith: "" });
    }
  })(e), ((o) => {
    if (Array.isArray(o.end)) {
      if (o.skip || o.excludeEnd || o.returnEnd)
        throw ti("skip, excludeEnd, returnEnd not compatible with endScope: {}"), Fl;
      if (typeof o.endScope != "object" || o.endScope === null)
        throw ti("endScope must be object"), Fl;
      qf(o, o.end, { key: "endScope" }), o.end = Zs(o.end, { joinWith: "" });
    }
  })(e);
}
function y0(e) {
  function o(n, u) {
    return RegExp(Oo(n), "m" + (e.case_insensitive ? "i" : "") + (e.unicodeRegex ? "u" : "") + (u ? "g" : ""));
  }
  class i {
    constructor() {
      this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
    }
    addRule(u, f) {
      f.position = this.position++, this.matchIndexes[this.matchAt] = f, this.regexes.push([f, u]), this.matchAt += Lc(u) + 1;
    }
    compile() {
      this.regexes.length === 0 && (this.exec = () => null);
      const u = this.regexes.map((f) => f[1]);
      this.matcherRe = o(Zs(u, {
        joinWith: "|"
      }), !0), this.lastIndex = 0;
    }
    exec(u) {
      this.matcherRe.lastIndex = this.lastIndex;
      const f = this.matcherRe.exec(u);
      if (!f)
        return null;
      const p = f.findIndex((v, b) => b > 0 && v !== void 0), c = this.matchIndexes[p];
      return f.splice(0, p), Object.assign(f, c);
    }
  }
  class l {
    constructor() {
      this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
    }
    getMatcher(u) {
      if (this.multiRegexes[u])
        return this.multiRegexes[u];
      const f = new i();
      return this.rules.slice(u).forEach(([p, c]) => f.addRule(p, c)), f.compile(), this.multiRegexes[u] = f, f;
    }
    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }
    considerAll() {
      this.regexIndex = 0;
    }
    addRule(u, f) {
      this.rules.push([u, f]), f.type === "begin" && this.count++;
    }
    exec(u) {
      const f = this.getMatcher(this.regexIndex);
      f.lastIndex = this.lastIndex;
      let p = f.exec(u);
      if (this.resumingScanAtSamePosition() && !(p && p.index === this.lastIndex)) {
        const c = this.getMatcher(0);
        c.lastIndex = this.lastIndex + 1, p = c.exec(u);
      }
      return p && (this.regexIndex += p.position + 1, this.regexIndex === this.count && this.considerAll()), p;
    }
  }
  if (e.compilerExtensions || (e.compilerExtensions = []), e.contains && e.contains.includes("self"))
    throw Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  return e.classNameAliases = $r(e.classNameAliases || {}), function n(u, f) {
    const p = u;
    if (u.isCompiled)
      return p;
    [s0, f0, g0, p0].forEach((v) => v(u, f)), e.compilerExtensions.forEach((v) => v(u, f)), u.__beforeBegin = null, [u0, d0, c0].forEach((v) => v(u, f)), u.isCompiled = !0;
    let c = null;
    return typeof u.keywords == "object" && u.keywords.$pattern && (u.keywords = Object.assign({}, u.keywords), c = u.keywords.$pattern, delete u.keywords.$pattern), c = c || /\w+/, u.keywords && (u.keywords = Pc(u.keywords, e.case_insensitive)), p.keywordPatternRe = o(c, !0), f && (u.begin || (u.begin = /\B|\b/), p.beginRe = o(p.begin), u.end || u.endsWithParent || (u.end = /\B|\b/), u.end && (p.endRe = o(p.end)), p.terminatorEnd = Oo(p.end) || "", u.endsWithParent && f.terminatorEnd && (p.terminatorEnd += (u.end ? "|" : "") + f.terminatorEnd)), u.illegal && (p.illegalRe = o(u.illegal)), u.contains || (u.contains = []), u.contains = [].concat(...u.contains.map((v) => ((b) => (b.variants && !b.cachedVariants && (b.cachedVariants = b.variants.map((y) => $r(b, {
      variants: null
    }, y))), b.cachedVariants ? b.cachedVariants : $c(b) ? $r(b, {
      starts: b.starts ? $r(b.starts) : null
    }) : Object.isFrozen(b) ? $r(b) : b))(v === "self" ? u : v))), u.contains.forEach((v) => {
      n(v, p);
    }), u.starts && n(u.starts, f), p.matcher = ((v) => {
      const b = new l();
      return v.contains.forEach((y) => b.addRule(y.begin, {
        rule: y,
        type: "begin"
      })), v.terminatorEnd && b.addRule(v.terminatorEnd, {
        type: "end"
      }), v.illegal && b.addRule(v.illegal, { type: "illegal" }), b;
    })(p), p;
  }(e);
}
function $c(e) {
  return !!e && (e.endsWithParent || $c(e.starts));
}
class b0 extends Error {
  constructor(o, i) {
    super(o), this.name = "HTMLInjectionError", this.html = i;
  }
}
const Hs = Oc, _f = $r, ec = Symbol("nomatch"), Bc = (e) => {
  const o = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), l = [];
  let n = !0;
  const u = "Could not find the language '{}', did you forget to load/include a language module?", f = {
    disableAutodetect: !0,
    name: "Plain text",
    contains: []
  };
  let p = {
    ignoreUnescapedHTML: !1,
    throwUnescapedHTML: !1,
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: "hljs-",
    cssSelector: "pre code",
    languages: null,
    __emitter: qy
  };
  function c(S) {
    return p.noHighlightRe.test(S);
  }
  function v(S, x, R) {
    let N = "", T = "";
    typeof x == "object" ? (N = S, R = x.ignoreIllegals, T = x.language) : (Fi("10.7.0", "highlight(lang, code, ...args) has been deprecated."), Fi("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), T = S, N = x), R === void 0 && (R = !0);
    const H = { code: N, language: T };
    g("before:highlight", H);
    const B = H.result ? H.result : b(H.language, H.code, R);
    return B.code = H.code, g("after:highlight", B), B;
  }
  function b(S, x, R, N) {
    const T = /* @__PURE__ */ Object.create(null);
    function H() {
      if (!q.keywords)
        return void be.addText(me);
      let se = 0;
      q.keywordPatternRe.lastIndex = 0;
      let Ae = q.keywordPatternRe.exec(me), Ee = "";
      for (; Ae;) {
        Ee += me.substring(se, Ae.index);
        const _e = Q.case_insensitive ? Ae[0].toLowerCase() : Ae[0], at = (Ne = _e, q.keywords[Ne]);
        if (at) {
          const [it, St] = at;
          if (be.addText(Ee), Ee = "", T[_e] = (T[_e] || 0) + 1, T[_e] <= 7 && (ae += St), it.startsWith("_"))
            Ee += Ae[0];
          else {
            const Et = Q.classNameAliases[it] || it;
            L(Ae[0], Et);
          }
        } else
          Ee += Ae[0];
        se = q.keywordPatternRe.lastIndex, Ae = q.keywordPatternRe.exec(me);
      }
      var Ne;
      Ee += me.substring(se), be.addText(Ee);
    }
    function B() {
      q.subLanguage != null ? (() => {
        if (me === "")
          return;
        let se = null;
        if (typeof q.subLanguage == "string") {
          if (!o[q.subLanguage])
            return void be.addText(me);
          se = b(q.subLanguage, me, !0, ge[q.subLanguage]), ge[q.subLanguage] = se._top;
        } else
          se = y(me, q.subLanguage.length ? q.subLanguage : null);
        q.relevance > 0 && (ae += se.relevance), be.__addSublanguage(se._emitter, se.language);
      })() : H(), me = "";
    }
    function L(se, Ae) {
      se !== "" && (be.startScope(Ae), be.addText(se), be.endScope());
    }
    function P(se, Ae) {
      let Ee = 1;
      const Ne = Ae.length - 1;
      for (; Ee <= Ne;) {
        if (!se._emit[Ee]) {
          Ee++;
          continue;
        }
        const _e = Q.classNameAliases[se[Ee]] || se[Ee], at = Ae[Ee];
        _e ? L(at, _e) : (me = at, H(), me = ""), Ee++;
      }
    }
    function C(se, Ae) {
      return se.scope && typeof se.scope == "string" && be.openNode(Q.classNameAliases[se.scope] || se.scope), se.beginScope && (se.beginScope._wrap ? (L(me, Q.classNameAliases[se.beginScope._wrap] || se.beginScope._wrap), me = "") : se.beginScope._multi && (P(se.beginScope, Ae), me = "")), q = Object.create(se, {
        parent: {
          value: q
        }
      }), q;
    }
    function M(se, Ae, Ee) {
      let Ne = ((_e, at) => {
        const it = _e && _e.exec(at);
        return it && it.index === 0;
      })(se.endRe, Ee);
      if (Ne) {
        if (se["on:end"]) {
          const _e = new zf(se);
          se["on:end"](Ae, _e), _e.isMatchIgnored && (Ne = !1);
        }
        if (Ne) {
          for (; se.endsParent && se.parent;)
            se = se.parent;
          return se;
        }
      }
      if (se.endsWithParent)
        return M(se.parent, Ae, Ee);
    }
    function k(se) {
      return q.matcher.regexIndex === 0 ? (me += se[0], 1) : (he = !0, 0);
    }
    function F(se) {
      const Ae = se[0], Ee = x.substring(se.index), Ne = M(q, se, Ee);
      if (!Ne)
        return ec;
      const _e = q;
      q.endScope && q.endScope._wrap ? (B(), L(Ae, q.endScope._wrap)) : q.endScope && q.endScope._multi ? (B(), P(q.endScope, se)) : _e.skip ? me += Ae : (_e.returnEnd || _e.excludeEnd || (me += Ae), B(), _e.excludeEnd && (me = Ae));
      do
        q.scope && be.closeNode(), q.skip || q.subLanguage || (ae += q.relevance), q = q.parent;
      while (q !== Ne.parent);
      return Ne.starts && C(Ne.starts, se), _e.returnEnd ? 0 : Ae.length;
    }
    let j = {};
    function W(se, Ae) {
      const Ee = Ae && Ae[0];
      if (me += se, Ee == null)
        return B(), 0;
      if (j.type === "begin" && Ae.type === "end" && j.index === Ae.index && Ee === "") {
        if (me += x.slice(Ae.index, Ae.index + 1), !n) {
          const Ne = Error(`0 width match regex (${S})`);
          throw Ne.languageName = S, Ne.badRule = j.rule, Ne;
        }
        return 1;
      }
      if (j = Ae, Ae.type === "begin")
        return ((Ne) => {
          const _e = Ne[0], at = Ne.rule, it = new zf(at), St = [at.__beforeBegin, at["on:begin"]];
          for (const Et of St)
            if (Et && (Et(Ne, it), it.isMatchIgnored))
              return k(_e);
          return at.skip ? me += _e : (at.excludeBegin && (me += _e), B(), at.returnBegin || at.excludeBegin || (me = _e)), C(at, Ne), at.returnBegin ? 0 : _e.length;
        })(Ae);
      if (Ae.type === "illegal" && !R) {
        const Ne = Error('Illegal lexeme "' + Ee + '" for mode "' + (q.scope || "<unnamed>") + '"');
        throw Ne.mode = q, Ne;
      }
      if (Ae.type === "end") {
        const Ne = F(Ae);
        if (Ne !== ec)
          return Ne;
      }
      if (Ae.type === "illegal" && Ee === "")
        return 1;
      if (ue > 1e5 && ue > 3 * Ae.index)
        throw Error("potential infinite loop, way more iterations than matches");
      return me += Ee, Ee.length;
    }
    const Q = m(S);
    if (!Q)
      throw ti(u.replace("{}", S)), Error('Unknown language: "' + S + '"');
    const ne = y0(Q);
    let te = "", q = N || ne;
    const ge = {}, be = new p.__emitter(p);
    (() => {
      const se = [];
      for (let Ae = q; Ae !== Q; Ae = Ae.parent)
        Ae.scope && se.unshift(Ae.scope);
      se.forEach((Ae) => be.openNode(Ae));
    })();
    let me = "", ae = 0, le = 0, ue = 0, he = !1;
    try {
      if (Q.__emitTokens)
        Q.__emitTokens(x, be);
      else {
        for (q.matcher.considerAll(); ;) {
          ue++, he ? he = !1 : q.matcher.considerAll(), q.matcher.lastIndex = le;
          const se = q.matcher.exec(x);
          if (!se)
            break;
          const Ae = W(x.substring(le, se.index), se);
          le = se.index + Ae;
        }
        W(x.substring(le));
      }
      return be.finalize(), te = be.toHTML(), {
        language: S,
        value: te,
        relevance: ae,
        illegal: !1,
        _emitter: be,
        _top: q
      };
    } catch (se) {
      if (se.message && se.message.includes("Illegal"))
        return {
          language: S,
          value: Hs(x),
          illegal: !0,
          relevance: 0,
          _illegalBy: {
            message: se.message,
            index: le,
            context: x.slice(le - 100, le + 100),
            mode: se.mode,
            resultSoFar: te
          },
          _emitter: be
        };
      if (n)
        return {
          language: S,
          value: Hs(x),
          illegal: !1,
          relevance: 0,
          errorRaised: se,
          _emitter: be,
          _top: q
        };
      throw se;
    }
  }
  function y(S, x) {
    x = x || p.languages || Object.keys(o);
    const R = ((P) => {
      const C = { value: Hs(P), illegal: !1, relevance: 0, _top: f, _emitter: new p.__emitter(p) };
      return C._emitter.addText(P), C;
    })(S), N = x.filter(m).filter(D).map((P) => b(P, S, !1));
    N.unshift(R);
    const T = N.sort((P, C) => {
      if (P.relevance !== C.relevance)
        return C.relevance - P.relevance;
      if (P.language && C.language) {
        if (m(P.language).supersetOf === C.language)
          return 1;
        if (m(C.language).supersetOf === P.language)
          return -1;
      }
      return 0;
    }), [H, B] = T, L = H;
    return L.secondBest = B, L;
  }
  function E(S) {
    let x = null;
    const R = ((H) => {
      let B = H.className + " ";
      B += H.parentNode ? H.parentNode.className : "";
      const L = p.languageDetectRe.exec(B);
      if (L) {
        const P = m(L[1]);
        return P || (Zf(u.replace("{}", L[1])), Zf("Falling back to no-highlight mode for this block.", H)), P ? L[1] : "no-highlight";
      }
      return B.split(/\s+/).find((P) => c(P) || m(P));
    })(S);
    if (c(R))
      return;
    if (g("before:highlightElement", {
      el: S,
      language: R
    }), S.dataset.highlighted)
      return console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", S);
    if (S.children.length > 0 && (p.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(S)), p.throwUnescapedHTML))
      throw new b0("One of your code blocks includes unescaped HTML.", S.innerHTML);
    x = S;
    const N = x.textContent, T = R ? v(N, { language: R, ignoreIllegals: !0 }) : y(N);
    S.innerHTML = T.value, S.dataset.highlighted = "yes", ((H, B, L) => {
      const P = B && i[B] || L;
      H.classList.add("hljs"), H.classList.add("language-" + P);
    })(S, R, T.language), S.result = {
      language: T.language,
      re: T.relevance,
      relevance: T.relevance
    }, T.secondBest && (S.secondBest = {
      language: T.secondBest.language,
      relevance: T.secondBest.relevance
    }), g("after:highlightElement", { el: S, result: T, text: N });
  }
  let w = !1;
  function h() {
    document.readyState !== "loading" ? document.querySelectorAll(p.cssSelector).forEach(E) : w = !0;
  }
  function m(S) {
    return S = (S || "").toLowerCase(), o[S] || o[i[S]];
  }
  function I(S, { languageName: x }) {
    typeof S == "string" && (S = [S]), S.forEach((R) => {
      i[R.toLowerCase()] = x;
    });
  }
  function D(S) {
    const x = m(S);
    return x && !x.disableAutodetect;
  }
  function g(S, x) {
    const R = S;
    l.forEach((N) => {
      N[R] && N[R](x);
    });
  }
  typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", () => {
    w && h();
  }, !1), Object.assign(e, {
    highlight: v,
    highlightAuto: y,
    highlightAll: h,
    highlightElement: E,
    highlightBlock: (S) => (Fi("10.7.0", "highlightBlock will be removed entirely in v12.0"), Fi("10.7.0", "Please use highlightElement now."), E(S)),
    configure: (S) => {
      p = _f(p, S);
    },
    initHighlighting: () => {
      h(), Fi("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    },
    initHighlightingOnLoad: () => {
      h(), Fi("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    },
    registerLanguage: (S, x) => {
      let R = null;
      try {
        R = x(e);
      } catch (N) {
        if (ti("Language definition for '{}' could not be registered.".replace("{}", S)), !n)
          throw N;
        ti(N), R = f;
      }
      R.name || (R.name = S), o[S] = R, R.rawDefinition = x.bind(null, e), R.aliases && I(R.aliases, {
        languageName: S
      });
    },
    unregisterLanguage: (S) => {
      delete o[S];
      for (const x of Object.keys(i))
        i[x] === S && delete i[x];
    },
    listLanguages: () => Object.keys(o),
    getLanguage: m,
    registerAliases: I,
    autoDetection: D,
    inherit: _f,
    addPlugin: (S) => {
      ((x) => {
        x["before:highlightBlock"] && !x["before:highlightElement"] && (x["before:highlightElement"] = (R) => {
          x["before:highlightBlock"](Object.assign({ block: R.el }, R));
        }), x["after:highlightBlock"] && !x["after:highlightElement"] && (x["after:highlightElement"] = (R) => {
          x["after:highlightBlock"](Object.assign({ block: R.el }, R));
        });
      })(S), l.push(S);
    },
    removePlugin: (S) => {
      const x = l.indexOf(S);
      x !== -1 && l.splice(x, 1);
    }
  }), e.debugMode = () => {
    n = !1;
  }, e.safeMode = () => {
    n = !0;
  }, e.versionString = "11.9.0", e.regex = {
    concat: ii,
    lookahead: Nc,
    either: ou,
    optional: e0,
    anyNumberOfTimes: _y
  };
  for (const S in Rl)
    typeof Rl[S] == "object" && Mc(Rl[S]);
  return Object.assign(e, Rl), e;
}, Xl = Bc({});
Xl.newInstance = () => Bc({});
/*! `xml` grammar compiled for Highlight.js 11.9.0 */
var A0 = (() => (e) => {
  const o = e.regex, i = o.concat(/[\p{L}_]/u, o.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), l = {
    className: "symbol",
    begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
  }, n = {
    begin: /\s/,
    contains: [{ className: "keyword", begin: /#?[a-z_][a-z1-9_-]+/, illegal: /\n/ }]
  }, u = e.inherit(n, { begin: /\(/, end: /\)/ }), f = e.inherit(e.APOS_STRING_MODE, {
    className: "string"
  }), p = e.inherit(e.QUOTE_STRING_MODE, { className: "string" }), c = {
    endsWithParent: !0,
    illegal: /</,
    relevance: 0,
    contains: [{
      className: "attr",
      begin: /[\p{L}0-9._:-]+/u,
      relevance: 0
    }, {
      begin: /=\s*/, relevance: 0, contains: [{
        className: "string",
        endsParent: !0,
        variants: [{ begin: /"/, end: /"/, contains: [l] }, {
          begin: /'/,
          end: /'/,
          contains: [l]
        }, { begin: /[^\s"'=<>`]+/ }]
      }]
    }]
  };
  return {
    name: "HTML, XML",
    aliases: ["html", "xhtml", "rss", "atom", "xjb", "xsd", "xsl", "plist", "wsf", "svg"],
    case_insensitive: !0,
    unicodeRegex: !0,
    contains: [{
      className: "meta",
      begin: /<![a-z]/,
      end: />/,
      relevance: 10,
      contains: [n, p, f, u, {
        begin: /\[/, end: /\]/, contains: [{
          className: "meta",
          begin: /<![a-z]/,
          end: />/,
          contains: [n, u, p, f]
        }]
      }]
    }, e.COMMENT(/<!--/, /-->/, { relevance: 10 }), {
      begin: /<!\[CDATA\[/,
      end: /\]\]>/,
      relevance: 10
    }, l, {
      className: "meta", end: /\?>/, variants: [{
        begin: /<\?xml/,
        relevance: 10,
        contains: [p]
      }, { begin: /<\?[a-z][a-z0-9]+/ }]
    }, {
      className: "tag",
      begin: /<style(?=\s|>)/,
      end: />/,
      keywords: { name: "style" },
      contains: [c],
      starts: {
        end: /<\/style>/,
        returnEnd: !0,
        subLanguage: ["css", "xml"]
      }
    }, {
      className: "tag",
      begin: /<script(?=\s|>)/,
      end: />/,
      keywords: { name: "script" },
      contains: [c],
      starts: {
        end: /<\/script>/,
        returnEnd: !0,
        subLanguage: ["javascript", "handlebars", "xml"]
      }
    }, {
      className: "tag",
      begin: /<>|<\/>/
    }, {
      className: "tag",
      begin: o.concat(/</, o.lookahead(o.concat(i, o.either(/\/>/, />/, /\s/)))),
      end: /\/?>/,
      contains: [{ className: "name", begin: i, relevance: 0, starts: c }]
    }, {
      className: "tag",
      begin: o.concat(/<\//, o.lookahead(o.concat(i, />/))),
      contains: [{
        className: "name",
        begin: i,
        relevance: 0
      }, { begin: />/, relevance: 0, endsParent: !0 }]
    }]
  };
})();
/*! `javascript` grammar compiled for Highlight.js 11.9.0 */
var C0 = (() => {
  const e = "[A-Za-z$_][0-9A-Za-z$_]*", o = ["as", "in", "of", "if", "for", "while", "finally", "var", "new", "function", "do", "return", "void", "else", "break", "catch", "instanceof", "with", "throw", "case", "default", "try", "switch", "continue", "typeof", "delete", "let", "yield", "const", "class", "debugger", "async", "await", "static", "import", "from", "export", "extends"], i = ["true", "false", "null", "undefined", "NaN", "Infinity"], l = ["Object", "Function", "Boolean", "Symbol", "Math", "Date", "Number", "BigInt", "String", "RegExp", "Array", "Float32Array", "Float64Array", "Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Int32Array", "Uint16Array", "Uint32Array", "BigInt64Array", "BigUint64Array", "Set", "Map", "WeakSet", "WeakMap", "ArrayBuffer", "SharedArrayBuffer", "Atomics", "DataView", "JSON", "Promise", "Generator", "GeneratorFunction", "AsyncFunction", "Reflect", "Proxy", "Intl", "WebAssembly"], n = ["Error", "EvalError", "InternalError", "RangeError", "ReferenceError", "SyntaxError", "TypeError", "URIError"], u = ["setInterval", "setTimeout", "clearInterval", "clearTimeout", "require", "exports", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "unescape"], f = ["arguments", "this", "super", "console", "window", "document", "localStorage", "sessionStorage", "module", "global"], p = [].concat(u, l, n);
  return (c) => {
    const v = c.regex, b = e, y = {
      begin: /<[A-Za-z0-9\\._:-]+/,
      end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
      isTrulyOpeningTag: (te, q) => {
        const ge = te[0].length + te.index, be = te.input[ge];
        if (be === "<" || be === ",")
          return void q.ignoreMatch();
        let me;
        be === ">" && (((le, { after: ue }) => {
          const he = "</" + le[0].slice(1);
          return le.input.indexOf(he, ue) !== -1;
        })(te, { after: ge }) || q.ignoreMatch());
        const ae = te.input.substring(ge);
        ((me = ae.match(/^\s*=/)) || (me = ae.match(/^\s+extends\s+/)) && me.index === 0) && q.ignoreMatch();
      }
    }, E = {
      $pattern: e,
      keyword: o,
      literal: i,
      built_in: p,
      "variable.language": f
    }, w = "[0-9](_?[0-9])*", h = `\\.(${w})`, m = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", I = {
      className: "number",
      variants: [{
        begin: `(\\b(${m})((${h})|\\.)?|(${h}))[eE][+-]?(${w})\\b`
      }, {
        begin: `\\b(${m})\\b((${h})\\b|\\.)?|(${h})\\b`
      }, {
        begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
      }, {
        begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
      }, {
        begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
      }, { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" }, {
        begin: "\\b0[0-7]+n?\\b"
      }],
      relevance: 0
    }, D = {
      className: "subst",
      begin: "\\$\\{",
      end: "\\}",
      keywords: E,
      contains: []
    }, g = {
      begin: "html`", end: "", starts: {
        end: "`",
        returnEnd: !1,
        contains: [c.BACKSLASH_ESCAPE, D],
        subLanguage: "xml"
      }
    }, S = {
      begin: "css`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [c.BACKSLASH_ESCAPE, D],
        subLanguage: "css"
      }
    }, x = {
      begin: "gql`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [c.BACKSLASH_ESCAPE, D],
        subLanguage: "graphql"
      }
    }, R = {
      className: "string",
      begin: "`",
      end: "`",
      contains: [c.BACKSLASH_ESCAPE, D]
    }, N = {
      className: "comment",
      variants: [c.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
        relevance: 0,
        contains: [{
          begin: "(?=@[A-Za-z]+)",
          relevance: 0,
          contains: [{
            className: "doctag",
            begin: "@[A-Za-z]+"
          }, {
            className: "type",
            begin: "\\{",
            end: "\\}",
            excludeEnd: !0,
            excludeBegin: !0,
            relevance: 0
          }, {
            className: "variable",
            begin: b + "(?=\\s*(-)|$)",
            endsParent: !0,
            relevance: 0
          }, { begin: /(?=[^\n])\s/, relevance: 0 }]
        }]
      }), c.C_BLOCK_COMMENT_MODE, c.C_LINE_COMMENT_MODE]
    }, T = [c.APOS_STRING_MODE, c.QUOTE_STRING_MODE, g, S, x, R, { match: /\$\d+/ }, I];
    D.contains = T.concat({
      begin: /\{/,
      end: /\}/,
      keywords: E,
      contains: ["self"].concat(T)
    });
    const H = [].concat(N, D.contains), B = H.concat([{
      begin: /\(/,
      end: /\)/,
      keywords: E,
      contains: ["self"].concat(H)
    }]), L = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      keywords: E,
      contains: B
    }, P = {
      variants: [{
        match: [/class/, /\s+/, b, /\s+/, /extends/, /\s+/, v.concat(b, "(", v.concat(/\./, b), ")*")],
        scope: { 1: "keyword", 3: "title.class", 5: "keyword", 7: "title.class.inherited" }
      }, {
        match: [/class/, /\s+/, b],
        scope: { 1: "keyword", 3: "title.class" }
      }]
    }, C = {
      relevance: 0,
      match: v.either(/\bJSON/, /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
      className: "title.class",
      keywords: { _: [...l, ...n] }
    }, M = {
      variants: [{
        match: [/function/, /\s+/, b, /(?=\s*\()/]
      }, { match: [/function/, /\s*(?=\()/] }],
      className: { 1: "keyword", 3: "title.function" },
      label: "func.def",
      contains: [L],
      illegal: /%/
    }, k = {
      match: v.concat(/\b/, (F = [...u, "super", "import"], v.concat("(?!", F.join("|"), ")")), b, v.lookahead(/\(/)),
      className: "title.function",
      relevance: 0
    };
    var F;
    const j = {
      begin: v.concat(/\./, v.lookahead(v.concat(b, /(?![0-9A-Za-z$_(])/))),
      end: b,
      excludeBegin: !0,
      keywords: "prototype",
      className: "property",
      relevance: 0
    }, W = {
      match: [/get|set/, /\s+/, b, /(?=\()/],
      className: { 1: "keyword", 3: "title.function" },
      contains: [{ begin: /\(\)/ }, L]
    }, Q = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + c.UNDERSCORE_IDENT_RE + ")\\s*=>", ne = {
      match: [/const|var|let/, /\s+/, b, /\s*/, /=\s*/, /(async\s*)?/, v.lookahead(Q)],
      keywords: "async",
      className: { 1: "keyword", 3: "title.function" },
      contains: [L]
    };
    return {
      name: "JavaScript",
      aliases: ["js", "jsx", "mjs", "cjs"],
      keywords: E,
      exports: {
        PARAMS_CONTAINS: B,
        CLASS_REFERENCE: C
      },
      illegal: /#(?![$_A-z])/,
      contains: [c.SHEBANG({ label: "shebang", binary: "node", relevance: 5 }), {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
      }, c.APOS_STRING_MODE, c.QUOTE_STRING_MODE, g, S, x, R, N, { match: /\$\d+/ }, I, C, {
        className: "attr",
        begin: b + v.lookahead(":"),
        relevance: 0
      }, ne, {
        begin: "(" + c.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        relevance: 0,
        contains: [N, c.REGEXP_MODE, {
          className: "function",
          begin: Q,
          returnBegin: !0,
          end: "\\s*=>",
          contains: [{
            className: "params",
            variants: [{ begin: c.UNDERSCORE_IDENT_RE, relevance: 0 }, {
              className: null,
              begin: /\(\s*\)/,
              skip: !0
            }, {
              begin: /\(/,
              end: /\)/,
              excludeBegin: !0,
              excludeEnd: !0,
              keywords: E,
              contains: B
            }]
          }]
        }, { begin: /,/, relevance: 0 }, {
            match: /\s+/,
            relevance: 0
          }, {
            variants: [{ begin: "<>", end: "</>" }, {
              match: /<[A-Za-z0-9\\._:-]+\s*\/>/
            }, {
              begin: y.begin,
              "on:begin": y.isTrulyOpeningTag,
              end: y.end
            }], subLanguage: "xml", contains: [{
              begin: y.begin,
              end: y.end,
              skip: !0,
              contains: ["self"]
            }]
          }]
      }, M, {
        beginKeywords: "while if switch catch for"
      }, {
        begin: "\\b(?!function)" + c.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        returnBegin: !0,
        label: "func.def",
        contains: [L, c.inherit(c.TITLE_MODE, {
          begin: b,
          className: "title.function"
        })]
      }, { match: /\.\.\./, relevance: 0 }, j, {
        match: "\\$" + b,
        relevance: 0
      }, {
        match: [/\bconstructor(?=\s*\()/],
        className: { 1: "title.function" },
        contains: [L]
      }, k, {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
      }, P, W, { match: /\$[(.]/ }]
    };
  };
})();
Xl.registerLanguage("javascript", C0);
Xl.registerLanguage("xml", A0);
const S0 = et({
  name: "FcDesigner",
  components: {
    draggable: ru,
    DragForm: Ze.$form(),
    ViewForm: Kl.$form(),
    EventConfig: Fc
  },
  props: {
    menu: Array,
    height: [String, Number],
    config: {
      type: Object,
      default: () => ({})
    },
    mask: {
      type: Boolean,
      default: void 0
    },
    locale: Object,
    handle: Array
  },
  emits: ["active", "create", "copy", "delete", "drag", "inputData", "save"],
  setup(e) {
    const { menu: o, height: i, mask: l, locale: n, handle: u } = af(e), f = Qh(), p = ni({ active: null });
    sf("fcx", p), sf("designer", f);
    const c = vo(e, "config", {}), v = vo(c.value, "baseRule", null), b = vo(c.value, "componentRule", {}), y = vo(c.value, "validateRule", null), E = vo(c.value, "formRule", null), w = Vn(() => {
      const C = i.value;
      return C ? st.Number(C) ? `${C}px` : C : "100%";
    }), h = Vn(() => c.value.fieldReadonly !== !1), m = Vn(() => c.value.fieldList || []), I = Vn(() => c.value.hiddenMenu || []), D = Vn(() => c.value.hiddenItem || []), g = Vn(() => c.value.hiddenDragMenu === !0), S = Vn(() => c.value.hiddenDragBtn === !0);
    let x = Xs;
    n.value && (x = Us(n).t);
    const R = (...C) => x(...C), N = (C, M, ...k) => {
      if (M) {
        if (st.Function(M))
          return M(...k);
        if (M.rule) {
          let F = M.rule(...k);
          return M.append && (F = [...F, ...C(...k)]), F;
        }
      }
      return C(...k);
    }, T = ni({
      cacheProps: {},
      operation: {
        idx: -1,
        list: []
      },
      moveRule: null,
      addRule: null,
      added: null,
      bus: pv(),
      device: "pc",
      activeTab: "form",
      activeMenuTab: "menu",
      activeRule: null,
      children: So([]),
      treeInfo: [],
      menuList: o.value || Cy(),
      dragRuleList: {},
      eventShow: !1,
      previewStatus: "form",
      t: R,
      preview: {
        state: !1,
        rule: [],
        option: {},
        api: {}
      },
      inputForm: {
        state: !1,
        rule: [],
        option: {},
        api: {},
        data: {},
        key: ""
      },
      dragForm: So({
        rule: [],
        api: {}
      }),
      formOptions: {},
      oldOptionsKeys: [],
      form: {
        rule: N(yf, E.value, { t: R }),
        api: {},
        option: {
          form: {
            labelPosition: "top",
            size: "small"
          },
          submitBtn: !1
        },
        value: {
          form: {},
          submitBtn: !1
        }
      },
      baseForm: {
        isShow: !1,
        rule: N(yo, v.value, { t: R }),
        api: {},
        value: {},
        options: {
          global: {
            input: {
              modelEmit: "blur"
            }
          },
          form: {
            labelPosition: "top",
            size: "small"
          },
          submitBtn: !1,
          mounted: (C) => {
            C.activeRule = T.activeRule, C.setValue(C.options.formData || {});
          }
        }
      },
      advancedForm: {
        isShow: !1,
        rule: Af({ t: R }),
        api: {},
        value: {},
        options: {
          global: {
            input: {
              modelEmit: "blur"
            }
          },
          form: {
            labelPosition: "top",
            size: "small"
          },
          submitBtn: !1,
          mounted: (C) => {
            C.activeRule = T.activeRule, C.setValue(C.options.formData || {});
          }
        }
      },
      styleForm: {
        isShow: !1,
        rule: bf({ t: R }),
        api: {},
        value: {},
        options: {
          form: {
            labelPosition: "left",
            size: "small"
          },
          submitBtn: !1,
          mounted: (C) => {
            C.activeRule = T.activeRule, C.setValue(C.options.formData || {});
          }
        }
      },
      validateForm: {
        isShow: !1,
        rule: N(Cf, y.value, { t: R }),
        api: {},
        value: [],
        options: {
          global: {
            input: {
              modelEmit: "blur"
            }
          },
          form: {
            labelPosition: "top",
            size: "small"
          },
          submitBtn: !1,
          mounted: (C) => {
            C.activeRule = T.activeRule, C.setValue(C.options.formData || {});
          }
        }
      },
      propsForm: {
        isShow: !1,
        rule: [],
        api: {},
        value: {},
        options: {
          global: {
            input: {
              modelEmit: "blur"
            },
            inputNumber: {
              props: {
                controlsPosition: "right"
              }
            }
          },
          form: {
            labelPosition: "top",
            size: "small"
          },
          submitBtn: !1,
          mounted: (C) => {
            C.activeRule = T.activeRule, C.setValue(C.options.formData || {});
          }
        }
      },
      customForm: {
        isShow: !1,
        config: null,
        key: "",
        rule: [],
        api: {},
        options: {
          global: {
            input: {
              modelEmit: "blur"
            }
          },
          form: {
            labelPosition: "top",
            size: "small"
          },
          submitBtn: !1
        }
      }
    });
    gl(() => T.preview.state, function (C) {
      C || cr(() => {
        T.previewStatus = "form", T.preview.rule = T.preview.option = null;
      });
    }), gl(() => T.previewStatus, (C) => {
      T.preview.rule && (T.preview.option.preview = C === "preview");
    });
    let H = null;
    const B = (C, M) => {
      if (C[10] !== ">") {
        if (C = C.replace("formCreate", ""), !C)
          return;
        C = Vs(C);
      } else
        C = C.replace("formCreate>", "");
      const k = C.split(">"), F = k.pop();
      let j = T.activeRule;
      k.forEach((W, Q) => {
        Q || (W = Vs(W)), j[W] || (j[W] = {}), j = j[W];
      }), M({ source: j, field: F });
    };
    gl(() => n.value, (C) => {
      x = C ? Us(n).t : Xs;
      const M = T.form.api.formData && T.form.api.formData(), k = T.baseForm.api.formData && T.baseForm.api.formData(), F = T.validateForm.api.formData && T.validateForm.api.formData();
      T.validateForm.rule = N(Cf, y.value, { t: R }), T.baseForm.rule = N(yo, v.value, { t: R }), T.form.rule = N(yf, E.value, { t: R }), T.styleForm.rule = bf({ t: R }), T.advancedForm.rule = Af({ t: R }), T.cacheProps = {};
      const j = T.activeRule;
      let W = null;
      j && (W = T.propsForm.api.formData && T.propsForm.api.formData(), T.propsForm.rule = T.cacheProps[j._fc_id] = N(j._menu.props, b.value && b.value[j._menu.name], j, {
        t: R,
        api: T.dragForm.api
      })), cr(() => {
        M && T.form.api.setValue(M), k && T.baseForm.api.setValue(k), F && T.validateForm.api.setValue(F), W && T.propsForm.api.setValue(W);
      });
    });
    const L = {
      openGlobalFetchDialog() {
        const C = T.form.api.el("GlobalFetchConfig");
        C && C.open();
      },
      openGlobalClassDialog() {
        const C = T.form.api.el("GlobalClassConfig");
        C && C.open();
      },
      openGlobalEventDialog() {
        const C = T.form.api.el("GlobalEventConfig");
        C && C.open();
      },
      unWatchActiveRule() {
        H && H(), H = null;
      },
      watchActiveRule() {
        L.unWatchActiveRule(), H = gl(() => T.activeRule, function (C) {
          C && L.updateRuleFormData();
        }, { deep: !0, flush: "post" });
      },
      makeChildren(C) {
        return ni({ children: C }).children;
      },
      addMenu(C) {
        if (!C.name || !C.list)
          return;
        let M = !0;
        T.menuList.forEach((k, F) => {
          k.name === C.name && (T.menuList[F] = C, M = !1);
        }), M && T.menuList.push(C);
      },
      setMenuItem(C, M) {
        T.menuList.forEach((k) => {
          k.name === C && (k.list = M);
        });
      },
      appendMenuItem(C, M) {
        T.menuList.forEach((k) => {
          k.name === C && k.list.push(...Array.isArray(M) ? M : [M]);
        });
      },
      removeMenuItem(C) {
        T.menuList.forEach((M) => {
          let k;
          st.String(C) ? [...M.list].forEach((F, j) => {
            F.name === C && M.list.splice(j, 1);
          }) : (k = M.list.indexOf(C)) > -1 && M.list.splice(k, 1);
        });
      },
      addComponent(C) {
        Array.isArray(C) ? C.forEach((M) => {
          T.dragRuleList[M.name] = M, M.menu && L.appendMenuItem(M.menu, M);
        }) : (T.dragRuleList[C.name] = C, C.menu && L.appendMenuItem(C.menu, C));
      },
      openInputData(C) {
        T.inputForm.state = C === void 0 ? !T.inputForm.state : !!C, T.inputForm.state && (T.inputForm.rule = Ze.parseJson(L.getJson()), T.inputForm.option = Ze.parseJson(L.getOptionsJson()), T.inputForm.option.formData = Lt(T.inputForm.data), T.inputForm.option.submitBtn.show = !1, T.inputForm.option.resetBtn.show = !1, L.clearActiveRule());
      },
      inputSave() {
        const C = T.inputForm.api.formData();
        Object.keys(C).forEach((k) => {
          Zn(C[k]) && delete C[k];
        });
        const M = JSON.stringify(T.inputForm.data) !== JSON.stringify(C);
        T.inputForm.data = C, T.inputForm.state = !1, f.emit("inputData", C), M && L.addOperationRecord();
      },
      inputClear() {
        L.inputReset({});
      },
      inputReset(C) {
        T.inputForm.rule = Ze.parseJson(L.getJson()), T.inputForm.option.formData = C || Lt(T.inputForm.data), T.inputForm.key = We();
      },
      setFormData(C) {
        T.inputForm.data = C || {};
      },
      getFormData() {
        return T.inputForm.data;
      },
      getParent(C) {
        let M = C.__fc__.parent.rule;
        const k = M._menu;
        return k && k.inside && (C = M, M = M.__fc__.parent.rule), { root: M, parent: C };
      },
      updateName() {
        this.activeRule.name = "ref_" + We();
      },
      makeDrag(C, M, k, F, j) {
        return {
          type: "DragBox",
          wrap: {
            show: !1
          },
          col: {
            show: !1
          },
          inject: !0,
          props: {
            rule: {
              props: {
                tag: "el-col",
                group: C === !0 ? "default" : C,
                ghostClass: "ghost",
                animation: 150,
                handle: "._fd-drag-btn",
                emptyInsertThreshold: 0,
                direction: "vertical",
                itemKey: "type"
              }
            },
            tag: M
          },
          children: k,
          slot: j,
          on: F
        };
      },
      clearDragRule() {
        L.setRule([]), L.addOperationRecord();
      },
      makeDragRule(C) {
        return L.makeChildren([L.makeDrag(!0, "draggable", C, {
          add: (M, k) => L.dragAdd(C, k),
          end: (M, k) => L.dragEnd(C, k),
          start: (M, k) => L.dragStart(C, k),
          unchoose: (M, k) => L.dragUnchoose(C, k)
        })]);
      },
      handleSave() {
        f.emit("save", {
          rule: L.getJson(),
          options: L.getOptionsJson()
        });
      },
      openPreview() {
        T.preview.state = !0;
        const C = L.getJson(), M = L.getOptionsJson();
        T.preview.rule = Ze.parseJson(C), T.preview.option = Ze.parseJson(M), T.preview.html = Xl.highlight(
          dv(C, M),
          { language: "xml" }
        ).value;
      },
      getRule() {
        return L.parseRule(Lt(T.dragForm.rule[0].children));
      },
      getJson() {
        return Ze.toJson(L.getRule());
      },
      getOption() {
        const C = Lt(T.formOptions);
        Object.keys(C._event || {}).forEach((k) => {
          C._event[k] && (C[k] = C._event[k]);
        }), delete C._event, C.submitBtn = C._submitBtn, C.resetBtn = C._resetBtn, C.resetBtn.innerText = R("props.reset"), C.submitBtn.innerText = R("props.submit");
        const M = Lt(T.inputForm.data);
        return Object.keys(M).length > 0 && (C.formData = M), delete C._submitBtn, delete C._resetBtn, C;
      },
      getOptions() {
        L.getOption();
      },
      getOptionsJson() {
        return Ze.toJson([this.getOption()]).slice(1).slice(0, -1);
      },
      setRule(C) {
        C || (C = []), T.children = So(L.loadRule(st.String(C) ? Ze.parseJson(C) : Lt(C))), L.clearActiveRule(), T.dragForm.rule = L.makeDragRule(L.makeChildren(T.children)), L.updateTree();
      },
      setBaseRuleConfig(C, M) {
        v.value = { rule: C, append: M }, T.baseForm.rule = N(yo, v.value, { t: R });
      },
      setComponentRuleConfig(C, M, k) {
        b.value[C] = { rule: M, append: k }, T.cacheProps = {};
        const F = T.activeRule;
        if (F) {
          const j = T.propsForm.api.formData && T.propsForm.api.formData();
          T.propsForm.rule = T.cacheProps[F._fc_id] = N(F._menu.props, b.value && b.value[F._menu.name], F, {
            t: R,
            api: T.dragForm.api
          }), cr(() => {
            j && T.propsForm.api.setValue(j);
          });
        }
      },
      setValidateRuleConfig(C, M) {
        y.value = { rule: C, append: M }, T.validateForm.rule = N(yo, y.value, { t: R });
      },
      setFormRuleConfig(C, M) {
        E.value = { rule: C, append: M }, T.form.rule = N(yo, E.value, { t: R });
      },
      clearActiveRule() {
        T.activeRule = null, T.customForm.config = null, T.activeTab = "form", p.active = "";
      },
      setOption(C) {
        let M = st.String(C) ? JSON.parse(C) : Lt(C || {});
        M.form = {
          inline: !1,
          hideRequiredAsterisk: !1,
          labelPosition: "right",
          size: "default",
          labelWidth: "125px",
          ...M.form || {}
        }, M._event = {
          onSubmit: M.onSubmit || "",
          onCreated: M.onCreated || "",
          onMounted: M.onMounted || "",
          onChange: M.onChange || ""
        }, Nr(M, "globalEvent") || (M.globalEvent = {}), Nr(M, "globalData") || (M.globalData = {}), M._resetBtn = typeof M.resetBtn == "object" ? M.resetBtn : { show: M.resetBtn === !0 }, M._submitBtn = typeof M.submitBtn == "object" ? M.submitBtn : { show: M.submitBtn !== !1 }, M.submitBtn = M.resetBtn = !1, T.inputForm.data = M.formData || {}, T.oldOptionsKeys = Object.keys(T.form.value), delete M.formData, T.formOptions = M, L.updateOptionsValue();
      },
      setOptions(C) {
        L.setOption(C);
      },
      updateOptionsValue() {
        const C = {};
        T.oldOptionsKeys.forEach((k) => {
          C[k] = void 0;
        });
        const M = { ...C, ...T.formOptions.form };
        Object.keys(T.formOptions).forEach((k) => {
          const F = T.formOptions[k];
          M[">" + k] = F, typeof F == "object" && Object.keys(F).forEach((j) => {
            M[k + ">" + j] = F[j];
          });
        }), T.form.value = M;
      },
      setGlobalEvent(C) {
        T.formOptions.globalEvent = { ...T.formOptions.globalEvent || {}, ...C }, L.updateOptionsValue();
      },
      setGlobalData(C) {
        T.formOptions.globalData = { ...T.formOptions.globalData || {}, ...C }, L.updateOptionsValue();
      },
      setGlobalClass(C) {
        T.formOptions.globalClass = { ...T.formOptions.globalClass || {}, ...C }, L.updateOptionsValue();
      },
      loadRule(C, M, k) {
        const F = [];
        return C.forEach((j) => {
          if (st.String(j))
            return F.push(j);
          let W = T.dragRuleList[j._fc_drag_tag] || T.dragRuleList[j.type];
          if (W || (W = Tg(j), j._fc_drag_tag = "_"), k && (j._fc_template = k), W && W.loadRule && W.loadRule(j), j.children = L.loadRule(j.children || [], W, k), j.control && (j._control = j.control, delete j.control), j.computed && (j._computed = j.computed, delete j.computed), j.on && (j._on = j.on, delete j.on), W) {
            const Q = j.slot;
            let ne;
            M && M.slot && Q && Q !== "default" && (ne = L.getSlotConfig(M, Q, W)), delete j.slot, j = L.makeRule(ne || W, j), Q && (j.slot = Q);
          }
          F.push(j);
        }), F;
      },
      parseRule(C, M) {
        return [...C].reduce((k, F) => {
          let j = M;
          if (st.String(F))
            return k.push(F), k;
          if (F.type === "DragBox")
            return k.push(...L.parseRule(F.children, j || F.slot)), k;
          if (F.type === "DragTool") {
            if (j = F.slot || M, F = F.children[0], st.String(F))
              return k.push(F), k;
            if (F.type === "DragBox")
              return k.push(...L.parseRule(F.children, j || F.slot)), k;
          }
          return F && (F = { ...F }, j && j !== "default" && (F.slot = j), F.children && F.children.length && (F.children = L.parseRule(F.children)), delete F.key, delete F.component, F._menu && (F._menu.parseRule && F._menu.parseRule(F), delete F._menu), F._fc_drag_tag === "_" && delete F._fc_drag_tag, F._control && (F.control = F._control, delete F._control), F._computed && (F.computed = F._computed, delete F._computed), F.slot || delete F.slot, F._on && (F.on = F._on, delete F._on), F.props && Object.keys(F.props).forEach((W) => {
            const Q = F.props[W];
            Zn(Q) && delete F.props[W];
          }), Object.keys(F).filter((W) => W.indexOf("__") === 0 || Array.isArray(F[W]) && F[W].length === 0 || st.Object(F[W]) && Object.keys(F[W]).length === 0).forEach((W) => {
            delete F[W];
          }), k.push(F)), k;
        }, []);
      },
      fields() {
        return T.dragForm.api.all().map((C) => C.field).filter((C) => !!C);
      },
      baseChange(C, M, k, F) {
        L.handleChange("", C, M, k, F);
      },
      formOptChange(C, M) {
        T.form.value[C] = M, C.indexOf(">") === -1 && (C = "form>" + C);
        let k = T.formOptions;
        const F = C.split(">"), j = F.pop();
        F.forEach((W) => {
          W && (k[W] || (k[W] = {}), k = k[W]);
        }), k[j] = M;
      },
      propRemoveField(C, M, k) {
        var F, j, W;
        if (T.activeRule && k[T.activeRule._fc_id] === T.activeRule) {
          L.unWatchActiveRule();
          const Q = C;
          T.dragForm.api.sync(T.activeRule), C.indexOf("__") !== 0 && (C === "formCreateChild" ? delete T.activeRule.children[0] : C.indexOf("formCreate") === 0 || C.indexOf(">") > 0 ? (C.indexOf("formCreate") < 0 && (C = "props>" + C), B(C, ({ source: ne, field: te }) => {
            delete ne[te];
          })) : delete T.activeRule.props[C]), L.watchActiveRule(), (W = (j = (F = T.activeRule._menu) == null ? void 0 : F.watch) == null ? void 0 : j[Q]) == null || W.call(j, {
            field: Q,
            value: void 0,
            api: k,
            rule: T.activeRule,
            ctx: f
          });
        }
      },
      propChange(C, M, k, F) {
        L.handleChange("props", C, M, k, F);
      },
      computedChange(C, M, k, F) {
        L.handleChange("_computed", C, M, k, F);
      },
      styleChange(C, M, k, F) {
        if (T.customForm.config)
          return T.customForm.config.style.change(C, M);
        L.handleChange("", C, M, k, F);
      },
      handleChange(C, M, k, F, j) {
        var W, Q, ne;
        if (T.activeRule && j[T.activeRule._fc_id] === T.activeRule) {
          L.unWatchActiveRule();
          const te = M;
          M.indexOf("__") !== 0 && (M === "formCreateChild" ? T.activeRule.children[0] = k : M.indexOf("formCreate") === 0 || M.indexOf(">") > 0 ? (M.indexOf("formCreate") < 0 && (M = (C ? C + ">" : "") + M), B(M, ({ source: q, field: ge }) => {
            Zn(k) ? delete q[ge] : q[ge] = k;
          })) : C && Zn(k) ? delete T.activeRule[C][M] : (C ? T.activeRule[C] : T.activeRule)[M] = k), L.watchActiveRule(), (ne = (Q = (W = T.activeRule._menu) == null ? void 0 : W.watch) == null ? void 0 : Q[te]) == null || ne.call(Q, {
            field: te,
            value: k,
            api: j,
            rule: T.activeRule,
            ctx: f
          });
        }
      },
      validateChange(C) {
        !T.activeRule || T.validateForm.api[T.activeRule._fc_id] !== T.activeRule || (T.activeRule.validate = C.validate || [], C.required ? T.activeRule.$required = C.required : delete T.activeRule.$required, T.dragForm.api.refreshValidate(), T.dragForm.api.nextTick(() => {
          T.dragForm.api.clearValidateState(T.activeRule.__fc__.id);
        }));
      },
      triggerActive(C) {
        let M;
        if (C._menu.inside ? M = C.children[0] : M = C.__fc__.parent.rule, M && M.type === "DragTool") {
          const k = T.dragForm.api.el(M.__fc__.id);
          k && (p.active = k.id, f.emit("active", C), L.toolActive(C));
        }
      },
      customFormChange(C, M) {
        T.customForm.config && T.customForm.config.change(C, M);
      },
      customActive(C) {
        T.baseForm.isShow = !1, T.propsForm.isShow = !1, T.advancedForm.isShow = !1, T.styleForm.isShow = !!C.style && L.getConfig("showStyleForm") !== !1, T.eventShow = !1, T.validateForm.isShow = !1, T.activeRule = null, T.customForm.config = C, T.customForm.isShow = !0, T.customForm.propsShow = C.props && L.getConfig("showPropsForm") !== !1, T.customForm.key = We(), T.customForm.rule = T.customForm.propsShow ? C.props({ t: R }) : [], T.customForm.options.formData = C.formData, C.style && (T.styleForm.value = C.style.formData || {}), cr(() => {
          T.activeTab = "props";
        });
      },
      toolActive(C) {
        L.unWatchActiveRule(), T.customForm.isShow = !1, T.customForm.config = null, T.activeRule && (delete T.propsForm.api[T.activeRule._fc_id], delete T.baseForm.api[T.activeRule._fc_id], delete T.validateForm.api[T.activeRule._fc_id], delete T.styleForm.api[T.activeRule._fc_id], delete T.advancedForm.api[T.activeRule._fc_id], delete T.dragForm.api.activeRule), T.activeRule = C, T.dragForm.api.activeRule = C, cr(() => {
          T.activeTab = "props", cr(() => {
            T.propsForm.api[T.activeRule._fc_id] = T.activeRule, T.baseForm.api[T.activeRule._fc_id] = T.activeRule, T.validateForm.api[T.activeRule._fc_id] = T.activeRule, T.styleForm.api[T.activeRule._fc_id] = T.activeRule, T.advancedForm.api[T.activeRule._fc_id] = T.activeRule;
          });
        }), T.cacheProps[C._fc_id] || (T.cacheProps[C._fc_id] = N(C._menu.props, b.value && b.value[C._menu.name], C, {
          t: R,
          api: T.dragForm.api
        }));
        const M = C._menu.hiddenBaseField || [];
        T.baseForm.api.hidden(!1), M.length && T.baseForm.api.hidden(!0, M), this.getConfig("showControl", !0) || T.baseForm.api.hidden(!0, "_control");
        const k = Nr(C, "field");
        T.advancedForm.api.hidden(!k, ["value", "$required", "props.disabled"]), T.baseForm.isShow = k && C.input !== !1 && L.getConfig("showBaseForm") !== !1, T.propsForm.isShow = T.cacheProps[C._fc_id].length > 0 && L.getConfig("showPropsForm") !== !1, T.styleForm.isShow = C._menu.style !== !1 && L.getConfig("showStyleForm") !== !1, T.advancedForm.isShow = C._menu.advanced !== !1 && L.getConfig("showAdvancedForm") !== !1, T.eventShow = C._menu.event && C._menu.event.length > 0 && L.getConfig("showEventForm") !== !1, T.validateForm.isShow = T.baseForm.isShow && C._menu.validate !== !1 && L.getConfig("showValidateForm") !== !1, T.propsForm.rule = T.cacheProps[C._fc_id], L.updateRuleFormData(), L.watchActiveRule();
      },
      getConfig(C, M) {
        return c.value && Nr(c.value, C) ? c.value[C] : M;
      },
      updateRuleFormData() {
        const C = T.activeRule, M = {
          ...C.props,
          formCreateChild: "" + C.children[0],
          "formCreateWrap>labelWidth": ""
        };
        Object.keys(C).forEach((j) => {
          ["effect", "config", "payload", "id", "type", "_menu"].indexOf(j) < 0 && (M["formCreate" + Fo(j)] = Lt(C[j]));
        }), ["props", "effect", "attrs", "style", "wrap"].forEach((j) => {
          C[j] && typeof C[j] == "object" && Object.keys(C[j]).forEach((W) => {
            M["formCreate" + Fo(j) + ">" + W] = Lt(C[j][W]);
          });
        });
        const k = {};
        ["value", "hidden", "$required", "props.disabled"].forEach((j) => {
          k[j] = C._computed && C._computed[j] || "";
        });
        const F = C._menu.attrs || {};
        Object.keys(F).forEach((j) => {
          M["__" + j] = F[j]({ rule: C });
        }), T.propsForm.value = M, T.styleForm.value = {
          style: C.style,
          class: C.class
        }, T.advancedForm.value = k, T.baseForm.isShow && (T.baseForm.value = {
          field: C.field,
          title: C.title || "",
          info: C.info,
          _control: C._control,
          ...M
        }, T.validateForm.value = {
          validate: C.validate ? [...C.validate] : [],
          required: M.formCreate$required
        }, T.dragForm.api.refreshValidate(), T.dragForm.api.nextTick(() => {
          T.dragForm.api.clearValidateState(C.__fc__.id);
        }));
      },
      dragStart(C) {
        console.log("top dragStart"), T.moveRule = C, T.added = !1;
      },
      dragUnchoose(C, M) {
        console.log("top dragUnchoose"), T.addRule = {
          children: C,
          oldIndex: M.oldIndex
        };
      },
      clickMenu(C) {
        L.dragMenu({ menu: C, children: T.children, index: T.children.length });
      },
      checkOnly(C) {
        let M = !1;
        return T.dragForm.api.all().forEach((k) => {
          M = M || k._fc_template === C.name || k._menu && k._menu.name === C.name;
        }), M && _t(T.t("struct.only", { label: R("com." + C.name + ".name") || C.label })), M;
      },
      dragMenu({ menu: C, children: M, index: k, slot: F }) {
        if (T.inputForm.state || C.only && L.checkOnly(C))
          return;
        L.handleAddBefore();
        const j = T.dragRuleList[C.name];
        f.emit("drag", {
          item: C,
          dragRule: j
        });
        let W = [];
        if (j.template) {
          let Q = "";
          st.Function(j.template) ? Q = Ze.toJson(j.template({ t: R })) : Array.isArray(j.template) ? Q = Ze.toJson(j.template) : Q = "" + j.template, j.autoField && (Q = L.replaceTemplateField(Q)), W = L.loadRule(Ze.parseJson(Q), null, C.name);
        } else
          W.push(L.makeRule(T.dragRuleList[j.name]));
        F && W.forEach((Q) => {
          Q && (Q.slot = F);
        }), M.splice(k, 0, ...W), L.handleAddAfter(j.template ? { template: W } : { rule: W[0] });
      },
      replaceField(C) {
        const M = ["array", "object"].indexOf(C._menu.subForm) > -1;
        let k = L.parseRule(Lt([C]))[0];
        return M && (k.field = We()), k = Ze.toJson(k), M ? k = L.batchReplaceUni(k) : k = L.batchReplaceField(k), L.loadRule([Ze.parseJson(k)])[0];
      },
      batchReplaceField(C) {
        const M = /"field"\s*:\s*"(\w[\w\d]+)"/g, k = [];
        return C = C.replace(M, (F, j) => {
          const W = We();
          return k.push({ old: j, key: W }), `"field":"${W}"`;
        }).replace(/"computed"\s*:\s*(\{\s*(?:"[^"]*"\s*:\s*"(?:\\"|[^"])*"(?:,\s*)?)*\})/g, (F, j) => {
          const W = JSON.parse(j);
          return k.forEach((Q) => {
            Object.keys(W).forEach((ne) => {
              W[ne] = `${W[ne]}`.replaceAll(Q.old, Q.key);
            });
          }), `"computed":${JSON.stringify(W)}`;
        }), L.batchReplaceUni(C);
      },
      replaceTemplateField(C) {
        const M = /"field"\s*:\s*"(\w[\w\d]+)"/g;
        let k;
        const F = [];
        for (; (k = M.exec(C)) !== null;)
          F.push({ old: k[1], key: We() });
        return F.forEach((j) => {
          C = C.replaceAll(j.old, j.key);
        }), C;
      },
      batchReplaceUni(C) {
        const M = /"_fc_id"\s*:\s*"(\w[\w\d]+)"/g;
        return C = C.replace(M, () => `"_fc_id":"id_${We()}"`), C;
      },
      dragAdd(C, M, k) {
        console.log("top dragAdd");
        const F = M.newIndex, j = M.item._underlying_vm_;
        if (j && j.__fc__) {
          if (T.addRule) {
            L.handleSortBefore();
            const W = T.addRule.children.splice(T.addRule.children.indexOf(j), 1)[0];
            k ? W.slot = k : delete W.slot, C.splice(F, 0, W), L.handleSortAfter({ rule: W });
          }
        } else
          L.dragMenu({ menu: j, children: C, index: F, slot: k });
        T.added = !0;
      },
      dragEnd(C, { newIndex: M, oldIndex: k }, F) {
        if (console.log("top dragEnd"), !T.added && !(T.moveRule === C && M === k)) {
          L.handleSortBefore();
          const j = T.moveRule.splice(k, 1);
          F && (j.slot = F), C.splice(M, 0, j[0]), L.handleSortAfter({ rule: j[0] });
        }
        T.moveRule = null, T.addRule = null, T.added = !1;
      },
      getSlotConfig(C, M, k) {
        let F = {};
        return (C.slot || []).forEach((j) => {
          j.name === M && (F = j.config || {});
        }), { ...k, dragBtn: !1, handleBtn: k.children ? ["addChild"] : !1, ...F };
      },
      makeRule(C, M) {
        const k = M || C.rule({ t: R });
        k._menu = On(C), k._fc_id || (k._fc_id = "id_" + We()), k.name || (k.name = "ref_" + We()), C.component && (k.component = On(C.component)), k._computed || (k._computed = {}), k.effect || (k.effect = {}), Nr(k, "display") || (k.display = !0), Nr(k, "hidden") || (k.hidden = !1), k._fc_drag_tag = C.name;
        let F = C.only === !0;
        if (!F && k._fc_template) {
          const ae = T.dragRuleList[k._fc_template];
          F = ae && ae.only === !0;
        }
        const j = st.trueArray(k.children), W = {}, Q = [];
        (C.slot || []).forEach((ae) => {
          typeof ae == "string" ? Q.push(ae) : (W[ae.name] = ae, Q.push(ae.name));
        });
        const ne = {
          default: []
        };
        Q.map((ae) => {
          ne[ae] = [];
        }), j && k.children.forEach((ae) => {
          ae.slot ? (ne[ae.slot] || (ne[ae.slot] = []), ne[ae.slot].push(ae)) : ne.default.push(ae);
        });
        const te = (ae, le, ue, he) => L.makeDrag(ae, le, ue, {
          end: (se, Ae) => L.dragEnd(se.self.children, Ae),
          add: (se, Ae) => L.dragAdd(se.self.children, Ae),
          start: (se, Ae) => L.dragStart(se.self.children, Ae),
          unchoose: (se, Ae) => L.dragUnchoose(se.self.children, Ae)
        }, he);
        let q;
        const ge = k._menu ? k._menu.name : k.type;
        if (Object.keys(ne).forEach((ae) => {
          const le = ae === "default";
          if (!le || C.drag) {
            let ue;
            if (W[ae] && !le) {
              if (!M) {
                const he = T.dragRuleList[W[ae].type];
                ue = L.makeRule({
                  ...he,
                  dragBtn: !1,
                  handleBtn: he.children ? ["addChild"] : !1,
                  ...W[ae].config || {}
                }), ue.slot = ae;
              }
            } else
              ue = te(!0, ge + (le ? "" : "-slot-" + ae), M ? ne[ae].map((he) => (delete he.slot, he)) : L.loadRule(ne[ae]), ae);
            ue && (ne[ae] = [ue]);
          }
          le && C.drag && (q = ne[ae][0]);
        }), C.children && !M && !j)
          for (let ae = 0; ae < (C.childrenLen || 1); ae++) {
            const le = L.makeRule(T.dragRuleList[C.children]);
            (q ? q.children : ne.default).push(le);
          }
        const be = [];
        Q.indexOf("default") === -1 && (be.push(...ne.default), delete ne.default), Q.forEach((ae) => {
          be.push(...ne[ae]), delete ne[ae];
        }), Object.keys(ne).forEach((ae) => {
          be.push(...ne[ae]);
        }), k.children = be;
        const me = l.value !== void 0 ? l.value !== !1 : C.mask !== !1;
        return C.tool === !1 ? k : C.inside ? (k.children = L.makeChildren([{
          type: "DragTool",
          props: {
            dragBtn: C.dragBtn !== !1,
            children: C.children,
            mask: me,
            handleBtn: C.handleBtn,
            only: F
          },
          inject: !0,
          on: {
            delete: ({ self: ae }) => {
              const le = L.getParent(ae).parent;
              L.handleRemoveBefore({ parent: le, rule: le }) !== !1 && (le.__fc__.rm(), f.emit("delete", le), L.clearActiveRule(), L.handleRemoveAfter({ rule: le }));
            },
            create: ({ self: ae }) => {
              L.handleAddBefore();
              const le = L.getParent(ae);
              f.emit("create", le.parent);
              const ue = L.makeRule(le.parent._menu);
              le.parent.slot && (ue.slot = le.parent.slot), le.root.children.splice(le.root.children.indexOf(le.parent) + 1, 0, ue), L.handleAddAfter({ rule: le.parent });
            },
            addChild: ({ self: ae }) => {
              L.handleAddBefore();
              const le = L.getParent(ae), ue = le.parent._menu, he = T.dragRuleList[ue.children];
              if (!he)
                return;
              const se = L.makeRule(he);
              (ue.drag ? le.parent.children[0] : le.parent).children[0].children.push(se), L.handleAddAfter({ rule: se });
            },
            copy: ({ self: ae }) => {
              L.handleCopyBefore();
              const le = L.getParent(ae);
              f.emit("copy", le.parent);
              const ue = L.replaceField(le.parent);
              le.root.children.splice(le.root.children.indexOf(le.parent) + 1, 0, ue), L.handleCopyAfter({ rule: le.parent });
            },
            active: ({ self: ae }) => {
              const le = L.getParent(ae);
              f.emit("active", le.parent), setTimeout(() => {
                L.toolActive(le.parent);
              }, 10);
            }
          },
          children: k.children
        }]), k) : {
          type: "DragTool",
          props: {
            dragBtn: C.dragBtn !== !1,
            children: C.children,
            mask: me,
            handleBtn: C.handleBtn,
            only: F
          },
          inject: !0,
          display: !!k.display,
          on: {
            delete: ({ self: ae }) => {
              L.handleRemoveBefore({ parent: ae, rule: ae.children[0] }) !== !1 && (f.emit("delete", ae.children[0]), ae.__fc__.rm(), L.clearActiveRule(), L.handleRemoveAfter({ rule: ae.children[0] }));
            },
            create: ({ self: ae }) => {
              L.handleAddBefore(), f.emit("create", ae.children[0]);
              const le = L.getParent(ae), ue = L.makeRule(ae.children[0]._menu);
              le.parent.slot && (ue.slot = le.parent.slot), le.root.children.splice(le.root.children.indexOf(le.parent) + 1, 0, ue), L.handleAddAfter({ rule: ue });
            },
            addChild: ({ self: ae }) => {
              L.handleAddBefore();
              const le = ae.children[0]._menu, ue = T.dragRuleList[le.children];
              if (!ue)
                return;
              const he = L.makeRule(ue);
              (le.drag ? ae.children[0] : ae).children[0].children.push(he), L.handleAddAfter({ rule: he });
            },
            copy: ({ self: ae }) => {
              L.handleCopyBefore(), f.emit("copy", ae.children[0]);
              const le = L.getParent(ae), ue = L.replaceField(ae.children[0]);
              le.root.children.splice(le.root.children.indexOf(le.parent) + 1, 0, ue), L.handleCopyAfter({ rule: ae.children[0] });
            },
            active: ({ self: ae }) => {
              f.emit("active", ae.children[0]), setTimeout(() => {
                L.toolActive(ae.children[0]);
              }, 10);
            }
          },
          children: L.makeChildren([k])
        };
      },
      toolHidden(C) {
        const M = !(C.display === void 0 || C.display);
        C._menu && !C._menu.inside && (C.__fc__.parent.rule.display = M), C.display = M;
      },
      toolHandle(C, M) {
        if (!C._fc_drag_tag || C._menu.tool === !1) {
          C.__fc__.rm();
          return;
        }
        let k;
        C._menu.inside ? k = C.children[0].__fc__.el : k = C.__fc__.parent.el, k.$emit(M);
      },
      handleAddBefore() {
      },
      handleRemoveBefore({ parent: C, rule: M }) {
        let k;
        M._menu && ["array", "object"].indexOf(M._menu.subForm) > -1 ? k = [M] : k = T.dragForm.api.getChildrenRuleList(C);
        const F = L.getSubFormChildren(C), j = JSON.stringify(st.trueArray(F) ? F : T.children).replace(JSON.stringify(C), "");
        let W = !0, Q = null;
        for (; W && k.length;) {
          Q = k.pop();
          const ne = new RegExp(_s(Q.field), "g");
          W = !j.match(ne);
        }
        return W || _t(T.t("computed.fieldUsed", { label: Q.title || R("com." + Q._menu.name + ".name") || Q._menu.label })), W;
      },
      handleCopyBefore() {
      },
      handleSortBefore() {
      },
      addOperationRecord() {
        const C = L.getJson(), M = Lt(T.inputForm.data), k = T.operation.list.slice(0, T.operation.idx + 1);
        k.push({ rule: C, formData: M }), T.operation.list = k, T.operation.idx = k.length - 1, window.onbeforeunload = (F) => {
          F.returnValue = R("designer.unload");
        };
      },
      prevOperationRecord() {
        if (!T.operation.list[T.operation.idx - 1])
          return;
        const C = T.operation.list[--T.operation.idx];
        L.useOperationRecord(C), L.clearActiveRule();
      },
      nextOperationRecord() {
        if (!T.operation.list[T.operation.idx + 1])
          return;
        const C = T.operation.list[++T.operation.idx];
        L.useOperationRecord(C), L.clearActiveRule();
      },
      useOperationRecord(C) {
        T.inputForm.data = C.formData, L.setRule(C.rule);
      },
      handleAddAfter() {
        console.log("handleAddAfter", arguments), L.addOperationRecord(), L.updateTree();
      },
      handleRemoveAfter() {
        console.log("handleRemoveAfter", arguments), L.addOperationRecord(), L.updateTree();
      },
      handleCopyAfter() {
        console.log("handleCopyAfter", arguments), L.addOperationRecord(), L.updateTree();
      },
      handleSortAfter() {
        console.log("handleSortAfter", arguments), L.addOperationRecord(), L.updateTree();
      },
      treeChange(C) {
        L.triggerActive(C.rule);
      },
      getFormDescription() {
        return mf(L.getDescription());
      },
      getDescription() {
        return gf(T.dragForm.rule[0].children);
      },
      getSubFormDescription(C) {
        let M = C.__fc__ && C.__fc__.parent;
        for (; M;) {
          if (M.rule._menu && ["array", "object"].indexOf(M.rule._menu.subForm) > -1)
            return mf(gf(M.rule.children));
          M = M.parent;
        }
        return null;
      },
      getSubFormChildren(C) {
        let M = C.__fc__ && C.__fc__.parent;
        for (; M;) {
          if (M.rule._menu && ["array", "object"].indexOf(M.rule._menu.subForm) > -1)
            return M.rule.children || [];
          M = M.parent;
        }
        return null;
      },
      updateTree: Xy(function () {
        cr(() => {
          T.treeInfo = js(T.dragForm.rule[0].children);
        });
      }, 300),
      findTree(C) {
        let M;
        const k = (F) => {
          F.forEach((j) => {
            j.rule.field === C ? M = j.children : j.children && k(j.children);
          });
        };
        return k(T.treeInfo), M || [];
      },
      handleDragenter(C) {
        T.bus.$emit("dragenter", C);
      },
      handleDragleave(C) {
        T.bus.$emit("dragleave", C);
      },
      handleDrop(C) {
        T.bus.$emit("drop", C);
      },
      bindDrop(C) {
      },
      changeEvent(C) {
        T.activeRule._on = C;
      },
      triggerHandle(C) {
        C.handle();
      }
    };
    T.dragForm.rule = L.makeDragRule(L.makeChildren(T.children)), L.setOption({}), L.addComponent(xg);
    const P = Vn(() => Object.keys(T.inputForm.data).length > 0);
    return {
      ...af(T),
      ...L,
      dragHeight: w,
      t: R,
      handle: u,
      inputCheckStatus: P,
      fieldReadonly: h,
      fieldList: m,
      hiddenMenu: I,
      hiddenItem: D,
      hiddenDragMenu: g,
      hiddenDragBtn: S
    };
  },
  created() {
    document.body.ondrop = (e) => {
      e.preventDefault(), e.stopPropagation();
    };
  },
  mounted() {
    this.bindDrop(this.$refs.dragCon);
  }
}), E0 = ["onClick"], w0 = ["onClick"], x0 = { class: "_fc-l-icon" }, T0 = { class: "_fc-l-name" }, D0 = {
  key: 1,
  class: "_fc-l-name"
}, I0 = { class: "_fc-tree-label" }, R0 = ["onClick"], F0 = /* @__PURE__ */ _("i", { class: "fc-icon icon-more" }, null, -1), M0 = { class: "_fc-m-tools-l" }, O0 = /* @__PURE__ */ _("path", {
  d: "M15.04 783.36h986.88v49.28H15.04zM163.2 191.36h690.88c27.2 0 49.28 22.08 49.28 49.28v542.72H113.92V240.64c0-27.2 22.08-49.28 49.28-49.28z",
  fill: "#7F7F7F"
}, null, -1), N0 = /* @__PURE__ */ _("path", {
  d: "M163.2 240.64h690.88v493.44H163.2z",
  fill: "#E5E5E5"
}, null, -1), L0 = [
  O0,
  N0
], P0 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 1024 1024"
}, $0 = /* @__PURE__ */ _("path", {
  d: "M15.04 783.36h986.88v49.28H15.04zM163.2 191.36h690.88c27.2 0 49.28 22.08 49.28 49.28v542.72H113.92V240.64c0-27.2 22.08-49.28 49.28-49.28z",
  fill: "#2E73FF"
}, null, -1), B0 = /* @__PURE__ */ _("path", {
  d: "M163.2 240.64h690.88v493.44H163.2z",
  fill: "#E0EAFF"
}, null, -1), k0 = [
  $0,
  B0
], H0 = /* @__PURE__ */ _("path", {
  d: "M217.28 29.76h589.44c29.44 0 53.44 24 53.44 53.44v857.28c0 29.44-24 53.44-53.44 53.44H217.28c-29.44 0-53.44-24-53.44-53.44V83.52c0-29.76 24-53.76 53.44-53.76z",
  fill: "#7F7F7F"
}, null, -1), V0 = /* @__PURE__ */ _("path", {
  d: "M217.28 136.96h589.44v750.08H217.28z",
  fill: "#E5E5E5"
}, null, -1), U0 = [
  H0,
  V0
], j0 = {
  key: 3,
  class: "icon",
  viewBox: "0 0 1024 1024"
}, z0 = /* @__PURE__ */ _("path", {
  d: "M217.28 29.76h589.44c29.44 0 53.44 24 53.44 53.44v857.28c0 29.44-24 53.44-53.44 53.44H217.28c-29.44 0-53.44-24-53.44-53.44V83.52c0-29.76 24-53.76 53.44-53.76z",
  fill: "#2E73FF"
}, null, -1), W0 = /* @__PURE__ */ _("path", {
  d: "M217.28 136.96h589.44v750.08H217.28z",
  fill: "#E0EAFF"
}, null, -1), G0 = [
  z0,
  W0
], Y0 = /* @__PURE__ */ _("path", {
  d: "M271.68 31.04h480.96c29.44 0 53.44 24 53.44 53.44v854.72c0 29.44-24 53.44-53.44 53.44H271.68c-29.44 0-53.44-24-53.44-53.44V84.48c0-29.44 23.68-53.44 53.44-53.44z",
  fill: "#7F7F7F"
}, null, -1), Q0 = /* @__PURE__ */ _("path", {
  d: "M271.68 137.92h480.96v747.84H271.68z",
  fill: "#E5E5E5"
}, null, -1), K0 = [
  Y0,
  Q0
], J0 = {
  key: 5,
  class: "icon",
  viewBox: "0 0 1024 1024"
}, X0 = /* @__PURE__ */ _("path", {
  d: "M271.68 31.04h480.96c29.44 0 53.44 24 53.44 53.44v854.72c0 29.44-24 53.44-53.44 53.44H271.68c-29.44 0-53.44-24-53.44-53.44V84.48c0-29.44 23.68-53.44 53.44-53.44z",
  fill: "#2E73FF"
}, null, -1), Z0 = /* @__PURE__ */ _("path", {
  d: "M271.68 137.92h480.96v747.84H271.68z",
  fill: "#E0EAFF"
}, null, -1), q0 = [
  X0,
  Z0
], _0 = /* @__PURE__ */ _("div", { class: "line" }, null, -1), eb = { class: "_fc-m-tools-r" }, tb = /* @__PURE__ */ _("i", { class: "fc-icon icon-save-online" }, null, -1), nb = /* @__PURE__ */ _("i", { class: "fc-icon icon-preview" }, null, -1), rb = /* @__PURE__ */ _("i", { class: "fc-icon icon-delete" }, null, -1), ib = /* @__PURE__ */ _("i", { class: "fc-icon icon-more" }, null, -1), ob = /* @__PURE__ */ _("div", { class: "line" }, null, -1), lb = { class: "_fd-input-btn" }, ab = {
  key: 0,
  class: "fc-icon icon-check"
}, sb = {
  key: 0,
  class: "_fc-m-input"
}, ub = {
  key: 0,
  class: "_fc-m-input-handle"
}, db = { class: "_fc-r-title" }, fb = { class: "_fc-r-title" }, cb = {
  key: 1,
  class: "_fd-preview-code"
}, pb = ["innerHTML"];
function hb(e, o, i, l, n, u) {
  const f = ie("el-header"), p = ie("draggable"), c = ie("el-main"), v = ie("el-dropdown-item"), b = ie("el-dropdown-menu"), y = ie("el-dropdown"), E = ie("el-tree"), w = ie("ElContainer"), h = ie("el-aside"), m = ie("el-button"), I = ie("el-popconfirm"), D = ie("el-switch"), g = ie("ViewForm"), S = ie("DragForm"), x = ie("ElMain"), R = ie("el-tag"), N = ie("el-input"), T = ie("ElDivider"), H = ie("EventConfig"), B = ie("ElAside"), L = ie("el-tab-pane"), P = ie("el-tabs"), C = ie("ElDialog");
  return Z(), we(w, {
    class: "_fc-designer",
    onDragenter: e.handleDragenter,
    onDragleave: e.handleDragleave,
    onDrop: e.handleDrop
  }, {
    default: Y(() => [
      X(x, null, {
        default: Y(() => [
          (Z(), we(w, {
            style: { height: "100%" },
            key: e.locale && e.locale.name
          }, {
            default: Y(() => [
              X(h, {
                class: "_fc-l",
                width: "266px"
              }, {
                default: Y(() => [
                  X(w, { style: { height: "100%" } }, {
                    default: Y(() => [
                      X(f, {
                        height: "40px",
                        class: "_fc-l-tabs"
                      }, {
                        default: Y(() => [
                          _("div", {
                            class: ot(["_fc-l-tab", { active: e.activeMenuTab === "menu" }]),
                            onClick: o[0] || (o[0] = (M) => e.activeMenuTab = "menu")
                          }, ve(e.t("menu.component")), 3),
                          _("div", {
                            class: ot(["_fc-l-tab", { active: e.activeMenuTab === "tree" }]),
                            onClick: o[1] || (o[1] = (M) => e.activeMenuTab = "tree")
                          }, ve(e.t("menu.tree")), 3)
                        ]),
                        _: 1
                      }),
                      dr(X(c, null, {
                        default: Y(() => [
                          (Z(!0), fe(ze, null, ft(e.menuList, (M, k) => (Z(), fe(ze, { key: k }, [
                            (M.name === "template" ? e.config.showTemplate !== !1 : !0) && e.hiddenMenu.indexOf(M.name) === -1 ? (Z(), fe("div", {
                              key: 0,
                              class: ot(["_fc-l-group", { "is-template": M.name === "template" }])
                            }, [
                              _("h4", {
                                class: "_fc-l-title",
                                onClick: (F) => M.hidden = !M.hidden
                              }, [
                                xe(ve(e.t("menu." + M.name) || M.title) + " ", 1),
                                _("i", {
                                  class: ot(["fc-icon icon-arrow", { down: !M.hidden }])
                                }, null, 2)
                              ], 8, E0),
                              dr(X(p, {
                                group: { name: "default", pull: "clone", put: !1 },
                                sort: !1,
                                itemKey: "name",
                                class: "_fc-l-list",
                                list: M.list
                              }, {
                                item: Y(({ element: F }) => [
                                  e.hiddenItem.indexOf(F.name) === -1 ? (Z(), fe("div", {
                                    key: 0,
                                    class: "_fc-l-item",
                                    onClick: (j) => e.clickMenu(F)
                                  }, [
                                    M.name !== "template" ? (Z(), fe(ze, { key: 0 }, [
                                      _("div", x0, [
                                        _("i", {
                                          class: ot(["fc-icon", F.icon || "icon-input"])
                                        }, null, 2)
                                      ]),
                                      _("span", T0, ve(e.t("com." + F.name + ".name") || F.label), 1)
                                    ], 64)) : (Z(), fe("span", D0, ve(e.t("tmp." + F.name) || F.label), 1))
                                  ], 8, w0)) : Se("", !0)
                                ]),
                                _: 2
                              }, 1032, ["list"]), [
                                [fr, !M.hidden]
                              ])
                            ], 2)) : Se("", !0)
                          ], 64))), 128))
                        ]),
                        _: 1
                      }, 512), [
                        [fr, e.activeMenuTab === "menu"]
                      ]),
                      e.activeMenuTab === "tree" ? (Z(), we(c, { key: 0 }, {
                        default: Y(() => [
                          X(E, {
                            ref: "treeRef",
                            data: e.treeInfo,
                            "default-expand-all": "",
                            "expand-on-click-node": !1,
                            onCurrentChange: e.treeChange
                          }, {
                            default: Y(({ node: M, data: k }) => [
                              _("div", {
                                class: ot(["_fc-tree-node", { active: e.activeRule === k.rule }])
                              }, [
                                _("div", I0, [
                                  _("i", {
                                    class: ot(["fc-icon", k.rule._menu && k.rule._menu.icon || "icon-cell"])
                                  }, null, 2),
                                  _("span", null, ve((k.rule.title || "").trim() || k.rule.props && k.rule.props.label || e.t("com." + (k.rule._menu && k.rule._menu.name) + ".name") || k.rule.type), 1)
                                ]),
                                k.slot ? Se("", !0) : (Z(), fe("div", {
                                  key: 0,
                                  class: "_fc-tree-more",
                                  onClick: o[2] || (o[2] = yt(() => {
                                  }, ["stop"]))
                                }, [
                                  _("i", {
                                    class: ot(["fc-icon", k.rule.display === !1 ? "icon-eye-close" : "icon-eye"]),
                                    onClick: (F) => e.toolHidden(k.rule),
                                    style: { "margin-right": "8px" }
                                  }, null, 10, R0),
                                  X(y, {
                                    trigger: "click",
                                    size: "default"
                                  }, {
                                    dropdown: Y(() => [
                                      X(b, null, {
                                        default: Y(() => [
                                          k.rule._fc_drag_tag !== "_" ? (Z(), we(v, {
                                            key: "1",
                                            onClick: (F) => e.toolHandle(k.rule, "create")
                                          }, {
                                            default: Y(() => [
                                              xe(ve(e.t("props.copy")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])) : Se("", !0),
                                          k.rule._menu && k.rule._menu.children && k.rule._fc_drag_tag !== "_" ? (Z(), we(v, {
                                            key: "2",
                                            onClick: (F) => e.toolHandle(k.rule, "addChild")
                                          }, {
                                            default: Y(() => [
                                              xe(ve(e.t("form.appendChild")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])) : Se("", !0),
                                          X(v, {
                                            key: "3",
                                            onClick: (F) => e.toolHandle(k.rule, "delete")
                                          }, {
                                            default: Y(() => [
                                              xe(ve(e.t("props.delete")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: Y(() => [
                                      F0
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              ], 2)
                            ]),
                            _: 1
                          }, 8, ["data", "onCurrentChange"])
                        ]),
                        _: 1
                      })) : Se("", !0)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              X(w, { class: "_fc-m" }, {
                default: Y(() => [
                  X(f, {
                    class: "_fc-m-tools",
                    height: "45"
                  }, {
                    default: Y(() => [
                      _("div", M0, [
                        e.inputForm.state ? Se("", !0) : (Z(), fe(ze, { key: 0 }, [
                          e.getConfig("showDevice") !== !1 ? (Z(), fe(ze, { key: 0 }, [
                            e.device !== "pc" ? (Z(), fe("svg", {
                              key: 0,
                              onClick: o[3] || (o[3] = (M) => e.device = "pc"),
                              class: "icon",
                              viewBox: "0 0 1024 1024"
                            }, L0)) : Se("", !0),
                            e.device === "pc" ? (Z(), fe("svg", P0, k0)) : Se("", !0),
                            e.device !== "pad" ? (Z(), fe("svg", {
                              key: 2,
                              onClick: o[4] || (o[4] = (M) => e.device = "pad"),
                              class: "icon",
                              viewBox: "0 0 1024 1024"
                            }, U0)) : Se("", !0),
                            e.device === "pad" ? (Z(), fe("svg", j0, G0)) : Se("", !0),
                            e.device !== "mobile" ? (Z(), fe("svg", {
                              key: 4,
                              onClick: o[5] || (o[5] = (M) => e.device = "mobile"),
                              class: "icon",
                              viewBox: "0 0 1024 1024"
                            }, K0)) : Se("", !0),
                            e.device === "mobile" ? (Z(), fe("svg", J0, q0)) : Se("", !0),
                            _0
                          ], 64)) : Se("", !0),
                          _("div", null, [
                            _("i", {
                              class: ot(["fc-icon icon-pre-step", { disabled: !e.operation.list[e.operation.idx - 1] }]),
                              onClick: o[6] || (o[6] = (...M) => e.prevOperationRecord && e.prevOperationRecord(...M))
                            }, null, 2),
                            _("i", {
                              class: ot(["fc-icon icon-next-step", { disabled: !e.operation.list[e.operation.idx + 1] }]),
                              onClick: o[7] || (o[7] = (...M) => e.nextOperationRecord && e.nextOperationRecord(...M))
                            }, null, 2)
                          ])
                        ], 64))
                      ]),
                      _("div", eb, [
                        e.inputForm.state ? Se("", !0) : (Z(), fe(ze, { key: 0 }, [
                          en(e.$slots, "handle"),
                          e.getConfig("showSaveBtn", !1) ? (Z(), we(m, {
                            key: 0,
                            type: "success",
                            plain: "",
                            size: "small",
                            onClick: e.handleSave
                          }, {
                            default: Y(() => [
                              tb,
                              xe(" " + ve(e.t("props.save")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])) : Se("", !0),
                          X(m, {
                            type: "primary",
                            plain: "",
                            size: "small",
                            onClick: e.openPreview
                          }, {
                            default: Y(() => [
                              nb,
                              xe(" " + ve(e.t("props.preview")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          X(I, {
                            title: e.t("designer.clearWarn"),
                            width: "200px",
                            "confirm-button-text": e.t("props.clear"),
                            "cancel-button-text": e.t("props.cancel"),
                            onConfirm: e.clearDragRule
                          }, {
                            reference: Y(() => [
                              X(m, {
                                type: "danger",
                                plain: "",
                                size: "small"
                              }, {
                                default: Y(() => [
                                  rb,
                                  xe(ve(e.t("props.clear")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["title", "confirm-button-text", "cancel-button-text", "onConfirm"]),
                          e.handle && e.handle.length ? (Z(), we(y, {
                            key: 1,
                            trigger: "click",
                            size: "default"
                          }, {
                            dropdown: Y(() => [
                              X(b, null, {
                                default: Y(() => [
                                  (Z(!0), fe(ze, null, ft(e.handle, (M) => (Z(), we(v, {
                                    onClick: yt((k) => e.triggerHandle(M), ["stop"])
                                  }, {
                                    default: Y(() => [
                                      _("div", null, ve(M.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))), 256))
                                ]),
                                _: 1
                              })
                            ]),
                            default: Y(() => [
                              X(m, {
                                class: "_fd-m-extend",
                                plain: "",
                                size: "small"
                              }, {
                                default: Y(() => [
                                  ib
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })) : Se("", !0)
                        ], 64)),
                        ob,
                        _("div", lb, [
                          e.inputCheckStatus ? (Z(), fe("i", ab)) : Se("", !0),
                          _("span", null, ve(e.t("props.inputData")) + "\uFF1A", 1),
                          X(D, {
                            size: "small",
                            "model-value": e.inputForm.state,
                            "inline-prompt": "",
                            "onUpdate:modelValue": e.openInputData
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ])
                      ])
                    ]),
                    _: 3
                  }),
                  X(x, { class: "_fc-m-con" }, {
                    default: Y(() => [
                      _("div", {
                        class: ot(["_fc-m-drag", e.device]),
                        ref: "dragCon",
                        style: ri({ "--fc-drag-empty": `'${e.t("designer.dragEmpty")}'`, "--fc-child-empty": `'${e.t("designer.childEmpty")}'`, height: e.dragHeight })
                      }, [
                        e.inputForm.state ? (Z(), fe("div", sb, [
                          (Z(), we(g, {
                            key: e.inputForm.key,
                            rule: e.inputForm.rule,
                            option: e.inputForm.option,
                            api: e.inputForm.api,
                            "onUpdate:api": o[8] || (o[8] = (M) => e.inputForm.api = M),
                            disabled: !1
                          }, null, 8, ["rule", "option", "api"]))
                        ])) : (Z(), we(S, {
                          key: 1,
                          rule: e.dragForm.rule,
                          option: e.formOptions,
                          api: e.dragForm.api,
                          "onUpdate:api": o[9] || (o[9] = (M) => e.dragForm.api = M)
                        }, null, 8, ["rule", "option", "api"]))
                      ], 6),
                      e.inputForm.state ? (Z(), fe("div", ub, [
                        X(m, {
                          plain: "",
                          onClick: o[10] || (o[10] = (M) => e.inputClear())
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.clear")), 1)
                          ]),
                          _: 1
                        }),
                        X(m, {
                          plain: "",
                          onClick: o[11] || (o[11] = (M) => e.inputReset())
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.reset")), 1)
                          ]),
                          _: 1
                        }),
                        X(m, {
                          type: "primary",
                          plain: "",
                          onClick: o[12] || (o[12] = (M) => e.inputSave())
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.save")), 1)
                          ]),
                          _: 1
                        })
                      ])) : Se("", !0)
                    ]),
                    _: 1
                  })
                ]),
                _: 3
              }),
              !e.config || e.config.showConfig !== !1 ? (Z(), we(B, {
                key: 0,
                class: "_fc-r",
                width: "320px"
              }, {
                default: Y(() => [
                  X(w, { style: { height: "100%" } }, {
                    default: Y(() => [
                      X(f, {
                        height: "40px",
                        class: "_fc-r-tabs"
                      }, {
                        default: Y(() => [
                          !!e.activeRule || e.customForm.isShow || e.config && e.config.showFormConfig === !1 ? (Z(), fe("div", {
                            key: 0,
                            class: ot(["_fc-r-tab", { active: e.activeTab === "props" }]),
                            onClick: o[13] || (o[13] = (M) => e.activeTab = "props")
                          }, ve(e.t("designer.component")), 3)) : Se("", !0),
                          !e.config || e.config.showFormConfig !== !1 ? (Z(), fe("div", {
                            key: 1,
                            class: ot(["_fc-r-tab", { active: e.activeTab === "form" && (!!e.activeRule || e.customForm.isShow) }]),
                            onClick: o[14] || (o[14] = (M) => e.activeTab = "form")
                          }, ve(e.t("designer.form")), 3)) : Se("", !0)
                        ]),
                        _: 1
                      }),
                      !e.config || e.config.showFormConfig !== !1 ? dr((Z(), we(x, {
                        key: 0,
                        class: "_fc-r-tab-form"
                      }, {
                        default: Y(() => [
                          X(S, {
                            rule: e.form.rule,
                            option: e.form.option,
                            modelValue: e.form.value,
                            onChange: e.formOptChange,
                            api: e.form.api,
                            "onUpdate:api": o[15] || (o[15] = (M) => e.form.api = M)
                          }, null, 8, ["rule", "option", "modelValue", "onChange", "api"])
                        ]),
                        _: 1
                      }, 512)), [
                        [fr, e.activeTab === "form"]
                      ]) : Se("", !0),
                      dr((Z(), we(x, {
                        class: "_fc-r-tab-props",
                        key: e.activeRule ? e.activeRule._fc_id : e.customForm.config ? e.customForm.key : ""
                      }, {
                        default: Y(() => [
                          e.activeRule || e.customForm.config && (e.customForm.config.name || e.customForm.config.label) ? (Z(), fe(ze, { key: 0 }, [
                            _("p", db, ve(e.t("designer.type")), 1),
                            X(R, {
                              type: "success",
                              effect: "plain",
                              "disable-transitions": ""
                            }, {
                              default: Y(() => [
                                e.activeRule ? (Z(), fe(ze, { key: 0 }, [
                                  xe(ve(e.t("com." + e.activeRule._menu.name + ".name") || e.activeRule._menu.label), 1)
                                ], 64)) : (Z(), fe(ze, { key: 1 }, [
                                  xe(ve(e.t("com." + e.customForm.config.name + ".name") || e.customForm.config.label || e.customForm.config.name), 1)
                                ], 64))
                              ]),
                              _: 1
                            }),
                            e.activeRule && e.activeRule.name ? (Z(), fe(ze, { key: 0 }, [
                              _("p", fb, ve(e.t("designer.name")), 1),
                              X(N, {
                                size: "small",
                                class: "_fc-r-name-input",
                                "model-value": e.activeRule.name,
                                readonly: ""
                              }, {
                                append: Y(() => [
                                  _("i", {
                                    class: "fc-icon icon-auto",
                                    onClick: o[16] || (o[16] = (...M) => e.updateName && e.updateName(...M))
                                  })
                                ]),
                                _: 1
                              }, 8, ["model-value"])
                            ], 64)) : Se("", !0)
                          ], 64)) : Se("", !0),
                          e.baseForm.isShow ? (Z(), we(T, { key: 1 }, {
                            default: Y(() => [
                              xe(ve(e.t("designer.rule")), 1)
                            ]),
                            _: 1
                          })) : Se("", !0),
                          dr(X(S, {
                            api: e.baseForm.api,
                            "onUpdate:api": o[17] || (o[17] = (M) => e.baseForm.api = M),
                            rule: e.baseForm.rule,
                            option: e.baseForm.options,
                            modelValue: e.baseForm.value,
                            onChange: e.baseChange
                          }, null, 8, ["api", "rule", "option", "modelValue", "onChange"]), [
                            [fr, e.baseForm.isShow]
                          ]),
                          e.propsForm.isShow ? (Z(), we(T, { key: 2 }, {
                            default: Y(() => [
                              xe(ve(e.t("designer.props")), 1)
                            ]),
                            _: 1
                          })) : Se("", !0),
                          dr(X(S, {
                            api: e.propsForm.api,
                            "onUpdate:api": o[18] || (o[18] = (M) => e.propsForm.api = M),
                            rule: e.propsForm.rule,
                            option: e.propsForm.options,
                            modelValue: e.propsForm.value,
                            onChange: e.propChange,
                            onRemoveField: e.propRemoveField
                          }, null, 8, ["api", "rule", "option", "modelValue", "onChange", "onRemoveField"]), [
                            [fr, e.propsForm.isShow]
                          ]),
                          e.advancedForm.isShow ? (Z(), we(T, { key: 3 }, {
                            default: Y(() => [
                              xe(ve(e.t("designer.advanced")), 1)
                            ]),
                            _: 1
                          })) : Se("", !0),
                          dr(X(S, {
                            api: e.advancedForm.api,
                            "onUpdate:api": o[19] || (o[19] = (M) => e.advancedForm.api = M),
                            rule: e.advancedForm.rule,
                            option: e.advancedForm.options,
                            modelValue: e.advancedForm.value,
                            onChange: e.computedChange
                          }, null, 8, ["api", "rule", "option", "modelValue", "onChange"]), [
                            [fr, e.advancedForm.isShow]
                          ]),
                          e.customForm.isShow && e.customForm.propsShow ? (Z(), we(T, { key: 4 }, {
                            default: Y(() => [
                              xe(ve(e.t("designer.props")), 1)
                            ]),
                            _: 1
                          })) : Se("", !0),
                          e.customForm.isShow && e.customForm.propsShow ? (Z(), we(S, {
                            api: e.customForm.api,
                            "onUpdate:api": o[20] || (o[20] = (M) => e.customForm.api = M),
                            rule: e.customForm.rule,
                            option: e.customForm.options,
                            key: e.customForm.key,
                            onChange: e.customFormChange
                          }, null, 8, ["api", "rule", "option", "onChange"])) : Se("", !0),
                          e.styleForm.isShow ? (Z(), we(T, { key: 6 }, {
                            default: Y(() => [
                              xe(ve(e.t("designer.style")), 1)
                            ]),
                            _: 1
                          })) : Se("", !0),
                          dr(X(S, {
                            rule: e.styleForm.rule,
                            option: e.styleForm.options,
                            modelValue: e.styleForm.value,
                            onChange: e.styleChange,
                            api: e.styleForm.api,
                            "onUpdate:api": o[21] || (o[21] = (M) => e.styleForm.api = M)
                          }, null, 8, ["rule", "option", "modelValue", "onChange", "api"]), [
                            [fr, e.styleForm.isShow]
                          ]),
                          e.eventShow ? (Z(), we(T, { key: 7 }, {
                            default: Y(() => [
                              xe(ve(e.t("designer.event")), 1)
                            ]),
                            _: 1
                          })) : Se("", !0),
                          e.eventShow ? (Z(), we(H, {
                            key: 8,
                            "event-name": e.activeRule && e.activeRule._menu.event || [],
                            "component-name": e.activeRule && e.activeRule._menu.name || "",
                            "model-value": e.activeRule && e.activeRule._on || {},
                            "onUpdate:modelValue": e.changeEvent
                          }, null, 8, ["event-name", "component-name", "model-value", "onUpdate:modelValue"])) : Se("", !0),
                          e.activeRule ? (Z(), fe(ze, { key: 9 }, [
                            e.validateForm.isShow ? (Z(), we(T, { key: 0 }, {
                              default: Y(() => [
                                xe(ve(e.t("designer.validate")), 1)
                              ]),
                              _: 1
                            })) : Se("", !0),
                            e.validateForm.isShow ? (Z(), we(S, {
                              api: e.validateForm.api,
                              "onUpdate:api": o[22] || (o[22] = (M) => e.validateForm.api = M),
                              rule: e.validateForm.rule,
                              option: e.validateForm.options,
                              modelValue: e.validateForm.value,
                              "onUpdate:modelValue": e.validateChange,
                              key: e.activeRule._fc_id
                            }, null, 8, ["api", "rule", "option", "modelValue", "onUpdate:modelValue"])) : Se("", !0)
                          ], 64)) : Se("", !0)
                        ]),
                        _: 1
                      })), [
                        [fr, e.activeTab === "props"]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })) : Se("", !0),
              X(C, {
                modelValue: e.preview.state,
                "onUpdate:modelValue": o[25] || (o[25] = (M) => e.preview.state = M),
                width: "800px",
                class: "_fd-preview-dialog",
                "append-to-body": ""
              }, {
                default: Y(() => [
                  X(P, {
                    class: "_fd-preview-tabs",
                    modelValue: e.previewStatus,
                    "onUpdate:modelValue": o[23] || (o[23] = (M) => e.previewStatus = M)
                  }, {
                    default: Y(() => [
                      X(L, {
                        label: e.t("form.formMode"),
                        name: "form"
                      }, null, 8, ["label"]),
                      X(L, {
                        label: e.t("form.previewMode"),
                        name: "preview"
                      }, null, 8, ["label"]),
                      X(L, {
                        label: e.t("form.componentMode"),
                        name: "component"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  e.previewStatus === "form" || e.previewStatus === "preview" ? (Z(), fe(ze, { key: 0 }, [
                    e.preview.state ? (Z(), we(g, {
                      key: 0,
                      rule: e.preview.rule,
                      option: e.preview.option,
                      api: e.preview.api,
                      "onUpdate:api": o[24] || (o[24] = (M) => e.preview.api = M)
                    }, null, 8, ["rule", "option", "api"])) : Se("", !0)
                  ], 64)) : (Z(), fe("pre", cb, [
                    _("code", {
                      innerHTML: e.preview.html
                    }, null, 8, pb)
                  ]))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 3
          }))
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["onDragenter", "onDragleave", "onDrop"]);
}
const mr = /* @__PURE__ */ qe(S0, [["render", hb]]);
const vb = et({
  name: "DragTool",
  emits: ["create", "copy", "addChild", "delete", "active"],
  props: {
    dragBtn: Boolean,
    children: String,
    mask: Boolean,
    handleBtn: [Boolean, Array],
    formCreateInject: Object,
    unique: String,
    only: Boolean
  },
  inject: {
    fcx: {
      default: null
    },
    designer: {
      default: null
    },
    dragTool: {
      default: null
    }
  },
  provide() {
    return {
      dragTool: this
    };
  },
  computed: {
    isCreate() {
      return this.dragTool ? !!this.dragTool.children : !1;
    },
    btns() {
      return Array.isArray(this.handleBtn) ? this.handleBtn.length ? this.handleBtn : !1 : this.handleBtn !== !1;
    },
    id() {
      return this.unique || this.formCreateInject.id;
    },
    hiddenMenu() {
      return this.designer.ctx.hiddenDragMenu;
    },
    hiddenBtn() {
      return this.designer.ctx.hiddenDragBtn;
    }
  },
  methods: {
    active() {
      this.fcx.active !== this.id && (this.fcx.active = this.id, this.$emit("active"));
    }
  },
  mounted() {
    this.designer.setupState.bindDrop(this.$el);
  }
}), mb = {
  key: 0,
  class: "_fd-drag-mask"
}, gb = {
  key: 1,
  class: "_fd-drag-l"
}, yb = {
  key: 0,
  class: "_fd-drag-btn",
  style: { cursor: "move" }
}, bb = /* @__PURE__ */ _("i", { class: "fc-icon icon-move" }, null, -1), Ab = [
  bb
], Cb = {
  key: 2,
  class: "drag-r"
}, Sb = /* @__PURE__ */ _("i", { class: "fc-icon icon-add" }, null, -1), Eb = [
  Sb
], wb = /* @__PURE__ */ _("i", { class: "fc-icon icon-copy" }, null, -1), xb = [
  wb
], Tb = /* @__PURE__ */ _("i", { class: "fc-icon icon-add-child" }, null, -1), Db = [
  Tb
], Ib = /* @__PURE__ */ _("i", { class: "fc-icon icon-delete" }, null, -1), Rb = [
  Ib
];
function Fb(e, o, i, l, n, u) {
  return Z(), fe("div", {
    class: ot(["_fd-drag-tool", { active: e.fcx.active === e.id }]),
    onClick: o[4] || (o[4] = yt((...f) => e.active && e.active(...f), ["stop"]))
  }, [
    e.mask ? (Z(), fe("div", mb)) : Se("", !0),
    e.hiddenBtn ? Se("", !0) : (Z(), fe("div", gb, [
      e.fcx.active === e.id && e.dragBtn !== !1 ? (Z(), fe("div", yb, Ab)) : Se("", !0)
    ])),
    e.btns !== !1 && !e.hiddenMenu ? (Z(), fe("div", Cb, [
      en(e.$slots, "handle", {}, () => [
        e.isCreate && (e.btns === !0 || e.btns.indexOf("create") > -1) ? (Z(), fe("div", {
          key: 0,
          class: "_fd-drag-btn",
          onClick: o[0] || (o[0] = (f) => e.$emit("create"))
        }, Eb)) : Se("", !0),
        !e.only && (e.btns === !0 || e.btns.indexOf("copy") > -1) ? (Z(), fe("div", {
          key: 1,
          class: "_fd-drag-btn",
          onClick: o[1] || (o[1] = (f) => e.$emit("copy"))
        }, xb)) : Se("", !0),
        e.children && (e.btns === !0 || e.btns.indexOf("addChild") > -1) ? (Z(), fe("div", {
          key: 2,
          class: "_fd-drag-btn",
          onClick: o[2] || (o[2] = (f) => e.$emit("addChild"))
        }, Db)) : Se("", !0),
        e.btns === !0 || e.btns.indexOf("delete") > -1 ? (Z(), fe("div", {
          key: 3,
          class: "_fd-drag-btn _fd-drag-danger",
          onClick: o[3] || (o[3] = (f) => e.$emit("delete"))
        }, Rb)) : Se("", !0)
      ])
    ])) : Se("", !0),
    en(e.$slots, "default")
  ], 2);
}
const kc = /* @__PURE__ */ qe(vb, [["render", Fb]]);
const Mb = et({
  name: "Struct",
  props: {
    modelValue: [Object, Array, Function],
    title: String,
    defaultValue: {
      require: !1
    },
    validate: Function
  },
  inject: ["designer"],
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    configured() {
      return !st.empty(this.modelValue);
    }
  },
  data() {
    return {
      editor: null,
      visible: !1,
      oldVal: null
    };
  },
  watch: {
    modelValue() {
      this.load();
    },
    visible(e) {
      e && this.load();
    }
  },
  methods: {
    load() {
      const e = kr(lc(this.modelValue ? Lt(this.modelValue) : this.defaultValue));
      this.oldVal = e, this.$nextTick(() => {
        this.editor = On(Hr(this.$refs.editor, {
          lineNumbers: !0,
          mode: "javascript",
          lint: !0,
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: e || ""
        }));
      });
    },
    onOk() {
      const e = this.editor.getValue();
      let o;
      try {
        o = new Function("return " + e)();
      } catch (i) {
        return console.error(i), _t(this.t("struct.errorMsg")), !1;
      }
      return this.validate && this.validate(o) === !1 ? (_t(this.t("struct.errorMsg")), !1) : (this.visible = !1, kr(o) !== this.oldVal && this.$emit("update:modelValue", o), !0);
    }
  }
}), Ob = { class: "_fd-struct" }, Nb = {
  key: 0,
  ref: "editor"
};
function Lb(e, o, i, l, n, u) {
  const f = ie("ElButton"), p = ie("el-badge"), c = ie("ElDialog");
  return Z(), fe("div", Ob, [
    X(p, {
      type: "warning",
      "is-dot": "",
      hidden: !e.configured
    }, {
      default: Y(() => [
        X(f, {
          onClick: o[0] || (o[0] = (v) => e.visible = !0),
          size: "small"
        }, {
          default: Y(() => [
            xe(ve(e.title || e.t("struct.title")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["hidden"]),
    X(c, {
      class: "_fd-struct-con",
      title: e.title || e.t("struct.title"),
      modelValue: e.visible,
      "onUpdate:modelValue": o[2] || (o[2] = (v) => e.visible = v),
      "destroy-on-close": "",
      "close-on-click-modal": !1,
      "append-to-body": ""
    }, {
      footer: Y(() => [
        _("div", null, [
          X(f, {
            onClick: o[1] || (o[1] = (v) => e.visible = !1),
            size: "default"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.cancel")), 1)
            ]),
            _: 1
          }),
          X(f, {
            type: "primary",
            onClick: e.onOk,
            size: "default",
            color: "#2f73ff"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.ok")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: Y(() => [
        e.visible ? (Z(), fe("div", Nb, null, 512)) : Se("", !0)
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]);
}
const Pb = /* @__PURE__ */ qe(Mb, [["render", Lb]]);
const $b = et({
  name: "HtmlEditor",
  props: {
    modelValue: String,
    title: String,
    defaultValue: {
      require: !1
    }
  },
  inject: ["designer"],
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  },
  data() {
    return {
      editor: null,
      visible: !1,
      oldVal: null
    };
  },
  watch: {
    modelValue() {
      this.load();
    },
    visible(e) {
      e && this.load();
    }
  },
  methods: {
    validateXML(e) {
      var n;
      const l = new DOMParser().parseFromString(e, "application/xml").getElementsByTagName("parsererror");
      return l.length > 0 && (n = l[0].innerText.split(`
`)[0]) != null ? n : "";
    },
    load() {
      this.oldVal = this.modelValue, this.$nextTick(() => {
        this.editor = On(Hr(this.$refs.editor, {
          lineNumbers: !0,
          mode: "xml",
          lint: !0,
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: this.modelValue || ""
        }));
      });
    },
    onOk() {
      const e = this.editor.getValue();
      return this.validateXML(e) ? (_t(this.t("struct.errorMsg")), !1) : (this.visible = !1, e !== this.oldVal && this.$emit("update:modelValue", e), !0);
    }
  }
}), Bb = { class: "_fd-html-editor" }, kb = {
  key: 0,
  ref: "editor"
};
function Hb(e, o, i, l, n, u) {
  const f = ie("ElButton"), p = ie("ElDialog");
  return Z(), fe("div", Bb, [
    X(f, {
      onClick: o[0] || (o[0] = (c) => e.visible = !0),
      style: { width: "100%" }
    }, {
      default: Y(() => [
        xe(ve(e.title || e.t("struct.title")), 1)
      ]),
      _: 1
    }),
    X(p, {
      class: "_fd-html-editor-con",
      title: e.title || e.t("struct.title"),
      modelValue: e.visible,
      "onUpdate:modelValue": o[2] || (o[2] = (c) => e.visible = c),
      "close-on-click-modal": !1,
      "append-to-body": ""
    }, {
      footer: Y(() => [
        _("div", null, [
          X(f, {
            onClick: o[1] || (o[1] = (c) => e.visible = !1),
            size: "default"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.cancel")), 1)
            ]),
            _: 1
          }),
          X(f, {
            type: "primary",
            onClick: e.onOk,
            size: "default"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.ok")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: Y(() => [
        e.visible ? (Z(), fe("div", kb, null, 512)) : Se("", !0)
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]);
}
const Vb = /* @__PURE__ */ qe($b, [["render", Hb]]);
const Ub = et({
  name: "SizeInput",
  inject: ["designer"],
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: String,
    unit: {
      type: Array,
      default: () => ["auto", "px", "%", "vh", "vw", "em", "rem"]
    },
    defaultUnit: {
      type: String,
      default: "px"
    }
  },
  watch: {
    modelValue() {
      this.parseValue();
    }
  },
  data() {
    return {
      idx: 1,
      num: 0,
      oldValue: this.modelValue || ""
    };
  },
  methods: {
    parseValue() {
      this.modelValue !== "auto" ? (this.idx = Math.max(this.unit.indexOf(this.defaultUnit), 0), this.unit.forEach((e, o) => {
        (this.modelValue || "").indexOf(e) > -1 && (this.idx = o);
      }), this.num = Zn(this.modelValue) ? null : parseFloat(this.modelValue || 0)) : (this.idx = 0, this.num = 0);
    },
    submit() {
      this.oldValue = Zn(this.num) ? "" : "" + this.num + this.unit[this.idx], this.$emit("update:modelValue", this.oldValue), this.$emit("change", this.oldValue);
    },
    changeType(e) {
      if (e !== void 0) {
        if (this.idx === e)
          return;
        this.idx = e;
      } else
        this.idx++, this.idx > 4 && (this.idx = 0);
      this.unit[this.idx] === "auto" ? (this.oldValue = "auto", this.$emit("update:modelValue", "auto"), this.$emit("change", "auto")) : this.submit();
    }
  },
  created() {
    this.parseValue();
  }
}), jb = { class: "_fd-size-input" };
function zb(e, o, i, l, n, u) {
  const f = ie("el-button"), p = ie("ElInputNumber"), c = ie("el-dropdown-item"), v = ie("el-dropdown-menu"), b = ie("el-dropdown");
  return Z(), fe("div", jb, [
    e.unit[e.idx] === "auto" ? (Z(), we(f, {
      key: 0,
      style: { width: "150px" },
      onClick: o[0] || (o[0] = (y) => e.changeType())
    }, {
      default: Y(() => [
        xe(ve(e.unit[e.idx]), 1)
      ]),
      _: 1
    })) : (Z(), fe(ze, { key: 1 }, [
      X(p, {
        modelValue: e.num,
        "onUpdate:modelValue": o[1] || (o[1] = (y) => e.num = y),
        onChange: e.submit,
        "controls-position": "right"
      }, null, 8, ["modelValue", "onChange"]),
      X(b, {
        trigger: "click",
        size: "small"
      }, {
        dropdown: Y(() => [
          X(v, null, {
            default: Y(() => [
              (Z(!0), fe(ze, null, ft(e.unit, (y, E) => (Z(), we(c, {
                key: y,
                onClick: (w) => e.changeType(E)
              }, {
                default: Y(() => [
                  _("div", null, ve(y), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))), 128))
            ]),
            _: 1
          })
        ]),
        default: Y(() => [
          X(f, null, {
            default: Y(() => [
              xe(ve(e.unit[e.idx]), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 64))
  ]);
}
const lu = /* @__PURE__ */ qe(Ub, [["render", zb]]);
const Wb = et({
  name: "ColorInput",
  inject: ["designer"],
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: String
  },
  watch: {
    modelValue() {
      this.value = this.modelValue || "";
    },
    value(e) {
      this.$emit("update:modelValue", e), this.$emit("change", e);
    }
  },
  data() {
    return {
      value: this.modelValue || ""
    };
  },
  methods: {},
  created() {
  }
}), Gb = { class: "_fd-color-input" };
function Yb(e, o, i, l, n, u) {
  const f = ie("el-color-picker"), p = ie("el-input");
  return Z(), fe("div", Gb, [
    X(p, {
      clearable: "",
      modelValue: e.value,
      "onUpdate:modelValue": o[1] || (o[1] = (c) => e.value = c)
    }, {
      append: Y(() => [
        X(f, {
          "show-alpha": "",
          "color-format": "hex",
          modelValue: e.value,
          "onUpdate:modelValue": o[0] || (o[0] = (c) => e.value = c)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const $o = /* @__PURE__ */ qe(Wb, [["render", Yb]]);
const Qb = et({
  name: "FieldInput",
  inject: ["designer"],
  emits: ["update:modelValue"],
  props: {
    modelValue: String
  },
  computed: {
    fieldList() {
      return this.designer.setupState.fieldList || [];
    },
    fieldReadonly() {
      return this.designer.setupState.fieldReadonly;
    },
    activeRule() {
      return this.designer.setupState.activeRule;
    },
    t() {
      return this.designer.setupState.t;
    }
  },
  data() {
    return {
      value: this.modelValue || "",
      oldValue: ""
    };
  },
  watch: {
    modelValue(e) {
      this.value = e;
    }
  },
  methods: {
    getSubChildren() {
      let e = this.designer.setupState.getSubFormChildren(this.activeRule) || [];
      return e = st.trueArray(e) ? e : this.designer.setupState.children, e;
    },
    getSubFieldChildren() {
      const e = this.getSubChildren(), o = [], i = (l) => (l && l.forEach((n) => {
        n && n._fc_drag_tag && n.field ? o.push({ ...n, children: [] }) : n && n.children && i(n.children);
      }), o);
      return i(e);
    },
    checkValue() {
      const e = this.oldValue, o = _s(e);
      let i = (this.value || "").replace(/[\s\　]/g, "");
      if (i)
        if (/^[a-zA-Z]/.test(i)) {
          if (e !== i) {
            const l = i.indexOf(".") > -1;
            if (l && (i = i.replaceAll(".", "_")), this.getSubFieldChildren().filter((n) => n.field === i).length > 0)
              return _t(this.t("computed.fieldExist", { label: i })), e;
            if (o) {
              const n = /"_computed"\s*:\s*(\{\s*(?:"[^"]*"\s*:\s*"(?:\\"|[^"])*"(?:,\s*)?)*\})/g, u = this.getSubChildren(), f = JSON.stringify(u).replace(JSON.stringify(this.activeRule), "");
              let p;
              for (; (p = n.exec(f)) !== null;) {
                const c = JSON.parse(p[1]);
                let v = !1;
                if (Object.keys(c).forEach((b) => {
                  if (!v) {
                    const y = new RegExp(`(${o})(?![a-zA-Z0-9_$])`, "g");
                    v = !!c[b].match(y);
                  }
                }), v)
                  return _t(this.t("computed.fieldUsed", { label: e })), e;
              }
            }
            if (l)
              return i;
          }
        } else
          return _t(this.t("computed.fieldChar")), e;
      else
        return _t(this.t("computed.fieldEmpty")), e;
      return this.oldValue = "", i;
    },
    onFocus() {
      this.oldValue = this.value;
    },
    makeField() {
      this.oldValue = this.value, this.value = We(), this.onInput();
    },
    onInput() {
      this.value !== this.modelValue && (this.value = this.checkValue(), this.value !== this.modelValue && this.$emit("update:modelValue", this.value));
    }
  }
}), Kb = { class: "_fd-field-input" };
function Jb(e, o, i, l, n, u) {
  const f = ie("el-input"), p = ie("el-tree-select");
  return Z(), fe("div", Kb, [
    e.fieldList.length ? (Z(), we(p, {
      key: 1,
      modelValue: e.value,
      "onUpdate:modelValue": o[2] || (o[2] = (c) => e.value = c),
      readonly: e.fieldReadonly,
      "allow-create": !e.fieldReadonly,
      filterable: !0,
      "default-first-option": !e.fieldReadonly,
      "popper-class": "_fd-field-popper",
      onFocus: e.onFocus,
      onChange: e.onInput,
      data: e.fieldList
    }, null, 8, ["modelValue", "readonly", "allow-create", "default-first-option", "onFocus", "onChange", "data"])) : (Z(), we(f, {
      key: 0,
      modelValue: e.value,
      "onUpdate:modelValue": o[1] || (o[1] = (c) => e.value = c),
      readonly: e.fieldReadonly,
      disabled: e.fieldReadonly,
      onFocus: e.onFocus,
      onBlur: e.onInput
    }, Kh({ _: 2 }, [
      e.fieldReadonly ? void 0 : {
        name: "append",
        fn: Y(() => [
          _("i", {
            class: "fc-icon icon-auto",
            onClick: o[0] || (o[0] = (...c) => e.makeField && e.makeField(...c))
          })
        ]),
        key: "0"
      }
    ]), 1032, ["modelValue", "readonly", "disabled", "onFocus", "onBlur"]))
  ]);
}
const Xb = /* @__PURE__ */ qe(Qb, [["render", Jb]]);
const Zb = et({
  name: "BoxSizeInput",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },
  inject: ["designer"],
  emits: ["update:modelValue", "change"],
  data() {
    return {
      position: ["Top", "Right", "Bottom", "Left"],
      boxStyle: {
        margin: "",
        padding: "",
        marginLeft: "",
        marginRight: "",
        marginTop: "",
        marginBottom: "",
        paddingLeft: "",
        paddingRight: "",
        paddingTop: "",
        paddingBottom: "",
        width: "",
        height: ""
      },
      marginLock: !1,
      paddingLock: !1
    };
  },
  watch: {
    modelValue() {
      this.tidyValue();
    }
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  },
  methods: {
    tidyValue() {
      this.boxStyle = {}, ["margin", "padding"].forEach((e) => {
        this.boxStyle[e] = this.modelValue[e] || "", this.position.forEach((o) => {
          this.boxStyle[e + o] = this.tidySize(this.modelValue[e + o] || this.modelValue[e] || "");
        });
      }), this.boxStyle.height = this.tidySize(this.modelValue.height), this.boxStyle.width = this.tidySize(this.modelValue.width || "");
    },
    onInput() {
      const e = Object.keys(this.boxStyle).reduce((o, i) => (this.boxStyle[i] !== "" && (o[i] = this.boxStyle[i]), o), {});
      this.$emit("update:modelValue", e), this.$emit("change", e);
    },
    tidySize(e) {
      if (!/^(\d*\.?\d+)(px|rem|%|vh|vw|em)$/.test(e)) {
        const i = parseInt(e);
        return isNaN(i) ? "" : i + "px";
      }
      return e;
    },
    setValue(e, o, i) {
      const l = this.tidySize(i.target.value);
      e ? this[e + "Lock"] ? this.position.forEach((n) => {
        this.boxStyle[e + n] = l;
      }) : this.boxStyle[e + o] = l : this.boxStyle[o] = l, this.onInput();
    },
    change(e, o) {
      this.boxStyle[e] = o.target.value;
    },
    clear(e) {
      this.position.forEach((o) => {
        this.boxStyle[e + o] = "";
      });
    },
    lock(e) {
      const o = e + "Lock";
      this[o] = !this[o];
    }
  },
  created() {
    this.tidyValue();
  }
}), qb = { class: "_fd-box-size-input" }, _b = { class: "_padding" }, e1 = { class: "_padding-title" }, t1 = ["value"], n1 = ["value"], r1 = ["value"], i1 = ["value"], o1 = { class: "_fd-help" }, l1 = { class: "_margin" }, a1 = { class: "_margin-title" }, s1 = { class: "_fd-help" }, u1 = ["value"], d1 = ["value"], f1 = ["value"], c1 = ["value"], p1 = { class: "_box" }, h1 = ["value"], v1 = /* @__PURE__ */ _("div", { class: "_fd-x" }, "x", -1), m1 = ["value"];
function g1(e, o, i, l, n, u) {
  return Z(), fe("div", qb, [
    _("div", _b, [
      _("span", e1, ve(e.t("style.margin")), 1),
      _("input", {
        class: "_fd-input _fd-top",
        placeholder: "      ",
        value: e.boxStyle.marginTop,
        type: "text",
        onBlur: o[0] || (o[0] = (f) => e.setValue("margin", "Top", f)),
        onInput: o[1] || (o[1] = (f) => e.change("marginTop", f))
      }, null, 40, t1),
      _("input", {
        class: "_fd-input _fd-right",
        placeholder: "      ",
        value: e.boxStyle.marginRight,
        type: "text",
        onBlur: o[2] || (o[2] = (f) => e.setValue("margin", "Right", f)),
        onInput: o[3] || (o[3] = (f) => e.change("marginRight", f))
      }, null, 40, n1),
      _("input", {
        class: "_fd-input _fd-bottom",
        placeholder: "      ",
        value: e.boxStyle.marginBottom,
        type: "text",
        onBlur: o[4] || (o[4] = (f) => e.setValue("margin", "Bottom", f)),
        onInput: o[5] || (o[5] = (f) => e.change("marginBottom", f))
      }, null, 40, r1),
      _("input", {
        class: "_fd-input _fd-left",
        placeholder: "      ",
        value: e.boxStyle.marginLeft,
        type: "text",
        onBlur: o[6] || (o[6] = (f) => e.setValue("margin", "Left", f)),
        onInput: o[7] || (o[7] = (f) => e.change("marginLeft", f))
      }, null, 40, i1),
      _("div", o1, [
        _("i", {
          class: ot(["fc-icon icon-lock", e.marginLock ? "active" : ""]),
          title: "lock",
          onClick: o[8] || (o[8] = (f) => e.lock("margin"))
        }, null, 2),
        _("i", {
          class: "fc-icon icon-minus",
          title: "clear",
          onClick: o[9] || (o[9] = (f) => e.clear("margin"))
        })
      ]),
      _("div", l1, [
        _("span", a1, ve(e.t("style.padding")), 1),
        _("div", s1, [
          _("i", {
            class: ot(["fc-icon icon-lock", e.paddingLock ? "active" : ""]),
            title: "lock",
            onClick: o[10] || (o[10] = (f) => e.lock("padding"))
          }, null, 2),
          _("i", {
            class: "fc-icon icon-minus",
            title: "clear",
            onClick: o[11] || (o[11] = (f) => e.clear("padding"))
          })
        ]),
        _("input", {
          class: "_fd-input _fd-top",
          placeholder: "      ",
          value: e.boxStyle.paddingTop,
          type: "text",
          onBlur: o[12] || (o[12] = (f) => e.setValue("padding", "Top", f)),
          onInput: o[13] || (o[13] = (f) => e.change("paddingTop", f))
        }, null, 40, u1),
        _("input", {
          class: "_fd-input _fd-right",
          placeholder: "      ",
          value: e.boxStyle.paddingRight,
          type: "text",
          onBlur: o[14] || (o[14] = (f) => e.setValue("padding", "Right", f)),
          onInput: o[15] || (o[15] = (f) => e.change("paddingRight", f))
        }, null, 40, d1),
        _("input", {
          class: "_fd-input _fd-bottom",
          placeholder: "      ",
          value: e.boxStyle.paddingBottom,
          type: "text",
          onBlur: o[16] || (o[16] = (f) => e.setValue("padding", "Bottom", f)),
          onInput: o[17] || (o[17] = (f) => e.change("paddingBottom", f))
        }, null, 40, f1),
        _("input", {
          class: "_fd-input _fd-left",
          placeholder: "      ",
          value: e.boxStyle.paddingLeft,
          type: "text",
          onBlur: o[18] || (o[18] = (f) => e.setValue("padding", "Left", f)),
          onInput: o[19] || (o[19] = (f) => e.change("paddingLeft", f))
        }, null, 40, c1),
        _("div", p1, [
          _("input", {
            class: "_fd-input",
            placeholder: "      ",
            value: e.boxStyle.width,
            type: "text",
            onBlur: o[20] || (o[20] = (f) => e.setValue("", "width", f)),
            onInput: o[21] || (o[21] = (f) => e.change("width", f))
          }, null, 40, h1),
          v1,
          _("input", {
            class: "_fd-input",
            placeholder: "      ",
            value: e.boxStyle.height,
            type: "text",
            onBlur: o[22] || (o[22] = (f) => e.setValue("", "height", f)),
            onInput: o[23] || (o[23] = (f) => e.change("height", f))
          }, null, 40, m1)
        ])
      ])
    ])
  ]);
}
const y1 = /* @__PURE__ */ qe(Zb, [["render", g1]]);
const b1 = et({
  name: "ConfigItem",
  props: {
    label: String,
    info: String,
    appendBackground: String,
    arrow: {
      type: Boolean,
      default: !0
    },
    showAppend: Boolean
  },
  data() {
    return {
      visit: !1
    };
  }
}), A1 = { class: "_fd-config-item" }, C1 = { class: "_fd-ci-head" }, S1 = {
  key: 0,
  class: "_fd-ci-con"
}, E1 = {
  key: 1,
  class: "_fd-ci-info"
};
function w1(e, o, i, l, n, u) {
  return Z(), fe("div", A1, [
    _("div", C1, [
      _("div", {
        class: ot(["_fd-ci-label", e.$slots.append && e.arrow !== !1 ? "is-arrow" : ""]),
        onClick: o[0] || (o[0] = (f) => e.visit = e.$slots.append && e.arrow !== !1 && !e.visit)
      }, [
        _("span", null, ve(e.label), 1),
        e.$slots.append && e.arrow !== !1 ? (Z(), fe("i", {
          key: 0,
          class: ot(["fc-icon icon-arrow", e.showAppend || e.visit ? "down" : ""])
        }, null, 2)) : Se("", !0)
      ], 2),
      e.$slots.default || e.info ? (Z(), fe("div", S1, [
        e.$slots.default ? en(e.$slots, "default", { key: 0 }) : (Z(), fe("span", E1, ve(e.info), 1))
      ])) : Se("", !0)
    ]),
    e.showAppend || e.visit ? (Z(), fe("div", {
      key: 0,
      class: "_fd-ci-append",
      style: ri("background:" + e.appendBackground)
    }, [
      en(e.$slots, "append")
    ], 4)) : Se("", !0)
  ]);
}
const Bi = /* @__PURE__ */ qe(b1, [["render", w1]]);
function Hc(e) {
  let o = e.replace(/([A-Z])/g, "-$1").toLocaleLowerCase();
  return o.indexOf("-") === 0 && (o = o.substr(1)), o;
}
function x1(e) {
  return typeof e != "object" || e === null ? e : e instanceof Array ? [...e] : { ...e };
}
const T1 = et({
  name: "BorderInput",
  components: { ColorInput: $o, SizeInput: lu, ConfigItem: Bi },
  inject: ["designer"],
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    modelValue() {
      this.tidyValue(), this.initCur();
    },
    active() {
      this.initCur();
    }
  },
  computed: {
    borderStyleStr() {
      let e = "";
      return Object.keys(this.borderStyle).forEach((o) => {
        this.borderStyle[o] !== "" && (e += Hc(o) + ": " + this.borderStyle[o] + ";");
      }, {}), e;
    }
  },
  data() {
    const e = this.designer.setupState.t;
    return {
      t: e,
      active: "",
      borderStyle: {},
      curStyle: "",
      curColor: "",
      curWidth: "",
      lineType: ["solid", "dashed", "dotted", "double"].map((o) => ({ value: o, label: e("style." + o) })),
      position: ["Top", "Left", "Bottom", "Right"],
      type: ["Style", "Color", "Width"],
      unwatch: null
    };
  },
  methods: {
    tidyValue() {
      const e = [];
      this.borderStyle = {}, ["", ...this.position].forEach((o) => {
        this.type.forEach((i) => {
          e.push("border" + o + i);
        });
      }), e.forEach((o) => {
        this.borderStyle[o] = this.modelValue[o] || "";
      });
    },
    onInput() {
      const e = Object.keys(this.borderStyle).reduce((o, i) => (this.borderStyle[i] !== "" && (o[i] = this.borderStyle[i]), o), {});
      this.$emit("update:modelValue", e), this.$emit("change", e);
    },
    pushCur() {
      this.borderStyle["border" + this.active + "Style"] = this.curStyle || "", this.borderStyle["border" + this.active + "Color"] = this.curColor || "", this.borderStyle["border" + this.active + "Width"] = this.curWidth || "", this.onInput();
    },
    initCur() {
      this.unwatch && this.unwatch(), this.curStyle = this.borderStyle["border" + this.active + "Style"] || "", this.curColor = this.borderStyle["border" + this.active + "Color"] || "", this.curWidth = this.borderStyle["border" + this.active + "Width"] || "", this.unwatch = this.$watch(() => [this.curStyle, this.curColor, this.curWidth], () => {
        this.pushCur();
      });
    }
  },
  created() {
    this.tidyValue(), this.initCur();
  }
}), D1 = /* @__PURE__ */ _("div", { class: "line-box-con" }, null, -1), I1 = [
  D1
], R1 = { class: "_fd-border-input" }, F1 = { class: "_fd-bi-left" }, M1 = { class: "_fd-bil-row" }, O1 = { class: "_fd-bil-row" }, N1 = { class: "_fd-bil-row" }, L1 = { class: "_fd-bi-right" }, P1 = { class: "_fd-bi-opt" };
function $1(e, o, i, l, n, u) {
  const f = ie("el-option"), p = ie("el-select"), c = ie("SizeInput"), v = ie("ColorInput"), b = ie("ConfigItem");
  return Z(), we(b, {
    label: e.t("style.border")
  }, {
    append: Y(() => [
      _("div", R1, [
        _("div", F1, [
          _("div", M1, [
            _("div", {
              class: ot(["_fd-bil-col", e.active === "Top" ? "active" : ""]),
              onClick: o[0] || (o[0] = (y) => e.active = "Top")
            }, "\u2533 ", 2)
          ]),
          _("div", O1, [
            _("div", {
              class: ot(["_fd-bil-col", e.active === "Left" ? "active" : ""]),
              onClick: o[1] || (o[1] = (y) => e.active = "Left")
            }, "\u2523 ", 2),
            _("div", {
              class: ot(["_fd-bil-col", e.active === "" ? "active" : ""]),
              onClick: o[2] || (o[2] = (y) => e.active = "")
            }, "\u254B", 2),
            _("div", {
              class: ot(["_fd-bil-col", e.active === "Right" ? "active" : ""]),
              onClick: o[3] || (o[3] = (y) => e.active = "Right")
            }, " \u252B ", 2)
          ]),
          _("div", N1, [
            _("div", {
              class: ot(["_fd-bil-col", e.active === "Bottom" ? "active" : ""]),
              onClick: o[4] || (o[4] = (y) => e.active = "Bottom")
            }, "\u253B ", 2)
          ])
        ]),
        _("div", L1, [
          X(p, {
            modelValue: e.curStyle,
            "onUpdate:modelValue": o[5] || (o[5] = (y) => e.curStyle = y),
            clearable: ""
          }, {
            default: Y(() => [
              (Z(!0), fe(ze, null, ft(e.lineType, (y) => (Z(), we(f, {
                key: y.value,
                label: y.label,
                value: y.value
              }, {
                default: Y(() => [
                  _("div", P1, [
                    _("div", {
                      class: ot(["_line", y.value])
                    }, null, 2)
                  ])
                ]),
                _: 2
              }, 1032, ["label", "value"]))), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          X(c, {
            modelValue: e.curWidth,
            "onUpdate:modelValue": o[6] || (o[6] = (y) => e.curWidth = y)
          }, null, 8, ["modelValue"]),
          X(v, {
            modelValue: e.curColor,
            "onUpdate:modelValue": o[7] || (o[7] = (y) => e.curColor = y)
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    default: Y(() => [
      _("div", {
        class: "line-box",
        style: ri(e.borderStyleStr)
      }, I1, 4)
    ]),
    _: 1
  }, 8, ["label"]);
}
const B1 = /* @__PURE__ */ qe(T1, [["render", $1]]);
const k1 = et({
  name: "RadiusInput",
  components: { ConfigItem: Bi, ColorInput: $o, SizeInput: lu },
  inject: ["designer"],
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: String
  },
  watch: {
    modelValue(e) {
      e !== this.oldValue && this.tidyValue();
    }
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  },
  data() {
    return {
      visit: !1,
      active: "",
      style: {
        com: "",
        left: "",
        right: "",
        top: "",
        bottom: ""
      },
      unit: ["px", "%"],
      oldValue: ""
    };
  },
  methods: {
    batch() {
      this.style.left = this.style.com, this.style.right = this.style.com, this.style.top = this.style.com, this.style.bottom = this.style.com, this.onInput();
    },
    tidyValue() {
      if (this.style = {
        com: "",
        left: "",
        right: "",
        top: "",
        bottom: ""
      }, !this.modelValue)
        return;
      let e = (this.modelValue || "").split(" ").filter((o) => o !== "");
      e.length === 1 ? e = [e[0], e[0], e[0], e[0]] : e.length === 2 ? e = [e[0], e[1], e[0], e[1]] : e.length === 3 && (e = [e[0], e[1], e[2], e[1]]), this.style.left = e[0], this.style.top = e[1], this.style.right = e[2], this.style.bottom = e[3], this.updateCom();
    },
    updateCom() {
      let e = `${this.style.left || "0px"} ${this.style.top || "0px"} ${this.style.right || "0px"} ${this.style.bottom || "0px"}`;
      this.style.com = e.replaceAll(this.style.left, "").trim() === "" ? this.style.left : "";
    },
    onInput() {
      let e = `${this.style.left || "0px"} ${this.style.top || "0px"} ${this.style.right || "0px"} ${this.style.bottom || "0px"}`;
      `${this.style.left}${this.style.top}${this.style.right}${this.style.bottom}`.trim() === "" ? e = "" : this.updateCom(), this.oldValue = e, this.$emit("update:modelValue", e), this.$emit("change", e);
    }
  },
  created() {
    this.tidyValue();
  }
}), H1 = { class: "_fd-radius-input" }, V1 = { class: "_fd-radius-con" }, U1 = { class: "_fd-radius-item" }, j1 = /* @__PURE__ */ _("div", {
  class: "_fd-radius-icon",
  style: { transform: "rotate(180deg)" }
}, [
  /* @__PURE__ */ _("i", { class: "fc-icon icon-radius" })
], -1), z1 = { class: "_fd-radius-item" }, W1 = /* @__PURE__ */ _("div", {
  class: "_fd-radius-icon",
  style: { transform: "rotate(-90deg)" }
}, [
  /* @__PURE__ */ _("i", { class: "fc-icon icon-radius" })
], -1), G1 = { class: "_fd-radius-item" }, Y1 = /* @__PURE__ */ _("div", {
  class: "_fd-radius-icon",
  style: { transform: "rotate(90deg)" }
}, [
  /* @__PURE__ */ _("i", { class: "fc-icon icon-radius" })
], -1), Q1 = { class: "_fd-radius-item" }, K1 = /* @__PURE__ */ _("div", { class: "_fd-radius-icon" }, [
  /* @__PURE__ */ _("i", { class: "fc-icon icon-radius" })
], -1);
function J1(e, o, i, l, n, u) {
  const f = ie("SizeInput"), p = ie("ConfigItem");
  return Z(), fe("div", H1, [
    X(p, {
      label: e.t("style.borderRadius")
    }, {
      append: Y(() => [
        _("div", V1, [
          _("div", U1, [
            j1,
            X(f, {
              unit: e.unit,
              modelValue: e.style.left,
              "onUpdate:modelValue": o[1] || (o[1] = (c) => e.style.left = c),
              onChange: e.onInput
            }, null, 8, ["unit", "modelValue", "onChange"])
          ]),
          _("div", z1, [
            W1,
            X(f, {
              unit: e.unit,
              modelValue: e.style.top,
              "onUpdate:modelValue": o[2] || (o[2] = (c) => e.style.top = c),
              onChange: e.onInput
            }, null, 8, ["unit", "modelValue", "onChange"])
          ]),
          _("div", G1, [
            Y1,
            X(f, {
              unit: e.unit,
              modelValue: e.style.bottom,
              "onUpdate:modelValue": o[3] || (o[3] = (c) => e.style.bottom = c),
              onChange: e.onInput
            }, null, 8, ["unit", "modelValue", "onChange"])
          ]),
          _("div", Q1, [
            K1,
            X(f, {
              unit: e.unit,
              modelValue: e.style.right,
              "onUpdate:modelValue": o[4] || (o[4] = (c) => e.style.right = c),
              onChange: e.onInput
            }, null, 8, ["unit", "modelValue", "onChange"])
          ])
        ])
      ]),
      default: Y(() => [
        X(f, {
          unit: e.unit,
          modelValue: e.style.com,
          "onUpdate:modelValue": o[0] || (o[0] = (c) => e.style.com = c),
          onChange: e.batch
        }, null, 8, ["unit", "modelValue", "onChange"])
      ]),
      _: 1
    }, 8, ["label"])
  ]);
}
const X1 = /* @__PURE__ */ qe(k1, [["render", J1]]);
const Z1 = et({
  name: "DisplayInput",
  components: { ConfigItem: Bi },
  inject: ["designer"],
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: Object
  },
  watch: {
    modelValue() {
      this.tidyValue();
    }
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  },
  data() {
    return {
      style: {},
      displayOptions: [
        { value: "block", icon: "block" },
        { value: "inline-block", icon: "inlineblock" },
        { value: "inline", icon: "inline" },
        { value: "flex", icon: "flex" }
      ],
      options: [
        {
          key: "flexDirection",
          items: [
            { value: "row", icon: "direction-row" },
            { value: "column", icon: "direction-column" },
            { value: "row-reverse", icon: "direction-rowreverse" },
            { value: "column-reverse", icon: "direction-columnreverse" }
          ]
        },
        {
          key: "flexWrap",
          items: [
            { value: "nowrap", icon: "flex-nowrap", row: !0 },
            { value: "wrap", icon: "flex-wrap", row: !0 }
          ]
        },
        {
          key: "alignContent",
          items: [
            { value: "center", icon: "align-center", row: !0 },
            { value: "flex-start", icon: "align-flexstart", row: !0 },
            { value: "flex-end", icon: "align-flexend", row: !0 },
            { value: "space-around", icon: "align-spacearound", row: !0 },
            { value: "space-between", icon: "align-spacebetween", row: !0 },
            { value: "stretch", icon: "align-stretch", row: !0 }
          ]
        },
        {
          key: "justifyContent",
          items: [
            { value: "center", icon: "justify-center", row: !0 },
            { value: "flex-start", icon: "justify-flexstart", row: !0 },
            { value: "flex-end", icon: "justify-flexend", row: !0 },
            { value: "space-between", icon: "justify-spacebetween", row: !0 },
            { value: "space-around", icon: "justify-spacearound", row: !0 },
            { value: "space-evenly", icon: "justify-stretch", row: !0 }
          ]
        },
        {
          key: "alignItems",
          items: [
            { value: "center", icon: "alignitems-center", row: !0 },
            { value: "flex-start", icon: "alignitems-flexstart", row: !0 },
            { value: "flex-end", icon: "alignitems-flexend", row: !0 },
            { value: "stretch", icon: "alignitems-stretch", row: !0 },
            { value: "baseline", icon: "alignitems-baseline" }
          ]
        }
      ]
    };
  },
  methods: {
    tidyValue() {
      this.style = {
        display: "",
        flexDirection: "",
        flexWrap: "",
        alignContent: "",
        justifyContent: "",
        alignItems: ""
      }, this.modelValue && Object.keys(this.style).forEach((e) => {
        this.modelValue[e] && (this.style[e] = this.modelValue[e]);
      });
    },
    onInput() {
      const e = Object.keys(this.style).reduce((o, i) => (this.style[i] !== "" && (o[i] = this.style[i]), o), {});
      this.$emit("update:modelValue", e), this.$emit("change", e);
    },
    radioClick(e, o) {
      const i = this.style[e];
      this.style[e] === o.value ? this.style[e] = "" : e === "display" && o.value !== "flex" ? this.style = {
        display: o.value,
        flexDirection: "",
        flexWrap: "",
        alignContent: "",
        justifyContent: "",
        alignItems: ""
      } : this.style[e] = o.value, this.style[e] !== i && this.onInput();
    }
  },
  created() {
    this.tidyValue();
  }
}), q1 = { class: "_fd-display-input" }, _1 = { class: "_fd-display-raw" }, eA = { class: "_label" };
function tA(e, o, i, l, n, u) {
  const f = ie("el-radio-button"), p = ie("el-tooltip"), c = ie("el-radio-group"), v = ie("ConfigItem");
  return Z(), fe("div", q1, [
    X(v, {
      label: e.t("style.display.name"),
      arrow: !1,
      showAppend: e.style.display === "flex"
    }, {
      append: Y(() => [
        _("div", {
          class: ot(["_fd-display-con", [e.style.flexDirection, ["column", "column-reverse"].indexOf(e.style.flexDirection) > -1 ? "rotate-flag" : ""]])
        }, [
          (Z(!0), fe(ze, null, ft(e.options, (b) => (Z(), fe("div", _1, [
            _("div", eA, ve(e.t("style." + b.key + ".name")) + ": ", 1),
            X(c, {
              "model-value": e.style[b.key],
              size: "small"
            }, {
              default: Y(() => [
                (Z(!0), fe(ze, null, ft(b.items, (y) => (Z(), we(p, {
                  effect: "dark",
                  content: e.t("style." + b.key + "." + y.value),
                  placement: "top",
                  persistent: "",
                  "hide-after": 0,
                  key: y.value
                }, {
                  default: Y(() => [
                    X(f, {
                      label: y.value,
                      value: y.value,
                      onClick: (E) => e.radioClick(b.key, y)
                    }, {
                      default: Y(() => [
                        _("span", {
                          class: ot(y.row ? "rotate" : "")
                        }, [
                          _("i", {
                            class: ot(["fc-icon", "icon-" + y.icon])
                          }, null, 2)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["label", "value", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["content"]))), 128))
              ]),
              _: 2
            }, 1032, ["model-value"])
          ]))), 256))
        ], 2)
      ]),
      default: Y(() => [
        X(c, {
          "model-value": e.style.display,
          size: "small",
          style: { width: "150px" }
        }, {
          default: Y(() => [
            (Z(!0), fe(ze, null, ft(e.displayOptions, (b) => (Z(), we(p, {
              effect: "dark",
              content: e.t("style.display." + b.value),
              placement: "top",
              persistent: "",
              "hide-after": 0,
              key: b.value
            }, {
              default: Y(() => [
                X(f, {
                  label: b.value,
                  value: b.value,
                  onClick: (y) => e.radioClick("display", b)
                }, {
                  default: Y(() => [
                    _("i", {
                      class: ot(["fc-icon", "icon-display-" + b.icon])
                    }, null, 2)
                  ]),
                  _: 2
                }, 1032, ["label", "value", "onClick"])
              ]),
              _: 2
            }, 1032, ["content"]))), 128))
          ]),
          _: 1
        }, 8, ["model-value"])
      ]),
      _: 1
    }, 8, ["label", "showAppend"])
  ]);
}
const nA = /* @__PURE__ */ qe(Z1, [["render", tA]]);
const rA = et({
  name: "ShadowContent",
  components: { ColorInput: $o },
  inject: ["designer"],
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: {
      default: "0px 0px 0px rgba(0, 0, 0, 0)",
      type: String
    }
  },
  data() {
    return {
      max: 24,
      boxSize: 250,
      options: [
        { key: "external", icon: "shadow" },
        { key: "inset", icon: "shadow-inset" }
      ],
      form: {
        color: "",
        type: "external",
        x: 0,
        y: 0,
        vague: 0,
        extend: 0,
        x_unit: "px",
        y_unit: "px",
        vague_unit: "px",
        extend_unit: "px"
      },
      units: ["px", "%", "rem", "em", "vw", "vh"],
      down: !1,
      position: {
        left: 0,
        top: 0
      }
    };
  },
  computed: {
    spotStyle() {
      return {
        left: this.position.left + "px",
        top: this.position.top + "px"
      };
    },
    t() {
      return this.designer.setupState.t;
    }
  },
  watch: {
    position(e) {
      this.form.x = parseInt(String((e.left - this.boxSize / 2) / this.boxSize * this.max)), this.form.y = parseInt(String((e.top - this.boxSize / 2) / this.boxSize * this.max));
      const o = this.max / 2;
      this.form.x = this.form.x < 0 ? Math.max(this.form.x, o * -1) : Math.min(this.form.x, o), this.form.y = this.form.y < 0 ? Math.max(this.form.y, o * -1) : Math.min(this.form.y, o);
    },
    modelValue(e) {
      this.initStyle(e);
    }
  },
  methods: {
    getMouseXY(e, o) {
      if (this.down || o) {
        const i = this.$refs.box.getBoundingClientRect();
        this.position = {
          left: parseInt(String(e.clientX - i.x)),
          top: parseInt(String(e.clientY - i.y))
        };
      }
    },
    onMouseup() {
      this.down = !1, this.onInput();
    },
    onMousedown(e) {
      this.getMouseXY(e, !0), this.down = !0;
    },
    onInput() {
      const e = this.form;
      let o = `${e.x}${e.x_unit} ${e.y}${e.y_unit} ${e.vague}${e.vague_unit} ${e.extend}${e.extend_unit} ${e.color}`;
      `${e.x}${e.y}${e.vague}${e.extend}`.replaceAll("0", "") === "" ? o = "" : e.type === "inset" && (o += " inset"), this.$emit("update:modelValue", o), this.$emit("change", o);
    },
    initStyle(e) {
      (this.modelValue || "").indexOf(" inset") > -1 && (this.form.type = "inset", e = e.replace(" inset", ""));
      const o = e.split("rgba");
      let i, l;
      o.length > 1 ? (i = "rgba" + o[1].trim(), l = o[0].trim().split(" ")) : (l = o[0].trim().split(" "), i = l.pop()), this.form.color = i || "#000", this.form.x = parseInt(l[0]) || 0, this.form.y = parseInt(l[1]) || 0, this.form.vague = parseInt(l[2]) || 0, this.form.extend = parseInt(l[3]) || 0;
      const n = (u) => (u == null ? void 0 : u.replace(/[-\d.]/g, "")) || "px";
      this.form.x_unit = n(l[0]), this.form.y_unit = n(l[1]), this.form.vague_unit = n(l[2]), this.form.extend_unit = n(l[3]), this.position.left = this.boxSize / 2 + this.form.x / this.max * this.boxSize || 0, this.position.top = this.boxSize / 2 + this.form.y / this.max * this.boxSize || 0;
    }
  },
  mounted() {
    this.initStyle(this.modelValue);
  }
}), iA = { class: "_fd-shadow-content" }, oA = { class: "_fd-sc-right" }, lA = /* @__PURE__ */ _("i", { class: "spot-id" }, null, -1), aA = [
  lA
], sA = /* @__PURE__ */ _("span", { class: "center-spot" }, null, -1), uA = /* @__PURE__ */ _("div", { class: "x-hr" }, null, -1), dA = /* @__PURE__ */ _("div", { class: "y-hr" }, null, -1);
function fA(e, o, i, l, n, u) {
  const f = ie("el-radio-button"), p = ie("el-tooltip"), c = ie("el-radio-group"), v = ie("el-form-item"), b = ie("ColorInput"), y = ie("el-option"), E = ie("el-select"), w = ie("el-input"), h = ie("el-form");
  return Z(), fe("div", iA, [
    X(h, {
      "label-width": "50px",
      "label-position": "top",
      inline: "",
      class: "_fd-sc-form",
      size: "small"
    }, {
      default: Y(() => [
        X(v, {
          label: e.t("style.shadow.mode")
        }, {
          default: Y(() => [
            X(c, {
              modelValue: e.form.type,
              "onUpdate:modelValue": o[0] || (o[0] = (m) => e.form.type = m),
              onChange: e.onInput,
              size: "small",
              class: "_fd-sc-radio"
            }, {
              default: Y(() => [
                (Z(!0), fe(ze, null, ft(e.options, (m) => (Z(), we(p, {
                  key: m.key,
                  effect: "dark",
                  content: e.t("style.shadow." + m.key),
                  placement: "top",
                  "hide-after": 0,
                  persistent: ""
                }, {
                  default: Y(() => [
                    X(f, {
                      label: m.key,
                      value: m.key
                    }, {
                      default: Y(() => [
                        _("i", {
                          class: ot(["fc-icon", "icon-" + m.icon])
                        }, null, 2)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"])
                  ]),
                  _: 2
                }, 1032, ["content"]))), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]),
        X(v, {
          label: e.t("style.color")
        }, {
          default: Y(() => [
            X(b, {
              modelValue: e.form.color,
              "onUpdate:modelValue": o[1] || (o[1] = (m) => e.form.color = m),
              onChange: e.onInput
            }, null, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]),
        X(v, {
          label: e.t("style.shadow.x")
        }, {
          default: Y(() => [
            X(w, {
              modelValue: e.form.x,
              "onUpdate:modelValue": o[3] || (o[3] = (m) => e.form.x = m),
              type: "number",
              onChange: e.onInput
            }, {
              append: Y(() => [
                X(E, {
                  modelValue: e.form.x_unit,
                  "onUpdate:modelValue": o[2] || (o[2] = (m) => e.form.x_unit = m),
                  onChange: e.onInput
                }, {
                  default: Y(() => [
                    (Z(!0), fe(ze, null, ft(e.units, (m) => (Z(), we(y, {
                      key: m,
                      label: m,
                      value: m
                    }, null, 8, ["label", "value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]),
        X(v, {
          label: e.t("style.shadow.y")
        }, {
          default: Y(() => [
            X(w, {
              modelValue: e.form.y,
              "onUpdate:modelValue": o[5] || (o[5] = (m) => e.form.y = m),
              type: "number",
              onChange: e.onInput
            }, {
              append: Y(() => [
                X(E, {
                  modelValue: e.form.y_unit,
                  "onUpdate:modelValue": o[4] || (o[4] = (m) => e.form.y_unit = m),
                  onChange: e.onInput
                }, {
                  default: Y(() => [
                    (Z(!0), fe(ze, null, ft(e.units, (m) => (Z(), we(y, {
                      key: m,
                      label: m,
                      value: m
                    }, null, 8, ["label", "value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]),
        X(v, {
          label: e.t("style.shadow.vague")
        }, {
          default: Y(() => [
            X(w, {
              modelValue: e.form.vague,
              "onUpdate:modelValue": o[7] || (o[7] = (m) => e.form.vague = m),
              type: "number",
              onChange: e.onInput
            }, {
              append: Y(() => [
                X(E, {
                  modelValue: e.form.vague_unit,
                  "onUpdate:modelValue": o[6] || (o[6] = (m) => e.form.vague_unit = m),
                  onChange: e.onInput
                }, {
                  default: Y(() => [
                    (Z(!0), fe(ze, null, ft(e.units, (m) => (Z(), we(y, {
                      key: m,
                      label: m,
                      value: m
                    }, null, 8, ["label", "value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]),
        X(v, {
          label: e.t("style.shadow.extend")
        }, {
          default: Y(() => [
            X(w, {
              modelValue: e.form.extend,
              "onUpdate:modelValue": o[9] || (o[9] = (m) => e.form.extend = m),
              type: "number",
              onChange: e.onInput
            }, {
              append: Y(() => [
                X(E, {
                  modelValue: e.form.extend_unit,
                  "onUpdate:modelValue": o[8] || (o[8] = (m) => e.form.extend_unit = m),
                  onChange: e.onInput
                }, {
                  default: Y(() => [
                    (Z(!0), fe(ze, null, ft(e.units, (m) => (Z(), we(y, {
                      key: m,
                      label: m,
                      value: m
                    }, null, 8, ["label", "value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }),
    _("div", oA, [
      _("div", {
        ref: "box",
        class: ot(["_fd-sc-box", e.down ? "down" : ""]),
        onClick: o[10] || (o[10] = (m) => e.getMouseXY(m, 1)),
        onMousedown: o[11] || (o[11] = (...m) => e.onMousedown && e.onMousedown(...m)),
        onMouseup: o[12] || (o[12] = (...m) => e.onMouseup && e.onMouseup(...m)),
        onMousemove: o[13] || (o[13] = (m) => e.getMouseXY(m, 0))
      }, [
        _("span", {
          class: "spot",
          style: ri(e.spotStyle)
        }, aA, 4),
        sA,
        uA,
        dA
      ], 34)
    ])
  ]);
}
const cA = /* @__PURE__ */ qe(rA, [["render", fA]]);
const pA = et({
  name: "ShadowInput",
  emits: ["update:modelValue", "change"],
  components: { ConfigItem: Bi, ShadowContent: cA },
  inject: ["designer"],
  props: {
    modelValue: String
  },
  watch: {
    modelValue() {
      this.value = this.modelValue || "";
    },
    value(e) {
      this.$emit("update:modelValue", e), this.$emit("change", e);
    }
  },
  data() {
    const e = this.designer.setupState.t;
    return {
      t: e,
      options: [
        { label: e("style.shadow.classic"), value: "3px 5px 7px 2px #CBCBCBFF" },
        { label: e("style.shadow.flat"), value: "4px 4px 3px -2px #E7E5E5FF" },
        { label: e("style.shadow.solid"), value: "1px 2px 4px 2px #979797FF" }
      ],
      value: this.modelValue || ""
    };
  },
  methods: {
    changeValue(e) {
      this.value = e;
    }
  },
  created() {
  }
}), hA = { class: "_fd-shadow-input" }, vA = /* @__PURE__ */ _("i", { class: "fc-icon icon-setting" }, null, -1);
function mA(e, o, i, l, n, u) {
  const f = ie("el-dropdown-item"), p = ie("el-dropdown-menu"), c = ie("el-dropdown"), v = ie("el-input"), b = ie("ShadowContent"), y = ie("ConfigItem");
  return Z(), fe("div", hA, [
    X(y, {
      label: e.t("style.shadow.name")
    }, {
      append: Y(() => [
        X(b, {
          modelValue: e.value,
          "onUpdate:modelValue": o[1] || (o[1] = (E) => e.value = E)
        }, null, 8, ["modelValue"])
      ]),
      default: Y(() => [
        X(v, {
          clearable: "",
          modelValue: e.value,
          "onUpdate:modelValue": o[0] || (o[0] = (E) => e.value = E),
          class: "_fd-si-input"
        }, {
          append: Y(() => [
            X(c, null, {
              dropdown: Y(() => [
                X(p, null, {
                  default: Y(() => [
                    (Z(!0), fe(ze, null, ft(e.options, (E) => (Z(), we(f, {
                      onClick: (w) => e.changeValue(E.value)
                    }, {
                      default: Y(() => [
                        xe(ve(E.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))), 256))
                  ]),
                  _: 1
                })
              ]),
              default: Y(() => [
                vA
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label"])
  ]);
}
const gA = /* @__PURE__ */ qe(pA, [["render", mA]]);
const yA = et({
  name: "TableOptions",
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: [Array, Object],
    column: {
      type: Array,
      default: () => [{ label: "label", key: "label" }, { label: "value", key: "value" }]
    },
    valueType: String,
    keyValue: String,
    max: Number
  },
  inject: ["designer"],
  watch: {
    modelValue() {
      this.value = this.tidyModelValue();
    }
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    overColumn() {
      let e = this.column;
      if (this.checked) {
        for (let o = 0; o < e.length; o++)
          if (e[o].key === this.keyValue)
            return [e[o]];
      }
      return e;
    }
  },
  data() {
    return {
      value: this.tidyModelValue(),
      checked: !1
    };
  },
  created() {
    this.keyValue && (this.checked = this.isChecked(), this.$watch("checked", (e) => {
      e && this.input();
    }));
  },
  methods: {
    isChecked() {
      for (let e = 0; e < this.value.length; e++) {
        const o = this.value[e], i = Object.keys(o), l = o[this.keyValue];
        for (let n = 0; n < i.length; n++)
          if (l !== o[i[n]])
            return !1;
      }
      return !0;
    },
    tidyModelValue() {
      const e = this.modelValue;
      return this.valueType === "string" ? (e || []).map((o) => ({ value: "" + o })) : this.valueType === "object" ? Object.keys(e || {}).map((o) => ({ label: o, value: e[o] })) : [...e || []].map((o) => x1(o));
    },
    tidyValue() {
      if (this.valueType === "object") {
        const e = {};
        return this.value.forEach((o) => {
          o.label && o.value && (e[o.label] = o.value);
        }), e;
      } else
        return this.value.map((e) => {
          if (this.valueType === "string")
            return e.value;
          if (this.checked) {
            const o = e[this.keyValue];
            return this.column.reduce((i, l) => (i[l.key] = o, i), {});
          } else
            return { ...e };
        });
    },
    onInput(e) {
      if (this.column.length === 1 && !e[this.column[0].key])
        return;
      this.column.every((i) => i.required === !1 ? !0 : ["object", "string"].indexOf(this.valueType) > -1 ? e[i.key] !== void 0 && e[i.key] !== "" && e[i.key] !== null : e[i.key] !== void 0) && this.input();
    },
    input() {
      const e = this.tidyValue();
      this.$emit("update:modelValue", e), this.$emit("change", e);
    },
    add() {
      this.value.push(this.column.reduce((e, o) => (e[o.key] = "", e), {}));
    },
    del(e) {
      this.value.splice(e, 1), this.input();
    }
  }
}), bA = (e) => (Jh("data-v-f024cd9c"), e = e(), Xh(), e), AA = { class: "_td-table-opt" }, CA = ["onClick"], SA = { class: "_td-table-opt-handle" }, EA = /* @__PURE__ */ bA(() => /* @__PURE__ */ _("i", { class: "fc-icon icon-add" }, null, -1));
function wA(e, o, i, l, n, u) {
  const f = ie("el-input"), p = ie("el-table-column"), c = ie("el-table"), v = ie("el-button"), b = ie("el-checkbox");
  return Z(), fe("div", AA, [
    (Z(), we(c, {
      data: e.value,
      key: e.checked ? "2" : "1",
      border: "",
      size: "small",
      style: { width: "100%" }
    }, {
      default: Y(() => [
        (Z(!0), fe(ze, null, ft(e.overColumn, (y, E) => (Z(), we(p, {
          key: y.label + E,
          label: y.label
        }, {
          default: Y((w) => [
            X(f, {
              size: "small",
              modelValue: w.row[y.key] || "",
              "onUpdate:modelValue": (h) => w.row[y.key] = h,
              onBlur: (h) => e.onInput(w.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
          ]),
          _: 2
        }, 1032, ["label"]))), 128)),
        X(p, {
          width: "50",
          align: "center",
          fixed: "right",
          label: e.t("tableOptions.handle")
        }, {
          default: Y((y) => [
            _("i", {
              class: "fc-icon icon-delete",
              onClick: (E) => e.del(y.$index)
            }, null, 8, CA)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"])),
    _("div", SA, [
      !e.max || e.max > e.value.length ? (Z(), we(v, {
        key: 0,
        link: "",
        type: "primary",
        onClick: e.add
      }, {
        default: Y(() => [
          EA,
          xe(" " + ve(e.t("tableOptions.add")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])) : Se("", !0),
      e.keyValue ? (Z(), we(b, {
        key: 1,
        modelValue: e.checked,
        "onUpdate:modelValue": o[0] || (o[0] = (y) => e.checked = y),
        label: e.t("tableOptions.keyValue")
      }, null, 8, ["modelValue", "label"])) : Se("", !0)
    ])
  ]);
}
const Vc = /* @__PURE__ */ qe(yA, [["render", wA], ["__scopeId", "data-v-f024cd9c"]]);
const Uc = [
  "display",
  "flexDirection",
  "flexWrap",
  "alignContent",
  "justifyContent",
  "alignItems"
], tc = [
  "color",
  "backgroundColor",
  "scale",
  "borderRadius",
  "boxShadow",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "margin",
  "padding",
  "opacity",
  "height",
  "width",
  "borderStyle",
  "borderColor",
  "borderWidth",
  "borderTopStyle",
  "borderTopColor",
  "borderTopWidth",
  "borderLeftStyle",
  "borderLeftColor",
  "borderLeftWidth",
  "borderBottomStyle",
  "borderBottomColor",
  "borderBottomWidth",
  "borderRightStyle",
  "borderRightColor",
  "borderRightWidth",
  ...Uc
], xA = et({
  name: "StyleConfig",
  inject: ["designer"],
  emits: ["update:modelValue"],
  components: {
    TableOptions: Vc,
    ColorInput: $o,
    ConfigItem: Bi,
    DisplayInput: nA,
    RadiusInput: X1,
    BoxSizeInput: y1,
    BorderInput: B1,
    ShadowInput: gA
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    modelValue() {
      this.tidyStyle();
    }
  },
  data() {
    return {
      t: this.designer.setupState.t,
      formData: {},
      size: {},
      border: {},
      display: {},
      radius: "",
      backgroundColor: "",
      color: "",
      boxShadow: "",
      opacity: 100,
      scale: 100
    };
  },
  methods: {
    tidyStyle() {
      const e = { ...this.modelValue || {} }, o = {};
      Object.keys(e).forEach((f) => {
        (["margin", "padding", "height", "width"].indexOf(f) > -1 || f.indexOf("margin") > -1 || f.indexOf("padding") > -1) && (o[f] = e[f]);
      });
      const i = {};
      Object.keys(e).forEach((f) => {
        f.indexOf("border") === 0 && (i[f] = e[f]);
      });
      let l = Zn(e.opacity) ? 100 : parseFloat(e.opacity) || 0;
      l && l < 1 && (l = l * 100);
      let n = e.scale;
      Zn(e.scale) ? n = 100 : isNaN(Number(n)) ? n = parseFloat(n) || 100 : n = n > 0 ? n * 100 : 0;
      const u = {};
      Uc.forEach((f) => {
        e[f] && (u[f] = e[f]);
      }), this.opacity = l, this.scale = n, this.size = o, this.border = i, this.display = u, this.radius = e.borderRadius || "", this.boxShadow = e.boxShadow || "", this.color = e.color || "", this.backgroundColor = e.backgroundColor || "", tc.forEach((f) => {
        delete e[f];
      }), this.formData = e;
    },
    onInput() {
      let e = { ...this.formData };
      tc.forEach((i) => {
        delete e[i];
      });
      const o = {
        ...e,
        color: this.color || "",
        backgroundColor: this.backgroundColor || "",
        opacity: this.opacity >= 0 && this.opacity < 100 ? this.opacity + "%" : "",
        borderRadius: this.radius || "",
        boxShadow: this.boxShadow || "",
        scale: this.scale >= 0 && this.scale !== 100 ? this.scale + "%" : "",
        ...this.size,
        ...this.border,
        ...this.display
      };
      Object.keys(o).forEach((i) => {
        Zn(o[i]) && delete o[i];
      }), this.$emit("update:modelValue", o);
    }
  },
  created() {
    this.tidyStyle();
  }
}), TA = { class: "_fd-style-config" };
function DA(e, o, i, l, n, u) {
  const f = ie("BoxSizeInput"), p = ie("DisplayInput"), c = ie("ColorInput"), v = ie("ConfigItem"), b = ie("BorderInput"), y = ie("RadiusInput"), E = ie("ShadowInput"), w = ie("el-slider"), h = ie("TableOptions");
  return Z(), fe("div", TA, [
    X(f, {
      modelValue: e.size,
      "onUpdate:modelValue": o[0] || (o[0] = (m) => e.size = m),
      onChange: e.onInput
    }, null, 8, ["modelValue", "onChange"]),
    X(p, {
      modelValue: e.display,
      "onUpdate:modelValue": o[1] || (o[1] = (m) => e.display = m),
      onChange: e.onInput
    }, null, 8, ["modelValue", "onChange"]),
    X(v, {
      label: e.t("style.color")
    }, {
      default: Y(() => [
        X(c, {
          modelValue: e.color,
          "onUpdate:modelValue": o[2] || (o[2] = (m) => e.color = m),
          onChange: e.onInput
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _: 1
    }, 8, ["label"]),
    X(v, {
      label: e.t("style.backgroundColor")
    }, {
      default: Y(() => [
        X(c, {
          modelValue: e.backgroundColor,
          "onUpdate:modelValue": o[3] || (o[3] = (m) => e.backgroundColor = m),
          onChange: e.onInput
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _: 1
    }, 8, ["label"]),
    X(b, {
      modelValue: e.border,
      "onUpdate:modelValue": o[4] || (o[4] = (m) => e.border = m),
      onChange: e.onInput
    }, null, 8, ["modelValue", "onChange"]),
    X(y, {
      modelValue: e.radius,
      "onUpdate:modelValue": o[5] || (o[5] = (m) => e.radius = m),
      onChange: e.onInput
    }, null, 8, ["modelValue", "onChange"]),
    X(E, {
      modelValue: e.boxShadow,
      "onUpdate:modelValue": o[6] || (o[6] = (m) => e.boxShadow = m),
      onChange: e.onInput
    }, null, 8, ["modelValue", "onChange"]),
    X(v, {
      label: e.t("style.opacity"),
      class: "_fd-opacity-input"
    }, {
      default: Y(() => [
        X(w, {
          "show-tooltip": !1,
          modelValue: e.opacity,
          "onUpdate:modelValue": o[7] || (o[7] = (m) => e.opacity = m),
          onChange: e.onInput
        }, null, 8, ["modelValue", "onChange"]),
        _("span", null, ve(e.opacity) + "%", 1)
      ]),
      _: 1
    }, 8, ["label"]),
    X(v, {
      label: e.t("style.scale"),
      class: "_fd-opacity-input"
    }, {
      default: Y(() => [
        X(w, {
          min: 80,
          max: 120,
          "show-tooltip": !1,
          modelValue: e.scale,
          "onUpdate:modelValue": o[8] || (o[8] = (m) => e.scale = m),
          onChange: e.onInput
        }, null, 8, ["modelValue", "onChange"]),
        _("span", null, ve(e.scale) + "%", 1)
      ]),
      _: 1
    }, 8, ["label"]),
    X(v, {
      label: e.t("props.custom"),
      info: Object.keys(e.formData).length > 0 ? e.t("struct.configured") : ""
    }, {
      append: Y(() => [
        X(h, Vr({
          modelValue: e.formData,
          "onUpdate:modelValue": o[9] || (o[9] = (m) => e.formData = m),
          onChange: e.onInput
        }, {
          column: [{ label: e.t("props.key"), key: "label" }, { label: e.t("props.value"), key: "value" }],
          valueType: "object"
        }), null, 16, ["modelValue", "onChange"])
      ]),
      _: 1
    }, 8, ["label", "info"])
  ]);
}
const jc = /* @__PURE__ */ qe(xA, [["render", DA]]);
const IA = et({
  name: "ComputedConfig",
  props: {
    modelValue: String,
    type: String,
    title: String,
    name: String,
    btn: String
  },
  inject: ["designer"],
  data() {
    const e = (o, i, l, n = []) => {
      const u = [];
      return o.forEach(({ rule: f, children: p }) => {
        const c = [...n];
        let v = l;
        f.field && (c.push(f), v || (v = f.field === i && this.type === "value"));
        const b = e(p || [], i, v, c);
        if (f.field) {
          const y = {
            value: f.field,
            label: f.title,
            rule: f,
            parent: n,
            formula: !0,
            disabled: v
          };
          b.length && (y.children = b), u.push(y);
        } else
          u.push(...b);
      }), u;
    };
    return {
      editor: null,
      visible: !1,
      expandedKeys: [
        "_form",
        "_formula",
        "_subform"
      ],
      err: "",
      formulaInfo: "",
      formulaExample: "",
      oldValue: "",
      getFields: e
    };
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    configured() {
      return !!this.modelValue;
    },
    activeRule() {
      return this.designer.setupState.activeRule;
    },
    treeInfo() {
      let e = this.activeRule.__fc__.parent;
      const o = [
        {
          id: "_form",
          label: this.t("computed.form"),
          children: this.getFields(this.designer.setupState.treeInfo, this.activeRule.field)
        },
        {
          id: "_formula",
          label: this.t("computed.formula"),
          children: Dc.map((i) => ({
            label: this.t("formula." + i.key),
            children: i.children.map((l) => ({
              label: l,
              info: this.t("formula." + l),
              example: Ks[l] || "",
              formula: !0
            }))
          }))
        }
      ];
      for (; e;)
        if (e.rule._menu && e.rule._menu.subForm === "array") {
          const i = this.getFields(this.designer.setupState.findTree(e.rule.field), this.activeRule.field);
          i.length && o.unshift({
            id: "_subform",
            label: this.t("computed.subform"),
            children: i
          }), e = void 0;
        } else
          e = e.parent;
      return o;
    }
  },
  watch: {
    visible(e) {
      e && this.load();
    }
  },
  beforeUnmount() {
    document.querySelector("._fd-comp-script") && document.querySelector("._fd-comp-script").removeEventListener("mouseover", this.spanOver);
  },
  methods: {
    getTitle(e) {
      return (e.title || "").trim() || e._menu && e._menu.label || e.field || e._fc_id;
    },
    setField(e) {
      e.disabled !== !0 && this.markRule(`"${e.rule.field}"`, this.getTitle(e.rule), "id");
    },
    spanOver(e) {
      if (e.target.classList.contains("cm-keyword")) {
        const o = e.target.innerText.trim();
        this.formulaInfo = this.t("formula." + o) || "", this.formulaExample = Ks[o] || "";
      }
    },
    nodeOver(e) {
      this.formulaInfo = e.info || "", this.formulaExample = e.example || "";
    },
    markRule(e, o, i) {
      const l = this.editor.getValue();
      if (l) {
        const f = this.editor.getCursor().ch;
        [" ", "(", ",", ")", "{", "}", "[", "]"].indexOf(l.substr(f - 1, 1)) === -1 && this.editor.replaceRange(" ", this.editor.getCursor());
      }
      this.editor.replaceRange(e, this.editor.getCursor());
      const n = this.editor.getCursor(), u = document.createElement("span");
      u.innerText = o, u.classList.add("cm-fc-" + i), this.editor.markText({
        line: n.line,
        ch: n.ch - e.length
      }, n, {
        replacedWith: u
      });
    },
    nodeClick(e) {
      if (!(!e.formula || e.disabled === !0)) {
        if (e.rule) {
          const o = [], i = [];
          let l = !1;
          if (e.parent.forEach((n) => {
            n._menu && n._menu.subForm === "array" && (l = !0), o.push(n.field), i.push(this.getTitle(n));
          }), l)
            return this.setColumn(e);
          o.push(e.rule.field), i.push(this.getTitle(e.rule)), this.markRule(o.join("."), i.join("."), "field");
        } else
          this.editor.replaceRange(e.label + "()", this.editor.getCursor()), this.editor.moveH(-1, "char");
        this.editor.focus();
      }
    },
    setColumn(e) {
      let o = !1;
      const i = [], l = [], n = [];
      e.parent.forEach((u) => {
        !o && u._menu && u._menu.subForm === "array" ? (o = !0, i.push(u.field), l.push(this.getTitle(u))) : n.push(u);
      }), n.push(e.rule), n.reverse().forEach((u) => {
        this.nodeClick({ label: "COLUMN", formula: !0 }), this.editor.replaceRange(",", this.editor.getCursor()), this.setField({ rule: u }), this.editor.moveH(-1 - u.field.length - 2, "char");
      }), this.markRule(i.join("."), l.join("."), "field");
    },
    submit() {
      const e = this.editor.getValue().trim();
      this.oldValue !== e && (this.oldValue = e, this.$emit("update:modelValue", e)), this.visible = !1;
    },
    setValue(e) {
      const o = this.designer.setupState.fields().map(_s);
      e = e.replace(new RegExp(`["'](${o.join("|")})(\\.(${o.join("|")}))*(?![a-zA-Z0-9_$])["']`, "g"), (i) => "__var___" + i + "__var__"), e = e.replace(new RegExp(`(?<!__var___")(${o.join("|")})(\\.(${o.join("|")}))*(?![a-zA-Z0-9_$])`, "g"), (i) => "__var___" + i + "__var__"), e.split("__var__").forEach((i) => {
        let l;
        if (i.indexOf("_") === 0) {
          i = i.slice(1);
          const n = ["'", '"'].indexOf(i[0]) > -1;
          n && (i = i.slice(1).slice(0, -1));
          let u = 0;
          if (i.indexOf(".") > -1) {
            const f = i.split(".");
            i = f.pop(), u = f.length;
          }
          if (l = this.designer.setupState.dragForm.api.all().filter((f) => f && f.field === i)[0], l) {
            if (n)
              this.setField({ rule: l });
            else {
              const f = [l.field], p = [this.getTitle(l)];
              let c = l.__fc__.parent;
              for (; c && u > 0;)
                c.input && (u--, f.unshift(c.rule.field), p.unshift(this.getTitle(c.rule))), c = c.parent;
              this.markRule(f.join("."), p.join("."), "field");
            }
            return;
          }
        }
        this.editor.replaceRange(i, this.editor.getCursor());
      });
    },
    load() {
      this.oldValue = this.modelValue, this.err = this.formulaInfo = "", this.$nextTick(() => {
        document.querySelector("._fd-comp-script").addEventListener("mouseover", this.spanOver), this.editor = On(Hr(this.$refs.editor, {
          lineNumbers: !0,
          mode: "fcComputedMode",
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: "",
          extraKeys: {
            Enter: function () {
              return !1;
            }
          }
        })), this.setValue(this.modelValue || ""), this.editor.on("beforeChange", (e, o) => {
          if (o.origin === "paste") {
            const i = o.text[0] || "";
            i && this.setValue(i), o.cancel();
          }
        }), oc(this.editor);
      });
    }
  }
}), RA = { class: "_fd-computed" }, FA = ["onMouseover"], MA = {
  key: 0,
  class: "_group"
}, OA = {
  key: 1,
  class: "_subform"
}, NA = ["onClick"], LA = {
  key: 0,
  ref: "editor",
  class: "_fd-comp-script"
}, PA = {
  key: 0,
  class: "_fd-comp-info"
}, $A = { key: 0 }, BA = { key: 1 }, kA = {
  key: 2,
  style: { color: "#f56c6c" }
};
function HA(e, o, i, l, n, u) {
  const f = ie("ElButton"), p = ie("el-badge"), c = ie("el-tree"), v = ie("el-aside"), b = ie("el-header"), y = ie("el-main"), E = ie("el-container"), w = ie("ElDialog");
  return Z(), fe("div", RA, [
    X(p, {
      type: "warning",
      "is-dot": "",
      hidden: !e.configured
    }, {
      default: Y(() => [
        X(f, {
          onClick: o[0] || (o[0] = (h) => e.visible = !0),
          size: "small"
        }, {
          default: Y(() => [
            xe(ve(e.btn), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["hidden"]),
    X(w, {
      class: "_fd-comp-dialog",
      title: e.title,
      modelValue: e.visible,
      "onUpdate:modelValue": o[2] || (o[2] = (h) => e.visible = h),
      "destroy-on-close": "",
      "close-on-click-modal": !1,
      "append-to-body": "",
      width: "980px"
    }, {
      footer: Y(() => [
        _("div", null, [
          X(f, {
            onClick: o[1] || (o[1] = (h) => e.visible = !1),
            size: "default"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.cancel")), 1)
            ]),
            _: 1
          }),
          X(f, {
            type: "primary",
            onClick: e.submit,
            size: "default",
            color: "#2f73ff"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.ok")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: Y(() => [
        X(E, { class: "_fd-comp-con" }, {
          default: Y(() => [
            X(v, null, {
              default: Y(() => [
                X(c, {
                  ref: "treeRef",
                  data: e.treeInfo,
                  "default-expanded-keys": e.expandedKeys,
                  "expand-on-click-node": !1,
                  "node-key": "id",
                  onNodeClick: e.nodeClick
                }, {
                  default: Y(({ node: h, data: m }) => [
                    _("div", {
                      class: ot(["_fd-comp-node", { disabled: m.disabled }]),
                      onMouseover: (I) => e.nodeOver(m)
                    }, [
                      _("div", null, [
                        m.rule ? (Z(), fe(ze, { key: 0 }, [
                          m.rule._menu.subForm === "object" ? (Z(), fe("span", MA, "{ " + ve(e.t("props.group")) + " }", 1)) : Se("", !0),
                          m.rule._menu.subForm === "array" ? (Z(), fe("span", OA, "[ " + ve(e.t("props.collection")) + " ]", 1)) : Se("", !0)
                        ], 64)) : Se("", !0),
                        _("span", null, ve((m.label || "").trim() || e.getTitle(m.rule)), 1)
                      ]),
                      m.rule ? (Z(), fe("span", {
                        key: 0,
                        class: "_fd-comp-id",
                        onClick: yt((I) => e.setField(m), ["stop"])
                      }, " ID ", 8, NA)) : Se("", !0)
                    ], 42, FA)
                  ]),
                  _: 1
                }, 8, ["data", "default-expanded-keys", "onNodeClick"])
              ]),
              _: 1
            }),
            X(y, null, {
              default: Y(() => [
                X(E, { class: "_fd-comp-r" }, {
                  default: Y(() => [
                    X(b, {
                      class: "_fd-comp-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        xe(ve(e.name), 1)
                      ]),
                      _: 1
                    }),
                    X(y, null, {
                      default: Y(() => [
                        e.visible ? (Z(), fe("div", LA, null, 512)) : Se("", !0)
                      ]),
                      _: 1
                    }),
                    e.formulaInfo || e.err ? (Z(), fe("div", PA, [
                      e.formulaInfo ? (Z(), fe("div", $A, ve(e.t("computed.formulaInfo")) + ": " + ve(e.formulaInfo), 1)) : Se("", !0),
                      e.formulaExample ? (Z(), fe("div", BA, ve(e.t("computed.formulaExample")) + ": " + ve(e.formulaExample), 1)) : Se("", !0),
                      e.err ? (Z(), fe("div", kA, ve(e.t("validate.message")) + ": " + ve(e.err), 1)) : Se("", !0)
                    ])) : Se("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]);
}
const VA = /* @__PURE__ */ qe(IA, [["render", HA]]);
const UA = "[[FORM-CREATE-PREFIX-", jA = "-FORM-CREATE-SUFFIX]]", zA = et({
  name: "FnConfig",
  emits: ["update:modelValue"],
  props: {
    modelValue: [Object, void 0, null],
    eventConfig: {
      type: Array,
      default: () => []
    }
  },
  inject: ["designer"],
  components: {
    FnEditor: Po
  },
  data() {
    return {
      visible: !1,
      activeData: null,
      defActive: "no",
      event: {},
      cus: !1,
      eventStr: ""
    };
  },
  computed: {
    eventInfo() {
      const e = {};
      return this.eventConfig.forEach((o) => {
        e[o.name] = o.info;
      }), e;
    },
    t() {
      return this.designer.setupState.t;
    },
    eventNum() {
      let e = 0;
      return Object.keys(this.modelValue || {}).forEach((o) => {
        this.modelValue[o] && e++;
      }), e;
    }
  },
  watch: {
    visible(e) {
      this.event = e ? this.loadFN(Wl({}, this.modelValue || {})) : {}, e || this.destroy();
    }
  },
  methods: {
    getArgs(e) {
      return e.args.join(", ");
    },
    loadFN(e) {
      const o = {};
      return this.eventConfig.forEach((i) => {
        const l = i.name, n = e[l] || "";
        o[l] = {
          item: i,
          fn: n
        };
      }), o;
    },
    parseFN(e) {
      const o = {};
      return Object.keys(e).forEach((i) => {
        e[i].fn && (o[i] = e[i].fn);
      }), o;
    },
    edit(e) {
      e.key = We(), this.activeData = e, this.eventStr = e.fn || UA + `function ${e.item.name}(${this.getArgs(e.item)}){}` + jA, this.defActive = e.item.name;
    },
    save() {
      this.$refs.fn.save() && (this.activeData.fn = this.eventStr, this.destroy());
    },
    destroy() {
      this.activeData = null, this.defActive = "no";
    },
    close() {
      this.destroy();
    },
    submit() {
      if (this.activeData)
        return _t(this.t("event.saveMsg"));
      this.$emit("update:modelValue", this.parseFN(this.event)), this.visible = !1, this.destroy();
    }
  }
}), WA = { class: "_fd-fn-list" }, GA = ["onClick"], YA = {
  key: 0,
  class: "_fd-label"
};
function QA(e, o, i, l, n, u) {
  const f = ie("ElButton"), p = ie("el-badge"), c = ie("el-text"), v = ie("el-header"), b = ie("el-menu-item"), y = ie("el-menu"), E = ie("el-main"), w = ie("el-container"), h = ie("el-aside"), m = ie("el-button"), I = ie("FnEditor"), D = ie("ElDialog");
  return Z(), fe("div", WA, [
    X(p, {
      value: e.eventNum,
      type: "warning",
      hidden: e.eventNum < 1
    }, {
      default: Y(() => [
        X(f, {
          onClick: o[0] || (o[0] = (g) => e.visible = !0),
          size: "small"
        }, {
          default: Y(() => [
            xe(ve(e.t("event.title")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "hidden"]),
    X(D, {
      class: "_fd-fn-list-dialog",
      title: e.t("event.title"),
      modelValue: e.visible,
      "onUpdate:modelValue": o[4] || (o[4] = (g) => e.visible = g),
      "destroy-on-close": "",
      "close-on-click-modal": !1,
      "append-to-body": "",
      width: "980px"
    }, {
      footer: Y(() => [
        _("div", null, [
          X(f, {
            size: "default",
            onClick: o[3] || (o[3] = (g) => e.visible = !1)
          }, {
            default: Y(() => [
              xe(ve(e.t("props.cancel")), 1)
            ]),
            _: 1
          }),
          X(f, {
            type: "primary",
            size: "default",
            onClick: e.submit,
            color: "#2f73ff"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.ok")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: Y(() => [
        X(w, {
          class: "_fd-fn-list-con",
          style: { height: "600px" }
        }, {
          default: Y(() => [
            X(h, { style: { width: "300px" } }, {
              default: Y(() => [
                X(w, { class: "_fd-fn-list-l" }, {
                  default: Y(() => [
                    X(v, {
                      class: "_fd-fn-list-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(c, {
                          type: "primary",
                          size: "default"
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("event.list")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    X(E, null, {
                      default: Y(() => [
                        X(y, {
                          "default-active": e.defActive,
                          modelValue: e.activeData,
                          "onUpdate:modelValue": o[1] || (o[1] = (g) => e.activeData = g)
                        }, {
                          default: Y(() => [
                            (Z(!0), fe(ze, null, ft(e.event, (g, S) => (Z(), we(b, { index: S }, {
                              default: Y(() => [
                                _("div", {
                                  class: "_fd-fn-list-method",
                                  onClick: yt((x) => e.edit(g), ["stop"])
                                }, [
                                  _("span", null, [
                                    xe("function"),
                                    _("span", null, ve(S), 1)
                                  ]),
                                  e.eventInfo[S] ? (Z(), fe("span", YA, ve(e.eventInfo[S]), 1)) : Se("", !0)
                                ], 8, GA)
                              ]),
                              _: 2
                            }, 1032, ["index"]))), 256))
                          ]),
                          _: 1
                        }, 8, ["default-active", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            X(E, null, {
              default: Y(() => [
                X(w, { class: "_fd-fn-list-r" }, {
                  default: Y(() => [
                    e.activeData ? (Z(), we(v, {
                      key: 0,
                      class: "_fd-fn-list-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(m, {
                          size: "small",
                          onClick: e.close
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        X(m, {
                          size: "small",
                          type: "primary",
                          onClick: e.save,
                          color: "#2f73ff"
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.save")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })) : Se("", !0),
                    e.activeData ? (Z(), we(E, { key: 1 }, {
                      default: Y(() => [
                        X(I, {
                          ref: "fn",
                          modelValue: e.eventStr,
                          "onUpdate:modelValue": o[2] || (o[2] = (g) => e.eventStr = g),
                          name: e.activeData.item.name,
                          args: e.activeData.item.args,
                          style: { height: "510px" }
                        }, null, 8, ["modelValue", "name", "args"])
                      ]),
                      _: 1
                    })) : Se("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]);
}
const KA = /* @__PURE__ */ qe(zA, [["render", QA]]);
const JA = et({
  name: "StructEditor",
  props: {
    modelValue: [Object, Array, Function],
    defaultValue: {
      require: !1
    }
  },
  inject: ["designer"],
  data() {
    return {
      editor: null,
      visible: !1,
      err: !1,
      oldVal: null
    };
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.load();
    });
  },
  methods: {
    load() {
      const e = this.modelValue ? kr(this.modelValue) : "";
      this.oldVal = e, this.$nextTick(() => {
        this.editor = On(Hr(this.$refs.editor, {
          lineNumbers: !0,
          mode: "javascript",
          lint: !0,
          line: !0,
          tabSize: 2,
          lineWrapping: !0,
          value: e || ""
        }));
      });
    },
    save() {
      const e = this.editor.getValue();
      let o;
      try {
        o = new Function("return " + e)();
      } catch (i) {
        return console.error(i), _t(this.t("struct.errorMsg")), !1;
      }
      return this.validate && this.validate(o) === !1 ? (this.err = !0, !1) : (this.visible = !1, kr(o) !== this.oldVal && this.$emit("update:modelValue", o), !0);
    }
  }
}), XA = { class: "_fd-struct-editor" }, ZA = { ref: "editor" };
function qA(e, o, i, l, n, u) {
  return Z(), fe("div", XA, [
    _("div", ZA, null, 512)
  ]);
}
const _A = /* @__PURE__ */ qe(JA, [["render", qA]]);
const eC = (e) => [
  {
    type: "input",
    field: "action",
    title: e("fetch.action"),
    value: "",
    $required: !0,
    props: { size: "default" },
    validate: [{ type: "url", message: e("fetch.actionRequired"), trigger: "blur" }]
  },
  {
    type: "radio",
    field: "method",
    title: e("fetch.method"),
    value: "GET",
    options: [
      { label: "GET", value: "GET" },
      { label: "POST", value: "POST" }
    ],
    $required: !0
  },
  {
    type: "TableOptions",
    field: "headers",
    title: e("fetch.headers"),
    value: {},
    props: {
      column: [{ label: e("props.key"), key: "label" }, { label: e("props.value"), key: "value" }],
      valueType: "object"
    }
  },
  {
    type: "TableOptions",
    field: "data",
    title: e("fetch.data"),
    value: {},
    props: {
      column: [{ label: e("props.key"), key: "label" }, { label: e("props.value"), key: "value" }],
      valueType: "object"
    }
  }
], tC = et({
  name: "GlobalFetchConfig",
  props: {
    modelValue: Object
  },
  components: {
    DragForm: Ze.$form(),
    FnEditor: Po,
    StructEditor: _A
  },
  inject: ["designer"],
  data() {
    return {
      visible: !1,
      activeIdx: "",
      list: {},
      cus: !1,
      cusValue: "",
      form: {
        api: {},
        formData: {},
        rule: [],
        options: {
          form: {
            labelWidth: "90px",
            size: "default"
          },
          submitBtn: !1,
          resetBtn: !1
        }
      }
    };
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    types() {
      return { fetch: this.t("fetch.remote"), static: this.t("fetch.static") };
    },
    dataNum() {
      return Object.keys(this.modelValue || {}).length;
    }
  },
  watch: {
    visible(e) {
      e && (this.list = Lt(this.modelValue || {}), this.activeIdx = "");
    }
  },
  methods: {
    open() {
      this.visible = !0;
    },
    active(e) {
      if (this.activeIdx !== e) {
        const o = this.list[e];
        this.form.rule = o.type === "static" ? [] : eC(this.t), this.form.formData = { ...o }, this.form.label = o.label, this.form.type = o.type, this.form.data = o.data, this.form.parse = o.parse || "", this.form.onError = o.onError || "", this.activeIdx = e;
      }
    },
    addCus() {
      const e = this.cusValue && this.cusValue.trim();
      if (e) {
        const o = "data_" + We();
        this.list[o] = {
          label: e,
          type: this.cus,
          data: []
        }, this.active(o), this.closeCus();
      }
    },
    closeCus() {
      this.cus = !1, this.cusValue = "";
    },
    cusEvent(e) {
      this.cus = e;
    },
    saveData() {
      !this.$refs.data.save() || (this.list[this.activeIdx].data = this.form.data || [], this.activeIdx = "");
    },
    save() {
      if (this.list[this.activeIdx].type === "static")
        return this.saveData();
      this.form.api.validate().then(() => {
        const e = { ...this.form.formData };
        this.$refs.parse && !this.$refs.parse.save() || this.$refs.error && !this.$refs.error.save() || (e.parse = this.form.parse, e.onError = this.form.onError, e.label = this.form.label, e.type = this.form.type, this.list[this.activeIdx] = e, this.activeIdx = "");
      }).catch((e) => {
        console.error(e), _t(e[Object.keys(e)[0]][0].message);
      });
    },
    rm(e) {
      delete this.list[e], e === this.activeIdx && (this.activeIdx = "");
    },
    close() {
      this.activeIdx = "";
    },
    submit() {
      if (this.activeIdx)
        return _t(this.t("event.saveMsg"));
      this.$emit("update:modelValue", { ...this.list }), this.visible = !1;
    }
  }
}), nC = { class: "_fd-gfc" }, rC = { class: "el-dropdown-link" }, iC = /* @__PURE__ */ _("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1), oC = ["onClick"], lC = { class: "_fd-gfc-method" }, aC = {
  key: 0,
  class: "_fd-label"
}, sC = ["onClick"];
function uC(e, o, i, l, n, u) {
  const f = ie("ElButton"), p = ie("el-badge"), c = ie("el-button"), v = ie("el-dropdown-item"), b = ie("el-dropdown-menu"), y = ie("el-dropdown"), E = ie("el-header"), w = ie("el-menu-item"), h = ie("el-input"), m = ie("el-menu"), I = ie("el-main"), D = ie("el-container"), g = ie("el-aside"), S = ie("DragForm"), x = ie("el-tab-pane"), R = ie("FnEditor"), N = ie("el-tabs"), T = ie("StructEditor"), H = ie("ElDialog");
  return Z(), fe("div", nC, [
    X(p, {
      value: e.dataNum,
      type: "warning",
      hidden: e.dataNum < 1
    }, {
      default: Y(() => [
        X(f, {
          onClick: e.open,
          size: "small"
        }, {
          default: Y(() => [
            xe(ve(e.t("fetch.title")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["value", "hidden"]),
    X(H, {
      class: "_fd-gfc-dialog",
      title: e.t("form.globalFetch"),
      modelValue: e.visible,
      "onUpdate:modelValue": o[10] || (o[10] = (B) => e.visible = B),
      "destroy-on-close": "",
      "close-on-click-modal": !1,
      "append-to-body": "",
      width: "980px"
    }, {
      footer: Y(() => [
        _("div", null, [
          X(f, {
            size: "default",
            onClick: o[9] || (o[9] = (B) => e.visible = !1)
          }, {
            default: Y(() => [
              xe(ve(e.t("props.cancel")), 1)
            ]),
            _: 1
          }),
          X(f, {
            type: "primary",
            size: "default",
            onClick: e.submit,
            color: "#2f73ff"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.ok")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: Y(() => [
        X(D, {
          class: "_fd-gfc-con",
          style: { height: "600px" }
        }, {
          default: Y(() => [
            X(g, { style: { width: "300px" } }, {
              default: Y(() => [
                X(D, { class: "_fd-gfc-l" }, {
                  default: Y(() => [
                    X(E, {
                      class: "_fd-gfc-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(y, {
                          trigger: "click",
                          size: "default"
                        }, {
                          dropdown: Y(() => [
                            X(b, null, {
                              default: Y(() => [
                                (Z(!0), fe(ze, null, ft(e.types, (B, L) => (Z(), we(v, {
                                  key: L,
                                  onClick: (P) => e.cusEvent(L)
                                }, {
                                  default: Y(() => [
                                    _("div", null, ve(B), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          default: Y(() => [
                            _("span", rC, [
                              X(c, {
                                link: "",
                                type: "primary",
                                size: "default"
                              }, {
                                default: Y(() => [
                                  xe(ve(e.t("fetch.create")), 1),
                                  iC
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    X(I, null, {
                      default: Y(() => [
                        X(m, null, {
                          default: Y(() => [
                            (Z(!0), fe(ze, null, ft(e.list, (B, L) => (Z(), we(w, {
                              class: ot({ "is-active": L === e.activeIdx })
                            }, {
                              default: Y(() => [
                                _("div", {
                                  class: "_fd-gfc-title",
                                  onClick: yt((P) => e.active(L), ["stop"])
                                }, [
                                  _("div", lC, [
                                    _("span", null, ve(L), 1),
                                    B.label ? (Z(), fe("span", aC, ve(B.label), 1)) : Se("", !0)
                                  ]),
                                  _("i", {
                                    class: "fc-icon icon-delete",
                                    onClick: yt((P) => e.rm(L), ["stop"])
                                  }, null, 8, sC)
                                ], 8, oC)
                              ]),
                              _: 2
                            }, 1032, ["class"]))), 256)),
                            e.cus ? (Z(), we(w, {
                              key: 0,
                              style: { "padding-left": "10px" }
                            }, {
                              default: Y(() => [
                                _("div", {
                                  class: "_fd-gfc-title",
                                  onClick: o[3] || (o[3] = yt(() => {
                                  }, ["stop"]))
                                }, [
                                  X(h, {
                                    type: "text",
                                    modelValue: e.cusValue,
                                    "onUpdate:modelValue": o[0] || (o[0] = (B) => e.cusValue = B),
                                    size: "default",
                                    onKeydown: jl(e.addCus, ["enter"]),
                                    placeholder: e.t("fetch.placeholder")
                                  }, null, 8, ["modelValue", "onKeydown", "placeholder"]),
                                  _("div", null, [
                                    _("i", {
                                      class: "fc-icon icon-add",
                                      onClick: o[1] || (o[1] = yt((...B) => e.addCus && e.addCus(...B), ["stop"]))
                                    }),
                                    _("i", {
                                      class: "fc-icon icon-delete",
                                      onClick: o[2] || (o[2] = yt((...B) => e.closeCus && e.closeCus(...B), ["stop"]))
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })) : Se("", !0)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            X(I, null, {
              default: Y(() => [
                X(D, { class: "_fd-gfc-r" }, {
                  default: Y(() => [
                    e.activeIdx ? (Z(), we(E, {
                      key: 0,
                      class: "_fd-gfc-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(c, {
                          size: "small",
                          onClick: e.close
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        X(c, {
                          size: "small",
                          type: "primary",
                          onClick: e.save,
                          color: "#2f73ff"
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.save")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })) : Se("", !0),
                    e.activeIdx ? (Z(), we(I, { key: e.activeIdx }, {
                      default: Y(() => [
                        e.list[e.activeIdx].type === "fetch" ? (Z(), we(N, {
                          key: 0,
                          "model-value": "first",
                          class: "_fc-tabs"
                        }, {
                          default: Y(() => [
                            X(x, {
                              label: e.t("fetch.config"),
                              name: "first"
                            }, {
                              default: Y(() => [
                                X(S, {
                                  api: e.form.api,
                                  "onUpdate:api": o[4] || (o[4] = (B) => e.form.api = B),
                                  modelValue: e.form.formData,
                                  "onUpdate:modelValue": o[5] || (o[5] = (B) => e.form.formData = B),
                                  rule: e.form.rule,
                                  option: e.form.options
                                }, null, 8, ["api", "modelValue", "rule", "option"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            X(x, {
                              lazy: "",
                              label: e.t("fetch.parse"),
                              name: "second"
                            }, {
                              default: Y(() => [
                                X(R, {
                                  style: { height: "480px" },
                                  modelValue: e.form.parse,
                                  "onUpdate:modelValue": o[6] || (o[6] = (B) => e.form.parse = B),
                                  name: "parse",
                                  args: [{ name: "res", info: e.t("fetch.response") }],
                                  ref: "parse"
                                }, null, 8, ["modelValue", "args"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            X(x, {
                              lazy: "",
                              label: e.t("fetch.onError"),
                              name: "third"
                            }, {
                              default: Y(() => [
                                X(R, {
                                  style: { height: "480px" },
                                  modelValue: e.form.onError,
                                  "onUpdate:modelValue": o[7] || (o[7] = (B) => e.form.onError = B),
                                  name: "onError",
                                  args: ["e"],
                                  ref: "error"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })) : (Z(), we(T, {
                          key: 1,
                          modelValue: e.form.data,
                          "onUpdate:modelValue": o[8] || (o[8] = (B) => e.form.data = B),
                          ref: "data"
                        }, null, 8, ["modelValue"]))
                      ]),
                      _: 1
                    })) : Se("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]);
}
const dC = /* @__PURE__ */ qe(tC, [["render", uC]]);
const fC = et({
  name: "GlobalFetchSelect",
  props: {
    modelValue: [Object, String],
    to: String
  },
  inject: ["designer"],
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    options() {
      return Object.keys(this.designer.setupState.formOptions.globalData || {}).map((e) => ({ label: this.designer.setupState.formOptions.globalData[e].label, value: e }));
    }
  },
  watch: {
    modelValue() {
      this.value = (this.modelValue || {}).key || "";
    }
  },
  data() {
    return {
      value: (this.modelValue || {}).key || "",
      uni: 1,
      loading: !1
    };
  },
  methods: {
    refresh() {
      !this.value || (this.uni = this.uni === 1 ? 0 : 1, this.input(), this.loading = !0, setTimeout(() => {
        this.loading = !1;
      }, 1e3));
    },
    openConfig() {
      this.designer.setupState.openGlobalFetchDialog();
    },
    input() {
      const e = typeof this.modelValue == "object" ? { ...this.modelValue } : {};
      e.to = this.to || "options", e.key = this.value, e._uni = this.uni, this.$emit("update:modelValue", e);
    }
  }
}), cC = { class: "_fd-gfs" }, pC = { class: "_fd-gfs-handle" }, hC = /* @__PURE__ */ _("i", { class: "fc-icon icon-setting" }, null, -1);
function vC(e, o, i, l, n, u) {
  const f = ie("el-option"), p = ie("el-select");
  return Z(), fe("div", cC, [
    X(p, {
      modelValue: e.value,
      "onUpdate:modelValue": o[0] || (o[0] = (c) => e.value = c),
      clearable: "",
      onChange: e.input
    }, {
      default: Y(() => [
        (Z(!0), fe(ze, null, ft(e.options, (c) => (Z(), we(f, {
          key: c.value,
          label: c.label,
          value: c.value
        }, null, 8, ["label", "value"]))), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onChange"]),
    _("div", pC, [
      _("i", {
        onClick: o[1] || (o[1] = (...c) => e.refresh && e.refresh(...c)),
        class: ot(["fc-icon icon-refresh", { disabled: !e.value, "_fc-loading": this.loading }]),
        title: "reload"
      }, null, 2),
      _("div", {
        class: "_fc-manage-text",
        onClick: o[2] || (o[2] = (...c) => e.openConfig && e.openConfig(...c))
      }, [
        xe(ve(e.t("props.manage")), 1),
        hC
      ])
    ])
  ]);
}
const mC = /* @__PURE__ */ qe(fC, [["render", vC]]);
const gC = et({
  name: "GlobalEventConfig",
  props: {
    modelValue: Object,
    eventName: Array
  },
  components: {
    FnEditor: Po
  },
  inject: ["designer"],
  data() {
    return {
      visible: !1,
      activeIdx: "",
      event: {},
      cus: !1,
      cusValue: "",
      handle: ""
    };
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    eventNum() {
      return Object.keys(this.modelValue || {}).length;
    },
    fnArgs() {
      return [qs(this.t)];
    }
  },
  watch: {
    visible(e) {
      e && (this.activeIdx = "", this.event = Lt(this.modelValue || {}));
    }
  },
  methods: {
    open() {
      this.visible = !0;
    },
    active(e) {
      this.activeIdx !== e && (this.handle = this.event[e].handle || "", this.activeIdx = e);
    },
    addCus() {
      const e = this.cusValue && this.cusValue.trim();
      if (e) {
        const o = "event_" + We();
        this.event[o] = {
          label: e,
          handle: ""
        }, this.active(o), this.closeCus();
      }
    },
    closeCus() {
      this.cus = !1, this.cusValue = "";
    },
    cusEvent() {
      this.cus = !0;
    },
    save() {
      !this.$refs.data.save() || (this.event[this.activeIdx].handle = this.handle, this.activeIdx = "");
    },
    rm(e) {
      delete this.event[e], e === this.activeIdx && (this.activeIdx = "");
    },
    close() {
      this.activeIdx = "";
    },
    submit() {
      if (this.activeIdx)
        return _t(this.t("event.saveMsg"));
      this.$emit("update:modelValue", { ...this.event }), this.visible = !1;
    }
  },
  beforeCreate() {
    window.$inject = {
      $f: {},
      rule: [],
      self: {},
      option: {},
      inject: {},
      args: []
    };
  }
}), yC = { class: "_fd-gec" }, bC = /* @__PURE__ */ _("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1), AC = ["onClick"], CC = { class: "_fd-gec-method" }, SC = {
  key: 0,
  class: "_fd-label"
}, EC = ["onClick"];
function wC(e, o, i, l, n, u) {
  const f = ie("ElButton"), p = ie("el-badge"), c = ie("el-button"), v = ie("el-header"), b = ie("el-menu-item"), y = ie("el-input"), E = ie("el-menu"), w = ie("el-main"), h = ie("el-container"), m = ie("el-aside"), I = ie("FnEditor"), D = ie("ElDialog");
  return Z(), fe("div", yC, [
    X(p, {
      value: e.eventNum,
      type: "warning",
      hidden: e.eventNum < 1
    }, {
      default: Y(() => [
        X(f, {
          onClick: e.open,
          size: "small"
        }, {
          default: Y(() => [
            xe(ve(e.t("event.title")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["value", "hidden"]),
    X(D, {
      class: "_fd-gec-dialog",
      title: e.t("form.globalEvent"),
      modelValue: e.visible,
      "onUpdate:modelValue": o[6] || (o[6] = (g) => e.visible = g),
      "destroy-on-close": "",
      "close-on-click-modal": !1,
      "append-to-body": "",
      width: "980px"
    }, {
      footer: Y(() => [
        _("div", null, [
          X(f, {
            size: "default",
            onClick: o[5] || (o[5] = (g) => e.visible = !1)
          }, {
            default: Y(() => [
              xe(ve(e.t("props.cancel")), 1)
            ]),
            _: 1
          }),
          X(f, {
            type: "primary",
            size: "default",
            onClick: e.submit,
            color: "#2E73FF"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.ok")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: Y(() => [
        X(h, {
          class: "_fd-gec-con",
          style: { height: "600px" }
        }, {
          default: Y(() => [
            X(m, { style: { width: "300px" } }, {
              default: Y(() => [
                X(h, { class: "_fd-gec-l" }, {
                  default: Y(() => [
                    X(v, {
                      class: "_fd-gec-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(c, {
                          link: "",
                          type: "primary",
                          size: "default",
                          onClick: e.cusEvent
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("event.create")), 1),
                            bC
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    X(w, null, {
                      default: Y(() => [
                        X(E, null, {
                          default: Y(() => [
                            (Z(!0), fe(ze, null, ft(e.event, (g, S) => (Z(), we(b, {
                              class: ot({ "is-active": S === e.activeIdx })
                            }, {
                              default: Y(() => [
                                _("div", {
                                  class: "_fd-gec-title",
                                  onClick: yt((x) => e.active(S), ["stop"])
                                }, [
                                  _("div", CC, [
                                    _("span", null, ve(S), 1),
                                    g.label ? (Z(), fe("span", SC, ve(g.label), 1)) : Se("", !0)
                                  ]),
                                  _("i", {
                                    class: "fc-icon icon-delete",
                                    onClick: yt((x) => e.rm(S), ["stop"])
                                  }, null, 8, EC)
                                ], 8, AC)
                              ]),
                              _: 2
                            }, 1032, ["class"]))), 256)),
                            e.cus ? (Z(), we(b, {
                              key: 0,
                              style: { "padding-left": "10px" }
                            }, {
                              default: Y(() => [
                                _("div", {
                                  class: "_fd-gec-title",
                                  onClick: o[3] || (o[3] = yt(() => {
                                  }, ["stop"]))
                                }, [
                                  X(y, {
                                    type: "text",
                                    modelValue: e.cusValue,
                                    "onUpdate:modelValue": o[0] || (o[0] = (g) => e.cusValue = g),
                                    size: "default",
                                    onKeydown: jl(e.addCus, ["enter"]),
                                    placeholder: e.t("event.placeholder")
                                  }, null, 8, ["modelValue", "onKeydown", "placeholder"]),
                                  _("div", null, [
                                    _("i", {
                                      class: "fc-icon icon-add",
                                      onClick: o[1] || (o[1] = yt((...g) => e.addCus && e.addCus(...g), ["stop"]))
                                    }),
                                    _("i", {
                                      class: "fc-icon icon-delete",
                                      onClick: o[2] || (o[2] = yt((...g) => e.closeCus && e.closeCus(...g), ["stop"]))
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })) : Se("", !0)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            X(w, null, {
              default: Y(() => [
                X(h, { class: "_fd-gec-r" }, {
                  default: Y(() => [
                    e.activeIdx ? (Z(), we(v, {
                      key: 0,
                      class: "_fd-gec-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(c, {
                          size: "small",
                          onClick: e.close
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        X(c, {
                          size: "small",
                          type: "primary",
                          onClick: e.save,
                          color: "#2E73FF"
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.save")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })) : Se("", !0),
                    e.activeIdx ? (Z(), we(w, { key: e.activeIdx }, {
                      default: Y(() => [
                        X(I, {
                          style: { height: "510px" },
                          modelValue: e.handle,
                          "onUpdate:modelValue": o[4] || (o[4] = (g) => e.handle = g),
                          name: "handle",
                          args: e.fnArgs,
                          ref: "data"
                        }, null, 8, ["modelValue", "args"])
                      ]),
                      _: 1
                    })) : Se("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]);
}
const xC = /* @__PURE__ */ qe(gC, [["render", wC]]);
const TC = et({
  name: "GlobalClassConfig",
  props: {
    modelValue: Object
  },
  components: {
    StyleConfig: jc
  },
  inject: ["designer"],
  data() {
    return {
      visible: !1,
      activeIdx: "",
      value: {},
      cus: !1,
      cusValue: "",
      handle: "",
      styleEl: null
    };
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    eventNum() {
      return Object.keys(this.modelValue || {}).length;
    },
    fnArgs() {
      return [qs(this.t)];
    }
  },
  watch: {
    visible(e) {
      e && (this.activeIdx = "", this.value = Lt(this.modelValue || {}));
    },
    modelValue() {
      this.updateGlobalStyle();
    }
  },
  methods: {
    open() {
      this.visible = !0;
    },
    active(e) {
      this.activeIdx !== e && (this.handle = this.value[e].style || "", this.activeIdx = e);
    },
    addCus() {
      const e = this.cusValue && this.cusValue.trim();
      if (e) {
        const o = "cls_" + We();
        this.value[o] = {
          label: e,
          style: {}
        }, this.active(o), this.closeCus();
      }
    },
    closeCus() {
      this.cus = !1, this.cusValue = "";
    },
    cusEvent() {
      this.cus = !0;
    },
    save() {
      this.value[this.activeIdx].style = this.handle, this.activeIdx = "";
    },
    rm(e) {
      delete this.value[e], e === this.activeIdx && (this.activeIdx = "");
    },
    close() {
      this.activeIdx = "";
    },
    submit() {
      if (this.activeIdx)
        return _t(this.t("class.saveMsg"));
      this.$emit("update:modelValue", { ...this.value }), this.visible = !1;
    },
    updateGlobalStyle() {
      let e = "";
      const o = this.modelValue || {};
      Object.keys(o).forEach((i) => {
        let l = "";
        o[i].style && Object.keys(o[i].style).forEach((n) => {
          l += Hc(n) + ":" + o[i].style[n] + ";";
        }), o[i].content && (l += o[i].content + ";"), l && (e += `.${i}{${l}}`);
      }), e && (this.styleEl.innerHTML = e);
    }
  },
  created() {
    this.styleEl = On(document.createElement("style")), this.styleEl.type = "text/css", document.head.appendChild(this.styleEl), this.updateGlobalStyle();
  },
  unmounted() {
    document.head.removeChild(this.styleEl);
  }
}), DC = { class: "_fd-gcc" }, IC = /* @__PURE__ */ _("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1), RC = ["onClick"], FC = { class: "_fd-gcc-method" }, MC = {
  key: 0,
  class: "_fd-label"
}, OC = ["onClick"];
function NC(e, o, i, l, n, u) {
  const f = ie("ElButton"), p = ie("el-badge"), c = ie("el-button"), v = ie("el-header"), b = ie("el-menu-item"), y = ie("el-input"), E = ie("el-menu"), w = ie("el-main"), h = ie("el-container"), m = ie("el-aside"), I = ie("StyleConfig"), D = ie("ElDialog");
  return Z(), fe("div", DC, [
    X(p, {
      value: e.eventNum,
      type: "warning",
      hidden: e.eventNum < 1
    }, {
      default: Y(() => [
        X(f, {
          onClick: e.open,
          size: "small"
        }, {
          default: Y(() => [
            xe(ve(e.t("class.title")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["value", "hidden"]),
    X(D, {
      class: "_fd-gcc-dialog",
      title: e.t("form.globalClass"),
      modelValue: e.visible,
      "onUpdate:modelValue": o[6] || (o[6] = (g) => e.visible = g),
      "destroy-on-close": "",
      "close-on-click-modal": !1,
      "append-to-body": "",
      width: "700px"
    }, {
      footer: Y(() => [
        _("div", null, [
          X(f, {
            size: "default",
            onClick: o[5] || (o[5] = (g) => e.visible = !1)
          }, {
            default: Y(() => [
              xe(ve(e.t("props.cancel")), 1)
            ]),
            _: 1
          }),
          X(f, {
            type: "primary",
            size: "default",
            onClick: e.submit,
            color: "#2E73FF"
          }, {
            default: Y(() => [
              xe(ve(e.t("props.ok")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: Y(() => [
        X(h, {
          class: "_fd-gcc-con",
          style: { height: "600px" }
        }, {
          default: Y(() => [
            X(m, { style: { width: "255px" } }, {
              default: Y(() => [
                X(h, { class: "_fd-gcc-l" }, {
                  default: Y(() => [
                    X(v, {
                      class: "_fd-gcc-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(c, {
                          link: "",
                          type: "primary",
                          size: "default",
                          onClick: e.cusEvent
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("class.create")), 1),
                            IC
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    X(w, null, {
                      default: Y(() => [
                        X(E, null, {
                          default: Y(() => [
                            (Z(!0), fe(ze, null, ft(e.value, (g, S) => (Z(), we(b, {
                              class: ot({ "is-active": S === e.activeIdx })
                            }, {
                              default: Y(() => [
                                _("div", {
                                  class: "_fd-gcc-title",
                                  onClick: yt((x) => e.active(S), ["stop"])
                                }, [
                                  _("div", FC, [
                                    _("span", null, "." + ve(S), 1),
                                    g.label ? (Z(), fe("span", MC, ve(g.label), 1)) : Se("", !0)
                                  ]),
                                  _("i", {
                                    class: "fc-icon icon-delete",
                                    onClick: yt((x) => e.rm(S), ["stop"])
                                  }, null, 8, OC)
                                ], 8, RC)
                              ]),
                              _: 2
                            }, 1032, ["class"]))), 256)),
                            e.cus ? (Z(), we(b, {
                              key: 0,
                              style: { "padding-left": "10px" }
                            }, {
                              default: Y(() => [
                                _("div", {
                                  class: "_fd-gcc-title",
                                  onClick: o[3] || (o[3] = yt(() => {
                                  }, ["stop"]))
                                }, [
                                  X(y, {
                                    type: "text",
                                    modelValue: e.cusValue,
                                    "onUpdate:modelValue": o[0] || (o[0] = (g) => e.cusValue = g),
                                    size: "default",
                                    onKeydown: jl(e.addCus, ["enter"]),
                                    placeholder: e.t("class.placeholder")
                                  }, null, 8, ["modelValue", "onKeydown", "placeholder"]),
                                  _("div", null, [
                                    _("i", {
                                      class: "fc-icon icon-add",
                                      onClick: o[1] || (o[1] = yt((...g) => e.addCus && e.addCus(...g), ["stop"]))
                                    }),
                                    _("i", {
                                      class: "fc-icon icon-delete",
                                      onClick: o[2] || (o[2] = yt((...g) => e.closeCus && e.closeCus(...g), ["stop"]))
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })) : Se("", !0)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            X(w, null, {
              default: Y(() => [
                X(h, { class: "_fd-gcc-r" }, {
                  default: Y(() => [
                    e.activeIdx ? (Z(), we(v, {
                      key: 0,
                      class: "_fd-gcc-head",
                      height: "40px"
                    }, {
                      default: Y(() => [
                        X(c, {
                          size: "small",
                          onClick: e.close
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        X(c, {
                          size: "small",
                          type: "primary",
                          onClick: e.save,
                          color: "#2E73FF"
                        }, {
                          default: Y(() => [
                            xe(ve(e.t("props.save")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })) : Se("", !0),
                    e.activeIdx ? (Z(), we(w, { key: e.activeIdx }, {
                      default: Y(() => [
                        X(I, {
                          modelValue: e.handle,
                          "onUpdate:modelValue": o[4] || (o[4] = (g) => e.handle = g)
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })) : Se("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]);
}
const LC = /* @__PURE__ */ qe(TC, [["render", NC]]);
const PC = et({
  name: "GlobalClassSelect",
  props: {
    modelValue: [Array, String],
    to: String
  },
  inject: ["designer"],
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    options() {
      return Object.keys(this.designer.setupState.formOptions.globalClass || {}).map((e) => ({ label: this.designer.setupState.formOptions.globalClass[e].label, value: e }));
    }
  },
  watch: {
    modelValue() {
      this.tidyValue();
    }
  },
  data() {
    return {
      value: []
    };
  },
  methods: {
    tidyValue() {
      this.value = Array.isArray(this.modelValue) ? this.modelValue : (this.modelValue || "").split(" ").filter((e) => !!e);
    },
    openConfig() {
      this.designer.setupState.openGlobalClassDialog();
    },
    input() {
      this.$emit("update:modelValue", this.value.join(" "));
    }
  },
  created() {
    this.tidyValue();
  }
}), $C = { class: "_fd-gcs" }, BC = { class: "_fd-gcs-handle" }, kC = /* @__PURE__ */ _("i", { class: "fc-icon icon-setting" }, null, -1);
function HC(e, o, i, l, n, u) {
  const f = ie("el-option"), p = ie("el-select");
  return Z(), fe("div", $C, [
    X(p, {
      modelValue: e.value,
      "onUpdate:modelValue": o[0] || (o[0] = (c) => e.value = c),
      multiple: "",
      filterable: "",
      "allow-create": "",
      "default-first-option": "",
      "reserve-keyword": !1,
      clearable: "",
      onChange: e.input
    }, {
      default: Y(() => [
        (Z(!0), fe(ze, null, ft(e.options, (c) => (Z(), we(f, {
          key: c.value,
          label: c.label,
          value: c.value
        }, null, 8, ["label", "value"]))), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onChange"]),
    _("div", BC, [
      _("div", {
        class: "_fc-manage-text",
        onClick: o[1] || (o[1] = (...c) => e.openConfig && e.openConfig(...c))
      }, [
        xe(ve(e.t("props.manage")), 1),
        kC
      ])
    ])
  ]);
}
const VC = /* @__PURE__ */ qe(PC, [["render", HC]]), UC = et({
  name: "Fetch",
  props: {
    modelValue: [Object, String],
    to: String
  },
  components: {
    DragForm: Ze.$form()
  },
  inject: ["designer"],
  computed: {
    formValue() {
      const e = this.modelValue;
      return e ? st.String(e) ? {
        action: e
      } : e : {};
    },
    t() {
      return this.designer.setupState.t;
    }
  },
  data() {
    return {
      api: {},
      option: {
        form: {
          labelPosition: "right",
          size: "small",
          labelWidth: "90px"
        },
        submitBtn: !1
      },
      rule: [{
        type: "select",
        field: "method",
        title: "",
        value: "",
        options: Object.keys(this.designer.setupState.formOptions.globalData || {}).map((e) => ({ label: this.designer.setupState.formOptions.globalData[e].label, value: e }))
      }]
    };
  },
  methods: {
    input: function () {
      this.api.submit((e) => {
        e.to = this.to || "options", this.$emit("update:modelValue", e);
      });
    }
  },
  mounted() {
    this.input();
  }
}), jC = {
  class: "_fd-fetch",
  style: { width: "100%" }
};
function zC(e, o, i, l, n, u) {
  const f = ie("DragForm");
  return Z(), fe("div", jC, [
    X(f, {
      api: e.api,
      "onUpdate:api": o[0] || (o[0] = (p) => e.api = p),
      modelValue: e.formValue,
      rule: e.rule,
      option: e.option,
      onChange: e.input
    }, null, 8, ["api", "modelValue", "rule", "option", "onChange"])
  ]);
}
const WC = /* @__PURE__ */ qe(UC, [["render", zC]]), zc = et({
  name: "DragBox",
  props: ["rule", "tag", "formCreateInject", "list"],
  render(e) {
    const o = { ...e.$props.rule.props, ...e.$attrs };
    let i = "_fd-" + e.$props.tag + "-drag _fd-drag-box";
    Object.keys(e.$slots).length || (i += " drag-holder"), o.class = i, o.modelValue = e.$props.list || [...e.$props.formCreateInject.children];
    const l = {};
    return e.$slots.default && e.$slots.default().forEach((u) => {
      u.key && (l[u.key] = u);
    }), Eo(ru, o, {
      item: ({ element: n, index: u }) => {
        var p;
        const f = (p = n == null ? void 0 : n.__fc__) == null ? void 0 : p.key;
        if (f) {
          let c = l["_" + n.slot];
          if (c ? c.children.forEach((v) => {
            v.key === f + "fc" && (c = v);
          }) : c = l[f + "fc"], c)
            return Eo("div", { class: "_fc-" + e.$props.tag + "-item _fd-drag-item", key: f }, c);
        }
        return Eo("div", { class: "_fc-" + e.$props.tag + "-item _fd-drag-item", key: u }, null);
      }
    });
  }
});
const GC = et({
  name: "FcTableView",
  props: {
    label: String,
    width: [Number, String],
    formCreateInject: Object,
    border: {
      type: Boolean,
      default: !0
    },
    borderWidth: String,
    borderColor: String,
    rule: {
      type: Object,
      default: () => ({ row: 1, col: 1 })
    }
  },
  inject: ["designer"],
  components: {
    DragTool: kc,
    DragBox: zc
  },
  watch: {
    rule: {
      handler() {
        this.initRule(), this.style = this.rule.style;
      },
      immediate: !0
    }
  },
  data() {
    return {
      unique: {},
      style: {},
      dragProp: {
        rule: {
          props: {
            tag: "el-col",
            group: "default",
            ghostClass: "ghost",
            animation: 150,
            handle: "._fd-drag-btn",
            emptyInsertThreshold: 0,
            direction: "vertical",
            itemKey: "type"
          }
        },
        tag: "tableCell"
      },
      lattice: {},
      uni: {}
    };
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    tableColor() {
      const e = {};
      return this.border === !1 ? e.border = "0 none" : (this.borderColor && (e.borderColor = this.borderColor), this.borderWidth && (e.borderWidth = this.borderWidth)), e;
    }
  },
  methods: {
    getUnique(e) {
      return this.unique[e] || (this.unique[e] = We()), this.unique[e];
    },
    getSlotChildren(e) {
      const o = [];
      return this.formCreateInject.children.forEach((i) => {
        e.indexOf(i.slot) > -1 && o.push(i);
      }), o;
    },
    dragAdd(e, o) {
      console.log("dragAdd");
      const i = this.designer.setupState, l = this.formCreateInject.children, n = `${o.pid}:${o.idx}`, u = e.item._underlying_vm_, f = i.addRule && i.addRule.children === i.moveRule;
      f && i.moveRule.splice(i.moveRule.indexOf(u), 1);
      let p = 0;
      const c = "drag" + o.pid + o.idx;
      if (this.$refs[c][0].list.length) {
        let v = this.$refs[c][0].list[e.newIndex ? e.newIndex - 1 : 0];
        p = l.indexOf(v) + (e.newIndex ? 1 : 0);
      } else if (l.length) {
        const v = Object.keys(this.$refs);
        for (let b = v.indexOf(c) - 1; b >= 0; b--) {
          if (!this.$refs[v[b]] || !this.$refs[v[b]].length)
            continue;
          const y = this.$refs[v[b]][0].list || [];
          if (y.length) {
            p = l.indexOf(y[y.length - 1]) + 1;
            break;
          }
        }
      }
      e.newIndex = p, f ? (u.slot = n, l.splice(e.newIndex, 0, u), i.added = !0, i.handleSortAfter({ rule: u })) : i.dragAdd(l, e, `${o.pid}:${o.idx}`);
    },
    dragEnd(e, o) {
      console.log("dragEnd");
      const i = this.designer.setupState, l = this.formCreateInject.children, n = e.item._underlying_vm_, u = l.indexOf(n);
      e.newIndex = u + (e.newIndex - e.oldIndex), e.oldIndex = u, i.dragEnd(this.formCreateInject.children, e, `${o.pid}:${o.idx}`);
    },
    dragStart() {
      console.log("dragStart"), this.designer.setupState.dragStart(this.formCreateInject.children);
    },
    dragUnchoose(e) {
      console.log("dragUnchoose"), this.designer.setupState.dragUnchoose(this.formCreateInject.children, e);
    },
    initRule() {
      const e = this.rule;
      e.style || (e.style = {}), e.class || (e.class = {}), e.layout || (e.layout = []), e.row || (e.row = 1), e.col || (e.col = 1);
    },
    active(e) {
      const o = `${e.pid}:${e.idx}`;
      this.designer.setupState.customActive({
        name: "fcTableGrid",
        style: {
          formData: {
            style: this.rule.style[o] || {},
            class: this.rule.class[o] || ""
          },
          change: (i, l) => {
            this.rule[i][o] = l || {};
          }
        }
      });
    },
    command(e) {
      this[e[0]](...e[1]);
    },
    rmSlot(e, o) {
      const i = Object.keys(e), l = this.formCreateInject.children;
      let n = 0;
      [...l].forEach((u, f) => {
        if (!u.slot)
          return;
        let p;
        o.indexOf(u.slot) > -1 ? (l.splice(f - n, 1), n++) : (p = i.indexOf(u.slot)) > -1 && (u.slot = e[i[p]]);
      }), o.forEach((u) => {
        delete this.style[u];
      }), this.loadRule();
    },
    rmRow(e) {
      this.rule.row--;
      const o = {}, i = [];
      for (let u = e.pid; u < this.rule.row + 1; u++)
        for (let f = 0; f < this.rule.col; f++)
          u === e.pid ? i.push(`${e.pid}:${f}`) : o[`${u}:${f}`] = `${u - 1}:${f}`;
      let l = 0;
      const n = this.rule.layout;
      [...n].forEach((u, f) => {
        u.top === e.pid && (n.splice(f - l, 1), l++);
      }), n.forEach((u) => {
        u.top > e.pid && u.top--;
      }), this.rmSlot(o, i);
    },
    rmCol(e) {
      this.rule.col--;
      const o = {}, i = [];
      for (let u = 0; u < this.rule.row; u++) {
        for (let f = e.idx + 1; f < this.rule.col + 1; f++)
          o[`${u}:${f}`] = `${u}:${f - 1}`;
        i.push(`${u}:${e.idx}`);
      }
      let l = 0;
      const n = this.rule.layout;
      [...n].forEach((u, f) => {
        u.left === e.idx && (n.splice(f - l, 1), l++);
      }), n.forEach((u) => {
        u.left > e.idx && u.left--;
      }), this.rmSlot(o, i);
    },
    splitRow(e) {
      const o = e.data.layout, i = o.row;
      if (o.row = 0, i > 1)
        for (let l = 1; l < i; l++)
          this.rule.layout.push({
            ...o,
            top: o.top + l
          });
      this.loadRule();
    },
    splitCol(e) {
      const o = e.data.layout, i = o.col;
      if (o.col = 0, i > 1)
        for (let l = 1; l < i; l++)
          this.rule.layout.push({
            ...o,
            left: o.left + l
          });
      this.loadRule();
    },
    makeMap(e) {
      let o = [];
      for (let i = e.top; i < (e.row || e.top + 1); i++)
        for (let l = e.left; l < (e.col || e.left + 1); l++)
          o.push(`${i}:${l}`);
      return o;
    },
    mergeRight(e) {
      let o;
      if (e.data.layout) {
        const l = (e.data.layout.col || 1) + 1;
        e.data.layout.col = l + e.idx > this.rule.col ? this.rule.col - e.idx : l, o = e.data.layout;
      } else
        o = {
          top: e.pid,
          left: e.idx,
          col: 2
        }, this.rule.layout.push(o);
      const i = this.makeMap(o);
      this.formCreateInject.children.forEach((l) => {
        !l.slot || i.indexOf(l.slot) > -1 && (l.slot = `${e.pid}:${e.idx}`);
      }), this.loadRule();
    },
    mergeBottom(e) {
      let o;
      if (e.data.layout) {
        const l = (e.data.layout.row || 1) + 1;
        e.data.layout.row = l + l.pid > this.rule.col ? this.rule.col - e.pid : l, o = e.data.layout;
      } else
        o = {
          top: e.pid,
          left: e.idx,
          row: 2
        }, this.rule.layout.push(o);
      const i = this.makeMap(o);
      this.formCreateInject.children.forEach((l) => {
        !l.slot || i.indexOf(l.slot) > -1 && (l.slot = `${e.pid}:${e.idx}`);
      }), this.loadRule();
    },
    addCol(e, o) {
      if (this.rule.col++, this.rule.layout.forEach((i) => {
        i.left > (o ? e.idx - 1 : e.idx) && i.left++;
      }), o || e.idx < this.rule.col - 2) {
        const i = {};
        for (let n = 0; n < this.rule.row; n++)
          for (let u = o ? e.idx - 1 : e.idx + 1; u < this.rule.col - 1; u++)
            i[`${n}:${u}`] = `${n}:${u + 1}`;
        const l = Object.keys(i);
        this.formCreateInject.children.forEach((n) => {
          let u;
          n.slot && (u = l.indexOf(n.slot)) > -1 && (n.slot = i[l[u]]);
        }), l.forEach((n) => {
          this.style[n] && (this.style[i[n]] = this.style[n], delete this.style[n]);
        });
      }
      this.loadRule();
    },
    addRow(e, o) {
      if (this.rule.row++, this.rule.layout.forEach((i) => {
        i.top > (o ? e.pid - 1 : e.pid) && i.top++;
      }), o || e.pid < this.rule.row - 2) {
        const i = {};
        for (let n = o ? e.pid - 1 : e.pid + 1; n < this.rule.row; n++)
          for (let u = 0; u < this.rule.col; u++)
            i[`${n}:${u}`] = `${n + 1}:${u}`;
        const l = Object.keys(i);
        this.formCreateInject.children.forEach((n) => {
          let u;
          n.slot && (u = l.indexOf(n.slot)) > -1 && (n.slot = i[l[u]]);
        }), l.reverse().forEach((n) => {
          this.style[n] && (this.style[i[n]] = this.style[n], delete this.style[n]);
        });
      }
      this.loadRule();
    },
    loadRule() {
      const e = [], o = this.rule || { row: 1, col: 1 };
      for (let l = 0; l < o.row; l++) {
        const n = [];
        e.push(n);
        for (let u = 0; u < o.col; u++)
          n.push({ rowspan: 1, colspan: 1, slot: [], show: !0, id: this.getUnique(`${l}${u}`) });
      }
      [...o.layout || []].forEach((l, n) => {
        if ((!l.row || l.row <= 0) && (!l.col || l.col <= 0) || !e[l.top] || !e[l.top][l.left] || !e[l.top][l.left].show) {
          o.layout.splice(n, 1);
          return;
        }
        const u = e[l.top][l.left];
        u.layout = l;
        let f = 1, p = 1;
        if (l.col && (f = l.col + l.left > o.col ? o.col - l.left : l.col, u.colspan = f), l.row && (p = l.row + l.top > o.row ? o.row - l.top : l.row, u.rowspan = p), p && f)
          for (let c = 0; c < p; c++) {
            const v = e[l.top + c];
            if (v)
              for (let b = 0; b < f; b++)
                !b && !c || (v[l.left + b] && (v[l.left + b].show = !1), u.slot.push(`${l.top + c}:${l.left + b}`));
          }
      });
      const i = (l) => !!(!l || l.layout || !l.show);
      e.forEach((l, n) => {
        l.forEach((u, f) => {
          let p = !1, c = !1;
          if (u.layout) {
            const v = u.layout.col || 1, b = u.layout.row || 1;
            for (let y = 0; y < v; y++)
              if (!e[n + b] || i(e[n + b][f + y])) {
                c = !0;
                continue;
              }
            for (let y = 0; y < b; y++)
              if (!e[n + y] || i(e[n + y][f + v])) {
                p = !0;
                continue;
              }
          } else
            p = i(l[f + 1]), c = e[n + 1] ? i(e[n + 1][f]) : !0;
          u.right = p, u.bottom = c;
        });
      }), this.lattice = e, this.formCreateInject.rule.props.rule = o;
    }
  },
  beforeMount() {
    this.loadRule();
  }
}), YC = { class: "_fd-table-view" }, QC = { class: "_fd-table-view-cell" }, KC = ["onClick"], JC = /* @__PURE__ */ _("i", { class: "fc-icon icon-add-tr" }, null, -1), XC = [
  JC
], ZC = ["onClick"], qC = /* @__PURE__ */ _("i", {
  class: "fc-icon icon-add-tr",
  style: { transform: "rotate(90deg)" }
}, null, -1), _C = [
  qC
], eS = { class: "_fd-drag-btn _fd-table-view-btn" }, tS = /* @__PURE__ */ _("i", { class: "fc-icon icon-setting" }, null, -1);
function nS(e, o, i, l, n, u) {
  const f = ie("DragBox"), p = ie("el-dropdown-item"), c = ie("el-dropdown-menu"), v = ie("el-dropdown"), b = ie("DragTool");
  return Z(), fe("div", YC, [
    _("table", {
      border: "1",
      cellspacing: "0",
      cellpadding: "0",
      style: ri(e.tableColor)
    }, [
      (Z(!0), fe(ze, null, ft(e.rule.row, (y, E) => (Z(), fe("tr", { key: E }, [
        (Z(!0), fe(ze, null, ft(e.rule.col, (w, h) => (Z(), fe(ze, null, [
          e.lattice[E][h].show ? (Z(), fe("td", Vr({
            key: `${E}${h}`
          }, e.lattice[E][h] ? { colspan: e.lattice[E][h].colspan, rowspan: e.lattice[E][h].rowspan } : {}, {
            style: [e.tableColor, e.style && e.style[`${E}:${h}`] || {}],
            class: e.rule.class && e.rule.class[`${E}:${h}`] || ""
          }), [
            _("div", QC, [
              X(b, {
                "drag-btn": !1,
                "handle-btn": !0,
                onActive: (m) => e.active({ pid: E, idx: h }),
                unique: e.lattice[E][h].id
              }, {
                handle: Y(() => [
                  _("div", {
                    class: "_fd-drag-btn _fd-table-view-btn",
                    onClick: (m) => e.addRow({ pid: E, idx: h, data: e.lattice[E][h] }, 0)
                  }, XC, 8, KC),
                  _("div", {
                    class: "_fd-drag-btn _fd-table-view-btn",
                    onClick: (m) => e.addCol({ pid: E, idx: h, data: e.lattice[E][h] }, 0)
                  }, _C, 8, ZC),
                  _("div", eS, [
                    X(v, {
                      trigger: "click",
                      onCommand: e.command
                    }, {
                      dropdown: Y(() => [
                        X(c, null, {
                          default: Y(() => [
                            X(p, {
                              command: ["addCol", [{ pid: E, idx: h, data: e.lattice[E][h] }, 1]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.addLeft")), 1)
                              ]),
                              _: 2
                            }, 1032, ["command"]),
                            X(p, {
                              command: ["addCol", [{ pid: E, idx: h, data: e.lattice[E][h] }, 0]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.addRight")), 1)
                              ]),
                              _: 2
                            }, 1032, ["command"]),
                            X(p, {
                              command: ["addRow", [{ pid: E, idx: h, data: e.lattice[E][h] }, 1]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.addTop")), 1)
                              ]),
                              _: 2
                            }, 1032, ["command"]),
                            X(p, {
                              command: ["addRow", [{ pid: E, idx: h, data: e.lattice[E][h] }, 0]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.addBottom")), 1)
                              ]),
                              _: 2
                            }, 1032, ["command"]),
                            X(p, {
                              divided: "",
                              disabled: e.lattice[E][h].right,
                              command: ["mergeRight", [{ pid: E, idx: h, data: e.lattice[E][h] }]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.mergeRight")), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "command"]),
                            X(p, {
                              disabled: e.lattice[E][h].bottom,
                              command: ["mergeBottom", [{ pid: E, idx: h, data: e.lattice[E][h] }]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.mergeBottom")), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "command"]),
                            X(p, {
                              divided: "",
                              disabled: !(e.lattice[E][h].layout && e.lattice[E][h].layout.col > 1),
                              command: ["splitCol", [{ pid: E, idx: h, data: e.lattice[E][h] }]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.splitCol")), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "command"]),
                            X(p, {
                              disabled: !(e.lattice[E][h].layout && e.lattice[E][h].layout.row > 1),
                              command: ["splitRow", [{ pid: E, idx: h, data: e.lattice[E][h] }]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.splitRow")), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "command"]),
                            X(p, {
                              divided: "",
                              disabled: e.rule.col < 2,
                              command: ["rmCol", [{ pid: E, idx: h, data: e.lattice[E][h] }]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.rmCol")), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "command"]),
                            X(p, {
                              disabled: e.rule.row < 2,
                              command: ["rmRow", [{ pid: E, idx: h, data: e.lattice[E][h] }]]
                            }, {
                              default: Y(() => [
                                xe(ve(e.t("tableOptions.rmRow")), 1)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "command"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: Y(() => [
                        tS
                      ]),
                      _: 2
                    }, 1032, ["onCommand"])
                  ])
                ]),
                default: Y(() => [
                  X(f, Vr(e.dragProp, {
                    onAdd: (m) => e.dragAdd(m, { pid: E, idx: h }),
                    ref_for: !0,
                    ref: "drag" + E + h,
                    onEnd: (m) => e.dragEnd(m, { pid: E, idx: h }),
                    onStart: o[0] || (o[0] = (m) => e.dragStart(m)),
                    onUnchoose: o[1] || (o[1] = (m) => e.dragUnchoose(m)),
                    list: e.getSlotChildren([`${E}:${h}`, ...e.lattice[E][h].slot])
                  }), {
                    default: Y(() => [
                      en(e.$slots, `${E}:${h}`)
                    ]),
                    _: 2
                  }, 1040, ["onAdd", "onEnd", "list"])
                ]),
                _: 2
              }, 1032, ["onActive", "unique"])
            ])
          ], 16)) : Se("", !0)
        ], 64))), 256))
      ]))), 128))
    ], 4)
  ]);
}
const rS = /* @__PURE__ */ qe(GC, [["render", nS]]);
const iS = {
  name: "FcTable",
  props: {
    label: String,
    width: [Number, String],
    border: {
      type: Boolean,
      default: !0
    },
    borderWidth: String,
    borderColor: String,
    rule: {
      type: Object,
      default: () => ({ row: 1, col: 1 })
    }
  },
  watch: {
    rule: {
      handler() {
        this.initRule(), this.loadRule(), this.tdStyle = this.rule.style || {}, this.tdClass = this.rule.class || {};
      },
      immediate: !0,
      deep: !0
    }
  },
  data() {
    return {
      tdStyle: {},
      tdClass: {},
      lattice: {}
    };
  },
  computed: {
    tableColor() {
      const e = {};
      return this.border === !1 ? e.border = "0 none" : (this.borderColor && (e.borderColor = this.borderColor), this.borderWidth && (e.borderWidth = this.borderWidth)), e;
    }
  },
  methods: {
    initRule() {
      const e = this.rule;
      e.style || (e.style = {}), e.layout || (e.layout = []), e.row || (e.row = 1), e.col || (e.col = 1);
    },
    loadRule() {
      const e = [], o = this.rule || { row: 1, col: 1 };
      for (let l = 0; l < o.row; l++) {
        const n = [];
        e.push(n);
        for (let u = 0; u < o.col; u++)
          n.push({ rowspan: 1, colspan: 1, slot: [], show: !0 });
      }
      [...o.layout || []].forEach((l, n) => {
        if ((!l.row || l.row <= 0) && (!l.col || l.col <= 0) || !e[l.top] || !e[l.top][l.left] || !e[l.top][l.left].show) {
          o.layout.splice(n, 1);
          return;
        }
        const u = e[l.top][l.left];
        u.layout = l;
        let f = 1, p = 1;
        if (l.col && (f = l.col + l.left > o.col ? o.col - l.left : l.col, u.colspan = f), l.row && (p = l.row + l.top > o.row ? o.row - l.top : l.row, u.rowspan = p), p && f)
          for (let c = 0; c < p; c++) {
            const v = e[l.top + c];
            if (v)
              for (let b = 0; b < f; b++)
                !b && !c || (v[l.left + b] && (v[l.left + b].show = !1), u.slot.push(`${l.top + c}:${l.left + b}`));
          }
      });
      const i = (l) => !!(!l || l.layout || !l.show);
      e.forEach((l, n) => {
        l.forEach((u, f) => {
          let p = !1, c = !1;
          if (u.layout) {
            const v = u.layout.col || 1, b = u.layout.row || 1;
            for (let y = 0; y < v; y++)
              if (!e[n + b] || i(e[n + b][f + y])) {
                c = !0;
                continue;
              }
            for (let y = 0; y < b; y++)
              if (!e[n + y] || i(e[n + y][f + v])) {
                p = !0;
                continue;
              }
          } else
            p = i(l[f + 1]), c = e[n + 1] ? i(e[n + 1][f]) : !0;
          u.right = p, u.bottom = c;
        });
      }), this.lattice = e;
    }
  }
}, oS = { class: "_fc-table" };
function lS(e, o, i, l, n, u) {
  const f = ie("ElCol");
  return Z(), we(f, { span: 24 }, {
    default: Y(() => [
      _("div", oS, [
        _("table", {
          border: "1",
          cellspacing: "0",
          cellpadding: "0",
          style: ri(u.tableColor)
        }, [
          (Z(!0), fe(ze, null, ft(i.rule.row, (p, c) => (Z(), fe("tr", { key: c }, [
            (Z(!0), fe(ze, null, ft(i.rule.col, (v, b) => (Z(), fe(ze, {
              key: `${c}${b}`
            }, [
              n.lattice[c][b].show ? (Z(), fe("td", Vr({ key: 0 }, n.lattice[c][b] ? { colspan: n.lattice[c][b].colspan, rowspan: n.lattice[c][b].rowspan } : {}, {
                valign: "top",
                class: n.tdClass && n.tdClass[`${c}:${b}`] || "",
                style: [u.tableColor, n.tdStyle && n.tdStyle[`${c}:${b}`] || {}]
              }), [
                en(e.$slots, `${c}:${b}`),
                (Z(!0), fe(ze, null, ft(n.lattice[c][b].slot, (y) => en(e.$slots, `${y}`)), 256))
              ], 16)) : Se("", !0)
            ], 64))), 128))
          ]))), 128))
        ], 4)
      ])
    ]),
    _: 3
  });
}
const aS = /* @__PURE__ */ qe(iS, [["render", lS]]);
const sS = et({
  name: "FcValue",
  props: ["modelValue"],
  inject: ["designer"],
  watch: {
    modelValue(e) {
      this.$emit("change", e);
    }
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  }
}), uS = { class: "_fd-value" };
function dS(e, o, i, l, n, u) {
  return Z(), fe("div", uS, ve(e.t("com.fcValue.empty")), 1);
}
const fS = /* @__PURE__ */ qe(sS, [["render", dS]]), cS = et({
  name: "FcValue",
  props: ["modelValue"],
  watch: {
    modelValue(e) {
      this.$emit("change", e);
    }
  }
}), pS = { class: "_fc-value" };
function hS(e, o, i, l, n, u) {
  return Z(), fe("div", pS, ve(e.modelValue), 1);
}
const vS = /* @__PURE__ */ qe(cS, [["render", hS]]);
const mS = et({
  name: "Validate",
  inject: ["designer"],
  props: {
    modelValue: Array
  },
  components: {
    DragForm: Ze.$form()
  },
  watch: {
    modelValue(e) {
      this.formValue = this.parseValue(e);
    }
  },
  data() {
    const e = this.designer.setupState.t, o = this.designer.setupState.activeRule._menu.validate || [], i = {
      string: e("validate.types.string"),
      array: e("validate.types.array"),
      number: e("validate.types.number"),
      integer: e("validate.types.integer"),
      float: e("validate.types.float"),
      object: e("validate.types.object"),
      date: e("validate.types.date"),
      url: e("validate.types.url"),
      email: e("validate.types.email")
    }, n = ((u) => {
      const f = [];
      return u && u.forEach((p) => {
        f.push({
          label: i[p],
          value: p
        });
      }), f.push({
        label: e("props.custom"),
        value: "validator"
      }), f;
    })(o);
    return {
      formValue: {},
      t: e,
      option: {
        form: {
          labelPosition: "top",
          size: "small",
          labelWidth: "90px"
        },
        submitBtn: !1,
        appendValue: !0,
        formData: this.parseValue(this.modelValue)
      },
      rule: [
        {
          type: "group",
          field: "validate",
          props: {
            expand: 1,
            sortBtn: !1,
            defaultValue: { type: n[0].value },
            rule: [
              {
                type: n.length === 1 ? "hidden" : "select",
                field: "type",
                value: "",
                title: e("validate.type"),
                props: {
                  placeholder: e("validate.typePlaceholder")
                },
                control: [
                  {
                    value: ["url", "date", "email", "object", "validator"],
                    condition: "notIn",
                    rule: ["mode", "min", "max", "len", "pattern"]
                  },
                  {
                    value: "validator",
                    rule: ["validator"]
                  }
                ],
                options: n
              },
              {
                type: "select",
                title: e("validate.trigger"),
                field: "trigger",
                value: "change",
                options: Ft(e, [
                  { label: "change", value: "change" },
                  { label: "submit", value: "submit" },
                  { label: "blur", value: "blur" }
                ])
              },
              {
                type: "FnEditor",
                field: "validator",
                value: "",
                props: {
                  name: "validator",
                  args: ["rule", "value", "callback"],
                  button: !0
                }
              },
              {
                type: "select",
                title: e("validate.mode"),
                field: "mode",
                options: [
                  { value: "min", label: e("validate.modes.min") },
                  { value: "max", label: e("validate.modes.max") },
                  { value: "len", label: e("validate.modes.len") },
                  { value: "pattern", label: e("validate.modes.pattern") }
                ],
                value: "min",
                control: [
                  {
                    value: "pattern",
                    rule: [
                      {
                        type: "input",
                        field: "pattern",
                        title: e("validate.modes.pattern")
                      }
                    ]
                  },
                  {
                    value: "min",
                    rule: [
                      {
                        type: "inputNumber",
                        field: "min",
                        title: e("validate.modes.min")
                      }
                    ]
                  },
                  {
                    value: "max",
                    rule: [
                      {
                        type: "inputNumber",
                        field: "max",
                        title: e("validate.modes.max")
                      }
                    ]
                  },
                  {
                    value: "len",
                    rule: [
                      {
                        type: "inputNumber",
                        field: "len",
                        title: e("validate.modes.len")
                      }
                    ]
                  }
                ]
              },
              {
                type: "input",
                title: e("validate.message"),
                field: "message",
                value: "",
                children: [
                  {
                    type: "span",
                    slot: "append",
                    inject: !0,
                    class: "append-msg",
                    on: {
                      click: (u) => {
                        const f = this.designer.setupState.activeRule.title;
                        this.designer.setupState.activeRule && u.api.setValue("message", e(u.api.form.mode !== "required" ? "validate.autoMode" : "validate.autoRequired", { title: f }));
                      }
                    },
                    children: [e("validate.auto")]
                  }
                ]
              }
            ]
          },
          value: []
        }
      ]
    };
  },
  methods: {
    onInput: function (e) {
      const { validate: o } = Lt(e);
      this.$emit("update:modelValue", (o || []).filter((i) => Object.keys(i).length > 1));
    },
    parseValue(e) {
      let o = {
        validate: e ? [...e] : [],
        type: e.length ? e[0].type || "string" : void 0
      };
      return o.validate.forEach((i) => {
        i.mode || Object.keys(i).forEach((l) => {
          ["message", "type", "trigger", "mode"].indexOf(l) < 0 && (i.mode = l);
        });
      }), o;
    }
  }
});
function gS(e, o, i, l, n, u) {
  const f = ie("DragForm");
  return Z(), we(f, {
    class: "_fd-validate",
    rule: e.rule,
    option: e.option,
    modelValue: e.formValue,
    "onUpdate:modelValue": e.onInput
  }, null, 8, ["rule", "option", "modelValue", "onUpdate:modelValue"]);
}
const yS = /* @__PURE__ */ qe(mS, [["render", gS]]);
const bS = et({
  name: "Required",
  props: {
    modelValue: {}
  },
  inject: ["designer"],
  watch: {
    required() {
      this.update();
    },
    requiredMsg() {
      this.update();
    },
    modelValue(e) {
      const o = st.String(e);
      this.required = e === void 0 ? !1 : o ? !0 : !!e, this.requiredMsg = o ? e : "";
    }
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  },
  data() {
    const e = st.String(this.modelValue);
    return {
      required: this.modelValue === void 0 ? !1 : e ? !0 : !!this.modelValue,
      requiredMsg: e ? this.modelValue : ""
    };
  },
  methods: {
    update() {
      let e;
      this.required === !1 ? e = !1 : e = this.requiredMsg || !0, this.$emit("update:modelValue", e);
    }
  }
}), AS = { class: "_fd-required" };
function CS(e, o, i, l, n, u) {
  const f = ie("ElSwitch"), p = ie("ElInput");
  return Z(), fe("div", AS, [
    X(f, {
      modelValue: e.required,
      "onUpdate:modelValue": o[0] || (o[0] = (c) => e.required = c)
    }, null, 8, ["modelValue"]),
    e.required ? (Z(), we(p, {
      key: 0,
      modelValue: e.requiredMsg,
      "onUpdate:modelValue": o[1] || (o[1] = (c) => e.requiredMsg = c),
      placeholder: e.t("validate.requiredPlaceholder")
    }, null, 8, ["modelValue", "placeholder"])) : Se("", !0)
  ]);
}
const SS = /* @__PURE__ */ qe(bS, [["render", CS]]);
const ES = et({
  name: "TreeOptions",
  props: {
    modelValue: Array,
    columns: Object,
    keyValue: String
  },
  inject: ["designer"],
  data() {
    return {
      value: [...Lt(this.modelValue || [])],
      checked: !1
    };
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    overColumns() {
      return this.columns ? {
        label: this.columns.label || "label",
        value: this.columns.value || "value"
      } : {
        label: "label",
        value: "value"
      };
    }
  },
  created() {
    this.value.length || (this.value = [{}]), this.keyValue && (this.checked = this.isChecked(), this.$watch("checked", (e) => {
      e && this.change();
    }));
  },
  methods: {
    isChecked() {
      const e = (o) => {
        for (let i = 0; i < o.length; i++) {
          const l = o[i];
          if (l[this.overColumns.label] !== l[this.overColumns.value] || l.children && !e(l.children))
            return !1;
        }
        return !0;
      };
      return e(this.modelValue);
    },
    tidyValue() {
      const e = (o) => {
        let i = [];
        return o.map((l) => {
          const n = l[this.keyValue], u = {
            [this.overColumns.label]: n,
            [this.overColumns.value]: n
          };
          i.push(u), l.children && (u.children = e(l.children));
        }), i;
      };
      return this.checked && this.keyValue ? e(this.value) : Lt(this.value);
    },
    change() {
      this.$emit("update:modelValue", this.tidyValue());
    },
    add(e) {
      const o = e.parent;
      (o.data.children || o.data).push({});
    },
    append(e) {
      e.children || (e.children = []), e.children.push({});
    },
    remove(e, o) {
      const i = e.parent;
      i.data.children ? (i.data.children.splice(i.data.children.indexOf(o), 1), i.data.children.length || delete i.data.children) : i.data.splice(i.data.indexOf(o), 1), this.change();
    }
  }
}), wS = { class: "_fd-tree-opt" }, xS = { class: "_fd-tree-opt-node" }, TS = ["onClick"], DS = /* @__PURE__ */ _("i", { class: "fc-icon icon-add" }, null, -1), IS = [
  DS
], RS = ["onClick"], FS = /* @__PURE__ */ _("i", { class: "fc-icon icon-add-child" }, null, -1), MS = [
  FS
], OS = ["onClick"], NS = /* @__PURE__ */ _("i", { class: "fc-icon icon-delete" }, null, -1), LS = [
  NS
], PS = ["onClick"], $S = /* @__PURE__ */ _("i", { class: "fc-icon icon-add" }, null, -1), BS = [
  $S
], kS = ["onClick"], HS = /* @__PURE__ */ _("i", { class: "fc-icon icon-add-child" }, null, -1), VS = [
  HS
], US = ["onClick"], jS = /* @__PURE__ */ _("i", { class: "fc-icon icon-delete" }, null, -1), zS = [
  jS
];
function WS(e, o, i, l, n, u) {
  const f = ie("ElInput"), p = ie("el-tree"), c = ie("el-checkbox");
  return Z(), fe("div", wS, [
    (Z(), we(p, {
      data: e.value,
      "node-key": "index",
      key: e.checked ? "1" : "2",
      "expand-on-click-node": !1
    }, {
      default: Y(({ node: v, data: b }) => [
        _("div", xS, [
          e.checked ? (Z(), we(f, {
            key: 1,
            class: "_fd-tree-opt-last _label",
            modelValue: b[e.keyValue],
            "onUpdate:modelValue": (y) => b[e.keyValue] = y,
            onBlur: e.change
          }, {
            append: Y(() => [
              _("div", {
                class: "_fd-tree-opt-btn",
                onClick: (y) => e.add(v, b)
              }, BS, 8, PS),
              _("div", {
                class: "_fd-tree-opt-btn",
                onClick: (y) => e.append(b)
              }, VS, 8, kS),
              _("div", {
                class: "_fd-tree-opt-btn _fd-tree-opt-danger",
                onClick: (y) => e.remove(v, b)
              }, zS, 8, US)
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur"])) : (Z(), fe(ze, { key: 0 }, [
            X(f, {
              class: "_fd-tree-opt-first",
              modelValue: b[e.overColumns.label],
              "onUpdate:modelValue": (y) => b[e.overColumns.label] = y,
              onBlur: e.change
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]),
            X(f, {
              class: "_fd-tree-opt-last",
              modelValue: b[e.overColumns.value],
              "onUpdate:modelValue": (y) => b[e.overColumns.value] = y,
              onBlur: e.change
            }, {
              append: Y(() => [
                _("div", {
                  class: "_fd-tree-opt-btn",
                  onClick: (y) => e.add(v, b)
                }, IS, 8, TS),
                _("div", {
                  class: "_fd-tree-opt-btn",
                  onClick: (y) => e.append(b)
                }, MS, 8, RS),
                _("div", {
                  class: "_fd-tree-opt-btn _fd-tree-opt-danger",
                  onClick: (y) => e.remove(v, b)
                }, LS, 8, OS)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur"])
          ], 64))
        ])
      ]),
      _: 1
    }, 8, ["data"])),
    e.keyValue ? (Z(), we(c, {
      key: 0,
      modelValue: e.checked,
      "onUpdate:modelValue": o[0] || (o[0] = (v) => e.checked = v),
      label: e.t("tableOptions.keyValue")
    }, null, 8, ["modelValue", "label"])) : Se("", !0)
  ]);
}
const GS = /* @__PURE__ */ qe(ES, [["render", WS]]);
const Wc = (e) => {
  const o = [];
  return e.forEach((i) => {
    i.field && o.push(i.__fc__.id), i.children && o.push(...Wc(i.children));
  }), o;
}, YS = et({
  name: "StepForm",
  props: {
    stepsProps: Object,
    modelValue: Object,
    formCreateInject: Object,
    autoValidate: Boolean,
    steps: {
      type: Array,
      required: !0,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ni({
        submitBtn: !1,
        resetBtn: !1
      })
    }
  },
  emits: ["update:modelValue", "change", "itemMounted", "submit", "next"],
  data() {
    return {
      active: 0,
      cacheRule: [],
      cacheValue: {},
      subApi: {},
      Form: On(this.formCreateInject.form.$form())
    };
  },
  watch: {
    active() {
      this.init();
    },
    modelValue(e) {
      this.setValue(e);
    }
  },
  methods: {
    init() {
      this.steps.forEach((e, o) => {
        this.cacheRule[o] = {
          type: "FcRow",
          native: !0,
          display: o === this.active,
          children: e.rule
        };
      });
    },
    onPrev() {
      this.active--;
    },
    validate() {
      return new Promise((e, o) => {
        const i = Wc(this.cacheRule[this.active].children);
        i.length > 0 ? this.subApi.formEl().validateField(i).then(() => {
          e();
        }).catch((l) => {
          o(l);
        }) : e();
      });
    },
    onNext() {
      this.autoValidate ? this.validate().then(() => {
        this.active++;
      }).catch((e) => {
      }) : this.active++, this.$emit("next", { active: this.active, api: this.subApi });
    },
    submit() {
      const e = () => {
        this.$emit("submit", this.subApi.formData(), this.subApi);
      };
      this.autoValidate ? this.validate().then(() => {
        e();
      }).catch((o) => {
      }) : e();
    },
    addSubApi(e) {
      this.subApi = e, this.$emit("itemMounted", e);
    },
    formData(e) {
      this.cacheValue = JSON.stringify(e), this.$emit("update:modelValue", e), this.$emit("change", e);
    },
    setValue(e) {
      const o = JSON.stringify(e);
      this.cacheValue !== o && (this.cacheValue = o, this.subApi.coverValue(e || {}));
    }
  },
  created() {
    this.init();
  }
}), QS = { class: "_fc-step-form" };
function KS(e, o, i, l, n, u) {
  const f = ie("el-step"), p = ie("el-steps"), c = ie("el-button"), v = ie("el-col"), b = ie("el-row");
  return Z(), fe("div", QS, [
    X(p, Vr({ active: e.active }, e.stepsProps), {
      default: Y(() => [
        (Z(!0), fe(ze, null, ft(e.steps, (y) => (Z(), we(f, Zh(qh(y.props)), null, 16))), 256))
      ]),
      _: 1
    }, 16, ["active"]),
    (Z(), we(zl(e.Form), {
      option: e.options,
      rule: e.cacheRule,
      extendOption: !0,
      modelValue: e.modelValue,
      "onUpdate:api": e.addSubApi,
      onEmitEvent: e.$emit,
      "onUpdate:modelValue": e.formData
    }, null, 40, ["option", "rule", "modelValue", "onUpdate:api", "onEmitEvent", "onUpdate:modelValue"])),
    X(b, null, {
      default: Y(() => [
        X(v, {
          span: 24,
          style: { display: "flex", "justify-content": "flex-end", "margin-top": "15px" }
        }, {
          default: Y(() => [
            e.active > 0 ? (Z(), we(c, {
              key: 0,
              onClick: e.onPrev
            }, {
              default: Y(() => [
                xe("\u4E0A\u4E00\u6B65")
              ]),
              _: 1
            }, 8, ["onClick"])) : Se("", !0),
            e.active < e.cacheRule.length - 1 ? (Z(), we(c, {
              key: 1,
              type: "primary",
              onClick: e.onNext
            }, {
              default: Y(() => [
                xe("\u4E0B\u4E00\u6B65")
              ]),
              _: 1
            }, 8, ["onClick"])) : Se("", !0),
            e.active === e.cacheRule.length - 1 ? (Z(), we(c, {
              key: 2,
              class: "fc-clock",
              type: "primary",
              onClick: e.submit
            }, {
              default: Y(() => [
                xe("\u63D0\u4EA4 ")
              ]),
              _: 1
            }, 8, ["onClick"])) : Se("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
const JS = /* @__PURE__ */ qe(YS, [["render", KS]]);
const XS = et({
  name: "StepFormView",
  props: {
    stepsProps: Object,
    formCreateInject: Object
  },
  provide() {
    return {
      stepForm: this
    };
  },
  inject: ["designer"],
  data() {
    return {
      active: void 0,
      activeId: void 0,
      stepItemRef: [],
      activeRef: void 0
    };
  },
  watch: {
    "stepItemRef.length"() {
      (!this.active || this.stepItemRef.indexOf(this.activeRef) === -1) && (this.active = 0);
    },
    active(e, o) {
      this.activeRef = this.stepItemRef[e], this.activeId = this.activeRef.id, o !== void 0 && this.$nextTick(() => {
        this.designer.setupState.triggerActive(this.activeRef.formCreateInject.rule);
      });
    }
  },
  methods: {
    onPrev() {
      this.active--;
    },
    onNext() {
      this.active++;
    },
    change(e) {
      this.active = e;
    }
  },
  created() {
  }
}), ZS = { class: "_fd-step-form" };
function qS(e, o, i, l, n, u) {
  const f = ie("el-step"), p = ie("el-steps"), c = ie("el-button"), v = ie("el-col"), b = ie("el-row");
  return Z(), fe("div", ZS, [
    X(p, Vr({ active: e.active }, e.stepsProps), {
      default: Y(() => [
        (Z(!0), fe(ze, null, ft(e.stepItemRef, (y, E) => (Z(), we(f, {
          key: y.id,
          onClick: yt((w) => e.change(E), ["stop"]),
          title: y.title,
          description: y.description
        }, null, 8, ["onClick", "title", "description"]))), 128))
      ]),
      _: 1
    }, 16, ["active"]),
    en(e.$slots, "default"),
    X(b, null, {
      default: Y(() => [
        X(v, {
          span: 24,
          style: { display: "flex", "justify-content": "flex-end", padding: "15px" }
        }, {
          default: Y(() => [
            e.active > 0 ? (Z(), we(c, {
              key: 0,
              onClick: yt(e.onPrev, ["stop"])
            }, {
              default: Y(() => [
                xe("\u4E0A\u4E00\u6B65")
              ]),
              _: 1
            }, 8, ["onClick"])) : Se("", !0),
            e.active < e.stepItemRef.length - 1 ? (Z(), we(c, {
              key: 1,
              type: "primary",
              onClick: yt(e.onNext, ["stop"])
            }, {
              default: Y(() => [
                xe("\u4E0B\u4E00\u6B65")
              ]),
              _: 1
            }, 8, ["onClick"])) : Se("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
const _S = /* @__PURE__ */ qe(XS, [["render", qS]]);
const eE = et({
  name: "TableFormView",
  data() {
    return {};
  }
}), tE = { class: "_fd-table-form" }, nE = {
  key: 0,
  class: "_fd-tf-wrap"
}, rE = {
  key: 1,
  class: "_fc-child-empty"
};
function iE(e, o, i, l, n, u) {
  return Z(), fe("div", tE, [
    e.$slots.default ? (Z(), fe("div", nE, [
      en(e.$slots, "default")
    ])) : (Z(), fe("div", rE))
  ]);
}
const oE = /* @__PURE__ */ qe(eE, [["render", iE]]);
const lE = et({
  name: "NestedTableFormView",
  inject: ["designer"],
  data() {
    return {};
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  }
}), aE = { class: "_fd-ntable-form" }, sE = {
  key: 0,
  class: "_fd-ntf-wrap"
}, uE = {
  key: 1,
  class: "_fc-child-empty"
}, dE = {
  key: 2,
  class: "_fd-ntable-sub"
}, fE = { class: "_title" };
function cE(e, o, i, l, n, u) {
  return Z(), fe("div", aE, [
    e.$slots.default ? (Z(), fe("div", sE, [
      en(e.$slots, "default")
    ])) : (Z(), fe("div", uE)),
    e.$slots.default ? (Z(), fe("div", dE, [
      _("div", fE, ve(e.t("com.nestedSubTableForm.name")), 1),
      en(e.$slots, "nested")
    ])) : Se("", !0)
  ]);
}
const pE = /* @__PURE__ */ qe(lE, [["render", cE]]);
const hE = {
  name: "NestedTableForm",
  inject: ["designer"],
  emits: ["change", "add", "delete", "update:modelValue"],
  props: {
    formCreateInject: Object,
    modelValue: {
      type: Array,
      default: () => []
    },
    nested: Array,
    nestedField: String,
    columns: {
      type: Array,
      required: !0,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ni({
        submitBtn: !1,
        resetBtn: !1
      })
    },
    max: Number,
    nestedMax: Number,
    disabled: Boolean
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    preview() {
      return this.formCreateInject.preview;
    }
  },
  watch: {
    modelValue() {
      this.updateTable();
    },
    "formCreateInject.preview"(e) {
      this.trs.forEach((o) => {
        const i = o.children[1].children[0].props.colspan;
        o.children[1].children[0].props.colspan = e ? i - 1 : i + 1;
      });
    }
  },
  data() {
    return {
      rule: [],
      trs: [],
      fapi: {},
      Form: On(this.formCreateInject.form.$form()),
      copyTrs: "",
      oldValue: ""
    };
  },
  methods: {
    formChange(e, o, i, l, n) {
      n === !1 && this.updateValue();
    },
    updateValue() {
      const e = this.trs.map((i) => this.fapi.getChildrenFormData(i)).filter((i) => {
        if (i == null)
          return !1;
        let l = !1;
        return Object.keys(i).forEach((n) => {
          l || (l = l || i[n] !== void 0 && i[n] !== "" && i[n] !== null && (Array.isArray(i[n]) ? !!i[n].length : !0));
        }), l;
      }), o = JSON.stringify(e);
      o !== this.oldValue && (this.oldValue = o, this.$emit("update:modelValue", e), this.$emit("change", e));
    },
    setRawData(e, o) {
      const i = this.trs[e];
      this.fapi.setChildrenFormData(i, o, !0);
    },
    updateTable() {
      const e = JSON.stringify(this.modelValue);
      this.oldValue !== e && (this.oldValue = e, this.trs = this.trs.splice(0, this.modelValue.length), this.modelValue.length || this.addRaw(), this.modelValue.forEach((o, i) => {
        this.trs[i] || this.addRaw(), this.setRawData(i, o);
      }), this.rule[0].children[1].children = this.trs);
    },
    delRaw(e) {
      this.disabled || (this.trs.splice(e, 1), this.updateValue(), this.trs.length ? this.trs.forEach((o) => this.updateRaw(o)) : this.addRaw(), this.$emit("delete", e));
    },
    addRaw(e) {
      if (e && this.disabled)
        return;
      const o = _n.parseJson(this.copyTrs)[0], i = {
        type: "template",
        subRule: !0,
        children: []
      };
      i.children.push(o), i.children.push({
        type: "tr",
        native: !0,
        display: !1,
        children: [{
          type: "td",
          native: !0,
          props: {
            colspan: o.children.length - (this.preview ? 1 : 0)
          },
          class: "_fc-ntf-sub",
          children: [{
            type: "TableForm",
            field: this.nestedField,
            value: [],
            props: {
              disabled: this.disabled,
              max: this.nestedMax || 0,
              columns: Lt(this.nested),
              options: Lt(this.options)
            }
          }]
        }]
      }), this.trs.push(i), this.updateRaw(i), e && this.$emit("add", this.trs);
    },
    updateRaw(e) {
      const o = this.trs.indexOf(e), i = e.children[0];
      i.children[0].children[0].props.onClick = (l) => {
        const n = l.self.children[0] === "-" ? "+" : "-";
        l.self.children = [n], this.trs[o].children[1].display = n === "-";
      }, i.children[1].props.innerText = o + 1, i.children[i.children.length - 1].children[0].props.onClick = () => {
        this.delRaw(o);
      };
    },
    loadRule() {
      const e = [{
        type: "th",
        native: !0,
        class: "_fc-ntf-sub-idx"
      }, {
        type: "th",
        native: !0,
        class: "_fc-ntf-head-idx",
        props: {
          innerText: "#"
        }
      }];
      let o = [{
        type: "td",
        class: "_fc-ntf-idx",
        native: !0,
        children: [
          {
            type: "div",
            hidden: !1,
            children: ["+"],
            inject: !0,
            props: {}
          }
        ]
      }, {
        type: "td",
        class: "_fc-ntf-idx",
        native: !0,
        props: {
          innerText: "0"
        }
      }];
      this.columns.forEach((i) => {
        e.push({
          type: "th",
          native: !0,
          style: i.style,
          props: {
            innerText: i.label || ""
          }
        }), o.push({
          type: "td",
          native: !0,
          children: [...i.rule || []]
        });
      }), e.push({
        type: "th",
        native: !0,
        class: "_fc-ntf-edit fc-clock",
        props: {
          innerText: this.t("tableOptions.handle")
        }
      }), o.push({
        type: "td",
        native: !0,
        class: "_fc-ntf-btn fc-clock",
        children: [
          {
            type: "i",
            native: !0,
            class: "fc-icon icon-delete",
            props: {}
          }
        ]
      }), this.copyTrs = _n.toJson([
        {
          type: "tr",
          native: !0,
          children: o
        }
      ]), this.rule = [
        {
          type: "table",
          native: !0,
          class: "_fc-ntf-table",
          props: {
            border: "1",
            cellspacing: "0",
            cellpadding: "0"
          },
          children: [
            {
              type: "thead",
              native: !0,
              children: [
                {
                  type: "tr",
                  native: !0,
                  children: e
                }
              ]
            },
            {
              type: "tbody",
              native: !0,
              children: this.trs
            }
          ]
        }
      ], this.addRaw();
    }
  },
  created() {
    this.loadRule();
  },
  mounted() {
    this.updateTable();
  }
}, vE = /* @__PURE__ */ _("i", {
  class: "fc-icon icon-add-circle",
  style: { "font-weight": "700" }
}, null, -1);
function mE(e, o, i, l, n, u) {
  const f = ie("el-button");
  return Z(), fe("div", {
    class: ot(["_fc-nested-table-form", { "_fc-disabled": i.disabled }])
  }, [
    (Z(), we(zl(n.Form), {
      option: i.options,
      rule: n.rule,
      extendOption: !0,
      onChange: u.formChange,
      disabled: i.disabled,
      api: n.fapi,
      "onUpdate:api": o[0] || (o[0] = (p) => n.fapi = p),
      onEmitEvent: e.$emit
    }, null, 40, ["option", "rule", "onChange", "disabled", "api", "onEmitEvent"])),
    !i.max || i.max > this.trs.length ? (Z(), we(f, {
      key: 0,
      link: "",
      type: "primary",
      class: "fc-clock",
      onClick: o[1] || (o[1] = (p) => u.addRaw(!0))
    }, {
      default: Y(() => [
        vE,
        xe(" " + ve(u.t("tableOptions.add")), 1)
      ]),
      _: 1
    })) : Se("", !0)
  ], 2);
}
const gE = /* @__PURE__ */ qe(hE, [["render", mE]]);
const yE = et({
  name: "InfiniteTableFormView",
  inject: ["designer"],
  data() {
    return {};
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  }
}), bE = { class: "_fd-itable-form" }, AE = {
  key: 0,
  class: "_fd-itf-wrap"
}, CE = {
  key: 1,
  class: "_fc-child-empty"
};
function SE(e, o, i, l, n, u) {
  return Z(), fe("div", bE, [
    e.$slots.default ? (Z(), fe("div", AE, [
      en(e.$slots, "default")
    ])) : (Z(), fe("div", CE))
  ]);
}
const EE = /* @__PURE__ */ qe(yE, [["render", SE]]);
const wE = {
  name: "InfiniteTableForm",
  inject: ["designer"],
  emits: ["change", "add", "delete", "update:modelValue"],
  props: {
    formCreateInject: Object,
    modelValue: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      required: !0,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ni({
        submitBtn: !1,
        resetBtn: !1
      })
    },
    max: Number,
    layerMax: {
      type: Number,
      default: 0
    },
    childrenField: String,
    disabled: Boolean
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    },
    preview() {
      return this.formCreateInject.preview;
    },
    subField() {
      return this.childrenField || "children";
    }
  },
  watch: {
    modelValue() {
      this.updateTable();
    },
    "formCreateInject.preview"(e) {
      this.trs.forEach((o, i) => {
        o.children[1] && (o.children[1].children[0].props.colspan = this.rule[0].children[0].children[0].children.length - (e ? 1 : 0)), o.children[0].children[0].children[0].hidden = this.layerMax === 1 || e && !(this.modelValue && this.modelValue[i] && Array.isArray(this.modelValue[i][this.subField]) && this.modelValue[i][this.subField].length > 0);
      });
    }
  },
  data() {
    return {
      rule: [],
      trs: [],
      fapi: {},
      Form: On(this.formCreateInject.form.$form()),
      copyTrs: "",
      oldValue: ""
    };
  },
  methods: {
    formChange(e, o, i, l, n) {
      n === !1 && this.updateValue();
    },
    updateValue() {
      const e = this.trs.map((i) => this.fapi.getChildrenFormData(i)), o = JSON.stringify(e);
      o !== this.oldValue && (this.oldValue = o, this.$emit("update:modelValue", e), this.$emit("change", e));
    },
    setRawData(e, o) {
      const i = this.trs[e];
      this.fapi.setChildrenFormData(i, o, !0);
    },
    updateTable() {
      const e = JSON.stringify(this.modelValue);
      this.oldValue !== e && (this.oldValue = e, this.trs = this.trs.splice(0, this.modelValue.length), this.modelValue.length || this.addRaw(), this.modelValue.forEach((o, i) => {
        this.trs[i] || this.addRaw(), this.setRawData(i, o);
      }), this.rule[0].children[1].children = this.trs);
    },
    delRaw(e) {
      this.disabled || (this.trs.splice(e, 1), this.updateValue(), this.trs.length ? this.trs.forEach((o) => this.updateRaw(o)) : this.addRaw(), this.$emit("delete", e));
    },
    addRaw(e) {
      if (e && this.disabled)
        return;
      const o = _n.parseJson(this.copyTrs)[0], i = {
        type: "template",
        subRule: !0,
        children: []
      };
      i.children.push(o), this.trs.push(i), this.trs.forEach((l) => this.updateRaw(l)), e && this.$emit("add", this.trs);
    },
    updateRaw(e) {
      const o = this.trs.indexOf(e), i = e.children[0];
      i.children[0].children[0].hidden = this.layerMax === 1 || this.preview && !(this.modelValue && this.modelValue[o] && Array.isArray(this.modelValue[o][this.subField]) && this.modelValue[o][this.subField].length > 0), i.children[0].children[0].props.onClick = (l) => {
        if (this.trs[o].children.length === 1) {
          if (this.disabled && !(this.modelValue && this.modelValue[o] && Array.isArray(this.modelValue[o][this.subField]) && this.modelValue[o][this.subField].length > 0))
            return;
          this.trs[o].children.push({
            type: "tr",
            native: !0,
            display: !0,
            children: [{
              type: "td",
              native: !0,
              props: {
                colspan: this.rule[0].children[0].children[0].children.length - (this.preview ? 1 : 0)
              },
              class: "_fc-itf-sub",
              children: [{
                type: "infiniteTableForm",
                field: this.subField,
                value: [...this.modelValue[o] && this.modelValue[o][this.subField] || []],
                props: {
                  disabled: this.disabled,
                  layerMax: this.layerMax === 0 ? 0 : this.layerMax > 1 ? this.layerMax - 1 : 1,
                  max: this.max || 0,
                  columns: Lt(this.columns),
                  options: Lt(this.options)
                }
              }]
            }]
          });
        }
        const n = l.self.children[0] === "-" ? "+" : "-";
        l.self.children = [n], this.trs[o].children[1].display = n === "-";
      }, i.children[1].props.innerText = o + 1, i.children[i.children.length - 1].children[0].props.onClick = () => {
        this.delRaw(o);
      };
    },
    loadRule() {
      const e = [{
        type: "th",
        native: !0,
        class: "_fc-itf-sub-idx"
      }, {
        type: "th",
        native: !0,
        class: "_fc-itf-head-idx",
        props: {
          innerText: "#"
        }
      }];
      let o = [{
        type: "td",
        class: "_fc-itf-idx",
        native: !0,
        children: [
          {
            type: "div",
            hidden: !1,
            children: ["+"],
            inject: !0,
            props: {}
          }
        ]
      }, {
        type: "td",
        class: "_fc-itf-idx",
        native: !0,
        props: {
          innerText: "0"
        }
      }];
      this.columns.forEach((i) => {
        e.push({
          type: "th",
          native: !0,
          style: i.style,
          props: {
            innerText: i.label || ""
          }
        }), o.push({
          type: "td",
          native: !0,
          children: [...i.rule || []]
        });
      }), e.push({
        type: "th",
        native: !0,
        class: "_fc-itf-edit fc-clock",
        props: {
          innerText: this.t("tableOptions.handle")
        }
      }), o.push({
        type: "td",
        native: !0,
        class: "_fc-itf-btn fc-clock",
        children: [
          {
            type: "i",
            native: !0,
            class: "fc-icon icon-delete",
            props: {}
          }
        ]
      }), this.copyTrs = _n.toJson([
        {
          type: "tr",
          native: !0,
          children: o
        }
      ]), this.rule = [
        {
          type: "table",
          native: !0,
          class: "_fc-itf-table",
          props: {
            border: "1",
            cellspacing: "0",
            cellpadding: "0"
          },
          children: [
            {
              type: "thead",
              native: !0,
              children: [
                {
                  type: "tr",
                  native: !0,
                  children: e
                }
              ]
            },
            {
              type: "tbody",
              native: !0,
              children: this.trs
            }
          ]
        }
      ], this.addRaw();
    }
  },
  created() {
    this.loadRule();
  },
  mounted() {
    this.updateTable();
  }
}, xE = /* @__PURE__ */ _("i", {
  class: "fc-icon icon-add-circle",
  style: { "font-weight": "700" }
}, null, -1);
function TE(e, o, i, l, n, u) {
  const f = ie("el-button");
  return Z(), fe("div", {
    class: ot(["_fc-infinite-table-form", { "_fc-disabled": i.disabled }])
  }, [
    (Z(), we(zl(n.Form), {
      option: i.options,
      rule: n.rule,
      extendOption: !0,
      onChange: u.formChange,
      disabled: i.disabled,
      api: n.fapi,
      "onUpdate:api": o[0] || (o[0] = (p) => n.fapi = p),
      onEmitEvent: e.$emit
    }, null, 40, ["option", "rule", "onChange", "disabled", "api", "onEmitEvent"])),
    !i.max || i.max > this.trs.length ? (Z(), we(f, {
      key: 0,
      link: "",
      type: "primary",
      class: "fc-clock",
      onClick: o[1] || (o[1] = (p) => u.addRaw(!0))
    }, {
      default: Y(() => [
        xE,
        xe(" " + ve(u.t("tableOptions.add")), 1)
      ]),
      _: 1
    })) : Se("", !0)
  ], 2);
}
const DE = /* @__PURE__ */ qe(wE, [["render", TE]]);
const IE = {
  name: "TableForm",
  inject: ["designer"],
  emits: ["change", "add", "delete", "update:modelValue"],
  props: {
    formCreateInject: Object,
    modelValue: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      required: !0,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ni({
        submitBtn: !1,
        resetBtn: !1
      })
    },
    max: Number,
    disabled: Boolean
  },
  computed: {
    t() {
      return this.designer.setupState.t;
    }
  },
  watch: {
    modelValue() {
      this.updateTable();
    }
  },
  data() {
    return {
      rule: [],
      trs: [],
      fapi: {},
      Form: On(this.formCreateInject.form.$form()),
      copyTrs: "",
      oldValue: ""
    };
  },
  methods: {
    formChange(e, o, i, l, n) {
      n === !1 && this.updateValue();
    },
    updateValue() {
      const e = this.trs.map((i) => this.fapi.getChildrenFormData(i)).filter((i) => {
        if (i == null)
          return !1;
        let l = !1;
        return Object.keys(i).forEach((n) => {
          l = l || i[n] !== void 0 && i[n] !== "" && i[n] !== null;
        }), l;
      }), o = JSON.stringify(e);
      o !== this.oldValue && (this.oldValue = o, this.$emit("update:modelValue", e), this.$emit("change", e));
    },
    setRawData(e, o) {
      const i = this.trs[e];
      this.fapi.setChildrenFormData(i, o, !0);
    },
    updateTable() {
      const e = JSON.stringify(this.modelValue);
      this.oldValue !== e && (this.oldValue = e, this.trs = this.trs.splice(0, this.modelValue.length), this.modelValue.length || this.addRaw(), this.modelValue.forEach((o, i) => {
        this.trs[i] || this.addRaw(), this.setRawData(i, o);
      }), this.rule[0].children[1].children = this.trs);
    },
    delRaw(e) {
      this.disabled || (this.trs.splice(e, 1), this.updateValue(), this.trs.length ? this.trs.forEach((o) => this.updateRaw(o)) : this.addRaw(), this.$emit("delete", e));
    },
    addRaw(e) {
      if (e && this.disabled)
        return;
      const o = _n.parseJson(this.copyTrs)[0];
      this.trs.push(o), this.updateRaw(o), e && this.$emit("add", this.trs.length);
    },
    updateRaw(e) {
      const o = this.trs.indexOf(e);
      e.children[0].props.innerText = o + 1, e.children[e.children.length - 1].children[0].props.onClick = () => {
        this.delRaw(o);
      };
    },
    loadRule() {
      const e = [{
        type: "th",
        native: !0,
        class: "_fc-tf-head-idx",
        props: {
          innerText: "#"
        }
      }];
      let o = [{
        type: "td",
        class: "_fc-tf-idx",
        native: !0,
        props: {
          innerText: "0"
        }
      }];
      this.columns.forEach((i) => {
        e.push({
          type: "th",
          native: !0,
          style: i.style,
          props: {
            innerText: i.label || ""
          }
        }), o.push({
          type: "td",
          native: !0,
          children: [...i.rule || []]
        });
      }), e.push({
        type: "th",
        native: !0,
        class: "_fc-tf-edit fc-clock",
        props: {
          innerText: this.t("tableOptions.handle")
        }
      }), o.push({
        type: "td",
        native: !0,
        class: "_fc-tf-btn fc-clock",
        children: [
          {
            type: "i",
            native: !0,
            class: "fc-icon icon-delete",
            props: {}
          }
        ]
      }), this.copyTrs = _n.toJson([
        {
          type: "tr",
          native: !0,
          subRule: !0,
          children: o
        }
      ]), this.rule = [
        {
          type: "table",
          native: !0,
          class: "_fc-tf-table",
          props: {
            border: "1",
            cellspacing: "0",
            cellpadding: "0"
          },
          children: [
            {
              type: "thead",
              native: !0,
              children: [
                {
                  type: "tr",
                  native: !0,
                  children: e
                }
              ]
            },
            {
              type: "tbody",
              native: !0,
              children: this.trs
            }
          ]
        }
      ], this.addRaw();
    }
  },
  created() {
    this.loadRule();
  },
  mounted() {
    this.updateTable();
  }
}, RE = /* @__PURE__ */ _("i", {
  class: "fc-icon icon-add-circle",
  style: { "font-weight": "700" }
}, null, -1);
function FE(e, o, i, l, n, u) {
  const f = ie("el-button");
  return Z(), fe("div", {
    class: ot(["_fc-table-form", { "_fc-disabled": i.disabled }])
  }, [
    (Z(), we(zl(n.Form), {
      option: i.options,
      rule: n.rule,
      extendOption: !0,
      disabled: i.disabled,
      onChange: u.formChange,
      api: n.fapi,
      "onUpdate:api": o[0] || (o[0] = (p) => n.fapi = p),
      onEmitEvent: e.$emit
    }, null, 40, ["option", "rule", "disabled", "onChange", "api", "onEmitEvent"])),
    !i.max || i.max > this.trs.length ? (Z(), we(f, {
      key: 0,
      link: "",
      type: "primary",
      class: "fc-clock",
      onClick: o[1] || (o[1] = (p) => u.addRaw(!0))
    }, {
      default: Y(() => [
        RE,
        xe(" " + ve(u.t("tableOptions.add")), 1)
      ]),
      _: 1
    })) : Se("", !0)
  ], 2);
}
const ME = /* @__PURE__ */ qe(IE, [["render", FE]]);
const OE = et({
  name: "TableFormColumnView",
  props: {
    label: String,
    width: [Number, String],
    color: String
  },
  computed: {
    colStyle() {
      const e = this.width, o = { width: st.Number(e) ? `${e}px` : !e || e === "auto" ? "180px" : e };
      return this.color && (o.color = this.color), o;
    }
  },
  data() {
    return {};
  }
}), NE = { class: "_fd-tf-title" }, LE = { class: "_fd-tf-con" };
function PE(e, o, i, l, n, u) {
  return Z(), fe("div", {
    class: "_fd-tf-col",
    style: ri(e.colStyle)
  }, [
    _("div", NE, ve(e.label || ""), 1),
    _("div", LE, [
      en(e.$slots, "default")
    ])
  ], 4);
}
const $E = /* @__PURE__ */ qe(OE, [["render", PE]]);
const BE = et({
  name: "StepFormItemView",
  props: {
    title: String,
    description: String,
    formCreateInject: Object
  },
  inject: ["stepForm"],
  data() {
    return {
      id: We()
    };
  },
  created() {
    const e = this.stepForm.formCreateInject.children.indexOf(this.formCreateInject.rule);
    this.stepForm.stepItemRef.splice(e, 0, this);
  },
  unmounted() {
    this.stepForm.stepItemRef.splice(this.stepForm.stepItemRef.indexOf(this), 1);
  },
  methods: {}
}), kE = { class: "_fd-step-form-item" };
function HE(e, o, i, l, n, u) {
  return Z(), fe("div", kE, [
    dr(_("div", null, [
      en(e.$slots, "default")
    ], 512), [
      [fr, e.stepForm.activeId === e.id]
    ])
  ]);
}
const VE = /* @__PURE__ */ qe(BE, [["render", HE]]);
const UE = et({
  name: "FcCell"
}), jE = {
  ref: "cell",
  class: "_fc-cell"
};
function zE(e, o, i, l, n, u) {
  return Z(), fe("div", jE, [
    en(e.$slots, "default")
  ], 512);
}
const WE = /* @__PURE__ */ qe(UE, [["render", zE]]);
const GE = et({
  name: "fcRow",
  mounted() {
  }
});
function YE(e, o, i, l, n, u) {
  const f = ie("ElCol");
  return Z(), we(f, { span: 24 }, {
    default: Y(() => [
      _("div", Vr({
        class: ["_fd-row el-row", { "_fc-child-empty": !e.$slots.default }]
      }, e.$attrs), [
        en(e.$slots, "default")
      ], 16)
    ]),
    _: 3
  });
}
const QE = /* @__PURE__ */ qe(GE, [["render", YE]]);
/*!
 * @form-create/component-wangeditor v3.1.12
 * (c) 2018-2022 xaboy
 * Github https://github.com/xaboy/form-create with wangeditor
 * Released under the MIT License.
 */
function nc(e, o) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    o && (l = l.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), i.push.apply(i, l);
  }
  return i;
}
function KE(e) {
  for (var o = 1; o < arguments.length; o++) {
    var i = arguments[o] != null ? arguments[o] : {};
    o % 2 ? nc(Object(i), !0).forEach(function (l) {
      JE(e, l, i[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : nc(Object(i)).forEach(function (l) {
      Object.defineProperty(e, l, Object.getOwnPropertyDescriptor(i, l));
    });
  }
  return e;
}
function Qt(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Qt = function (o) {
    return typeof o;
  } : Qt = function (o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Qt(e);
}
function JE(e, o, i) {
  return o in e ? Object.defineProperty(e, o, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = i, e;
}
function XE(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Gc = { exports: {} };
(function (e, o) {
  (function (l, n) {
    e.exports = n();
  })(window, function () {
    return function (i) {
      var l = {};
      function n(u) {
        if (l[u])
          return l[u].exports;
        var f = l[u] = { i: u, l: !1, exports: {} };
        return i[u].call(f.exports, f, f.exports, n), f.l = !0, f.exports;
      }
      return n.m = i, n.c = l, n.d = function (u, f, p) {
        n.o(u, f) || Object.defineProperty(u, f, { enumerable: !0, get: p });
      }, n.r = function (u) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(u, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(u, "__esModule", { value: !0 });
      }, n.t = function (u, f) {
        if (f & 1 && (u = n(u)), f & 8 || f & 4 && Qt(u) === "object" && u && u.__esModule)
          return u;
        var p = /* @__PURE__ */ Object.create(null);
        if (n.r(p), Object.defineProperty(p, "default", { enumerable: !0, value: u }), f & 2 && typeof u != "string")
          for (var c in u)
            n.d(p, c, function (v) {
              return u[v];
            }.bind(null, c));
        return p;
      }, n.n = function (u) {
        var f = u && u.__esModule ? function () {
          return u.default;
        } : function () {
          return u;
        };
        return n.d(f, "a", f), f;
      }, n.o = function (u, f) {
        return Object.prototype.hasOwnProperty.call(u, f);
      }, n.p = "", n(n.s = 141);
    }([function (i, l) {
      function n(u) {
        return u && u.__esModule ? u : { default: u };
      }
      i.exports = n;
    }, function (i, l, n) {
      i.exports = n(142);
    }, function (i, l, n) {
      n.r(l), n.d(l, "__extends", function () {
        return f;
      }), n.d(l, "__assign", function () {
        return p;
      }), n.d(l, "__rest", function () {
        return c;
      }), n.d(l, "__decorate", function () {
        return v;
      }), n.d(l, "__param", function () {
        return b;
      }), n.d(l, "__metadata", function () {
        return y;
      }), n.d(l, "__awaiter", function () {
        return E;
      }), n.d(l, "__generator", function () {
        return w;
      }), n.d(l, "__createBinding", function () {
        return h;
      }), n.d(l, "__exportStar", function () {
        return m;
      }), n.d(l, "__values", function () {
        return I;
      }), n.d(l, "__read", function () {
        return D;
      }), n.d(l, "__spread", function () {
        return g;
      }), n.d(l, "__spreadArrays", function () {
        return S;
      }), n.d(l, "__spreadArray", function () {
        return x;
      }), n.d(l, "__await", function () {
        return R;
      }), n.d(l, "__asyncGenerator", function () {
        return N;
      }), n.d(l, "__asyncDelegator", function () {
        return T;
      }), n.d(l, "__asyncValues", function () {
        return H;
      }), n.d(l, "__makeTemplateObject", function () {
        return B;
      }), n.d(l, "__importStar", function () {
        return P;
      }), n.d(l, "__importDefault", function () {
        return C;
      }), n.d(l, "__classPrivateFieldGet", function () {
        return M;
      }), n.d(l, "__classPrivateFieldSet", function () {
        return k;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation.
      
      Permission to use, copy, modify, and/or distribute this software for any
      purpose with or without fee is hereby granted.
      
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
      REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
      AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
      INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
      LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
      OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
      PERFORMANCE OF THIS SOFTWARE.
      ***************************************************************************** */
      var u = function (j, W) {
        return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (Q, ne) {
          Q.__proto__ = ne;
        } || function (Q, ne) {
          for (var te in ne)
            Object.prototype.hasOwnProperty.call(ne, te) && (Q[te] = ne[te]);
        }, u(j, W);
      };
      function f(F, j) {
        if (typeof j != "function" && j !== null)
          throw new TypeError("Class extends value " + String(j) + " is not a constructor or null");
        u(F, j);
        function W() {
          this.constructor = F;
        }
        F.prototype = j === null ? Object.create(j) : (W.prototype = j.prototype, new W());
      }
      var p = function () {
        return p = Object.assign || function (W) {
          for (var Q, ne = 1, te = arguments.length; ne < te; ne++) {
            Q = arguments[ne];
            for (var q in Q)
              Object.prototype.hasOwnProperty.call(Q, q) && (W[q] = Q[q]);
          }
          return W;
        }, p.apply(this, arguments);
      };
      function c(F, j) {
        var W = {};
        for (var Q in F)
          Object.prototype.hasOwnProperty.call(F, Q) && j.indexOf(Q) < 0 && (W[Q] = F[Q]);
        if (F != null && typeof Object.getOwnPropertySymbols == "function")
          for (var ne = 0, Q = Object.getOwnPropertySymbols(F); ne < Q.length; ne++)
            j.indexOf(Q[ne]) < 0 && Object.prototype.propertyIsEnumerable.call(F, Q[ne]) && (W[Q[ne]] = F[Q[ne]]);
        return W;
      }
      function v(F, j, W, Q) {
        var ne = arguments.length, te = ne < 3 ? j : Q === null ? Q = Object.getOwnPropertyDescriptor(j, W) : Q, q;
        if ((typeof Reflect > "u" ? "undefined" : Qt(Reflect)) === "object" && typeof Reflect.decorate == "function")
          te = Reflect.decorate(F, j, W, Q);
        else
          for (var ge = F.length - 1; ge >= 0; ge--)
            (q = F[ge]) && (te = (ne < 3 ? q(te) : ne > 3 ? q(j, W, te) : q(j, W)) || te);
        return ne > 3 && te && Object.defineProperty(j, W, te), te;
      }
      function b(F, j) {
        return function (W, Q) {
          j(W, Q, F);
        };
      }
      function y(F, j) {
        if ((typeof Reflect > "u" ? "undefined" : Qt(Reflect)) === "object" && typeof Reflect.metadata == "function")
          return Reflect.metadata(F, j);
      }
      function E(F, j, W, Q) {
        function ne(te) {
          return te instanceof W ? te : new W(function (q) {
            q(te);
          });
        }
        return new (W || (W = Promise))(function (te, q) {
          function ge(ae) {
            try {
              me(Q.next(ae));
            } catch (le) {
              q(le);
            }
          }
          function be(ae) {
            try {
              me(Q.throw(ae));
            } catch (le) {
              q(le);
            }
          }
          function me(ae) {
            ae.done ? te(ae.value) : ne(ae.value).then(ge, be);
          }
          me((Q = Q.apply(F, j || [])).next());
        });
      }
      function w(F, j) {
        var W = {
          label: 0, sent: function () {
            if (te[0] & 1)
              throw te[1];
            return te[1];
          }, trys: [], ops: []
        }, Q, ne, te, q;
        return q = { next: ge(0), throw: ge(1), return: ge(2) }, typeof Symbol == "function" && (q[Symbol.iterator] = function () {
          return this;
        }), q;
        function ge(me) {
          return function (ae) {
            return be([me, ae]);
          };
        }
        function be(me) {
          if (Q)
            throw new TypeError("Generator is already executing.");
          for (; W;)
            try {
              if (Q = 1, ne && (te = me[0] & 2 ? ne.return : me[0] ? ne.throw || ((te = ne.return) && te.call(ne), 0) : ne.next) && !(te = te.call(ne, me[1])).done)
                return te;
              switch (ne = 0, te && (me = [me[0] & 2, te.value]), me[0]) {
                case 0:
                case 1:
                  te = me;
                  break;
                case 4:
                  return W.label++, { value: me[1], done: !1 };
                case 5:
                  W.label++, ne = me[1], me = [0];
                  continue;
                case 7:
                  me = W.ops.pop(), W.trys.pop();
                  continue;
                default:
                  if (te = W.trys, !(te = te.length > 0 && te[te.length - 1]) && (me[0] === 6 || me[0] === 2)) {
                    W = 0;
                    continue;
                  }
                  if (me[0] === 3 && (!te || me[1] > te[0] && me[1] < te[3])) {
                    W.label = me[1];
                    break;
                  }
                  if (me[0] === 6 && W.label < te[1]) {
                    W.label = te[1], te = me;
                    break;
                  }
                  if (te && W.label < te[2]) {
                    W.label = te[2], W.ops.push(me);
                    break;
                  }
                  te[2] && W.ops.pop(), W.trys.pop();
                  continue;
              }
              me = j.call(F, W);
            } catch (ae) {
              me = [6, ae], ne = 0;
            } finally {
              Q = te = 0;
            }
          if (me[0] & 5)
            throw me[1];
          return { value: me[0] ? me[1] : void 0, done: !0 };
        }
      }
      var h = Object.create ? function (F, j, W, Q) {
        Q === void 0 && (Q = W), Object.defineProperty(F, Q, {
          enumerable: !0, get: function () {
            return j[W];
          }
        });
      } : function (F, j, W, Q) {
        Q === void 0 && (Q = W), F[Q] = j[W];
      };
      function m(F, j) {
        for (var W in F)
          W !== "default" && !Object.prototype.hasOwnProperty.call(j, W) && h(j, F, W);
      }
      function I(F) {
        var j = typeof Symbol == "function" && Symbol.iterator, W = j && F[j], Q = 0;
        if (W)
          return W.call(F);
        if (F && typeof F.length == "number")
          return {
            next: function () {
              return F && Q >= F.length && (F = void 0), { value: F && F[Q++], done: !F };
            }
          };
        throw new TypeError(j ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }
      function D(F, j) {
        var W = typeof Symbol == "function" && F[Symbol.iterator];
        if (!W)
          return F;
        var Q = W.call(F), ne, te = [], q;
        try {
          for (; (j === void 0 || j-- > 0) && !(ne = Q.next()).done;)
            te.push(ne.value);
        } catch (ge) {
          q = { error: ge };
        } finally {
          try {
            ne && !ne.done && (W = Q.return) && W.call(Q);
          } finally {
            if (q)
              throw q.error;
          }
        }
        return te;
      }
      function g() {
        for (var F = [], j = 0; j < arguments.length; j++)
          F = F.concat(D(arguments[j]));
        return F;
      }
      function S() {
        for (var F = 0, j = 0, W = arguments.length; j < W; j++)
          F += arguments[j].length;
        for (var Q = Array(F), ne = 0, j = 0; j < W; j++)
          for (var te = arguments[j], q = 0, ge = te.length; q < ge; q++, ne++)
            Q[ne] = te[q];
        return Q;
      }
      function x(F, j) {
        for (var W = 0, Q = j.length, ne = F.length; W < Q; W++, ne++)
          F[ne] = j[W];
        return F;
      }
      function R(F) {
        return this instanceof R ? (this.v = F, this) : new R(F);
      }
      function N(F, j, W) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var Q = W.apply(F, j || []), ne, te = [];
        return ne = {}, q("next"), q("throw"), q("return"), ne[Symbol.asyncIterator] = function () {
          return this;
        }, ne;
        function q(ue) {
          Q[ue] && (ne[ue] = function (he) {
            return new Promise(function (se, Ae) {
              te.push([ue, he, se, Ae]) > 1 || ge(ue, he);
            });
          });
        }
        function ge(ue, he) {
          try {
            be(Q[ue](he));
          } catch (se) {
            le(te[0][3], se);
          }
        }
        function be(ue) {
          ue.value instanceof R ? Promise.resolve(ue.value.v).then(me, ae) : le(te[0][2], ue);
        }
        function me(ue) {
          ge("next", ue);
        }
        function ae(ue) {
          ge("throw", ue);
        }
        function le(ue, he) {
          ue(he), te.shift(), te.length && ge(te[0][0], te[0][1]);
        }
      }
      function T(F) {
        var j, W;
        return j = {}, Q("next"), Q("throw", function (ne) {
          throw ne;
        }), Q("return"), j[Symbol.iterator] = function () {
          return this;
        }, j;
        function Q(ne, te) {
          j[ne] = F[ne] ? function (q) {
            return (W = !W) ? { value: R(F[ne](q)), done: ne === "return" } : te ? te(q) : q;
          } : te;
        }
      }
      function H(F) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var j = F[Symbol.asyncIterator], W;
        return j ? j.call(F) : (F = typeof I == "function" ? I(F) : F[Symbol.iterator](), W = {}, Q("next"), Q("throw"), Q("return"), W[Symbol.asyncIterator] = function () {
          return this;
        }, W);
        function Q(te) {
          W[te] = F[te] && function (q) {
            return new Promise(function (ge, be) {
              q = F[te](q), ne(ge, be, q.done, q.value);
            });
          };
        }
        function ne(te, q, ge, be) {
          Promise.resolve(be).then(function (me) {
            te({ value: me, done: ge });
          }, q);
        }
      }
      function B(F, j) {
        return Object.defineProperty ? Object.defineProperty(F, "raw", { value: j }) : F.raw = j, F;
      }
      var L = Object.create ? function (F, j) {
        Object.defineProperty(F, "default", { enumerable: !0, value: j });
      } : function (F, j) {
        F.default = j;
      };
      function P(F) {
        if (F && F.__esModule)
          return F;
        var j = {};
        if (F != null)
          for (var W in F)
            W !== "default" && Object.prototype.hasOwnProperty.call(F, W) && h(j, F, W);
        return L(j, F), j;
      }
      function C(F) {
        return F && F.__esModule ? F : { default: F };
      }
      function M(F, j) {
        if (!j.has(F))
          throw new TypeError("attempted to get private field on non-instance");
        return j.get(F);
      }
      function k(F, j, W) {
        if (!j.has(F))
          throw new TypeError("attempted to set private field on non-instance");
        return j.set(F, W), W;
      }
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(89)), c = u(n(4)), v = u(n(26)), b = u(n(17)), y = u(n(120)), E = u(n(27)), w = u(n(91)), h = u(n(70)), m = u(n(44)), I = u(n(57));
      (0, f.default)(l, "__esModule", { value: !0 }), l.DomElement = void 0;
      var D = n(2), g = n(6), S = [];
      function x(L) {
        var P = document.createElement("div");
        P.innerHTML = L;
        var C = P.children;
        return g.toArray(C);
      }
      function R(L) {
        return L ? L instanceof HTMLCollection || L instanceof NodeList : !1;
      }
      function N(L) {
        var P = document.querySelectorAll(L);
        return g.toArray(P);
      }
      function T(L) {
        var P = [], C = [];
        return (0, p.default)(L) ? P = L : P = L.split(";"), (0, c.default)(P).call(P, function (M) {
          var k, F = (0, v.default)(k = M.split(":")).call(k, function (j) {
            return (0, b.default)(j).call(j);
          });
          F.length === 2 && C.push(F[0] + ":" + F[1]);
        }), C;
      }
      var H = function () {
        function L(P) {
          if (this.elems = [], this.length = this.elems.length, this.dataSource = new y.default(), !!P) {
            if (P instanceof L)
              return P;
            var C = [], M = P instanceof Node ? P.nodeType : -1;
            if (this.selector = P, M === 1 || M === 9)
              C = [P];
            else if (R(P))
              C = g.toArray(P);
            else if (P instanceof Array)
              C = P;
            else if (typeof P == "string") {
              var k, F = (0, b.default)(k = P.replace(`/
/mg`, "")).call(k);
              (0, E.default)(F).call(F, "<") === 0 ? C = x(F) : C = N(F);
            }
            var j = C.length;
            if (!j)
              return this;
            for (var W = 0; W < j; W++)
              this.elems.push(C[W]);
            this.length = j;
          }
        }
        return (0, f.default)(L.prototype, "id", {
          get: function () {
            return this.elems[0].id;
          },
          enumerable: !1,
          configurable: !0
        }), L.prototype.forEach = function (P) {
          for (var C = 0; C < this.length; C++) {
            var M = this.elems[C], k = P.call(M, M, C);
            if (k === !1)
              break;
          }
          return this;
        }, L.prototype.clone = function (P) {
          var C;
          P === void 0 && (P = !1);
          var M = [];
          return (0, c.default)(C = this.elems).call(C, function (k) {
            M.push(k.cloneNode(!!P));
          }), B(M);
        }, L.prototype.get = function (P) {
          P === void 0 && (P = 0);
          var C = this.length;
          return P >= C && (P = P % C), B(this.elems[P]);
        }, L.prototype.first = function () {
          return this.get(0);
        }, L.prototype.last = function () {
          var P = this.length;
          return this.get(P - 1);
        }, L.prototype.on = function (P, C, M) {
          var k;
          return P ? (typeof C == "function" && (M = C, C = ""), (0, c.default)(k = this).call(k, function (F) {
            if (!C) {
              F.addEventListener(P, M);
              return;
            }
            var j = function (Q) {
              var ne = Q.target;
              ne.matches(C) && M.call(ne, Q);
            };
            F.addEventListener(P, j), S.push({ elem: F, selector: C, fn: M, agentFn: j });
          })) : this;
        }, L.prototype.off = function (P, C, M) {
          var k;
          return P ? (typeof C == "function" && (M = C, C = ""), (0, c.default)(k = this).call(k, function (F) {
            if (C) {
              for (var j = -1, W = 0; W < S.length; W++) {
                var Q = S[W];
                if (Q.selector === C && Q.fn === M && Q.elem === F) {
                  j = W;
                  break;
                }
              }
              if (j !== -1) {
                var ne = (0, w.default)(S).call(S, j, 1)[0].agentFn;
                F.removeEventListener(P, ne);
              }
            } else
              F.removeEventListener(P, M);
          })) : this;
        }, L.prototype.attr = function (P, C) {
          var M;
          return C == null ? this.elems[0].getAttribute(P) || "" : (0, c.default)(M = this).call(M, function (k) {
            k.setAttribute(P, C);
          });
        }, L.prototype.removeAttr = function (P) {
          var C;
          (0, c.default)(C = this).call(C, function (M) {
            M.removeAttribute(P);
          });
        }, L.prototype.addClass = function (P) {
          var C;
          return P ? (0, c.default)(C = this).call(C, function (M) {
            if (M.className) {
              var k = M.className.split(/\s/);
              k = (0, h.default)(k).call(k, function (F) {
                return !!(0, b.default)(F).call(F);
              }), (0, E.default)(k).call(k, P) < 0 && k.push(P), M.className = k.join(" ");
            } else
              M.className = P;
          }) : this;
        }, L.prototype.removeClass = function (P) {
          var C;
          return P ? (0, c.default)(C = this).call(C, function (M) {
            if (!!M.className) {
              var k = M.className.split(/\s/);
              k = (0, h.default)(k).call(k, function (F) {
                return F = (0, b.default)(F).call(F), !(!F || F === P);
              }), M.className = k.join(" ");
            }
          }) : this;
        }, L.prototype.hasClass = function (P) {
          if (!P)
            return !1;
          var C = this.elems[0];
          if (!C.className)
            return !1;
          var M = C.className.split(/\s/);
          return (0, m.default)(M).call(M, P);
        }, L.prototype.css = function (P, C) {
          var M, k;
          return C == "" ? k = "" : k = P + ":" + C + ";", (0, c.default)(M = this).call(M, function (F) {
            var j, W = (0, b.default)(j = F.getAttribute("style") || "").call(j);
            if (W) {
              var Q = T(W);
              Q = (0, v.default)(Q).call(Q, function (ne) {
                return (0, E.default)(ne).call(ne, P) === 0 ? k : ne;
              }), k != "" && (0, E.default)(Q).call(Q, k) < 0 && Q.push(k), k == "" && (Q = T(Q)), F.setAttribute("style", Q.join("; "));
            } else
              F.setAttribute("style", k);
          });
        }, L.prototype.getBoundingClientRect = function () {
          var P = this.elems[0];
          return P.getBoundingClientRect();
        }, L.prototype.show = function () {
          return this.css("display", "block");
        }, L.prototype.hide = function () {
          return this.css("display", "none");
        }, L.prototype.children = function () {
          var P = this.elems[0];
          return P ? B(P.children) : null;
        }, L.prototype.childNodes = function () {
          var P = this.elems[0];
          return P ? B(P.childNodes) : null;
        }, L.prototype.replaceChildAll = function (P) {
          for (var C = this.getNode(), M = this.elems[0]; M.hasChildNodes();)
            C.firstChild && M.removeChild(C.firstChild);
          this.append(P);
        }, L.prototype.append = function (P) {
          var C;
          return (0, c.default)(C = this).call(C, function (M) {
            (0, c.default)(P).call(P, function (k) {
              M.appendChild(k);
            });
          });
        }, L.prototype.remove = function () {
          var P;
          return (0, c.default)(P = this).call(P, function (C) {
            if (C.remove)
              C.remove();
            else {
              var M = C.parentElement;
              M && M.removeChild(C);
            }
          });
        }, L.prototype.isContain = function (P) {
          var C = this.elems[0], M = P.elems[0];
          return C.contains(M);
        }, L.prototype.getNodeName = function () {
          var P = this.elems[0];
          return P.nodeName;
        }, L.prototype.getNode = function (P) {
          P === void 0 && (P = 0);
          var C;
          return C = this.elems[P], C;
        }, L.prototype.find = function (P) {
          var C = this.elems[0];
          return B(C.querySelectorAll(P));
        }, L.prototype.text = function (P) {
          if (P) {
            var M;
            return (0, c.default)(M = this).call(M, function (k) {
              k.innerHTML = P;
            });
          } else {
            var C = this.elems[0];
            return C.innerHTML.replace(/<[^>]+>/g, function () {
              return "";
            });
          }
        }, L.prototype.html = function (P) {
          var C = this.elems[0];
          return P ? (C.innerHTML = P, this) : C.innerHTML;
        }, L.prototype.val = function () {
          var P, C = this.elems[0];
          return (0, b.default)(P = C.value).call(P);
        }, L.prototype.focus = function () {
          var P;
          return (0, c.default)(P = this).call(P, function (C) {
            C.focus();
          });
        }, L.prototype.prev = function () {
          var P = this.elems[0];
          return B(P.previousElementSibling);
        }, L.prototype.next = function () {
          var P = this.elems[0];
          return B(P.nextElementSibling);
        }, L.prototype.getNextSibling = function () {
          var P = this.elems[0];
          return B(P.nextSibling);
        }, L.prototype.parent = function () {
          var P = this.elems[0];
          return B(P.parentElement);
        }, L.prototype.parentUntil = function (P, C) {
          var M = C || this.elems[0];
          if (M.nodeName === "BODY")
            return null;
          var k = M.parentElement;
          return k === null ? null : k.matches(P) ? B(k) : this.parentUntil(P, k);
        }, L.prototype.parentUntilEditor = function (P, C, M) {
          var k = M || this.elems[0];
          if (B(k).equal(C.$textContainerElem) || B(k).equal(C.$toolbarElem))
            return null;
          var F = k.parentElement;
          return F === null ? null : F.matches(P) ? B(F) : this.parentUntilEditor(P, C, F);
        }, L.prototype.equal = function (P) {
          return P instanceof L ? this.elems[0] === P.elems[0] : P instanceof HTMLElement ? this.elems[0] === P : !1;
        }, L.prototype.insertBefore = function (P) {
          var C, M = B(P), k = M.elems[0];
          return k ? (0, c.default)(C = this).call(C, function (F) {
            var j = k.parentNode;
            j == null || j.insertBefore(F, k);
          }) : this;
        }, L.prototype.insertAfter = function (P) {
          var C, M = B(P), k = M.elems[0], F = k && k.nextSibling;
          return k ? (0, c.default)(C = this).call(C, function (j) {
            var W = k.parentNode;
            F ? W.insertBefore(j, F) : W.appendChild(j);
          }) : this;
        }, L.prototype.data = function (P, C) {
          if (C != null)
            this.dataSource.set(P, C);
          else
            return this.dataSource.get(P);
        }, L.prototype.getNodeTop = function (P) {
          if (this.length < 1)
            return this;
          var C = this.parent();
          return P.$textElem.equal(this) || P.$textElem.equal(C) ? this : (C.prior = this, C.getNodeTop(P));
        }, L.prototype.getOffsetData = function () {
          var P = this.elems[0];
          return { top: P.offsetTop, left: P.offsetLeft, width: P.offsetWidth, height: P.offsetHeight, parent: P.offsetParent };
        }, L.prototype.scrollTop = function (P) {
          var C = this.elems[0];
          C.scrollTo({ top: P });
        }, L;
      }();
      l.DomElement = H;
      function B() {
        for (var L = [], P = 0; P < arguments.length; P++)
          L[P] = arguments[P];
        return new ((0, I.default)(H).apply(H, D.__spreadArrays([void 0], L)))();
      }
      l.default = B;
    }, function (i, l, n) {
      i.exports = n(180);
    }, function (i, l, n) {
      var u = n(8), f = n(71).f, p = n(100), c = n(9), v = n(39), b = n(19), y = n(16), E = function (h) {
        var m = function (D, g, S) {
          if (this instanceof h) {
            switch (arguments.length) {
              case 0:
                return new h();
              case 1:
                return new h(D);
              case 2:
                return new h(D, g);
            }
            return new h(D, g, S);
          }
          return h.apply(this, arguments);
        };
        return m.prototype = h.prototype, m;
      };
      i.exports = function (w, h) {
        var m = w.target, I = w.global, D = w.stat, g = w.proto, S = I ? u : D ? u[m] : (u[m] || {}).prototype, x = I ? c : c[m] || (c[m] = {}), R = x.prototype, N, T, H, B, L, P, C, M, k;
        for (B in h)
          N = p(I ? B : m + (D ? "." : "#") + B, w.forced), T = !N && S && y(S, B), P = x[B], T && (w.noTargetGet ? (k = f(S, B), C = k && k.value) : C = S[B]), L = T && C ? C : h[B], !(T && Qt(P) === Qt(L)) && (w.bind && T ? M = v(L, u) : w.wrap && T ? M = E(L) : g && typeof L == "function" ? M = v(Function.call, L) : M = L, (w.sham || L && L.sham || P && P.sham) && b(M, "sham", !0), x[B] = M, g && (H = m + "Prototype", y(c, H) || b(c, H, {}), c[H][B] = L, w.real && R && !R[B] && b(R, B, L)));
      };
    }, function (i, l, n) {
      var u = n(0), f = u(n(92)), p = u(n(1)), c = u(n(256)), v = u(n(45)), b = u(n(46)), y = u(n(89)), E = u(n(26));
      (0, p.default)(l, "__esModule", { value: !0 }), l.hexToRgb = l.getRandomCode = l.toArray = l.deepClone = l.isFunction = l.debounce = l.throttle = l.arrForEach = l.forEach = l.replaceSpecialSymbol = l.replaceHtmlSymbol = l.getRandom = l.UA = void 0;
      var w = n(2), h = function () {
        function P() {
          this._ua = navigator.userAgent;
          var C = this._ua.match(/(Edge?)\/(\d+)/);
          this.isOldEdge = !!(C && C[1] == "Edge" && (0, c.default)(C[2]) < 19), this.isFirefox = !!(/Firefox\/\d+/.test(this._ua) && !/Seamonkey\/\d+/.test(this._ua));
        }
        return P.prototype.isIE = function () {
          return "ActiveXObject" in window;
        }, P.prototype.isWebkit = function () {
          return /webkit/i.test(this._ua);
        }, P;
      }();
      l.UA = new h();
      function m(P) {
        var C;
        return P === void 0 && (P = ""), P + (0, v.default)(C = Math.random().toString()).call(C, 2);
      }
      l.getRandom = m;
      function I(P) {
        return P.replace(/</gm, "&lt;").replace(/>/gm, "&gt;").replace(/"/gm, "&quot;").replace(/(\r\n|\r|\n)/g, "<br/>");
      }
      l.replaceHtmlSymbol = I;
      function D(P) {
        return P.replace(/&lt;/gm, "<").replace(/&gt;/gm, ">").replace(/&quot;/gm, '"');
      }
      l.replaceSpecialSymbol = D;
      function g(P, C) {
        for (var M in P)
          if (Object.prototype.hasOwnProperty.call(P, M)) {
            var k = C(M, P[M]);
            if (k === !1)
              break;
          }
      }
      l.forEach = g;
      function S(P, C) {
        var M, k, F, j = P.length || 0;
        for (M = 0; M < j && (k = P[M], F = C.call(P, k, M), F !== !1); M++)
          ;
      }
      l.arrForEach = S;
      function x(P, C) {
        C === void 0 && (C = 200);
        var M = !1;
        return function () {
          for (var k = this, F = [], j = 0; j < arguments.length; j++)
            F[j] = arguments[j];
          M || (M = !0, (0, b.default)(function () {
            M = !1, P.call.apply(P, w.__spreadArrays([k], F));
          }, C));
        };
      }
      l.throttle = x;
      function R(P, C) {
        C === void 0 && (C = 200);
        var M = 0;
        return function () {
          for (var k = this, F = [], j = 0; j < arguments.length; j++)
            F[j] = arguments[j];
          M && window.clearTimeout(M), M = (0, b.default)(function () {
            M = 0, P.call.apply(P, w.__spreadArrays([k], F));
          }, C);
        };
      }
      l.debounce = R;
      function N(P) {
        return typeof P == "function";
      }
      l.isFunction = N;
      function T(P) {
        if ((0, f.default)(P) !== "object" || typeof P == "function" || P === null)
          return P;
        var C;
        (0, y.default)(P) && (C = []), (0, y.default)(P) || (C = {});
        for (var M in P)
          Object.prototype.hasOwnProperty.call(P, M) && (C[M] = T(P[M]));
        return C;
      }
      l.deepClone = T;
      function H(P) {
        return (0, v.default)(Array.prototype).call(P);
      }
      l.toArray = H;
      function B() {
        var P;
        return (0, v.default)(P = Math.random().toString(36)).call(P, -5);
      }
      l.getRandomCode = B;
      function L(P) {
        var C = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(P);
        if (C == null)
          return null;
        var M = (0, E.default)(C).call(C, function (W) {
          return (0, c.default)(W, 16);
        }), k = M[1], F = M[2], j = M[3];
        return "rgb(" + k + ", " + F + ", " + j + ")";
      }
      l.hexToRgb = L;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.EMPTY_P_REGEX = l.EMPTY_P_LAST_REGEX = l.EMPTY_P = l.urlRegex = l.EMPTY_FN = void 0;
      function p() {
      }
      l.EMPTY_FN = p, l.urlRegex = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?/, l.EMPTY_P = '<p data-we-empty-p=""><br></p>', l.EMPTY_P_LAST_REGEX = /<p data-we-empty-p=""><br\/?><\/p>$/gim, l.EMPTY_P_REGEX = /<p data-we-empty-p="">/gim;
    }, function (i, l, n) {
      (function (u) {
        var f = function (c) {
          return c && c.Math == Math && c;
        };
        i.exports = f((typeof globalThis > "u" ? "undefined" : Qt(globalThis)) == "object" && globalThis) || f((typeof window > "u" ? "undefined" : Qt(window)) == "object" && window) || f((typeof self > "u" ? "undefined" : Qt(self)) == "object" && self) || f(Qt(u) == "object" && u) || Function("return this")();
      }).call(this, n(145));
    }, function (i, l) {
      i.exports = {};
    }, function (i, l, n) {
      var u = n(8), f = n(74), p = n(16), c = n(64), v = n(76), b = n(105), y = f("wks"), E = u.Symbol, w = b ? E : E && E.withoutSetter || c;
      i.exports = function (h) {
        return p(y, h) || (v && p(E, h) ? y[h] = E[h] : y[h] = w("Symbol." + h)), y[h];
      };
    }, function (i, l) {
      i.exports = function (n) {
        try {
          return !!n();
        } catch {
          return !0;
        }
      };
    }, function (i, l, n) {
      var u = n(9), f = n(16), p = n(93), c = n(18).f;
      i.exports = function (v) {
        var b = u.Symbol || (u.Symbol = {});
        f(b, v) || c(b, v, { value: p.f(v) });
      };
    }, function (i, l) {
      i.exports = function (n) {
        return Qt(n) === "object" ? n !== null : typeof n == "function";
      };
    }, function (i, l, n) {
      var u = n(11);
      i.exports = !u(function () {
        return Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          }
        })[1] != 7;
      });
    }, function (i, l, n) {
      var u = n(9);
      i.exports = function (f) {
        return u[f + "Prototype"];
      };
    }, function (i, l) {
      var n = {}.hasOwnProperty;
      i.exports = function (u, f) {
        return n.call(u, f);
      };
    }, function (i, l, n) {
      i.exports = n(192);
    }, function (i, l, n) {
      var u = n(14), f = n(99), p = n(25), c = n(60), v = Object.defineProperty;
      l.f = u ? v : function (y, E, w) {
        if (p(y), E = c(E, !0), p(w), f)
          try {
            return v(y, E, w);
          } catch {
          }
        if ("get" in w || "set" in w)
          throw TypeError("Accessors not supported");
        return "value" in w && (y[E] = w.value), y;
      };
    }, function (i, l, n) {
      var u = n(14), f = n(18), p = n(48);
      i.exports = u ? function (c, v, b) {
        return f.f(c, v, p(1, b));
      } : function (c, v, b) {
        return c[v] = b, c;
      };
    }, function (i, l, n) {
      var u = function () {
        var S;
        return function () {
          return typeof S > "u" && (S = Boolean(window && document && document.all && !window.atob)), S;
        };
      }(), f = function () {
        var S = {};
        return function (R) {
          if (typeof S[R] > "u") {
            var N = document.querySelector(R);
            if (window.HTMLIFrameElement && N instanceof window.HTMLIFrameElement)
              try {
                N = N.contentDocument.head;
              } catch {
                N = null;
              }
            S[R] = N;
          }
          return S[R];
        };
      }(), p = [];
      function c(g) {
        for (var S = -1, x = 0; x < p.length; x++)
          if (p[x].identifier === g) {
            S = x;
            break;
          }
        return S;
      }
      function v(g, S) {
        for (var x = {}, R = [], N = 0; N < g.length; N++) {
          var T = g[N], H = S.base ? T[0] + S.base : T[0], B = x[H] || 0, L = "".concat(H, " ").concat(B);
          x[H] = B + 1;
          var P = c(L), C = { css: T[1], media: T[2], sourceMap: T[3] };
          P !== -1 ? (p[P].references++, p[P].updater(C)) : p.push({ identifier: L, updater: D(C, S), references: 1 }), R.push(L);
        }
        return R;
      }
      function b(g) {
        var S = document.createElement("style"), x = g.attributes || {};
        if (typeof x.nonce > "u") {
          var R = n.nc;
          R && (x.nonce = R);
        }
        if (Object.keys(x).forEach(function (T) {
          S.setAttribute(T, x[T]);
        }), typeof g.insert == "function")
          g.insert(S);
        else {
          var N = f(g.insert || "head");
          if (!N)
            throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          N.appendChild(S);
        }
        return S;
      }
      function y(g) {
        if (g.parentNode === null)
          return !1;
        g.parentNode.removeChild(g);
      }
      var E = function () {
        var S = [];
        return function (R, N) {
          return S[R] = N, S.filter(Boolean).join(`
`);
        };
      }();
      function w(g, S, x, R) {
        var N = x ? "" : R.media ? "@media ".concat(R.media, " {").concat(R.css, "}") : R.css;
        if (g.styleSheet)
          g.styleSheet.cssText = E(S, N);
        else {
          var T = document.createTextNode(N), H = g.childNodes;
          H[S] && g.removeChild(H[S]), H.length ? g.insertBefore(T, H[S]) : g.appendChild(T);
        }
      }
      function h(g, S, x) {
        var R = x.css, N = x.media, T = x.sourceMap;
        if (N ? g.setAttribute("media", N) : g.removeAttribute("media"), T && typeof btoa < "u" && (R += `
/*# sourceMappingURL=data:application/json;base64,`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(T)))), " */")), g.styleSheet)
          g.styleSheet.cssText = R;
        else {
          for (; g.firstChild;)
            g.removeChild(g.firstChild);
          g.appendChild(document.createTextNode(R));
        }
      }
      var m = null, I = 0;
      function D(g, S) {
        var x, R, N;
        if (S.singleton) {
          var T = I++;
          x = m || (m = b(S)), R = w.bind(null, x, T, !1), N = w.bind(null, x, T, !0);
        } else
          x = b(S), R = h.bind(null, x, S), N = function () {
            y(x);
          };
        return R(g), function (B) {
          if (B) {
            if (B.css === g.css && B.media === g.media && B.sourceMap === g.sourceMap)
              return;
            R(g = B);
          } else
            N();
        };
      }
      i.exports = function (g, S) {
        S = S || {}, !S.singleton && typeof S.singleton != "boolean" && (S.singleton = u()), g = g || [];
        var x = v(g, S);
        return function (N) {
          if (N = N || [], Object.prototype.toString.call(N) === "[object Array]") {
            for (var T = 0; T < x.length; T++) {
              var H = x[T], B = c(H);
              p[B].references--;
            }
            for (var L = v(N, S), P = 0; P < x.length; P++) {
              var C = x[P], M = c(C);
              p[M].references === 0 && (p[M].updater(), p.splice(M, 1));
            }
            x = L;
          }
        };
      };
    }, function (i, l, n) {
      i.exports = function (p) {
        var c = [];
        return c.toString = function () {
          return this.map(function (b) {
            var y = u(b, p);
            return b[2] ? "@media ".concat(b[2], " {").concat(y, "}") : y;
          }).join("");
        }, c.i = function (v, b, y) {
          typeof v == "string" && (v = [[null, v, ""]]);
          var E = {};
          if (y)
            for (var w = 0; w < this.length; w++) {
              var h = this[w][0];
              h != null && (E[h] = !0);
            }
          for (var m = 0; m < v.length; m++) {
            var I = [].concat(v[m]);
            y && E[I[0]] || (b && (I[2] ? I[2] = "".concat(b, " and ").concat(I[2]) : I[2] = b), c.push(I));
          }
        }, c;
      };
      function u(p, c) {
        var v = p[1] || "", b = p[3];
        if (!b)
          return v;
        if (c && typeof btoa == "function") {
          var y = f(b), E = b.sources.map(function (w) {
            return "/*# sourceURL=".concat(b.sourceRoot || "").concat(w, " */");
          });
          return [v].concat(E).concat([y]).join(`
`);
        }
        return [v].join(`
`);
      }
      function f(p) {
        var c = btoa(unescape(encodeURIComponent(JSON.stringify(p)))), v = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(c);
        return "/*# ".concat(v, " */");
      }
    }, function (i, l, n) {
      var u = n(14), f = n(11), p = n(16), c = Object.defineProperty, v = {}, b = function (E) {
        throw E;
      };
      i.exports = function (y, E) {
        if (p(v, y))
          return v[y];
        E || (E = {});
        var w = [][y], h = p(E, "ACCESSORS") ? E.ACCESSORS : !1, m = p(E, 0) ? E[0] : b, I = p(E, 1) ? E[1] : void 0;
        return v[y] = !!w && !f(function () {
          if (h && !u)
            return !0;
          var D = { length: -1 };
          h ? c(D, 1, { enumerable: !0, get: b }) : D[1] = 1, w.call(D, m, I);
        });
      };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(95)), v = function (b) {
        p.__extends(y, b);
        function y(E, w) {
          return b.call(this, E, w) || this;
        }
        return y;
      }(c.default);
      l.default = v;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(46));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(3)), y = v.__importDefault(n(95)), E = v.__importDefault(n(133)), w = function (h) {
        v.__extends(m, h);
        function m(I, D, g) {
          var S = h.call(this, I, D) || this;
          g.title = D.i18next.t("menus.dropListMenu." + g.title);
          var x = D.config.lang === "zh-CN" ? "" : "w-e-drop-list-tl";
          if (x !== "" && g.type === "list") {
            var R;
            (0, p.default)(R = g.list).call(R, function (T) {
              var H = T.$elem, B = b.default(H.children());
              if (B.length > 0) {
                var L = B == null ? void 0 : B.getNodeName();
                L && L === "I" && H.addClass(x);
              }
            });
          }
          var N = new E.default(S, g);
          return S.dropList = N, I.on("click", function () {
            var T;
            D.selection.getRange() != null && (I.css("z-index", D.zIndex.get("menu")), (0, p.default)(T = D.txt.eventHooks.dropListMenuHoverEvents).call(T, function (H) {
              return H();
            }), N.show());
          }).on("mouseleave", function () {
            I.css("z-index", "auto"), N.hideTimeoutId = (0, c.default)(function () {
              N.hide();
            });
          }), S;
        }
        return m;
      }(y.default);
      l.default = w;
    }, function (i, l, n) {
      var u = n(13);
      i.exports = function (f) {
        if (!u(f))
          throw TypeError(String(f) + " is not an object");
        return f;
      };
    }, function (i, l, n) {
      i.exports = n(188);
    }, function (i, l, n) {
      i.exports = n(201);
    }, function (i, l, n) {
      var u = n(72), f = n(49);
      i.exports = function (p) {
        return u(f(p));
      };
    }, function (i, l, n) {
      var u = n(49);
      i.exports = function (f) {
        return Object(u(f));
      };
    }, function (i, l, n) {
      var u = n(39), f = n(72), p = n(29), c = n(34), v = n(88), b = [].push, y = function (w) {
        var h = w == 1, m = w == 2, I = w == 3, D = w == 4, g = w == 6, S = w == 5 || g;
        return function (x, R, N, T) {
          for (var H = p(x), B = f(H), L = u(R, N, 3), P = c(B.length), C = 0, M = T || v, k = h ? M(x, P) : m ? M(x, 0) : void 0, F, j; P > C; C++)
            if ((S || C in B) && (F = B[C], j = L(F, C, H), w)) {
              if (h)
                k[C] = j;
              else if (j)
                switch (w) {
                  case 3:
                    return !0;
                  case 5:
                    return F;
                  case 6:
                    return C;
                  case 2:
                    b.call(k, F);
                }
              else if (D)
                return !1;
            }
          return g ? -1 : I || D ? D : k;
        };
      };
      i.exports = {
        forEach: y(0),
        map: y(1),
        filter: y(2),
        some: y(3),
        every: y(4),
        find: y(5),
        findIndex: y(6)
      };
    }, function (i, l, n) {
      i.exports = n(283);
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(31)), v = u(n(131));
      (0, f.default)(l, "__esModule", { value: !0 });
      var b = n(2), y = b.__importDefault(n(3)), E = n(7), w = function () {
        function h(m, I) {
          this.menu = m, this.conf = I, this.$container = y.default('<div class="w-e-panel-container"></div>');
          var D = m.editor;
          D.txt.eventHooks.clickEvents.push(h.hideCurAllPanels), D.txt.eventHooks.toolbarClickEvents.push(h.hideCurAllPanels), D.txt.eventHooks.dropListMenuHoverEvents.push(h.hideCurAllPanels);
        }
        return h.prototype.create = function () {
          var m = this, I = this.menu;
          if (!h.createdMenus.has(I)) {
            var D = this.conf, g = this.$container, S = D.width || 300, x = I.editor.$toolbarElem.getBoundingClientRect(), R = I.$elem.getBoundingClientRect(), N = x.height + x.top - R.top, T = (x.width - S) / 2 + x.left - R.left, H = 300;
            Math.abs(T) > H && (R.left < document.documentElement.clientWidth / 2 ? T = -R.width / 2 : T = -S + R.width / 2), g.css("width", S + "px").css("margin-top", N + "px").css("margin-left", T + "px").css("z-index", I.editor.zIndex.get("panel"));
            var B = y.default('<i class="w-e-icon-close w-e-panel-close"></i>');
            g.append(B), B.on("click", function () {
              m.remove();
            });
            var L = y.default('<ul class="w-e-panel-tab-title"></ul>'), P = y.default('<div class="w-e-panel-tab-content"></div>');
            g.append(L).append(P);
            var C = D.height;
            C && P.css("height", C + "px").css("overflow-y", "auto");
            var M = D.tabs || [], k = [], F = [];
            (0, p.default)(M).call(M, function (W, Q) {
              if (!!W) {
                var ne = W.title || "", te = W.tpl || "", q = y.default('<li class="w-e-item">' + ne + "</li>");
                L.append(q);
                var ge = y.default(te);
                P.append(ge), k.push(q), F.push(ge), Q === 0 ? (q.data("active", !0), q.addClass("w-e-active")) : ge.hide(), q.on("click", function () {
                  q.data("active") || ((0, p.default)(k).call(k, function (be) {
                    be.data("active", !1), be.removeClass("w-e-active");
                  }), (0, p.default)(F).call(F, function (be) {
                    be.hide();
                  }), q.data("active", !0), q.addClass("w-e-active"), ge.show());
                });
              }
            }), g.on("click", function (W) {
              W.stopPropagation();
            }), I.$elem.append(g), (0, p.default)(M).call(M, function (W, Q) {
              if (!!W) {
                var ne = W.events || [];
                (0, p.default)(ne).call(ne, function (te) {
                  var q, ge = te.selector, be = te.type, me = te.fn || E.EMPTY_FN, ae = F[Q], le = (q = te.bindEnter) !== null && q !== void 0 ? q : !1, ue = function (se) {
                    return b.__awaiter(m, void 0, void 0, function () {
                      var Ae;
                      return b.__generator(this, function (Ee) {
                        switch (Ee.label) {
                          case 0:
                            return se.stopPropagation(), [
                              4,
                              me(se)
                            ];
                          case 1:
                            return Ae = Ee.sent(), Ae && this.remove(), [2];
                        }
                      });
                    });
                  };
                  (0, c.default)(ae).call(ae, ge).on(be, ue), le && be === "click" && ae.on("keyup", function (he) {
                    he.keyCode == 13 && ue(he);
                  });
                });
              }
            });
            var j = (0, c.default)(g).call(g, "input[type=text],textarea");
            j.length && j.get(0).focus(), h.hideCurAllPanels(), I.setPanel(this), h.createdMenus.add(I);
          }
        }, h.prototype.remove = function () {
          var m = this.menu, I = this.$container;
          I && I.remove(), h.createdMenus.delete(m);
        }, h.hideCurAllPanels = function () {
          var m;
          h.createdMenus.size !== 0 && (0, p.default)(m = h.createdMenus).call(m, function (I) {
            var D = I.panel;
            D && D.remove();
          });
        }, h.createdMenus = new v.default(), h;
      }();
      l.default = w;
    }, function (i, l) {
      var n = {}.toString;
      i.exports = function (u) {
        return n.call(u).slice(8, -1);
      };
    }, function (i, l, n) {
      var u = n(62), f = Math.min;
      i.exports = function (p) {
        return p > 0 ? f(u(p), 9007199254740991) : 0;
      };
    }, function (i, l, n) {
      var u = n(9), f = n(8), p = function (v) {
        return typeof v == "function" ? v : void 0;
      };
      i.exports = function (c, v) {
        return arguments.length < 2 ? p(u[c]) || p(f[c]) : u[c] && u[c][v] || f[c] && f[c][v];
      };
    }, function (i, l, n) {
      var u = n(81), f = n(18).f, p = n(19), c = n(16), v = n(170), b = n(10), y = b("toStringTag");
      i.exports = function (E, w, h, m) {
        if (E) {
          var I = h ? E : E.prototype;
          c(I, y) || f(I, y, { configurable: !0, value: w }), m && !u && p(I, "toString", v);
        }
      };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(95)), v = function (b) {
        p.__extends(y, b);
        function y(E, w) {
          return b.call(this, E, w) || this;
        }
        return y.prototype.setPanel = function (E) {
          this.panel = E;
        }, y;
      }(c.default);
      l.default = v;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(57));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(3)), y = function () {
        function E(w, h, m) {
          this.editor = w, this.$targetElem = h, this.conf = m, this._show = !1, this._isInsertTextContainer = !1;
          var I = b.default("<div></div>");
          I.addClass("w-e-tooltip"), this.$container = I;
        }
        return E.prototype.getPositionData = function () {
          var w = this.$container, h = 0, m = 0, I = 20, D = document.documentElement.scrollTop, g = this.$targetElem.getBoundingClientRect(), S = this.editor.$textElem.getBoundingClientRect(), x = this.$targetElem.getOffsetData(), R = b.default(x.parent), N = this.editor.$textElem.elems[0].scrollTop;
          if (this._isInsertTextContainer = R.equal(this.editor.$textContainerElem), this._isInsertTextContainer) {
            var T = R.getBoundingClientRect().height, H = x.top, B = x.left, L = x.height, P = H - N;
            P > I + 5 ? (h = P - I - 15, w.addClass("w-e-tooltip-up")) : P + L + I < T ? (h = P + L + 10, w.addClass("w-e-tooltip-down")) : (h = (P > 0 ? P : 0) + I + 10, w.addClass("w-e-tooltip-down")), B < 0 ? m = 0 : m = B;
          } else
            g.top < I || g.top - S.top < I ? (h = g.bottom + D + 5, w.addClass("w-e-tooltip-down")) : (h = g.top + D - I - 15, w.addClass("w-e-tooltip-up")), g.left < 0 ? m = 0 : m = g.left;
          return { top: h, left: m };
        }, E.prototype.appendMenus = function () {
          var w = this, h = this.conf, m = this.editor, I = this.$targetElem, D = this.$container;
          (0, p.default)(h).call(h, function (g, S) {
            var x = g.$elem, R = b.default("<div></div>");
            R.addClass("w-e-tooltip-item-wrapper "), R.append(x), D.append(R), x.on("click", function (N) {
              N.preventDefault();
              var T = g.onClick(m, I);
              T && w.remove();
            });
          });
        }, E.prototype.create = function () {
          var w, h, m = this.editor, I = this.$container;
          this.appendMenus();
          var D = this.getPositionData(), g = D.top, S = D.left;
          I.css("top", g + "px"), I.css("left", S + "px"), I.css("z-index", m.zIndex.get("tooltip")), this._isInsertTextContainer ? this.editor.$textContainerElem.append(I) : b.default("body").append(I), this._show = !0, m.beforeDestroy((0, c.default)(w = this.remove).call(w, this)), m.txt.eventHooks.onBlurEvents.push((0, c.default)(h = this.remove).call(h, this));
        }, E.prototype.remove = function () {
          this.$container.remove(), this._show = !1;
        }, (0, f.default)(E.prototype, "isShow", {
          get: function () {
            return this._show;
          },
          enumerable: !1,
          configurable: !0
        }), E;
      }();
      l.default = y;
    }, function (i, l, n) {
      var u = n(40);
      i.exports = function (f, p, c) {
        if (u(f), p === void 0)
          return f;
        switch (c) {
          case 0:
            return function () {
              return f.call(p);
            };
          case 1:
            return function (v) {
              return f.call(p, v);
            };
          case 2:
            return function (v, b) {
              return f.call(p, v, b);
            };
          case 3:
            return function (v, b, y) {
              return f.call(p, v, b, y);
            };
        }
        return function () {
          return f.apply(p, arguments);
        };
      };
    }, function (i, l) {
      i.exports = function (n) {
        if (typeof n != "function")
          throw TypeError(String(n) + " is not a function");
        return n;
      };
    }, function (i, l, n) {
      var u = n(165), f = n(8), p = n(13), c = n(19), v = n(16), b = n(63), y = n(51), E = f.WeakMap, w, h, m, I = function (H) {
        return m(H) ? h(H) : w(H, {});
      }, D = function (H) {
        return function (B) {
          var L;
          if (!p(B) || (L = h(B)).type !== H)
            throw TypeError("Incompatible receiver, " + H + " required");
          return L;
        };
      };
      if (u) {
        var g = new E(), S = g.get, x = g.has, R = g.set;
        w = function (H, B) {
          return R.call(g, H, B), B;
        }, h = function (H) {
          return S.call(g, H) || {};
        }, m = function (H) {
          return x.call(g, H);
        };
      } else {
        var N = b("state");
        y[N] = !0, w = function (H, B) {
          return c(H, N, B), B;
        }, h = function (H) {
          return v(H, N) ? H[N] : {};
        }, m = function (H) {
          return v(H, N);
        };
      }
      i.exports = { set: w, get: h, has: m, enforce: I, getterFor: D };
    }, function (i, l) {
      i.exports = !0;
    }, function (i, l) {
      i.exports = {};
    }, function (i, l, n) {
      i.exports = n(213);
    }, function (i, l, n) {
      i.exports = n(261);
    }, function (i, l, n) {
      i.exports = n(265);
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 }), l.createElementFragment = l.createDocumentFragment = l.createElement = l.insertBefore = l.getEndPoint = l.getStartPoint = l.updateRange = l.filterSelectionNodes = void 0;
      var c = n(2), v = n(137), b = c.__importDefault(n(3));
      function y(S) {
        var x = [];
        return (0, p.default)(S).call(S, function (R) {
          var N = R.getNodeName();
          if (N !== v.ListType.OrderedList && N !== v.ListType.UnorderedList)
            x.push(R);
          else if (R.prior)
            x.push(R.prior);
          else {
            var T = R.children();
            T == null || (0, p.default)(T).call(T, function (H) {
              x.push(b.default(H));
            });
          }
        }), x;
      }
      l.filterSelectionNodes = y;
      function E(S, x, R) {
        var N = S.selection, T = document.createRange();
        x.length > 1 ? (T.setStart(x.elems[0], 0), T.setEnd(x.elems[x.length - 1], x.elems[x.length - 1].childNodes.length)) : T.selectNodeContents(x.elems[0]), R && T.collapse(!1), N.saveRange(T), N.restoreSelection();
      }
      l.updateRange = E;
      function w(S) {
        var x;
        return S.prior ? S.prior : b.default((x = S.children()) === null || x === void 0 ? void 0 : x.elems[0]);
      }
      l.getStartPoint = w;
      function h(S) {
        var x;
        return S.prior ? S.prior : b.default((x = S.children()) === null || x === void 0 ? void 0 : x.last().elems[0]);
      }
      l.getEndPoint = h;
      function m(S, x, R) {
        R === void 0 && (R = null), S.parent().elems[0].insertBefore(x, R);
      }
      l.insertBefore = m;
      function I(S) {
        return document.createElement(S);
      }
      l.createElement = I;
      function D() {
        return document.createDocumentFragment();
      }
      l.createDocumentFragment = D;
      function g(S, x, R) {
        return R === void 0 && (R = "li"), (0, p.default)(S).call(S, function (N) {
          var T = I(R);
          T.innerHTML = N.html(), x.appendChild(T), N.remove();
        }), x;
      }
      l.createElementFragment = g;
    }, function (i, l) {
      i.exports = function (n, u) {
        return { enumerable: !(n & 1), configurable: !(n & 2), writable: !(n & 4), value: u };
      };
    }, function (i, l) {
      i.exports = function (n) {
        if (n == null)
          throw TypeError("Can't call method on " + n);
        return n;
      };
    }, function (i, l, n) {
      var u = n(164).charAt, f = n(41), p = n(75), c = "String Iterator", v = f.set, b = f.getterFor(c);
      p(String, "String", function (y) {
        v(this, { type: c, string: String(y), index: 0 });
      }, function () {
        var E = b(this), w = E.string, h = E.index, m;
        return h >= w.length ? { value: void 0, done: !0 } : (m = u(w, h), E.index += m.length, { value: m, done: !1 });
      });
    }, function (i, l) {
      i.exports = {};
    }, function (i, l, n) {
      var u = n(106), f = n(80);
      i.exports = Object.keys || function (c) {
        return u(c, f);
      };
    }, function (i, l, n) {
      var u = n(19);
      i.exports = function (f, p, c, v) {
        v && v.enumerable ? f[p] = c : u(f, p, c);
      };
    }, function (i, l, n) {
      n(173);
      var u = n(174), f = n(8), p = n(65), c = n(19), v = n(43), b = n(10), y = b("toStringTag");
      for (var E in u) {
        var w = f[E], h = w && w.prototype;
        h && p(h) !== y && c(h, y, E), v[E] = v.Array;
      }
    }, function (i, l, n) {
      var u = n(33);
      i.exports = Array.isArray || function (p) {
        return u(p) == "Array";
      };
    }, function (i, l, n) {
      var u = n(11), f = n(10), p = n(86), c = f("species");
      i.exports = function (v) {
        return p >= 51 || !u(function () {
          var b = [], y = b.constructor = {};
          return y[c] = function () {
            return { foo: 1 };
          }, b[v](Boolean).foo !== 1;
        });
      };
    }, function (i, l, n) {
      i.exports = n(222);
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.ListHandle = void 0;
      var p = n(2), c = p.__importDefault(n(373)), v = function () {
        function b(y) {
          this.options = y, this.selectionRangeElem = new c.default();
        }
        return b;
      }();
      l.ListHandle = v;
    }, function (i, l, n) {
      var u = {}.propertyIsEnumerable, f = Object.getOwnPropertyDescriptor, p = f && !u.call({ 1: 2 }, 1);
      l.f = p ? function (v) {
        var b = f(this, v);
        return !!b && b.enumerable;
      } : u;
    }, function (i, l, n) {
      var u = n(13);
      i.exports = function (f, p) {
        if (!u(f))
          return f;
        var c, v;
        if (p && typeof (c = f.toString) == "function" && !u(v = c.call(f)) || typeof (c = f.valueOf) == "function" && !u(v = c.call(f)) || !p && typeof (c = f.toString) == "function" && !u(v = c.call(f)))
          return v;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (i, l) {
    }, function (i, l) {
      var n = Math.ceil, u = Math.floor;
      i.exports = function (f) {
        return isNaN(f = +f) ? 0 : (f > 0 ? u : n)(f);
      };
    }, function (i, l, n) {
      var u = n(74), f = n(64), p = u("keys");
      i.exports = function (c) {
        return p[c] || (p[c] = f(c));
      };
    }, function (i, l) {
      var n = 0, u = Math.random();
      i.exports = function (f) {
        return "Symbol(" + String(f === void 0 ? "" : f) + ")_" + (++n + u).toString(36);
      };
    }, function (i, l, n) {
      var u = n(81), f = n(33), p = n(10), c = p("toStringTag"), v = f(function () {
        return arguments;
      }()) == "Arguments", b = function (E, w) {
        try {
          return E[w];
        } catch {
        }
      };
      i.exports = u ? f : function (y) {
        var E, w, h;
        return y === void 0 ? "Undefined" : y === null ? "Null" : typeof (w = b(E = Object(y), c)) == "string" ? w : v ? f(E) : (h = f(E)) == "Object" && typeof E.callee == "function" ? "Arguments" : h;
      };
    }, function (i, l, n) {
      var u = n(25), f = n(111), p = n(34), c = n(39), v = n(112), b = n(113), y = function (h, m) {
        this.stopped = h, this.result = m;
      }, E = i.exports = function (w, h, m, I, D) {
        var g = c(h, m, I ? 2 : 1), S, x, R, N, T, H, B;
        if (D)
          S = w;
        else {
          if (x = v(w), typeof x != "function")
            throw TypeError("Target is not iterable");
          if (f(x)) {
            for (R = 0, N = p(w.length); N > R; R++)
              if (T = I ? g(u(B = w[R])[0], B[1]) : g(w[R]), T && T instanceof y)
                return T;
            return new y(!1);
          }
          S = x.call(w);
        }
        for (H = S.next; !(B = H.call(S)).done;)
          if (T = b(S, g, B.value, I), Qt(T) == "object" && T && T instanceof y)
            return T;
        return new y(!1);
      };
      E.stop = function (w) {
        return new y(!0, w);
      };
    }, function (i, l, n) {
      var u = n(11);
      i.exports = function (f, p) {
        var c = [][f];
        return !!c && u(function () {
          c.call(null, p || function () {
            throw 1;
          }, 1);
        });
      };
    }, function (i, l) {
      i.exports = `	
\v\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF`;
    }, function (i, l, n) {
      var u = n(60), f = n(18), p = n(48);
      i.exports = function (c, v, b) {
        var y = u(v);
        y in c ? f.f(c, y, p(0, b)) : c[y] = b;
      };
    }, function (i, l, n) {
      i.exports = n(209);
    }, function (i, l, n) {
      var u = n(14), f = n(59), p = n(48), c = n(28), v = n(60), b = n(16), y = n(99), E = Object.getOwnPropertyDescriptor;
      l.f = u ? E : function (h, m) {
        if (h = c(h), m = v(m, !0), y)
          try {
            return E(h, m);
          } catch {
          }
        if (b(h, m))
          return p(!f.f.call(h, m), h[m]);
      };
    }, function (i, l, n) {
      var u = n(11), f = n(33), p = "".split;
      i.exports = u(function () {
        return !Object("z").propertyIsEnumerable(0);
      }) ? function (c) {
        return f(c) == "String" ? p.call(c, "") : Object(c);
      } : Object;
    }, function (i, l, n) {
      var u = n(8), f = n(13), p = u.document, c = f(p) && f(p.createElement);
      i.exports = function (v) {
        return c ? p.createElement(v) : {};
      };
    }, function (i, l, n) {
      var u = n(42), f = n(102);
      (i.exports = function (p, c) {
        return f[p] || (f[p] = c !== void 0 ? c : {});
      })("versions", []).push({ version: "3.6.4", mode: u ? "pure" : "global", copyright: "\xA9 2020 Denis Pushkarev (zloirock.ru)" });
    }, function (i, l, n) {
      var u = n(5), f = n(167), p = n(104), c = n(171), v = n(36), b = n(19), y = n(53), E = n(10), w = n(42), h = n(43), m = n(103), I = m.IteratorPrototype, D = m.BUGGY_SAFARI_ITERATORS, g = E("iterator"), S = "keys", x = "values", R = "entries", N = function () {
        return this;
      };
      i.exports = function (T, H, B, L, P, C, M) {
        f(B, H, L);
        var k = function (ae) {
          if (ae === P && ne)
            return ne;
          if (!D && ae in W)
            return W[ae];
          switch (ae) {
            case S:
              return function () {
                return new B(this, ae);
              };
            case x:
              return function () {
                return new B(this, ae);
              };
            case R:
              return function () {
                return new B(this, ae);
              };
          }
          return function () {
            return new B(this);
          };
        }, F = H + " Iterator", j = !1, W = T.prototype, Q = W[g] || W["@@iterator"] || P && W[P], ne = !D && Q || k(P), te = H == "Array" && W.entries || Q, q, ge, be;
        if (te && (q = p(te.call(new T())), I !== Object.prototype && q.next && (!w && p(q) !== I && (c ? c(q, I) : typeof q[g] != "function" && b(q, g, N)), v(q, F, !0, !0), w && (h[F] = N))), P == x && Q && Q.name !== x && (j = !0, ne = function () {
          return Q.call(this);
        }), (!w || M) && W[g] !== ne && b(W, g, ne), h[H] = ne, P)
          if (ge = { values: k(x), keys: C ? ne : k(S), entries: k(R) }, M)
            for (be in ge)
              (D || j || !(be in W)) && y(W, be, ge[be]);
          else
            u({ target: H, proto: !0, forced: D || j }, ge);
        return ge;
      };
    }, function (i, l, n) {
      var u = n(11);
      i.exports = !!Object.getOwnPropertySymbols && !u(function () {
        return !String(Symbol());
      });
    }, function (i, l, n) {
      var u = n(25), f = n(169), p = n(80), c = n(51), v = n(107), b = n(73), y = n(63), E = ">", w = "<", h = "prototype", m = "script", I = y("IE_PROTO"), D = function () {
      }, g = function (H) {
        return w + m + E + H + w + "/" + m + E;
      }, S = function (H) {
        H.write(g("")), H.close();
        var B = H.parentWindow.Object;
        return H = null, B;
      }, x = function () {
        var H = b("iframe"), B = "java" + m + ":", L;
        return H.style.display = "none", v.appendChild(H), H.src = String(B), L = H.contentWindow.document, L.open(), L.write(g("document.F=Object")), L.close(), L.F;
      }, R, N = function () {
        try {
          R = document.domain && new ActiveXObject("htmlfile");
        } catch {
        }
        N = R ? S(R) : x();
        for (var H = p.length; H--;)
          delete N[h][p[H]];
        return N();
      };
      c[I] = !0, i.exports = Object.create || function (H, B) {
        var L;
        return H !== null ? (D[h] = u(H), L = new D(), D[h] = null, L[I] = H) : L = N(), B === void 0 ? L : f(L, B);
      };
    }, function (i, l, n) {
      var u = n(28), f = n(34), p = n(79), c = function (b) {
        return function (y, E, w) {
          var h = u(y), m = f(h.length), I = p(w, m), D;
          if (b && E != E) {
            for (; m > I;)
              if (D = h[I++], D != D)
                return !0;
          } else
            for (; m > I; I++)
              if ((b || I in h) && h[I] === E)
                return b || I || 0;
          return !b && -1;
        };
      };
      i.exports = {
        includes: c(!0),
        indexOf: c(!1)
      };
    }, function (i, l, n) {
      var u = n(62), f = Math.max, p = Math.min;
      i.exports = function (c, v) {
        var b = u(c);
        return b < 0 ? f(b + v, 0) : p(b, v);
      };
    }, function (i, l) {
      i.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }, function (i, l, n) {
      var u = n(10), f = u("toStringTag"), p = {};
      p[f] = "z", i.exports = String(p) === "[object z]";
    }, function (i, l) {
      i.exports = function () {
      };
    }, function (i, l) {
      i.exports = function (n, u, f) {
        if (!(n instanceof u))
          throw TypeError("Incorrect " + (f ? f + " " : "") + "invocation");
        return n;
      };
    }, function (i, l, n) {
      var u = n(35);
      i.exports = u("navigator", "userAgent") || "";
    }, function (i, l, n) {
      var u = n(40), f = function (c) {
        var v, b;
        this.promise = new c(function (y, E) {
          if (v !== void 0 || b !== void 0)
            throw TypeError("Bad Promise constructor");
          v = y, b = E;
        }), this.resolve = u(v), this.reject = u(b);
      };
      i.exports.f = function (p) {
        return new f(p);
      };
    }, function (i, l, n) {
      var u = n(8), f = n(84), p = u.process, c = p && p.versions, v = c && c.v8, b, y;
      v ? (b = v.split("."), y = b[0] + b[1]) : f && (b = f.match(/Edge\/(\d+)/), (!b || b[1] >= 74) && (b = f.match(/Chrome\/(\d+)/), b && (y = b[1]))), i.exports = y && +y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = n(6), y = c.__importDefault(n(267)), E = c.__importDefault(n(280)), w = c.__importDefault(n(281)), h = c.__importDefault(n(282)), m = c.__importDefault(n(301)), I = c.__importStar(n(416)), D = c.__importDefault(n(417)), g = c.__importDefault(n(418)), S = c.__importDefault(n(419)), x = c.__importStar(n(420)), R = c.__importDefault(n(423)), N = c.__importDefault(n(424)), T = c.__importDefault(n(425)), H = c.__importDefault(n(427)), B = c.__importDefault(n(437)), L = c.__importDefault(n(440)), P = c.__importStar(n(441)), C = c.__importDefault(n(23)), M = c.__importDefault(n(133)), k = c.__importDefault(n(24)), F = c.__importDefault(n(32)), j = c.__importDefault(n(37)), W = c.__importDefault(n(38)), Q = 1, ne = function () {
        function te(q, ge) {
          this.pluginsFunctionList = {}, this.beforeDestroyHooks = [], this.id = "wangEditor-" + Q++, this.toolbarSelector = q, this.textSelector = ge, I.selectorValidator(this), this.config = b.deepClone(y.default), this.$toolbarElem = v.default("<div></div>"), this.$textContainerElem = v.default("<div></div>"), this.$textElem = v.default("<div></div>"), this.toolbarElemId = "", this.textElemId = "", this.isFocus = !1, this.isComposing = !1, this.isCompatibleMode = !1, this.selection = new E.default(this), this.cmd = new w.default(this), this.txt = new h.default(this), this.menus = new m.default(this), this.zIndex = new N.default(), this.change = new T.default(this), this.history = new H.default(this), this.onSelectionChange = new L.default(this);
          var be = B.default(this), me = be.disable, ae = be.enable;
          this.disable = me, this.enable = ae, this.isEnable = !0;
        }
        return te.prototype.initSelection = function (q) {
          D.default(this, q);
        }, te.prototype.create = function () {
          this.zIndex.init(this), this.isCompatibleMode = this.config.compatibleMode(), this.isCompatibleMode || (this.config.onchangeTimeout = 30), S.default(this), I.default(this), this.txt.init(), this.menus.init(), x.default(this), this.initSelection(!0), g.default(this), this.change.observe(), this.history.observe(), P.default(this);
        }, te.prototype.beforeDestroy = function (q) {
          return this.beforeDestroyHooks.push(q), this;
        }, te.prototype.destroy = function () {
          var q, ge = this;
          (0, p.default)(q = this.beforeDestroyHooks).call(q, function (be) {
            return be.call(ge);
          }), this.$toolbarElem.remove(), this.$textContainerElem.remove();
        }, te.prototype.fullScreen = function () {
          x.setFullScreen(this);
        }, te.prototype.unFullScreen = function () {
          x.setUnFullScreen(this);
        }, te.prototype.scrollToHead = function (q) {
          R.default(this, q);
        }, te.registerMenu = function (q, ge) {
          !ge || typeof ge != "function" || (te.globalCustomMenuConstructorList[q] = ge);
        }, te.prototype.registerPlugin = function (q, ge) {
          P.registerPlugin(q, ge, this.pluginsFunctionList);
        }, te.registerPlugin = function (q, ge) {
          P.registerPlugin(q, ge, te.globalPluginsFunctionList);
        }, te.$ = v.default, te.BtnMenu = C.default, te.DropList = M.default, te.DropListMenu = k.default, te.Panel = F.default, te.PanelMenu = j.default, te.Tooltip = W.default, te.globalCustomMenuConstructorList = {}, te.globalPluginsFunctionList = {}, te;
      }();
      l.default = ne;
    }, function (i, l, n) {
      var u = n(13), f = n(55), p = n(10), c = p("species");
      i.exports = function (v, b) {
        var y;
        return f(v) && (y = v.constructor, typeof y == "function" && (y === Array || f(y.prototype)) ? y = void 0 : u(y) && (y = y[c], y === null && (y = void 0))), new (y === void 0 ? Array : y)(b === 0 ? 0 : b);
      };
    }, function (i, l, n) {
      i.exports = n(185);
    }, function (i, l, n) {
      var u = n(49), f = n(68), p = "[" + f + "]", c = RegExp("^" + p + p + "*"), v = RegExp(p + p + "*$"), b = function (E) {
        return function (w) {
          var h = String(u(w));
          return E & 1 && (h = h.replace(c, "")), E & 2 && (h = h.replace(v, "")), h;
        };
      };
      i.exports = {
        start: b(1),
        end: b(2),
        trim: b(3)
      };
    }, function (i, l, n) {
      i.exports = n(205);
    }, function (i, l, n) {
      var u = n(227), f = n(230);
      function p(c) {
        return typeof f == "function" && typeof u == "symbol" ? i.exports = p = function (b) {
          return typeof b;
        } : i.exports = p = function (b) {
          return b && typeof f == "function" && b.constructor === f && b !== f.prototype ? "symbol" : typeof b;
        }, p(c);
      }
      i.exports = p;
    }, function (i, l, n) {
      var u = n(10);
      l.f = u;
    }, function (i, l, n) {
      i.exports = n(306);
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(32)), b = function () {
        function y(E, w) {
          var h = this;
          this.$elem = E, this.editor = w, this._active = !1, E.on("click", function (m) {
            var I;
            v.default.hideCurAllPanels(), (0, p.default)(I = w.txt.eventHooks.menuClickEvents).call(I, function (D) {
              return D();
            }), m.stopPropagation(), w.selection.getRange() != null && h.clickHandler(m);
          });
        }
        return y.prototype.clickHandler = function (E) {
        }, y.prototype.active = function () {
          this._active = !0, this.$elem.addClass("w-e-active");
        }, y.prototype.unActive = function () {
          this._active = !1, this.$elem.removeClass("w-e-active");
        }, (0, f.default)(y.prototype, "isActive", {
          get: function () {
            return this._active;
          },
          enumerable: !1,
          configurable: !0
        }), y;
      }();
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(57)), c = u(n(4)), v = u(n(27));
      (0, f.default)(l, "__esModule", { value: !0 });
      var b = n(2), y = n(6), E = b.__importDefault(n(135)), w = b.__importDefault(n(136)), h = function () {
        function m(I) {
          this.editor = I;
        }
        return m.prototype.insertImg = function (I, D, g) {
          var S = this.editor, x = S.config, R = "validate.", N = function (P, C) {
            return C === void 0 && (C = R), S.i18next.t(C + P);
          }, T = D ? 'alt="' + D + '" ' : "", H = g ? 'data-href="' + encodeURIComponent(g) + '" ' : "";
          S.cmd.do("insertHTML", '<img src="' + I + '" ' + T + H + 'style="max-width:100%;" contenteditable="false"/>'), x.linkImgCallback(I, D, g);
          var B = document.createElement("img");
          B.onload = function () {
            B = null;
          }, B.onerror = function () {
            x.customAlert(N("\u63D2\u5165\u56FE\u7247\u9519\u8BEF"), "error", "wangEditor: " + N("\u63D2\u5165\u56FE\u7247\u9519\u8BEF") + "\uFF0C" + N("\u56FE\u7247\u94FE\u63A5") + ' "' + I + '"\uFF0C' + N("\u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25")), B = null;
          }, B.onabort = function () {
            return B = null;
          }, B.src = I;
        }, m.prototype.uploadImg = function (I) {
          var D = this;
          if (!!I.length) {
            var g = this.editor, S = g.config, x = "validate.", R = function (ue) {
              return g.i18next.t(x + ue);
            }, N = S.uploadImgServer, T = S.uploadImgShowBase64, H = S.uploadImgMaxSize, B = H / 1024 / 1024, L = S.uploadImgMaxLength, P = S.uploadFileName, C = S.uploadImgParams, M = S.uploadImgParamsWithUrl, k = S.uploadImgHeaders, F = S.uploadImgHooks, j = S.uploadImgTimeout, W = S.withCredentials, Q = S.customUploadImg;
            if (!(!Q && !N && !T)) {
              var ne = [], te = [];
              if (y.arrForEach(I, function (le) {
                if (!!le) {
                  var ue = le.name || le.type.replace("/", "."), he = le.size;
                  if (!(!ue || !he)) {
                    var se = g.config.uploadImgAccept.join("|"), Ae = ".(" + se + ")$", Ee = new RegExp(Ae, "i");
                    if (Ee.test(ue) === !1) {
                      te.push("\u3010" + ue + "\u3011" + R("\u4E0D\u662F\u56FE\u7247"));
                      return;
                    }
                    if (H < he) {
                      te.push("\u3010" + ue + "\u3011" + R("\u5927\u4E8E") + " " + B + "M");
                      return;
                    }
                    ne.push(le);
                  }
                }
              }), te.length) {
                S.customAlert(R("\u56FE\u7247\u9A8C\u8BC1\u672A\u901A\u8FC7") + `: 
` + te.join(`
`), "warning");
                return;
              }
              if (ne.length === 0) {
                S.customAlert(R("\u4F20\u5165\u7684\u6587\u4EF6\u4E0D\u5408\u6CD5"), "warning");
                return;
              }
              if (ne.length > L) {
                S.customAlert(R("\u4E00\u6B21\u6700\u591A\u4E0A\u4F20") + L + R("\u5F20\u56FE\u7247"), "warning");
                return;
              }
              if (Q && typeof Q == "function") {
                var q;
                Q(ne, (0, p.default)(q = this.insertImg).call(q, this));
                return;
              }
              var ge = new FormData();
              if ((0, c.default)(ne).call(ne, function (le, ue) {
                var he = P || le.name;
                ne.length > 1 && (he = he + (ue + 1)), ge.append(he, le);
              }), N) {
                var be = N.split("#");
                N = be[0];
                var me = be[1] || "";
                (0, c.default)(y).call(y, C, function (le, ue) {
                  M && ((0, v.default)(N).call(N, "?") > 0 ? N += "&" : N += "?", N = N + le + "=" + ue), ge.append(le, ue);
                }), me && (N += "#" + me);
                var ae = E.default(N, {
                  timeout: j, formData: ge, headers: k, withCredentials: !!W, beforeSend: function (ue) {
                    if (F.before)
                      return F.before(ue, g, ne);
                  }, onTimeout: function (ue) {
                    S.customAlert(R("\u4E0A\u4F20\u56FE\u7247\u8D85\u65F6"), "error"), F.timeout && F.timeout(ue, g);
                  }, onProgress: function (ue, he) {
                    var se = new w.default(g);
                    he.lengthComputable && (ue = he.loaded / he.total, se.show(ue));
                  }, onError: function (ue) {
                    S.customAlert(R("\u4E0A\u4F20\u56FE\u7247\u9519\u8BEF"), "error", R("\u4E0A\u4F20\u56FE\u7247\u9519\u8BEF") + "\uFF0C" + R("\u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001") + ": " + ue.status), F.error && F.error(ue, g);
                  }, onFail: function (ue, he) {
                    S.customAlert(R("\u4E0A\u4F20\u56FE\u7247\u5931\u8D25"), "error", R("\u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF") + ("\uFF0C" + R("\u8FD4\u56DE\u7ED3\u679C") + ": ") + he), F.fail && F.fail(ue, g, he);
                  }, onSuccess: function (ue, he) {
                    if (F.customInsert) {
                      var se;
                      F.customInsert((0, p.default)(se = D.insertImg).call(se, D), he, g);
                      return;
                    }
                    if (he.errno != "0") {
                      S.customAlert(R("\u4E0A\u4F20\u56FE\u7247\u5931\u8D25"), "error", R("\u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF") + "\uFF0C" + R("\u8FD4\u56DE\u7ED3\u679C") + " errno=" + he.errno), F.fail && F.fail(ue, g, he);
                      return;
                    }
                    var Ae = he.data;
                    (0, c.default)(Ae).call(Ae, function (Ee) {
                      typeof Ee == "string" ? D.insertImg(Ee) : D.insertImg(Ee.url, Ee.alt, Ee.href);
                    }), F.success && F.success(ue, g, he);
                  }
                });
                typeof ae == "string" && S.customAlert(ae, "error");
                return;
              }
              T && y.arrForEach(I, function (le) {
                var ue = D, he = new FileReader();
                he.readAsDataURL(le), he.onload = function () {
                  if (!!this.result) {
                    var se = this.result.toString();
                    ue.insertImg(se, se);
                  }
                };
              });
            }
          }
        }, m;
      }();
      l.default = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(410)), c = u(n(4)), v = u(n(45));
      (0, f.default)(l, "__esModule", { value: !0 }), l.dealTextNode = l.isAllTodo = l.isTodo = l.getCursorNextNode = void 0;
      function b(m) {
        return m.length ? m.attr("class") === "w-e-todo" : !1;
      }
      l.isTodo = b;
      function y(m) {
        var I = m.selection.getSelectionRangeTopNodes();
        if (I.length !== 0)
          return (0, p.default)(I).call(I, function (D) {
            return b(D);
          });
      }
      l.isAllTodo = y;
      function E(m, I, D) {
        var g;
        if (!!m.hasChildNodes()) {
          var S = m.cloneNode(), x = !1;
          I.nodeValue === "" && (x = !0);
          var R = [];
          return (0, c.default)(g = m.childNodes).call(g, function (N) {
            if (!w(N, I) && x && (S.appendChild(N.cloneNode(!0)), N.nodeName !== "BR" && R.push(N)), w(N, I)) {
              if (N.nodeType === 1) {
                var T = E(N, I, D);
                T && T.textContent !== "" && (S == null || S.appendChild(T));
              }
              if (N.nodeType === 3 && I.isEqualNode(N)) {
                var H = h(N, D);
                S.textContent = H;
              }
              x = !0;
            }
          }), (0, c.default)(R).call(R, function (N) {
            var T = N;
            T.remove();
          }), S;
        }
      }
      l.getCursorNextNode = E;
      function w(m, I) {
        return m.nodeType === 3 ? m.nodeValue === I.nodeValue : m.contains(I);
      }
      function h(m, I, D) {
        D === void 0 && (D = !0);
        var g = m.nodeValue, S = g == null ? void 0 : (0, v.default)(g).call(g, 0, I);
        if (g = g == null ? void 0 : (0, v.default)(g).call(g, I), !D) {
          var x = g;
          g = S, S = x;
        }
        return m.nodeValue = S, g;
      }
      l.dealTextNode = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(430), c = function () {
        function v(b) {
          this.maxSize = b, this.isRe = !1, this.data = new p.CeilStack(b), this.revokeData = new p.CeilStack(b);
        }
        return (0, f.default)(v.prototype, "size", {
          get: function () {
            return [this.data.size, this.revokeData.size];
          },
          enumerable: !1,
          configurable: !0
        }), v.prototype.resetMaxSize = function (b) {
          this.data.resetMax(b), this.revokeData.resetMax(b);
        }, v.prototype.save = function (b) {
          return this.isRe && (this.revokeData.clear(), this.isRe = !1), this.data.instack(b), this;
        }, v.prototype.revoke = function (b) {
          !this.isRe && (this.isRe = !0);
          var y = this.data.outstack();
          return y ? (this.revokeData.instack(y), b(y), !0) : !1;
        }, v.prototype.restore = function (b) {
          !this.isRe && (this.isRe = !0);
          var y = this.revokeData.outstack();
          return y ? (this.data.instack(y), b(y), !0) : !1;
        }, v;
      }();
      l.default = c;
    }, function (i, l, n) {
      var u = n(14), f = n(11), p = n(73);
      i.exports = !u && !f(function () {
        return Object.defineProperty(p("div"), "a", {
          get: function () {
            return 7;
          }
        }).a != 7;
      });
    }, function (i, l, n) {
      var u = n(11), f = /#|\.prototype\./, p = function (w, h) {
        var m = v[c(w)];
        return m == y ? !0 : m == b ? !1 : typeof h == "function" ? u(h) : !!h;
      }, c = p.normalize = function (E) {
        return String(E).replace(f, ".").toLowerCase();
      }, v = p.data = {}, b = p.NATIVE = "N", y = p.POLYFILL = "P";
      i.exports = p;
    }, function (i, l, n) {
      var u = n(102), f = Function.toString;
      typeof u.inspectSource != "function" && (u.inspectSource = function (p) {
        return f.call(p);
      }), i.exports = u.inspectSource;
    }, function (i, l, n) {
      var u = n(8), f = n(166), p = "__core-js_shared__", c = u[p] || f(p, {});
      i.exports = c;
    }, function (i, l, n) {
      var u = n(104), f = n(19), p = n(16), c = n(10), v = n(42), b = c("iterator"), y = !1, E = function () {
        return this;
      }, w, h, m;
      [].keys && (m = [].keys(), "next" in m ? (h = u(u(m)), h !== Object.prototype && (w = h)) : y = !0), w == null && (w = {}), !v && !p(w, b) && f(w, b, E), i.exports = { IteratorPrototype: w, BUGGY_SAFARI_ITERATORS: y };
    }, function (i, l, n) {
      var u = n(16), f = n(29), p = n(63), c = n(168), v = p("IE_PROTO"), b = Object.prototype;
      i.exports = c ? Object.getPrototypeOf : function (y) {
        return y = f(y), u(y, v) ? y[v] : typeof y.constructor == "function" && y instanceof y.constructor ? y.constructor.prototype : y instanceof Object ? b : null;
      };
    }, function (i, l, n) {
      var u = n(76);
      i.exports = u && !Symbol.sham && Qt(Symbol.iterator) == "symbol";
    }, function (i, l, n) {
      var u = n(16), f = n(28), p = n(78).indexOf, c = n(51);
      i.exports = function (v, b) {
        var y = f(v), E = 0, w = [], h;
        for (h in y)
          !u(c, h) && u(y, h) && w.push(h);
        for (; b.length > E;)
          u(y, h = b[E++]) && (~p(w, h) || w.push(h));
        return w;
      };
    }, function (i, l, n) {
      var u = n(35);
      i.exports = u("document", "documentElement");
    }, function (i, l, n) {
      var u = n(8);
      i.exports = u.Promise;
    }, function (i, l, n) {
      var u = n(53);
      i.exports = function (f, p, c) {
        for (var v in p)
          c && c.unsafe && f[v] ? f[v] = p[v] : u(f, v, p[v], c);
        return f;
      };
    }, function (i, l, n) {
      var u = n(35), f = n(18), p = n(10), c = n(14), v = p("species");
      i.exports = function (b) {
        var y = u(b), E = f.f;
        c && y && !y[v] && E(y, v, {
          configurable: !0, get: function () {
            return this;
          }
        });
      };
    }, function (i, l, n) {
      var u = n(10), f = n(43), p = u("iterator"), c = Array.prototype;
      i.exports = function (v) {
        return v !== void 0 && (f.Array === v || c[p] === v);
      };
    }, function (i, l, n) {
      var u = n(65), f = n(43), p = n(10), c = p("iterator");
      i.exports = function (v) {
        if (v != null)
          return v[c] || v["@@iterator"] || f[u(v)];
      };
    }, function (i, l, n) {
      var u = n(25);
      i.exports = function (f, p, c, v) {
        try {
          return v ? p(u(c)[0], c[1]) : p(c);
        } catch (y) {
          var b = f.return;
          throw b !== void 0 && u(b.call(f)), y;
        }
      };
    }, function (i, l, n) {
      var u = n(10), f = u("iterator"), p = !1;
      try {
        var c = 0, v = {
          next: function () {
            return { done: !!c++ };
          }, return: function () {
            p = !0;
          }
        };
        v[f] = function () {
          return this;
        }, Array.from(v, function () {
          throw 2;
        });
      } catch {
      }
      i.exports = function (b, y) {
        if (!y && !p)
          return !1;
        var E = !1;
        try {
          var w = {};
          w[f] = function () {
            return {
              next: function () {
                return { done: E = !0 };
              }
            };
          }, b(w);
        } catch {
        }
        return E;
      };
    }, function (i, l, n) {
      var u = n(25), f = n(40), p = n(10), c = p("species");
      i.exports = function (v, b) {
        var y = u(v).constructor, E;
        return y === void 0 || (E = u(y)[c]) == null ? b : f(E);
      };
    }, function (i, l, n) {
      var u = n(8), f = n(11), p = n(33), c = n(39), v = n(107), b = n(73), y = n(117), E = u.location, w = u.setImmediate, h = u.clearImmediate, m = u.process, I = u.MessageChannel, D = u.Dispatch, g = 0, S = {}, x = "onreadystatechange", R, N, T, H = function (M) {
        if (S.hasOwnProperty(M)) {
          var k = S[M];
          delete S[M], k();
        }
      }, B = function (M) {
        return function () {
          H(M);
        };
      }, L = function (M) {
        H(M.data);
      }, P = function (M) {
        u.postMessage(M + "", E.protocol + "//" + E.host);
      };
      (!w || !h) && (w = function (M) {
        for (var k = [], F = 1; arguments.length > F;)
          k.push(arguments[F++]);
        return S[++g] = function () {
          (typeof M == "function" ? M : Function(M)).apply(void 0, k);
        }, R(g), g;
      }, h = function (M) {
        delete S[M];
      }, p(m) == "process" ? R = function (M) {
        m.nextTick(B(M));
      } : D && D.now ? R = function (M) {
        D.now(B(M));
      } : I && !y ? (N = new I(), T = N.port2, N.port1.onmessage = L, R = c(T.postMessage, T, 1)) : u.addEventListener && typeof postMessage == "function" && !u.importScripts && !f(P) && E.protocol !== "file:" ? (R = P, u.addEventListener("message", L, !1)) : x in b("script") ? R = function (M) {
        v.appendChild(b("script"))[x] = function () {
          v.removeChild(this), H(M);
        };
      } : R = function (M) {
        setTimeout(B(M), 0);
      }), i.exports = { set: w, clear: h };
    }, function (i, l, n) {
      var u = n(84);
      i.exports = /(iphone|ipod|ipad).*applewebkit/i.test(u);
    }, function (i, l, n) {
      var u = n(25), f = n(13), p = n(85);
      i.exports = function (c, v) {
        if (u(c), f(v) && v.constructor === c)
          return v;
        var b = p.f(c), y = b.resolve;
        return y(v), b.promise;
      };
    }, function (i, l) {
      i.exports = function (n) {
        try {
          return { error: !1, value: n() };
        } catch (u) {
          return { error: !0, value: u };
        }
      };
    }, function (i, l, n) {
      i.exports = n(197);
    }, function (i, l, n) {
      var u = n(5), f = n(8), p = n(122), c = n(11), v = n(19), b = n(66), y = n(83), E = n(13), w = n(36), h = n(18).f, m = n(30).forEach, I = n(14), D = n(41), g = D.set, S = D.getterFor;
      i.exports = function (x, R, N) {
        var T = x.indexOf("Map") !== -1, H = x.indexOf("Weak") !== -1, B = T ? "set" : "add", L = f[x], P = L && L.prototype, C = {}, M;
        if (!I || typeof L != "function" || !(H || P.forEach && !c(function () {
          new L().entries().next();
        })))
          M = N.getConstructor(R, x, T, B), p.REQUIRED = !0;
        else {
          M = R(function (F, j) {
            g(y(F, M, x), { type: x, collection: new L() }), j != null && b(j, F[B], F, T);
          });
          var k = S(x);
          m(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function (F) {
            var j = F == "add" || F == "set";
            F in P && !(H && F == "clear") && v(M.prototype, F, function (W, Q) {
              var ne = k(this).collection;
              if (!j && H && !E(W))
                return F == "get" ? void 0 : !1;
              var te = ne[F](W === 0 ? 0 : W, Q);
              return j ? this : te;
            });
          }), H || h(M.prototype, "size", {
            configurable: !0, get: function () {
              return k(this).collection.size;
            }
          });
        }
        return w(M, x, !1, !0), C[x] = M, u({ global: !0, forced: !0 }, C), H || N.setStrong(M, x, T), M;
      };
    }, function (i, l, n) {
      var u = n(51), f = n(13), p = n(16), c = n(18).f, v = n(64), b = n(200), y = v("meta"), E = 0, w = Object.isExtensible || function () {
        return !0;
      }, h = function (x) {
        c(x, y, {
          value: {
            objectID: "O" + ++E,
            weakData: {}
          }
        });
      }, m = function (x, R) {
        if (!f(x))
          return Qt(x) == "symbol" ? x : (typeof x == "string" ? "S" : "P") + x;
        if (!p(x, y)) {
          if (!w(x))
            return "F";
          if (!R)
            return "E";
          h(x);
        }
        return x[y].objectID;
      }, I = function (x, R) {
        if (!p(x, y)) {
          if (!w(x))
            return !0;
          if (!R)
            return !1;
          h(x);
        }
        return x[y].weakData;
      }, D = function (x) {
        return b && g.REQUIRED && w(x) && !p(x, y) && h(x), x;
      }, g = i.exports = { REQUIRED: !1, fastKey: m, getWeakData: I, onFreeze: D };
      u[y] = !0;
    }, function (i, l, n) {
      var u = n(18).f, f = n(77), p = n(109), c = n(39), v = n(83), b = n(66), y = n(75), E = n(110), w = n(14), h = n(122).fastKey, m = n(41), I = m.set, D = m.getterFor;
      i.exports = {
        getConstructor: function (S, x, R, N) {
          var T = S(function (P, C) {
            v(P, T, x), I(P, { type: x, index: f(null), first: void 0, last: void 0, size: 0 }), w || (P.size = 0), C != null && b(C, P[N], P, R);
          }), H = D(x), B = function (C, M, k) {
            var F = H(C), j = L(C, M), W, Q;
            return j ? j.value = k : (F.last = j = { index: Q = h(M, !0), key: M, value: k, previous: W = F.last, next: void 0, removed: !1 }, F.first || (F.first = j), W && (W.next = j), w ? F.size++ : C.size++, Q !== "F" && (F.index[Q] = j)), C;
          }, L = function (C, M) {
            var k = H(C), F = h(M), j;
            if (F !== "F")
              return k.index[F];
            for (j = k.first; j; j = j.next)
              if (j.key == M)
                return j;
          };
          return p(T.prototype, {
            clear: function () {
              for (var C = this, M = H(C), k = M.index, F = M.first; F;)
                F.removed = !0, F.previous && (F.previous = F.previous.next = void 0), delete k[F.index], F = F.next;
              M.first = M.last = void 0, w ? M.size = 0 : C.size = 0;
            },
            delete: function (C) {
              var M = this, k = H(M), F = L(M, C);
              if (F) {
                var j = F.next, W = F.previous;
                delete k.index[F.index], F.removed = !0, W && (W.next = j), j && (j.previous = W), k.first == F && (k.first = j), k.last == F && (k.last = W), w ? k.size-- : M.size--;
              }
              return !!F;
            },
            forEach: function (C) {
              for (var M = H(this), k = c(C, arguments.length > 1 ? arguments[1] : void 0, 3), F; F = F ? F.next : M.first;)
                for (k(F.value, F.key, this); F && F.removed;)
                  F = F.previous;
            },
            has: function (C) {
              return !!L(this, C);
            }
          }), p(T.prototype, R ? {
            get: function (C) {
              var M = L(this, C);
              return M && M.value;
            },
            set: function (C, M) {
              return B(this, C === 0 ? 0 : C, M);
            }
          } : {
            add: function (C) {
              return B(this, C = C === 0 ? 0 : C, C);
            }
          }), w && u(T.prototype, "size", {
            get: function () {
              return H(this).size;
            }
          }), T;
        }, setStrong: function (S, x, R) {
          var N = x + " Iterator", T = D(x), H = D(N);
          y(S, x, function (B, L) {
            I(this, { type: N, target: B, state: T(B), kind: L, last: void 0 });
          }, function () {
            for (var B = H(this), L = B.kind, P = B.last; P && P.removed;)
              P = P.previous;
            return !B.target || !(B.last = P = P ? P.next : B.state.first) ? (B.target = void 0, { value: void 0, done: !0 }) : L == "keys" ? { value: P.key, done: !1 } : L == "values" ? { value: P.value, done: !1 } : { value: [P.key, P.value], done: !1 };
          }, R ? "entries" : "values", !R, !0), E(x);
        }
      };
    }, function (i, l, n) {
      var u = n(12);
      u("iterator");
    }, function (i, l, n) {
      var u = n(106), f = n(80), p = f.concat("length", "prototype");
      l.f = Object.getOwnPropertyNames || function (v) {
        return u(v, p);
      };
    }, function (i, l) {
      l.f = Object.getOwnPropertySymbols;
    }, function (i, l, n) {
      i.exports = n(268);
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.default = { zIndex: 1e4 };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.default = { focus: !0, height: 300, placeholder: "\u8BF7\u8F93\u5165\u6B63\u6587", zIndexFullScreen: 10002, showFullScreen: !0 };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 }), l.getPasteImgs = l.getPasteHtml = l.getPasteText = void 0;
      var c = n(2), v = n(6), b = c.__importDefault(n(292));
      function y(h) {
        var m = h.clipboardData, I = "";
        return m == null ? I = window.clipboardData && window.clipboardData.getData("text") : I = m.getData("text/plain"), v.replaceHtmlSymbol(I);
      }
      l.getPasteText = y;
      function E(h, m, I) {
        m === void 0 && (m = !0), I === void 0 && (I = !1);
        var D = h.clipboardData, g = "";
        if (D && (g = D.getData("text/html")), !g) {
          var S = y(h);
          if (!S)
            return "";
          g = "<p>" + S + "</p>";
        }
        return g = g.replace(/<(\d)/gm, function (x, R) {
          return "&lt;" + R;
        }), g = g.replace(/<(\/?meta.*?)>/gim, ""), g = b.default(g, m, I), g;
      }
      l.getPasteHtml = E;
      function w(h) {
        var m, I = [], D = y(h);
        if (D)
          return I;
        var g = (m = h.clipboardData) === null || m === void 0 ? void 0 : m.items;
        return g && (0, p.default)(v).call(v, g, function (S, x) {
          var R = x.type;
          /image/i.test(R) && I.push(x.getAsFile());
        }), I;
      }
      l.getPasteImgs = w;
    }, function (i, l, n) {
      i.exports = n(294);
    }, function (i, l, n) {
      i.exports = n(310);
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(46));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(3)), y = n(7), E = function () {
        function w(h, m) {
          var I = this;
          this.hideTimeoutId = 0, this.menu = h, this.conf = m;
          var D = b.default('<div class="w-e-droplist"></div>'), g = b.default("<p>" + m.title + "</p>");
          g.addClass("w-e-dp-title"), D.append(g);
          var S = m.list || [], x = m.type || "list", R = m.clickHandler || y.EMPTY_FN, N = b.default('<ul class="' + (x === "list" ? "w-e-list" : "w-e-block") + '"></ul>');
          (0, p.default)(S).call(S, function (T) {
            var H = T.$elem, B = T.value, L = b.default('<li class="w-e-item"></li>');
            H && (L.append(H), N.append(L), L.on("click", function (P) {
              R(B), P.stopPropagation(), I.hideTimeoutId = (0, c.default)(function () {
                I.hide();
              });
            }));
          }), D.append(N), D.on("mouseleave", function () {
            I.hideTimeoutId = (0, c.default)(function () {
              I.hide();
            });
          }), this.$container = D, this.rendered = !1, this._show = !1;
        }
        return w.prototype.show = function () {
          this.hideTimeoutId && clearTimeout(this.hideTimeoutId);
          var h = this.menu, m = h.$elem, I = this.$container;
          if (!this._show) {
            if (this.rendered)
              I.show();
            else {
              var D = m.getBoundingClientRect().height || 0, g = this.conf.width || 100;
              I.css("margin-top", D + "px").css("width", g + "px"), m.append(I), this.rendered = !0;
            }
            this._show = !0;
          }
        }, w.prototype.hide = function () {
          var h = this.$container;
          !this._show || (h.hide(), this._show = !1);
        }, (0, f.default)(w.prototype, "isShow", {
          get: function () {
            return this._show;
          }, enumerable: !1, configurable: !0
        }), w;
      }();
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      function p(c) {
        var v = c.selection.getSelectionContainerElem();
        return v != null && v.length ? v.getNodeName() === "A" : !1;
      }
      l.default = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(92)), p = u(n(1)), c = u(n(4));
      (0, p.default)(l, "__esModule", { value: !0 });
      var v = n(6);
      function b(y, E) {
        var w = new XMLHttpRequest();
        if (w.open("POST", y), w.timeout = E.timeout || 10 * 1e3, w.ontimeout = function () {
          console.error("wangEditor - \u8BF7\u6C42\u8D85\u65F6"), E.onTimeout && E.onTimeout(w);
        }, w.upload && (w.upload.onprogress = function (m) {
          var I = m.loaded / m.total;
          E.onProgress && E.onProgress(I, m);
        }), E.headers && (0, c.default)(v).call(v, E.headers, function (m, I) {
          w.setRequestHeader(m, I);
        }), w.withCredentials = !!E.withCredentials, E.beforeSend) {
          var h = E.beforeSend(w);
          if (h && (0, f.default)(h) === "object" && h.prevent)
            return h.msg;
        }
        return w.onreadystatechange = function () {
          if (w.readyState === 4) {
            var m = w.status;
            if (!(m < 200) && !(m >= 300 && m < 400)) {
              if (m >= 400) {
                console.error("wangEditor - XHR \u62A5\u9519\uFF0C\u72B6\u6001\u7801 " + m), E.onError && E.onError(w);
                return;
              }
              var I = w.responseText, D;
              if ((0, f.default)(I) !== "object")
                try {
                  D = JSON.parse(I);
                } catch {
                  console.error("wangEditor - \u8FD4\u56DE\u7ED3\u679C\u4E0D\u662F JSON \u683C\u5F0F", I), E.onFail && E.onFail(w, I);
                  return;
                }
              else
                D = I;
              E.onSuccess(w, D);
            }
          }
        }, w.send(E.formData || null), w;
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(342)), c = u(n(46));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(3)), y = function () {
        function E(w) {
          this.editor = w, this.$textContainer = w.$textContainerElem, this.$bar = b.default('<div class="w-e-progress"></div>'), this.isShow = !1, this.time = 0, this.timeoutId = 0;
        }
        return E.prototype.show = function (w) {
          var h = this;
          if (!this.isShow) {
            this.isShow = !0;
            var m = this.$bar, I = this.$textContainer;
            I.append(m), (0, p.default)() - this.time > 100 && w <= 1 && (m.css("width", w * 100 + "%"), this.time = (0, p.default)());
            var D = this.timeoutId;
            D && clearTimeout(D), this.timeoutId = (0, c.default)(function () {
              h.hide();
            }, 500);
          }
        }, E.prototype.hide = function () {
          var w = this.$bar;
          w.remove(), this.isShow = !1, this.time = 0, this.timeoutId = 0;
        }, E;
      }();
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.ListType = void 0;
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(24)), b = n(47), y = p.__importStar(n(371)), E;
      (function (h) {
        h.OrderedList = "OL", h.UnorderedList = "UL";
      })(E = l.ListType || (l.ListType = {}));
      var w = function (h) {
        p.__extends(m, h);
        function m(I) {
          var D = this, g = c.default(`<div class="w-e-menu" data-title="\u5E8F\u5217">
                <i class="w-e-icon-list2"></i>
            </div>`), S = {
              width: 130, title: "\u5E8F\u5217", type: "list", list: [{
                $elem: c.default(`
                        <p>
                            <i class="w-e-icon-list2 w-e-drop-list-item"></i>
                            ` + I.i18next.t("menus.dropListMenu.list.\u65E0\u5E8F\u5217\u8868") + `
                        <p>`), value: E.UnorderedList
              }, {
                $elem: c.default(`<p>
                            <i class="w-e-icon-list-numbered w-e-drop-list-item"></i>
                            ` + I.i18next.t("menus.dropListMenu.list.\u6709\u5E8F\u5217\u8868") + `
                        <p>`), value: E.OrderedList
              }], clickHandler: function (R) {
                D.command(R);
              }
            };
          return D = h.call(this, g, I, S) || this, D;
        }
        return m.prototype.command = function (I) {
          var D = this.editor, g = D.selection.getSelectionContainerElem();
          g !== void 0 && (this.handleSelectionRangeNodes(I), this.tryChangeActive());
        }, m.prototype.validator = function (I, D, g) {
          return !(!I.length || !D.length || g.equal(I) || g.equal(D));
        }, m.prototype.handleSelectionRangeNodes = function (I) {
          var D = this.editor, g = D.selection, S = I.toLowerCase(), x = g.getSelectionContainerElem(), R = g.getSelectionStartElem().getNodeTop(D), N = g.getSelectionEndElem().getNodeTop(D);
          if (!!this.validator(R, N, D.$textElem)) {
            var T = g.getRange(), H = T == null ? void 0 : T.collapsed;
            D.$textElem.equal(x) || (x = x.getNodeTop(D));
            var B = { editor: D, listType: I, listTarget: S, $selectionElem: x, $startElem: R, $endElem: N }, L;
            this.isOrderElem(x) ? L = y.ClassType.Wrap : this.isOrderElem(R) && this.isOrderElem(N) ? L = y.ClassType.Join : this.isOrderElem(R) ? L = y.ClassType.StartJoin : this.isOrderElem(N) ? L = y.ClassType.EndJoin : L = y.ClassType.Other;
            var P = new y.default(y.createListHandle(L, B, T));
            b.updateRange(D, P.getSelectionRangeElem(), !!H);
          }
        }, m.prototype.isOrderElem = function (I) {
          var D = I.getNodeName();
          return D === E.OrderedList || D === E.UnorderedList;
        }, m.prototype.tryChangeActive = function () {
        }, m;
      }(v.default);
      l.default = w;
    }, function (i, l, n) {
      i.exports = n(395);
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      function p(c) {
        var v = c.selection.getSelectionContainerElem();
        return v != null && v.length ? !!(v.getNodeName() == "CODE" || v.getNodeName() == "PRE" || v.parent().getNodeName() == "CODE" || v.parent().getNodeName() == "PRE" || /hljs/.test(v.parent().attr("class"))) : !1;
      }
      l.default = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(31));
      (0, f.default)(l, "__esModule", { value: !0 }), l.todo = void 0;
      var c = n(2), v = c.__importDefault(n(3)), b = function () {
        function E(w) {
          var h;
          this.template = '<ul class="w-e-todo"><li><span contenteditable="false"><input type="checkbox"></span></li></ul>', this.checked = !1, this.$todo = v.default(this.template), this.$child = (h = w == null ? void 0 : w.childNodes()) === null || h === void 0 ? void 0 : h.clone(!0);
        }
        return E.prototype.init = function () {
          var w = this.$child, h = this.getInputContainer();
          w && w.insertAfter(h);
        }, E.prototype.getInput = function () {
          var w = this.$todo, h = (0, p.default)(w).call(w, "input");
          return h;
        }, E.prototype.getInputContainer = function () {
          var w = this.getInput().parent();
          return w;
        }, E.prototype.getTodo = function () {
          return this.$todo;
        }, E;
      }();
      l.todo = b;
      function y(E) {
        var w = new b(E);
        return w.init(), w;
      }
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2);
      n(146), n(148), n(152), n(154), n(156), n(158), n(160);
      var c = p.__importDefault(n(87));
      p.__exportStar(n(442), l);
      try {
      } catch {
        throw new Error("\u8BF7\u5728\u6D4F\u89C8\u5668\u73AF\u5883\u4E0B\u8FD0\u884C");
      }
      l.default = c.default;
    }, function (i, l, n) {
      var u = n(143);
      i.exports = u;
    }, function (i, l, n) {
      n(144);
      var u = n(9), f = u.Object, p = i.exports = function (v, b, y) {
        return f.defineProperty(v, b, y);
      };
      f.defineProperty.sham && (p.sham = !0);
    }, function (i, l, n) {
      var u = n(5), f = n(14), p = n(18);
      u({ target: "Object", stat: !0, forced: !f, sham: !f }, { defineProperty: p.f });
    }, function (i, l) {
      var n;
      n = function () {
        return this;
      }();
      try {
        n = n || new Function("return this")();
      } catch {
        (typeof window > "u" ? "undefined" : Qt(window)) === "object" && (n = window);
      }
      i.exports = n;
    }, function (i, l, n) {
      var u = n(20), f = n(147);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-toolbar,
.w-e-text-container,
.w-e-menu-panel {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background-color: #fff;
  /*\u8868\u60C5\u83DC\u5355\u6837\u5F0F*/
  /*\u5206\u5272\u7EBF\u6837\u5F0F*/
}
.w-e-toolbar h1,
.w-e-text-container h1,
.w-e-menu-panel h1 {
  font-size: 32px !important;
}
.w-e-toolbar h2,
.w-e-text-container h2,
.w-e-menu-panel h2 {
  font-size: 24px !important;
}
.w-e-toolbar h3,
.w-e-text-container h3,
.w-e-menu-panel h3 {
  font-size: 18.72px !important;
}
.w-e-toolbar h4,
.w-e-text-container h4,
.w-e-menu-panel h4 {
  font-size: 16px !important;
}
.w-e-toolbar h5,
.w-e-text-container h5,
.w-e-menu-panel h5 {
  font-size: 13.28px !important;
}
.w-e-toolbar p,
.w-e-text-container p,
.w-e-menu-panel p {
  font-size: 16px !important;
}
.w-e-toolbar .eleImg,
.w-e-text-container .eleImg,
.w-e-menu-panel .eleImg {
  cursor: pointer;
  display: inline-block;
  font-size: 18px;
  padding: 0 3px;
}
.w-e-toolbar *,
.w-e-text-container *,
.w-e-menu-panel * {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.w-e-toolbar hr,
.w-e-text-container hr,
.w-e-menu-panel hr {
  cursor: pointer;
  display: block;
  height: 0px;
  border: 0;
  border-top: 3px solid #ccc;
  margin: 20px 0;
}
.w-e-clear-fix:after {
  content: "";
  display: table;
  clear: both;
}
.w-e-drop-list-item {
  position: relative;
  top: 1px;
  padding-right: 7px;
  color: #333 !important;
}
.w-e-drop-list-tl {
  padding-left: 10px;
  text-align: left;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(20), f = n(149);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21), f = n(150), p = n(151);
      l = u(!1);
      var c = f(p);
      l.push([i.i, `@font-face {
  font-family: 'w-e-icon';
  src: url(` + c + `) format('truetype');
  font-weight: normal;
  font-style: normal;
}
[class^="w-e-icon-"],
[class*=" w-e-icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'w-e-icon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.w-e-icon-close:before {
  content: "\\f00d";
}
.w-e-icon-upload2:before {
  content: "\\e9c6";
}
.w-e-icon-trash-o:before {
  content: "\\f014";
}
.w-e-icon-header:before {
  content: "\\f1dc";
}
.w-e-icon-pencil2:before {
  content: "\\e906";
}
.w-e-icon-paint-brush:before {
  content: "\\f1fc";
}
.w-e-icon-image:before {
  content: "\\e90d";
}
.w-e-icon-play:before {
  content: "\\e912";
}
.w-e-icon-location:before {
  content: "\\e947";
}
.w-e-icon-undo:before {
  content: "\\e965";
}
.w-e-icon-redo:before {
  content: "\\e966";
}
.w-e-icon-quotes-left:before {
  content: "\\e977";
}
.w-e-icon-list-numbered:before {
  content: "\\e9b9";
}
.w-e-icon-list2:before {
  content: "\\e9bb";
}
.w-e-icon-link:before {
  content: "\\e9cb";
}
.w-e-icon-happy:before {
  content: "\\e9df";
}
.w-e-icon-bold:before {
  content: "\\ea62";
}
.w-e-icon-underline:before {
  content: "\\ea63";
}
.w-e-icon-italic:before {
  content: "\\ea64";
}
.w-e-icon-strikethrough:before {
  content: "\\ea65";
}
.w-e-icon-table2:before {
  content: "\\ea71";
}
.w-e-icon-paragraph-left:before {
  content: "\\ea77";
}
.w-e-icon-paragraph-center:before {
  content: "\\ea78";
}
.w-e-icon-paragraph-right:before {
  content: "\\ea79";
}
.w-e-icon-paragraph-justify:before {
  content: "\\ea7a";
}
.w-e-icon-terminal:before {
  content: "\\f120";
}
.w-e-icon-page-break:before {
  content: "\\ea68";
}
.w-e-icon-cancel-circle:before {
  content: "\\ea0d";
}
.w-e-icon-font:before {
  content: "\\ea5c";
}
.w-e-icon-text-heigh:before {
  content: "\\ea5f";
}
.w-e-icon-paint-format:before {
  content: "\\e90c";
}
.w-e-icon-indent-increase:before {
  content: "\\ea7b";
}
.w-e-icon-indent-decrease:before {
  content: "\\ea7c";
}
.w-e-icon-row-height:before {
  content: "\\e9be";
}
.w-e-icon-fullscreen_exit:before {
  content: "\\e900";
}
.w-e-icon-fullscreen:before {
  content: "\\e901";
}
.w-e-icon-split-line:before {
  content: "\\ea0b";
}
.w-e-icon-checkbox-checked:before {
  content: "\\ea52";
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      i.exports = function (u, f) {
        return f || (f = {}), u = u && u.__esModule ? u.default : u, typeof u != "string" ? u : (/^['"].*['"]$/.test(u) && (u = u.slice(1, -1)), f.hash && (u += f.hash), /["'() \t\n]/.test(u) || f.needQuotes ? '"'.concat(u.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : u);
      };
    }, function (i, l, n) {
      n.r(l), l.default = "data:font/woff;base64,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";
    }, function (i, l, n) {
      var u = n(20), f = n(153);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-toolbar {
  display: flex;
  padding: 0 6px;
  flex-wrap: wrap;
  position: relative;
  /* \u5355\u4E2A\u83DC\u5355 */
}
.w-e-toolbar .w-e-menu {
  position: relative;
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}
.w-e-toolbar .w-e-menu i {
  color: #999;
}
.w-e-toolbar .w-e-menu:hover {
  background-color: #F6F6F6;
}
.w-e-toolbar .w-e-menu:hover i {
  color: #333;
}
.w-e-toolbar .w-e-active i {
  color: #1e88e5;
}
.w-e-toolbar .w-e-active:hover i {
  color: #1e88e5;
}
.w-e-menu-tooltip {
  position: absolute;
  display: flex;
  color: #f1f1f1;
  background-color: rgba(0, 0, 0, 0.75);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 4px 5px 6px;
  justify-content: center;
  align-items: center;
}
.w-e-menu-tooltip-up::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-top-color: rgba(0, 0, 0, 0.73);
}
.w-e-menu-tooltip-down::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-bottom-color: rgba(0, 0, 0, 0.73);
}
.w-e-menu-tooltip-item-wrapper {
  font-size: 14px;
  margin: 0 5px;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(20), f = n(155);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-text-container {
  position: relative;
  height: 100%;
}
.w-e-text-container .w-e-progress {
  position: absolute;
  background-color: #1e88e5;
  top: 0;
  left: 0;
  height: 1px;
}
.w-e-text-container .placeholder {
  color: #D4D4D4;
  position: absolute;
  font-size: 11pt;
  line-height: 22px;
  left: 10px;
  top: 10px;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  z-index: -1;
}
.w-e-text {
  padding: 0 10px;
  overflow-y: auto;
}
.w-e-text p,
.w-e-text h1,
.w-e-text h2,
.w-e-text h3,
.w-e-text h4,
.w-e-text h5,
.w-e-text table,
.w-e-text pre {
  margin: 10px 0;
  line-height: 1.5;
}
.w-e-text ul,
.w-e-text ol {
  margin: 10px 0 10px 20px;
}
.w-e-text blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}
.w-e-text code {
  display: inline-block;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}
.w-e-text pre code {
  display: block;
}
.w-e-text table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.w-e-text table td,
.w-e-text table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
  min-height: 30px;
  height: 30px;
}
.w-e-text table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
  background-color: #f1f1f1;
}
.w-e-text:focus {
  outline: none;
}
.w-e-text img {
  cursor: pointer;
}
.w-e-text img:hover {
  box-shadow: 0 0 5px #333;
}
.w-e-text .w-e-todo {
  margin: 0 0 0 20px;
}
.w-e-text .w-e-todo li {
  list-style: none;
  font-size: 1em;
}
.w-e-text .w-e-todo li span:nth-child(1) {
  position: relative;
  left: -18px;
}
.w-e-text .w-e-todo li span:nth-child(1) input {
  position: absolute;
  margin-right: 3px;
}
.w-e-text .w-e-todo li span:nth-child(1) input[type=checkbox] {
  top: 50%;
  margin-top: -6px;
}
.w-e-tooltip {
  position: absolute;
  display: flex;
  color: #f1f1f1;
  background-color: rgba(0, 0, 0, 0.75);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 4px 5px 6px;
  justify-content: center;
  align-items: center;
}
.w-e-tooltip-up::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-top-color: rgba(0, 0, 0, 0.73);
}
.w-e-tooltip-down::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-bottom-color: rgba(0, 0, 0, 0.73);
}
.w-e-tooltip-item-wrapper {
  cursor: pointer;
  font-size: 14px;
  margin: 0 5px;
}
.w-e-tooltip-item-wrapper:hover {
  color: #ccc;
  text-decoration: underline;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(20), f = n(157);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-menu .w-e-panel-container {
  position: absolute;
  top: 0;
  left: 50%;
  border: 1px solid #ccc;
  border-top: 0;
  box-shadow: 1px 1px 2px #ccc;
  color: #333;
  background-color: #fff;
  text-align: left;
  /* \u4E3A emotion panel \u5B9A\u5236\u7684\u6837\u5F0F */
  /* \u4E0A\u4F20\u56FE\u7247\u3001\u4E0A\u4F20\u89C6\u9891\u7684 panel \u5B9A\u5236\u6837\u5F0F */
}
.w-e-menu .w-e-panel-container .w-e-panel-close {
  position: absolute;
  right: 0;
  top: 0;
  padding: 5px;
  margin: 2px 5px 0 0;
  cursor: pointer;
  color: #999;
}
.w-e-menu .w-e-panel-container .w-e-panel-close:hover {
  color: #333;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-title {
  list-style: none;
  display: flex;
  font-size: 14px;
  margin: 2px 10px 0 10px;
  border-bottom: 1px solid #f1f1f1;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-title .w-e-item {
  padding: 3px 5px;
  color: #999;
  cursor: pointer;
  margin: 0 3px;
  position: relative;
  top: 1px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-title .w-e-active {
  color: #333;
  border-bottom: 1px solid #333;
  cursor: default;
  font-weight: 700;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content {
  padding: 10px 15px 10px 15px;
  font-size: 16px;
  /* \u8F93\u5165\u6846\u7684\u6837\u5F0F */
  /* \u6309\u94AE\u7684\u6837\u5F0F */
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input:focus,
.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea:focus,
.w-e-menu .w-e-panel-container .w-e-panel-tab-content button:focus {
  outline: none;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea {
  width: 100%;
  border: 1px solid #ccc;
  padding: 5px;
  margin-top: 10px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea:focus {
  border-color: #1e88e5;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text] {
  border: none;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
  height: 20px;
  color: #333;
  text-align: left;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text].small {
  width: 30px;
  text-align: center;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text].block {
  display: block;
  width: 100%;
  margin: 10px 0;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text]:focus {
  border-bottom: 2px solid #1e88e5;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button {
  font-size: 14px;
  color: #1e88e5;
  border: none;
  padding: 5px 10px;
  background-color: #fff;
  cursor: pointer;
  border-radius: 3px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.left {
  float: left;
  margin-right: 10px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.right {
  float: right;
  margin-left: 10px;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.gray {
  color: #999;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.red {
  color: #c24f4a;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button:hover {
  background-color: #f1f1f1;
}
.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container:after {
  content: "";
  display: table;
  clear: both;
}
.w-e-menu .w-e-panel-container .w-e-emoticon-container .w-e-item {
  cursor: pointer;
  font-size: 18px;
  padding: 0 3px;
  display: inline-block;
}
.w-e-menu .w-e-panel-container .w-e-up-img-container,
.w-e-menu .w-e-panel-container .w-e-up-video-container {
  text-align: center;
}
.w-e-menu .w-e-panel-container .w-e-up-img-container .w-e-up-btn,
.w-e-menu .w-e-panel-container .w-e-up-video-container .w-e-up-btn {
  display: inline-block;
  color: #999;
  cursor: pointer;
  font-size: 60px;
  line-height: 1;
}
.w-e-menu .w-e-panel-container .w-e-up-img-container .w-e-up-btn:hover,
.w-e-menu .w-e-panel-container .w-e-up-video-container .w-e-up-btn:hover {
  color: #333;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(20), f = n(159);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-toolbar .w-e-droplist {
  position: absolute;
  left: 0;
  top: 0;
  background-color: #fff;
  border: 1px solid #f1f1f1;
  border-right-color: #ccc;
  border-bottom-color: #ccc;
}
.w-e-toolbar .w-e-droplist .w-e-dp-title {
  text-align: center;
  color: #999;
  line-height: 2;
  border-bottom: 1px solid #f1f1f1;
  font-size: 13px;
}
.w-e-toolbar .w-e-droplist ul.w-e-list {
  list-style: none;
  line-height: 1;
}
.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item {
  color: #333;
  padding: 5px 0;
}
.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item:hover {
  background-color: #f1f1f1;
}
.w-e-toolbar .w-e-droplist ul.w-e-block {
  list-style: none;
  text-align: left;
  padding: 5px;
}
.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item {
  display: inline-block;
  padding: 3px 5px;
}
.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item:hover {
  background-color: #f1f1f1;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(0), f = u(n(161));
      Element.prototype.matches || (Element.prototype.matches = function (p) {
        var c = this.ownerDocument.querySelectorAll(p), v = c.length;
        for (v; v >= 0 && c.item(v) !== this; v--)
          ;
        return v > -1;
      }), f.default || (window.Promise = f.default);
    }, function (i, l, n) {
      i.exports = n(162);
    }, function (i, l, n) {
      var u = n(163);
      i.exports = u;
    }, function (i, l, n) {
      n(61), n(50), n(54), n(175), n(178), n(179);
      var u = n(9);
      i.exports = u.Promise;
    }, function (i, l, n) {
      var u = n(62), f = n(49), p = function (v) {
        return function (b, y) {
          var E = String(f(b)), w = u(y), h = E.length, m, I;
          return w < 0 || w >= h ? v ? "" : void 0 : (m = E.charCodeAt(w), m < 55296 || m > 56319 || w + 1 === h || (I = E.charCodeAt(w + 1)) < 56320 || I > 57343 ? v ? E.charAt(w) : m : v ? E.slice(w, w + 2) : (m - 55296 << 10) + (I - 56320) + 65536);
        };
      };
      i.exports = {
        codeAt: p(!1),
        charAt: p(!0)
      };
    }, function (i, l, n) {
      var u = n(8), f = n(101), p = u.WeakMap;
      i.exports = typeof p == "function" && /native code/.test(f(p));
    }, function (i, l, n) {
      var u = n(8), f = n(19);
      i.exports = function (p, c) {
        try {
          f(u, p, c);
        } catch {
          u[p] = c;
        }
        return c;
      };
    }, function (i, l, n) {
      var u = n(103).IteratorPrototype, f = n(77), p = n(48), c = n(36), v = n(43), b = function () {
        return this;
      };
      i.exports = function (y, E, w) {
        var h = E + " Iterator";
        return y.prototype = f(u, { next: p(1, w) }), c(y, h, !1, !0), v[h] = b, y;
      };
    }, function (i, l, n) {
      var u = n(11);
      i.exports = !u(function () {
        function f() {
        }
        return f.prototype.constructor = null, Object.getPrototypeOf(new f()) !== f.prototype;
      });
    }, function (i, l, n) {
      var u = n(14), f = n(18), p = n(25), c = n(52);
      i.exports = u ? Object.defineProperties : function (b, y) {
        p(b);
        for (var E = c(y), w = E.length, h = 0, m; w > h;)
          f.f(b, m = E[h++], y[m]);
        return b;
      };
    }, function (i, l, n) {
      var u = n(81), f = n(65);
      i.exports = u ? {}.toString : function () {
        return "[object " + f(this) + "]";
      };
    }, function (i, l, n) {
      var u = n(25), f = n(172);
      i.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
        var p = !1, c = {}, v;
        try {
          v = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, v.call(c, []), p = c instanceof Array;
        } catch {
        }
        return function (y, E) {
          return u(y), f(E), p ? v.call(y, E) : y.__proto__ = E, y;
        };
      }() : void 0);
    }, function (i, l, n) {
      var u = n(13);
      i.exports = function (f) {
        if (!u(f) && f !== null)
          throw TypeError("Can't set " + String(f) + " as a prototype");
        return f;
      };
    }, function (i, l, n) {
      var u = n(28), f = n(82), p = n(43), c = n(41), v = n(75), b = "Array Iterator", y = c.set, E = c.getterFor(b);
      i.exports = v(Array, "Array", function (w, h) {
        y(this, {
          type: b,
          target: u(w),
          index: 0,
          kind: h
        });
      }, function () {
        var w = E(this), h = w.target, m = w.kind, I = w.index++;
        return !h || I >= h.length ? (w.target = void 0, { value: void 0, done: !0 }) : m == "keys" ? { value: I, done: !1 } : m == "values" ? { value: h[I], done: !1 } : { value: [I, h[I]], done: !1 };
      }, "values"), p.Arguments = p.Array, f("keys"), f("values"), f("entries");
    }, function (i, l) {
      i.exports = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 };
    }, function (i, l, n) {
      var u = n(5), f = n(42), p = n(8), c = n(35), v = n(108), b = n(53), y = n(109), E = n(36), w = n(110), h = n(13), m = n(40), I = n(83), D = n(33), g = n(101), S = n(66), x = n(114), R = n(115), N = n(116).set, T = n(176), H = n(118), B = n(177), L = n(85), P = n(119), C = n(41), M = n(100), k = n(10), F = n(86), j = k("species"), W = "Promise", Q = C.get, ne = C.set, te = C.getterFor(W), q = v, ge = p.TypeError, be = p.document, me = p.process, ae = c("fetch"), le = L.f, ue = le, he = D(me) == "process", se = !!(be && be.createEvent && p.dispatchEvent), Ae = "unhandledrejection", Ee = "rejectionhandled", Ne = 0, _e = 1, at = 2, it = 1, St = 2, Et, He, bt, pn, Ut = M(W, function () {
        var rt = g(q) !== String(q);
        if (!rt && (F === 66 || !he && typeof PromiseRejectionEvent != "function") || f && !q.prototype.finally)
          return !0;
        if (F >= 51 && /native code/.test(q))
          return !1;
        var Me = q.resolve(1), Re = function (de) {
          de(function () {
          }, function () {
          });
        }, je = Me.constructor = {};
        return je[j] = Re, !(Me.then(function () {
        }) instanceof Re);
      }), yr = Ut || !x(function (rt) {
        q.all(rt).catch(function () {
        });
      }), Un = function (Me) {
        var Re;
        return h(Me) && typeof (Re = Me.then) == "function" ? Re : !1;
      }, bn = function (Me, Re, je) {
        if (!Re.notified) {
          Re.notified = !0;
          var Oe = Re.reactions;
          T(function () {
            for (var de = Re.value, ke = Re.state == _e, Pe = 0; Oe.length > Pe;) {
              var $e = Oe[Pe++], Xe = ke ? $e.ok : $e.fail, on = $e.resolve, xt = $e.reject, Ct = $e.domain, pt, In, br;
              try {
                Xe ? (ke || (Re.rejection === St && Dn(Me, Re), Re.rejection = it), Xe === !0 ? pt = de : (Ct && Ct.enter(), pt = Xe(de), Ct && (Ct.exit(), br = !0)), pt === $e.promise ? xt(ge("Promise-chain cycle")) : (In = Un(pt)) ? In.call(pt, on, xt) : on(pt)) : xt(de);
              } catch (Nn) {
                Ct && !br && Ct.exit(), xt(Nn);
              }
            }
            Re.reactions = [], Re.notified = !1, je && !Re.rejection && jn(Me, Re);
          });
        }
      }, An = function (Me, Re, je) {
        var Oe, de;
        se ? (Oe = be.createEvent("Event"), Oe.promise = Re, Oe.reason = je, Oe.initEvent(Me, !1, !0), p.dispatchEvent(Oe)) : Oe = { promise: Re, reason: je }, (de = p["on" + Me]) ? de(Oe) : Me === Ae && B("Unhandled promise rejection", je);
      }, jn = function (Me, Re) {
        N.call(p, function () {
          var je = Re.value, Oe = Cn(Re), de;
          if (Oe && (de = P(function () {
            he ? me.emit("unhandledRejection", je, Me) : An(Ae, Me, je);
          }), Re.rejection = he || Cn(Re) ? St : it, de.error))
            throw de.value;
        });
      }, Cn = function (Me) {
        return Me.rejection !== it && !Me.parent;
      }, Dn = function (Me, Re) {
        N.call(p, function () {
          he ? me.emit("rejectionHandled", Me) : An(Ee, Me, Re.value);
        });
      }, Bt = function (Me, Re, je, Oe) {
        return function (de) {
          Me(Re, je, de, Oe);
        };
      }, ct = function (Me, Re, je, Oe) {
        Re.done || (Re.done = !0, Oe && (Re = Oe), Re.value = je, Re.state = at, bn(Me, Re, !0));
      }, hn = function rt(Me, Re, je, Oe) {
        if (!Re.done) {
          Re.done = !0, Oe && (Re = Oe);
          try {
            if (Me === je)
              throw ge("Promise can't be resolved itself");
            var de = Un(je);
            de ? T(function () {
              var ke = { done: !1 };
              try {
                de.call(je, Bt(rt, Me, ke, Re), Bt(ct, Me, ke, Re));
              } catch (Pe) {
                ct(Me, ke, Pe, Re);
              }
            }) : (Re.value = je, Re.state = _e, bn(Me, Re, !1));
          } catch (ke) {
            ct(Me, { done: !1 }, ke, Re);
          }
        }
      };
      Ut && (q = function (Me) {
        I(this, q, W), m(Me), Et.call(this);
        var Re = Q(this);
        try {
          Me(Bt(hn, this, Re), Bt(ct, this, Re));
        } catch (je) {
          ct(this, Re, je);
        }
      }, Et = function (Me) {
        ne(this, { type: W, done: !1, notified: !1, parent: !1, reactions: [], rejection: !1, state: Ne, value: void 0 });
      }, Et.prototype = y(q.prototype, {
        then: function (Me, Re) {
          var je = te(this), Oe = le(R(this, q));
          return Oe.ok = typeof Me == "function" ? Me : !0, Oe.fail = typeof Re == "function" && Re, Oe.domain = he ? me.domain : void 0, je.parent = !0, je.reactions.push(Oe), je.state != Ne && bn(this, je, !1), Oe.promise;
        },
        catch: function (Me) {
          return this.then(void 0, Me);
        }
      }), He = function () {
        var Me = new Et(), Re = Q(Me);
        this.promise = Me, this.resolve = Bt(hn, Me, Re), this.reject = Bt(ct, Me, Re);
      }, L.f = le = function (Me) {
        return Me === q || Me === bt ? new He(Me) : ue(Me);
      }, !f && typeof v == "function" && (pn = v.prototype.then, b(v.prototype, "then", function (Me, Re) {
        var je = this;
        return new q(function (Oe, de) {
          pn.call(je, Oe, de);
        }).then(Me, Re);
      }, { unsafe: !0 }), typeof ae == "function" && u({ global: !0, enumerable: !0, forced: !0 }, {
        fetch: function (Me) {
          return H(q, ae.apply(p, arguments));
        }
      }))), u({ global: !0, wrap: !0, forced: Ut }, { Promise: q }), E(q, W, !1, !0), w(W), bt = c(W), u({ target: W, stat: !0, forced: Ut }, {
        reject: function (Me) {
          var Re = le(this);
          return Re.reject.call(void 0, Me), Re.promise;
        }
      }), u({ target: W, stat: !0, forced: f || Ut }, {
        resolve: function (Me) {
          return H(f && this === bt ? q : this, Me);
        }
      }), u({ target: W, stat: !0, forced: yr }, {
        all: function (Me) {
          var Re = this, je = le(Re), Oe = je.resolve, de = je.reject, ke = P(function () {
            var Pe = m(Re.resolve), $e = [], Xe = 0, on = 1;
            S(Me, function (xt) {
              var Ct = Xe++, pt = !1;
              $e.push(void 0), on++, Pe.call(Re, xt).then(function (In) {
                pt || (pt = !0, $e[Ct] = In, --on || Oe($e));
              }, de);
            }), --on || Oe($e);
          });
          return ke.error && de(ke.value), je.promise;
        },
        race: function (Me) {
          var Re = this, je = le(Re), Oe = je.reject, de = P(function () {
            var ke = m(Re.resolve);
            S(Me, function (Pe) {
              ke.call(Re, Pe).then(je.resolve, Oe);
            });
          });
          return de.error && Oe(de.value), je.promise;
        }
      });
    }, function (i, l, n) {
      var u = n(8), f = n(71).f, p = n(33), c = n(116).set, v = n(117), b = u.MutationObserver || u.WebKitMutationObserver, y = u.process, E = u.Promise, w = p(y) == "process", h = f(u, "queueMicrotask"), m = h && h.value, I, D, g, S, x, R, N, T;
      m || (I = function () {
        var B, L;
        for (w && (B = y.domain) && B.exit(); D;) {
          L = D.fn, D = D.next;
          try {
            L();
          } catch (P) {
            throw D ? S() : g = void 0, P;
          }
        }
        g = void 0, B && B.enter();
      }, w ? S = function () {
        y.nextTick(I);
      } : b && !v ? (x = !0, R = document.createTextNode(""), new b(I).observe(R, { characterData: !0 }), S = function () {
        R.data = x = !x;
      }) : E && E.resolve ? (N = E.resolve(void 0), T = N.then, S = function () {
        T.call(N, I);
      }) : S = function () {
        c.call(u, I);
      }), i.exports = m || function (H) {
        var B = { fn: H, next: void 0 };
        g && (g.next = B), D || (D = B, S()), g = B;
      };
    }, function (i, l, n) {
      var u = n(8);
      i.exports = function (f, p) {
        var c = u.console;
        c && c.error && (arguments.length === 1 ? c.error(f) : c.error(f, p));
      };
    }, function (i, l, n) {
      var u = n(5), f = n(40), p = n(85), c = n(119), v = n(66);
      u({ target: "Promise", stat: !0 }, {
        allSettled: function (y) {
          var E = this, w = p.f(E), h = w.resolve, m = w.reject, I = c(function () {
            var D = f(E.resolve), g = [], S = 0, x = 1;
            v(y, function (R) {
              var N = S++, T = !1;
              g.push(void 0), x++, D.call(E, R).then(function (H) {
                T || (T = !0, g[N] = { status: "fulfilled", value: H }, --x || h(g));
              }, function (H) {
                T || (T = !0, g[N] = { status: "rejected", reason: H }, --x || h(g));
              });
            }), --x || h(g);
          });
          return I.error && m(I.value), w.promise;
        }
      });
    }, function (i, l, n) {
      var u = n(5), f = n(42), p = n(108), c = n(11), v = n(35), b = n(115), y = n(118), E = n(53), w = !!p && c(function () {
        p.prototype.finally.call({
          then: function () {
          }
        }, function () {
        });
      });
      u({ target: "Promise", proto: !0, real: !0, forced: w }, {
        finally: function (m) {
          var I = b(this, v("Promise")), D = typeof m == "function";
          return this.then(D ? function (g) {
            return y(I, m()).then(function () {
              return g;
            });
          } : m, D ? function (g) {
            return y(I, m()).then(function () {
              throw g;
            });
          } : m);
        }
      }), !f && typeof p == "function" && !p.prototype.finally && E(p.prototype, "finally", v("Promise").prototype.finally);
    }, function (i, l, n) {
      n(54);
      var u = n(181), f = n(65), p = Array.prototype, c = { DOMTokenList: !0, NodeList: !0 };
      i.exports = function (v) {
        var b = v.forEach;
        return v === p || v instanceof Array && b === p.forEach || c.hasOwnProperty(f(v)) ? u : b;
      };
    }, function (i, l, n) {
      var u = n(182);
      i.exports = u;
    }, function (i, l, n) {
      n(183);
      var u = n(15);
      i.exports = u("Array").forEach;
    }, function (i, l, n) {
      var u = n(5), f = n(184);
      u({ target: "Array", proto: !0, forced: [].forEach != f }, { forEach: f });
    }, function (i, l, n) {
      var u = n(30).forEach, f = n(67), p = n(22), c = f("forEach"), v = p("forEach");
      i.exports = !c || !v ? function (y) {
        return u(this, y, arguments.length > 1 ? arguments[1] : void 0);
      } : [].forEach;
    }, function (i, l, n) {
      var u = n(186);
      i.exports = u;
    }, function (i, l, n) {
      n(187);
      var u = n(9);
      i.exports = u.Array.isArray;
    }, function (i, l, n) {
      var u = n(5), f = n(55);
      u({ target: "Array", stat: !0 }, { isArray: f });
    }, function (i, l, n) {
      var u = n(189);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(190), f = Array.prototype;
      i.exports = function (p) {
        var c = p.map;
        return p === f || p instanceof Array && c === f.map ? u : c;
      };
    }, function (i, l, n) {
      n(191);
      var u = n(15);
      i.exports = u("Array").map;
    }, function (i, l, n) {
      var u = n(5), f = n(30).map, p = n(56), c = n(22), v = p("map"), b = c("map");
      u({ target: "Array", proto: !0, forced: !v || !b }, {
        map: function (E) {
          return f(this, E, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }, function (i, l, n) {
      var u = n(193);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(194), f = String.prototype;
      i.exports = function (p) {
        var c = p.trim;
        return typeof p == "string" || p === f || p instanceof String && c === f.trim ? u : c;
      };
    }, function (i, l, n) {
      n(195);
      var u = n(15);
      i.exports = u("String").trim;
    }, function (i, l, n) {
      var u = n(5), f = n(90).trim, p = n(196);
      u({ target: "String", proto: !0, forced: p("trim") }, {
        trim: function () {
          return f(this);
        }
      });
    }, function (i, l, n) {
      var u = n(11), f = n(68), p = "\u200B\x85\u180E";
      i.exports = function (c) {
        return u(function () {
          return !!f[c]() || p[c]() != p || f[c].name !== c;
        });
      };
    }, function (i, l, n) {
      var u = n(198);
      i.exports = u;
    }, function (i, l, n) {
      n(199), n(61), n(50), n(54);
      var u = n(9);
      i.exports = u.Map;
    }, function (i, l, n) {
      var u = n(121), f = n(123);
      i.exports = u("Map", function (p) {
        return function () {
          return p(this, arguments.length ? arguments[0] : void 0);
        };
      }, f);
    }, function (i, l, n) {
      var u = n(11);
      i.exports = !u(function () {
        return Object.isExtensible(Object.preventExtensions({}));
      });
    }, function (i, l, n) {
      var u = n(202);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(203), f = Array.prototype;
      i.exports = function (p) {
        var c = p.indexOf;
        return p === f || p instanceof Array && c === f.indexOf ? u : c;
      };
    }, function (i, l, n) {
      n(204);
      var u = n(15);
      i.exports = u("Array").indexOf;
    }, function (i, l, n) {
      var u = n(5), f = n(78).indexOf, p = n(67), c = n(22), v = [].indexOf, b = !!v && 1 / [1].indexOf(1, -0) < 0, y = p("indexOf"), E = c("indexOf", { ACCESSORS: !0, 1: 0 });
      u({ target: "Array", proto: !0, forced: b || !y || !E }, {
        indexOf: function (h) {
          return b ? v.apply(this, arguments) || 0 : f(this, h, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }, function (i, l, n) {
      var u = n(206);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(207), f = Array.prototype;
      i.exports = function (p) {
        var c = p.splice;
        return p === f || p instanceof Array && c === f.splice ? u : c;
      };
    }, function (i, l, n) {
      n(208);
      var u = n(15);
      i.exports = u("Array").splice;
    }, function (i, l, n) {
      var u = n(5), f = n(79), p = n(62), c = n(34), v = n(29), b = n(88), y = n(69), E = n(56), w = n(22), h = E("splice"), m = w("splice", { ACCESSORS: !0, 0: 0, 1: 2 }), I = Math.max, D = Math.min, g = 9007199254740991, S = "Maximum allowed length exceeded";
      u({ target: "Array", proto: !0, forced: !h || !m }, {
        splice: function (R, N) {
          var T = v(this), H = c(T.length), B = f(R, H), L = arguments.length, P, C, M, k, F, j;
          if (L === 0 ? P = C = 0 : L === 1 ? (P = 0, C = H - B) : (P = L - 2, C = D(I(p(N), 0), H - B)), H + P - C > g)
            throw TypeError(S);
          for (M = b(T, C), k = 0; k < C; k++)
            F = B + k, F in T && y(M, k, T[F]);
          if (M.length = C, P < C) {
            for (k = B; k < H - C; k++)
              F = k + C, j = k + P, F in T ? T[j] = T[F] : delete T[j];
            for (k = H; k > H - C + P; k--)
              delete T[k - 1];
          } else if (P > C)
            for (k = H - C; k > B; k--)
              F = k + C - 1, j = k + P - 1, F in T ? T[j] = T[F] : delete T[j];
          for (k = 0; k < P; k++)
            T[k + B] = arguments[k + 2];
          return T.length = H - C + P, M;
        }
      });
    }, function (i, l, n) {
      var u = n(210);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(211), f = Array.prototype;
      i.exports = function (p) {
        var c = p.filter;
        return p === f || p instanceof Array && c === f.filter ? u : c;
      };
    }, function (i, l, n) {
      n(212);
      var u = n(15);
      i.exports = u("Array").filter;
    }, function (i, l, n) {
      var u = n(5), f = n(30).filter, p = n(56), c = n(22), v = p("filter"), b = c("filter");
      u({ target: "Array", proto: !0, forced: !v || !b }, {
        filter: function (E) {
          return f(this, E, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }, function (i, l, n) {
      var u = n(214);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(215), f = n(217), p = Array.prototype, c = String.prototype;
      i.exports = function (v) {
        var b = v.includes;
        return v === p || v instanceof Array && b === p.includes ? u : typeof v == "string" || v === c || v instanceof String && b === c.includes ? f : b;
      };
    }, function (i, l, n) {
      n(216);
      var u = n(15);
      i.exports = u("Array").includes;
    }, function (i, l, n) {
      var u = n(5), f = n(78).includes, p = n(82), c = n(22), v = c("indexOf", { ACCESSORS: !0, 1: 0 });
      u({ target: "Array", proto: !0, forced: !v }, {
        includes: function (y) {
          return f(this, y, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), p("includes");
    }, function (i, l, n) {
      n(218);
      var u = n(15);
      i.exports = u("String").includes;
    }, function (i, l, n) {
      var u = n(5), f = n(219), p = n(49), c = n(221);
      u({ target: "String", proto: !0, forced: !c("includes") }, {
        includes: function (b) {
          return !!~String(p(this)).indexOf(f(b), arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }, function (i, l, n) {
      var u = n(220);
      i.exports = function (f) {
        if (u(f))
          throw TypeError("The method doesn't accept regular expressions");
        return f;
      };
    }, function (i, l, n) {
      var u = n(13), f = n(33), p = n(10), c = p("match");
      i.exports = function (v) {
        var b;
        return u(v) && ((b = v[c]) !== void 0 ? !!b : f(v) == "RegExp");
      };
    }, function (i, l, n) {
      var u = n(10), f = u("match");
      i.exports = function (p) {
        var c = /./;
        try {
          "/./"[p](c);
        } catch {
          try {
            return c[f] = !1, "/./"[p](c);
          } catch {
          }
        }
        return !1;
      };
    }, function (i, l, n) {
      var u = n(223);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(224), f = Function.prototype;
      i.exports = function (p) {
        var c = p.bind;
        return p === f || p instanceof Function && c === f.bind ? u : c;
      };
    }, function (i, l, n) {
      n(225);
      var u = n(15);
      i.exports = u("Function").bind;
    }, function (i, l, n) {
      var u = n(5), f = n(226);
      u({ target: "Function", proto: !0 }, { bind: f });
    }, function (i, l, n) {
      var u = n(40), f = n(13), p = [].slice, c = {}, v = function (y, E, w) {
        if (!(E in c)) {
          for (var h = [], m = 0; m < E; m++)
            h[m] = "a[" + m + "]";
          c[E] = Function("C,a", "return new C(" + h.join(",") + ")");
        }
        return c[E](y, w);
      };
      i.exports = Function.bind || function (y) {
        var E = u(this), w = p.call(arguments, 1), h = function () {
          var I = w.concat(p.call(arguments));
          return this instanceof h ? v(E, I.length, I) : E.apply(y, I);
        };
        return f(E.prototype) && (h.prototype = E.prototype), h;
      };
    }, function (i, l, n) {
      i.exports = n(228);
    }, function (i, l, n) {
      var u = n(229);
      i.exports = u;
    }, function (i, l, n) {
      n(124), n(50), n(54);
      var u = n(93);
      i.exports = u.f("iterator");
    }, function (i, l, n) {
      i.exports = n(231);
    }, function (i, l, n) {
      var u = n(232);
      n(251), n(252), n(253), n(254), n(255), i.exports = u;
    }, function (i, l, n) {
      n(233), n(61), n(234), n(236), n(237), n(238), n(239), n(124), n(240), n(241), n(242), n(243), n(244), n(245), n(246), n(247), n(248), n(249), n(250);
      var u = n(9);
      i.exports = u.Symbol;
    }, function (i, l, n) {
      var u = n(5), f = n(11), p = n(55), c = n(13), v = n(29), b = n(34), y = n(69), E = n(88), w = n(56), h = n(10), m = n(86), I = h("isConcatSpreadable"), D = 9007199254740991, g = "Maximum allowed index exceeded", S = m >= 51 || !f(function () {
        var T = [];
        return T[I] = !1, T.concat()[0] !== T;
      }), x = w("concat"), R = function (H) {
        if (!c(H))
          return !1;
        var B = H[I];
        return B !== void 0 ? !!B : p(H);
      }, N = !S || !x;
      u({ target: "Array", proto: !0, forced: N }, {
        concat: function (H) {
          var B = v(this), L = E(B, 0), P = 0, C, M, k, F, j;
          for (C = -1, k = arguments.length; C < k; C++)
            if (j = C === -1 ? B : arguments[C], R(j)) {
              if (F = b(j.length), P + F > D)
                throw TypeError(g);
              for (M = 0; M < F; M++, P++)
                M in j && y(L, P, j[M]);
            } else {
              if (P >= D)
                throw TypeError(g);
              y(L, P++, j);
            }
          return L.length = P, L;
        }
      });
    }, function (i, l, n) {
      var u = n(5), f = n(8), p = n(35), c = n(42), v = n(14), b = n(76), y = n(105), E = n(11), w = n(16), h = n(55), m = n(13), I = n(25), D = n(29), g = n(28), S = n(60), x = n(48), R = n(77), N = n(52), T = n(125), H = n(235), B = n(126), L = n(71), P = n(18), C = n(59), M = n(19), k = n(53), F = n(74), j = n(63), W = n(51), Q = n(64), ne = n(10), te = n(93), q = n(12), ge = n(36), be = n(41), me = n(30).forEach, ae = j("hidden"), le = "Symbol", ue = "prototype", he = ne("toPrimitive"), se = be.set, Ae = be.getterFor(le), Ee = Object[ue], Ne = f.Symbol, _e = p("JSON", "stringify"), at = L.f, it = P.f, St = H.f, Et = C.f, He = F("symbols"), bt = F("op-symbols"), pn = F("string-to-symbol-registry"), Ut = F("symbol-to-string-registry"), yr = F("wks"), Un = f.QObject, bn = !Un || !Un[ue] || !Un[ue].findChild, An = v && E(function () {
        return R(it({}, "a", {
          get: function () {
            return it(this, "a", { value: 7 }).a;
          }
        })).a != 7;
      }) ? function (Oe, de, ke) {
        var Pe = at(Ee, de);
        Pe && delete Ee[de], it(Oe, de, ke), Pe && Oe !== Ee && it(Ee, de, Pe);
      } : it, jn = function (de, ke) {
        var Pe = He[de] = R(Ne[ue]);
        return se(Pe, { type: le, tag: de, description: ke }), v || (Pe.description = ke), Pe;
      }, Cn = y ? function (Oe) {
        return Qt(Oe) == "symbol";
      } : function (Oe) {
        return Object(Oe) instanceof Ne;
      }, Dn = function (de, ke, Pe) {
        de === Ee && Dn(bt, ke, Pe), I(de);
        var $e = S(ke, !0);
        return I(Pe), w(He, $e) ? (Pe.enumerable ? (w(de, ae) && de[ae][$e] && (de[ae][$e] = !1), Pe = R(Pe, { enumerable: x(0, !1) })) : (w(de, ae) || it(de, ae, x(1, {})), de[ae][$e] = !0), An(de, $e, Pe)) : it(de, $e, Pe);
      }, Bt = function (de, ke) {
        I(de);
        var Pe = g(ke), $e = N(Pe).concat(Re(Pe));
        return me($e, function (Xe) {
          (!v || hn.call(Pe, Xe)) && Dn(de, Xe, Pe[Xe]);
        }), de;
      }, ct = function (de, ke) {
        return ke === void 0 ? R(de) : Bt(R(de), ke);
      }, hn = function (de) {
        var ke = S(de, !0), Pe = Et.call(this, ke);
        return this === Ee && w(He, ke) && !w(bt, ke) ? !1 : Pe || !w(this, ke) || !w(He, ke) || w(this, ae) && this[ae][ke] ? Pe : !0;
      }, rt = function (de, ke) {
        var Pe = g(de), $e = S(ke, !0);
        if (!(Pe === Ee && w(He, $e) && !w(bt, $e))) {
          var Xe = at(Pe, $e);
          return Xe && w(He, $e) && !(w(Pe, ae) && Pe[ae][$e]) && (Xe.enumerable = !0), Xe;
        }
      }, Me = function (de) {
        var ke = St(g(de)), Pe = [];
        return me(ke, function ($e) {
          !w(He, $e) && !w(W, $e) && Pe.push($e);
        }), Pe;
      }, Re = function (de) {
        var ke = de === Ee, Pe = St(ke ? bt : g(de)), $e = [];
        return me(Pe, function (Xe) {
          w(He, Xe) && (!ke || w(Ee, Xe)) && $e.push(He[Xe]);
        }), $e;
      };
      if (b || (Ne = function () {
        if (this instanceof Ne)
          throw TypeError("Symbol is not a constructor");
        var de = !arguments.length || arguments[0] === void 0 ? void 0 : String(arguments[0]), ke = Q(de), Pe = function $e(Xe) {
          this === Ee && $e.call(bt, Xe), w(this, ae) && w(this[ae], ke) && (this[ae][ke] = !1), An(this, ke, x(1, Xe));
        };
        return v && bn && An(Ee, ke, { configurable: !0, set: Pe }), jn(ke, de);
      }, k(Ne[ue], "toString", function () {
        return Ae(this).tag;
      }), k(Ne, "withoutSetter", function (Oe) {
        return jn(Q(Oe), Oe);
      }), C.f = hn, P.f = Dn, L.f = rt, T.f = H.f = Me, B.f = Re, te.f = function (Oe) {
        return jn(ne(Oe), Oe);
      }, v && (it(Ne[ue], "description", {
        configurable: !0, get: function () {
          return Ae(this).description;
        }
      }), c || k(Ee, "propertyIsEnumerable", hn, { unsafe: !0 }))), u({ global: !0, wrap: !0, forced: !b, sham: !b }, { Symbol: Ne }), me(N(yr), function (Oe) {
        q(Oe);
      }), u({ target: le, stat: !0, forced: !b }, {
        for: function (de) {
          var ke = String(de);
          if (w(pn, ke))
            return pn[ke];
          var Pe = Ne(ke);
          return pn[ke] = Pe, Ut[Pe] = ke, Pe;
        },
        keyFor: function (de) {
          if (!Cn(de))
            throw TypeError(de + " is not a symbol");
          if (w(Ut, de))
            return Ut[de];
        },
        useSetter: function () {
          bn = !0;
        },
        useSimple: function () {
          bn = !1;
        }
      }), u({ target: "Object", stat: !0, forced: !b, sham: !v }, {
        create: ct,
        defineProperty: Dn,
        defineProperties: Bt,
        getOwnPropertyDescriptor: rt
      }), u({ target: "Object", stat: !0, forced: !b }, {
        getOwnPropertyNames: Me,
        getOwnPropertySymbols: Re
      }), u({
        target: "Object", stat: !0, forced: E(function () {
          B.f(1);
        })
      }, {
        getOwnPropertySymbols: function (de) {
          return B.f(D(de));
        }
      }), _e) {
        var je = !b || E(function () {
          var Oe = Ne();
          return _e([Oe]) != "[null]" || _e({ a: Oe }) != "{}" || _e(Object(Oe)) != "{}";
        });
        u({ target: "JSON", stat: !0, forced: je }, {
          stringify: function (de, ke, Pe) {
            for (var $e = [de], Xe = 1, on; arguments.length > Xe;)
              $e.push(arguments[Xe++]);
            if (on = ke, !(!m(ke) && de === void 0 || Cn(de)))
              return h(ke) || (ke = function (Ct, pt) {
                if (typeof on == "function" && (pt = on.call(this, Ct, pt)), !Cn(pt))
                  return pt;
              }), $e[1] = ke, _e.apply(null, $e);
          }
        });
      }
      Ne[ue][he] || M(Ne[ue], he, Ne[ue].valueOf), ge(Ne, le), W[ae] = !0;
    }, function (i, l, n) {
      var u = n(28), f = n(125).f, p = {}.toString, c = (typeof window > "u" ? "undefined" : Qt(window)) == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], v = function (y) {
        try {
          return f(y);
        } catch {
          return c.slice();
        }
      };
      i.exports.f = function (y) {
        return c && p.call(y) == "[object Window]" ? v(y) : f(u(y));
      };
    }, function (i, l, n) {
      var u = n(12);
      u("asyncIterator");
    }, function (i, l) {
    }, function (i, l, n) {
      var u = n(12);
      u("hasInstance");
    }, function (i, l, n) {
      var u = n(12);
      u("isConcatSpreadable");
    }, function (i, l, n) {
      var u = n(12);
      u("match");
    }, function (i, l, n) {
      var u = n(12);
      u("matchAll");
    }, function (i, l, n) {
      var u = n(12);
      u("replace");
    }, function (i, l, n) {
      var u = n(12);
      u("search");
    }, function (i, l, n) {
      var u = n(12);
      u("species");
    }, function (i, l, n) {
      var u = n(12);
      u("split");
    }, function (i, l, n) {
      var u = n(12);
      u("toPrimitive");
    }, function (i, l, n) {
      var u = n(12);
      u("toStringTag");
    }, function (i, l, n) {
      var u = n(12);
      u("unscopables");
    }, function (i, l, n) {
      var u = n(36);
      u(Math, "Math", !0);
    }, function (i, l, n) {
      var u = n(8), f = n(36);
      f(u.JSON, "JSON", !0);
    }, function (i, l, n) {
      var u = n(12);
      u("asyncDispose");
    }, function (i, l, n) {
      var u = n(12);
      u("dispose");
    }, function (i, l, n) {
      var u = n(12);
      u("observable");
    }, function (i, l, n) {
      var u = n(12);
      u("patternMatch");
    }, function (i, l, n) {
      var u = n(12);
      u("replaceAll");
    }, function (i, l, n) {
      i.exports = n(257);
    }, function (i, l, n) {
      var u = n(258);
      i.exports = u;
    }, function (i, l, n) {
      n(259);
      var u = n(9);
      i.exports = u.parseInt;
    }, function (i, l, n) {
      var u = n(5), f = n(260);
      u({ global: !0, forced: parseInt != f }, { parseInt: f });
    }, function (i, l, n) {
      var u = n(8), f = n(90).trim, p = n(68), c = u.parseInt, v = /^[+-]?0[Xx]/, b = c(p + "08") !== 8 || c(p + "0x16") !== 22;
      i.exports = b ? function (E, w) {
        var h = f(String(E));
        return c(h, w >>> 0 || (v.test(h) ? 16 : 10));
      } : c;
    }, function (i, l, n) {
      var u = n(262);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(263), f = Array.prototype;
      i.exports = function (p) {
        var c = p.slice;
        return p === f || p instanceof Array && c === f.slice ? u : c;
      };
    }, function (i, l, n) {
      n(264);
      var u = n(15);
      i.exports = u("Array").slice;
    }, function (i, l, n) {
      var u = n(5), f = n(13), p = n(55), c = n(79), v = n(34), b = n(28), y = n(69), E = n(10), w = n(56), h = n(22), m = w("slice"), I = h("slice", { ACCESSORS: !0, 0: 0, 1: 2 }), D = E("species"), g = [].slice, S = Math.max;
      u({ target: "Array", proto: !0, forced: !m || !I }, {
        slice: function (R, N) {
          var T = b(this), H = v(T.length), B = c(R, H), L = c(N === void 0 ? H : N, H), P, C, M;
          if (p(T) && (P = T.constructor, typeof P == "function" && (P === Array || p(P.prototype)) ? P = void 0 : f(P) && (P = P[D], P === null && (P = void 0)), P === Array || P === void 0))
            return g.call(T, B, L);
          for (C = new (P === void 0 ? Array : P)(S(L - B, 0)), M = 0; B < L; B++, M++)
            B in T && y(C, M, T[B]);
          return C.length = M, C;
        }
      });
    }, function (i, l, n) {
      n(266);
      var u = n(9);
      i.exports = u.setTimeout;
    }, function (i, l, n) {
      var u = n(5), f = n(8), p = n(84), c = [].slice, v = /MSIE .\./.test(p), b = function (E) {
        return function (w, h) {
          var m = arguments.length > 2, I = m ? c.call(arguments, 2) : void 0;
          return E(m ? function () {
            (typeof w == "function" ? w : Function(w)).apply(this, I);
          } : w, h);
        };
      };
      u({ global: !0, bind: !0, forced: v }, {
        setTimeout: b(f.setTimeout),
        setInterval: b(f.setInterval)
      });
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(127));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(272)), b = c.__importDefault(n(273)), y = c.__importDefault(n(128)), E = c.__importDefault(n(274)), w = c.__importDefault(n(275)), h = c.__importDefault(n(276)), m = c.__importDefault(n(129)), I = c.__importDefault(n(277)), D = c.__importDefault(n(278)), g = c.__importDefault(n(279)), S = (0, p.default)(
        {},
        v.default,
        b.default,
        y.default,
        w.default,
        E.default,
        h.default,
        m.default,
        I.default,
        D.default,
        g.default,
        {
          linkCheck: function (R, N) {
            return !0;
          }
        }
      );
      l.default = S;
    }, function (i, l, n) {
      var u = n(269);
      i.exports = u;
    }, function (i, l, n) {
      n(270);
      var u = n(9);
      i.exports = u.Object.assign;
    }, function (i, l, n) {
      var u = n(5), f = n(271);
      u({ target: "Object", stat: !0, forced: Object.assign !== f }, { assign: f });
    }, function (i, l, n) {
      var u = n(14), f = n(11), p = n(52), c = n(126), v = n(59), b = n(29), y = n(72), E = Object.assign, w = Object.defineProperty;
      i.exports = !E || f(function () {
        if (u && E({ b: 1 }, E(w({}, "a", {
          enumerable: !0, get: function () {
            w(this, "b", { value: 3, enumerable: !1 });
          }
        }), { b: 2 })).b !== 1)
          return !0;
        var h = {}, m = {}, I = Symbol(), D = "abcdefghijklmnopqrst";
        return h[I] = 7, D.split("").forEach(function (g) {
          m[g] = g;
        }), E({}, h)[I] != 7 || p(E({}, m)).join("") != D;
      }) ? function (m, I) {
        for (var D = b(m), g = arguments.length, S = 1, x = c.f, R = v.f; g > S;)
          for (var N = y(arguments[S++]), T = x ? p(N).concat(x(N)) : p(N), H = T.length, B = 0, L; H > B;)
            L = T[B++], (!u || R.call(N, L)) && (D[L] = N[L]);
        return D;
      } : E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.default = {
        menus: [
          "head",
          "bold",
          "fontSize",
          "fontName",
          "italic",
          "underline",
          "strikeThrough",
          "indent",
          "lineHeight",
          "foreColor",
          "backColor",
          "link",
          "list",
          "todo",
          "justify",
          "quote",
          "emoticon",
          "image",
          "video",
          "table",
          "code",
          "splitLine",
          "undo",
          "redo"
        ],
        fontNames: ["\u9ED1\u4F53", "\u4EFF\u5B8B", "\u6977\u4F53", "\u6807\u6977\u4F53", "\u534E\u6587\u4EFF\u5B8B", "\u534E\u6587\u6977\u4F53", "\u5B8B\u4F53", "\u5FAE\u8F6F\u96C5\u9ED1", "Arial", "Tahoma", "Verdana", "Times New Roman", "Courier New"],
        fontSizes: { "x-small": { name: "10px", value: "1" }, small: { name: "13px", value: "2" }, normal: { name: "16px", value: "3" }, large: { name: "18px", value: "4" }, "x-large": { name: "24px", value: "5" }, "xx-large": { name: "32px", value: "6" }, "xxx-large": { name: "48px", value: "7" } },
        colors: ["#000000", "#ffffff", "#eeece0", "#1c487f", "#4d80bf", "#c24f4a", "#8baa4a", "#7b5ba1", "#46acc8", "#f9963b"],
        languageType: ["Bash", "C", "C#", "C++", "CSS", "Java", "JavaScript", "JSON", "TypeScript", "Plain text", "Html", "XML", "SQL", "Go", "Kotlin", "Lua", "Markdown", "PHP", "Python", "Shell Session", "Ruby"],
        languageTab: "\u3000\u3000\u3000\u3000",
        emotions: [{
          title: "\u8868\u60C5",
          type: "emoji",
          content: "\u{1F600} \u{1F603} \u{1F604} \u{1F601} \u{1F606} \u{1F605} \u{1F602} \u{1F923} \u{1F60A} \u{1F607} \u{1F642} \u{1F643} \u{1F609} \u{1F60C} \u{1F60D} \u{1F618} \u{1F617} \u{1F619} \u{1F61A} \u{1F60B} \u{1F61B} \u{1F61D} \u{1F61C} \u{1F913} \u{1F60E} \u{1F60F} \u{1F612} \u{1F61E} \u{1F614} \u{1F61F} \u{1F615} \u{1F641} \u{1F623} \u{1F616} \u{1F62B} \u{1F629} \u{1F622} \u{1F62D} \u{1F624} \u{1F620} \u{1F621} \u{1F633} \u{1F631} \u{1F628} \u{1F917} \u{1F914} \u{1F636} \u{1F611} \u{1F62C} \u{1F644} \u{1F62F} \u{1F634} \u{1F637} \u{1F911} \u{1F608} \u{1F921} \u{1F4A9} \u{1F47B} \u{1F480} \u{1F440} \u{1F463}".split(/\s/)
        }, {
          title: "\u624B\u52BF",
          type: "emoji",
          content: "\u{1F450} \u{1F64C} \u{1F44F} \u{1F91D} \u{1F44D} \u{1F44E} \u{1F44A} \u270A \u{1F91B} \u{1F91C} \u{1F91E} \u270C\uFE0F \u{1F918} \u{1F44C} \u{1F448} \u{1F449} \u{1F446} \u{1F447} \u261D\uFE0F \u270B \u{1F91A} \u{1F590} \u{1F596} \u{1F44B} \u{1F919} \u{1F4AA} \u{1F595} \u270D\uFE0F \u{1F64F}".split(/\s/)
        }],
        lineHeights: ["1", "1.15", "1.6", "2", "2.5", "3"],
        undoLimit: 20,
        indentation: "2em",
        showMenuTooltips: !0,
        menuTooltipPosition: "up"
      };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(7);
      function c(v, b, y) {
        window.alert(v), y && console.error("wangEditor: " + y);
      }
      l.default = { onchangeTimeout: 200, onchange: null, onfocus: p.EMPTY_FN, onblur: p.EMPTY_FN, onCatalogChange: null, customAlert: c };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.default = {
        pasteFilterStyle: !0,
        pasteIgnoreImg: !1,
        pasteTextHandle: function (c) {
          return c;
        }
      };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.default = { styleWithCSS: !1 };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(7);
      l.default = {
        linkImgCheck: function (v, b, y) {
          return !0;
        },
        showLinkImg: !0,
        showLinkImgAlt: !0,
        showLinkImgHref: !0,
        linkImgCallback: p.EMPTY_FN,
        uploadImgAccept: ["jpg", "jpeg", "png", "gif", "bmp"],
        uploadImgServer: "",
        uploadImgShowBase64: !1,
        uploadImgMaxSize: 5 * 1024 * 1024,
        uploadImgMaxLength: 100,
        uploadFileName: "",
        uploadImgParams: {},
        uploadImgParamsWithUrl: !1,
        uploadImgHeaders: {},
        uploadImgHooks: {},
        uploadImgTimeout: 10 * 1e3,
        withCredentials: !1,
        customUploadImg: null,
        uploadImgFromMedia: null
      };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.default = { lang: "zh-CN", languages: { "zh-CN": { wangEditor: { \u91CD\u7F6E: "\u91CD\u7F6E", \u63D2\u5165: "\u63D2\u5165", \u9ED8\u8BA4: "\u9ED8\u8BA4", \u521B\u5EFA: "\u521B\u5EFA", \u4FEE\u6539: "\u4FEE\u6539", \u5982: "\u5982", \u8BF7\u8F93\u5165\u6B63\u6587: "\u8BF7\u8F93\u5165\u6B63\u6587", menus: { title: { \u6807\u9898: "\u6807\u9898", \u52A0\u7C97: "\u52A0\u7C97", \u5B57\u53F7: "\u5B57\u53F7", \u5B57\u4F53: "\u5B57\u4F53", \u659C\u4F53: "\u659C\u4F53", \u4E0B\u5212\u7EBF: "\u4E0B\u5212\u7EBF", \u5220\u9664\u7EBF: "\u5220\u9664\u7EBF", \u7F29\u8FDB: "\u7F29\u8FDB", \u884C\u9AD8: "\u884C\u9AD8", \u6587\u5B57\u989C\u8272: "\u6587\u5B57\u989C\u8272", \u80CC\u666F\u8272: "\u80CC\u666F\u8272", \u94FE\u63A5: "\u94FE\u63A5", \u5E8F\u5217: "\u5E8F\u5217", \u5BF9\u9F50: "\u5BF9\u9F50", \u5F15\u7528: "\u5F15\u7528", \u8868\u60C5: "\u8868\u60C5", \u56FE\u7247: "\u56FE\u7247", \u89C6\u9891: "\u89C6\u9891", \u8868\u683C: "\u8868\u683C", \u4EE3\u7801: "\u4EE3\u7801", \u5206\u5272\u7EBF: "\u5206\u5272\u7EBF", \u6062\u590D: "\u6062\u590D", \u64A4\u9500: "\u64A4\u9500", \u5168\u5C4F: "\u5168\u5C4F", \u53D6\u6D88\u5168\u5C4F: "\u53D6\u6D88\u5168\u5C4F", \u5F85\u529E\u4E8B\u9879: "\u5F85\u529E\u4E8B\u9879" }, dropListMenu: { \u8BBE\u7F6E\u6807\u9898: "\u8BBE\u7F6E\u6807\u9898", \u80CC\u666F\u989C\u8272: "\u80CC\u666F\u989C\u8272", \u6587\u5B57\u989C\u8272: "\u6587\u5B57\u989C\u8272", \u8BBE\u7F6E\u5B57\u53F7: "\u8BBE\u7F6E\u5B57\u53F7", \u8BBE\u7F6E\u5B57\u4F53: "\u8BBE\u7F6E\u5B57\u4F53", \u8BBE\u7F6E\u7F29\u8FDB: "\u8BBE\u7F6E\u7F29\u8FDB", \u5BF9\u9F50\u65B9\u5F0F: "\u5BF9\u9F50\u65B9\u5F0F", \u8BBE\u7F6E\u884C\u9AD8: "\u8BBE\u7F6E\u884C\u9AD8", \u5E8F\u5217: "\u5E8F\u5217", head: { \u6B63\u6587: "\u6B63\u6587" }, indent: { \u589E\u52A0\u7F29\u8FDB: "\u589E\u52A0\u7F29\u8FDB", \u51CF\u5C11\u7F29\u8FDB: "\u51CF\u5C11\u7F29\u8FDB" }, justify: { \u9760\u5DE6: "\u9760\u5DE6", \u5C45\u4E2D: "\u5C45\u4E2D", \u9760\u53F3: "\u9760\u53F3", \u4E24\u7AEF: "\u4E24\u7AEF" }, list: { \u65E0\u5E8F\u5217\u8868: "\u65E0\u5E8F\u5217\u8868", \u6709\u5E8F\u5217\u8868: "\u6709\u5E8F\u5217\u8868" } }, panelMenus: { emoticon: { \u9ED8\u8BA4: "\u9ED8\u8BA4", \u65B0\u6D6A: "\u65B0\u6D6A", emoji: "emoji", \u624B\u52BF: "\u624B\u52BF" }, image: { \u4E0A\u4F20\u56FE\u7247: "\u4E0A\u4F20\u56FE\u7247", \u7F51\u7EDC\u56FE\u7247: "\u7F51\u7EDC\u56FE\u7247", \u56FE\u7247\u5730\u5740: "\u56FE\u7247\u5730\u5740", \u56FE\u7247\u6587\u5B57\u8BF4\u660E: "\u56FE\u7247\u6587\u5B57\u8BF4\u660E", \u8DF3\u8F6C\u94FE\u63A5: "\u8DF3\u8F6C\u94FE\u63A5" }, link: { \u94FE\u63A5: "\u94FE\u63A5", \u94FE\u63A5\u6587\u5B57: "\u94FE\u63A5\u6587\u5B57", \u53D6\u6D88\u94FE\u63A5: "\u53D6\u6D88\u94FE\u63A5", \u67E5\u770B\u94FE\u63A5: "\u67E5\u770B\u94FE\u63A5" }, video: { \u63D2\u5165\u89C6\u9891: "\u63D2\u5165\u89C6\u9891", \u4E0A\u4F20\u89C6\u9891: "\u4E0A\u4F20\u89C6\u9891" }, table: { \u884C: "\u884C", \u5217: "\u5217", \u7684: "\u7684", \u8868\u683C: "\u8868\u683C", \u6DFB\u52A0\u884C: "\u6DFB\u52A0\u884C", \u5220\u9664\u884C: "\u5220\u9664\u884C", \u6DFB\u52A0\u5217: "\u6DFB\u52A0\u5217", \u5220\u9664\u5217: "\u5220\u9664\u5217", \u8BBE\u7F6E\u8868\u5934: "\u8BBE\u7F6E\u8868\u5934", \u53D6\u6D88\u8868\u5934: "\u53D6\u6D88\u8868\u5934", \u63D2\u5165\u8868\u683C: "\u63D2\u5165\u8868\u683C", \u5220\u9664\u8868\u683C: "\u5220\u9664\u8868\u683C" }, code: { \u5220\u9664\u4EE3\u7801: "\u5220\u9664\u4EE3\u7801", \u4FEE\u6539\u4EE3\u7801: "\u4FEE\u6539\u4EE3\u7801", \u63D2\u5165\u4EE3\u7801: "\u63D2\u5165\u4EE3\u7801" } } }, validate: { \u5F20\u56FE\u7247: "\u5F20\u56FE\u7247", \u5927\u4E8E: "\u5927\u4E8E", \u56FE\u7247\u94FE\u63A5: "\u56FE\u7247\u94FE\u63A5", \u4E0D\u662F\u56FE\u7247: "\u4E0D\u662F\u56FE\u7247", \u8FD4\u56DE\u7ED3\u679C: "\u8FD4\u56DE\u7ED3\u679C", \u4E0A\u4F20\u56FE\u7247\u8D85\u65F6: "\u4E0A\u4F20\u56FE\u7247\u8D85\u65F6", \u4E0A\u4F20\u56FE\u7247\u9519\u8BEF: "\u4E0A\u4F20\u56FE\u7247\u9519\u8BEF", \u4E0A\u4F20\u56FE\u7247\u5931\u8D25: "\u4E0A\u4F20\u56FE\u7247\u5931\u8D25", \u63D2\u5165\u56FE\u7247\u9519\u8BEF: "\u63D2\u5165\u56FE\u7247\u9519\u8BEF", \u4E00\u6B21\u6700\u591A\u4E0A\u4F20: "\u4E00\u6B21\u6700\u591A\u4E0A\u4F20", \u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25: "\u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25", \u56FE\u7247\u9A8C\u8BC1\u672A\u901A\u8FC7: "\u56FE\u7247\u9A8C\u8BC1\u672A\u901A\u8FC7", \u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001: "\u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001", \u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF: "\u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF", \u8BF7\u66FF\u6362\u4E3A\u652F\u6301\u7684\u56FE\u7247\u7C7B\u578B: "\u8BF7\u66FF\u6362\u4E3A\u652F\u6301\u7684\u56FE\u7247\u7C7B\u578B", \u60A8\u63D2\u5165\u7684\u7F51\u7EDC\u56FE\u7247\u65E0\u6CD5\u8BC6\u522B: "\u60A8\u63D2\u5165\u7684\u7F51\u7EDC\u56FE\u7247\u65E0\u6CD5\u8BC6\u522B", \u60A8\u521A\u624D\u63D2\u5165\u7684\u56FE\u7247\u94FE\u63A5\u672A\u901A\u8FC7\u7F16\u8F91\u5668\u6821\u9A8C: "\u60A8\u521A\u624D\u63D2\u5165\u7684\u56FE\u7247\u94FE\u63A5\u672A\u901A\u8FC7\u7F16\u8F91\u5668\u6821\u9A8C", \u63D2\u5165\u89C6\u9891\u9519\u8BEF: "\u63D2\u5165\u89C6\u9891\u9519\u8BEF", \u89C6\u9891\u94FE\u63A5: "\u89C6\u9891\u94FE\u63A5", \u4E0D\u662F\u89C6\u9891: "\u4E0D\u662F\u89C6\u9891", \u89C6\u9891\u9A8C\u8BC1\u672A\u901A\u8FC7: "\u89C6\u9891\u9A8C\u8BC1\u672A\u901A\u8FC7", \u4E2A\u89C6\u9891: "\u4E2A\u89C6\u9891", \u4E0A\u4F20\u89C6\u9891\u8D85\u65F6: "\u4E0A\u4F20\u89C6\u9891\u8D85\u65F6", \u4E0A\u4F20\u89C6\u9891\u9519\u8BEF: "\u4E0A\u4F20\u89C6\u9891\u9519\u8BEF", \u4E0A\u4F20\u89C6\u9891\u5931\u8D25: "\u4E0A\u4F20\u89C6\u9891\u5931\u8D25", \u4E0A\u4F20\u89C6\u9891\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF: "\u4E0A\u4F20\u89C6\u9891\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF" } } }, en: { wangEditor: { \u91CD\u7F6E: "reset", \u63D2\u5165: "insert", \u9ED8\u8BA4: "default", \u521B\u5EFA: "create", \u4FEE\u6539: "edit", \u5982: "like", \u8BF7\u8F93\u5165\u6B63\u6587: "please enter the text", menus: { title: { \u6807\u9898: "head", \u52A0\u7C97: "bold", \u5B57\u53F7: "font size", \u5B57\u4F53: "font family", \u659C\u4F53: "italic", \u4E0B\u5212\u7EBF: "underline", \u5220\u9664\u7EBF: "strikethrough", \u7F29\u8FDB: "indent", \u884C\u9AD8: "line heihgt", \u6587\u5B57\u989C\u8272: "font color", \u80CC\u666F\u8272: "background", \u94FE\u63A5: "link", \u5E8F\u5217: "numbered list", \u5BF9\u9F50: "align", \u5F15\u7528: "quote", \u8868\u60C5: "emoticons", \u56FE\u7247: "image", \u89C6\u9891: "media", \u8868\u683C: "table", \u4EE3\u7801: "code", \u5206\u5272\u7EBF: "split line", \u6062\u590D: "undo", \u64A4\u9500: "redo", \u5168\u5C4F: "fullscreen", \u53D6\u6D88\u5168\u5C4F: "cancel fullscreen", \u5F85\u529E\u4E8B\u9879: "todo" }, dropListMenu: { \u8BBE\u7F6E\u6807\u9898: "title", \u80CC\u666F\u989C\u8272: "background", \u6587\u5B57\u989C\u8272: "font color", \u8BBE\u7F6E\u5B57\u53F7: "font size", \u8BBE\u7F6E\u5B57\u4F53: "font family", \u8BBE\u7F6E\u7F29\u8FDB: "indent", \u5BF9\u9F50\u65B9\u5F0F: "align", \u8BBE\u7F6E\u884C\u9AD8: "line heihgt", \u5E8F\u5217: "list", head: { \u6B63\u6587: "text" }, indent: { \u589E\u52A0\u7F29\u8FDB: "indent", \u51CF\u5C11\u7F29\u8FDB: "outdent" }, justify: { \u9760\u5DE6: "left", \u5C45\u4E2D: "center", \u9760\u53F3: "right", \u4E24\u7AEF: "justify" }, list: { \u65E0\u5E8F\u5217\u8868: "unordered", \u6709\u5E8F\u5217\u8868: "ordered" } }, panelMenus: { emoticon: { \u8868\u60C5: "emoji", \u624B\u52BF: "gesture" }, image: { \u4E0A\u4F20\u56FE\u7247: "upload image", \u7F51\u7EDC\u56FE\u7247: "network image", \u56FE\u7247\u5730\u5740: "image link", \u56FE\u7247\u6587\u5B57\u8BF4\u660E: "image alt", \u8DF3\u8F6C\u94FE\u63A5: "hyperlink" }, link: { \u94FE\u63A5: "link", \u94FE\u63A5\u6587\u5B57: "link text", \u53D6\u6D88\u94FE\u63A5: "unlink", \u67E5\u770B\u94FE\u63A5: "view links" }, video: { \u63D2\u5165\u89C6\u9891: "insert video", \u4E0A\u4F20\u89C6\u9891: "upload local video" }, table: { \u884C: "rows", \u5217: "columns", \u7684: " ", \u8868\u683C: "table", \u6DFB\u52A0\u884C: "insert row", \u5220\u9664\u884C: "delete row", \u6DFB\u52A0\u5217: "insert column", \u5220\u9664\u5217: "delete column", \u8BBE\u7F6E\u8868\u5934: "set header", \u53D6\u6D88\u8868\u5934: "cancel header", \u63D2\u5165\u8868\u683C: "insert table", \u5220\u9664\u8868\u683C: "delete table" }, code: { \u5220\u9664\u4EE3\u7801: "delete code", \u4FEE\u6539\u4EE3\u7801: "edit code", \u63D2\u5165\u4EE3\u7801: "insert code" } } }, validate: { \u5F20\u56FE\u7247: "images", \u5927\u4E8E: "greater than", \u56FE\u7247\u94FE\u63A5: "image link", \u4E0D\u662F\u56FE\u7247: "is not image", \u8FD4\u56DE\u7ED3\u679C: "return results", \u4E0A\u4F20\u56FE\u7247\u8D85\u65F6: "upload image timeout", \u4E0A\u4F20\u56FE\u7247\u9519\u8BEF: "upload image error", \u4E0A\u4F20\u56FE\u7247\u5931\u8D25: "upload image failed", \u63D2\u5165\u56FE\u7247\u9519\u8BEF: "insert image error", \u4E00\u6B21\u6700\u591A\u4E0A\u4F20: "once most at upload", \u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25: "download link failed", \u56FE\u7247\u9A8C\u8BC1\u672A\u901A\u8FC7: "image validate failed", \u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001: "server return status", \u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF: "upload image return results error", \u8BF7\u66FF\u6362\u4E3A\u652F\u6301\u7684\u56FE\u7247\u7C7B\u578B: "please replace with a supported image type", \u60A8\u63D2\u5165\u7684\u7F51\u7EDC\u56FE\u7247\u65E0\u6CD5\u8BC6\u522B: "the network picture you inserted is not recognized", \u60A8\u521A\u624D\u63D2\u5165\u7684\u56FE\u7247\u94FE\u63A5\u672A\u901A\u8FC7\u7F16\u8F91\u5668\u6821\u9A8C: "the image link you just inserted did not pass the editor verification", \u63D2\u5165\u89C6\u9891\u9519\u8BEF: "insert video error", \u89C6\u9891\u94FE\u63A5: "video link", \u4E0D\u662F\u89C6\u9891: "is not video", \u89C6\u9891\u9A8C\u8BC1\u672A\u901A\u8FC7: "video validate failed", \u4E2A\u89C6\u9891: "videos", \u4E0A\u4F20\u89C6\u9891\u8D85\u65F6: "upload video timeout", \u4E0A\u4F20\u89C6\u9891\u9519\u8BEF: "upload video error", \u4E0A\u4F20\u89C6\u9891\u5931\u8D25: "upload video failed", \u4E0A\u4F20\u89C6\u9891\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF: "upload video return results error" } } } } };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(6);
      function c() {
        return !!(p.UA.isIE() || p.UA.isOldEdge);
      }
      l.default = { compatibleMode: c, historyMaxSize: 30 };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(7);
      l.default = {
        onlineVideoCheck: function (v) {
          return !0;
        },
        onlineVideoCallback: p.EMPTY_FN,
        showLinkVideo: !0,
        uploadVideoAccept: ["mp4"],
        uploadVideoServer: "",
        uploadVideoMaxSize: 1 * 1024 * 1024 * 1024,
        uploadVideoName: "",
        uploadVideoParams: {},
        uploadVideoParamsWithUrl: !1,
        uploadVideoHeaders: {},
        uploadVideoHooks: {},
        uploadVideoTimeout: 1e3 * 60 * 60 * 2,
        withVideoCredentials: !1,
        customUploadVideo: null,
        customInsertVideo: null
      };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(17));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = n(6), y = n(7), E = function () {
        function w(h) {
          this._currentRange = null, this.editor = h;
        }
        return w.prototype.getRange = function () {
          return this._currentRange;
        }, w.prototype.saveRange = function (h) {
          if (h) {
            this._currentRange = h;
            return;
          }
          var m = window.getSelection();
          if (m.rangeCount !== 0) {
            var I = m.getRangeAt(0), D = this.getSelectionContainerElem(I);
            if (!!(D != null && D.length) && !(D.attr("contenteditable") === "false" || D.parentUntil("[contenteditable=false]"))) {
              var g = this.editor, S = g.$textElem;
              if (S.isContain(D)) {
                if (S.elems[0] === D.elems[0]) {
                  var x;
                  if ((0, p.default)(x = S.html()).call(x) === y.EMPTY_P) {
                    var R = S.children(), N = R == null ? void 0 : R.last();
                    g.selection.createRangeByElem(N, !0, !0), g.selection.restoreSelection();
                  }
                }
                this._currentRange = I;
              }
            }
          }
        }, w.prototype.collapseRange = function (h) {
          h === void 0 && (h = !1);
          var m = this._currentRange;
          m && m.collapse(h);
        }, w.prototype.getSelectionText = function () {
          var h = this._currentRange;
          return h ? h.toString() : "";
        }, w.prototype.getSelectionContainerElem = function (h) {
          var m;
          m = h || this._currentRange;
          var I;
          if (m)
            return I = m.commonAncestorContainer, v.default(I.nodeType === 1 ? I : I.parentNode);
        }, w.prototype.getSelectionStartElem = function (h) {
          var m;
          m = h || this._currentRange;
          var I;
          if (m)
            return I = m.startContainer, v.default(I.nodeType === 1 ? I : I.parentNode);
        }, w.prototype.getSelectionEndElem = function (h) {
          var m;
          m = h || this._currentRange;
          var I;
          if (m)
            return I = m.endContainer, v.default(I.nodeType === 1 ? I : I.parentNode);
        }, w.prototype.isSelectionEmpty = function () {
          var h = this._currentRange;
          return !!(h && h.startContainer && h.startContainer === h.endContainer && h.startOffset === h.endOffset);
        }, w.prototype.restoreSelection = function () {
          var h = window.getSelection(), m = this._currentRange;
          h && m && (h.removeAllRanges(), h.addRange(m));
        }, w.prototype.createEmptyRange = function () {
          var h = this.editor, m = this.getRange(), I;
          if (!!m && !!this.isSelectionEmpty())
            try {
              b.UA.isWebkit() ? (h.cmd.do("insertHTML", "&#8203;"), m.setEnd(m.endContainer, m.endOffset + 1), this.saveRange(m)) : (I = v.default("<strong>&#8203;</strong>"), h.cmd.do("insertElem", I), this.createRangeByElem(I, !0));
            } catch {
            }
        }, w.prototype.createRangeByElems = function (h, m) {
          var I = window.getSelection ? window.getSelection() : document.getSelection();
          I == null || I.removeAllRanges();
          var D = document.createRange();
          D.setStart(h, 0), D.setEnd(m, m.childNodes.length || 1), this.saveRange(D), this.restoreSelection();
        }, w.prototype.createRangeByElem = function (h, m, I) {
          if (!!h.length) {
            var D = h.elems[0], g = document.createRange();
            I ? g.selectNodeContents(D) : g.selectNode(D), m != null && (g.collapse(m), m || (this.saveRange(g), this.editor.selection.moveCursor(D))), this.saveRange(g);
          }
        }, w.prototype.getSelectionRangeTopNodes = function () {
          var h, m, I, D = (h = this.getSelectionStartElem()) === null || h === void 0 ? void 0 : h.getNodeTop(this.editor), g = (m = this.getSelectionEndElem()) === null || m === void 0 ? void 0 : m.getNodeTop(this.editor);
          return I = this.recordSelectionNodes(v.default(D), v.default(g)), I;
        }, w.prototype.moveCursor = function (h, m) {
          var I, D = this.getRange(), g = h.nodeType === 3 ? (I = h.nodeValue) === null || I === void 0 ? void 0 : I.length : h.childNodes.length;
          (b.UA.isFirefox || b.UA.isIE()) && g !== 0 && (h.nodeType === 3 || h.childNodes[g - 1].nodeName === "BR") && (g = g - 1);
          var S = m != null ? m : g;
          !D || h && (D.setStart(h, S), D.setEnd(h, S), this.restoreSelection());
        }, w.prototype.getCursorPos = function () {
          var h = window.getSelection();
          return h == null ? void 0 : h.anchorOffset;
        }, w.prototype.clearWindowSelectionRange = function () {
          var h = window.getSelection();
          h && h.removeAllRanges();
        }, w.prototype.recordSelectionNodes = function (h, m) {
          var I = [], D = !0;
          try {
            for (var g = h, S = this.editor.$textElem; D;) {
              var x = g == null ? void 0 : g.getNodeTop(this.editor);
              x.getNodeName() === "BODY" && (D = !1), x.length > 0 && (I.push(v.default(g)), (m == null ? void 0 : m.equal(x)) || S.equal(x) ? D = !1 : g = x.getNextSibling());
            }
          } catch {
            D = !1;
          }
          return I;
        }, w.prototype.setRangeToElem = function (h) {
          var m = this.getRange();
          m == null || m.setStart(h, 0), m == null || m.setEnd(h, 0);
        }, w;
      }();
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = function () {
        function b(y) {
          this.editor = y;
        }
        return b.prototype.do = function (y, E) {
          var w = this.editor;
          w.config.styleWithCSS && document.execCommand("styleWithCSS", !1, "true");
          var h = w.selection;
          if (!!h.getRange()) {
            switch (h.restoreSelection(), y) {
              case "insertHTML":
                this.insertHTML(E);
                break;
              case "insertElem":
                this.insertElem(E);
                break;
              default:
                this.execCommand(y, E);
                break;
            }
            w.menus.changeActive(), h.saveRange(), h.restoreSelection();
          }
        }, b.prototype.insertHTML = function (y) {
          var E = this.editor, w = E.selection.getRange();
          if (w != null) {
            if (this.queryCommandSupported("insertHTML"))
              this.execCommand("insertHTML", y);
            else if (w.insertNode) {
              if (w.deleteContents(), c.default(y).elems.length > 0)
                w.insertNode(c.default(y).elems[0]);
              else {
                var h = document.createElement("p");
                h.appendChild(document.createTextNode(y)), w.insertNode(h);
              }
              E.selection.collapseRange();
            }
          }
        }, b.prototype.insertElem = function (y) {
          var E = this.editor, w = E.selection.getRange();
          w != null && w.insertNode && (w.deleteContents(), w.insertNode(y.elems[0]));
        }, b.prototype.execCommand = function (y, E) {
          document.execCommand(y, !1, E);
        }, b.prototype.queryCommandValue = function (y) {
          return document.queryCommandValue(y);
        }, b.prototype.queryCommandState = function (y) {
          return document.queryCommandState(y);
        }, b.prototype.queryCommandSupported = function (y) {
          return document.queryCommandSupported(y);
        }, b;
      }();
      l.default = v;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(31)), c = u(n(4)), v = u(n(17)), b = u(n(27)), y = u(n(46));
      (0, f.default)(l, "__esModule", { value: !0 });
      var E = n(2), w = E.__importDefault(n(3)), h = E.__importDefault(n(287)), m = n(6), I = E.__importDefault(n(299)), D = E.__importDefault(n(300)), g = n(7), S = function () {
        function x(R) {
          this.editor = R, this.eventHooks = { onBlurEvents: [], changeEvents: [], dropEvents: [], clickEvents: [], keydownEvents: [], keyupEvents: [], tabUpEvents: [], tabDownEvents: [], enterUpEvents: [], enterDownEvents: [], deleteUpEvents: [], deleteDownEvents: [], pasteEvents: [], linkClickEvents: [], codeClickEvents: [], textScrollEvents: [], toolbarClickEvents: [], imgClickEvents: [], imgDragBarMouseDownEvents: [], tableClickEvents: [], menuClickEvents: [], dropListMenuHoverEvents: [], splitLineEvents: [], videoClickEvents: [] };
        }
        return x.prototype.init = function () {
          this._saveRange(), this._bindEventHooks(), h.default(this);
        }, x.prototype.togglePlaceholder = function () {
          var R, N = this.html(), T = (0, p.default)(R = this.editor.$textContainerElem).call(R, ".placeholder");
          T.hide(), !this.editor.isComposing && (!N || N === " ") && T.show();
        }, x.prototype.clear = function () {
          this.html(g.EMPTY_P);
        }, x.prototype.html = function (R) {
          var N = this.editor, T = N.$textElem;
          if (R == null) {
            var H = T.html();
            H = H.replace(/\u200b/gm, ""), H = H.replace(/<p><\/p>/gim, ""), H = H.replace(g.EMPTY_P_LAST_REGEX, ""), H = H.replace(g.EMPTY_P_REGEX, "<p>");
            var B = H.match(/<(img|br|hr|input)[^>]*>/gi);
            return B !== null && (0, c.default)(B).call(B, function (L) {
              L.match(/\/>/) || (H = H.replace(L, L.substring(0, L.length - 1) + "/>"));
            }), H;
          }
          R = (0, v.default)(R).call(R), R === "" && (R = g.EMPTY_P), (0, b.default)(R).call(R, "<") !== 0 && (R = "<p>" + R + "</p>"), T.html(R), N.initSelection();
        }, x.prototype.setJSON = function (R) {
          var N = D.default(R).children(), T = this.editor, H = T.$textElem;
          !N || H.replaceChildAll(N);
        }, x.prototype.getJSON = function () {
          var R = this.editor, N = R.$textElem;
          return I.default(N);
        }, x.prototype.text = function (R) {
          var N = this.editor, T = N.$textElem;
          if (R == null) {
            var H = T.text();
            return H = H.replace(/\u200b/gm, ""), H;
          }
          T.text("<p>" + R + "</p>"), N.initSelection();
        }, x.prototype.append = function (R) {
          var N = this.editor;
          (0, b.default)(R).call(R, "<") !== 0 && (R = "<p>" + R + "</p>"), this.html(this.html() + R), N.initSelection();
        }, x.prototype._saveRange = function () {
          var R = this.editor, N = R.$textElem, T = w.default(document);
          function H() {
            R.selection.saveRange(), R.menus.changeActive();
          }
          N.on("keyup", H);
          function B() {
            H(), N.off("click", B);
          }
          N.on("click", B);
          function L() {
            H(), T.off("mouseup", L);
          }
          function P() {
            T.on("mouseup", L), N.off("mouseleave", P);
          }
          N.on("mousedown", function () {
            N.on("mouseleave", P);
          }), N.on("mouseup", function (C) {
            N.off("mouseleave", P), (0, y.default)(function () {
              var M = R.selection, k = M.getRange();
              k !== null && H();
            }, 0);
          });
        }, x.prototype._bindEventHooks = function () {
          var R = this.editor, N = R.$textElem, T = this.eventHooks;
          N.on("click", function (B) {
            var L = T.clickEvents;
            (0, c.default)(L).call(L, function (P) {
              return P(B);
            });
          }), N.on("keyup", function (B) {
            if (B.keyCode === 13) {
              var L = T.enterUpEvents;
              (0, c.default)(L).call(L, function (P) {
                return P(B);
              });
            }
          }), N.on("keyup", function (B) {
            var L = T.keyupEvents;
            (0, c.default)(L).call(L, function (P) {
              return P(B);
            });
          }), N.on("keydown", function (B) {
            var L = T.keydownEvents;
            (0, c.default)(L).call(L, function (P) {
              return P(B);
            });
          }), N.on("keyup", function (B) {
            if (!(B.keyCode !== 8 && B.keyCode !== 46)) {
              var L = T.deleteUpEvents;
              (0, c.default)(L).call(L, function (P) {
                return P(B);
              });
            }
          }), N.on("keydown", function (B) {
            if (!(B.keyCode !== 8 && B.keyCode !== 46)) {
              var L = T.deleteDownEvents;
              (0, c.default)(L).call(L, function (P) {
                return P(B);
              });
            }
          }), N.on("paste", function (B) {
            if (!m.UA.isIE()) {
              B.preventDefault();
              var L = T.pasteEvents;
              (0, c.default)(L).call(L, function (P) {
                return P(B);
              });
            }
          }), N.on("keydown", function (B) {
            (R.isFocus || R.isCompatibleMode) && (B.ctrlKey || B.metaKey) && B.keyCode === 90 && (B.preventDefault(), B.shiftKey ? R.history.restore() : R.history.revoke());
          }), N.on("keyup", function (B) {
            if (B.keyCode === 9) {
              B.preventDefault();
              var L = T.tabUpEvents;
              (0, c.default)(L).call(L, function (P) {
                return P(B);
              });
            }
          }), N.on("keydown", function (B) {
            if (B.keyCode === 9) {
              B.preventDefault();
              var L = T.tabDownEvents;
              (0, c.default)(L).call(L, function (P) {
                return P(B);
              });
            }
          }), N.on(
            "scroll",
            m.throttle(function (B) {
              var L = T.textScrollEvents;
              (0, c.default)(L).call(L, function (P) {
                return P(B);
              });
            }, 100)
          );
          function H(B) {
            B.preventDefault();
          }
          w.default(document).on("dragleave", H).on("drop", H).on("dragenter", H).on("dragover", H), R.beforeDestroy(function () {
            w.default(document).off("dragleave", H).off("drop", H).off("dragenter", H).off("dragover", H);
          }), N.on("drop", function (B) {
            B.preventDefault();
            var L = T.dropEvents;
            (0, c.default)(L).call(L, function (P) {
              return P(B);
            });
          }), N.on("click", function (B) {
            var L = null, P = B.target, C = w.default(P);
            if (C.getNodeName() === "A")
              L = C;
            else {
              var M = C.parentUntil("a");
              M != null && (L = M);
            }
            if (!!L) {
              var k = T.linkClickEvents;
              (0, c.default)(k).call(k, function (F) {
                return F(L);
              });
            }
          }), N.on("click", function (B) {
            var L = null, P = B.target, C = w.default(P);
            if (C.getNodeName() === "IMG" && !C.elems[0].getAttribute("data-emoji") && (B.stopPropagation(), L = C), !!L) {
              var M = T.imgClickEvents;
              (0, c.default)(M).call(M, function (k) {
                return k(L);
              });
            }
          }), N.on("click", function (B) {
            var L = null, P = B.target, C = w.default(P);
            if (C.getNodeName() === "PRE")
              L = C;
            else {
              var M = C.parentUntil("pre");
              M !== null && (L = M);
            }
            if (!!L) {
              var k = T.codeClickEvents;
              (0, c.default)(k).call(k, function (F) {
                return F(L);
              });
            }
          }), N.on("click", function (B) {
            var L = null, P = B.target, C = w.default(P);
            if (C.getNodeName() === "HR" && (L = C), !!L) {
              R.selection.createRangeByElem(L), R.selection.restoreSelection();
              var M = T.splitLineEvents;
              (0, c.default)(M).call(M, function (k) {
                return k(L);
              });
            }
          }), R.$toolbarElem.on("click", function (B) {
            var L = T.toolbarClickEvents;
            (0, c.default)(L).call(L, function (P) {
              return P(B);
            });
          }), R.$textContainerElem.on("mousedown", function (B) {
            var L = B.target, P = w.default(L);
            if (P.hasClass("w-e-img-drag-rb")) {
              var C = T.imgDragBarMouseDownEvents;
              (0, c.default)(C).call(C, function (M) {
                return M();
              });
            }
          }), N.on("click", function (B) {
            var L = null, P = B.target;
            if (L = w.default(P).parentUntilEditor("TABLE", R, P), !!L) {
              var C = T.tableClickEvents;
              (0, c.default)(C).call(C, function (M) {
                return M(L, B);
              });
            }
          }), N.on("keydown", function (B) {
            if (B.keyCode === 13) {
              var L = T.enterDownEvents;
              (0, c.default)(L).call(L, function (P) {
                return P(B);
              });
            }
          }), N.on("click", function (B) {
            var L = null, P = B.target, C = w.default(P);
            if (C.getNodeName() === "VIDEO" && (B.stopPropagation(), L = C), !!L) {
              var M = T.videoClickEvents;
              (0, c.default)(M).call(M, function (k) {
                return k(L);
              });
            }
          });
        }, x;
      }();
      l.default = S;
    }, function (i, l, n) {
      var u = n(284);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(285), f = Array.prototype;
      i.exports = function (p) {
        var c = p.find;
        return p === f || p instanceof Array && c === f.find ? u : c;
      };
    }, function (i, l, n) {
      n(286);
      var u = n(15);
      i.exports = u("Array").find;
    }, function (i, l, n) {
      var u = n(5), f = n(30).find, p = n(82), c = n(22), v = "find", b = !0, y = c(v);
      v in [] && Array(1)[v](function () {
        b = !1;
      }), u({ target: "Array", proto: !0, forced: b || !y }, {
        find: function (w) {
          return f(this, w, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), p(v);
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(288)), v = p.__importStar(n(289)), b = p.__importDefault(n(290)), y = p.__importDefault(n(291)), E = p.__importDefault(n(298));
      function w(h) {
        var m = h.editor, I = h.eventHooks;
        c.default(m, I.enterUpEvents, I.enterDownEvents), v.default(m, I.deleteUpEvents, I.deleteDownEvents), v.cutToKeepP(m, I.keyupEvents), b.default(m, I.tabDownEvents), y.default(m, I.pasteEvents), E.default(m, I.imgClickEvents);
      }
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(27));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = n(7), b = c.__importDefault(n(3));
      function y(E, w, h) {
        function m(g) {
          var S, x = b.default(v.EMPTY_P);
          if (x.insertBefore(g), (0, p.default)(S = g.html()).call(S, "<img") >= 0) {
            x.remove();
            return;
          }
          E.selection.createRangeByElem(x, !0, !0), E.selection.restoreSelection(), g.remove();
        }
        function I() {
          var g = E.$textElem, S = E.selection.getSelectionContainerElem(), x = S.parent();
          if (x.html() === "<code><br></code>") {
            m(x);
            return;
          }
          if (S.getNodeName() === "FONT" && S.text() === "" && S.attr("face") === "monospace") {
            m(x);
            return;
          }
          if (!!x.equal(g)) {
            var R = S.getNodeName();
            R === "P" && S.attr("data-we-empty-p") === null || S.text() || m(S);
          }
        }
        w.push(I);
        function D(g) {
          var S;
          E.selection.saveRange((S = getSelection()) === null || S === void 0 ? void 0 : S.getRangeAt(0));
          var x = E.selection.getSelectionContainerElem();
          x.id === E.textElemId && (g.preventDefault(), E.cmd.do("insertHTML", "<p><br></p>"));
        }
        h.push(D);
      }
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(17)), c = u(n(44));
      (0, f.default)(l, "__esModule", { value: !0 }), l.cutToKeepP = void 0;
      var v = n(2), b = n(7), y = v.__importDefault(n(3));
      function E(h, m, I) {
        function D() {
          var S = h.$textElem, x = h.$textElem.html(), R = h.$textElem.text(), N = (0, p.default)(x).call(x), T = ["<p><br></p>", "<br>", '<p data-we-empty-p=""></p>', b.EMPTY_P];
          /^\s*$/.test(R) && (!N || (0, c.default)(T).call(T, N)) && (S.html(b.EMPTY_P), h.selection.createRangeByElem(S, !1, !0), h.selection.restoreSelection(), h.selection.moveCursor(S.getNode(), 0));
        }
        m.push(D);
        function g(S) {
          var x, R = h.$textElem, N = (0, p.default)(x = R.html().toLowerCase()).call(x);
          if (N === b.EMPTY_P) {
            S.preventDefault();
            return;
          }
        }
        I.push(g);
      }
      function w(h, m) {
        function I(D) {
          var g;
          if (D.keyCode === 88) {
            var S = h.$textElem, x = (0, p.default)(g = S.html().toLowerCase()).call(g);
            if (!x || x === "<br>") {
              var R = y.default(b.EMPTY_P);
              S.html(" "), S.append(R), h.selection.createRangeByElem(R, !1, !0), h.selection.restoreSelection(), h.selection.moveCursor(R.getNode(), 0);
            }
          }
        }
        m.push(I);
      }
      l.cutToKeepP = w, l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      function p(c, v) {
        function b() {
          if (!!c.cmd.queryCommandSupported("insertHTML")) {
            var y = c.selection.getSelectionContainerElem();
            if (!!y) {
              var E = y.parent(), w = y.getNodeName(), h = E.getNodeName();
              w == "CODE" || h === "CODE" || h === "PRE" || /hljs/.test(h) ? c.cmd.do("insertHTML", c.config.languageTab) : c.cmd.do("insertHTML", "&nbsp;&nbsp;&nbsp;&nbsp;");
            }
          }
        }
        v.push(b);
      }
      l.default = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(17));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(130), v = n(6), b = n(7);
      function y(I) {
        var D, g = (0, p.default)(D = I.replace(/<div>/gim, "<p>").replace(/<\/div>/gim, "</p>")).call(D), S = document.createElement("div");
        return S.innerHTML = g, S.innerHTML.replace(/<p><\/p>/gim, "");
      }
      function E(I) {
        var D = I.replace(/<br>|<br\/>/gm, `
`).replace(/<[^>]+>/gm, "");
        return D;
      }
      function w(I) {
        var D;
        if (I === "")
          return !1;
        var g = document.createElement("div");
        return g.innerHTML = I, ((D = g.firstChild) === null || D === void 0 ? void 0 : D.nodeName) === "P";
      }
      function h(I) {
        if (!(I != null && I.length))
          return !1;
        var D = I.elems[0];
        return D.nodeName === "P" && D.innerHTML === "<br>";
      }
      function m(I, D) {
        function g(S) {
          var x = I.config, R = x.pasteFilterStyle, N = x.pasteIgnoreImg, T = x.pasteTextHandle, H = c.getPasteHtml(S, R, N), B = c.getPasteText(S);
          B = B.replace(/\n/gm, "<br>");
          var L = I.selection.getSelectionContainerElem();
          if (!!L) {
            var P = L == null ? void 0 : L.getNodeName(), C = L == null ? void 0 : L.getNodeTop(I), M = "";
            if (C.elems[0] && (M = C == null ? void 0 : C.getNodeName()), P === "CODE" || M === "PRE") {
              T && v.isFunction(T) && (B = "" + (T(B) || "")), I.cmd.do("insertHTML", E(B));
              return;
            }
            if (b.urlRegex.test(B) && R) {
              T && v.isFunction(T) && (B = "" + (T(B) || ""));
              var k = b.urlRegex.exec(B)[0], F = B.replace(b.urlRegex, "");
              return I.cmd.do("insertHTML", '<a href="' + k + '" target="_blank">' + k + "</a>" + F);
            }
            if (!!H)
              try {
                T && v.isFunction(T) && (H = "" + (T(H) || ""));
                var j = /[\.\#\@]?\w+[ ]+\{[^}]*\}/.test(H);
                if (j && R)
                  I.cmd.do("insertHTML", "" + y(B));
                else {
                  var W = y(H);
                  if (w(W)) {
                    var Q = I.$textElem;
                    if (I.cmd.do("insertHTML", W), Q.equal(L)) {
                      I.selection.createEmptyRange();
                      return;
                    }
                    h(C) && C.remove();
                  } else {
                    var ne = /^<img [^>]*src=['"]([^'"]+)[^>]*>$/g;
                    ne.test(W) || I.cmd.do("insertHTML", W);
                  }
                }
              } catch {
                T && v.isFunction(T) && (B = "" + (T(B) || "")), I.cmd.do("insertHTML", "" + y(B));
              }
          }
        }
        D.push(g);
      }
      l.default = m;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(17)), c = u(n(4)), v = u(n(44));
      (0, f.default)(l, "__esModule", { value: !0 });
      var b = n(2), y = n(293), E = b.__importDefault(n(297));
      function w(g) {
        var S = /<span>.*?<\/span>/gi, x = /<span>(.*?)<\/span>/;
        return g.replace(S, function (R) {
          var N = R.match(x);
          return N == null ? "" : N[1];
        });
      }
      function h(g, S) {
        var x;
        return g = (0, p.default)(x = g.toLowerCase()).call(x), !!(y.IGNORE_TAGS.has(g) || S && g === "img");
      }
      function m(g, S) {
        var x = "";
        x = "<" + g;
        var R = [];
        (0, c.default)(S).call(S, function (T) {
          R.push(T.name + '="' + T.value + '"');
        }), R.length > 0 && (x = x + " " + R.join(" "));
        var N = y.EMPTY_TAGS.has(g);
        return x = x + (N ? "/" : "") + ">", x;
      }
      function I(g) {
        return "</" + g + ">";
      }
      function D(g, S, x) {
        S === void 0 && (S = !0), x === void 0 && (x = !1);
        var R = [], N = "";
        function T(P) {
          P = (0, p.default)(P).call(P), P && (y.EMPTY_TAGS.has(P) || (N = P));
        }
        function H() {
          N = "";
        }
        var B = new E.default();
        B.parse(g, {
          startElement: function (C, M) {
            if (T(C), !h(C, x)) {
              var k = y.NECESSARY_ATTRS.get(C) || [], F = [];
              (0, c.default)(M).call(M, function (W) {
                var Q = W.name;
                if (Q === "style") {
                  S || F.push(W);
                  return;
                }
                (0, v.default)(k).call(k, Q) !== !1 && F.push(W);
              });
              var j = m(C, F);
              R.push(j);
            }
          }, characters: function (C) {
            !C || h(N, x) || R.push(C);
          }, endElement: function (C) {
            if (!h(C, x)) {
              var M = I(C);
              R.push(M), H();
            }
          }, comment: function (C) {
            T(C);
          }
        });
        var L = R.join("");
        return L = w(L), L;
      }
      l.default = D;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(131)), c = u(n(120));
      (0, f.default)(l, "__esModule", { value: !0 }), l.TOP_LEVEL_TAGS = l.EMPTY_TAGS = l.NECESSARY_ATTRS = l.IGNORE_TAGS = void 0, l.IGNORE_TAGS = new p.default(["doctype", "!doctype", "html", "head", "meta", "body", "script", "style", "link", "frame", "iframe", "title", "svg", "center", "o:p"]), l.NECESSARY_ATTRS = new c.default([["img", ["src", "alt"]], ["a", ["href", "target"]], ["td", ["colspan", "rowspan"]], ["th", ["colspan", "rowspan"]]]), l.EMPTY_TAGS = new p.default(["area", "base", "basefont", "br", "col", "hr", "img", "input", "isindex", "embed"]), l.TOP_LEVEL_TAGS = new p.default(["h1", "h2", "h3", "h4", "h5", "p", "ul", "ol", "table", "blockquote", "pre", "hr", "form"]);
    }, function (i, l, n) {
      var u = n(295);
      i.exports = u;
    }, function (i, l, n) {
      n(296), n(61), n(50), n(54);
      var u = n(9);
      i.exports = u.Set;
    }, function (i, l, n) {
      var u = n(121), f = n(123);
      i.exports = u("Set", function (p) {
        return function () {
          return p(this, arguments.length ? arguments[0] : void 0);
        };
      }, f);
    }, function (i, l) {
      function n() {
      }
      n.prototype = {
        handler: null,
        startTagRe: /^<([^>\s\/]+)((\s+[^=>\s]+(\s*=\s*((\"[^"]*\")|(\'[^']*\')|[^>\s]+))?)*)\s*\/?\s*>/m,
        endTagRe: /^<\/([^>\s]+)[^>]*>/m,
        attrRe: /([^=\s]+)(\s*=\s*((\"([^"]*)\")|(\'([^']*)\')|[^>\s]+))?/gm,
        parse: function (f, p) {
          p && (this.contentHandler = p);
          for (var c, v, b, y = !1, E = this; f.length > 0;)
            f.substring(0, 4) == "<!--" ? (b = f.indexOf("-->"), b != -1 ? (this.contentHandler.comment(f.substring(4, b)), f = f.substring(b + 3), y = !1) : y = !0) : f.substring(0, 2) == "</" ? this.endTagRe.test(f) ? (c = RegExp.lastMatch, v = RegExp.rightContext, c.replace(this.endTagRe, function () {
              return E.parseEndTag.apply(E, arguments);
            }), f = v, y = !1) : y = !0 : f.charAt(0) == "<" && (this.startTagRe.test(f) ? (c = RegExp.lastMatch, v = RegExp.rightContext, c.replace(this.startTagRe, function () {
              return E.parseStartTag.apply(E, arguments);
            }), f = v, y = !1) : y = !0), y && (b = f.indexOf("<"), b == -1 ? (this.contentHandler.characters(f), f = "") : (this.contentHandler.characters(f.substring(0, b)), f = f.substring(b))), y = !0;
        },
        parseStartTag: function (f, p, c) {
          var v = this.parseAttributes(p, c);
          this.contentHandler.startElement(p, v);
        },
        parseEndTag: function (f, p) {
          this.contentHandler.endElement(p);
        },
        parseAttributes: function (f, p) {
          var c = this, v = [];
          return p.replace(this.attrRe, function (b, y, E, w, h, m, I, D) {
            v.push(c.parseAttribute(f, b, y, E, w, h, m, I, D));
          }), v;
        },
        parseAttribute: function (f, p, c) {
          var v = "";
          arguments[7] ? v = arguments[8] : arguments[5] ? v = arguments[6] : arguments[3] && (v = arguments[4]);
          var b = !v && !arguments[3];
          return { name: c, value: b ? null : v };
        }
      }, i.exports = n;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      function p(c, v) {
        function b(y) {
          c.selection.createRangeByElem(y), c.selection.restoreSelection();
        }
        v.push(b);
      }
      l.default = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = n(6), b = c.__importDefault(n(3));
      function y(E) {
        var w = [], h = E.childNodes() || [];
        return (0, p.default)(h).call(h, function (m) {
          var I, D = m.nodeType;
          if (D === 3 && (I = m.textContent || "", I = v.replaceHtmlSymbol(I)), D === 1) {
            I = {}, I = I, I.tag = m.nodeName.toLowerCase();
            for (var g = [], S = m.attributes, x = S.length || 0, R = 0; R < x; R++) {
              var N = S[R];
              g.push({ name: N.name, value: N.value });
            }
            I.attrs = g, I.children = y(b.default(m));
          }
          I && w.push(I);
        }), w;
      }
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(92)), p = u(n(1)), c = u(n(4));
      (0, p.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(3));
      function y(E, w) {
        w === void 0 && (w = document.createElement("div"));
        var h = w;
        return (0, c.default)(E).call(E, function (m) {
          var I;
          if (typeof m == "string" && (I = document.createTextNode(m)), (0, f.default)(m) === "object") {
            var D;
            I = document.createElement(m.tag), (0, c.default)(D = m.attrs).call(D, function (g) {
              b.default(I).attr(g.name, g.value);
            }), m.children && m.children.length > 0 && y(m.children, I.getRootNode());
          }
          I && h.appendChild(I);
        }), b.default(h);
      }
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(89)), c = u(n(70)), v = u(n(44)), b = u(n(302)), y = u(n(4)), E = u(n(94)), w = u(n(132)), h = u(n(46)), m = u(n(57));
      (0, f.default)(l, "__esModule", { value: !0 });
      var I = n(2), D = I.__importDefault(n(87)), g = I.__importDefault(n(314)), S = I.__importDefault(n(3)), x = function () {
        function R(N) {
          this.editor = N, this.menuList = [], this.constructorList = g.default;
        }
        return R.prototype.extend = function (N, T) {
          !T || typeof T != "function" || (this.constructorList[N] = T);
        }, R.prototype.init = function () {
          var N, T, H = this, B = this.editor.config, L = B.excludeMenus;
          (0, p.default)(L) === !1 && (L = []), B.menus = (0, c.default)(N = B.menus).call(N, function (Q) {
            return (0, v.default)(L).call(L, Q) === !1;
          });
          var P = (0, b.default)(D.default.globalCustomMenuConstructorList);
          P = (0, c.default)(P).call(P, function (Q) {
            return (0, v.default)(L).call(L, Q);
          }), (0, y.default)(P).call(P, function (Q) {
            delete D.default.globalCustomMenuConstructorList[Q];
          }), (0, y.default)(T = B.menus).call(T, function (Q) {
            var ne = H.constructorList[Q];
            H._initMenuList(Q, ne);
          });
          for (var C = 0, M = (0, E.default)(D.default.globalCustomMenuConstructorList); C < M.length; C++) {
            var k = M[C], F = k[0], j = k[1], W = j;
            this._initMenuList(F, W);
          }
          this._addToToolbar(), B.showMenuTooltips && this._bindMenuTooltips();
        }, R.prototype._initMenuList = function (N, T) {
          var H;
          if (!(T == null || typeof T != "function"))
            if ((0, w.default)(H = this.menuList).call(H, function (L) {
              return L.key === N;
            }))
              console.warn("\u83DC\u5355\u540D\u79F0\u91CD\u590D:" + N);
            else {
              var B = new T(this.editor);
              B.key = N, this.menuList.push(B);
            }
        }, R.prototype._bindMenuTooltips = function () {
          var N = this.editor, T = N.$toolbarElem, H = N.config, B = H.menuTooltipPosition, L = S.default('<div class="w-e-menu-tooltip w-e-menu-tooltip-' + B + `">
            <div class="w-e-menu-tooltip-item-wrapper">
              <div></div>
            </div>
          </div>`);
          L.css("visibility", "hidden"), T.append(L), L.css("z-index", N.zIndex.get("tooltip"));
          var P = 0;
          function C() {
            P && clearTimeout(P);
          }
          function M() {
            C(), L.css("visibility", "hidden");
          }
          T.on("mouseover", function (k) {
            var F = k.target, j = S.default(F), W, Q;
            if (j.isContain(T)) {
              M();
              return;
            }
            if (j.parentUntil(".w-e-droplist") != null)
              M();
            else if (j.attr("data-title"))
              W = j.attr("data-title"), Q = j;
            else {
              var ne = j.parentUntil(".w-e-menu");
              ne != null && (W = ne.attr("data-title"), Q = ne);
            }
            if (W && Q) {
              C();
              var te = Q.getOffsetData();
              L.text(N.i18next.t("menus.title." + W));
              var q = L.getOffsetData(), ge = te.left + te.width / 2 - q.width / 2;
              L.css("left", ge + "px"), B === "up" ? L.css("top", te.top - q.height - 8 + "px") : B === "down" && L.css("top", te.top + te.height + 8 + "px"), P = (0, h.default)(function () {
                L.css("visibility", "visible");
              }, 200);
            } else
              M();
          }).on("mouseleave", function () {
            M();
          });
        }, R.prototype._addToToolbar = function () {
          var N, T = this.editor, H = T.$toolbarElem;
          (0, y.default)(N = this.menuList).call(N, function (B) {
            var L = B.$elem;
            L && H.append(L);
          });
        }, R.prototype.menuFind = function (N) {
          for (var T = this.menuList, H = 0, B = T.length; H < B; H++)
            if (T[H].key === N)
              return T[H];
          return T[0];
        }, R.prototype.changeActive = function () {
          var N;
          (0, y.default)(N = this.menuList).call(N, function (T) {
            var H;
            (0, h.default)((0, m.default)(H = T.tryChangeActive).call(H, T), 100);
          });
        }, R;
      }();
      l.default = x;
    }, function (i, l, n) {
      i.exports = n(303);
    }, function (i, l, n) {
      var u = n(304);
      i.exports = u;
    }, function (i, l, n) {
      n(305);
      var u = n(9);
      i.exports = u.Object.keys;
    }, function (i, l, n) {
      var u = n(5), f = n(29), p = n(52), c = n(11), v = c(function () {
        p(1);
      });
      u({ target: "Object", stat: !0, forced: v }, {
        keys: function (y) {
          return p(f(y));
        }
      });
    }, function (i, l, n) {
      var u = n(307);
      i.exports = u;
    }, function (i, l, n) {
      n(308);
      var u = n(9);
      i.exports = u.Object.entries;
    }, function (i, l, n) {
      var u = n(5), f = n(309).entries;
      u({ target: "Object", stat: !0 }, {
        entries: function (c) {
          return f(c);
        }
      });
    }, function (i, l, n) {
      var u = n(14), f = n(52), p = n(28), c = n(59).f, v = function (y) {
        return function (E) {
          for (var w = p(E), h = f(w), m = h.length, I = 0, D = [], g; m > I;)
            g = h[I++], (!u || c.call(w, g)) && D.push(y ? [g, w[g]] : w[g]);
          return D;
        };
      };
      i.exports = {
        entries: v(!0),
        values: v(!1)
      };
    }, function (i, l, n) {
      var u = n(311);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(312), f = Array.prototype;
      i.exports = function (p) {
        var c = p.some;
        return p === f || p instanceof Array && c === f.some ? u : c;
      };
    }, function (i, l, n) {
      n(313);
      var u = n(15);
      i.exports = u("Array").some;
    }, function (i, l, n) {
      var u = n(5), f = n(30).some, p = n(67), c = n(22), v = p("some"), b = c("some");
      u({ target: "Array", proto: !0, forced: !v || !b }, {
        some: function (E) {
          return f(this, E, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(315)), v = p.__importDefault(n(316)), b = p.__importDefault(n(321)), y = p.__importDefault(n(326)), E = p.__importDefault(n(327)), w = p.__importDefault(n(328)), h = p.__importDefault(n(329)), m = p.__importDefault(n(331)), I = p.__importDefault(n(333)), D = p.__importDefault(n(334)), g = p.__importDefault(n(337)), S = p.__importDefault(n(338)), x = p.__importDefault(n(339)), R = p.__importDefault(n(350)), N = p.__importDefault(n(365)), T = p.__importDefault(n(369)), H = p.__importDefault(n(137)), B = p.__importDefault(n(378)), L = p.__importDefault(n(380)), P = p.__importDefault(n(381)), C = p.__importDefault(n(382)), M = p.__importDefault(n(401)), k = p.__importDefault(n(406)), F = p.__importDefault(n(409));
      l.default = { bold: c.default, head: v.default, italic: y.default, link: b.default, underline: E.default, strikeThrough: w.default, fontName: h.default, fontSize: m.default, justify: I.default, quote: D.default, backColor: g.default, foreColor: S.default, video: x.default, image: R.default, indent: N.default, emoticon: T.default, list: H.default, lineHeight: B.default, undo: L.default, redo: P.default, table: C.default, code: M.default, splitLine: k.default, todo: F.default };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(23)), v = p.__importDefault(n(3)), b = function (y) {
        p.__extends(E, y);
        function E(w) {
          var h = this, m = v.default(`<div class="w-e-menu" data-title="\u52A0\u7C97">
                <i class="w-e-icon-bold"></i>
            </div>`);
          return h = y.call(this, m, w) || this, h;
        }
        return E.prototype.clickHandler = function () {
          var w = this.editor, h = w.selection.isSelectionEmpty();
          h && w.selection.createEmptyRange(), w.cmd.do("bold"), h && (w.selection.collapseRange(), w.selection.restoreSelection());
        }, E.prototype.tryChangeActive = function () {
          var w = this.editor;
          w.cmd.queryCommandState("bold") ? this.active() : this.unActive();
        }, E;
      }(c.default);
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(27)), c = u(n(31)), v = u(n(4)), b = u(n(317)), y = u(n(44));
      (0, f.default)(l, "__esModule", { value: !0 });
      var E = n(2), w = E.__importDefault(n(24)), h = E.__importDefault(n(3)), m = n(6), I = n(7), D = function (g) {
        E.__extends(S, g);
        function S(x) {
          var R = this, N = h.default('<div class="w-e-menu" data-title="\u6807\u9898"><i class="w-e-icon-header"></i></div>'), T = {
            width: 100, title: "\u8BBE\u7F6E\u6807\u9898", type: "list", list: [{ $elem: h.default("<h1>H1</h1>"), value: "<h1>" }, { $elem: h.default("<h2>H2</h2>"), value: "<h2>" }, { $elem: h.default("<h3>H3</h3>"), value: "<h3>" }, { $elem: h.default("<h4>H4</h4>"), value: "<h4>" }, { $elem: h.default("<h5>H5</h5>"), value: "<h5>" }, { $elem: h.default("<p>" + x.i18next.t("menus.dropListMenu.head.\u6B63\u6587") + "</p>"), value: "<p>" }], clickHandler: function (L) {
              R.command(L);
            }
          };
          R = g.call(this, N, x, T) || this;
          var H = x.config.onCatalogChange;
          return H && (R.oldCatalogs = [], R.addListenerCatalog(), R.getCatalogs()), R;
        }
        return S.prototype.command = function (x) {
          var R = this.editor, N = R.selection.getSelectionContainerElem();
          if (N && R.$textElem.equal(N))
            this.setMultilineHead(x);
          else {
            var T;
            if ((0, p.default)(T = ["OL", "UL", "LI", "TABLE", "TH", "TR", "CODE", "HR"]).call(T, h.default(N).getNodeName()) > -1)
              return;
            R.cmd.do("formatBlock", x);
          }
          x !== "<p>" && this.addUidForSelectionElem();
        }, S.prototype.addUidForSelectionElem = function () {
          var x = this.editor, R = x.selection.getSelectionContainerElem(), N = m.getRandomCode();
          h.default(R).attr("id", N);
        }, S.prototype.addListenerCatalog = function () {
          var x = this, R = this.editor;
          R.txt.eventHooks.changeEvents.push(function () {
            x.getCatalogs();
          });
        }, S.prototype.getCatalogs = function () {
          var x = this.editor, R = this.editor.$textElem, N = x.config.onCatalogChange, T = (0, c.default)(R).call(R, "h1,h2,h3,h4,h5"), H = [];
          (0, v.default)(T).call(T, function (B, L) {
            var P = h.default(B), C = P.attr("id"), M = P.getNodeName(), k = P.text();
            C || (C = m.getRandomCode(), P.attr("id", C)), k && H.push({ tag: M, id: C, text: k });
          }), (0, b.default)(this.oldCatalogs) !== (0, b.default)(H) && (this.oldCatalogs = H, N && N(H));
        }, S.prototype.setMultilineHead = function (x) {
          var R = this, N, T, H = this.editor, B = H.selection, L = (N = B.getSelectionContainerElem()) === null || N === void 0 ? void 0 : N.elems[0], P = ["IMG", "VIDEO", "TABLE", "TH", "TR", "UL", "OL", "PRE", "HR", "BLOCKQUOTE"], C = h.default(B.getSelectionStartElem()), M = h.default(B.getSelectionEndElem());
          M.elems[0].outerHTML === h.default(I.EMPTY_P).elems[0].outerHTML && !M.elems[0].nextSibling && (M = M.prev());
          var k = [];
          k.push(C.getNodeTop(H));
          var F = [], j = (T = B.getRange()) === null || T === void 0 ? void 0 : T.commonAncestorContainer.childNodes;
          j == null || (0, v.default)(j).call(j, function (ne, te) {
            ne === k[0].getNode() && F.push(te), ne === M.getNodeTop(H).getNode() && F.push(te);
          });
          for (var W = 0; k[W].getNode() !== M.getNodeTop(H).getNode();) {
            if (!k[W].elems[0])
              return;
            var Q = h.default(k[W].next().getNode());
            k.push(Q), W++;
          }
          k == null || (0, v.default)(k).call(k, function (ne, te) {
            if (!R.hasTag(ne, P)) {
              var q = h.default(x), ge = ne.parent().getNode();
              q.html("" + ne.html()), ge.insertBefore(q.getNode(), ne.getNode()), ne.remove();
            }
          }), B.createRangeByElems(L.children[F[0]], L.children[F[1]]);
        }, S.prototype.hasTag = function (x, R) {
          var N = this, T;
          if (!x)
            return !1;
          if ((0, y.default)(R).call(R, x == null ? void 0 : x.getNodeName()))
            return !0;
          var H = !1;
          return (T = x.children()) === null || T === void 0 || (0, v.default)(T).call(T, function (B) {
            H = N.hasTag(h.default(B), R);
          }), H;
        }, S.prototype.tryChangeActive = function () {
          var x = this.editor, R = /^h/i, N = x.cmd.queryCommandValue("formatBlock");
          R.test(N) ? this.active() : this.unActive();
        }, S;
      }(w.default);
      l.default = D;
    }, function (i, l, n) {
      i.exports = n(318);
    }, function (i, l, n) {
      var u = n(319);
      i.exports = u;
    }, function (i, l, n) {
      n(320);
      var u = n(9);
      u.JSON || (u.JSON = { stringify: JSON.stringify }), i.exports = function (p, c, v) {
        return u.JSON.stringify.apply(null, arguments);
      };
    }, function (i, l, n) {
      var u = n(5), f = n(35), p = n(11), c = f("JSON", "stringify"), v = /[\uD800-\uDFFF]/g, b = /^[\uD800-\uDBFF]$/, y = /^[\uDC00-\uDFFF]$/, E = function (m, I, D) {
        var g = D.charAt(I - 1), S = D.charAt(I + 1);
        return b.test(m) && !y.test(S) || y.test(m) && !b.test(g) ? "\\u" + m.charCodeAt(0).toString(16) : m;
      }, w = p(function () {
        return c("\uDF06\uD834") !== '"\\udf06\\ud834"' || c("\uDEAD") !== '"\\udead"';
      });
      c && u({ target: "JSON", stat: !0, forced: w }, {
        stringify: function (m, I, D) {
          var g = c.apply(null, arguments);
          return typeof g == "string" ? g.replace(v, E) : g;
        }
      });
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(17));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(37)), b = c.__importDefault(n(3)), y = c.__importDefault(n(322)), E = c.__importDefault(n(134)), w = c.__importDefault(n(32)), h = c.__importDefault(n(324)), m = n(7), I = function (D) {
        c.__extends(g, D);
        function g(S) {
          var x = this, R = b.default('<div class="w-e-menu" data-title="\u94FE\u63A5"><i class="w-e-icon-link"></i></div>');
          return x = D.call(this, R, S) || this, h.default(S), x;
        }
        return g.prototype.clickHandler = function () {
          var S = this.editor, x, R = S.selection.getSelectionContainerElem(), N = S.$textElem, T = N.html(), H = (0, p.default)(T).call(T);
          if (H === m.EMPTY_P) {
            var B = N.children();
            S.selection.createRangeByElem(B, !0, !0), R = S.selection.getSelectionContainerElem();
          }
          if (!(R && S.$textElem.equal(R)))
            if (this.isActive) {
              if (x = S.selection.getSelectionContainerElem(), !x)
                return;
              this.createPanel(x.text(), x.attr("href"));
            } else
              S.selection.isSelectionEmpty() ? this.createPanel("", "") : this.createPanel(S.selection.getSelectionText(), "");
        }, g.prototype.createPanel = function (S, x) {
          var R = y.default(this.editor, S, x), N = new w.default(this, R);
          N.create();
        }, g.prototype.tryChangeActive = function () {
          var S = this.editor;
          E.default(S) ? this.active() : this.unActive();
        }, g;
      }(v.default);
      l.default = I;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(17));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = n(6), b = c.__importDefault(n(3)), y = c.__importDefault(n(134)), E = n(323);
      function w(h, m, I) {
        var D = v.getRandom("input-link"), g = v.getRandom("input-text"), S = v.getRandom("btn-ok"), x = v.getRandom("btn-del"), R = y.default(h) ? "inline-block" : "none", N;
        function T() {
          if (!!y.default(h)) {
            var C = h.selection.getSelectionContainerElem();
            !C || (h.selection.createRangeByElem(C), h.selection.restoreSelection(), N = C);
          }
        }
        function H(C, M) {
          var k = new RegExp(/(<\/*ul>)|(<\/*li>)|(<\/*ol>)/g);
          C = C.replace(k, ""), y.default(h) && T(), h.cmd.do("insertHTML", '<a href="' + M + '" target="_blank">' + C + "</a>");
        }
        function B() {
          if (!!y.default(h)) {
            T();
            var C = N.text();
            h.cmd.do("insertHTML", "<span>" + C + "</span>");
          }
        }
        function L(C, M) {
          var k = h.config.linkCheck(C, M);
          if (k !== void 0) {
            if (k === !0)
              return !0;
            h.config.customAlert(k, "warning");
          }
          return !1;
        }
        var P = {
          width: 300,
          height: 0,
          tabs: [{
            title: h.i18next.t("menus.panelMenus.link.\u94FE\u63A5"),
            tpl: `<div>
                        <input
                            id="` + g + `"
                            type="text"
                            class="block"
                            value="` + m + `"
                            placeholder="` + h.i18next.t("menus.panelMenus.link.\u94FE\u63A5\u6587\u5B57") + `"/>
                        </td>
                        <input
                            id="` + D + `"
                            type="text"
                            class="block"
                            value="` + I + `"
                            placeholder="` + h.i18next.t("\u5982") + ` https://..."/>
                        </td>
                        <div class="w-e-button-container">
                            <button type="button" id="` + S + `" class="right">
                                ` + h.i18next.t("\u63D2\u5165") + `
                            </button>
                            <button type="button" id="` + x + '" class="gray right" style="display:' + R + `">
                                ` + h.i18next.t("menus.panelMenus.link.\u53D6\u6D88\u94FE\u63A5") + `
                            </button>
                        </div>
                    </div>`,
            events: [
              {
                selector: "#" + S, type: "click", fn: function () {
                  var M, k, F, j;
                  h.selection.restoreSelection();
                  var W = h.selection.getSelectionRangeTopNodes()[0].getNode(), Q = window.getSelection(), ne = b.default("#" + D), te = b.default("#" + g), q = (0, p.default)(M = ne.val()).call(M), ge = (0, p.default)(k = te.val()).call(k), be = "";
                  Q && !(Q != null && Q.isCollapsed) && (be = (F = E.insertHtml(Q, W)) === null || F === void 0 ? void 0 : (0, p.default)(F).call(F));
                  var me = be == null ? void 0 : be.replace(/<.*?>/g, ""), ae = (j = me == null ? void 0 : me.length) !== null && j !== void 0 ? j : 0;
                  if (ae <= ge.length) {
                    var le = ge.substring(0, ae), ue = ge.substring(ae);
                    me === le && (ge = be + ue);
                  }
                  if (!!q && (ge || (ge = q), !!L(ge, q)))
                    return H(ge, q), !0;
                }, bindEnter: !0
              },
              {
                selector: "#" + x, type: "click", fn: function () {
                  return B(), !0;
                }
              }
            ]
          }]
        };
        return P;
      }
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 }), l.insertHtml = l.createPartHtml = l.makeHtmlString = l.getTopNode = void 0;
      function c(h, m) {
        var I = h, D = h;
        do {
          if (I.textContent === m)
            break;
          D = I, I.parentNode && (I = I == null ? void 0 : I.parentNode);
        } while ((I == null ? void 0 : I.nodeName) !== "P");
        return D;
      }
      l.getTopNode = c;
      function v(h, m) {
        var I = h.nodeName, D = "";
        if (h.nodeType === 3 || /^(h|H)[1-6]$/.test(I))
          return m;
        if (h.nodeType === 1) {
          var g = h.getAttribute("style"), S = h.getAttribute("face"), x = h.getAttribute("color");
          g && (D = D + (' style="' + g + '"')), S && (D = D + (' face="' + S + '"')), x && (D = D + (' color="' + x + '"'));
        }
        return I = I.toLowerCase(), "<" + I + D + ">" + m + "</" + I + ">";
      }
      l.makeHtmlString = v;
      function b(h, m, I, D) {
        var g, S = (g = m.textContent) === null || g === void 0 ? void 0 : g.substring(I, D), x = m, R = "";
        do
          R = v(x, S != null ? S : ""), S = R, x = x == null ? void 0 : x.parentElement;
        while (x && x.textContent !== h);
        return R;
      }
      l.createPartHtml = b;
      function y(h, m) {
        var I, D, g, S, x, R = h.anchorNode, N = h.focusNode, T = h.anchorOffset, H = h.focusOffset, B = (I = m.textContent) !== null && I !== void 0 ? I : "", L = E(m), P = "", C = "", M = "", k = "", F = R, j = N, W = R;
        if (R != null && R.isEqualNode(N != null ? N : null)) {
          var Q = b(B, R, T, H);
          return Q = w(L, Q), Q;
        }
        for (R && (C = b(B, R, T != null ? T : 0)), N && (k = b(B, N, 0, H)), R && (F = c(R, B)), N && (j = c(N, B)), W = (D = F == null ? void 0 : F.nextSibling) !== null && D !== void 0 ? D : R; !(W != null && W.isEqualNode(j != null ? j : null));) {
          var ne = W == null ? void 0 : W.nodeName;
          if (ne === "#text")
            M = M + (W == null ? void 0 : W.textContent);
          else {
            var te = (S = (g = W == null ? void 0 : W.firstChild) === null || g === void 0 ? void 0 : g.parentElement) === null || S === void 0 ? void 0 : S.innerHTML;
            W && (M = M + v(W, te != null ? te : ""));
          }
          var q = (x = W == null ? void 0 : W.nextSibling) !== null && x !== void 0 ? x : W;
          if (q === W)
            break;
          W = q;
        }
        return P = "" + C + M + k, P = w(L, P), P;
      }
      l.insertHtml = y;
      function E(h) {
        for (var m, I = (m = h.textContent) !== null && m !== void 0 ? m : "", D = []; (h == null ? void 0 : h.textContent) === I;)
          h.nodeName !== "P" && h.nodeName !== "TABLE" && D.push(h), h = h.childNodes[0];
        return D;
      }
      function w(h, m) {
        return (0, p.default)(h).call(h, function (I) {
          m = v(I, m);
        }), m;
      }
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(325));
      function v(b) {
        c.default(b);
      }
      l.default = v;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(38));
      function b(E) {
        var w;
        function h(I) {
          var D = [{
            $elem: c.default("<span>" + E.i18next.t("menus.panelMenus.link.\u67E5\u770B\u94FE\u63A5") + "</span>"), onClick: function (S, x) {
              var R = x.attr("href");
              return window.open(R, "_target"), !0;
            }
          }, {
            $elem: c.default("<span>" + E.i18next.t("menus.panelMenus.link.\u53D6\u6D88\u94FE\u63A5") + "</span>"), onClick: function (S, x) {
              var R, N;
              S.selection.createRangeByElem(x), S.selection.restoreSelection();
              var T = x.childNodes();
              if ((T == null ? void 0 : T.getNodeName()) === "IMG") {
                var H = (N = (R = S.selection.getSelectionContainerElem()) === null || R === void 0 ? void 0 : R.children()) === null || N === void 0 ? void 0 : N.elems[0].children[0];
                S.cmd.do("insertHTML", `<img 
                                src=` + (H == null ? void 0 : H.getAttribute("src")) + ` 
                                style=` + (H == null ? void 0 : H.getAttribute("style")) + ">");
              } else {
                var B = x.text();
                S.cmd.do("insertHTML", "<span>" + B + "</span>");
              }
              return !0;
            }
          }];
          w = new v.default(E, I, D), w.create();
        }
        function m() {
          w && (w.remove(), w = null);
        }
        return { showLinkTooltip: h, hideLinkTooltip: m };
      }
      function y(E) {
        var w = b(E), h = w.showLinkTooltip, m = w.hideLinkTooltip;
        E.txt.eventHooks.linkClickEvents.push(h), E.txt.eventHooks.clickEvents.push(m), E.txt.eventHooks.keyupEvents.push(m), E.txt.eventHooks.toolbarClickEvents.push(m), E.txt.eventHooks.menuClickEvents.push(m), E.txt.eventHooks.textScrollEvents.push(m);
      }
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(23)), v = p.__importDefault(n(3)), b = function (y) {
        p.__extends(E, y);
        function E(w) {
          var h = this, m = v.default(`<div class="w-e-menu" data-title="\u659C\u4F53">
                <i class="w-e-icon-italic"></i>
            </div>`);
          return h = y.call(this, m, w) || this, h;
        }
        return E.prototype.clickHandler = function () {
          var w = this.editor, h = w.selection.isSelectionEmpty();
          h && w.selection.createEmptyRange(), w.cmd.do("italic"), h && (w.selection.collapseRange(), w.selection.restoreSelection());
        }, E.prototype.tryChangeActive = function () {
          var w = this.editor;
          w.cmd.queryCommandState("italic") ? this.active() : this.unActive();
        }, E;
      }(c.default);
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(23)), v = p.__importDefault(n(3)), b = function (y) {
        p.__extends(E, y);
        function E(w) {
          var h = this, m = v.default(`<div class="w-e-menu" data-title="\u4E0B\u5212\u7EBF">
                <i class="w-e-icon-underline"></i>
            </div>`);
          return h = y.call(this, m, w) || this, h;
        }
        return E.prototype.clickHandler = function () {
          var w = this.editor, h = w.selection.isSelectionEmpty();
          h && w.selection.createEmptyRange(), w.cmd.do("underline"), h && (w.selection.collapseRange(), w.selection.restoreSelection());
        }, E.prototype.tryChangeActive = function () {
          var w = this.editor;
          w.cmd.queryCommandState("underline") ? this.active() : this.unActive();
        }, E;
      }(c.default);
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(23)), v = p.__importDefault(n(3)), b = function (y) {
        p.__extends(E, y);
        function E(w) {
          var h = this, m = v.default(`<div class="w-e-menu" data-title="\u5220\u9664\u7EBF">
                <i class="w-e-icon-strikethrough"></i>
            </div>`);
          return h = y.call(this, m, w) || this, h;
        }
        return E.prototype.clickHandler = function () {
          var w = this.editor, h = w.selection.isSelectionEmpty();
          h && w.selection.createEmptyRange(), w.cmd.do("strikeThrough"), h && (w.selection.collapseRange(), w.selection.restoreSelection());
        }, E.prototype.tryChangeActive = function () {
          var w = this.editor;
          w.cmd.queryCommandState("strikeThrough") ? this.active() : this.unActive();
        }, E;
      }(c.default);
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(24)), v = p.__importDefault(n(3)), b = p.__importDefault(n(330)), y = function (E) {
        p.__extends(w, E);
        function w(h) {
          var m = this, I = v.default(`<div class="w-e-menu" data-title="\u5B57\u4F53">
                <i class="w-e-icon-font"></i>
            </div>`), D = new b.default(h.config.fontNames), g = {
              width: 100, title: "\u8BBE\u7F6E\u5B57\u4F53", type: "list", list: D.getItemList(), clickHandler: function (x) {
                m.command(x);
              }
            };
          return m = E.call(this, I, h, g) || this, m;
        }
        return w.prototype.command = function (h) {
          var m, I = this.editor, D = I.selection.isSelectionEmpty(), g = (m = I.selection.getSelectionContainerElem()) === null || m === void 0 ? void 0 : m.elems[0];
          if (g != null) {
            var S = (g == null ? void 0 : g.nodeName.toLowerCase()) !== "p", x = (g == null ? void 0 : g.getAttribute("face")) === h;
            if (D) {
              if (S && !x) {
                var R = I.selection.getSelectionRangeTopNodes();
                I.selection.createRangeByElem(R[0]), I.selection.moveCursor(R[0].elems[0]);
              }
              I.selection.setRangeToElem(g), I.selection.createEmptyRange();
            }
            I.cmd.do("fontName", h), D && (I.selection.collapseRange(), I.selection.restoreSelection());
          }
        }, w.prototype.tryChangeActive = function () {
        }, w;
      }(c.default);
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = function () {
        function y(E) {
          var w = this;
          this.itemList = [], (0, p.default)(E).call(E, function (h) {
            var m = typeof h == "string" ? h : h.value, I = typeof h == "string" ? h : h.name;
            w.itemList.push({ $elem: v.default(`<p style="font-family:'` + m + `'">` + I + "</p>"), value: I });
          });
        }
        return y.prototype.getItemList = function () {
          return this.itemList;
        }, y;
      }();
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(24)), v = p.__importDefault(n(3)), b = p.__importDefault(n(332)), y = function (E) {
        p.__extends(w, E);
        function w(h) {
          var m = this, I = v.default(`<div class="w-e-menu" data-title="\u5B57\u53F7">
                <i class="w-e-icon-text-heigh"></i>
            </div>`), D = new b.default(h.config.fontSizes), g = {
              width: 160, title: "\u8BBE\u7F6E\u5B57\u53F7", type: "list", list: D.getItemList(), clickHandler: function (x) {
                m.command(x);
              }
            };
          return m = E.call(this, I, h, g) || this, m;
        }
        return w.prototype.command = function (h) {
          var m, I = this.editor, D = I.selection.isSelectionEmpty(), g = (m = I.selection.getSelectionContainerElem()) === null || m === void 0 ? void 0 : m.elems[0];
          g != null && (I.cmd.do("fontSize", h), D && (I.selection.collapseRange(), I.selection.restoreSelection()));
        }, w.prototype.tryChangeActive = function () {
        }, w;
      }(c.default);
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = function () {
        function b(y) {
          this.itemList = [];
          for (var E in y) {
            var w = y[E];
            this.itemList.push({ $elem: c.default('<p style="font-size:' + E + '">' + w.name + "</p>"), value: w.value });
          }
        }
        return b.prototype.getItemList = function () {
          return this.itemList;
        }, b;
      }();
      l.default = v;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(27));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(24)), y = v.__importDefault(n(3)), E = ["LI"], w = ["UL", "BLOCKQUOTE"], h = function (m) {
        v.__extends(I, m);
        function I(D) {
          var g = this, S = y.default('<div class="w-e-menu" data-title="\u5BF9\u9F50"><i class="w-e-icon-paragraph-left"></i></div>'), x = {
            width: 100, title: "\u5BF9\u9F50\u65B9\u5F0F", type: "list", list: [{
              $elem: y.default(`<p>
                            <i class="w-e-icon-paragraph-left w-e-drop-list-item"></i>
                            ` + D.i18next.t("menus.dropListMenu.justify.\u9760\u5DE6") + `
                        </p>`), value: "left"
            }, {
              $elem: y.default(`<p>
                            <i class="w-e-icon-paragraph-center w-e-drop-list-item"></i>
                            ` + D.i18next.t("menus.dropListMenu.justify.\u5C45\u4E2D") + `
                        </p>`), value: "center"
            }, {
              $elem: y.default(`<p>
                            <i class="w-e-icon-paragraph-right w-e-drop-list-item"></i>
                            ` + D.i18next.t("menus.dropListMenu.justify.\u9760\u53F3") + `
                        </p>`), value: "right"
            }, {
              $elem: y.default(`<p>
                            <i class="w-e-icon-paragraph-justify w-e-drop-list-item"></i>
                            ` + D.i18next.t("menus.dropListMenu.justify.\u4E24\u7AEF") + `
                        </p>`), value: "justify"
            }], clickHandler: function (N) {
              g.command(N);
            }
          };
          return g = m.call(this, S, D, x) || this, g;
        }
        return I.prototype.command = function (D) {
          var g = this.editor, S = g.selection, x = S.getSelectionContainerElem();
          S.saveRange();
          var R = g.selection.getSelectionRangeTopNodes();
          if (x != null && x.length)
            if (this.isSpecialNode(x, R[0]) || this.isSpecialTopNode(R[0])) {
              var N = this.getSpecialNodeUntilTop(x, R[0]);
              if (N == null)
                return;
              y.default(N).css("text-align", D);
            } else
              (0, p.default)(R).call(R, function (T) {
                T.css("text-align", D);
              });
          S.restoreSelection();
        }, I.prototype.getSpecialNodeUntilTop = function (D, g) {
          for (var S = D.elems[0], x = g.elems[0]; S != null;) {
            if ((0, c.default)(E).call(E, S == null ? void 0 : S.nodeName) !== -1 || S.parentNode === x)
              return S;
            S = S.parentNode;
          }
          return S;
        }, I.prototype.isSpecialNode = function (D, g) {
          var S = this.getSpecialNodeUntilTop(D, g);
          return S == null ? !1 : (0, c.default)(E).call(E, S.nodeName) !== -1;
        }, I.prototype.isSpecialTopNode = function (D) {
          var g;
          return D == null ? !1 : (0, c.default)(w).call(w, (g = D.elems[0]) === null || g === void 0 ? void 0 : g.nodeName) !== -1;
        }, I.prototype.tryChangeActive = function () {
        }, I;
      }(b.default);
      l.default = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = c.__importDefault(n(23)), y = c.__importDefault(n(335)), E = c.__importDefault(n(336)), w = n(7), h = function (m) {
        c.__extends(I, m);
        function I(D) {
          var g = this, S = v.default(`<div class="w-e-menu" data-title="\u5F15\u7528">
                <i class="w-e-icon-quotes-left"></i>
            </div>`);
          return g = m.call(this, S, D) || this, y.default(D), g;
        }
        return I.prototype.clickHandler = function () {
          var D, g, S = this.editor, x = S.selection.isSelectionEmpty(), R = S.selection.getSelectionRangeTopNodes(), N = R[R.length - 1], T = this.getTopNodeName();
          if (T === "BLOCKQUOTE") {
            var H = v.default(N.childNodes()), B = H.length, L = N;
            (0, p.default)(H).call(H, function (k) {
              var F = v.default(k);
              F.insertAfter(L), L = F;
            }), N.remove(), S.selection.moveCursor(H.elems[B - 1]), this.tryChangeActive();
          } else {
            var P = E.default(R);
            if (S.$textElem.equal(N)) {
              var C = (D = S.selection.getSelectionContainerElem()) === null || D === void 0 ? void 0 : D.elems[0];
              S.selection.createRangeByElems(C.children[0], C.children[0]), R = S.selection.getSelectionRangeTopNodes(), P = E.default(R), N.append(P);
            } else
              P.insertAfter(N);
            this.delSelectNode(R);
            var M = (g = P.childNodes()) === null || g === void 0 ? void 0 : g.last().getNode();
            if (M == null)
              return;
            M.textContent ? S.selection.moveCursor(M) : S.selection.moveCursor(M, 0), this.tryChangeActive(), v.default(w.EMPTY_P).insertAfter(P);
            return;
          }
          x && (S.selection.collapseRange(), S.selection.restoreSelection());
        }, I.prototype.tryChangeActive = function () {
          var D, g = this.editor, S = (D = g.selection.getSelectionRangeTopNodes()[0]) === null || D === void 0 ? void 0 : D.getNodeName();
          S === "BLOCKQUOTE" ? this.active() : this.unActive();
        }, I.prototype.getTopNodeName = function () {
          var D = this.editor, g = D.selection.getSelectionRangeTopNodes()[0], S = g == null ? void 0 : g.getNodeName();
          return S;
        }, I.prototype.delSelectNode = function (D) {
          (0, p.default)(D).call(D, function (g) {
            g.remove();
          });
        }, I;
      }(b.default);
      l.default = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = n(7), v = p.__importDefault(n(3));
      function b(y) {
        function E(w) {
          var h, m = y.selection.getSelectionContainerElem(), I = y.selection.getSelectionRangeTopNodes()[0];
          if ((I == null ? void 0 : I.getNodeName()) === "BLOCKQUOTE") {
            if (m.getNodeName() === "BLOCKQUOTE") {
              var D = (h = m.childNodes()) === null || h === void 0 ? void 0 : h.getNode();
              y.selection.moveCursor(D);
            }
            if (m.text() === "") {
              w.preventDefault(), m.remove();
              var g = v.default(c.EMPTY_P);
              g.insertAfter(I), y.selection.moveCursor(g.getNode(), 0);
            }
            I.text() === "" && I.remove();
          }
        }
        y.txt.eventHooks.enterDownEvents.push(E);
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3));
      function b(y) {
        var E = v.default("<blockquote></blockquote>");
        return (0, p.default)(y).call(y, function (w) {
          E.append(w.clone(!0));
        }), E;
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(26));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(24)), b = c.__importDefault(n(3)), y = n(6), E = function (w) {
        c.__extends(h, w);
        function h(m) {
          var I, D = this, g = b.default(`<div class="w-e-menu" data-title="\u80CC\u666F\u8272">
                <i class="w-e-icon-paint-brush"></i>
            </div>`), S = {
              width: 120,
              title: "\u80CC\u666F\u989C\u8272",
              type: "inline-block",
              list: (0, p.default)(I = m.config.colors).call(I, function (x) {
                return { $elem: b.default('<i style="color:' + x + ';" class="w-e-icon-paint-brush"></i>'), value: x };
              }),
              clickHandler: function (R) {
                D.command(R);
              }
            };
          return D = w.call(this, g, m, S) || this, D;
        }
        return h.prototype.command = function (m) {
          var I, D = this.editor, g = D.selection.isSelectionEmpty(), S = (I = D.selection.getSelectionContainerElem()) === null || I === void 0 ? void 0 : I.elems[0];
          if (S != null) {
            var x = (S == null ? void 0 : S.nodeName.toLowerCase()) !== "p", R = S == null ? void 0 : S.style.backgroundColor, N = y.hexToRgb(m) === R;
            if (g) {
              if (x && !N) {
                var T = D.selection.getSelectionRangeTopNodes();
                D.selection.createRangeByElem(T[0]), D.selection.moveCursor(T[0].elems[0]);
              }
              D.selection.createEmptyRange();
            }
            D.cmd.do("backColor", m), g && (D.selection.collapseRange(), D.selection.restoreSelection());
          }
        }, h.prototype.tryChangeActive = function () {
        }, h;
      }(v.default);
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(26));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(24)), b = c.__importDefault(n(3)), y = function (E) {
        c.__extends(w, E);
        function w(h) {
          var m, I = this, D = b.default(`<div class="w-e-menu" data-title="\u6587\u5B57\u989C\u8272">
                <i class="w-e-icon-pencil2"></i>
            </div>`), g = {
              width: 120,
              title: "\u6587\u5B57\u989C\u8272",
              type: "inline-block",
              list: (0, p.default)(m = h.config.colors).call(m, function (S) {
                return { $elem: b.default('<i style="color:' + S + ';" class="w-e-icon-pencil2"></i>'), value: S };
              }),
              clickHandler: function (x) {
                I.command(x);
              }
            };
          return I = E.call(this, D, h, g) || this, I;
        }
        return w.prototype.command = function (h) {
          var m, I = this.editor, D = I.selection.isSelectionEmpty(), g = (m = I.selection.getSelectionContainerElem()) === null || m === void 0 ? void 0 : m.elems[0];
          if (g != null) {
            var S = I.selection.getSelectionText();
            if (g.nodeName === "A" && g.textContent === S) {
              var x = b.default("<span>&#8203;</span>").getNode();
              g.appendChild(x);
            }
            I.cmd.do("foreColor", h), D && (I.selection.collapseRange(), I.selection.restoreSelection());
          }
        }, w.prototype.tryChangeActive = function () {
        }, w;
      }(v.default);
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(32)), b = p.__importDefault(n(37)), y = p.__importDefault(n(340)), E = p.__importDefault(n(346)), w = function (h) {
        p.__extends(m, h);
        function m(I) {
          var D = this, g = c.default(`<div class="w-e-menu" data-title="\u89C6\u9891">
                <i class="w-e-icon-play"></i>
            </div>`);
          return D = h.call(this, g, I) || this, E.default(I), D;
        }
        return m.prototype.clickHandler = function () {
          this.createPanel("");
        }, m.prototype.createPanel = function (I) {
          var D = y.default(this.editor, I), g = new v.default(this, D);
          g.create();
        }, m.prototype.tryChangeActive = function () {
        }, m;
      }(b.default);
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(17));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = n(6), b = c.__importDefault(n(3)), y = c.__importDefault(n(341)), E = n(7);
      function w(h, m) {
        var I = h.config, D = new y.default(h), g = v.getRandom("input-iframe"), S = v.getRandom("btn-ok"), x = v.getRandom("input-upload"), R = v.getRandom("btn-local-ok");
        function N(L) {
          h.cmd.do("insertHTML", L + E.EMPTY_P), h.config.onlineVideoCallback(L);
        }
        function T(L) {
          var P = h.config.onlineVideoCheck(L);
          return P === !0 ? !0 : (typeof P == "string" && h.config.customAlert(P, "error"), !1);
        }
        var H = [{
          title: h.i18next.t("menus.panelMenus.video.\u4E0A\u4F20\u89C6\u9891"),
          tpl: `<div class="w-e-up-video-container">
                    <div id="` + R + `" class="w-e-up-btn">
                        <i class="w-e-icon-upload2"></i>
                    </div>
                    <div style="display:none;">
                        <input id="` + x + `" type="file" accept="video/*"/>
                    </div>
                 </div>`,
          events: [
            {
              selector: "#" + R, type: "click", fn: function () {
                var P = b.default("#" + x), C = P.elems[0];
                if (C)
                  C.click();
                else
                  return !0;
              }
            },
            {
              selector: "#" + x, type: "change", fn: function () {
                var P = b.default("#" + x), C = P.elems[0];
                if (!C)
                  return !0;
                var M = C.files;
                return M.length && D.uploadVideo(M), !0;
              }
            }
          ]
        }, {
          title: h.i18next.t("menus.panelMenus.video.\u63D2\u5165\u89C6\u9891"),
          tpl: `<div>
                    <input 
                        id="` + g + `" 
                        type="text" 
                        class="block" 
                        placeholder="` + h.i18next.t("\u5982") + `\uFF1A<iframe src=... ></iframe>"/>
                    </td>
                    <div class="w-e-button-container">
                        <button type="button" id="` + S + `" class="right">
                            ` + h.i18next.t("\u63D2\u5165") + `
                        </button>
                    </div>
                </div>`,
          events: [
            {
              selector: "#" + S, type: "click", fn: function () {
                var P, C = b.default("#" + g), M = (0, p.default)(P = C.val()).call(P);
                if (!!M && !!T(M))
                  return N(M), !0;
              }, bindEnter: !0
            }
          ]
        }], B = {
          width: 300,
          height: 0,
          tabs: []
        };
        return window.FileReader && (I.uploadVideoServer || I.customUploadVideo) && B.tabs.push(H[0]), I.showLinkVideo && B.tabs.push(H[1]), B;
      }
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(132)), c = u(n(57)), v = u(n(4)), b = u(n(27));
      (0, f.default)(l, "__esModule", { value: !0 });
      var y = n(2), E = n(6), w = y.__importDefault(n(135)), h = y.__importDefault(n(136)), m = n(7), I = n(6), D = function () {
        function g(S) {
          this.editor = S;
        }
        return g.prototype.uploadVideo = function (S) {
          var x = this;
          if (!!S.length) {
            var R = this.editor, N = R.config, T = "validate.", H = function (se) {
              return R.i18next.t(T + se);
            }, B = N.uploadVideoServer, L = N.uploadVideoMaxSize, P = L / 1024, C = N.uploadVideoName, M = N.uploadVideoParams, k = N.uploadVideoParamsWithUrl, F = N.uploadVideoHeaders, j = N.uploadVideoHooks, W = N.uploadVideoTimeout, Q = N.withVideoCredentials, ne = N.customUploadVideo, te = N.uploadVideoAccept, q = [], ge = [];
            if (E.arrForEach(S, function (he) {
              var se = he.name, Ae = he.size / 1024 / 1024;
              if (!(!se || !Ae)) {
                if (!(te instanceof Array)) {
                  ge.push("\u3010" + te + "\u3011" + H("uploadVideoAccept \u4E0D\u662FArray"));
                  return;
                }
                if (!(0, p.default)(te).call(te, function (Ee) {
                  return Ee === se.split(".")[se.split(".").length - 1];
                })) {
                  ge.push("\u3010" + se + "\u3011" + H("\u4E0D\u662F\u89C6\u9891"));
                  return;
                }
                if (P < Ae) {
                  ge.push("\u3010" + se + "\u3011" + H("\u5927\u4E8E") + " " + P + "M");
                  return;
                }
                q.push(he);
              }
            }), ge.length) {
              N.customAlert(H("\u89C6\u9891\u9A8C\u8BC1\u672A\u901A\u8FC7") + `: 
` + ge.join(`
`), "warning");
              return;
            }
            if (q.length === 0) {
              N.customAlert(H("\u4F20\u5165\u7684\u6587\u4EF6\u4E0D\u5408\u6CD5"), "warning");
              return;
            }
            if (ne && typeof ne == "function") {
              var be;
              ne(q, (0, c.default)(be = this.insertVideo).call(be, this));
              return;
            }
            var me = new FormData();
            if ((0, v.default)(q).call(q, function (he, se) {
              var Ae = C || he.name;
              q.length > 1 && (Ae = Ae + (se + 1)), me.append(Ae, he);
            }), B) {
              var ae = B.split("#");
              B = ae[0];
              var le = ae[1] || "";
              (0, v.default)(E).call(E, M, function (he, se) {
                k && ((0, b.default)(B).call(B, "?") > 0 ? B += "&" : B += "?", B = B + he + "=" + se), me.append(he, se);
              }), le && (B += "#" + le);
              var ue = w.default(B, {
                timeout: W, formData: me, headers: F, withCredentials: !!Q, beforeSend: function (se) {
                  if (j.before)
                    return j.before(se, R, q);
                }, onTimeout: function (se) {
                  N.customAlert(H("\u4E0A\u4F20\u89C6\u9891\u8D85\u65F6"), "error"), j.timeout && j.timeout(se, R);
                }, onProgress: function (se, Ae) {
                  var Ee = new h.default(R);
                  Ae.lengthComputable && (se = Ae.loaded / Ae.total, Ee.show(se));
                }, onError: function (se) {
                  N.customAlert(H("\u4E0A\u4F20\u89C6\u9891\u9519\u8BEF"), "error", H("\u4E0A\u4F20\u89C6\u9891\u9519\u8BEF") + "\uFF0C" + H("\u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001") + ": " + se.status), j.error && j.error(se, R);
                }, onFail: function (se, Ae) {
                  N.customAlert(H("\u4E0A\u4F20\u89C6\u9891\u5931\u8D25"), "error", H("\u4E0A\u4F20\u89C6\u9891\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF") + ("\uFF0C" + H("\u8FD4\u56DE\u7ED3\u679C") + ": ") + Ae), j.fail && j.fail(se, R, Ae);
                }, onSuccess: function (se, Ae) {
                  if (j.customInsert) {
                    var Ee;
                    j.customInsert((0, c.default)(Ee = x.insertVideo).call(Ee, x), Ae, R);
                    return;
                  }
                  if (Ae.errno != "0") {
                    N.customAlert(H("\u4E0A\u4F20\u89C6\u9891\u5931\u8D25"), "error", H("\u4E0A\u4F20\u89C6\u9891\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF") + "\uFF0C" + H("\u8FD4\u56DE\u7ED3\u679C") + " errno=" + Ae.errno), j.fail && j.fail(se, R, Ae);
                    return;
                  }
                  var Ne = Ae.data;
                  x.insertVideo(Ne.url), j.success && j.success(se, R, Ae);
                }
              });
              typeof ue == "string" && N.customAlert(ue, "error");
            }
          }
        }, g.prototype.insertVideo = function (S) {
          var x = this.editor, R = x.config, N = "validate.", T = function (L, P) {
            return P === void 0 && (P = N), x.i18next.t(P + L);
          };
          if (!R.customInsertVideo)
            I.UA.isFirefox ? x.cmd.do("insertHTML", '<p data-we-video-p="true"><video src="' + S + '" controls="controls" style="max-width:100%"></video></p><p>&#8203</p>') : x.cmd.do("insertHTML", '<video src="' + S + '" controls="controls" style="max-width:100%"></video>' + m.EMPTY_P);
          else {
            R.customInsertVideo(S);
            return;
          }
          var H = document.createElement("video");
          H.onload = function () {
            H = null;
          }, H.onerror = function () {
            R.customAlert(T("\u63D2\u5165\u89C6\u9891\u9519\u8BEF"), "error", "wangEditor: " + T("\u63D2\u5165\u89C6\u9891\u9519\u8BEF") + "\uFF0C" + T("\u89C6\u9891\u94FE\u63A5") + ' "' + S + '"\uFF0C' + T("\u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25")), H = null;
          }, H.onabort = function () {
            return H = null;
          }, H.src = S;
        }, g;
      }();
      l.default = D;
    }, function (i, l, n) {
      i.exports = n(343);
    }, function (i, l, n) {
      var u = n(344);
      i.exports = u;
    }, function (i, l, n) {
      n(345);
      var u = n(9);
      i.exports = u.Date.now;
    }, function (i, l, n) {
      var u = n(5);
      u({ target: "Date", stat: !0 }, {
        now: function () {
          return new Date().getTime();
        }
      });
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(347)), v = p.__importDefault(n(349));
      function b(y) {
        c.default(y), v.default(y);
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.createShowHideFn = void 0;
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(38)), b = p.__importDefault(n(348));
      function y(w) {
        var h, m = function (S, x) {
          return x === void 0 && (x = ""), w.i18next.t(x + S);
        };
        function I(g) {
          var S = [{
            $elem: c.default("<span class='w-e-icon-trash-o'></span>"), onClick: function (R, N) {
              return N.remove(), !0;
            }
          }, {
            $elem: c.default("<span>100%</span>"), onClick: function (R, N) {
              return N.attr("width", "100%"), N.removeAttr("height"), !0;
            }
          }, {
            $elem: c.default("<span>50%</span>"), onClick: function (R, N) {
              return N.attr("width", "50%"), N.removeAttr("height"), !0;
            }
          }, {
            $elem: c.default("<span>30%</span>"), onClick: function (R, N) {
              return N.attr("width", "30%"), N.removeAttr("height"), !0;
            }
          }, {
            $elem: c.default("<span>" + m("\u91CD\u7F6E") + "</span>"), onClick: function (R, N) {
              return N.removeAttr("width"), N.removeAttr("height"), !0;
            }
          }, {
            $elem: c.default("<span>" + m("menus.justify.\u9760\u5DE6") + "</span>"), onClick: function (R, N) {
              return b.default(N, "left"), !0;
            }
          }, {
            $elem: c.default("<span>" + m("menus.justify.\u5C45\u4E2D") + "</span>"), onClick: function (R, N) {
              return b.default(N, "center"), !0;
            }
          }, {
            $elem: c.default("<span>" + m("menus.justify.\u9760\u53F3") + "</span>"), onClick: function (R, N) {
              return b.default(N, "right"), !0;
            }
          }];
          h = new v.default(w, g, S), h.create();
        }
        function D() {
          h && (h.remove(), h = null);
        }
        return { showVideoTooltip: I, hideVideoTooltip: D };
      }
      l.createShowHideFn = y;
      function E(w) {
        var h = y(w), m = h.showVideoTooltip, I = h.hideVideoTooltip;
        w.txt.eventHooks.videoClickEvents.push(m), w.txt.eventHooks.clickEvents.push(I), w.txt.eventHooks.keyupEvents.push(I), w.txt.eventHooks.toolbarClickEvents.push(I), w.txt.eventHooks.menuClickEvents.push(I), w.txt.eventHooks.textScrollEvents.push(I), w.txt.eventHooks.changeEvents.push(I);
      }
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(44));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3));
      function b(E, w) {
        var h = ["P"], m = y(E, h);
        m && v.default(m).css("text-align", w);
      }
      l.default = b;
      function y(E, w) {
        for (var h, m = E.elems[0]; m != null;) {
          if ((0, p.default)(w).call(w, m == null ? void 0 : m.nodeName))
            return m;
          if (((h = m == null ? void 0 : m.parentNode) === null || h === void 0 ? void 0 : h.nodeName) === "BODY")
            return null;
          m = m.parentNode;
        }
        return m;
      }
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(6);
      function c(v) {
        if (!!p.UA.isFirefox) {
          var b = v.txt, y = v.selection, E = b.eventHooks.keydownEvents;
          E.push(function (w) {
            var h = y.getSelectionContainerElem();
            if (h) {
              var m = h.getNodeTop(v), I = m.length && m.prev().length ? m.prev() : null;
              I && I.attr("data-we-video-p") && y.getCursorPos() === 0 && w.keyCode === 8 && I.remove();
            }
          });
        }
      }
      l.default = c;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(26));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = n(7), b = c.__importDefault(n(3)), y = c.__importDefault(n(32)), E = c.__importDefault(n(37)), w = c.__importDefault(n(351)), h = c.__importDefault(n(364)), m = function (I) {
        c.__extends(D, I);
        function D(g) {
          var S = this, x = b.default('<div class="w-e-menu" data-title="\u56FE\u7247"><i class="w-e-icon-image"></i></div>'), R = h.default(g);
          if (R.onlyUploadConf) {
            var N;
            x = R.onlyUploadConf.$elem, (0, p.default)(N = R.onlyUploadConf.events).call(N, function (T) {
              var H = T.type, B = T.fn || v.EMPTY_FN;
              x.on(H, function (L) {
                L.stopPropagation(), B(L);
              });
            });
          }
          return S = I.call(this, x, g) || this, S.imgPanelConfig = R, w.default(g), S;
        }
        return D.prototype.clickHandler = function () {
          this.imgPanelConfig.onlyUploadConf || this.createPanel();
        }, D.prototype.createPanel = function () {
          var g = this.imgPanelConfig, S = new y.default(this, g);
          this.setPanel(S), S.create();
        }, D.prototype.tryChangeActive = function () {
        }, D;
      }(E.default);
      l.default = m;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(352)), v = p.__importDefault(n(353)), b = p.__importDefault(n(354)), y = p.__importDefault(n(362)), E = p.__importDefault(n(363));
      function w(h) {
        c.default(h), v.default(h), b.default(h), y.default(h), E.default(h);
      }
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = n(130), v = p.__importDefault(n(96));
      function b(h, m) {
        var I = h.config, D = I.pasteFilterStyle, g = I.pasteIgnoreImg, S = c.getPasteHtml(m, D, g);
        if (S)
          return !0;
        var x = c.getPasteText(m);
        return !!x;
      }
      function y(h, m) {
        for (var I, D = ((I = m.clipboardData) === null || I === void 0 ? void 0 : I.types) || [], g = 0; g < D.length; g++) {
          var S = D[g];
          if (S === "Files")
            return !0;
        }
        return !1;
      }
      function E(h, m) {
        if (!(!y(m, h) && b(m, h))) {
          var I = c.getPasteImgs(h);
          if (!!I.length) {
            var D = new v.default(m);
            D.uploadImg(I);
          }
        }
      }
      function w(h) {
        h.txt.eventHooks.pasteEvents.unshift(function (m) {
          E(m, h);
        });
      }
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(96));
      function v(b) {
        function y(E) {
          var w = E.dataTransfer && E.dataTransfer.files;
          if (!(!w || !w.length)) {
            var h = new c.default(b);
            h.uploadImg(w);
          }
        }
        b.txt.eventHooks.dropEvents.push(y);
      }
      l.default = v;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(31)), c = u(n(355));
      (0, f.default)(l, "__esModule", { value: !0 }), l.createShowHideFn = void 0;
      var v = n(2), b = v.__importDefault(n(3));
      n(360);
      var y = n(6);
      function E(D, g, S, x, R) {
        D.attr("style", "width:" + g + "px; height:" + S + "px; left:" + x + "px; top:" + R + "px;");
      }
      function w(D, g) {
        var S = b.default(`<div class="w-e-img-drag-mask">
            <div class="w-e-img-drag-show-size"></div>
            <div class="w-e-img-drag-rb"></div>
         </div>`);
        return S.hide(), g.append(S), S;
      }
      function h(D, g, S) {
        var x = D.getBoundingClientRect(), R = S.getBoundingClientRect(), N = R.width.toFixed(2), T = R.height.toFixed(2);
        (0, p.default)(g).call(g, ".w-e-img-drag-show-size").text(N + "px * " + T + "px"), E(g, (0, c.default)(N), (0, c.default)(T), R.left - x.left, R.top - x.top), g.show();
      }
      function m(D) {
        var g = D.$textContainerElem, S, x = w(D, g);
        function R(H, B) {
          H.on("click", function (L) {
            L.stopPropagation();
          }), H.on("mousedown", ".w-e-img-drag-rb", function (L) {
            if (L.preventDefault(), !S)
              return;
            var P = L.clientX, C = L.clientY, M = B.getBoundingClientRect(), k = S.getBoundingClientRect(), F = k.width, j = k.height, W = k.left - M.left, Q = k.top - M.top, ne = F / j, te = F, q = j, ge = b.default(document);
            function be() {
              ge.off("mousemove", me), ge.off("mouseup", ae);
            }
            function me(le) {
              le.stopPropagation(), le.preventDefault(), te = F + (le.clientX - P), q = j + (le.clientY - C), te / q != ne && (q = te / ne), te = (0, c.default)(te.toFixed(2)), q = (0, c.default)(q.toFixed(2)), (0, p.default)(H).call(H, ".w-e-img-drag-show-size").text(te.toFixed(2).replace(".00", "") + "px * " + q.toFixed(2).replace(".00", "") + "px"), E(H, te, q, W, Q);
            }
            ge.on("mousemove", me);
            function ae() {
              S.attr("width", te + ""), S.attr("height", q + "");
              var le = S.getBoundingClientRect();
              E(H, te, q, le.left - M.left, le.top - M.top), be();
            }
            ge.on("mouseup", ae), ge.on("mouseleave", be);
          });
        }
        function N(H) {
          if (y.UA.isIE())
            return !1;
          H && (S = H, h(g, x, S));
        }
        function T() {
          (0, p.default)(g).call(g, ".w-e-img-drag-mask").hide();
        }
        return R(x, g), b.default(document).on("click", T), D.beforeDestroy(function () {
          b.default(document).off("click", T);
        }), { showDrag: N, hideDrag: T };
      }
      l.createShowHideFn = m;
      function I(D) {
        var g = m(D), S = g.showDrag, x = g.hideDrag;
        D.txt.eventHooks.imgClickEvents.push(S), D.txt.eventHooks.textScrollEvents.push(x), D.txt.eventHooks.keyupEvents.push(x), D.txt.eventHooks.toolbarClickEvents.push(x), D.txt.eventHooks.menuClickEvents.push(x), D.txt.eventHooks.changeEvents.push(x);
      }
      l.default = I;
    }, function (i, l, n) {
      i.exports = n(356);
    }, function (i, l, n) {
      var u = n(357);
      i.exports = u;
    }, function (i, l, n) {
      n(358);
      var u = n(9);
      i.exports = u.parseFloat;
    }, function (i, l, n) {
      var u = n(5), f = n(359);
      u({ global: !0, forced: parseFloat != f }, { parseFloat: f });
    }, function (i, l, n) {
      var u = n(8), f = n(90).trim, p = n(68), c = u.parseFloat, v = 1 / c(p + "-0") !== -1 / 0;
      i.exports = v ? function (y) {
        var E = f(String(y)), w = c(E);
        return w === 0 && E.charAt(0) == "-" ? -0 : w;
      } : c;
    }, function (i, l, n) {
      var u = n(20), f = n(361);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-text-container {
  overflow: hidden;
}
.w-e-img-drag-mask {
  position: absolute;
  z-index: 1;
  border: 1px dashed #ccc;
  box-sizing: border-box;
}
.w-e-img-drag-mask .w-e-img-drag-rb {
  position: absolute;
  right: -5px;
  bottom: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ccc;
  cursor: se-resize;
}
.w-e-img-drag-mask .w-e-img-drag-show-size {
  min-width: 110px;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #999;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #999;
  color: #fff;
  border-radius: 2px;
  padding: 0 5px;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.createShowHideFn = void 0;
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(38));
      function b(E) {
        var w, h = function (g, S) {
          return S === void 0 && (S = ""), E.i18next.t(S + g);
        };
        function m(D) {
          var g = [{
            $elem: c.default("<span class='w-e-icon-trash-o'></span>"), onClick: function (x, R) {
              return x.selection.createRangeByElem(R), x.selection.restoreSelection(), x.cmd.do("delete"), !0;
            }
          }, {
            $elem: c.default("<span>30%</span>"), onClick: function (x, R) {
              return R.attr("width", "30%"), R.removeAttr("height"), !0;
            }
          }, {
            $elem: c.default("<span>50%</span>"), onClick: function (x, R) {
              return R.attr("width", "50%"), R.removeAttr("height"), !0;
            }
          }, {
            $elem: c.default("<span>100%</span>"), onClick: function (x, R) {
              return R.attr("width", "100%"), R.removeAttr("height"), !0;
            }
          }];
          g.push({
            $elem: c.default("<span>" + h("\u91CD\u7F6E") + "</span>"), onClick: function (x, R) {
              return R.removeAttr("width"), R.removeAttr("height"), !0;
            }
          }), D.attr("data-href") && g.push({
            $elem: c.default("<span>" + h("\u67E5\u770B\u94FE\u63A5") + "</span>"), onClick: function (x, R) {
              var N = R.attr("data-href");
              return N && (N = decodeURIComponent(N), window.open(N, "_target")), !0;
            }
          }), w = new v.default(E, D, g), w.create();
        }
        function I() {
          w && (w.remove(), w = null);
        }
        return { showImgTooltip: m, hideImgTooltip: I };
      }
      l.createShowHideFn = b;
      function y(E) {
        var w = b(E), h = w.showImgTooltip, m = w.hideImgTooltip;
        E.txt.eventHooks.imgClickEvents.push(h), E.txt.eventHooks.clickEvents.push(m), E.txt.eventHooks.keyupEvents.push(m), E.txt.eventHooks.toolbarClickEvents.push(m), E.txt.eventHooks.menuClickEvents.push(m), E.txt.eventHooks.textScrollEvents.push(m), E.txt.eventHooks.imgDragBarMouseDownEvents.push(m), E.txt.eventHooks.changeEvents.push(m);
      }
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      function p(c) {
        var v = c.txt, b = c.selection, y = v.eventHooks.keydownEvents;
        y.push(function (E) {
          var w = b.getSelectionContainerElem(), h = b.getRange();
          if (!(!h || !w || E.keyCode !== 8 || !b.isSelectionEmpty())) {
            var m = h.startContainer, I = h.startOffset, D = null;
            if (I === 0)
              for (; m !== w.elems[0] && w.elems[0].contains(m) && m.parentNode && !D;) {
                if (m.previousSibling) {
                  D = m.previousSibling;
                  break;
                }
                m = m.parentNode;
              }
            else
              m.nodeType !== 3 && (D = m.childNodes[I - 1]);
            if (!!D) {
              for (var g = D; g.childNodes.length;)
                g = g.childNodes[g.childNodes.length - 1];
              g instanceof HTMLElement && g.tagName === "IMG" && (g.remove(), E.preventDefault());
            }
          }
        });
      }
      l.default = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(26)), c = u(n(17));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(3)), y = n(6), E = v.__importDefault(n(96));
      function w(h) {
        var m, I = h.config, D = new E.default(h), g = y.getRandom("up-trigger-id"), S = y.getRandom("up-file-id"), x = y.getRandom("input-link-url"), R = y.getRandom("input-link-url-alt"), N = y.getRandom("input-link-url-href"), T = y.getRandom("btn-link"), H = "menus.panelMenus.image.", B = function (ne, te) {
          return te === void 0 && (te = H), h.i18next.t(te + ne);
        };
        function L(Q, ne, te) {
          var q = I.linkImgCheck(Q);
          return q === !0 ? !0 : (typeof q == "string" && I.customAlert(q, "error"), !1);
        }
        var P = I.uploadImgMaxLength === 1 ? "" : 'multiple="multiple"', C = (0, p.default)(m = I.uploadImgAccept).call(m, function (Q) {
          return "image/" + Q;
        }).join(","), M = function (ne, te, q) {
          return '<div class="' + ne + '" data-title="' + q + `">
            <div id="` + g + `" class="w-e-up-btn">
                <i class="` + te + `"></i>
            </div>
            <div style="display:none;">
                <input id="` + S + '" type="file" ' + P + ' accept="' + C + `"/>
            </div>
        </div>`;
        }, k = [
          {
            selector: "#" + g, type: "click", fn: function () {
              var ne = I.uploadImgFromMedia;
              if (ne && typeof ne == "function")
                return ne(), !0;
              var te = b.default("#" + S), q = te.elems[0];
              if (q)
                q.click();
              else
                return !0;
            }
          },
          {
            selector: "#" + S, type: "change", fn: function () {
              var ne = b.default("#" + S), te = ne.elems[0];
              if (!te)
                return !0;
              var q = te.files;
              return q != null && q.length && D.uploadImg(q), te && (te.value = ""), !0;
            }
          }
        ], F = [`<input
            id="` + x + `"
            type="text"
            class="block"
            placeholder="` + B("\u56FE\u7247\u5730\u5740") + '"/>'];
        I.showLinkImgAlt && F.push(`
        <input
            id="` + R + `"
            type="text"
            class="block"
            placeholder="` + B("\u56FE\u7247\u6587\u5B57\u8BF4\u660E") + '"/>'), I.showLinkImgHref && F.push(`
        <input
            id="` + N + `"
            type="text"
            class="block"
            placeholder="` + B("\u8DF3\u8F6C\u94FE\u63A5") + '"/>');
        var j = [
          {
            title: B("\u4E0A\u4F20\u56FE\u7247"),
            tpl: M("w-e-up-img-container", "w-e-icon-upload2", ""),
            events: k
          },
          {
            title: B("\u7F51\u7EDC\u56FE\u7247"), tpl: `<div>
                    ` + F.join("") + `
                    <div class="w-e-button-container">
                        <button type="button" id="` + T + '" class="right">' + B("\u63D2\u5165", "") + `</button>
                    </div>
                </div>`, events: [{
              selector: "#" + T, type: "click", fn: function () {
                var ne, te = b.default("#" + x), q = (0, c.default)(ne = te.val()).call(ne);
                if (!!q) {
                  var ge;
                  if (I.showLinkImgAlt) {
                    var be;
                    ge = (0, c.default)(be = b.default("#" + R).val()).call(be);
                  }
                  var me;
                  if (I.showLinkImgHref) {
                    var ae;
                    me = (0, c.default)(ae = b.default("#" + N).val()).call(ae);
                  }
                  if (!!L(q))
                    return D.insertImg(q, ge, me), !0;
                }
              }, bindEnter: !0
            }]
          }
        ], W = { width: 300, height: 0, tabs: [], onlyUploadConf: { $elem: b.default(M("w-e-menu", "w-e-icon-image", "\u56FE\u7247")), events: k } };
        return window.FileReader && (I.uploadImgShowBase64 || I.uploadImgServer || I.customUploadImg || I.uploadImgFromMedia) && W.tabs.push(j[0]), I.showLinkImg && (W.tabs.push(j[1]), W.onlyUploadConf = void 0), W;
      }
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = c.__importDefault(n(24)), y = c.__importDefault(n(366)), E = function (w) {
        c.__extends(h, w);
        function h(m) {
          var I = this, D = v.default(`<div class="w-e-menu" data-title="\u7F29\u8FDB">
                <i class="w-e-icon-indent-increase"></i>
            </div>`), g = {
              width: 130, title: "\u8BBE\u7F6E\u7F29\u8FDB", type: "list", list: [{
                $elem: v.default(`<p>
                            <i class="w-e-icon-indent-increase w-e-drop-list-item"></i>
                            ` + m.i18next.t("menus.dropListMenu.indent.\u589E\u52A0\u7F29\u8FDB") + `
                        <p>`), value: "increase"
              }, {
                $elem: v.default(`<p>
                            <i class="w-e-icon-indent-decrease w-e-drop-list-item"></i>
                            ` + m.i18next.t("menus.dropListMenu.indent.\u51CF\u5C11\u7F29\u8FDB") + `
                        <p>`), value: "decrease"
              }], clickHandler: function (x) {
                I.command(x);
              }
            };
          return I = w.call(this, D, m, g) || this, I;
        }
        return h.prototype.command = function (m) {
          var I = this.editor, D = I.selection.getSelectionContainerElem();
          if (D && I.$textElem.equal(D)) {
            var g = I.selection.getSelectionRangeTopNodes();
            g.length > 0 && (0, p.default)(g).call(g, function (S) {
              y.default(v.default(S), m, I);
            });
          } else
            D && D.length > 0 && (0, p.default)(D).call(D, function (S) {
              y.default(v.default(S), m, I);
            });
          I.selection.restoreSelection(), this.tryChangeActive();
        }, h.prototype.tryChangeActive = function () {
          var m = this.editor, I = m.selection.getSelectionStartElem(), D = v.default(I).getNodeTop(m);
          D.length <= 0 || (D.elems[0].style.paddingLeft != "" ? this.active() : this.unActive());
        }, h;
      }(b.default);
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(45)), c = u(n(17));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(367)), y = v.__importDefault(n(368)), E = /^(\d+)(\w+)$/, w = /^(\d+)%$/;
      function h(I) {
        var D = I.config.indentation;
        if (typeof D == "string") {
          if (E.test(D)) {
            var g, S = (0, p.default)(g = (0, c.default)(D).call(D).match(E)).call(g, 1, 3), x = S[0], R = S[1];
            return { value: Number(x), unit: R };
          } else if (w.test(D))
            return { value: Number((0, c.default)(D).call(D).match(w)[1]), unit: "%" };
        } else if (D.value !== void 0 && D.unit)
          return D;
        return { value: 2, unit: "em" };
      }
      function m(I, D, g) {
        var S = I.getNodeTop(g), x = /^(P|H[0-9]*)$/;
        x.test(S.getNodeName()) && (D === "increase" ? b.default(S, h(g)) : D === "decrease" && y.default(S, h(g)));
      }
      l.default = m;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(45));
      (0, f.default)(l, "__esModule", { value: !0 });
      function c(v, b) {
        var y = v.elems[0];
        if (y.style.paddingLeft === "")
          v.css("padding-left", b.value + b.unit);
        else {
          var E = y.style.paddingLeft, w = (0, p.default)(E).call(E, 0, E.length - b.unit.length), h = Number(w) + b.value;
          v.css("padding-left", "" + h + b.unit);
        }
      }
      l.default = c;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(45));
      (0, f.default)(l, "__esModule", { value: !0 });
      function c(v, b) {
        var y = v.elems[0];
        if (y.style.paddingLeft !== "") {
          var E = y.style.paddingLeft, w = (0, p.default)(E).call(E, 0, E.length - b.unit.length), h = Number(w) - b.value;
          h > 0 ? v.css("padding-left", "" + h + b.unit) : v.css("padding-left", "");
        }
      }
      l.default = c;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(37)), b = p.__importDefault(n(32)), y = p.__importDefault(n(370)), E = function (w) {
        p.__extends(h, w);
        function h(m) {
          var I = this, D = c.default(`<div class="w-e-menu" data-title="\u8868\u60C5">
                <i class="w-e-icon-happy"></i>
            </div>`);
          return I = w.call(this, D, m) || this, I;
        }
        return h.prototype.createPanel = function () {
          var m = y.default(this.editor), I = new b.default(this, m);
          I.create();
        }, h.prototype.clickHandler = function () {
          this.createPanel();
        }, h.prototype.tryChangeActive = function () {
        }, h;
      }(v.default);
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(26)), c = u(n(70)), v = u(n(17));
      (0, f.default)(l, "__esModule", { value: !0 });
      var b = n(2), y = b.__importDefault(n(3));
      function E(w) {
        var h = w.config.emotions;
        function m(g) {
          var S = [];
          if (g.type == "image") {
            var x;
            S = (0, p.default)(x = g.content).call(x, function (N) {
              return typeof N == "string" ? "" : '<span  title="' + N.alt + `">
                    <img class="eleImg" data-emoji="` + N.alt + '" style src="' + N.src + '" alt="[' + N.alt + `]">
                </span>`;
            }), S = (0, c.default)(S).call(S, function (N) {
              return N !== "";
            });
          } else {
            var R;
            S = (0, p.default)(R = g.content).call(R, function (N) {
              return '<span class="eleImg" title="' + N + '">' + N + "</span>";
            });
          }
          return S.join("").replace(/&nbsp;/g, "");
        }
        var I = (0, p.default)(h).call(h, function (g) {
          return {
            title: w.i18next.t("menus.panelMenus.emoticon." + g.title),
            tpl: "<div>" + m(g) + "</div>",
            events: [{
              selector: ".eleImg", type: "click", fn: function (x) {
                var R = y.default(x.target), N = R.getNodeName(), T;
                if (N === "IMG") {
                  var H;
                  T = (0, v.default)(H = R.parent().html()).call(H);
                } else
                  T = "<span>" + R.html() + "</span>";
                return w.cmd.do("insertHTML", T), !0;
              }
            }]
          };
        }), D = { width: 300, height: 230, tabs: I };
        return D;
      }
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.createListHandle = l.ClassType = void 0;
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(372)), b = p.__importDefault(n(374)), y = p.__importDefault(n(375)), E = p.__importDefault(n(376)), w = p.__importDefault(n(377)), h;
      (function (g) {
        g.Wrap = "WrapListHandle", g.Join = "JoinListHandle", g.StartJoin = "StartJoinListHandle", g.EndJoin = "EndJoinListHandle", g.Other = "OtherListHandle";
      })(h = l.ClassType || (l.ClassType = {}));
      var m = { WrapListHandle: v.default, JoinListHandle: b.default, StartJoinListHandle: y.default, EndJoinListHandle: E.default, OtherListHandle: w.default };
      function I(g, S, x) {
        if (g === h.Other && x === void 0)
          throw new Error("other \u7C7B\u9700\u8981\u4F20\u5165 range");
        return g !== h.Other ? new m[g](S) : new m[g](S, x);
      }
      l.createListHandle = I;
      var D = function () {
        function g(S) {
          this.handle = S, this.handle.exec();
        }
        return g.prototype.getSelectionRangeElem = function () {
          return c.default(this.handle.selectionRangeElem.get());
        }, g;
      }();
      l.default = D;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = n(58), y = n(47), E = function (w) {
        c.__extends(h, w);
        function h(m) {
          return w.call(this, m) || this;
        }
        return h.prototype.exec = function () {
          var m = this.options, I = m.listType, D = m.listTarget, g = m.$selectionElem, S = m.$startElem, x = m.$endElem, R, N = [], T = g == null ? void 0 : g.getNodeName(), H = S.prior, B = x.prior;
          if (!S.prior && !x.prior || !(H != null && H.prev().length) && !(B != null && B.next().length)) {
            var L;
            (0, p.default)(L = g == null ? void 0 : g.children()).call(L, function (W) {
              N.push(v.default(W));
            }), T === I ? R = y.createElementFragment(
              N,
              y.createDocumentFragment(),
              "p"
            ) : (R = y.createElement(D), (0, p.default)(N).call(N, function (W) {
              R.appendChild(W.elems[0]);
            })), this.selectionRangeElem.set(R), y.insertBefore(g, R, g.elems[0]), g.remove();
          } else {
            for (var P = H; P.length;)
              N.push(P), B != null && B.equal(P) ? P = v.default(void 0) : P = P.next();
            var C = H.prev(), M = B.next();
            if (T === I ? R = y.createElementFragment(
              N,
              y.createDocumentFragment(),
              "p"
            ) : (R = y.createElement(D), (0, p.default)(N).call(N, function (W) {
              R.append(W.elems[0]);
            })), C.length && M.length) {
              for (var k = []; M.length;)
                k.push(M), M = M.next();
              var F = y.createElement(T);
              (0, p.default)(k).call(k, function (W) {
                F.append(W.elems[0]);
              }), v.default(F).insertAfter(g), this.selectionRangeElem.set(R);
              var j = g.next();
              j.length ? y.insertBefore(g, R, j.elems[0]) : g.parent().elems[0].append(R);
            } else if (!C.length)
              this.selectionRangeElem.set(R), y.insertBefore(g, R, g.elems[0]);
            else {
              this.selectionRangeElem.set(R);
              var j = g.next();
              j.length ? y.insertBefore(g, R, j.elems[0]) : g.parent().elems[0].append(R);
            }
          }
        }, h;
      }(b.ListHandle);
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = function () {
        function v() {
          this._element = null;
        }
        return v.prototype.set = function (b) {
          if (b instanceof DocumentFragment) {
            var y, E = [];
            (0, p.default)(y = b.childNodes).call(y, function (w) {
              E.push(w);
            }), b = E;
          }
          this._element = b;
        }, v.prototype.get = function () {
          return this._element;
        }, v.prototype.clear = function () {
          this._element = null;
        }, v;
      }();
      l.default = c;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = n(58), y = n(47), E = function (w) {
        c.__extends(h, w);
        function h(m) {
          return w.call(this, m) || this;
        }
        return h.prototype.exec = function () {
          var m, I, D, g, S, x, R, N = this.options, T = N.editor, H = N.listType, B = N.listTarget, L = N.$startElem, P = N.$endElem, C, M = T.selection.getSelectionRangeTopNodes(), k = L == null ? void 0 : L.getNodeName(), F = P == null ? void 0 : P.getNodeName();
          if (k === F)
            if (M.length > 2)
              if (M.shift(), M.pop(), C = y.createElementFragment(
                y.filterSelectionNodes(M),
                y.createDocumentFragment()
              ), k === H)
                (m = P.children()) === null || m === void 0 || (0, p.default)(m).call(m, function (le) {
                  C.append(le);
                }), P.remove(), this.selectionRangeElem.set(C), L.elems[0].append(C);
              else {
                for (var j = document.createDocumentFragment(), W = document.createDocumentFragment(), Q = y.getStartPoint(L); Q.length;) {
                  var ne = Q.elems[0];
                  Q = Q.next(), j.append(ne);
                }
                for (var te = y.getEndPoint(P), q = []; te.length;)
                  q.unshift(te.elems[0]), te = te.prev();
                (0, p.default)(q).call(q, function (le) {
                  W.append(le);
                });
                var ge = y.createElement(B);
                ge.append(j), ge.append(C), ge.append(W), C = ge, this.selectionRangeElem.set(C), v.default(ge).insertAfter(L), !(!((I = L.children()) === null || I === void 0) && I.length) && L.remove(), !(!((D = P.children()) === null || D === void 0) && D.length) && P.remove();
              }
            else {
              M.length = 0;
              for (var Q = y.getStartPoint(L); Q.length;)
                M.push(Q), Q = Q.next();
              for (var te = y.getEndPoint(P), q = []; te.length;)
                q.unshift(te), te = te.prev();
              M.push.apply(M, q), k === H ? (C = y.createElementFragment(M, y.createDocumentFragment(), "p"), this.selectionRangeElem.set(C), y.insertBefore(L, C, P.elems[0])) : (C = y.createElement(B), (0, p.default)(M).call(M, function (se) {
                C.append(se.elems[0]);
              }), this.selectionRangeElem.set(C), v.default(C).insertAfter(L)), !(!((g = L.children()) === null || g === void 0) && g.length) && P.remove(), !(!((S = P.children()) === null || S === void 0) && S.length) && P.remove();
            }
          else {
            for (var be = [], te = y.getEndPoint(P); te.length;)
              be.unshift(te), te = te.prev();
            for (var me = [], Q = y.getStartPoint(L); Q.length;)
              me.push(Q), Q = Q.next();
            if (C = y.createDocumentFragment(), M.shift(), M.pop(), (0, p.default)(me).call(me, function (he) {
              return C.append(he.elems[0]);
            }), C = y.createElementFragment(
              y.filterSelectionNodes(M),
              C
            ), (0, p.default)(be).call(be, function (he) {
              return C.append(he.elems[0]);
            }), this.selectionRangeElem.set(C), k === H)
              L.elems[0].append(C), !(!((x = P.children()) === null || x === void 0) && x.length) && P.remove();
            else if (!((R = P.children()) === null || R === void 0) && R.length) {
              var ae = P.children();
              y.insertBefore(ae, C, ae.elems[0]);
            } else
              P.elems[0].append(C);
          }
        }, h;
      }(b.ListHandle);
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = n(58), y = n(47), E = function (w) {
        c.__extends(h, w);
        function h(m) {
          return w.call(this, m) || this;
        }
        return h.prototype.exec = function () {
          var m, I = this.options, D = I.editor, g = I.listType, S = I.listTarget, x = I.$startElem, R, N = D.selection.getSelectionRangeTopNodes(), T = x == null ? void 0 : x.getNodeName();
          N.shift();
          for (var H = [], B = y.getStartPoint(x); B.length;)
            H.push(B), B = B.next();
          T === g ? (R = y.createDocumentFragment(), (0, p.default)(H).call(H, function (L) {
            return R.append(L.elems[0]);
          }), R = y.createElementFragment(
            y.filterSelectionNodes(N),
            R
          ), this.selectionRangeElem.set(R), x.elems[0].append(R)) : (R = y.createElement(S), (0, p.default)(H).call(H, function (L) {
            return R.append(L.elems[0]);
          }), R = y.createElementFragment(
            y.filterSelectionNodes(N),
            R
          ), this.selectionRangeElem.set(R), v.default(R).insertAfter(x), !(!((m = x.children()) === null || m === void 0) && m.length) && x.remove());
        }, h;
      }(b.ListHandle);
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = n(58), y = n(47), E = function (w) {
        c.__extends(h, w);
        function h(m) {
          return w.call(this, m) || this;
        }
        return h.prototype.exec = function () {
          var m, I, D = this.options, g = D.editor, S = D.listType, x = D.listTarget, R = D.$endElem, N, T = g.selection.getSelectionRangeTopNodes(), H = R == null ? void 0 : R.getNodeName();
          T.pop();
          for (var B = [], L = y.getEndPoint(R); L.length;)
            B.unshift(L), L = L.prev();
          if (H === S)
            if (N = y.createElementFragment(
              y.filterSelectionNodes(T),
              y.createDocumentFragment()
            ), (0, p.default)(B).call(B, function (M) {
              return N.append(M.elems[0]);
            }), this.selectionRangeElem.set(N), !((m = R.children()) === null || m === void 0) && m.length) {
              var P = R.children();
              y.insertBefore(P, N, P.elems[0]);
            } else
              R.elems[0].append(N);
          else {
            var C = y.filterSelectionNodes(T);
            C.push.apply(C, B), N = y.createElementFragment(
              C,
              y.createElement(x)
            ), this.selectionRangeElem.set(N), v.default(N).insertBefore(R), !(!((I = R.children()) === null || I === void 0) && I.length) && R.remove();
          }
        }, h;
      }(b.ListHandle);
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = n(58), v = n(47), b = function (y) {
        p.__extends(E, y);
        function E(w, h) {
          var m = y.call(this, w) || this;
          return m.range = h, m;
        }
        return E.prototype.exec = function () {
          var w = this.options, h = w.editor, m = w.listTarget, I = h.selection.getSelectionRangeTopNodes(), D = v.createElementFragment(
            v.filterSelectionNodes(I),
            v.createElement(m)
          );
          this.selectionRangeElem.set(D), this.range.insertNode(D);
        }, E;
      }(c.ListHandle);
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(27));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(24)), y = v.__importDefault(n(3)), E = v.__importDefault(n(379)), w = n(6), h = function (m) {
        v.__extends(I, m);
        function I(D) {
          var g = this, S = y.default(`<div class="w-e-menu" data-title="\u884C\u9AD8">
                    <i class="w-e-icon-row-height"></i>
                </div>`), x = new E.default(D, D.config.lineHeights), R = {
              width: 100, title: "\u8BBE\u7F6E\u884C\u9AD8", type: "list", list: x.getItemList(), clickHandler: function (T) {
                D.selection.saveRange(), g.command(T);
              }
            };
          return g = m.call(this, S, D, R) || this, g;
        }
        return I.prototype.command = function (D) {
          var g = this, S, x = window.getSelection ? window.getSelection() : document.getSelection(), R = ["P"], N = this.editor, T = "";
          N.selection.restoreSelection();
          var H = y.default(N.selection.getSelectionContainerElem());
          if (!!(H != null && H.length)) {
            var B = y.default(N.selection.getSelectionContainerElem()), L = y.default(N.selection.getSelectionStartElem()).elems[0], P = "", C = [], M = "";
            if (H && N.$textElem.equal(H)) {
              var k = w.UA.isIE(), F = [], j = [], W = [], Q = y.default(N.selection.getSelectionStartElem()), ne = y.default(N.selection.getSelectionEndElem()), te = (S = N.selection.getRange()) === null || S === void 0 ? void 0 : S.commonAncestorContainer.childNodes;
              j.push(this.getDom(Q.elems[0])), te == null || (0, p.default)(te).call(te, function (ae, le) {
                ae === g.getDom(Q.elems[0]) && F.push(le), ae === g.getDom(ne.elems[0]) && F.push(le);
              });
              var q = 0, ge = void 0;
              for (W.push(this.getDom(Q.elems[0])); j[q] !== this.getDom(ne.elems[0]);)
                ge = y.default(j[q].nextElementSibling).elems[0], (0, c.default)(R).call(R, y.default(ge).getNodeName()) !== -1 && W.push(ge), j.push(ge), q++;
              if (y.default(j[0]).getNodeName() !== "P") {
                q = 0;
                for (var be = 0; be < j.length; be++)
                  if (y.default(j[be]).getNodeName() === "P") {
                    q = be;
                    break;
                  }
                if (q === 0)
                  return;
                for (var me = 0; me !== q;)
                  j.shift(), me++;
              }
              this.setRange(j[0], j[j.length - 1]), (0, p.default)(j).call(j, function (ae) {
                P = ae.getAttribute("style"), C = P ? P.split(";") : [], M = g.styleProcessing(C), y.default(ae).getNodeName() === "P" && D && (M += D ? "line-height:" + D + ";" : ""), k ? y.default(ae).css("line-height", D) : T += "<" + y.default(ae).getNodeName().toLowerCase() + ' style="' + M + '">' + ae.innerHTML + "</" + y.default(ae).getNodeName().toLowerCase() + ">";
              }), T && this.action(T, N), L = B.elems[0], this.setRange(L.children[F[0]], L.children[F[1]]);
              return;
            }
            if (L = this.getDom(L), (0, c.default)(R).call(R, y.default(L).getNodeName()) !== -1) {
              if (P = L.getAttribute("style"), C = P ? P.split(";") : [], x == null || x.selectAllChildren(L), N.selection.saveRange(), !D) {
                P && (M = this.styleProcessing(C), M === "" ? T = "<" + y.default(L).getNodeName().toLowerCase() + ">" + L.innerHTML + "</" + y.default(L).getNodeName().toLowerCase() + ">" : T = "<" + y.default(L).getNodeName().toLowerCase() + ' style="' + M + '">' + L.innerHTML + "</" + y.default(L).getNodeName().toLowerCase() + ">", this.action(T, N));
                return;
              }
              P ? M = this.styleProcessing(C) + ("line-height:" + D + ";") : M = "line-height:" + D + ";", T = "<" + y.default(L).getNodeName().toLowerCase() + ' style="' + M + '">' + L.innerHTML + "</" + y.default(L).getNodeName().toLowerCase() + ">", y.default(L).getNodeName() === "BLOCKQUOTE" || w.UA.isIE() ? y.default(L).css("line-height", D) : this.action(T, N);
            }
          }
        }, I.prototype.getDom = function (D) {
          var g = y.default(D).elems[0];
          if (!g.parentNode)
            return g;
          function S(x, R) {
            var N = y.default(x.parentNode);
            return R.$textElem.equal(N) ? x : S(N.elems[0], R);
          }
          return g = S(g, this.editor), g;
        }, I.prototype.action = function (D, g) {
          g.cmd.do("insertHTML", D);
        }, I.prototype.styleProcessing = function (D) {
          var g = "";
          return (0, p.default)(D).call(D, function (S) {
            S !== "" && (0, c.default)(S).call(S, "line-height") === -1 && (g = g + S + ";");
          }), g;
        }, I.prototype.setRange = function (D, g) {
          var S = this.editor, x = window.getSelection ? window.getSelection() : document.getSelection();
          x == null || x.removeAllRanges();
          var R = document.createRange(), N = D, T = g;
          R.setStart(N, 0), R.setEnd(T, 1), x == null || x.addRange(R), S.selection.saveRange(), x == null || x.removeAllRanges(), S.selection.restoreSelection();
        }, I.prototype.tryChangeActive = function () {
          var D = this.editor, g = D.selection.getSelectionContainerElem();
          if (!(g && D.$textElem.equal(g))) {
            var S = y.default(D.selection.getSelectionStartElem());
            if (S.length !== 0) {
              S = this.getDom(S.elems[0]);
              var x = S.getAttribute("style") ? S.getAttribute("style") : "";
              x && (0, c.default)(x).call(x, "line-height") !== -1 ? this.active() : this.unActive();
            }
          }
        }, I;
      }(b.default);
      l.default = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = function () {
        function y(E, w) {
          var h = this;
          this.itemList = [{ $elem: v.default("<span>" + E.i18next.t("\u9ED8\u8BA4") + "</span>"), value: "" }], (0, p.default)(w).call(w, function (m) {
            h.itemList.push({ $elem: v.default("<span>" + m + "</span>"), value: m });
          });
        }
        return y.prototype.getItemList = function () {
          return this.itemList;
        }, y;
      }();
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(23)), b = function (y) {
        p.__extends(E, y);
        function E(w) {
          var h = this, m = c.default(`<div class="w-e-menu" data-title="\u64A4\u9500">
                <i class="w-e-icon-undo"></i>
            </div>`);
          return h = y.call(this, m, w) || this, h;
        }
        return E.prototype.clickHandler = function () {
          var w = this.editor;
          w.history.revoke();
          var h = w.$textElem.children();
          if (!!(h != null && h.length)) {
            var m = h.last();
            w.selection.createRangeByElem(m, !1, !0), w.selection.restoreSelection();
          }
        }, E.prototype.tryChangeActive = function () {
          this.editor.isCompatibleMode || (this.editor.history.size[0] ? this.active() : this.unActive());
        }, E;
      }(v.default);
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(23)), b = function (y) {
        p.__extends(E, y);
        function E(w) {
          var h = this, m = c.default(`<div class="w-e-menu" data-title="\u6062\u590D">
                <i class="w-e-icon-redo"></i>
            </div>`);
          return h = y.call(this, m, w) || this, h;
        }
        return E.prototype.clickHandler = function () {
          var w = this.editor;
          w.history.restore();
          var h = w.$textElem.children();
          if (!!(h != null && h.length)) {
            var m = h.last();
            w.selection.createRangeByElem(m, !1, !0), w.selection.restoreSelection();
          }
        }, E.prototype.tryChangeActive = function () {
          this.editor.isCompatibleMode || (this.editor.history.size[1] ? this.active() : this.unActive());
        }, E;
      }(v.default);
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(37)), v = p.__importDefault(n(3)), b = p.__importDefault(n(383)), y = p.__importDefault(n(32)), E = p.__importDefault(n(392)), w = function (h) {
        p.__extends(m, h);
        function m(I) {
          var D = this, g = v.default('<div class="w-e-menu" data-title="\u8868\u683C"><i class="w-e-icon-table2"></i></div>');
          return D = h.call(this, g, I) || this, E.default(I), D;
        }
        return m.prototype.clickHandler = function () {
          this.createPanel();
        }, m.prototype.createPanel = function () {
          var I = b.default(this.editor), D = new y.default(this, I);
          D.create();
        }, m.prototype.tryChangeActive = function () {
        }, m;
      }(c.default);
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(384));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = n(6), b = c.__importDefault(n(3));
      n(389);
      var y = c.__importDefault(n(391));
      function E(h) {
        return h > 0 && (0, p.default)(h);
      }
      function w(h) {
        var m = new y.default(h), I = v.getRandom("w-col-id"), D = v.getRandom("w-row-id"), g = v.getRandom("btn-link"), S = "menus.panelMenus.table.", x = function (H) {
          return h.i18next.t(H);
        }, R = [{
          title: x(S + "\u63D2\u5165\u8868\u683C"), tpl: `<div>
                    <div class="w-e-table">
                        <span>` + x("\u521B\u5EFA") + `</span>
                        <input id="` + D + `"  type="text" class="w-e-table-input" value="5"/></td>
                        <span>` + x(S + "\u884C") + `</span>
                        <input id="` + I + `" type="text" class="w-e-table-input" value="5"/></td>
                        <span>` + (x(S + "\u5217") + x(S + "\u7684") + x(S + "\u8868\u683C")) + `</span>
                    </div>
                    <div class="w-e-button-container">
                        <button type="button" id="` + g + '" class="right">' + x("\u63D2\u5165") + `</button>
                    </div>
                </div>`, events: [{
            selector: "#" + g, type: "click", fn: function () {
              var H = Number(b.default("#" + I).val()), B = Number(b.default("#" + D).val());
              return E(B) && E(H) ? (m.createAction(B, H), !0) : (h.config.customAlert("\u8868\u683C\u884C\u5217\u8BF7\u8F93\u5165\u6B63\u6574\u6570", "warning"), !1);
            }, bindEnter: !0
          }]
        }], N = { width: 330, height: 0, tabs: [] };
        return N.tabs.push(R[0]), N;
      }
      l.default = w;
    }, function (i, l, n) {
      i.exports = n(385);
    }, function (i, l, n) {
      var u = n(386);
      i.exports = u;
    }, function (i, l, n) {
      n(387);
      var u = n(9);
      i.exports = u.Number.isInteger;
    }, function (i, l, n) {
      var u = n(5), f = n(388);
      u({ target: "Number", stat: !0 }, { isInteger: f });
    }, function (i, l, n) {
      var u = n(13), f = Math.floor;
      i.exports = function (c) {
        return !u(c) && isFinite(c) && f(c) === c;
      };
    }, function (i, l, n) {
      var u = n(20), f = n(390);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-table {
  display: flex;
}
.w-e-table .w-e-table-input {
  width: 40px;
  text-align: center!important;
  margin: 0 5px;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = n(7), v = p.__importDefault(n(3)), b = function () {
        function y(E) {
          this.editor = E;
        }
        return y.prototype.createAction = function (E, w) {
          var h = this.editor, m = v.default(h.selection.getSelectionContainerElem()), I = v.default(m.elems[0]).parentUntilEditor("UL", h), D = v.default(m.elems[0]).parentUntilEditor("OL", h);
          if (!(I || D)) {
            var g = this.createTableHtml(E, w);
            h.cmd.do("insertHTML", g);
          }
        }, y.prototype.createTableHtml = function (E, w) {
          for (var h = "", m = "", I = 0; I < E; I++) {
            m = "";
            for (var D = 0; D < w; D++)
              I === 0 ? m = m + "<th></th>" : m = m + "<td></td>";
            h = h + "<tr>" + m + "</tr>";
          }
          var g = '<table border="0" width="100%" cellpadding="0" cellspacing="0"><tbody>' + h + ("</tbody></table>" + c.EMPTY_P);
          return g;
        }, y;
      }();
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(393)), v = n(400);
      function b(y) {
        c.default(y), v.bindEventKeyboardEvent(y), v.bindClickEvent(y);
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(38)), b = p.__importDefault(n(394)), y = p.__importDefault(n(399)), E = n(7);
      function w(D) {
        var g;
        function S(R) {
          var N = new y.default(D), T = "menus.panelMenus.table.", H = function (P, C) {
            return C === void 0 && (C = T), D.i18next.t(C + P);
          }, B = [{
            $elem: c.default("<span>" + H("\u5220\u9664\u8868\u683C") + "</span>"),
            onClick: function (P, C) {
              return P.selection.createRangeByElem(C), P.selection.restoreSelection(), P.cmd.do("insertHTML", E.EMPTY_P), !0;
            }
          }, {
            $elem: c.default("<span>" + H("\u6DFB\u52A0\u884C") + "</span>"), onClick: function (P, C) {
              var M = h(P);
              if (M)
                return !0;
              var k = c.default(P.selection.getSelectionStartElem()), F = N.getRowNode(k.elems[0]);
              if (!F)
                return !0;
              var j = Number(N.getCurrentRowIndex(C.elems[0], F)), W = N.getTableHtml(C.elems[0]), Q = N.getTableHtml(b.default.ProcessingRow(c.default(W), j).elems[0]);
              return Q = I(C, Q), P.selection.createRangeByElem(C), P.selection.restoreSelection(), P.cmd.do("insertHTML", Q), !0;
            }
          }, {
            $elem: c.default("<span>" + H("\u5220\u9664\u884C") + "</span>"), onClick: function (P, C) {
              var M = h(P);
              if (M)
                return !0;
              var k = c.default(P.selection.getSelectionStartElem()), F = N.getRowNode(k.elems[0]);
              if (!F)
                return !0;
              var j = Number(N.getCurrentRowIndex(C.elems[0], F)), W = N.getTableHtml(C.elems[0]), Q = b.default.DeleteRow(c.default(W), j).elems[0].children[0].children.length, ne = "";
              return P.selection.createRangeByElem(C), P.selection.restoreSelection(), Q === 0 ? ne = E.EMPTY_P : ne = N.getTableHtml(b.default.DeleteRow(c.default(W), j).elems[0]), ne = I(C, ne), P.cmd.do("insertHTML", ne), !0;
            }
          }, {
            $elem: c.default("<span>" + H("\u6DFB\u52A0\u5217") + "</span>"), onClick: function (P, C) {
              var M = h(P);
              if (M)
                return !0;
              var k = c.default(P.selection.getSelectionStartElem()), F = N.getCurrentColIndex(k.elems[0]), j = N.getTableHtml(C.elems[0]), W = N.getTableHtml(b.default.ProcessingCol(c.default(j), F).elems[0]);
              return W = I(C, W), P.selection.createRangeByElem(C), P.selection.restoreSelection(), P.cmd.do("insertHTML", W), !0;
            }
          }, {
            $elem: c.default("<span>" + H("\u5220\u9664\u5217") + "</span>"), onClick: function (P, C) {
              var M = h(P);
              if (M)
                return !0;
              var k = c.default(P.selection.getSelectionStartElem()), F = N.getCurrentColIndex(k.elems[0]), j = N.getTableHtml(C.elems[0]), W = b.default.DeleteCol(c.default(j), F), Q = W.elems[0].children[0].children[0].children.length, ne = "";
              return P.selection.createRangeByElem(C), P.selection.restoreSelection(), Q === 0 ? ne = E.EMPTY_P : ne = N.getTableHtml(W.elems[0]), ne = I(C, ne), P.cmd.do("insertHTML", ne), !0;
            }
          }, {
            $elem: c.default("<span>" + H("\u8BBE\u7F6E\u8868\u5934") + "</span>"), onClick: function (P, C) {
              var M = h(P);
              if (M)
                return !0;
              var k = c.default(P.selection.getSelectionStartElem()), F = N.getRowNode(k.elems[0]);
              if (!F)
                return !0;
              var j = Number(N.getCurrentRowIndex(C.elems[0], F));
              j !== 0 && (j = 0);
              var W = N.getTableHtml(C.elems[0]), Q = N.getTableHtml(b.default.setTheHeader(c.default(W), j, "th").elems[0]);
              return Q = I(C, Q), P.selection.createRangeByElem(C), P.selection.restoreSelection(), P.cmd.do("insertHTML", Q), !0;
            }
          }, {
            $elem: c.default("<span>" + H("\u53D6\u6D88\u8868\u5934") + "</span>"), onClick: function (P, C) {
              var M = c.default(P.selection.getSelectionStartElem()), k = N.getRowNode(M.elems[0]);
              if (!k)
                return !0;
              var F = Number(N.getCurrentRowIndex(C.elems[0], k));
              F !== 0 && (F = 0);
              var j = N.getTableHtml(C.elems[0]), W = N.getTableHtml(b.default.setTheHeader(c.default(j), F, "td").elems[0]);
              return W = I(C, W), P.selection.createRangeByElem(C), P.selection.restoreSelection(), P.cmd.do("insertHTML", W), !0;
            }
          }];
          g = new v.default(D, R, B), g.create();
        }
        function x() {
          g && (g.remove(), g = null);
        }
        return { showTableTooltip: S, hideTableTooltip: x };
      }
      function h(D) {
        var g = D.selection.getSelectionStartElem(), S = D.selection.getSelectionEndElem();
        return (g == null ? void 0 : g.elems[0]) !== (S == null ? void 0 : S.elems[0]);
      }
      function m(D) {
        var g = w(D), S = g.showTableTooltip, x = g.hideTableTooltip;
        D.txt.eventHooks.tableClickEvents.push(S), D.txt.eventHooks.clickEvents.push(x), D.txt.eventHooks.keyupEvents.push(x), D.txt.eventHooks.toolbarClickEvents.push(x), D.txt.eventHooks.menuClickEvents.push(x), D.txt.eventHooks.textScrollEvents.push(x);
      }
      l.default = m;
      function I(D, g) {
        var S = D.elems[0].nextSibling;
        return (!S || S.innerHTML === "<br>") && (g += "" + E.EMPTY_P), g;
      }
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(45)), c = u(n(91)), v = u(n(4)), b = u(n(138));
      (0, f.default)(l, "__esModule", { value: !0 });
      var y = n(2), E = y.__importDefault(n(3));
      function w(x, R) {
        for (var N = S(x), T = (0, p.default)(Array.prototype).apply(N.children), H = T[0].children.length, B = document.createElement("tr"), L = 0; L < H; L++) {
          var P = document.createElement("td");
          B.appendChild(P);
        }
        return (0, c.default)(T).call(T, R + 1, 0, B), g(N, T), E.default(N.parentNode);
      }
      function h(x, R) {
        for (var N = S(x), T = (0, p.default)(Array.prototype).apply(N.children), H = function (P) {
          var C, M = [];
          for ((0, v.default)(C = (0, b.default)(T[P].children)).call(C, function (j) {
            M.push(j);
          }); T[P].children.length !== 0;)
            T[P].removeChild(T[P].children[0]);
          var k = E.default(M[0]).getNodeName() !== "TH" ? document.createElement("td") : document.createElement("th");
          (0, c.default)(M).call(M, R + 1, 0, k);
          for (var F = 0; F < M.length; F++)
            T[P].appendChild(M[F]);
        }, B = 0; B < T.length; B++)
          H(B);
        return g(N, T), E.default(N.parentNode);
      }
      function m(x, R) {
        var N = S(x), T = (0, p.default)(Array.prototype).apply(N.children);
        return (0, c.default)(T).call(T, R, 1), g(N, T), E.default(N.parentNode);
      }
      function I(x, R) {
        for (var N = S(x), T = (0, p.default)(Array.prototype).apply(N.children), H = function (P) {
          var C, M = [];
          for ((0, v.default)(C = (0, b.default)(T[P].children)).call(C, function (F) {
            M.push(F);
          }); T[P].children.length !== 0;)
            T[P].removeChild(T[P].children[0]);
          (0, c.default)(M).call(M, R, 1);
          for (var k = 0; k < M.length; k++)
            T[P].appendChild(M[k]);
        }, B = 0; B < T.length; B++)
          H(B);
        return g(N, T), E.default(N.parentNode);
      }
      function D(x, R, N) {
        for (var T = S(x), H = (0, p.default)(Array.prototype).apply(T.children), B = H[R].children, L = document.createElement("tr"), P = function (k) {
          var F, j = document.createElement(N), W = B[k];
          (0, v.default)(F = (0, b.default)(W.childNodes)).call(F, function (Q) {
            j.appendChild(Q);
          }), L.appendChild(j);
        }, C = 0; C < B.length; C++)
          P(C);
        return (0, c.default)(H).call(H, R, 1, L), g(T, H), E.default(T.parentNode);
      }
      function g(x, R) {
        for (; x.children.length !== 0;)
          x.removeChild(x.children[0]);
        for (var N = 0; N < R.length; N++)
          x.appendChild(R[N]);
      }
      function S(x) {
        var R = x.elems[0].children[0];
        return R.nodeName === "COLGROUP" && (R = x.elems[0].children[x.elems[0].children.length - 1]), R;
      }
      l.default = { ProcessingRow: w, ProcessingCol: h, DeleteRow: m, DeleteCol: I, setTheHeader: D };
    }, function (i, l, n) {
      var u = n(396);
      i.exports = u;
    }, function (i, l, n) {
      n(50), n(397);
      var u = n(9);
      i.exports = u.Array.from;
    }, function (i, l, n) {
      var u = n(5), f = n(398), p = n(114), c = !p(function (v) {
        Array.from(v);
      });
      u({ target: "Array", stat: !0, forced: c }, { from: f });
    }, function (i, l, n) {
      var u = n(39), f = n(29), p = n(113), c = n(111), v = n(34), b = n(69), y = n(112);
      i.exports = function (w) {
        var h = f(w), m = typeof this == "function" ? this : Array, I = arguments.length, D = I > 1 ? arguments[1] : void 0, g = D !== void 0, S = y(h), x = 0, R, N, T, H, B, L;
        if (g && (D = u(D, I > 2 ? arguments[2] : void 0, 2)), S != null && !(m == Array && c(S)))
          for (H = S.call(h), B = H.next, N = new m(); !(T = B.call(H)).done; x++)
            L = g ? p(H, D, [T.value, x], !0) : T.value, b(N, x, L);
        else
          for (R = v(h.length), N = new m(R); R > x; x++)
            L = g ? D(h[x], x) : h[x], b(N, x, L);
        return N.length = x, N;
      };
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(138));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(3)), y = function () {
        function E(w) {
          this.editor = w;
        }
        return E.prototype.getRowNode = function (w) {
          var h, m = b.default(w).elems[0];
          return m.parentNode && (m = (h = b.default(m).parentUntil("TR", m)) === null || h === void 0 ? void 0 : h.elems[0]), m;
        }, E.prototype.getCurrentRowIndex = function (w, h) {
          var m, I = 0, D = w.children[0];
          return D.nodeName === "COLGROUP" && (D = w.children[w.children.length - 1]), (0, p.default)(m = (0, c.default)(D.children)).call(m, function (g, S) {
            g === h && (I = S);
          }), I;
        }, E.prototype.getCurrentColIndex = function (w) {
          var h, m, I = 0, D = b.default(w).getNodeName() === "TD" || b.default(w).getNodeName() === "TH" ? w : (m = b.default(w).parentUntil("TD", w)) === null || m === void 0 ? void 0 : m.elems[0], g = b.default(D).parent();
          return (0, p.default)(h = (0, c.default)(g.elems[0].children)).call(h, function (S, x) {
            S === D && (I = x);
          }), I;
        }, E.prototype.getTableHtml = function (w) {
          var h = '<table border="0" width="100%" cellpadding="0" cellspacing="0">' + b.default(w).html() + "</table>";
          return h;
        }, E;
      }();
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.bindEventKeyboardEvent = l.bindClickEvent = void 0;
      var p = n(2), c = p.__importDefault(n(3));
      function v(E) {
        if (!E.length)
          return !1;
        var w = E.elems[0];
        return w.nodeName === "P" && w.innerHTML === "<br>";
      }
      function b(E) {
        function w(h, m) {
          if (m.detail >= 3) {
            var I = window.getSelection();
            if (I) {
              var D = I.focusNode, g = I.anchorNode, S = c.default(g == null ? void 0 : g.parentElement);
              if (!h.isContain(c.default(D))) {
                var x = S.elems[0].tagName === "TD" ? S : S.parentUntilEditor("td", E);
                if (x) {
                  var R = E.selection.getRange();
                  R == null || R.setEnd(x.elems[0], x.elems[0].childNodes.length), E.selection.restoreSelection();
                }
              }
            }
          }
        }
        E.txt.eventHooks.tableClickEvents.push(w);
      }
      l.bindClickEvent = b;
      function y(E) {
        var w = E.txt, h = E.selection, m = w.eventHooks.keydownEvents;
        m.push(function (I) {
          E.selection.saveRange();
          var D = h.getSelectionContainerElem();
          if (D) {
            var g = D.getNodeTop(E), S = g.length && g.prev().length ? g.prev() : null;
            if (S && S.getNodeName() === "TABLE" && h.isSelectionEmpty() && h.getCursorPos() === 0 && I.keyCode === 8) {
              var x = g.next(), R = !!x.length;
              R && v(g) && (g.remove(), E.selection.setRangeToElem(x.elems[0])), I.preventDefault();
            }
          }
        });
      }
      l.bindEventKeyboardEvent = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(26));
      (0, f.default)(l, "__esModule", { value: !0 }), l.formatCodeHtml = void 0;
      var c = n(2), v = c.__importDefault(n(37)), b = c.__importDefault(n(3)), y = n(6), E = c.__importDefault(n(402)), w = c.__importDefault(n(139)), h = c.__importDefault(n(32)), m = c.__importDefault(n(403));
      function I(g, S) {
        if (!S)
          return S;
        return S = R(S), S = x(S), S = y.replaceSpecialSymbol(S), S;
        function x(N) {
          var T = N.match(/<pre[\s|\S]+?\/pre>/g);
          return T === null || (0, p.default)(T).call(T, function (H) {
            N = N.replace(H, H.replace(/<\/code><code>/g, `
`).replace(/<br>/g, ""));
          }), N;
        }
        function R(N) {
          var T, H = N.match(/<span\sclass="hljs[\s|\S]+?\/span>/gm);
          if (!H || !H.length)
            return N;
          for (var B = (0, p.default)(T = y.deepClone(H)).call(T, function (P) {
            return P = P.replace(/<span\sclass="hljs[^>]+>/, ""), P.replace(/<\/span>/, "");
          }), L = 0; L < H.length; L++)
            N = N.replace(H[L], B[L]);
          return R(N);
        }
      }
      l.formatCodeHtml = I;
      var D = function (g) {
        c.__extends(S, g);
        function S(x) {
          var R = this, N = b.default('<div class="w-e-menu" data-title="\u4EE3\u7801"><i class="w-e-icon-terminal"></i></div>');
          return R = g.call(this, N, x) || this, m.default(x), R;
        }
        return S.prototype.insertLineCode = function (x) {
          var R = this.editor, N = b.default("<code>" + x + "</code>");
          R.cmd.do("insertElem", N), R.selection.createRangeByElem(N, !1), R.selection.restoreSelection();
        }, S.prototype.clickHandler = function () {
          var x = this.editor, R = x.selection.getSelectionText();
          this.isActive || (x.selection.isSelectionEmpty() ? this.createPanel("", "") : this.insertLineCode(R));
        }, S.prototype.createPanel = function (x, R) {
          var N = E.default(this.editor, x, R), T = new h.default(this, N);
          T.create();
        }, S.prototype.tryChangeActive = function () {
          var x = this.editor;
          w.default(x) ? this.active() : this.unActive();
        }, S;
      }(v.default);
      l.default = D;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(26));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = n(6), b = c.__importDefault(n(3)), y = c.__importDefault(n(139)), E = n(7);
      function w(h, m, I) {
        var D, g = v.getRandom("input-iframe"), S = v.getRandom("select"), x = v.getRandom("btn-ok");
        function R(B) {
          var L, P = y.default(h);
          P && N();
          var C = (L = h.selection.getSelectionStartElem()) === null || L === void 0 ? void 0 : L.elems[0].innerHTML;
          C && h.cmd.do("insertHTML", E.EMPTY_P), h.cmd.do("insertHTML", B);
          var M = h.selection.getSelectionStartElem(), k = M == null ? void 0 : M.getNodeTop(h);
          (k == null ? void 0 : k.getNextSibling().elems.length) === 0 && b.default(E.EMPTY_P).insertAfter(k);
        }
        function N() {
          if (!!y.default(h)) {
            var B = h.selection.getSelectionStartElem(), L = B == null ? void 0 : B.getNodeTop(h);
            !L || (h.selection.createRangeByElem(L), h.selection.restoreSelection());
          }
        }
        var T = function (L) {
          return h.i18next.t(L);
        }, H = {
          width: 500,
          height: 0,
          tabs: [{
            title: T("menus.panelMenus.code.\u63D2\u5165\u4EE3\u7801"),
            tpl: `<div>
                        <select name="" id="` + S + `">
                            ` + (0, p.default)(D = h.config.languageType).call(D, function (B) {
              return "<option " + (I == B ? "selected" : "") + ' value ="' + B + '">' + B + "</option>";
            }) + `
                        </select>
                        <textarea id="` + g + '" type="text" class="wang-code-textarea" placeholder="" style="height: 160px">' + m.replace(/&quot;/g, '"') + `</textarea>
                        <div class="w-e-button-container">
                            <button type="button" id="` + x + '" class="right">' + (y.default(h) ? T("\u4FEE\u6539") : T("\u63D2\u5165")) + `</button>
                        </div>
                    </div>`,
            events: [
              {
                selector: "#" + x, type: "click", fn: function () {
                  var L, P, C = document.getElementById(g), M = b.default("#" + S), k = M.val(), F = C.value;
                  if (h.highlight ? L = h.highlight.highlightAuto(F).value : L = "<xmp>" + F + "</xmp>", !!F)
                    return y.default(h) ? !1 : (P = '<pre><code class="' + k + '">' + L + "</code></pre>", R(P), !0);
                }
              }
            ]
          }]
        };
        return H;
      }
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(404)), v = p.__importDefault(n(405));
      function b(y) {
        c.default(y), v.default(y);
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.createShowHideFn = void 0;
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(38));
      function b(E) {
        var w;
        function h(I) {
          var D = "menus.panelMenus.code.", g = function (R, N) {
            return N === void 0 && (N = D), E.i18next.t(N + R);
          }, S = [{
            $elem: c.default("<span>" + g("\u5220\u9664\u4EE3\u7801") + "</span>"), onClick: function (R, N) {
              return N.remove(), !0;
            }
          }];
          w = new v.default(E, I, S), w.create();
        }
        function m() {
          w && (w.remove(), w = null);
        }
        return { showCodeTooltip: h, hideCodeTooltip: m };
      }
      l.createShowHideFn = b;
      function y(E) {
        var w = b(E), h = w.showCodeTooltip, m = w.hideCodeTooltip;
        E.txt.eventHooks.codeClickEvents.push(h), E.txt.eventHooks.clickEvents.push(m), E.txt.eventHooks.toolbarClickEvents.push(m), E.txt.eventHooks.menuClickEvents.push(m), E.txt.eventHooks.textScrollEvents.push(m);
      }
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = n(7), v = p.__importDefault(n(3));
      function b(y) {
        var E = y.$textElem, w = y.selection, h = y.txt, m = h.eventHooks.keydownEvents;
        m.push(function (I) {
          var D;
          if (I.keyCode === 40) {
            var g = w.getSelectionContainerElem(), S = (D = E.children()) === null || D === void 0 ? void 0 : D.last();
            if ((g == null ? void 0 : g.elems[0].tagName) === "XMP" && (S == null ? void 0 : S.elems[0].tagName) === "PRE") {
              var x = v.default(c.EMPTY_P);
              E.append(x);
            }
          }
        }), m.push(function (I) {
          y.selection.saveRange();
          var D = w.getSelectionContainerElem();
          if (D) {
            var g = D.getNodeTop(y), S = g == null ? void 0 : g.prev(), x = g == null ? void 0 : g.getNextSibling();
            if (S.length && (S == null ? void 0 : S.getNodeName()) === "PRE" && x.length === 0 && w.getCursorPos() === 0 && I.keyCode === 8) {
              var R = v.default(c.EMPTY_P);
              E.append(R);
            }
          }
        });
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(23)), v = p.__importDefault(n(3)), b = p.__importDefault(n(407)), y = n(6), E = n(7), w = function (h) {
        p.__extends(m, h);
        function m(I) {
          var D = this, g = v.default('<div class="w-e-menu" data-title="\u5206\u5272\u7EBF"><i class="w-e-icon-split-line"></i></div>');
          return D = h.call(this, g, I) || this, b.default(I), D;
        }
        return m.prototype.clickHandler = function () {
          var I = this.editor, D = I.selection.getRange(), g = I.selection.getSelectionContainerElem();
          if (!!(g != null && g.length)) {
            var S = v.default(g.elems[0]), x = S.parentUntil("TABLE", g.elems[0]), R = S.children();
            S.getNodeName() !== "CODE" && (x && v.default(x.elems[0]).getNodeName() === "TABLE" || R && R.length !== 0 && v.default(R.elems[0]).getNodeName() === "IMG" && !(D != null && D.collapsed) || this.createSplitLine());
          }
        }, m.prototype.createSplitLine = function () {
          var I = "<hr/>" + E.EMPTY_P;
          y.UA.isFirefox && (I = "<hr/><p></p>"), this.editor.cmd.do("insertHTML", I);
        }, m.prototype.tryChangeActive = function () {
        }, m;
      }(c.default);
      l.default = w;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(408));
      function v(b) {
        c.default(b);
      }
      l.default = v;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = p.__importDefault(n(38));
      function b(E) {
        var w;
        function h(I) {
          var D = [{
            $elem: c.default("<span>" + E.i18next.t("menus.panelMenus.\u5220\u9664") + "</span>"), onClick: function (S, x) {
              return S.selection.createRangeByElem(x), S.selection.restoreSelection(), S.cmd.do("delete"), !0;
            }
          }];
          w = new v.default(E, I, D), w.create();
        }
        function m() {
          w && (w.remove(), w = null);
        }
        return { showSplitLineTooltip: h, hideSplitLineTooltip: m };
      }
      function y(E) {
        var w = b(E), h = w.showSplitLineTooltip, m = w.hideSplitLineTooltip;
        E.txt.eventHooks.splitLineEvents.push(h), E.txt.eventHooks.clickEvents.push(m), E.txt.eventHooks.keyupEvents.push(m), E.txt.eventHooks.toolbarClickEvents.push(m), E.txt.eventHooks.menuClickEvents.push(m), E.txt.eventHooks.textScrollEvents.push(m);
      }
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = c.__importDefault(n(23)), y = n(97), E = c.__importDefault(n(415)), w = c.__importDefault(n(140)), h = function (m) {
        c.__extends(I, m);
        function I(D) {
          var g = this, S = v.default(`<div class="w-e-menu" data-title="\u5F85\u529E\u4E8B\u9879">
                    <i class="w-e-icon-checkbox-checked"></i>
                </div>`);
          return g = m.call(this, S, D) || this, E.default(D), g;
        }
        return I.prototype.clickHandler = function () {
          var D = this.editor;
          y.isAllTodo(D) ? (this.cancelTodo(), this.tryChangeActive()) : this.setTodo();
        }, I.prototype.tryChangeActive = function () {
          y.isAllTodo(this.editor) ? this.active() : this.unActive();
        }, I.prototype.setTodo = function () {
          var D = this.editor, g = D.selection.getSelectionRangeTopNodes();
          (0, p.default)(g).call(g, function (S) {
            var x, R = S == null ? void 0 : S.getNodeName();
            if (R === "P") {
              var N = w.default(S), T = N.getTodo(), H = (x = T.children()) === null || x === void 0 ? void 0 : x.getNode();
              T.insertAfter(S), D.selection.moveCursor(H), S.remove();
            }
          }), this.tryChangeActive();
        }, I.prototype.cancelTodo = function () {
          var D = this.editor, g = D.selection.getSelectionRangeTopNodes();
          (0, p.default)(g).call(g, function (S) {
            var x, R, N, T = (R = (x = S.childNodes()) === null || x === void 0 ? void 0 : x.childNodes()) === null || R === void 0 ? void 0 : R.clone(!0), H = v.default("<p></p>");
            H.append(T), H.insertAfter(S), (N = H.childNodes()) === null || N === void 0 || N.get(0).remove(), D.selection.moveCursor(H.getNode()), S.remove();
          });
        }, I;
      }(b.default);
      l.default = h;
    }, function (i, l, n) {
      i.exports = n(411);
    }, function (i, l, n) {
      var u = n(412);
      i.exports = u;
    }, function (i, l, n) {
      var u = n(413), f = Array.prototype;
      i.exports = function (p) {
        var c = p.every;
        return p === f || p instanceof Array && c === f.every ? u : c;
      };
    }, function (i, l, n) {
      n(414);
      var u = n(15);
      i.exports = u("Array").every;
    }, function (i, l, n) {
      var u = n(5), f = n(30).every, p = n(67), c = n(22), v = p("every"), b = c("every");
      u({ target: "Array", proto: !0, forced: !v || !b }, {
        every: function (E) {
          return f(this, E, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3)), b = n(97), y = c.__importDefault(n(140)), E = n(97), w = n(7);
      function h(m) {
        function I(x) {
          var R, N;
          if (b.isAllTodo(m)) {
            x.preventDefault();
            var T = m.selection, H = T.getSelectionRangeTopNodes()[0], B = (R = H.childNodes()) === null || R === void 0 ? void 0 : R.get(0), L = (N = window.getSelection()) === null || N === void 0 ? void 0 : N.anchorNode, P = T.getRange();
            if (!(P != null && P.collapsed)) {
              var C = P == null ? void 0 : P.commonAncestorContainer.childNodes, M = P == null ? void 0 : P.startContainer, k = P == null ? void 0 : P.endContainer, F = P == null ? void 0 : P.startOffset, j = P == null ? void 0 : P.endOffset, W = 0, Q = 0, ne = [];
              C == null || (0, p.default)(C).call(C, function (se, Ae) {
                se.contains(M) && (W = Ae), se.contains(k) && (Q = Ae);
              }), Q - W > 1 && (C == null || (0, p.default)(C).call(C, function (se, Ae) {
                Ae <= W || Ae >= Q || ne.push(se);
              }), (0, p.default)(ne).call(ne, function (se) {
                se.remove();
              })), E.dealTextNode(M, F), E.dealTextNode(k, j, !1), m.selection.moveCursor(k, 0);
            }
            if (H.text() === "") {
              var te = v.default(w.EMPTY_P);
              te.insertAfter(H), T.moveCursor(te.getNode()), H.remove();
              return;
            }
            var q = T.getCursorPos(), ge = b.getCursorNextNode(B == null ? void 0 : B.getNode(), L, q), be = y.default(v.default(ge)), me = be.getInputContainer(), ae = me.parent().getNode(), le = be.getTodo(), ue = me.getNode().nextSibling;
            if ((B == null ? void 0 : B.text()) === "" && (B == null || B.append(v.default("<br>"))), le.insertAfter(H), !ue || (ue == null ? void 0 : ue.textContent) === "") {
              if ((ue == null ? void 0 : ue.nodeName) !== "BR") {
                var he = v.default("<br>");
                he.insertAfter(me);
              }
              T.moveCursor(ae, 1);
            } else
              T.moveCursor(ae);
          }
        }
        function D(x) {
          var R, N;
          if (b.isAllTodo(m)) {
            var T = m.selection, H = T.getSelectionRangeTopNodes()[0], B = (R = H.childNodes()) === null || R === void 0 ? void 0 : R.getNode(), L = v.default("<p></p>"), P = L.getNode(), C = (N = window.getSelection()) === null || N === void 0 ? void 0 : N.anchorNode, M = T.getCursorPos(), k = C.previousSibling;
            if (H.text() === "") {
              x.preventDefault();
              var F = v.default(w.EMPTY_P);
              F.insertAfter(H), H.remove(), T.moveCursor(F.getNode(), 0);
              return;
            }
            if ((k == null ? void 0 : k.nodeName) === "SPAN" && k.childNodes[0].nodeName === "INPUT" && M === 0) {
              var j;
              x.preventDefault(), B == null || (0, p.default)(j = B.childNodes).call(j, function (W, Q) {
                Q !== 0 && P.appendChild(W.cloneNode(!0));
              }), L.insertAfter(H), H.remove();
            }
          }
        }
        function g() {
          var x = m.selection, R = x.getSelectionRangeTopNodes()[0];
          R && E.isTodo(R) && R.text() === "" && (v.default(w.EMPTY_P).insertAfter(R), R.remove());
        }
        function S(x) {
          x && x.target instanceof HTMLInputElement && x.target.type === "checkbox" && (x.target.checked ? x.target.setAttribute("checked", "true") : x.target.removeAttribute("checked"));
        }
        m.txt.eventHooks.enterDownEvents.push(I), m.txt.eventHooks.deleteUpEvents.push(g), m.txt.eventHooks.deleteDownEvents.push(D), m.txt.eventHooks.clickEvents.push(S);
      }
      l.default = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.selectorValidator = void 0;
      var p = n(2), c = p.__importDefault(n(3)), v = n(6), b = n(7), y = p.__importDefault(n(129)), E = { border: "1px solid #c9d8db", toolbarBgColor: "#FFF", toolbarBottomBorder: "1px solid #EEE" };
      function w(m) {
        var I = m.toolbarSelector, D = c.default(I), g = m.textSelector, S = m.config, x = S.height, R = m.i18next, N = c.default("<div></div>"), T = c.default("<div></div>"), H, B, L = null;
        g == null ? (B = D.children(), D.append(N).append(T), N.css("background-color", E.toolbarBgColor).css("border", E.border).css("border-bottom", E.toolbarBottomBorder), T.css("border", E.border).css("border-top", "none").css("height", x + "px")) : (D.append(N), L = c.default(g).children(), c.default(g).append(T), B = T.children()), H = c.default("<div></div>"), H.attr("contenteditable", "true").css("width", "100%").css("height", "100%");
        var P, C = m.config.placeholder;
        C !== y.default.placeholder ? P = c.default("<div>" + C + "</div>") : P = c.default("<div>" + R.t(C) + "</div>"), P.addClass("placeholder"), B && B.length ? (H.append(B), P.hide()) : H.append(c.default(b.EMPTY_P)), L && L.length && (H.append(L), P.hide()), T.append(H), T.append(P), N.addClass("w-e-toolbar").css("z-index", m.zIndex.get("toolbar")), T.addClass("w-e-text-container"), T.css("z-index", m.zIndex.get()), H.addClass("w-e-text");
        var M = v.getRandom("toolbar-elem");
        N.attr("id", M);
        var k = v.getRandom("text-elem");
        H.attr("id", k);
        var F = T.getBoundingClientRect().height, j = H.getBoundingClientRect().height;
        F !== j && H.css("min-height", F + "px"), m.$toolbarElem = N, m.$textContainerElem = T, m.$textElem = H, m.toolbarElemId = M, m.textElemId = k;
      }
      l.default = w;
      function h(m) {
        var I = "data-we-id", D = /^wangEditor-\d+$/, g = m.textSelector, S = m.toolbarSelector, x = { bar: c.default("<div></div>"), text: c.default("<div></div>") };
        if (S == null)
          throw new Error("\u9519\u8BEF\uFF1A\u521D\u59CB\u5316\u7F16\u8F91\u5668\u65F6\u5019\u672A\u4F20\u5165\u4EFB\u4F55\u53C2\u6570\uFF0C\u8BF7\u67E5\u9605\u6587\u6863");
        if (x.bar = c.default(S), !x.bar.elems.length)
          throw new Error("\u65E0\u6548\u7684\u8282\u70B9\u9009\u62E9\u5668\uFF1A" + S);
        if (D.test(x.bar.attr(I)))
          throw new Error("\u521D\u59CB\u5316\u8282\u70B9\u5DF2\u5B58\u5728\u7F16\u8F91\u5668\u5B9E\u4F8B\uFF0C\u65E0\u6CD5\u91CD\u590D\u521B\u5EFA\u7F16\u8F91\u5668");
        if (g) {
          if (x.text = c.default(g), !x.text.elems.length)
            throw new Error("\u65E0\u6548\u7684\u8282\u70B9\u9009\u62E9\u5668\uFF1A" + g);
          if (D.test(x.text.attr(I)))
            throw new Error("\u521D\u59CB\u5316\u8282\u70B9\u5DF2\u5B58\u5728\u7F16\u8F91\u5668\u5B9E\u4F8B\uFF0C\u65E0\u6CD5\u91CD\u590D\u521B\u5EFA\u7F16\u8F91\u5668");
        }
        x.bar.attr(I, m.id), x.text.attr(I, m.id), m.beforeDestroy(function () {
          x.bar.removeAttr(I), x.text.removeAttr(I);
        });
      }
      l.selectorValidator = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(3)), v = n(7);
      function b(y, E) {
        var w = y.$textElem, h = w.children();
        if (!h || !h.length) {
          w.append(c.default(v.EMPTY_P)), b(y);
          return;
        }
        var m = h.last();
        if (E) {
          var I = m.html().toLowerCase(), D = m.getNodeName();
          if (I !== "<br>" && I !== "<br/>" || D !== "P") {
            w.append(c.default(v.EMPTY_P)), b(y);
            return;
          }
        }
        y.selection.createRangeByElem(m, !1, !0), y.config.focus ? y.selection.restoreSelection() : y.selection.clearWindowSelectionRange();
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3));
      function b(I) {
        y(I), E(I), w(I);
      }
      function y(I) {
        I.txt.eventHooks.changeEvents.push(function () {
          var D = I.config.onchange;
          if (D) {
            var g = I.txt.html() || "";
            I.isFocus = !0, D(g);
          }
          I.txt.togglePlaceholder();
        });
      }
      function E(I) {
        I.isFocus = !1;
        function D(g) {
          var S = g.target, x = v.default(S), R = I.$textElem, N = I.$toolbarElem, T = R.isContain(x), H = N.isContain(x), B = N.elems[0] == g.target;
          if (T)
            I.isFocus || m(I), I.isFocus = !0;
          else {
            if (H && !B || !I.isFocus)
              return;
            h(I), I.isFocus = !1;
          }
        }
        document.activeElement === I.$textElem.elems[0] && I.config.focus && (m(I), I.isFocus = !0), v.default(document).on("click", D), I.beforeDestroy(function () {
          v.default(document).off("click", D);
        });
      }
      function w(I) {
        I.$textElem.on("compositionstart", function () {
          I.isComposing = !0, I.txt.togglePlaceholder();
        }).on("compositionend", function () {
          I.isComposing = !1, I.txt.togglePlaceholder();
        });
      }
      function h(I) {
        var D, g = I.config, S = g.onblur, x = I.txt.html() || "";
        (0, p.default)(D = I.txt.eventHooks.onBlurEvents).call(D, function (R) {
          return R();
        }), S(x);
      }
      function m(I) {
        var D = I.config, g = D.onfocus, S = I.txt.html() || "";
        g(S);
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      function p(c) {
        var v = c.config, b = v.lang, y = v.languages;
        if (c.i18next != null) {
          try {
            c.i18next.init({ ns: "wangEditor", lng: b, defaultNS: "wangEditor", resources: y });
          } catch (E) {
            throw new Error("i18next:" + E);
          }
          return;
        }
        c.i18next = {
          t: function (w) {
            var h = w.split(".");
            return h[h.length - 1];
          }
        };
      }
      l.default = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(31));
      (0, f.default)(l, "__esModule", { value: !0 }), l.setUnFullScreen = l.setFullScreen = void 0;
      var c = n(2), v = c.__importDefault(n(3));
      n(421);
      var b = "w-e-icon-fullscreen", y = "w-e-icon-fullscreen_exit", E = "w-e-full-screen-editor";
      l.setFullScreen = function (h) {
        var m = v.default(h.toolbarSelector), I = h.$textContainerElem, D = h.$toolbarElem, g = (0, p.default)(D).call(D, "i." + b), S = h.config;
        g.removeClass(b), g.addClass(y), m.addClass(E), m.css("z-index", S.zIndexFullScreen);
        var x = D.getBoundingClientRect();
        I.css("height", "calc(100% - " + x.height + "px)");
      }, l.setUnFullScreen = function (h) {
        var m = v.default(h.toolbarSelector), I = h.$textContainerElem, D = h.$toolbarElem, g = (0, p.default)(D).call(D, "i." + y), S = h.config;
        g.removeClass(y), g.addClass(b), m.removeClass(E), m.css("z-index", "auto"), I.css("height", S.height + "px");
      };
      var w = function (m) {
        if (!m.textSelector && !!m.config.showFullScreen) {
          var I = m.$toolbarElem, D = v.default(`<div class="w-e-menu" data-title="\u5168\u5C4F">
            <i class="` + b + `"></i>
        </div>`);
          D.on("click", function (g) {
            var S, x = (0, p.default)(S = v.default(g.currentTarget)).call(S, "i");
            x.hasClass(b) ? (D.attr("data-title", "\u53D6\u6D88\u5168\u5C4F"), l.setFullScreen(m)) : (D.attr("data-title", "\u5168\u5C4F"), l.setUnFullScreen(m));
          }), I.append(D);
        }
      };
      l.default = w;
    }, function (i, l, n) {
      var u = n(20), f = n(422);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-full-screen-editor {
  position: fixed;
  width: 100%!important;
  height: 100%!important;
  left: 0;
  top: 0;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(31));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = function (b, y) {
        var E, w = b.isEnable ? b.$textElem : (0, p.default)(E = b.$textContainerElem).call(E, ".w-e-content-mantle"), h = (0, p.default)(w).call(w, "[id='" + y + "']"), m = h.getOffsetData().top;
        w.scrollTop(m);
      };
      l.default = c;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(128)), v = { menu: 2, panel: 2, toolbar: 1, tooltip: 1, textContainer: 1 }, b = function () {
        function y() {
          this.tier = v, this.baseZIndex = c.default.zIndex;
        }
        return y.prototype.get = function (E) {
          return E && this.tier[E] ? this.baseZIndex + this.tier[E] : this.baseZIndex;
        }, y.prototype.init = function (E) {
          this.baseZIndex == c.default.zIndex && (this.baseZIndex = E.config.zIndex);
        }, y;
      }();
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(70)), c = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 });
      var v = n(2), b = v.__importDefault(n(426)), y = n(6), E = n(7);
      function w(m, I) {
        return (0, p.default)(m).call(m, function (D) {
          var g = D.type, S = D.target, x = D.attributeName;
          return g != "attributes" || g == "attributes" && (x == "contenteditable" || S != I);
        });
      }
      var h = function (m) {
        v.__extends(I, m);
        function I(D) {
          var g = m.call(this, function (S, x) {
            var R;
            if (S = w(S, x.target), (R = g.data).push.apply(R, S), D.isCompatibleMode)
              g.asyncSave();
            else if (!D.isComposing)
              return g.asyncSave();
          }) || this;
          return g.editor = D, g.data = [], g.asyncSave = E.EMPTY_FN, g;
        }
        return I.prototype.save = function () {
          this.data.length && (this.editor.history.save(this.data), this.data.length = 0, this.emit());
        }, I.prototype.emit = function () {
          var D;
          (0, c.default)(D = this.editor.txt.eventHooks.changeEvents).call(D, function (g) {
            return g();
          });
        }, I.prototype.observe = function () {
          var D = this;
          m.prototype.observe.call(this, this.editor.$textElem.elems[0]);
          var g = this.editor.config.onchangeTimeout;
          this.asyncSave = y.debounce(function () {
            D.save();
          }, g), this.editor.isCompatibleMode || this.editor.$textElem.on("compositionend", function () {
            D.asyncSave();
          });
        }, I;
      }(b.default);
      l.default = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = function () {
        function c(v, b) {
          var y = this;
          this.options = { subtree: !0, childList: !0, attributes: !0, attributeOldValue: !0, characterData: !0, characterDataOldValue: !0 }, this.callback = function (E) {
            v(E, y);
          }, this.observer = new MutationObserver(this.callback), b && (this.options = b);
        }
        return (0, f.default)(c.prototype, "target", {
          get: function () {
            return this.node;
          }, enumerable: !1, configurable: !0
        }), c.prototype.observe = function (v) {
          this.node instanceof Node || (this.node = v, this.connect());
        }, c.prototype.connect = function () {
          if (this.node)
            return this.observer.observe(this.node, this.options), this;
          throw new Error("\u8FD8\u672A\u521D\u59CB\u5316\u7ED1\u5B9A\uFF0C\u8BF7\u60A8\u5148\u7ED1\u5B9A\u6709\u6548\u7684 Node \u8282\u70B9");
        }, c.prototype.disconnect = function () {
          var v = this.observer.takeRecords();
          v.length && this.callback(v), this.observer.disconnect();
        }, c;
      }();
      l.default = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(428)), v = p.__importDefault(n(435)), b = p.__importDefault(n(436)), y = function () {
        function E(w) {
          this.editor = w, this.content = new c.default(w), this.scroll = new v.default(w), this.range = new b.default(w);
        }
        return (0, f.default)(E.prototype, "size", {
          get: function () {
            return this.scroll.size;
          },
          enumerable: !1,
          configurable: !0
        }), E.prototype.observe = function () {
          this.content.observe(), this.scroll.observe(), !this.editor.isCompatibleMode && this.range.observe();
        }, E.prototype.save = function (w) {
          w.length && (this.content.save(w), this.scroll.save(), !this.editor.isCompatibleMode && this.range.save());
        }, E.prototype.revoke = function () {
          this.editor.change.disconnect();
          var w = this.content.revoke();
          w && (this.scroll.revoke(), this.editor.isCompatibleMode || (this.range.revoke(), this.editor.$textElem.focus())), this.editor.change.connect(), w && this.editor.change.emit();
        }, E.prototype.restore = function () {
          this.editor.change.disconnect();
          var w = this.content.restore();
          w && (this.scroll.restore(), this.editor.isCompatibleMode || (this.range.restore(), this.editor.$textElem.focus())), this.editor.change.connect(), w && this.editor.change.emit();
        }, E;
      }();
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(429)), v = p.__importDefault(n(433)), b = function () {
        function y(E) {
          this.editor = E;
        }
        return y.prototype.observe = function () {
          this.editor.isCompatibleMode ? this.cache = new v.default(this.editor) : this.cache = new c.default(this.editor), this.cache.observe();
        }, y.prototype.save = function (E) {
          this.editor.isCompatibleMode ? this.cache.save() : this.cache.compile(E);
        }, y.prototype.revoke = function () {
          var E;
          return (E = this.cache) === null || E === void 0 ? void 0 : E.revoke();
        }, y.prototype.restore = function () {
          var E;
          return (E = this.cache) === null || E === void 0 ? void 0 : E.restore();
        }, y;
      }();
      l.default = b;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(98)), v = p.__importDefault(n(431)), b = n(432), y = function (E) {
        p.__extends(w, E);
        function w(h) {
          var m = E.call(this, h.config.historyMaxSize) || this;
          return m.editor = h, m;
        }
        return w.prototype.observe = function () {
          this.resetMaxSize(this.editor.config.historyMaxSize);
        }, w.prototype.compile = function (h) {
          return this.save(v.default(h)), this;
        }, w.prototype.revoke = function () {
          return E.prototype.revoke.call(this, function (h) {
            b.revoke(h);
          });
        }, w.prototype.restore = function () {
          return E.prototype.restore.call(this, function (h) {
            b.restore(h);
          });
        }, w;
      }(c.default);
      l.default = y;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 }), l.CeilStack = void 0;
      var p = function () {
        function c(v) {
          v === void 0 && (v = 0), this.data = [], this.max = 0, this.reset = !1, v = Math.abs(v), v && (this.max = v);
        }
        return c.prototype.resetMax = function (v) {
          v = Math.abs(v), !this.reset && !isNaN(v) && (this.max = v, this.reset = !0);
        }, (0, f.default)(c.prototype, "size", {
          get: function () {
            return this.data.length;
          },
          enumerable: !1,
          configurable: !0
        }), c.prototype.instack = function (v) {
          return this.data.unshift(v), this.max && this.size > this.max && (this.data.length = this.max), this;
        }, c.prototype.outstack = function () {
          return this.data.shift();
        }, c.prototype.clear = function () {
          return this.data.length = 0, this;
        }, c;
      }();
      l.CeilStack = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(27));
      (0, f.default)(l, "__esModule", { value: !0 }), l.compliePosition = l.complieNodes = l.compileValue = l.compileType = void 0;
      var v = n(6);
      function b(D) {
        switch (D) {
          case "childList":
            return "node";
          case "attributes":
            return "attr";
          default:
            return "text";
        }
      }
      l.compileType = b;
      function y(D) {
        switch (D.type) {
          case "attributes":
            return D.target.getAttribute(D.attributeName) || "";
          case "characterData":
            return D.target.textContent;
          default:
            return "";
        }
      }
      l.compileValue = y;
      function E(D) {
        var g = {};
        return D.addedNodes.length && (g.add = v.toArray(D.addedNodes)), D.removedNodes.length && (g.remove = v.toArray(D.removedNodes)), g;
      }
      l.complieNodes = E;
      function w(D) {
        var g;
        return D.previousSibling ? g = { type: "before", target: D.previousSibling } : D.nextSibling ? g = { type: "after", target: D.nextSibling } : g = { type: "parent", target: D.target }, g;
      }
      l.compliePosition = w;
      var h = ["UL", "OL", "H1", "H2", "H3", "H4", "H5", "H6"];
      function m(D) {
        var g = [], S = !1, x = [];
        return (0, p.default)(D).call(D, function (R, N) {
          var T = { type: b(R.type), target: R.target, attr: R.attributeName || "", value: y(R) || "", oldValue: R.oldValue || "", nodes: E(R), position: w(R) };
          if (g.push(T), !!v.UA.isFirefox) {
            if (S && R.addedNodes.length && R.addedNodes[0].nodeType == 1) {
              var H = R.addedNodes[0], B = { type: "node", target: H, attr: "", value: "", oldValue: "", nodes: { add: [S] }, position: { type: "parent", target: H } };
              (0, c.default)(h).call(h, H.nodeName) != -1 ? (B.nodes.add = v.toArray(H.childNodes), g.push(B)) : S.nodeType == 3 ? (I(H, x) && (B.nodes.add = v.toArray(H.childNodes)), g.push(B)) : (0, c.default)(h).call(h, R.target.nodeName) == -1 && I(H, x) && (B.nodes.add = v.toArray(H.childNodes), g.push(B));
            }
            T.type == "node" && R.removedNodes.length == 1 ? (S = R.removedNodes[0], x.push(S)) : (S = !1, x.length = 0);
          }
        }), g;
      }
      l.default = m;
      function I(D, g) {
        for (var S = 0, x = g.length - 1; x > 0 && D.contains(g[x]); x--)
          S++;
        return S;
      }
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(4)), c = u(n(94));
      (0, f.default)(l, "__esModule", { value: !0 }), l.restore = l.revoke = void 0;
      function v(x, R) {
        var N = x.position.target;
        switch (x.position.type) {
          case "before":
            N.nextSibling ? (N = N.nextSibling, (0, p.default)(R).call(R, function (T) {
              x.target.insertBefore(T, N);
            })) : (0, p.default)(R).call(R, function (T) {
              x.target.appendChild(T);
            });
            break;
          case "after":
            (0, p.default)(R).call(R, function (T) {
              x.target.insertBefore(T, N);
            });
            break;
          default:
            (0, p.default)(R).call(R, function (T) {
              N.appendChild(T);
            });
            break;
        }
      }
      function b(x) {
        for (var R = 0, N = (0, c.default)(x.nodes); R < N.length; R++) {
          var T = N[R], H = T[0], B = T[1];
          switch (H) {
            case "add":
              (0, p.default)(B).call(B, function (L) {
                x.target.removeChild(L);
              });
              break;
            default: {
              v(x, B);
              break;
            }
          }
        }
      }
      function y(x) {
        var R = x.target;
        x.oldValue == null ? R.removeAttribute(x.attr) : R.setAttribute(x.attr, x.oldValue);
      }
      function E(x) {
        x.target.textContent = x.oldValue;
      }
      var w = { node: b, text: E, attr: y };
      function h(x) {
        for (var R = x.length - 1; R > -1; R--) {
          var N = x[R];
          w[N.type](N);
        }
      }
      l.revoke = h;
      function m(x) {
        for (var R = 0, N = (0, c.default)(x.nodes); R < N.length; R++) {
          var T = N[R], H = T[0], B = T[1];
          switch (H) {
            case "add": {
              v(x, B);
              break;
            }
            default: {
              (0, p.default)(B).call(B, function (L) {
                L.parentNode.removeChild(L);
              });
              break;
            }
          }
        }
      }
      function I(x) {
        x.target.textContent = x.value;
      }
      function D(x) {
        x.target.setAttribute(x.attr, x.value);
      }
      var g = { node: m, text: I, attr: D };
      function S(x) {
        for (var R = 0, N = x; R < N.length; R++) {
          var T = N[R];
          g[T.type](T);
        }
      }
      l.restore = S;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(434), c = function () {
        function v(b) {
          this.editor = b, this.data = new p.TailChain();
        }
        return v.prototype.observe = function () {
          this.data.resetMax(this.editor.config.historyMaxSize), this.data.insertLast(this.editor.$textElem.html());
        }, v.prototype.save = function () {
          return this.data.insertLast(this.editor.$textElem.html()), this;
        }, v.prototype.revoke = function () {
          var b = this.data.prev();
          return b ? (this.editor.$textElem.html(b), !0) : !1;
        }, v.prototype.restore = function () {
          var b = this.data.next();
          return b ? (this.editor.$textElem.html(b), !0) : !1;
        }, v;
      }();
      l.default = c;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(91));
      (0, f.default)(l, "__esModule", { value: !0 }), l.TailChain = void 0;
      var c = function () {
        function v() {
          this.data = [], this.max = 0, this.point = 0, this.isRe = !1;
        }
        return v.prototype.resetMax = function (b) {
          b = Math.abs(b), b && (this.max = b);
        }, (0, f.default)(v.prototype, "size", {
          get: function () {
            return this.data.length;
          },
          enumerable: !1,
          configurable: !0
        }), v.prototype.insertLast = function (b) {
          if (this.isRe) {
            var y;
            (0, p.default)(y = this.data).call(y, this.point + 1), this.isRe = !1;
          }
          for (this.data.push(b); this.max && this.size > this.max;)
            this.data.shift();
          return this.point = this.size - 1, this;
        }, v.prototype.current = function () {
          return this.data[this.point];
        }, v.prototype.prev = function () {
          if (!this.isRe && (this.isRe = !0), this.point--, this.point < 0) {
            this.point = 0;
            return;
          }
          return this.current();
        }, v.prototype.next = function () {
          if (!this.isRe && (this.isRe = !0), this.point++, this.point >= this.size) {
            this.point = this.size - 1;
            return;
          }
          return this.current();
        }, v;
      }();
      l.TailChain = c;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(98)), v = function (b) {
        p.__extends(y, b);
        function y(E) {
          var w = b.call(this, E.config.historyMaxSize) || this;
          return w.editor = E, w.last = 0, w.target = E.$textElem.elems[0], w;
        }
        return y.prototype.observe = function () {
          var E = this;
          this.target = this.editor.$textElem.elems[0], this.editor.$textElem.on("scroll", function () {
            E.last = E.target.scrollTop;
          }), this.resetMaxSize(this.editor.config.historyMaxSize);
        }, y.prototype.save = function () {
          return b.prototype.save.call(this, [this.last, this.target.scrollTop]), this;
        }, y.prototype.revoke = function () {
          var E = this;
          return b.prototype.revoke.call(this, function (w) {
            E.target.scrollTop = w[0];
          });
        }, y.prototype.restore = function () {
          var E = this;
          return b.prototype.restore.call(this, function (w) {
            E.target.scrollTop = w[1];
          });
        }, y;
      }(c.default);
      l.default = v;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = n(2), c = p.__importDefault(n(98)), v = p.__importDefault(n(3)), b = n(6);
      function y(w) {
        return { start: [w.startContainer, w.startOffset], end: [w.endContainer, w.endOffset], root: w.commonAncestorContainer, collapsed: w.collapsed };
      }
      var E = function (w) {
        p.__extends(h, w);
        function h(m) {
          var I = w.call(this, m.config.historyMaxSize) || this;
          return I.editor = m, I.lastRange = y(document.createRange()), I.root = m.$textElem.elems[0], I.updateLastRange = b.debounce(function () {
            I.lastRange = y(I.rangeHandle);
          }, m.config.onchangeTimeout), I;
        }
        return (0, f.default)(h.prototype, "rangeHandle", {
          get: function () {
            var I = document.getSelection();
            return I && I.rangeCount ? I.getRangeAt(0) : document.createRange();
          },
          enumerable: !1,
          configurable: !0
        }), h.prototype.observe = function () {
          var m = this;
          this.root = this.editor.$textElem.elems[0], this.resetMaxSize(this.editor.config.historyMaxSize);
          function I() {
            var g = m.rangeHandle;
            (m.root === g.commonAncestorContainer || m.root.contains(g.commonAncestorContainer)) && (m.editor.isComposing || m.updateLastRange());
          }
          function D(g) {
            (g.key == "Backspace" || g.key == "Delete") && m.updateLastRange();
          }
          v.default(document).on("selectionchange", I), this.editor.beforeDestroy(function () {
            v.default(document).off("selectionchange", I);
          }), m.editor.$textElem.on("keydown", D);
        }, h.prototype.save = function () {
          var m = y(this.rangeHandle);
          return w.prototype.save.call(this, [this.lastRange, m]), this.lastRange = m, this;
        }, h.prototype.set = function (m) {
          try {
            if (m) {
              var I = this.rangeHandle;
              return I.setStart.apply(I, m.start), I.setEnd.apply(I, m.end), this.editor.menus.changeActive(), !0;
            }
          } catch {
            return !1;
          }
          return !1;
        }, h.prototype.revoke = function () {
          var m = this;
          return w.prototype.revoke.call(this, function (I) {
            m.set(I[0]);
          });
        }, h.prototype.restore = function () {
          var m = this;
          return w.prototype.restore.call(this, function (I) {
            m.set(I[1]);
          });
        }, h;
      }(c.default);
      l.default = E;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(31));
      (0, f.default)(l, "__esModule", { value: !0 });
      var c = n(2), v = c.__importDefault(n(3));
      n(438);
      function b(y) {
        var E = !1, w, h;
        y.txt.eventHooks.changeEvents.push(function () {
          E && (0, p.default)(w).call(w, ".w-e-content-preview").html(y.$textElem.html());
        });
        function m() {
          if (!E) {
            y.$textElem.hide();
            var D = y.zIndex.get("textContainer"), g = y.txt.html();
            w = v.default('<div class="w-e-content-mantle" style="z-index:' + D + `">
                <div class="w-e-content-preview w-e-text">` + g + `</div>
            </div>`), y.$textContainerElem.append(w);
            var S = y.zIndex.get("menu");
            h = v.default('<div class="w-e-menue-mantle" style="z-index:' + S + '"></div>'), y.$toolbarElem.append(h), E = !0, y.isEnable = !1;
          }
        }
        function I() {
          !E || (w.remove(), h.remove(), y.$textElem.show(), E = !1, y.isEnable = !0);
        }
        return { disable: m, enable: I };
      }
      l.default = b;
    }, function (i, l, n) {
      var u = n(20), f = n(439);
      f = f.__esModule ? f.default : f, typeof f == "string" && (f = [[i.i, f, ""]]);
      var p = {};
      p.insert = "head", p.singleton = !1, u(f, p), i.exports = f.locals || {};
    }, function (i, l, n) {
      var u = n(21);
      l = u(!1), l.push([i.i, `.w-e-content-mantle {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.w-e-content-mantle .w-e-content-preview {
  width: 100%;
  min-height: 100%;
  padding: 0 10px;
  line-height: 1.5;
}
.w-e-content-mantle .w-e-content-preview img {
  cursor: default;
}
.w-e-content-mantle .w-e-content-preview img:hover {
  box-shadow: none;
}
.w-e-menue-mantle {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
`, ""]), i.exports = l;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
      var p = function () {
        function c(v) {
          var b = this;
          this.editor = v;
          var y = function () {
            var w = document.activeElement;
            w === v.$textElem.elems[0] && b.emit();
          };
          window.document.addEventListener("selectionchange", y), this.editor.beforeDestroy(function () {
            window.document.removeEventListener("selectionchange", y);
          });
        }
        return c.prototype.emit = function () {
          var v, b = this.editor.config.onSelectionChange;
          if (b) {
            var y = this.editor.selection;
            y.saveRange(), y.isSelectionEmpty() || b({
              text: y.getSelectionText(),
              html: (v = y.getSelectionContainerElem()) === null || v === void 0 ? void 0 : v.elems[0].innerHTML,
              selection: y
            });
          }
        }, c;
      }();
      l.default = p;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1)), p = u(n(127)), c = u(n(94)), v = u(n(4));
      (0, f.default)(l, "__esModule", { value: !0 }), l.registerPlugin = void 0;
      var b = n(2), y = b.__importDefault(n(87)), E = n(6);
      function w(m, I, D) {
        if (!m)
          throw new TypeError("name is not define");
        if (!I)
          throw new TypeError("options is not define");
        if (!I.intention)
          throw new TypeError("options.intention is not define");
        if (I.intention && typeof I.intention != "function")
          throw new TypeError("options.intention is not function");
        D[m] && console.warn("plugin " + m + " \u5DF2\u5B58\u5728\uFF0C\u5DF2\u8986\u76D6\u3002"), D[m] = I;
      }
      l.registerPlugin = w;
      function h(m) {
        var I = (0, p.default)({}, E.deepClone(y.default.globalPluginsFunctionList), E.deepClone(m.pluginsFunctionList)), D = (0, c.default)(I);
        (0, v.default)(D).call(D, function (g) {
          var S = g[0], x = g[1];
          console.info("plugin " + S + " initializing");
          var R = x.intention, N = x.config;
          R(m, N), console.info("plugin " + S + " initialization complete");
        });
      }
      l.default = h;
    }, function (i, l, n) {
      var u = n(0), f = u(n(1));
      (0, f.default)(l, "__esModule", { value: !0 });
    }]).default;
  });
})(Gc);
var ZE = /* @__PURE__ */ XE(Gc.exports), qE = "fcEditor", _E = 1, ew = Object.assign || function (e) {
  for (var o, i = 1; i < arguments.length; i++)
    for (var l in o = arguments[i], o)
      Object.prototype.hasOwnProperty.call(o, l) && (e[l] = o[l]);
  return e;
}, tw = et({
  name: qE,
  props: {
    modelValue: String,
    init: Function,
    disabled: Boolean,
    config: Object
  },
  inheritAttrs: !1,
  emits: ["update:modelValue"],
  data: function () {
    return {
      editor: {},
      uni: _E++
    };
  },
  watch: {
    disabled: function () {
      this.enable();
    },
    modelValue: function (o) {
      o !== this.editor.txt.html() && this.editor.txt.html(o);
    }
  },
  methods: {
    enable: function () {
      this.disabled ? this.editor.disable() : this.editor.enable();
    },
    result: function () {
      this.$emit("update:modelValue", this.editor.txt.html());
    }
  },
  mounted: function () {
    var o = this;
    this.$nextTick(function () {
      o.editor = new ZE("#editor".concat(o.uni)), o.editor.config.zIndex = 2, o.config && ew(o.editor.config, o.config), o.init && o.init(o.editor), o.editor.create(), o.enable(), o.editor.txt.html(o.modelValue);
    });
  },
  render: function () {
    var o = KE({}, this.$attrs);
    return delete o.id, X("div", Vr(o, {
      onInput: this.result,
      id: "editor".concat(this.uni),
      style: "line-height: normal;"
    }), null);
  },
  beforeDestroy: function () {
    this.editor && this.editor.destroy(), this.editor = null;
  }
});
(function (e, o) {
  (function (i) {
    i($i.exports);
  })(function (i) {
    i.defineSimpleMode = function (E, w) {
      i.defineMode(E, function (h) {
        return i.simpleMode(h, w);
      });
    }, i.simpleMode = function (E, w) {
      l(w, "start");
      var h = {}, m = w.meta || {}, I = !1;
      for (var D in w)
        if (D != m && w.hasOwnProperty(D))
          for (var g = h[D] = [], S = w[D], x = 0; x < S.length; x++) {
            var R = S[x];
            g.push(new f(R, w)), (R.indent || R.dedent) && (I = !0);
          }
      var N = {
        startState: function () {
          return {
            state: "start",
            pending: null,
            local: null,
            localState: null,
            indent: I ? [] : null
          };
        },
        copyState: function (H) {
          var B = {
            state: H.state,
            pending: H.pending,
            local: H.local,
            localState: null,
            indent: H.indent && H.indent.slice(0)
          };
          H.localState && (B.localState = i.copyState(H.local.mode, H.localState)), H.stack && (B.stack = H.stack.slice(0));
          for (var L = H.persistentStates; L; L = L.next)
            B.persistentStates = {
              mode: L.mode,
              spec: L.spec,
              state: L.state == H.localState ? B.localState : i.copyState(L.mode, L.state),
              next: B.persistentStates
            };
          return B;
        },
        token: p(h, E),
        innerMode: function (H) {
          return H.local && { mode: H.local.mode, state: H.localState };
        },
        indent: y(h, m)
      };
      if (m)
        for (var T in m)
          m.hasOwnProperty(T) && (N[T] = m[T]);
      return N;
    };
    function l(E, w) {
      if (!E.hasOwnProperty(w))
        throw new Error("Undefined state " + w + " in simple mode");
    }
    function n(E, w) {
      if (!E)
        return /(?:)/;
      var h = "";
      return E instanceof RegExp ? (E.ignoreCase && (h = "i"), E.unicode && (h += "u"), E = E.source) : E = String(E), new RegExp((w === !1 ? "" : "^") + "(?:" + E + ")", h);
    }
    function u(E) {
      if (!E)
        return null;
      if (E.apply)
        return E;
      if (typeof E == "string")
        return E.replace(/\./g, " ");
      for (var w = [], h = 0; h < E.length; h++)
        w.push(E[h] && E[h].replace(/\./g, " "));
      return w;
    }
    function f(E, w) {
      (E.next || E.push) && l(w, E.next || E.push), this.regex = n(E.regex), this.token = u(E.token), this.data = E;
    }
    function p(E, w) {
      return function (h, m) {
        if (m.pending) {
          var I = m.pending.shift();
          return m.pending.length == 0 && (m.pending = null), h.pos += I.text.length, I.token;
        }
        if (m.local)
          if (m.local.end && h.match(m.local.end)) {
            var D = m.local.endToken || null;
            return m.local = m.localState = null, D;
          } else {
            var D = m.local.mode.token(h, m.localState), g;
            return m.local.endScan && (g = m.local.endScan.exec(h.current())) && (h.pos = h.start + g.index), D;
          }
        for (var S = E[m.state], x = 0; x < S.length; x++) {
          var R = S[x], N = (!R.data.sol || h.sol()) && h.match(R.regex);
          if (N) {
            R.data.next ? m.state = R.data.next : R.data.push ? ((m.stack || (m.stack = [])).push(m.state), m.state = R.data.push) : R.data.pop && m.stack && m.stack.length && (m.state = m.stack.pop()), R.data.mode && v(w, m, R.data.mode, R.token), R.data.indent && m.indent.push(h.indentation() + w.indentUnit), R.data.dedent && m.indent.pop();
            var T = R.token;
            if (T && T.apply && (T = T(N)), N.length > 2 && R.token && typeof R.token != "string") {
              for (var H = 2; H < N.length; H++)
                N[H] && (m.pending || (m.pending = [])).push({ text: N[H], token: R.token[H - 1] });
              return h.backUp(N[0].length - (N[1] ? N[1].length : 0)), T[0];
            } else
              return T && T.join ? T[0] : T;
          }
        }
        return h.next(), null;
      };
    }
    function c(E, w) {
      if (E === w)
        return !0;
      if (!E || typeof E != "object" || !w || typeof w != "object")
        return !1;
      var h = 0;
      for (var m in E)
        if (E.hasOwnProperty(m)) {
          if (!w.hasOwnProperty(m) || !c(E[m], w[m]))
            return !1;
          h++;
        }
      for (var m in w)
        w.hasOwnProperty(m) && h--;
      return h == 0;
    }
    function v(E, w, h, m) {
      var I;
      if (h.persistent)
        for (var D = w.persistentStates; D && !I; D = D.next)
          (h.spec ? c(h.spec, D.spec) : h.mode == D.mode) && (I = D);
      var g = I ? I.mode : h.mode || i.getMode(E, h.spec), S = I ? I.state : i.startState(g);
      h.persistent && !I && (w.persistentStates = { mode: g, spec: h.spec, state: S, next: w.persistentStates }), w.localState = S, w.local = {
        mode: g,
        end: h.end && n(h.end),
        endScan: h.end && h.forceEnd !== !1 && n(h.end, !1),
        endToken: m && m.join ? m[m.length - 1] : m
      };
    }
    function b(E, w) {
      for (var h = 0; h < w.length; h++)
        if (w[h] === E)
          return !0;
    }
    function y(E, w) {
      return function (h, m, I) {
        if (h.local && h.local.mode.indent)
          return h.local.mode.indent(h.localState, m, I);
        if (h.indent == null || h.local || w.dontIndentStates && b(h.state, w.dontIndentStates) > -1)
          return i.Pass;
        var D = h.indent.length - 1, g = E[h.state];
        e:
        for (; ;) {
          for (var S = 0; S < g.length; S++) {
            var x = g[S];
            if (x.data.dedent && x.data.dedentIfLineStart !== !1) {
              var R = x.regex.exec(m);
              if (R && R[0]) {
                D--, (x.next || x.push) && (g = E[x.next || x.push]), m = m.slice(R[0].length);
                continue e;
              }
            }
          }
          break;
        }
        return D < 0 ? 0 : h.indent[D];
      };
    }
  });
})();
Hr.defineSimpleMode("fcComputedMode", {
  start: [
    { regex: /[a-zA-Z_]\w*/, token: "keyword" },
    { regex: /[a-z]+/, token: "def" },
    { regex: /\/\/.*/, token: "comment" },
    { regex: /\/\*/, token: "comment", next: "comment" },
    { regex: /[-+]?(\d*\.)?\d+/, token: "number" },
    { regex: /"(?:[^\\]|\\.)*?(?:"|$)/, token: "string" },
    { regex: /[\(\),]/, token: "bracket" },
    { regex: /==/, token: "operator" },
    { regex: /=/, token: "operator" },
    { regex: /[!<>]=?/, token: "operator" },
    { regex: /&&|\|\|/, token: "operator" },
    { regex: /[\+\-\*\%\/]/, token: "builtin" }
  ],
  comment: [
    { regex: /.*?\*\//, token: "comment", next: "start" },
    { regex: /.*/, token: "comment" }
  ]
});
const gr = (e, o, i) => {
  Ze.component(e, i || o), Kl.component(e, o);
};
Ze.component("draggable", ru);
Ze.component("DragTool", kc);
Ze.component("DragBox", zc);
Ze.component("Validate", yS);
Ze.component("Struct", Pb);
Ze.component("HtmlEditor", Vb);
Ze.component("FnEditor", Po);
Ze.component("ComputedConfig", VA);
Ze.component("Fetch", WC);
Ze.component("Required", SS);
Ze.component("TableOptions", Vc);
Ze.component("TreeOptions", GS);
Ze.component("TableFormColumn", $E);
Ze.component("EventConfig", Fc);
Ze.component("SizeInput", lu);
Ze.component("StyleConfig", jc);
Ze.component("GlobalFetchConfig", dC);
Ze.component("GlobalFetchSelect", mC);
Ze.component("GlobalEventConfig", xC);
Ze.component("GlobalClassConfig", LC);
Ze.component("GlobalClassSelect", VC);
Ze.component("ColorInput", $o);
Ze.component("ConfigItem", Bi);
Ze.component("FieldInput", Xb);
Ze.component("StepFormItem", VE);
Ze.component("FcRow", QE);
Ze.component("FnConfig", KA);
gr("FcEditor", tw);
gr("FcCell", WE);
gr("TableForm", ME, oE);
gr("StepForm", JS, _S);
gr("FcValue", vS, fS);
gr("FcTable", aS, rS);
gr("NestedTableForm", gE, pE);
gr("InfiniteTableForm", DE, EE);
const nw = function (e) {
  (Array.isArray(e) ? e : [e]).forEach((i) => {
    Mo[i.name] = i.handle, Ks[i.name] = i.example, Js.value.formula[i.name] = i.info, Dc.forEach((l) => {
      l.key === i.menu && l.children.push(i.name), Kl.setFormula(i.name, i.handle), Ze.setFormula(i.name, i.handle);
    });
  });
}, rw = function (e) {
  e.component("FcDesigner", mr);
};
mr.install = rw;
mr.makeOptionsRule = Gl;
mr.formCreate = Kl;
mr.designerForm = Ze;
mr.component = gr;
mr.setFormula = nw;
mr.useLocale = Rc;
mr.t = Xs;
export {
  mr as default,
  Ze as designerForm,
  Kl as formCreate,
  rw as install
};
